(function () {
	'use strict';

	/** @returns {void} */
	function noop() {}

	const identity$1 = (x) => x;

	/**
	 * @template T
	 * @template S
	 * @param {T} tar
	 * @param {S} src
	 * @returns {T & S}
	 */
	function assign(tar, src) {
		// @ts-ignore
		for (const k in src) tar[k] = src[k];
		return /** @type {T & S} */ (tar);
	}

	function run(fn) {
		return fn();
	}

	function blank_object() {
		return Object.create(null);
	}

	/**
	 * @param {Function[]} fns
	 * @returns {void}
	 */
	function run_all(fns) {
		fns.forEach(run);
	}

	/**
	 * @param {any} thing
	 * @returns {thing is Function}
	 */
	function is_function(thing) {
		return typeof thing === 'function';
	}

	/** @returns {boolean} */
	function safe_not_equal(a, b) {
		return a != a ? b == b : a !== b || (a && typeof a === 'object') || typeof a === 'function';
	}

	let src_url_equal_anchor;

	/**
	 * @param {string} element_src
	 * @param {string} url
	 * @returns {boolean}
	 */
	function src_url_equal(element_src, url) {
		if (element_src === url) return true;
		if (!src_url_equal_anchor) {
			src_url_equal_anchor = document.createElement('a');
		}
		// This is actually faster than doing URL(..).href
		src_url_equal_anchor.href = url;
		return element_src === src_url_equal_anchor.href;
	}

	/** @returns {boolean} */
	function is_empty(obj) {
		return Object.keys(obj).length === 0;
	}

	function create_slot(definition, ctx, $$scope, fn) {
		if (definition) {
			const slot_ctx = get_slot_context(definition, ctx, $$scope, fn);
			return definition[0](slot_ctx);
		}
	}

	function get_slot_context(definition, ctx, $$scope, fn) {
		return definition[1] && fn ? assign($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
	}

	function get_slot_changes(definition, $$scope, dirty, fn) {
		if (definition[2] && fn) {
			const lets = definition[2](fn(dirty));
			if ($$scope.dirty === undefined) {
				return lets;
			}
			if (typeof lets === 'object') {
				const merged = [];
				const len = Math.max($$scope.dirty.length, lets.length);
				for (let i = 0; i < len; i += 1) {
					merged[i] = $$scope.dirty[i] | lets[i];
				}
				return merged;
			}
			return $$scope.dirty | lets;
		}
		return $$scope.dirty;
	}

	/** @returns {void} */
	function update_slot_base(
		slot,
		slot_definition,
		ctx,
		$$scope,
		slot_changes,
		get_slot_context_fn
	) {
		if (slot_changes) {
			const slot_context = get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
			slot.p(slot_context, slot_changes);
		}
	}

	/** @returns {any[] | -1} */
	function get_all_dirty_from_scope($$scope) {
		if ($$scope.ctx.length > 32) {
			const dirty = [];
			const length = $$scope.ctx.length / 32;
			for (let i = 0; i < length; i++) {
				dirty[i] = -1;
			}
			return dirty;
		}
		return -1;
	}

	/** @returns {{}} */
	function exclude_internal_props(props) {
		const result = {};
		for (const k in props) if (k[0] !== '$') result[k] = props[k];
		return result;
	}

	function null_to_empty(value) {
		return value == null ? '' : value;
	}

	function action_destroyer(action_result) {
		return action_result && is_function(action_result.destroy) ? action_result.destroy : noop;
	}

	const is_client = typeof window !== 'undefined';

	/** @type {() => number} */
	let now = is_client ? () => window.performance.now() : () => Date.now();

	let raf = is_client ? (cb) => requestAnimationFrame(cb) : noop;

	const tasks = new Set();

	/**
	 * @param {number} now
	 * @returns {void}
	 */
	function run_tasks(now) {
		tasks.forEach((task) => {
			if (!task.c(now)) {
				tasks.delete(task);
				task.f();
			}
		});
		if (tasks.size !== 0) raf(run_tasks);
	}

	/**
	 * Creates a new task that runs on each raf frame
	 * until it returns a falsy value or is aborted
	 * @param {import('./private.js').TaskCallback} callback
	 * @returns {import('./private.js').Task}
	 */
	function loop(callback) {
		/** @type {import('./private.js').TaskEntry} */
		let task;
		if (tasks.size === 0) raf(run_tasks);
		return {
			promise: new Promise((fulfill) => {
				tasks.add((task = { c: callback, f: fulfill }));
			}),
			abort() {
				tasks.delete(task);
			}
		};
	}

	/**
	 * @param {Node} target
	 * @param {Node} node
	 * @returns {void}
	 */
	function append(target, node) {
		target.appendChild(node);
	}

	/**
	 * @param {Node} target
	 * @param {string} style_sheet_id
	 * @param {string} styles
	 * @returns {void}
	 */
	function append_styles(target, style_sheet_id, styles) {
		const append_styles_to = get_root_for_style(target);
		if (!append_styles_to.getElementById(style_sheet_id)) {
			const style = element('style');
			style.id = style_sheet_id;
			style.textContent = styles;
			append_stylesheet(append_styles_to, style);
		}
	}

	/**
	 * @param {Node} node
	 * @returns {ShadowRoot | Document}
	 */
	function get_root_for_style(node) {
		if (!node) return document;
		const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
		if (root && /** @type {ShadowRoot} */ (root).host) {
			return /** @type {ShadowRoot} */ (root);
		}
		return node.ownerDocument;
	}

	/**
	 * @param {Node} node
	 * @returns {CSSStyleSheet}
	 */
	function append_empty_stylesheet(node) {
		const style_element = element('style');
		// For transitions to work without 'style-src: unsafe-inline' Content Security Policy,
		// these empty tags need to be allowed with a hash as a workaround until we move to the Web Animations API.
		// Using the hash for the empty string (for an empty tag) works in all browsers except Safari.
		// So as a workaround for the workaround, when we append empty style tags we set their content to /* empty */.
		// The hash 'sha256-9OlNO0DNEeaVzHL4RZwCLsBHA8WBQ8toBp/4F5XV2nc=' will then work even in Safari.
		style_element.textContent = '/* empty */';
		append_stylesheet(get_root_for_style(node), style_element);
		return style_element.sheet;
	}

	/**
	 * @param {ShadowRoot | Document} node
	 * @param {HTMLStyleElement} style
	 * @returns {CSSStyleSheet}
	 */
	function append_stylesheet(node, style) {
		append(/** @type {Document} */ (node).head || node, style);
		return style.sheet;
	}

	/**
	 * @param {Node} target
	 * @param {Node} node
	 * @param {Node} [anchor]
	 * @returns {void}
	 */
	function insert(target, node, anchor) {
		target.insertBefore(node, anchor || null);
	}

	/**
	 * @param {Node} node
	 * @returns {void}
	 */
	function detach(node) {
		if (node.parentNode) {
			node.parentNode.removeChild(node);
		}
	}

	/**
	 * @returns {void} */
	function destroy_each(iterations, detaching) {
		for (let i = 0; i < iterations.length; i += 1) {
			if (iterations[i]) iterations[i].d(detaching);
		}
	}

	/**
	 * @template {keyof HTMLElementTagNameMap} K
	 * @param {K} name
	 * @returns {HTMLElementTagNameMap[K]}
	 */
	function element(name) {
		return document.createElement(name);
	}

	/**
	 * @template {keyof SVGElementTagNameMap} K
	 * @param {K} name
	 * @returns {SVGElement}
	 */
	function svg_element(name) {
		return document.createElementNS('http://www.w3.org/2000/svg', name);
	}

	/**
	 * @param {string} data
	 * @returns {Text}
	 */
	function text(data) {
		return document.createTextNode(data);
	}

	/**
	 * @returns {Text} */
	function space() {
		return text(' ');
	}

	/**
	 * @returns {Text} */
	function empty() {
		return text('');
	}

	/**
	 * @param {EventTarget} node
	 * @param {string} event
	 * @param {EventListenerOrEventListenerObject} handler
	 * @param {boolean | AddEventListenerOptions | EventListenerOptions} [options]
	 * @returns {() => void}
	 */
	function listen(node, event, handler, options) {
		node.addEventListener(event, handler, options);
		return () => node.removeEventListener(event, handler, options);
	}

	/**
	 * @param {Element} node
	 * @param {string} attribute
	 * @param {string} [value]
	 * @returns {void}
	 */
	function attr(node, attribute, value) {
		if (value == null) node.removeAttribute(attribute);
		else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
	}

	/**
	 * @returns {void} */
	function set_custom_element_data(node, prop, value) {
		const lower = prop.toLowerCase(); // for backwards compatibility with existing behavior we do lowercase first
		if (lower in node) {
			node[lower] = typeof node[lower] === 'boolean' && value === '' ? true : value;
		} else if (prop in node) {
			node[prop] = typeof node[prop] === 'boolean' && value === '' ? true : value;
		} else {
			attr(node, prop, value);
		}
	}

	/**
	 * @param {Element} element
	 * @returns {ChildNode[]}
	 */
	function children(element) {
		return Array.from(element.childNodes);
	}

	/**
	 * @param {Text} text
	 * @param {unknown} data
	 * @returns {void}
	 */
	function set_data(text, data) {
		data = '' + data;
		if (text.data === data) return;
		text.data = /** @type {string} */ (data);
	}

	/**
	 * @returns {void} */
	function set_input_value(input, value) {
		input.value = value == null ? '' : value;
	}

	/**
	 * @returns {void} */
	function set_style(node, key, value, important) {
		if (value == null) {
			node.style.removeProperty(key);
		} else {
			node.style.setProperty(key, value, important ? 'important' : '');
		}
	}

	/**
	 * @returns {void} */
	function select_option(select, value, mounting) {
		for (let i = 0; i < select.options.length; i += 1) {
			const option = select.options[i];
			if (option.__value === value) {
				option.selected = true;
				return;
			}
		}
		if (!mounting || value !== undefined) {
			select.selectedIndex = -1; // no option should be selected
		}
	}

	/**
	 * @returns {void} */
	function select_options(select, value) {
		for (let i = 0; i < select.options.length; i += 1) {
			const option = select.options[i];
			option.selected = ~value.indexOf(option.__value);
		}
	}

	function select_value(select) {
		const selected_option = select.querySelector(':checked');
		return selected_option && selected_option.__value;
	}

	function select_multiple_value(select) {
		return [].map.call(select.querySelectorAll(':checked'), (option) => option.__value);
	}

	/**
	 * @returns {void} */
	function toggle_class(element, name, toggle) {
		// The `!!` is required because an `undefined` flag means flipping the current state.
		element.classList.toggle(name, !!toggle);
	}

	/**
	 * @template T
	 * @param {string} type
	 * @param {T} [detail]
	 * @param {{ bubbles?: boolean, cancelable?: boolean }} [options]
	 * @returns {CustomEvent<T>}
	 */
	function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
		return new CustomEvent(type, { detail, bubbles, cancelable });
	}

	/**
	 * @param {HTMLElement} element
	 * @returns {{}}
	 */
	function get_custom_elements_slots(element) {
		const result = {};
		element.childNodes.forEach(
			/** @param {Element} node */ (node) => {
				result[node.slot || 'default'] = true;
			}
		);
		return result;
	}

	/**
	 * @typedef {Node & {
	 * 	claim_order?: number;
	 * 	hydrate_init?: true;
	 * 	actual_end_child?: NodeEx;
	 * 	childNodes: NodeListOf<NodeEx>;
	 * }} NodeEx
	 */

	/** @typedef {ChildNode & NodeEx} ChildNodeEx */

	/** @typedef {NodeEx & { claim_order: number }} NodeEx2 */

	/**
	 * @typedef {ChildNodeEx[] & {
	 * 	claim_info?: {
	 * 		last_index: number;
	 * 		total_claimed: number;
	 * 	};
	 * }} ChildNodeArray
	 */

	// we need to store the information for multiple documents because a Svelte application could also contain iframes
	// https://github.com/sveltejs/svelte/issues/3624
	/** @type {Map<Document | ShadowRoot, import('./private.d.ts').StyleInformation>} */
	const managed_styles = new Map();

	let active = 0;

	// https://github.com/darkskyapp/string-hash/blob/master/index.js
	/**
	 * @param {string} str
	 * @returns {number}
	 */
	function hash(str) {
		let hash = 5381;
		let i = str.length;
		while (i--) hash = ((hash << 5) - hash) ^ str.charCodeAt(i);
		return hash >>> 0;
	}

	/**
	 * @param {Document | ShadowRoot} doc
	 * @param {Element & ElementCSSInlineStyle} node
	 * @returns {{ stylesheet: any; rules: {}; }}
	 */
	function create_style_information(doc, node) {
		const info = { stylesheet: append_empty_stylesheet(node), rules: {} };
		managed_styles.set(doc, info);
		return info;
	}

	/**
	 * @param {Element & ElementCSSInlineStyle} node
	 * @param {number} a
	 * @param {number} b
	 * @param {number} duration
	 * @param {number} delay
	 * @param {(t: number) => number} ease
	 * @param {(t: number, u: number) => string} fn
	 * @param {number} uid
	 * @returns {string}
	 */
	function create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
		const step = 16.666 / duration;
		let keyframes = '{\n';
		for (let p = 0; p <= 1; p += step) {
			const t = a + (b - a) * ease(p);
			keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
		}
		const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
		const name = `__svelte_${hash(rule)}_${uid}`;
		const doc = get_root_for_style(node);
		const { stylesheet, rules } = managed_styles.get(doc) || create_style_information(doc, node);
		if (!rules[name]) {
			rules[name] = true;
			stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
		}
		const animation = node.style.animation || '';
		node.style.animation = `${
		animation ? `${animation}, ` : ''
	}${name} ${duration}ms linear ${delay}ms 1 both`;
		active += 1;
		return name;
	}

	/**
	 * @param {Element & ElementCSSInlineStyle} node
	 * @param {string} [name]
	 * @returns {void}
	 */
	function delete_rule(node, name) {
		const previous = (node.style.animation || '').split(', ');
		const next = previous.filter(
			name
				? (anim) => anim.indexOf(name) < 0 // remove specific animation
				: (anim) => anim.indexOf('__svelte') === -1 // remove all Svelte animations
		);
		const deleted = previous.length - next.length;
		if (deleted) {
			node.style.animation = next.join(', ');
			active -= deleted;
			if (!active) clear_rules();
		}
	}

	/** @returns {void} */
	function clear_rules() {
		raf(() => {
			if (active) return;
			managed_styles.forEach((info) => {
				const { ownerNode } = info.stylesheet;
				// there is no ownerNode if it runs on jsdom.
				if (ownerNode) detach(ownerNode);
			});
			managed_styles.clear();
		});
	}

	let current_component;

	/** @returns {void} */
	function set_current_component(component) {
		current_component = component;
	}

	function get_current_component() {
		if (!current_component) throw new Error('Function called outside component initialization');
		return current_component;
	}

	/**
	 * Schedules a callback to run immediately before the component is updated after any state change.
	 *
	 * The first time the callback runs will be before the initial `onMount`
	 *
	 * https://svelte.dev/docs/svelte#beforeupdate
	 * @param {() => any} fn
	 * @returns {void}
	 */
	function beforeUpdate(fn) {
		get_current_component().$$.before_update.push(fn);
	}

	/**
	 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
	 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
	 * it can be called from an external module).
	 *
	 * If a function is returned _synchronously_ from `onMount`, it will be called when the component is unmounted.
	 *
	 * `onMount` does not run inside a [server-side component](https://svelte.dev/docs#run-time-server-side-component-api).
	 *
	 * https://svelte.dev/docs/svelte#onmount
	 * @template T
	 * @param {() => import('./private.js').NotFunction<T> | Promise<import('./private.js').NotFunction<T>> | (() => any)} fn
	 * @returns {void}
	 */
	function onMount(fn) {
		get_current_component().$$.on_mount.push(fn);
	}

	/**
	 * Schedules a callback to run immediately after the component has been updated.
	 *
	 * The first time the callback runs will be after the initial `onMount`
	 *
	 * https://svelte.dev/docs/svelte#afterupdate
	 * @param {() => any} fn
	 * @returns {void}
	 */
	function afterUpdate(fn) {
		get_current_component().$$.after_update.push(fn);
	}

	/**
	 * Creates an event dispatcher that can be used to dispatch [component events](https://svelte.dev/docs#template-syntax-component-directives-on-eventname).
	 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
	 *
	 * Component events created with `createEventDispatcher` create a
	 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
	 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
	 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
	 * property and can contain any type of data.
	 *
	 * The event dispatcher can be typed to narrow the allowed event names and the type of the `detail` argument:
	 * ```ts
	 * const dispatch = createEventDispatcher<{
	 *  loaded: never; // does not take a detail argument
	 *  change: string; // takes a detail argument of type string, which is required
	 *  optional: number | null; // takes an optional detail argument of type number
	 * }>();
	 * ```
	 *
	 * https://svelte.dev/docs/svelte#createeventdispatcher
	 * @template {Record<string, any>} [EventMap=any]
	 * @returns {import('./public.js').EventDispatcher<EventMap>}
	 */
	function createEventDispatcher() {
		const component = get_current_component();
		return (type, detail, { cancelable = false } = {}) => {
			const callbacks = component.$$.callbacks[type];
			if (callbacks) {
				// TODO are there situations where events could be dispatched
				// in a server (non-DOM) environment?
				const event = custom_event(/** @type {string} */ (type), detail, { cancelable });
				callbacks.slice().forEach((fn) => {
					fn.call(component, event);
				});
				return !event.defaultPrevented;
			}
			return true;
		};
	}

	const dirty_components = [];
	const binding_callbacks = [];

	let render_callbacks = [];

	const flush_callbacks = [];

	const resolved_promise = /* @__PURE__ */ Promise.resolve();

	let update_scheduled = false;

	/** @returns {void} */
	function schedule_update() {
		if (!update_scheduled) {
			update_scheduled = true;
			resolved_promise.then(flush);
		}
	}

	/** @returns {void} */
	function add_render_callback(fn) {
		render_callbacks.push(fn);
	}

	// flush() calls callbacks in this order:
	// 1. All beforeUpdate callbacks, in order: parents before children
	// 2. All bind:this callbacks, in reverse order: children before parents.
	// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
	//    for afterUpdates called during the initial onMount, which are called in
	//    reverse order: children before parents.
	// Since callbacks might update component values, which could trigger another
	// call to flush(), the following steps guard against this:
	// 1. During beforeUpdate, any updated components will be added to the
	//    dirty_components array and will cause a reentrant call to flush(). Because
	//    the flush index is kept outside the function, the reentrant call will pick
	//    up where the earlier call left off and go through all dirty components. The
	//    current_component value is saved and restored so that the reentrant call will
	//    not interfere with the "parent" flush() call.
	// 2. bind:this callbacks cannot trigger new flush() calls.
	// 3. During afterUpdate, any updated components will NOT have their afterUpdate
	//    callback called a second time; the seen_callbacks set, outside the flush()
	//    function, guarantees this behavior.
	const seen_callbacks = new Set();

	let flushidx = 0; // Do *not* move this inside the flush() function

	/** @returns {void} */
	function flush() {
		// Do not reenter flush while dirty components are updated, as this can
		// result in an infinite loop. Instead, let the inner flush handle it.
		// Reentrancy is ok afterwards for bindings etc.
		if (flushidx !== 0) {
			return;
		}
		const saved_component = current_component;
		do {
			// first, call beforeUpdate functions
			// and update components
			try {
				while (flushidx < dirty_components.length) {
					const component = dirty_components[flushidx];
					flushidx++;
					set_current_component(component);
					update(component.$$);
				}
			} catch (e) {
				// reset dirty state to not end up in a deadlocked state and then rethrow
				dirty_components.length = 0;
				flushidx = 0;
				throw e;
			}
			set_current_component(null);
			dirty_components.length = 0;
			flushidx = 0;
			while (binding_callbacks.length) binding_callbacks.pop()();
			// then, once components are updated, call
			// afterUpdate functions. This may cause
			// subsequent updates...
			for (let i = 0; i < render_callbacks.length; i += 1) {
				const callback = render_callbacks[i];
				if (!seen_callbacks.has(callback)) {
					// ...so guard against infinite loops
					seen_callbacks.add(callback);
					callback();
				}
			}
			render_callbacks.length = 0;
		} while (dirty_components.length);
		while (flush_callbacks.length) {
			flush_callbacks.pop()();
		}
		update_scheduled = false;
		seen_callbacks.clear();
		set_current_component(saved_component);
	}

	/** @returns {void} */
	function update($$) {
		if ($$.fragment !== null) {
			$$.update();
			run_all($$.before_update);
			const dirty = $$.dirty;
			$$.dirty = [-1];
			$$.fragment && $$.fragment.p($$.ctx, dirty);
			$$.after_update.forEach(add_render_callback);
		}
	}

	/**
	 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
	 * @param {Function[]} fns
	 * @returns {void}
	 */
	function flush_render_callbacks(fns) {
		const filtered = [];
		const targets = [];
		render_callbacks.forEach((c) => (fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c)));
		targets.forEach((c) => c());
		render_callbacks = filtered;
	}

	/**
	 * @type {Promise<void> | null}
	 */
	let promise;

	/**
	 * @returns {Promise<void>}
	 */
	function wait() {
		if (!promise) {
			promise = Promise.resolve();
			promise.then(() => {
				promise = null;
			});
		}
		return promise;
	}

	/**
	 * @param {Element} node
	 * @param {INTRO | OUTRO | boolean} direction
	 * @param {'start' | 'end'} kind
	 * @returns {void}
	 */
	function dispatch(node, direction, kind) {
		node.dispatchEvent(custom_event(`${direction ? 'intro' : 'outro'}${kind}`));
	}

	const outroing = new Set();

	/**
	 * @type {Outro}
	 */
	let outros;

	/**
	 * @returns {void} */
	function group_outros() {
		outros = {
			r: 0,
			c: [],
			p: outros // parent group
		};
	}

	/**
	 * @returns {void} */
	function check_outros() {
		if (!outros.r) {
			run_all(outros.c);
		}
		outros = outros.p;
	}

	/**
	 * @param {import('./private.js').Fragment} block
	 * @param {0 | 1} [local]
	 * @returns {void}
	 */
	function transition_in(block, local) {
		if (block && block.i) {
			outroing.delete(block);
			block.i(local);
		}
	}

	/**
	 * @param {import('./private.js').Fragment} block
	 * @param {0 | 1} local
	 * @param {0 | 1} [detach]
	 * @param {() => void} [callback]
	 * @returns {void}
	 */
	function transition_out(block, local, detach, callback) {
		if (block && block.o) {
			if (outroing.has(block)) return;
			outroing.add(block);
			outros.c.push(() => {
				outroing.delete(block);
				if (callback) {
					if (detach) block.d(1);
					callback();
				}
			});
			block.o(local);
		} else if (callback) {
			callback();
		}
	}

	/**
	 * @type {import('../transition/public.js').TransitionConfig}
	 */
	const null_transition = { duration: 0 };

	/**
	 * @param {Element & ElementCSSInlineStyle} node
	 * @param {TransitionFn} fn
	 * @param {any} params
	 * @param {boolean} intro
	 * @returns {{ run(b: 0 | 1): void; end(): void; }}
	 */
	function create_bidirectional_transition(node, fn, params, intro) {
		/**
		 * @type {TransitionOptions} */
		const options = { direction: 'both' };
		let config = fn(node, params, options);
		let t = intro ? 0 : 1;

		/**
		 * @type {Program | null} */
		let running_program = null;

		/**
		 * @type {PendingProgram | null} */
		let pending_program = null;
		let animation_name = null;

		/** @type {boolean} */
		let original_inert_value;

		/**
		 * @returns {void} */
		function clear_animation() {
			if (animation_name) delete_rule(node, animation_name);
		}

		/**
		 * @param {PendingProgram} program
		 * @param {number} duration
		 * @returns {Program}
		 */
		function init(program, duration) {
			const d = /** @type {Program['d']} */ (program.b - t);
			duration *= Math.abs(d);
			return {
				a: t,
				b: program.b,
				d,
				duration,
				start: program.start,
				end: program.start + duration,
				group: program.group
			};
		}

		/**
		 * @param {INTRO | OUTRO} b
		 * @returns {void}
		 */
		function go(b) {
			const {
				delay = 0,
				duration = 300,
				easing = identity$1,
				tick = noop,
				css
			} = config || null_transition;

			/**
			 * @type {PendingProgram} */
			const program = {
				start: now() + delay,
				b
			};

			if (!b) {
				// @ts-ignore todo: improve typings
				program.group = outros;
				outros.r += 1;
			}

			if ('inert' in node) {
				if (b) {
					if (original_inert_value !== undefined) {
						// aborted/reversed outro — restore previous inert value
						node.inert = original_inert_value;
					}
				} else {
					original_inert_value = /** @type {HTMLElement} */ (node).inert;
					node.inert = true;
				}
			}

			if (running_program || pending_program) {
				pending_program = program;
			} else {
				// if this is an intro, and there's a delay, we need to do
				// an initial tick and/or apply CSS animation immediately
				if (css) {
					clear_animation();
					animation_name = create_rule(node, t, b, duration, delay, easing, css);
				}
				if (b) tick(0, 1);
				running_program = init(program, duration);
				add_render_callback(() => dispatch(node, b, 'start'));
				loop((now) => {
					if (pending_program && now > pending_program.start) {
						running_program = init(pending_program, duration);
						pending_program = null;
						dispatch(node, running_program.b, 'start');
						if (css) {
							clear_animation();
							animation_name = create_rule(
								node,
								t,
								running_program.b,
								running_program.duration,
								0,
								easing,
								config.css
							);
						}
					}
					if (running_program) {
						if (now >= running_program.end) {
							tick((t = running_program.b), 1 - t);
							dispatch(node, running_program.b, 'end');
							if (!pending_program) {
								// we're done
								if (running_program.b) {
									// intro — we can tidy up immediately
									clear_animation();
								} else {
									// outro — needs to be coordinated
									if (!--running_program.group.r) run_all(running_program.group.c);
								}
							}
							running_program = null;
						} else if (now >= running_program.start) {
							const p = now - running_program.start;
							t = running_program.a + running_program.d * easing(p / running_program.duration);
							tick(t, 1 - t);
						}
					}
					return !!(running_program || pending_program);
				});
			}
		}
		return {
			run(b) {
				if (is_function(config)) {
					wait().then(() => {
						const opts = { direction: b ? 'in' : 'out' };
						// @ts-ignore
						config = config(opts);
						go(b);
					});
				} else {
					go(b);
				}
			},
			end() {
				clear_animation();
				running_program = pending_program = null;
			}
		};
	}

	/** @typedef {1} INTRO */
	/** @typedef {0} OUTRO */
	/** @typedef {{ direction: 'in' | 'out' | 'both' }} TransitionOptions */
	/** @typedef {(node: Element, params: any, options: TransitionOptions) => import('../transition/public.js').TransitionConfig} TransitionFn */

	/**
	 * @typedef {Object} Outro
	 * @property {number} r
	 * @property {Function[]} c
	 * @property {Object} p
	 */

	/**
	 * @typedef {Object} PendingProgram
	 * @property {number} start
	 * @property {INTRO|OUTRO} b
	 * @property {Outro} [group]
	 */

	/**
	 * @typedef {Object} Program
	 * @property {number} a
	 * @property {INTRO|OUTRO} b
	 * @property {1|-1} d
	 * @property {number} duration
	 * @property {number} start
	 * @property {number} end
	 * @property {Outro} [group]
	 */

	// general each functions:

	function ensure_array_like(array_like_or_iterator) {
		return array_like_or_iterator?.length !== undefined
			? array_like_or_iterator
			: Array.from(array_like_or_iterator);
	}

	// keyed each functions:

	/** @returns {void} */
	function destroy_block(block, lookup) {
		block.d(1);
		lookup.delete(block.key);
	}

	/** @returns {any[]} */
	function update_keyed_each(
		old_blocks,
		dirty,
		get_key,
		dynamic,
		ctx,
		list,
		lookup,
		node,
		destroy,
		create_each_block,
		next,
		get_context
	) {
		let o = old_blocks.length;
		let n = list.length;
		let i = o;
		const old_indexes = {};
		while (i--) old_indexes[old_blocks[i].key] = i;
		const new_blocks = [];
		const new_lookup = new Map();
		const deltas = new Map();
		const updates = [];
		i = n;
		while (i--) {
			const child_ctx = get_context(ctx, list, i);
			const key = get_key(child_ctx);
			let block = lookup.get(key);
			if (!block) {
				block = create_each_block(key, child_ctx);
				block.c();
			} else if (dynamic) {
				// defer updates until all the DOM shuffling is done
				updates.push(() => block.p(child_ctx, dirty));
			}
			new_lookup.set(key, (new_blocks[i] = block));
			if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
		}
		const will_move = new Set();
		const did_move = new Set();
		/** @returns {void} */
		function insert(block) {
			transition_in(block, 1);
			block.m(node, next);
			lookup.set(block.key, block);
			next = block.first;
			n--;
		}
		while (o && n) {
			const new_block = new_blocks[n - 1];
			const old_block = old_blocks[o - 1];
			const new_key = new_block.key;
			const old_key = old_block.key;
			if (new_block === old_block) {
				// do nothing
				next = new_block.first;
				o--;
				n--;
			} else if (!new_lookup.has(old_key)) {
				// remove old block
				destroy(old_block, lookup);
				o--;
			} else if (!lookup.has(new_key) || will_move.has(new_key)) {
				insert(new_block);
			} else if (did_move.has(old_key)) {
				o--;
			} else if (deltas.get(new_key) > deltas.get(old_key)) {
				did_move.add(new_key);
				insert(new_block);
			} else {
				will_move.add(old_key);
				o--;
			}
		}
		while (o--) {
			const old_block = old_blocks[o];
			if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
		}
		while (n) insert(new_blocks[n - 1]);
		run_all(updates);
		return new_blocks;
	}

	/** @returns {void} */
	function mount_component(component, target, anchor) {
		const { fragment, after_update } = component.$$;
		fragment && fragment.m(target, anchor);
		// onMount happens before the initial afterUpdate
		add_render_callback(() => {
			const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
			// if the component was destroyed immediately
			// it will update the `$$.on_destroy` reference to `null`.
			// the destructured on_destroy may still reference to the old array
			if (component.$$.on_destroy) {
				component.$$.on_destroy.push(...new_on_destroy);
			} else {
				// Edge case - component was destroyed immediately,
				// most likely as a result of a binding initialising
				run_all(new_on_destroy);
			}
			component.$$.on_mount = [];
		});
		after_update.forEach(add_render_callback);
	}

	/** @returns {void} */
	function destroy_component(component, detaching) {
		const $$ = component.$$;
		if ($$.fragment !== null) {
			flush_render_callbacks($$.after_update);
			run_all($$.on_destroy);
			$$.fragment && $$.fragment.d(detaching);
			// TODO null out other refs, including component.$$ (but need to
			// preserve final state?)
			$$.on_destroy = $$.fragment = null;
			$$.ctx = [];
		}
	}

	/** @returns {void} */
	function make_dirty(component, i) {
		if (component.$$.dirty[0] === -1) {
			dirty_components.push(component);
			schedule_update();
			component.$$.dirty.fill(0);
		}
		component.$$.dirty[(i / 31) | 0] |= 1 << i % 31;
	}

	// TODO: Document the other params
	/**
	 * @param {SvelteComponent} component
	 * @param {import('./public.js').ComponentConstructorOptions} options
	 *
	 * @param {import('./utils.js')['not_equal']} not_equal Used to compare props and state values.
	 * @param {(target: Element | ShadowRoot) => void} [append_styles] Function that appends styles to the DOM when the component is first initialised.
	 * This will be the `add_css` function from the compiled component.
	 *
	 * @returns {void}
	 */
	function init(
		component,
		options,
		instance,
		create_fragment,
		not_equal,
		props,
		append_styles = null,
		dirty = [-1]
	) {
		const parent_component = current_component;
		set_current_component(component);
		/** @type {import('./private.js').T$$} */
		const $$ = (component.$$ = {
			fragment: null,
			ctx: [],
			// state
			props,
			update: noop,
			not_equal,
			bound: blank_object(),
			// lifecycle
			on_mount: [],
			on_destroy: [],
			on_disconnect: [],
			before_update: [],
			after_update: [],
			context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
			// everything else
			callbacks: blank_object(),
			dirty,
			skip_bound: false,
			root: options.target || parent_component.$$.root
		});
		append_styles && append_styles($$.root);
		let ready = false;
		$$.ctx = instance
			? instance(component, options.props || {}, (i, ret, ...rest) => {
					const value = rest.length ? rest[0] : ret;
					if ($$.ctx && not_equal($$.ctx[i], ($$.ctx[i] = value))) {
						if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
						if (ready) make_dirty(component, i);
					}
					return ret;
			  })
			: [];
		$$.update();
		ready = true;
		run_all($$.before_update);
		// `false` as a special case of no DOM component
		$$.fragment = create_fragment ? create_fragment($$.ctx) : false;
		if (options.target) {
			if (options.hydrate) {
				// TODO: what is the correct type here?
				// @ts-expect-error
				const nodes = children(options.target);
				$$.fragment && $$.fragment.l(nodes);
				nodes.forEach(detach);
			} else {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				$$.fragment && $$.fragment.c();
			}
			if (options.intro) transition_in(component.$$.fragment);
			mount_component(component, options.target, options.anchor);
			flush();
		}
		set_current_component(parent_component);
	}

	let SvelteElement;

	if (typeof HTMLElement === 'function') {
		SvelteElement = class extends HTMLElement {
			/** The Svelte component constructor */
			$$ctor;
			/** Slots */
			$$s;
			/** The Svelte component instance */
			$$c;
			/** Whether or not the custom element is connected */
			$$cn = false;
			/** Component props data */
			$$d = {};
			/** `true` if currently in the process of reflecting component props back to attributes */
			$$r = false;
			/** @type {Record<string, CustomElementPropDefinition>} Props definition (name, reflected, type etc) */
			$$p_d = {};
			/** @type {Record<string, Function[]>} Event listeners */
			$$l = {};
			/** @type {Map<Function, Function>} Event listener unsubscribe functions */
			$$l_u = new Map();

			constructor($$componentCtor, $$slots, use_shadow_dom) {
				super();
				this.$$ctor = $$componentCtor;
				this.$$s = $$slots;
				if (use_shadow_dom) {
					this.attachShadow({ mode: 'open' });
				}
			}

			addEventListener(type, listener, options) {
				// We can't determine upfront if the event is a custom event or not, so we have to
				// listen to both. If someone uses a custom event with the same name as a regular
				// browser event, this fires twice - we can't avoid that.
				this.$$l[type] = this.$$l[type] || [];
				this.$$l[type].push(listener);
				if (this.$$c) {
					const unsub = this.$$c.$on(type, listener);
					this.$$l_u.set(listener, unsub);
				}
				super.addEventListener(type, listener, options);
			}

			removeEventListener(type, listener, options) {
				super.removeEventListener(type, listener, options);
				if (this.$$c) {
					const unsub = this.$$l_u.get(listener);
					if (unsub) {
						unsub();
						this.$$l_u.delete(listener);
					}
				}
			}

			async connectedCallback() {
				this.$$cn = true;
				if (!this.$$c) {
					// We wait one tick to let possible child slot elements be created/mounted
					await Promise.resolve();
					if (!this.$$cn || this.$$c) {
						return;
					}
					function create_slot(name) {
						return () => {
							let node;
							const obj = {
								c: function create() {
									node = element('slot');
									if (name !== 'default') {
										attr(node, 'name', name);
									}
								},
								/**
								 * @param {HTMLElement} target
								 * @param {HTMLElement} [anchor]
								 */
								m: function mount(target, anchor) {
									insert(target, node, anchor);
								},
								d: function destroy(detaching) {
									if (detaching) {
										detach(node);
									}
								}
							};
							return obj;
						};
					}
					const $$slots = {};
					const existing_slots = get_custom_elements_slots(this);
					for (const name of this.$$s) {
						if (name in existing_slots) {
							$$slots[name] = [create_slot(name)];
						}
					}
					for (const attribute of this.attributes) {
						// this.$$data takes precedence over this.attributes
						const name = this.$$g_p(attribute.name);
						if (!(name in this.$$d)) {
							this.$$d[name] = get_custom_element_value(name, attribute.value, this.$$p_d, 'toProp');
						}
					}
					// Port over props that were set programmatically before ce was initialized
					for (const key in this.$$p_d) {
						if (!(key in this.$$d) && this[key] !== undefined) {
							this.$$d[key] = this[key]; // don't transform, these were set through JavaScript
							delete this[key]; // remove the property that shadows the getter/setter
						}
					}
					this.$$c = new this.$$ctor({
						target: this.shadowRoot || this,
						props: {
							...this.$$d,
							$$slots,
							$$scope: {
								ctx: []
							}
						}
					});

					// Reflect component props as attributes
					const reflect_attributes = () => {
						this.$$r = true;
						for (const key in this.$$p_d) {
							this.$$d[key] = this.$$c.$$.ctx[this.$$c.$$.props[key]];
							if (this.$$p_d[key].reflect) {
								const attribute_value = get_custom_element_value(
									key,
									this.$$d[key],
									this.$$p_d,
									'toAttribute'
								);
								if (attribute_value == null) {
									this.removeAttribute(this.$$p_d[key].attribute || key);
								} else {
									this.setAttribute(this.$$p_d[key].attribute || key, attribute_value);
								}
							}
						}
						this.$$r = false;
					};
					this.$$c.$$.after_update.push(reflect_attributes);
					reflect_attributes(); // once initially because after_update is added too late for first render

					for (const type in this.$$l) {
						for (const listener of this.$$l[type]) {
							const unsub = this.$$c.$on(type, listener);
							this.$$l_u.set(listener, unsub);
						}
					}
					this.$$l = {};
				}
			}

			// We don't need this when working within Svelte code, but for compatibility of people using this outside of Svelte
			// and setting attributes through setAttribute etc, this is helpful
			attributeChangedCallback(attr, _oldValue, newValue) {
				if (this.$$r) return;
				attr = this.$$g_p(attr);
				this.$$d[attr] = get_custom_element_value(attr, newValue, this.$$p_d, 'toProp');
				this.$$c?.$set({ [attr]: this.$$d[attr] });
			}

			disconnectedCallback() {
				this.$$cn = false;
				// In a microtask, because this could be a move within the DOM
				Promise.resolve().then(() => {
					if (!this.$$cn && this.$$c) {
						this.$$c.$destroy();
						this.$$c = undefined;
					}
				});
			}

			$$g_p(attribute_name) {
				return (
					Object.keys(this.$$p_d).find(
						(key) =>
							this.$$p_d[key].attribute === attribute_name ||
							(!this.$$p_d[key].attribute && key.toLowerCase() === attribute_name)
					) || attribute_name
				);
			}
		};
	}

	/**
	 * @param {string} prop
	 * @param {any} value
	 * @param {Record<string, CustomElementPropDefinition>} props_definition
	 * @param {'toAttribute' | 'toProp'} [transform]
	 */
	function get_custom_element_value(prop, value, props_definition, transform) {
		const type = props_definition[prop]?.type;
		value = type === 'Boolean' && typeof value !== 'boolean' ? value != null : value;
		if (!transform || !props_definition[prop]) {
			return value;
		} else if (transform === 'toAttribute') {
			switch (type) {
				case 'Object':
				case 'Array':
					return value == null ? null : JSON.stringify(value);
				case 'Boolean':
					return value ? '' : null;
				case 'Number':
					return value == null ? null : value;
				default:
					return value;
			}
		} else {
			switch (type) {
				case 'Object':
				case 'Array':
					return value && JSON.parse(value);
				case 'Boolean':
					return value; // conversion already handled above
				case 'Number':
					return value != null ? +value : value;
				default:
					return value;
			}
		}
	}

	/**
	 * @internal
	 *
	 * Turn a Svelte component into a custom element.
	 * @param {import('./public.js').ComponentType} Component  A Svelte component constructor
	 * @param {Record<string, CustomElementPropDefinition>} props_definition  The props to observe
	 * @param {string[]} slots  The slots to create
	 * @param {string[]} accessors  Other accessors besides the ones for props the component has
	 * @param {boolean} use_shadow_dom  Whether to use shadow DOM
	 * @param {(ce: new () => HTMLElement) => new () => HTMLElement} [extend]
	 */
	function create_custom_element(
		Component,
		props_definition,
		slots,
		accessors,
		use_shadow_dom,
		extend
	) {
		let Class = class extends SvelteElement {
			constructor() {
				super(Component, slots, use_shadow_dom);
				this.$$p_d = props_definition;
			}
			static get observedAttributes() {
				return Object.keys(props_definition).map((key) =>
					(props_definition[key].attribute || key).toLowerCase()
				);
			}
		};
		Object.keys(props_definition).forEach((prop) => {
			Object.defineProperty(Class.prototype, prop, {
				get() {
					return this.$$c && prop in this.$$c ? this.$$c[prop] : this.$$d[prop];
				},
				set(value) {
					value = get_custom_element_value(prop, value, props_definition);
					this.$$d[prop] = value;
					this.$$c?.$set({ [prop]: value });
				}
			});
		});
		accessors.forEach((accessor) => {
			Object.defineProperty(Class.prototype, accessor, {
				get() {
					return this.$$c?.[accessor];
				}
			});
		});
		if (extend) {
			// @ts-expect-error - assigning here is fine
			Class = extend(Class);
		}
		Component.element = /** @type {any} */ (Class);
		return Class;
	}

	/**
	 * Base class for Svelte components. Used when dev=false.
	 *
	 * @template {Record<string, any>} [Props=any]
	 * @template {Record<string, any>} [Events=any]
	 */
	class SvelteComponent {
		/**
		 * ### PRIVATE API
		 *
		 * Do not use, may change at any time
		 *
		 * @type {any}
		 */
		$$ = undefined;
		/**
		 * ### PRIVATE API
		 *
		 * Do not use, may change at any time
		 *
		 * @type {any}
		 */
		$$set = undefined;

		/** @returns {void} */
		$destroy() {
			destroy_component(this, 1);
			this.$destroy = noop;
		}

		/**
		 * @template {Extract<keyof Events, string>} K
		 * @param {K} type
		 * @param {((e: Events[K]) => void) | null | undefined} callback
		 * @returns {() => void}
		 */
		$on(type, callback) {
			if (!is_function(callback)) {
				return noop;
			}
			const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
			callbacks.push(callback);
			return () => {
				const index = callbacks.indexOf(callback);
				if (index !== -1) callbacks.splice(index, 1);
			};
		}

		/**
		 * @param {Partial<Props>} props
		 * @returns {void}
		 */
		$set(props) {
			if (this.$$set && !is_empty(props)) {
				this.$$.skip_bound = true;
				this.$$set(props);
				this.$$.skip_bound = false;
			}
		}
	}

	/**
	 * @typedef {Object} CustomElementPropDefinition
	 * @property {string} [attribute]
	 * @property {boolean} [reflect]
	 * @property {'String'|'Boolean'|'Number'|'Array'|'Object'} [type]
	 */

	// generated during release, do not modify

	const PUBLIC_VERSION = '4';

	if (typeof window !== 'undefined')
		// @ts-ignore
		(window.__svelte || (window.__svelte = { v: new Set() })).v.add(PUBLIC_VERSION);

	/* src\lib\web-components\select\eas-select.svelte generated by Svelte v4.2.19 */

	function add_css$x(target) {
		append_styles(target, "svelte-sigzy4", ".error.svelte-sigzy4.svelte-sigzy4{border-style:solid;border-color:red}.error-text.svelte-sigzy4.svelte-sigzy4{color:red}.ds-select-field.svelte-sigzy4.svelte-sigzy4{display:inline-flex;position:relative;width:100%;font-size:16px;color:#000;border-radius:4px 4px 0 0;padding:20px 20px 0;margin:0;border:0;outline:none;cursor:pointer;box-sizing:border-box;overflow:hidden;background:#fff;transition:all .2s ease-in-out}.rounded-4.svelte-sigzy4.svelte-sigzy4{border-radius:4px!important}select.svelte-sigzy4.svelte-sigzy4{outline:none;-webkit-writing-mode:horizontal-tb!important;text-rendering:auto;color:-internal-light-dark-color(black,black);letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0px;text-shadow:none;display:inline-block;text-align:start;-webkit-appearance:menulist;box-sizing:border-box;align-items:center;white-space:pre;-webkit-rtl-ordering:logical;background-color:-internal-light-dark-color(black,black)!important;cursor:default;margin:0;font:400 13.3333px Arial;border-radius:0;border-width:1px;border-style:solid;border-color:#a9a9a9;border-image:initial;appearance:none}select.svelte-sigzy4.svelte-sigzy4:not(:-internal-list-box){overflow:visible !important}.hover-gray-300.svelte-sigzy4.svelte-sigzy4:hover{background:#E8E8E8!important\r\n    }.select-container.svelte-sigzy4.svelte-sigzy4{position:relative}.border-gray-600.svelte-sigzy4.svelte-sigzy4{border-color:#8C8C8C!important}.border-bottom.svelte-sigzy4.svelte-sigzy4{border-bottom:1px solid #D9D9D9}.select-container.chevron.svelte-sigzy4.svelte-sigzy4::before{content:\"\\f078\";position:absolute;top:15px;right:20px;font-family:\"font awesome 5 pro\";font-weight:800;pointer-events:none;z-index:100}.select-container.chevron.svelte-sigzy4::before>select.svelte-sigzy4:active{content:\"\\f078\";position:absolute;top:18px;right:20px;font-family:\"font awesome 5 pro\";transform:rotate(180deg);pointer-events:none}.inline-text-field-container.svelte-sigzy4.svelte-sigzy4{display:flex;flex-direction:column}.even-cols.svelte-sigzy4.svelte-sigzy4{display:flex}.flex-row.svelte-sigzy4.svelte-sigzy4{flex-direction:row!important}.gap-20.svelte-sigzy4.svelte-sigzy4{gap:20px}.container.svelte-sigzy4.svelte-sigzy4{transition:all .2s ease-in-out;position:relative;width:100%}.border-medium.svelte-sigzy4.svelte-sigzy4{border-width:2px!important}.pb-20.svelte-sigzy4.svelte-sigzy4{padding-bottom:20px!important}.width-full.svelte-sigzy4.svelte-sigzy4{width:100%!important;max-width:100%!important}.pb-5.svelte-sigzy4.svelte-sigzy4{padding-bottom:5px!important}.ds-floating-label.svelte-sigzy4.svelte-sigzy4{text-decoration:inherit;text-transform:inherit;position:absolute;transform-origin:left top;transition:all .15s cubic-bezier(.4,0,.2,1);line-height:1.15rem;text-align:left;font-size:1rem;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;padding-right:16px}select.svelte-sigzy4:invalid~.ds-floating-label.svelte-sigzy4{left:0;right:auto;top:50%;width:100%;padding:0 20px;font-size:1em;transform:translateY(-50%);pointer-events:none;color:#434343}.select-container.chevron.svelte-sigzy4.svelte-sigzy4:before{top:23px;font-weight:800;z-index:100\r\n}.select-container.chevron.svelte-sigzy4.svelte-sigzy4:before,.select-container.chevron.svelte-sigzy4:before>select.svelte-sigzy4:active{content:\"\\f078\";position:absolute;right:20px;font-family:font awesome\\ 5 pro;pointer-events:none\r\n    }.select-container.chevron.svelte-sigzy4:before>select.svelte-sigzy4:active{top:18px;transform:rotate(180deg)\r\n    }select.svelte-sigzy4:invalid~.ds-floating-label.svelte-sigzy4{left:0;right:auto;top:50%;width:100%;padding:0 20px;font-size:1em;transform:translateY(-50%);pointer-events:none;color:#434343\r\n    }select.svelte-sigzy4:focus~.ds-floating-label.svelte-sigzy4,select.svelte-sigzy4:valid~.ds-floating-label.svelte-sigzy4{left:0;right:auto;top:20%;width:100%;padding:0 20px;font-size:.875rem;transform:translateY(-30%);pointer-events:none;color:#434343\r\n    }select:focus.ds-select-field.svelte-sigzy4.svelte-sigzy4,select:focus.ds-select-field.svelte-sigzy4.svelte-sigzy4:hover{background:#dfdfdf\r\n    }select.svelte-sigzy4.svelte-sigzy4::-ms-expand{display:none\r\n    }.select-container.svelte-sigzy4.svelte-sigzy4{position:relative\r\n    }");
	}

	function get_each_context$c(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[14] = list[i];
		return child_ctx;
	}

	// (26:24) {#each data as item}
	function create_each_block$c(ctx) {
		let option;
		let t0_value = /*item*/ ctx[14].value + "";
		let t0;
		let t1;
		let option_value_value;

		return {
			c() {
				option = element("option");
				t0 = text(t0_value);
				t1 = space();
				option.__value = option_value_value = /*item*/ ctx[14].key;
				set_input_value(option, option.__value);
			},
			m(target, anchor) {
				insert(target, option, anchor);
				append(option, t0);
				append(option, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 4 && t0_value !== (t0_value = /*item*/ ctx[14].value + "")) set_data(t0, t0_value);

				if (dirty & /*data*/ 4 && option_value_value !== (option_value_value = /*item*/ ctx[14].key)) {
					option.__value = option_value_value;
					set_input_value(option, option.__value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(option);
				}
			}
		};
	}

	// (35:12) {#if error}
	function create_if_block$k(ctx) {
		let div;
		let t;

		return {
			c() {
				div = element("div");
				t = text(/*errormessage*/ ctx[9]);
				attr(div, "class", "error-text svelte-sigzy4");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t);
			},
			p(ctx, dirty) {
				if (dirty & /*errormessage*/ 512) set_data(t, /*errormessage*/ ctx[9]);
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	function create_fragment$y(ctx) {
		let link;
		let t0;
		let div4;
		let div3;
		let div2;
		let div1;
		let div0;
		let select;
		let option;
		let t1;
		let label;
		let t2;
		let t3_value = (/*required*/ ctx[7] ? '*' : '') + "";
		let t3;
		let div1_class_value;
		let t4;
		let mounted;
		let dispose;
		let each_value = ensure_array_like(/*data*/ ctx[2]);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$c(get_each_context$c(ctx, each_value, i));
		}

		let if_block = /*error*/ ctx[8] && create_if_block$k(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div4 = element("div");
				div3 = element("div");
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");
				select = element("select");
				option = element("option");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t1 = space();
				label = element("label");
				t2 = text(/*placeholder*/ ctx[3]);
				t3 = text(t3_value);
				t4 = space();
				if (if_block) if_block.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				option.__value = "";
				set_input_value(option, option.__value);
				option.disabled = true;
				option.selected = true;
				select.required = true;
				attr(select, "class", "ds-select-field rounded-4 hover-gray-300 svelte-sigzy4");
				attr(select, "id", /*controlid*/ ctx[1]);
				set_style(select, "height", /*height*/ ctx[4] ? /*height*/ ctx[4] + 'px' : '50px');
				set_style(select, "width", /*width*/ ctx[5] ? /*width*/ ctx[5] + 'px' : '500px');

				set_style(select, "font-size", /*fontsize*/ ctx[6]
				? /*fontsize*/ ctx[6] + 'px'
				: '16px');

				if (/*selecteditem*/ ctx[0] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[11].call(select));
				attr(label, "class", "ds-floating-label svelte-sigzy4");
				attr(div0, "class", "select-container chevron border-bottom border-gray-600 svelte-sigzy4");
				attr(div1, "class", div1_class_value = "inline-text-field-container even-cols flex-row gap-20 " + (/*error*/ ctx[8] ? 'error' : '') + " svelte-sigzy4");
				attr(div2, "class", "container border-medium pb-20 svelte-sigzy4");
				attr(div3, "class", "width-full svelte-sigzy4");
				attr(div4, "class", "flex-row pb-5 svelte-sigzy4");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div4, anchor);
				append(div4, div3);
				append(div3, div2);
				append(div2, div1);
				append(div1, div0);
				append(div0, select);
				append(select, option);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(select, null);
					}
				}

				select_option(select, /*selecteditem*/ ctx[0], true);
				append(div0, t1);
				append(div0, label);
				append(label, t2);
				append(label, t3);
				append(div2, t4);
				if (if_block) if_block.m(div2, null);

				if (!mounted) {
					dispose = [
						listen(select, "change", /*select_change_handler*/ ctx[11]),
						listen(select, "change", /*change_handler*/ ctx[12])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*data*/ 4) {
					each_value = ensure_array_like(/*data*/ ctx[2]);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$c(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$c(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(select, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}

				if (dirty & /*controlid*/ 2) {
					attr(select, "id", /*controlid*/ ctx[1]);
				}

				if (dirty & /*height*/ 16) {
					set_style(select, "height", /*height*/ ctx[4] ? /*height*/ ctx[4] + 'px' : '50px');
				}

				if (dirty & /*width*/ 32) {
					set_style(select, "width", /*width*/ ctx[5] ? /*width*/ ctx[5] + 'px' : '500px');
				}

				if (dirty & /*fontsize*/ 64) {
					set_style(select, "font-size", /*fontsize*/ ctx[6]
					? /*fontsize*/ ctx[6] + 'px'
					: '16px');
				}

				if (dirty & /*selecteditem, data*/ 5) {
					select_option(select, /*selecteditem*/ ctx[0]);
				}

				if (dirty & /*placeholder*/ 8) set_data(t2, /*placeholder*/ ctx[3]);
				if (dirty & /*required*/ 128 && t3_value !== (t3_value = (/*required*/ ctx[7] ? '*' : '') + "")) set_data(t3, t3_value);

				if (dirty & /*error*/ 256 && div1_class_value !== (div1_class_value = "inline-text-field-container even-cols flex-row gap-20 " + (/*error*/ ctx[8] ? 'error' : '') + " svelte-sigzy4")) {
					attr(div1, "class", div1_class_value);
				}

				if (/*error*/ ctx[8]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$k(ctx);
						if_block.c();
						if_block.m(div2, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div4);
				}

				destroy_each(each_blocks, detaching);
				if (if_block) if_block.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$y($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { controlid } = $$props;
		let { data = [] } = $$props;
		let { placeholder } = $$props;
		let { height } = $$props;
		let { width } = $$props;
		let { fontsize } = $$props;
		let { required } = $$props;
		let { error = false } = $$props;
		let { errormessage } = $$props;
		let { selecteditem } = $$props;

		function onSelect(e) {
			svelteDispatch("itemselected", { selectedItem: selecteditem });
		}

		function select_change_handler() {
			selecteditem = select_value(this);
			$$invalidate(0, selecteditem);
			$$invalidate(2, data);
		}

		const change_handler = e => onSelect();

		$$self.$$set = $$props => {
			if ('controlid' in $$props) $$invalidate(1, controlid = $$props.controlid);
			if ('data' in $$props) $$invalidate(2, data = $$props.data);
			if ('placeholder' in $$props) $$invalidate(3, placeholder = $$props.placeholder);
			if ('height' in $$props) $$invalidate(4, height = $$props.height);
			if ('width' in $$props) $$invalidate(5, width = $$props.width);
			if ('fontsize' in $$props) $$invalidate(6, fontsize = $$props.fontsize);
			if ('required' in $$props) $$invalidate(7, required = $$props.required);
			if ('error' in $$props) $$invalidate(8, error = $$props.error);
			if ('errormessage' in $$props) $$invalidate(9, errormessage = $$props.errormessage);
			if ('selecteditem' in $$props) $$invalidate(0, selecteditem = $$props.selecteditem);
		};

		return [
			selecteditem,
			controlid,
			data,
			placeholder,
			height,
			width,
			fontsize,
			required,
			error,
			errormessage,
			onSelect,
			select_change_handler,
			change_handler
		];
	}

	class Eas_select extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$y,
				create_fragment$y,
				safe_not_equal,
				{
					controlid: 1,
					data: 2,
					placeholder: 3,
					height: 4,
					width: 5,
					fontsize: 6,
					required: 7,
					error: 8,
					errormessage: 9,
					selecteditem: 0
				},
				add_css$x
			);
		}

		get controlid() {
			return this.$$.ctx[1];
		}

		set controlid(controlid) {
			this.$$set({ controlid });
			flush();
		}

		get data() {
			return this.$$.ctx[2];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}

		get placeholder() {
			return this.$$.ctx[3];
		}

		set placeholder(placeholder) {
			this.$$set({ placeholder });
			flush();
		}

		get height() {
			return this.$$.ctx[4];
		}

		set height(height) {
			this.$$set({ height });
			flush();
		}

		get width() {
			return this.$$.ctx[5];
		}

		set width(width) {
			this.$$set({ width });
			flush();
		}

		get fontsize() {
			return this.$$.ctx[6];
		}

		set fontsize(fontsize) {
			this.$$set({ fontsize });
			flush();
		}

		get required() {
			return this.$$.ctx[7];
		}

		set required(required) {
			this.$$set({ required });
			flush();
		}

		get error() {
			return this.$$.ctx[8];
		}

		set error(error) {
			this.$$set({ error });
			flush();
		}

		get errormessage() {
			return this.$$.ctx[9];
		}

		set errormessage(errormessage) {
			this.$$set({ errormessage });
			flush();
		}

		get selecteditem() {
			return this.$$.ctx[0];
		}

		set selecteditem(selecteditem) {
			this.$$set({ selecteditem });
			flush();
		}
	}

	customElements.define("eas-select", create_custom_element(Eas_select, {"controlid":{},"data":{},"placeholder":{},"height":{},"width":{},"fontsize":{},"required":{},"error":{"type":"Boolean"},"errormessage":{},"selecteditem":{}}, [], [], true));

	var ContactGroup;
	(function (ContactGroup) {
	    ContactGroup[ContactGroup["SEA"] = 1] = "SEA";
	    ContactGroup[ContactGroup["RelatedOrg"] = 2] = "RelatedOrg";
	    ContactGroup[ContactGroup["LEA"] = 3] = "LEA";
	})(ContactGroup || (ContactGroup = {}));

	class ServiceBase {
	    _headers = new Headers();
	    easBaseUrl;
	    easDataloadBaseUrl;
	    monitoringBaseUrl;
	    easAssetAuthUrl;
	    helpBaseUrl;
	    easUtilityUrl;
	    easWorkflowBaseUrl;
	    easContactBaseUrl;
	    validationResultsUrl;
	    validationRevalidateUrl;
	    apiEndPoint;
	    easCommunicationLogUrl;
	    easCommunicationUrl;
	    accessToken;
	    claimToken;
	    get headers() {
	        // Every time we get the headers, we need to check if the access token and claims token
	        // are already loaded. If not, we need to load them from session storage. 
	        // Otherwise it just returns the headers without any change. - kevin.low 01/02/24
	        if (!('accessToken' in this.accessToken)) {
	            console.error('accessToken not in this.accessToken. Reloading it from session storage.');
	            try {
	                this.accessToken = JSON.parse(sessionStorage.getItem('accessToken') ?? '{}');
	                if (!('accessToken' in this.accessToken)) {
	                    console.error('accessToken is still not found in session storage.');
	                }
	                else {
	                    this._headers.delete('Authorization');
	                    this._headers.append('Authorization', `Bearer ${this.accessToken?.accessToken}`);
	                }
	            }
	            catch (error) {
	                console.error(error);
	            }
	        }
	        try {
	            let updatedClaimToken = JSON.parse(sessionStorage.getItem('claims') ?? '{}');
	            if (!('claimsJwt' in this.claimToken)) {
	                console.error('claims is still not found in session storage.');
	            }
	            else {
	                if (this.claimToken?.claimsJwt != updatedClaimToken?.claimsJwt) {
	                    this._headers.delete('claims');
	                    this._headers.append('claims', this.claimToken?.claimsJwt);
	                }
	            }
	        }
	        catch (error) {
	            console.error(error);
	        }
	        return this._headers;
	    }
	    set headers(value) {
	        this._headers = value;
	    }
	    constructor() {
	        //Storybook url
	        if (window.location.href.includes(':6006')) {
	            sessionStorage.setItem('EAS_Base_Url', 'https://edu-dev-eas-assetauth.azurewebsites.net');
	            sessionStorage.setItem('EAS_Dataload_Base_Url', 'https://edu-dev-eas-dataload-request.azurewebsites.net');
	            sessionStorage.setItem('Asset_Auth_Url', 'https://edu-dev-eas-assetauth.azurewebsites.net');
	            sessionStorage.setItem('Eas_Help_Url', 'https://edu-dev-ent-help.azurewebsites.net');
	            sessionStorage.setItem('Eas_Utility_Url', 'https://edu-dev-eas-utility.azurewebsites.net');
	            sessionStorage.setItem('Eas_Workflow_Url', 'https://edu-dev-eas-workflow.azurewebsites.net');
	            sessionStorage.setItem('Eas_Contact_Url', 'https://edu-dev-eas-contact.azurewebsites.net');
	            sessionStorage.setItem('Eas_CommunicationLog_Url', 'https://edu-dev-eas-communicationlog.azurewebsites.net');
	            sessionStorage.setItem('Eas_Communication_Url', 'https://edu-dev-eas-communication.azurewebsites.net');
	            sessionStorage.setItem('accessToken', `{"accessToken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYzYmVjNmVkLWRlMDUtNGQxZS05ZTI0LTQwZTJlNTUxNGQzYSIsInVuaXF1ZV9uYW1lIjoiOTUzMDQiLCJmaXJzdF9uYW1lIjoiRGlhbmUiLCJsYXN0X25hbWUiOiJOZWFsIiwicGVyc29uX2tleSI6Ijk1MzA0Iiwic3lzdGVtX2tleSI6IjMwIiwidXVpZCI6IkE5Uk8wR1RXSklTTFJCSEo1UkU4WVVYTTlTUFJOSEIwVTk0QyIsInN5c3RlbV91cmwiOiJodHRwczovL2Vkc3RlcHNkZXYuZWR1Y2F0aW9uLm9oaW8uZ292L29uZWZ1bmRpbmcvIiwic3lzdGVtX25hbWUiOiJPbmUgRnVuZGluZyBBcHBsaWNhdGlvbiIsIm9mZmljZV9lbWFpbCI6IiIsImhvbWVfZW1haWwiOiIiLCJvYWtzX2lkIjoiIiwibmJmIjoxNzI3Nzg2MDQyLCJleHAiOjE3Mjc4NzI0NDIsImlhdCI6MTcyNzc4NjA0MiwiaXNzIjoib2hpby1kZXBhcnRtZW50LW9mLWVkdWNhdGlvbiIsImF1ZCI6ImVhc19hdWRpZW5jZSJ9.ZxhT5--NANxGfhrG15E_uCJp3iCR9nu_hykdzROYYN4","orgs":[{"org_id":6108,"name":"Ohio Department of Education and Workforce","audiences":[{"aud_id":1,"name":"Admin","applications":[{"app_id":231,"name":"One Funding Application","url":null}]}],"irn":"050765"}],"expires":"2024-10-02T08:34:02.4470379Z","public":false}`);
	            sessionStorage.setItem('claims', `{"claimsJwt":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYwNDdhZTYwLWE3Y2YtNDlhMy1hNjdiLTQ4YzgxYTIwMzU1ZSIsImFwcGxpY2F0aW9uX2tleSI6IjIzMSIsImF1ZGllbmNlX2tleSI6IjEiLCJvcmdfa2V5IjoiNjEwOCIsIm9yZ19uYW1lIjoiT2hpbyBEZXBhcnRtZW50IG9mIEVkdWNhdGlvbiBhbmQgV29ya2ZvcmNlIiwiaXJuIjoiMDUwNzY1Iiwib3JnX3R5cGVfa2V5IjoiMjciLCJvcmdfdHlwZV9uYW1lIjoiU3RhdGUgQm9hcmQvQWdlbmN5Iiwicm9sZV9jb250ZXh0IjoiMjciLCJjb250YWN0X2NvbnRleHRfaWQiOiIzNDAiLCJjb250YWN0X2NvbnRleHRfdXJsIjoiaHR0cHM6Ly9lZHUtZGV2LW9uZS1mdW5kaW5nLWdhdGV3YXkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL0NvbnRhY3RDb250ZXh0LzM0MCIsIm5iZiI6MTcyNzc4NjA1NSwiZXhwIjoxNzI3ODcyNDU1LCJpYXQiOjE3Mjc3ODYwNTUsImlzcyI6Im9oaW8tZGVwYXJ0bWVudC1vZi1lZHVjYXRpb24iLCJhdWQiOiJlYXNfYXVkaWVuY2UifQ.rX-IV9OdOKB2SeqGE171a0Ks-h6Mzy5VoIp1pSO9sg0","claims":{"organizationId":6108,"audienceId":1,"applicationId":231,"contactContextId":"340","contactContextUrl":"https://edu-dev-one-funding-gateway.azurewebsites.net/api/ContactContext/340"}}`);
	        }
	        this.easBaseUrl = sessionStorage.getItem('EAS_Base_Url') ?? '';
	        this.easDataloadBaseUrl = sessionStorage.getItem('EAS_Dataload_Base_Url') ?? '';
	        this.monitoringBaseUrl = sessionStorage.getItem('Monitoring_Base_Url') ?? '';
	        this.easAssetAuthUrl = sessionStorage.getItem('Asset_Auth_Url') ?? '';
	        this.helpBaseUrl = sessionStorage.getItem('Eas_Help_Url') ?? '';
	        this.easUtilityUrl = sessionStorage.getItem('Eas_Utility_Url') ?? '';
	        this.easWorkflowBaseUrl = sessionStorage.getItem('Eas_Workflow_Url') ?? '';
	        this.easContactBaseUrl = sessionStorage.getItem('Eas_Contact_Url') ?? '';
	        this.validationResultsUrl = sessionStorage.getItem('Validation_Results_Url') ?? '';
	        this.validationRevalidateUrl = sessionStorage.getItem('Validation_Revalidate_Url') ?? '';
	        this.apiEndPoint = sessionStorage.getItem('APIEndPoint') ?? '';
	        this.easCommunicationLogUrl = sessionStorage.getItem('Eas_CommunicationLog_Url') ?? '';
	        this.easCommunicationUrl = sessionStorage.getItem('Eas_Communication_Url') ?? '';
	        try {
	            this.accessToken = JSON.parse(sessionStorage.getItem('accessToken') ?? '{}');
	            if (!('accessToken' in this.accessToken)) {
	                console.error('accessToken is not found in session storage.');
	            }
	        }
	        catch (error) {
	            console.log(error);
	        }
	        try {
	            this.claimToken = JSON.parse(sessionStorage.getItem('claims') ?? '{}');
	            if (!('claimsJwt' in this.claimToken)) {
	                console.error('claims is not found in session storage.');
	            }
	        }
	        catch (error) {
	            console.error(error);
	        }
	        this.headers = new Headers();
	        this.headers.append('Content-Type', 'application/json');
	        this.headers.append('Authorization', `Bearer ${this.accessToken?.accessToken}`);
	        //this.headers.append('Authorization', `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYzYmVjNmVkLWRlMDUtNGQxZS05ZTI0LTQwZTJlNTUxNGQzYSIsInVuaXF1ZV9uYW1lIjoiOTUzMDQiLCJmaXJzdF9uYW1lIjoiRGlhbmUiLCJsYXN0X25hbWUiOiJOZWFsIiwicGVyc29uX2tleSI6Ijk1MzA0Iiwic3lzdGVtX2tleSI6IjMwIiwidXVpZCI6IkE5Uk8wR1RXSklTTFJCSEo1UkU4WVVYTTlTUFJOSEIwVTk0QyIsInN5c3RlbV91cmwiOiJodHRwczovL2Vkc3RlcHNkZXYuZWR1Y2F0aW9uLm9oaW8uZ292L29uZWZ1bmRpbmcvIiwic3lzdGVtX25hbWUiOiJPbmUgRnVuZGluZyBBcHBsaWNhdGlvbiIsIm9mZmljZV9lbWFpbCI6IiIsImhvbWVfZW1haWwiOiIiLCJvYWtzX2lkIjoiIiwibmJmIjoxNzI3Nzg2MDQyLCJleHAiOjE3Mjc4NzI0NDIsImlhdCI6MTcyNzc4NjA0MiwiaXNzIjoib2hpby1kZXBhcnRtZW50LW9mLWVkdWNhdGlvbiIsImF1ZCI6ImVhc19hdWRpZW5jZSJ9.ZxhT5--NANxGfhrG15E_uCJp3iCR9nu_hykdzROYYN4`);
	        this.headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
	        this.headers.append('x-requestid', this.generateUUID());
	        this.headers.append('claims', this.claimToken?.claimsJwt);
	        //this.headers.append('claims', `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYwNDdhZTYwLWE3Y2YtNDlhMy1hNjdiLTQ4YzgxYTIwMzU1ZSIsImFwcGxpY2F0aW9uX2tleSI6IjIzMSIsImF1ZGllbmNlX2tleSI6IjEiLCJvcmdfa2V5IjoiNjEwOCIsIm9yZ19uYW1lIjoiT2hpbyBEZXBhcnRtZW50IG9mIEVkdWNhdGlvbiBhbmQgV29ya2ZvcmNlIiwiaXJuIjoiMDUwNzY1Iiwib3JnX3R5cGVfa2V5IjoiMjciLCJvcmdfdHlwZV9uYW1lIjoiU3RhdGUgQm9hcmQvQWdlbmN5Iiwicm9sZV9jb250ZXh0IjoiMjciLCJjb250YWN0X2NvbnRleHRfaWQiOiIzNDAiLCJjb250YWN0X2NvbnRleHRfdXJsIjoiaHR0cHM6Ly9lZHUtZGV2LW9uZS1mdW5kaW5nLWdhdGV3YXkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL0NvbnRhY3RDb250ZXh0LzM0MCIsIm5iZiI6MTcyNzc4NjA1NSwiZXhwIjoxNzI3ODcyNDU1LCJpYXQiOjE3Mjc3ODYwNTUsImlzcyI6Im9oaW8tZGVwYXJ0bWVudC1vZi1lZHVjYXRpb24iLCJhdWQiOiJlYXNfYXVkaWVuY2UifQ.rX-IV9OdOKB2SeqGE171a0Ks-h6Mzy5VoIp1pSO9sg0`);
	    }
	    getJSON = (url) => {
	        return fetch(url, { headers: this.headers })
	            .then(response => {
	            return response.status === 204 ? [] : response.json();
	        });
	    };
	    postJSON = (url, payload) => {
	        return fetch(url, { method: 'POST', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => {
	            return response.json();
	        });
	    };
	    putJSON = (url, payload) => {
	        return fetch(url, { method: 'PUT', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => response.json());
	    };
	    putData = (url) => {
	        return fetch(url, { method: 'PUT', headers: this.headers })
	            .then(response => response.json());
	    };
	    deleteJSON = (url, payload) => {
	        return fetch(url, { method: 'DELETE', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => response.json());
	    };
	    postData = (url, payload) => {
	        return fetch(url, { method: 'POST', body: payload, headers: this.headers })
	            .then(response => response.json());
	    };
	    getString = (url) => {
	        return fetch(url, { headers: this.headers })
	            .then(response => response.text());
	    };
	    uploadFile = (url, payload) => {
	        this.headers.delete('Content-Type');
	        //this.headers.append('Content-Type', 'multipart/form-data; boundary=----WebKitFormBoundaryaw7OAy2cWKU1Ndnn');
	        return fetch(url, { method: 'POST', body: payload, headers: this.headers })
	            .then(data => data.text());
	    };
	    getFile = (url) => {
	        this.headers.delete('Content-Type');
	        const options = {
	            headers: this.headers,
	            observe: 'body', // return data only
	            responseType: 'blob' // return type for binary data; json is default
	        };
	        return fetch(url, options);
	        //.then(response => response);
	    };
	    get = (url) => {
	        this.headers.delete('Content-Type');
	        return fetch(url, { headers: this.headers });
	        //.then(response => response);
	    };
	    generateUUID() {
	        var d = new Date().getTime(); //Timestamp
	        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16; //random number between 0 and 16
	            if (d > 0) { //Use timestamp until depleted
	                r = (d + r) % 16 | 0;
	                d = Math.floor(d / 16);
	            }
	            else { //Use microseconds since page-load if supported
	                r = (d2 + r) % 16 | 0;
	                d2 = Math.floor(d2 / 16);
	            }
	            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	        });
	    }
	}

	class ContactAdminService extends ServiceBase {
	    getContactsSearchConfiguration(applicationKey, moduleKey) {
	        const url = `${this.easContactBaseUrl}/api/v1/Contact/search/configuration/${applicationKey}/${moduleKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((searchConfig) => {
	                resolve(searchConfig);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getTypeAheadData(baseUrl, endpoint) {
	        const url = baseUrl === 'Eas_Utility_Url' ? `${this.easUtilityUrl}/${endpoint}` : `${sessionStorage.getItem(baseUrl) ?? ''}/${endpoint}`; //modify the end point
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((orgIrns) => {
	                resolve(orgIrns);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getContactNames(applicationKeys, contactTypes, contactGroupKeys, fiscalYears, irns, excludeDeletedRecords = false) {
	        let url = `${this.easContactBaseUrl}/api/v1/contact/applications/contacttypes/contactgroups/fy?applicationKeys=${applicationKeys}&contactTypeKeys=${contactTypes}&contactGroupKeys=${contactGroupKeys}&fiscalYears=${fiscalYears}&excludeDeletedRecords=${excludeDeletedRecords}`;
	        if (irns) {
	            url = `${this.easContactBaseUrl}/api/v1/contact/applications/contacttypes/contactgroups/fy?applicationKeys=${applicationKeys}&contactTypeKeys=${contactTypes}&contactGroupKeys=${contactGroupKeys}&fiscalYears=${fiscalYears}&irns=${irns}&excludeDeletedRecords=${excludeDeletedRecords}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((contactNames) => {
	                resolve(contactNames);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getFundingApplications(fiscalYear) {
	        const url = `https://edu-dev-one-funding-gateway.azurewebsites.net/api/contact/GetAllFundingApplications/${fiscalYear}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((contactNames) => {
	                resolve(contactNames);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getGrantApplications(fiscalYear) {
	        const url = `https://edu-dev-one-funding-gateway.azurewebsites.net/api/contact/GetAllGrantApplications/${fiscalYear}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((contactNames) => {
	                resolve(contactNames);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getContactsSearchResults(searchCriteria, applicationKey, moduleKey) {
	        const url = `${this.easContactBaseUrl}/api/v1/Contact/search/${applicationKey}/${moduleKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.postJSON(url, searchCriteria)
	                .then((response) => {
	                resolve(response);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getExportResults(parameters) {
	        const url = `${this.easUtilityUrl}/api/v1/Contact/export/schedule`;
	        let result = new Promise((resolve, reject) => {
	            this.postJSON(url, parameters)
	                .then((response) => {
	                resolve(response);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getPersonContactData(contactKey) {
	        const url = `${this.easContactBaseUrl}/api/v1/Contact/person/contactId/${contactKey}?manifest=AddressList%2CPhoneList%2CEmailList`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((contactData) => {
	                resolve(contactData);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getExportHistory() {
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(`${this.easUtilityUrl}/api/v1/Contact/export/history`)
	                .then((response) => {
	                resolve(response);
	            }).catch((err) => {
	                resolve(null);
	            });
	        });
	        return result;
	    }
	    getApplications(systemKey) {
	        const url = `${this.easBaseUrl}/api/v1/application/system/systemKey/${systemKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((applications) => {
	                resolve(applications);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    addPersonContactByAdmin(requestData) {
	        const url = `${this.easContactBaseUrl}/api/v1/contact/personsbyadmin`;
	        return new Promise((resolve, reject) => {
	            this.postJSON(url, requestData)
	                .then((response) => {
	                resolve(response);
	            })
	                .catch((err) => {
	                reject(err);
	            });
	        });
	    }
	    fetchDropdownDataForDataElement(apiUrl) {
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(apiUrl)
	                .then((data) => {
	                resolve(data);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getContactTypes(applicationKey, moduleKey) {
	        const url = `${this.easContactBaseUrl}/api/v1/contact/contactTypes/noContext/mod/${moduleKey}/applicationKey/${applicationKey}/parentAssetTemplateKey/14820300?childAssetTemplateKey=14820305`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((contactTypes) => {
	                resolve(contactTypes);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getContactTypeDataElements(moduleKey, applicationKey, contactTypeKey) {
	        const url = `${this.easContactBaseUrl}/api/v1/contact/contactTypeDataElements?moduleKey=${moduleKey}&applicationKey=${applicationKey}&contactTypeKey=${contactTypeKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((dataElements) => {
	                resolve(dataElements);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getRelatedContactsByContactType(moduleKey, irn, contactTypeKey, parentAssetTemplateKey) {
	        irn = irn.toString().padStart(6, '0');
	        const _url = `${this.easUtilityUrl}/api/v1/Contact/assignableContacts/${contactTypeKey}?irn=${irn}&moduleKey=${moduleKey}&contactParentAssetKey=${parentAssetTemplateKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(_url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getAssignableContactsByContactType(moduleKey, applicationKey, contactTypeKey) {
	        const _url = `${this.easUtilityUrl}/api/v1/Contact/assignable/names/mod/${moduleKey}/app/${applicationKey}/contactType/${contactTypeKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(_url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getOrgIrns(applicationKey, moduleKey) {
	        const url = `${this.easContactBaseUrl}/api/v1/Contact/search/configuration/${applicationKey}/${moduleKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((searchConfig) => {
	                resolve(searchConfig);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getFiscalYears(applicationKey) {
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(`${this.easBaseUrl}/api/v1/application/${applicationKey}/Application-periods`)
	                .then((response) => {
	                console.log("FY Response", response);
	                resolve(response);
	            }).catch((err) => {
	                resolve(null);
	            });
	        });
	        return result;
	    }
	    getContactTo(contactTypeKeys, parentAssetTemplateKey, moduleKey) {
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(`${this.easUtilityUrl}/api/v1/Contact/assignableContactsBulk?moduleKey=${moduleKey}&parentAssetTemplateKey=${parentAssetTemplateKey}&contactTypeKeys=${contactTypeKeys}`)
	                .then((response) => {
	                resolve(response);
	            }).catch((err) => {
	                resolve(null);
	            });
	        });
	        return result;
	    }
	    contactBulkCopy(moduleKey, parentAssetTemplateKey, childAssetTemplateKey, fromApplicationKey, fromFiscalYear, fromContactTypeKey, fromPartyKey, toApplicationKey, toFiscalYear, toContactTypeKey, toPartyKey, excludeDeletedRecords = false) {
	        const url = `${this.easContactBaseUrl}/api/v1/contact/bulkCopy`;
	        let contactBulkCopy = {
	            moduleKey: moduleKey,
	            parentAssetTemplateKey: parentAssetTemplateKey,
	            childAssetTemplateKey: childAssetTemplateKey,
	            fromApplicationKey: fromApplicationKey,
	            fromFiscalYear: fromFiscalYear,
	            fromContactTypeKey: fromContactTypeKey,
	            fromPartyKey: fromPartyKey,
	            toApplicationKey: toApplicationKey,
	            toFiscalYear: toFiscalYear,
	            toContactTypeKey: toContactTypeKey,
	            toPartyKey: toPartyKey,
	            excludeDeletedRecords: excludeDeletedRecords
	        };
	        let result = new Promise((resolve, reject) => {
	            this.postJSON(url, contactBulkCopy)
	                .then((response) => {
	                resolve(response);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    contactBulkReplace(moduleKey, parentAssetTemplateKey, childAssetTemplateKey, applicationKey, fiscalYear, contactTypeKey, fromPartyKey, toPartyKey, excludeDeletedRecords = false) {
	        const url = `${this.easContactBaseUrl}/api/v1/contact/bulkReplace`;
	        let contactBulkReplace = {
	            moduleKey: moduleKey,
	            parentAssetTemplateKey: parentAssetTemplateKey,
	            childAssetTemplateKey: childAssetTemplateKey,
	            applicationKey: applicationKey,
	            fiscalYear: fiscalYear,
	            contactTypeKey: contactTypeKey,
	            fromPartyKey: fromPartyKey,
	            toPartyKey: toPartyKey,
	            excludeDeletedRecords: excludeDeletedRecords
	        };
	        return new Promise((resolve, reject) => {
	            this.postJSON(url, contactBulkReplace)
	                .then((response) => {
	                resolve(response);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	    }
	    contactBulkRemove(moduleKey, parentAssetTemplateKey, childAssetTemplateKey, partyKeys, applicationKey, fiscalYear, contactTypeKey) {
	        const url = `${this.easContactBaseUrl}/api/v1/contact/bulkDelete`;
	        let contactBulkRemove = {
	            moduleKey: moduleKey,
	            parentAssetTemplateKey: parentAssetTemplateKey,
	            childAssetTemplateKey: childAssetTemplateKey,
	            applicationKey: applicationKey,
	            fy: fiscalYear,
	            contactTypeKey: contactTypeKey,
	            partyKeys: partyKeys
	        };
	        return new Promise((resolve, reject) => {
	            this.postJSON(url, contactBulkRemove)
	                .then((response) => {
	                resolve(response);
	            })
	                .catch((err) => {
	                reject(err);
	            });
	        });
	    }
	}

	/* src\lib\web-components\select\eas-typeahead-select.svelte generated by Svelte v4.2.19 */

	function add_css$w(target) {
		append_styles(target, "svelte-rhzgp5", ".floating-label.svelte-rhzgp5.svelte-rhzgp5{left:0;right:0;top:20%;position:absolute;font-size:var(--type-ahead-font-size, 0.875rem);color:var(--input-placeholder-color, #434343);padding:0 20px}.error-display.svelte-rhzgp5.svelte-rhzgp5{position:absolute;bottom:-13px;left:15px;height:10%;width:calc(100% - 15%);padding:0 0 0 10px;font-size:var(--type-ahead-font-size, 0.875rem);color:grey;;}.help-display.svelte-rhzgp5.svelte-rhzgp5{position:absolute;bottom:-13px;left:15px;height:10%;width:100%;padding:0 0 0 10px;font-size:var(--type-ahead-font-size, 0.875rem);color:grey;;}.input.svelte-rhzgp5.svelte-rhzgp5{font-size:16px;border-bottom-color:rgba(0, 0, 0, 0.42);width:100%;height:100%;padding:20px 20px 0;font-size:1 rem;text-decoration:inherit;text-transform:inherit;border:none;border-bottom:1px solid;box-sizing:border-box;background:none;appearance:none;border-radius:4p!important;outline:none}.typeahead.svelte-rhzgp5 .svelte-rhzgp5:hover{background:var(--background, #ebebeb)}.typeahead.svelte-rhzgp5.svelte-rhzgp5{margin-bottom:10px;position:relative;height:50px;border-radius:4px 4px 0 0;box-sizing:border-box;background:var(--background, white);overflow:visible;flex:1 1 30% !important;font-family:'Source Sans Pro', sans-serif}li.typeahead-objects.svelte-rhzgp5.svelte-rhzgp5{list-style:none;border:1px solid #d4d4d4;margin:0;padding:10px;cursor:pointer;background-color:#fff;display:block;font-size:var(--type-ahead-font-size, 0.875rem)}li.typeahead-objects.svelte-rhzgp5.svelte-rhzgp5:hover{background:var(--background, #ebebeb)}ul.svelte-rhzgp5.svelte-rhzgp5{max-height:215px;overflow:auto}ul.typeahead-object-list.svelte-rhzgp5.svelte-rhzgp5{padding:0;margin-top:0;z-index:99;background-color:white;font-size:var(--type-ahead-font-size, 0.875rem)}");
	}

	function get_each_context$b(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[22] = list[i];
		return child_ctx;
	}

	// (104:6) {#if isFocused === true}
	function create_if_block_1$g(ctx) {
		let each_1_anchor;
		let each_value = ensure_array_like(/*results*/ ctx[3]);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$b(get_each_context$b(ctx, each_value, i));
		}

		return {
			c() {
				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty();
			},
			m(target, anchor) {
				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*newSearchInput, results*/ 520) {
					each_value = ensure_array_like(/*results*/ ctx[3]);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$b(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$b(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(each_1_anchor);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (105:7) {#each results as oneResult}
	function create_each_block$b(ctx) {
		let li;
		let t0_value = /*oneResult*/ ctx[22].value + "";
		let t0;
		let t1;
		let mounted;
		let dispose;

		function mousedown_handler() {
			return /*mousedown_handler*/ ctx[16](/*oneResult*/ ctx[22]);
		}

		return {
			c() {
				li = element("li");
				t0 = text(t0_value);
				t1 = space();
				attr(li, "class", "typeahead-objects svelte-rhzgp5");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, t0);
				append(li, t1);

				if (!mounted) {
					dispose = listen(li, "mousedown", mousedown_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*results*/ 8 && t0_value !== (t0_value = /*oneResult*/ ctx[22].value + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (116:1) {#if error}
	function create_if_block$j(ctx) {
		let div;

		return {
			c() {
				div = element("div");
				div.textContent = `${errormessage}`;
				attr(div, "class", "error");
			},
			m(target, anchor) {
				insert(target, div, anchor);
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	function create_fragment$x(ctx) {
		let link;
		let t0;
		let div5;
		let div4;
		let div3;
		let div2;
		let div1;
		let div0;
		let input;
		let t1;
		let label;
		let t2;
		let t3;
		let span0;
		let t4;
		let span1;
		let t5;
		let ul;
		let t6;
		let mounted;
		let dispose;
		let if_block0 = /*isFocused*/ ctx[5] === true && create_if_block_1$g(ctx);
		let if_block1 = /*error*/ ctx[2] && create_if_block$j();

		return {
			c() {
				link = element("link");
				t0 = space();
				div5 = element("div");
				div4 = element("div");
				div3 = element("div");
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");
				input = element("input");
				t1 = space();
				label = element("label");
				t2 = text(/*placeholder*/ ctx[0]);
				t3 = space();
				span0 = element("span");
				t4 = space();
				span1 = element("span");
				t5 = space();
				ul = element("ul");
				if (if_block0) if_block0.c();
				t6 = space();
				if (if_block1) if_block1.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(input, "id", /*controlid*/ ctx[1]);
				attr(input, "type", "text");
				attr(input, "name", "searchfield");
				attr(input, "class", "input svelte-rhzgp5");
				attr(label, "class", "floating-label svelte-rhzgp5");
				attr(label, "for", /*controlid*/ ctx[1]);
				attr(span0, "class", "help-display svelte-rhzgp5");
				attr(span1, "class", "error-display svelte-rhzgp5");
				attr(div0, "class", "typeahead svelte-rhzgp5");
				attr(ul, "class", "typeahead-object-list svelte-rhzgp5");
				attr(div1, "class", "chevron border-bottom border-gray-600");
				attr(div2, "class", "inline-text-field-container even-cols flex-row gap-20");
				attr(div3, "class", "container border-medium pb-20");
				attr(div4, "class", "width-full");
				attr(div5, "class", "flex-row pb-5");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div5, anchor);
				append(div5, div4);
				append(div4, div3);
				append(div3, div2);
				append(div2, div1);
				append(div1, div0);
				append(div0, input);
				set_input_value(input, /*searchInput*/ ctx[4]);
				append(div0, t1);
				append(div0, label);
				append(label, t2);
				append(div0, t3);
				append(div0, span0);
				append(div0, t4);
				append(div0, span1);
				append(div1, t5);
				append(div1, ul);
				if (if_block0) if_block0.m(ul, null);
				append(div5, t6);
				if (if_block1) if_block1.m(div5, null);

				if (!mounted) {
					dispose = [
						listen(input, "input", /*input_input_handler*/ ctx[14]),
						listen(input, "input", /*typeahead*/ ctx[10]),
						listen(input, "focus", /*onFocus*/ ctx[6]),
						listen(input, "blur", /*onBlur*/ ctx[7]),
						listen(label, "click", /*click_handler*/ ctx[15])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*controlid*/ 2) {
					attr(input, "id", /*controlid*/ ctx[1]);
				}

				if (dirty & /*searchInput*/ 16 && input.value !== /*searchInput*/ ctx[4]) {
					set_input_value(input, /*searchInput*/ ctx[4]);
				}

				if (dirty & /*placeholder*/ 1) set_data(t2, /*placeholder*/ ctx[0]);

				if (dirty & /*controlid*/ 2) {
					attr(label, "for", /*controlid*/ ctx[1]);
				}

				if (/*isFocused*/ ctx[5] === true) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_1$g(ctx);
						if_block0.c();
						if_block0.m(ul, null);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*error*/ ctx[2]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block$j();
						if_block1.c();
						if_block1.m(div5, null);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div5);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$x($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { data } = $$props;
		let { dataendpoint } = $$props;
		let { placeholder = "" } = $$props;
		let { controlid } = $$props;
		let { valueproperty = "" } = $$props;
		let contactAdminService = new ContactAdminService();
		let results = [];
		let timeoutId;
		let searchInput;
		let isFocused = false;
		let { error = false } = $$props;

		const onFocus = () => {
			$$invalidate(5, isFocused = true);
			typeahead();
		};

		const onBlur = () => $$invalidate(5, isFocused = false);
		const onClick = () => $$invalidate(5, isFocused = true);

		const newSearchInput = oneResult => {
			$$invalidate(4, searchInput = oneResult.value);
			svelteDispatch('itemSelected', { selected: oneResult });
		};

		function debounce(func, delay) {
			return function (...args) {
				clearTimeout(timeoutId);

				timeoutId = setTimeout(
					() => {
						func(...args);
					},
					delay
				);
			};
		}

		function handleInput(event) {
			if (searchInput === null || searchInput === '') {
				svelteDispatch('itemSelected', { selected: searchInput });
				return;
			}

			if (data && data.length > 0) {
				$$invalidate(3, results = [...data]);

				if (searchInput && searchInput !== '') {
					$$invalidate(3, results = results.filter(x => x.value.toLowerCase().includes(searchInput.toLowerCase())));
				}
			} else {
				if (searchInput && searchInput !== '' && searchInput.length > 2) {
					let endpoint = `${dataendpoint}${searchInput}`;

					contactAdminService.getTypeAheadData('Eas_Utility_Url', endpoint).then(result => {
						if (Array.isArray(result)) {
							switch (valueproperty) {
								case 'value':
									$$invalidate(3, results = result);
									break;
								case 'fullName':
								default:
									$$invalidate(3, results = result.map(x => {
										return { ...x, value: x.fullName };
									}));
									break;
							}

							svelteDispatch('items', { items: results });
						}
					}).catch(error => {
						console.error("Error: ", error);
					});
				} else {
					if (searchInput === null || searchInput === '') {
						console.log('Input value to be processed7:', event, data);
						svelteDispatch('itemSelected', { selected: searchInput });
					}
				}
			}
		}

		const typeahead = debounce(handleInput, 500);

		function input_input_handler() {
			searchInput = this.value;
			$$invalidate(4, searchInput);
		}

		const click_handler = () => {
			onClick();
		};

		const mousedown_handler = oneResult => newSearchInput(oneResult);

		$$self.$$set = $$props => {
			if ('data' in $$props) $$invalidate(11, data = $$props.data);
			if ('dataendpoint' in $$props) $$invalidate(12, dataendpoint = $$props.dataendpoint);
			if ('placeholder' in $$props) $$invalidate(0, placeholder = $$props.placeholder);
			if ('controlid' in $$props) $$invalidate(1, controlid = $$props.controlid);
			if ('valueproperty' in $$props) $$invalidate(13, valueproperty = $$props.valueproperty);
			if ('error' in $$props) $$invalidate(2, error = $$props.error);
		};

		return [
			placeholder,
			controlid,
			error,
			results,
			searchInput,
			isFocused,
			onFocus,
			onBlur,
			onClick,
			newSearchInput,
			typeahead,
			data,
			dataendpoint,
			valueproperty,
			input_input_handler,
			click_handler,
			mousedown_handler
		];
	}

	class Eas_typeahead_select extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$x,
				create_fragment$x,
				safe_not_equal,
				{
					data: 11,
					dataendpoint: 12,
					placeholder: 0,
					controlid: 1,
					valueproperty: 13,
					error: 2
				},
				add_css$w
			);
		}

		get data() {
			return this.$$.ctx[11];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}

		get dataendpoint() {
			return this.$$.ctx[12];
		}

		set dataendpoint(dataendpoint) {
			this.$$set({ dataendpoint });
			flush();
		}

		get placeholder() {
			return this.$$.ctx[0];
		}

		set placeholder(placeholder) {
			this.$$set({ placeholder });
			flush();
		}

		get controlid() {
			return this.$$.ctx[1];
		}

		set controlid(controlid) {
			this.$$set({ controlid });
			flush();
		}

		get valueproperty() {
			return this.$$.ctx[13];
		}

		set valueproperty(valueproperty) {
			this.$$set({ valueproperty });
			flush();
		}

		get error() {
			return this.$$.ctx[2];
		}

		set error(error) {
			this.$$set({ error });
			flush();
		}
	}

	customElements.define("eas-typeahead-select", create_custom_element(Eas_typeahead_select, {"data":{},"dataendpoint":{},"placeholder":{},"controlid":{},"valueproperty":{},"error":{"type":"Boolean"}}, [], [], true));

	/* src\lib\web-components\carousel\eas-carousel.component.svelte generated by Svelte v4.2.19 */

	function add_css$v(target) {
		append_styles(target, "svelte-1mb88zp", ".search.svelte-1mb88zp.svelte-1mb88zp{margin-right:10px;font-size:25px;cursor:pointer}.left.svelte-1mb88zp.svelte-1mb88zp,.right.svelte-1mb88zp.svelte-1mb88zp{margin:10px;font-size:25px;display:flex}.fa-solid.svelte-1mb88zp.svelte-1mb88zp:hover{color:#3bb7fa\r\n    }.carousel-content.svelte-1mb88zp.svelte-1mb88zp{font-size:20px;font-weight:bold;margin:10px}.carousel.svelte-1mb88zp.svelte-1mb88zp{display:flex;flex-direction:row;justify-content:center}.carousel.svelte-1mb88zp>.svelte-1mb88zp{flex:1 4 1\r\n    }#slider.svelte-1mb88zp.svelte-1mb88zp{--current-slide:0;position:relative;overflow:hidden}.slides.svelte-1mb88zp.svelte-1mb88zp{display:flex;transition:transform 0.5s;transform:translateX(calc(-100% * var(--current-slide)))}.slide.svelte-1mb88zp.svelte-1mb88zp{flex:0 0 100%;text-align:center}");
	}

	function get_each_context$a(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[15] = list[i];
		child_ctx[17] = i;
		return child_ctx;
	}

	// (50:24) {#each carouseldata as item, index}
	function create_each_block$a(ctx) {
		let div1;
		let div0;
		let t0;
		let t1_value = /*index*/ ctx[17] + 1 + "";
		let t1;
		let t2;
		let t3_value = /*carouseldata*/ ctx[0].length + "";
		let t3;
		let t4;
		let t5_value = /*item*/ ctx[15].requestType + "";
		let t5;
		let t6;
		let t7_value = /*item*/ ctx[15].status + "";
		let t7;
		let t8;

		return {
			c() {
				div1 = element("div");
				div0 = element("div");
				t0 = text("[");
				t1 = text(t1_value);
				t2 = text(" of ");
				t3 = text(t3_value);
				t4 = text("] | Type: ");
				t5 = text(t5_value);
				t6 = text(" | Status:  ");
				t7 = text(t7_value);
				t8 = space();
				attr(div1, "class", "slide svelte-1mb88zp");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, div0);
				append(div0, t0);
				append(div0, t1);
				append(div0, t2);
				append(div0, t3);
				append(div0, t4);
				append(div0, t5);
				append(div0, t6);
				append(div0, t7);
				append(div1, t8);
			},
			p(ctx, dirty) {
				if (dirty & /*carouseldata*/ 1 && t3_value !== (t3_value = /*carouseldata*/ ctx[0].length + "")) set_data(t3, t3_value);
				if (dirty & /*carouseldata*/ 1 && t5_value !== (t5_value = /*item*/ ctx[15].requestType + "")) set_data(t5, t5_value);
				if (dirty & /*carouseldata*/ 1 && t7_value !== (t7_value = /*item*/ ctx[15].status + "")) set_data(t7, t7_value);
			},
			d(detaching) {
				if (detaching) {
					detach(div1);
				}
			}
		};
	}

	function create_fragment$w(ctx) {
		let link;
		let t0;
		let div6;
		let hr0;
		let t1;
		let div5;
		let div0;
		let i0;
		let t2;
		let i1;
		let i1_class_value;
		let t3;
		let div3;
		let div2;
		let div1;
		let t4;
		let div4;
		let i2;
		let i2_class_value;
		let t5;
		let hr1;
		let mounted;
		let dispose;
		let each_value = ensure_array_like(/*carouseldata*/ ctx[0]);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$a(get_each_context$a(ctx, each_value, i));
		}

		return {
			c() {
				link = element("link");
				t0 = space();
				div6 = element("div");
				hr0 = element("hr");
				t1 = space();
				div5 = element("div");
				div0 = element("div");
				i0 = element("i");
				t2 = space();
				i1 = element("i");
				t3 = space();
				div3 = element("div");
				div2 = element("div");
				div1 = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t4 = space();
				div4 = element("div");
				i2 = element("i");
				t5 = space();
				hr1 = element("hr");
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(i0, "class", "fa fa-search search svelte-1mb88zp");
				attr(i1, "class", i1_class_value = "fa " + /*chevronTypeLeft*/ ctx[5] + " fa-circle-chevron-left" + " svelte-1mb88zp");
				attr(div0, "class", "left svelte-1mb88zp");
				attr(div1, "class", "slides svelte-1mb88zp");
				attr(div2, "id", "slider");
				set_style(div2, "--current-slide", /*currentSlide*/ ctx[1]);
				attr(div2, "class", "svelte-1mb88zp");
				set_style(div3, "width", "70vw");
				attr(div3, "class", "carousel-content svelte-1mb88zp");
				attr(i2, "class", i2_class_value = "fa " + /*chevronTypeRight*/ ctx[4] + " fa-circle-chevron-right" + " svelte-1mb88zp");
				attr(div4, "class", "right svelte-1mb88zp");
				attr(div5, "class", "carousel svelte-1mb88zp");
				set_style(div6, "margin-bottom", "25px");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div6, anchor);
				append(div6, hr0);
				append(div6, t1);
				append(div6, div5);
				append(div5, div0);
				append(div0, i0);
				append(div0, t2);
				append(div0, i1);
				append(div5, t3);
				append(div5, div3);
				append(div3, div2);
				append(div2, div1);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div1, null);
					}
				}

				/*div2_binding*/ ctx[11](div2);
				append(div5, t4);
				append(div5, div4);
				append(div4, i2);
				/*div5_binding*/ ctx[13](div5);
				append(div6, t5);
				append(div6, hr1);

				if (!mounted) {
					dispose = [
						listen(i0, "keyup", keyup_handler$4),
						listen(i0, "click", /*click_handler*/ ctx[9]),
						listen(i1, "keyup", keyup_handler_1$5),
						listen(i1, "click", /*click_handler_1*/ ctx[10]),
						listen(i2, "keyup", keyup_handler_2$3),
						listen(i2, "click", /*click_handler_2*/ ctx[12])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*chevronTypeLeft*/ 32 && i1_class_value !== (i1_class_value = "fa " + /*chevronTypeLeft*/ ctx[5] + " fa-circle-chevron-left" + " svelte-1mb88zp")) {
					attr(i1, "class", i1_class_value);
				}

				if (dirty & /*carouseldata*/ 1) {
					each_value = ensure_array_like(/*carouseldata*/ ctx[0]);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$a(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$a(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div1, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}

				if (dirty & /*currentSlide*/ 2) {
					set_style(div2, "--current-slide", /*currentSlide*/ ctx[1]);
				}

				if (dirty & /*chevronTypeRight*/ 16 && i2_class_value !== (i2_class_value = "fa " + /*chevronTypeRight*/ ctx[4] + " fa-circle-chevron-right" + " svelte-1mb88zp")) {
					attr(i2, "class", i2_class_value);
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div6);
				}

				destroy_each(each_blocks, detaching);
				/*div2_binding*/ ctx[11](null);
				/*div5_binding*/ ctx[13](null);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	const keyup_handler$4 = e => {
		
	};

	const keyup_handler_1$5 = e => {
		
	};

	const keyup_handler_2$3 = e => {
		
	};

	function instance$w($$self, $$props, $$invalidate) {
		let chevronTypeLeft;
		let chevronTypeRight;
		let { carouseldata = [] } = $$props;
		const svelteDispatch = createEventDispatcher();
		let currentSlide = 0;
		let carousel;
		let slider;

		onMount(async () => {
			if (carouseldata && carouseldata.length > 1) $$invalidate(1, currentSlide = carouseldata.findIndex(x => x.selected));
		});

		function previous(e) {
			if (currentSlide > 0) $$invalidate(1, currentSlide--, currentSlide); else return;

			svelteDispatch("newRequestInstanceKey", {
				requestInstanceKey: carouseldata[currentSlide].key
			});

			slider.style.setProperty('--current-slide', currentSlide);
		}

		function next(e) {
			if (currentSlide < carouseldata.length - 1) $$invalidate(1, currentSlide++, currentSlide); else return;

			svelteDispatch("newRequestInstanceKey", {
				requestInstanceKey: carouseldata[currentSlide].key
			});

			slider.style.setProperty('--current-slide', currentSlide);
		}

		function navigateToSearch(e) {
			svelteDispatch("navigateToSearch", e);
		}

		const click_handler = e => {
			navigateToSearch(e);
		};

		const click_handler_1 = e => {
			previous();
		};

		function div2_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				slider = $$value;
				$$invalidate(3, slider);
			});
		}

		const click_handler_2 = e => {
			next();
		};

		function div5_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				carousel = $$value;
				$$invalidate(2, carousel);
			});
		}

		$$self.$$set = $$props => {
			if ('carouseldata' in $$props) $$invalidate(0, carouseldata = $$props.carouseldata);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*carouseldata*/ 1) {
				if (carouseldata.length === 1) {
					$$invalidate(5, chevronTypeLeft = 'fa-duotone');
					$$invalidate(4, chevronTypeRight = 'fa-duotone');
					$$invalidate(1, currentSlide = 0);
				}
			}

			if ($$self.$$.dirty & /*currentSlide*/ 2) {
				$$invalidate(5, chevronTypeLeft = currentSlide === 0 ? 'fa-duotone' : 'fa-solid');
			}

			if ($$self.$$.dirty & /*currentSlide, carouseldata*/ 3) {
				$$invalidate(4, chevronTypeRight = currentSlide === carouseldata.length - 1
				? 'fa-duotone'
				: 'fa-solid');
			}
		};

		return [
			carouseldata,
			currentSlide,
			carousel,
			slider,
			chevronTypeRight,
			chevronTypeLeft,
			previous,
			next,
			navigateToSearch,
			click_handler,
			click_handler_1,
			div2_binding,
			click_handler_2,
			div5_binding
		];
	}

	class Eas_carousel_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$w, create_fragment$w, safe_not_equal, { carouseldata: 0 }, add_css$v);
		}

		get carouseldata() {
			return this.$$.ctx[0];
		}

		set carouseldata(carouseldata) {
			this.$$set({ carouseldata });
			flush();
		}
	}

	customElements.define("eas-carousel", create_custom_element(Eas_carousel_component, {"carouseldata":{}}, [], [], true));

	/* src\lib\web-components\date\eas-date.component.svelte generated by Svelte v4.2.19 */

	function add_css$u(target) {
		append_styles(target, "svelte-1368gxp", ".error.svelte-1368gxp.svelte-1368gxp{border-style:solid;border-color:red}.error-text.svelte-1368gxp.svelte-1368gxp{color:red}.ds-input-field.svelte-1368gxp.svelte-1368gxp{display:inline-flex;position:relative;width:100%;font-size:16px;color:#000;border-radius:4px 4px 0 0;padding:20px 20px 0;margin:0;border:0;outline:none;cursor:pointer;box-sizing:border-box;overflow:hidden;background:#fff;transition:all 0.2s ease-in-out}.rounded-4.svelte-1368gxp.svelte-1368gxp{border-radius:4px !important}input.svelte-1368gxp.svelte-1368gxp{outline:none;-webkit-writing-mode:horizontal-tb !important;text-rendering:auto;color:-internal-light-dark-color(black, black);letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0px;text-shadow:none;display:inline-block;text-align:start;-webkit-appearance:menulist;box-sizing:border-box;align-items:center;white-space:pre;-webkit-rtl-ordering:logical;background-color:-internal-light-dark-color(black, black) !important;cursor:default;margin:0;font:400 13.3333px Arial;border-radius:0;border-width:1px;border-style:solid;border-color:#a9a9a9;border-image:initial;appearance:none}input.svelte-1368gxp.svelte-1368gxp:not(:-internal-list-box){overflow:visible !important}input[type=date].svelte-1368gxp.svelte-1368gxp:required:invalid::-webkit-datetime-edit{color:transparent}input[type=date].svelte-1368gxp.svelte-1368gxp:focus::-webkit-datetime-edit{color:black !important}.hover-gray-300.svelte-1368gxp.svelte-1368gxp:hover{background:#e8e8e8 !important}.input-container.svelte-1368gxp.svelte-1368gxp{position:relative}.border-gray-600.svelte-1368gxp.svelte-1368gxp{border-color:#8c8c8c !important}.border-bottom.svelte-1368gxp.svelte-1368gxp{border-bottom:1px solid #d9d9d9}.inline-text-field-container.svelte-1368gxp.svelte-1368gxp{display:flex;flex-direction:column}.even-cols.svelte-1368gxp.svelte-1368gxp{display:flex}.flex-row.svelte-1368gxp.svelte-1368gxp{flex-direction:row !important}.gap-20.svelte-1368gxp.svelte-1368gxp{gap:20px}.container.svelte-1368gxp.svelte-1368gxp{transition:all 0.2s ease-in-out;position:relative;width:100%}.border-medium.svelte-1368gxp.svelte-1368gxp{border-width:2px !important}.pb-20.svelte-1368gxp.svelte-1368gxp{padding-bottom:20px !important}.width-full.svelte-1368gxp.svelte-1368gxp{width:100% !important;max-width:100% !important}.pb-5.svelte-1368gxp.svelte-1368gxp{padding-bottom:5px !important}.ds-floating-label.svelte-1368gxp.svelte-1368gxp{text-decoration:inherit;text-transform:inherit;position:absolute;transform-origin:left top;transition:all 0.15s cubic-bezier(0.4, 0, 0.2, 1);line-height:1.15rem;text-align:left;font-size:1rem;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;padding-right:16px}input.svelte-1368gxp:invalid~.ds-floating-label.svelte-1368gxp{left:0;right:auto;top:50%;width:100%;padding:0 20px;font-size:1em;transform:translateY(-50%);pointer-events:none;color:#434343}input.svelte-1368gxp:invalid~.ds-floating-label.svelte-1368gxp{left:0;right:auto;top:50%;width:100%;padding:0 20px;font-size:1em;transform:translateY(-50%);pointer-events:none;color:#434343}input.svelte-1368gxp:focus~.ds-floating-label.svelte-1368gxp,input.svelte-1368gxp:valid~.ds-floating-label.svelte-1368gxp{left:0;right:auto;top:20%;width:100%;padding:0 20px;font-size:0.875rem;transform:translateY(-30%);pointer-events:none;color:#434343}input:focus.ds-input-field.svelte-1368gxp.svelte-1368gxp,input:focus.ds-input-field.svelte-1368gxp.svelte-1368gxp:hover{background:#dfdfdf}input.svelte-1368gxp.svelte-1368gxp::-ms-expand{display:none}.input-container.svelte-1368gxp.svelte-1368gxp{position:relative}");
	}

	// (39:3) {#if error}
	function create_if_block$i(ctx) {
		let div;
		let t;

		return {
			c() {
				div = element("div");
				t = text(/*errormessage*/ ctx[8]);
				attr(div, "class", "error-text svelte-1368gxp");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t);
			},
			p(ctx, dirty) {
				if (dirty & /*errormessage*/ 256) set_data(t, /*errormessage*/ ctx[8]);
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	function create_fragment$v(ctx) {
		let div4;
		let div3;
		let div2;
		let div1;
		let div0;
		let input;
		let t0;
		let label;
		let t1;
		let t2_value = (/*required*/ ctx[6] ? "*" : "") + "";
		let t2;
		let div1_class_value;
		let t3;
		let mounted;
		let dispose;
		let if_block = /*error*/ ctx[7] && create_if_block$i(ctx);

		return {
			c() {
				div4 = element("div");
				div3 = element("div");
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");
				input = element("input");
				t0 = space();
				label = element("label");
				t1 = text(/*placeholder*/ ctx[3]);
				t2 = text(t2_value);
				t3 = space();
				if (if_block) if_block.c();
				input.required = true;
				attr(input, "class", "ds-input-field rounded-4 hover-gray-300 svelte-1368gxp");
				attr(input, "type", "date");
				attr(input, "min", /*datemin*/ ctx[1]);
				attr(input, "max", /*datemax*/ ctx[2]);
				set_style(input, "height", /*height*/ ctx[4] ? /*height*/ ctx[4] + 'px' : '50px');
				set_style(input, "width", /*width*/ ctx[5] ? /*width*/ ctx[5] + 'px' : '500px');
				attr(label, "class", "ds-floating-label svelte-1368gxp");
				attr(div0, "class", "input-container border-bottom border-gray-600 svelte-1368gxp");
				attr(div1, "class", div1_class_value = "inline-text-field-container even-cols flex-row gap-20 " + (/*error*/ ctx[7] ? 'error' : '') + " svelte-1368gxp");
				attr(div2, "class", "container border-medium pb-20 svelte-1368gxp");
				attr(div3, "class", "width-full svelte-1368gxp");
				attr(div4, "class", "flex-row pb-5 svelte-1368gxp");
			},
			m(target, anchor) {
				insert(target, div4, anchor);
				append(div4, div3);
				append(div3, div2);
				append(div2, div1);
				append(div1, div0);
				append(div0, input);
				set_input_value(input, /*date*/ ctx[0]);
				append(div0, t0);
				append(div0, label);
				append(label, t1);
				append(label, t2);
				append(div2, t3);
				if (if_block) if_block.m(div2, null);

				if (!mounted) {
					dispose = [
						listen(input, "input", /*input_input_handler*/ ctx[10]),
						listen(input, "change", /*onDateChanged*/ ctx[9])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*datemin*/ 2) {
					attr(input, "min", /*datemin*/ ctx[1]);
				}

				if (dirty & /*datemax*/ 4) {
					attr(input, "max", /*datemax*/ ctx[2]);
				}

				if (dirty & /*height*/ 16) {
					set_style(input, "height", /*height*/ ctx[4] ? /*height*/ ctx[4] + 'px' : '50px');
				}

				if (dirty & /*width*/ 32) {
					set_style(input, "width", /*width*/ ctx[5] ? /*width*/ ctx[5] + 'px' : '500px');
				}

				if (dirty & /*date*/ 1) {
					set_input_value(input, /*date*/ ctx[0]);
				}

				if (dirty & /*placeholder*/ 8) set_data(t1, /*placeholder*/ ctx[3]);
				if (dirty & /*required*/ 64 && t2_value !== (t2_value = (/*required*/ ctx[6] ? "*" : "") + "")) set_data(t2, t2_value);

				if (dirty & /*error*/ 128 && div1_class_value !== (div1_class_value = "inline-text-field-container even-cols flex-row gap-20 " + (/*error*/ ctx[7] ? 'error' : '') + " svelte-1368gxp")) {
					attr(div1, "class", div1_class_value);
				}

				if (/*error*/ ctx[7]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$i(ctx);
						if_block.c();
						if_block.m(div2, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(div4);
				}

				if (if_block) if_block.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$v($$self, $$props, $$invalidate) {
		let { date = "" } = $$props;
		let { datemin = "" } = $$props;
		let { datemax = "" } = $$props;
		let { placeholder } = $$props;
		let { height } = $$props;
		let { width } = $$props;
		let { required } = $$props;
		let { error = false } = $$props;
		let { errormessage = '' } = $$props;
		const svelteDispatch = createEventDispatcher();

		function onDateChanged(e) {
			let detail = { date: e.target.value, datemin, datemax };
			let eventData = { event: e, detail };
			console.log("onDateChanged eventData: ", eventData);
			e.stopPropagation();
			svelteDispatch("datechanged", detail);
		}

		function input_input_handler() {
			date = this.value;
			$$invalidate(0, date);
		}

		$$self.$$set = $$props => {
			if ('date' in $$props) $$invalidate(0, date = $$props.date);
			if ('datemin' in $$props) $$invalidate(1, datemin = $$props.datemin);
			if ('datemax' in $$props) $$invalidate(2, datemax = $$props.datemax);
			if ('placeholder' in $$props) $$invalidate(3, placeholder = $$props.placeholder);
			if ('height' in $$props) $$invalidate(4, height = $$props.height);
			if ('width' in $$props) $$invalidate(5, width = $$props.width);
			if ('required' in $$props) $$invalidate(6, required = $$props.required);
			if ('error' in $$props) $$invalidate(7, error = $$props.error);
			if ('errormessage' in $$props) $$invalidate(8, errormessage = $$props.errormessage);
		};

		return [
			date,
			datemin,
			datemax,
			placeholder,
			height,
			width,
			required,
			error,
			errormessage,
			onDateChanged,
			input_input_handler
		];
	}

	class Eas_date_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$v,
				create_fragment$v,
				safe_not_equal,
				{
					date: 0,
					datemin: 1,
					datemax: 2,
					placeholder: 3,
					height: 4,
					width: 5,
					required: 6,
					error: 7,
					errormessage: 8
				},
				add_css$u
			);
		}

		get date() {
			return this.$$.ctx[0];
		}

		set date(date) {
			this.$$set({ date });
			flush();
		}

		get datemin() {
			return this.$$.ctx[1];
		}

		set datemin(datemin) {
			this.$$set({ datemin });
			flush();
		}

		get datemax() {
			return this.$$.ctx[2];
		}

		set datemax(datemax) {
			this.$$set({ datemax });
			flush();
		}

		get placeholder() {
			return this.$$.ctx[3];
		}

		set placeholder(placeholder) {
			this.$$set({ placeholder });
			flush();
		}

		get height() {
			return this.$$.ctx[4];
		}

		set height(height) {
			this.$$set({ height });
			flush();
		}

		get width() {
			return this.$$.ctx[5];
		}

		set width(width) {
			this.$$set({ width });
			flush();
		}

		get required() {
			return this.$$.ctx[6];
		}

		set required(required) {
			this.$$set({ required });
			flush();
		}

		get error() {
			return this.$$.ctx[7];
		}

		set error(error) {
			this.$$set({ error });
			flush();
		}

		get errormessage() {
			return this.$$.ctx[8];
		}

		set errormessage(errormessage) {
			this.$$set({ errormessage });
			flush();
		}
	}

	customElements.define("eas-date", create_custom_element(Eas_date_component, {"date":{},"datemin":{},"datemax":{},"placeholder":{},"height":{},"width":{},"required":{},"error":{"type":"Boolean"},"errormessage":{}}, [], [], true));

	/* src\lib\web-components\skeleton\eas-rectangle-skeleton.component.svelte generated by Svelte v4.2.19 */

	function add_css$t(target) {
		append_styles(target, "svelte-1o72iae", ".skeleton.svelte-1o72iae{animation:svelte-1o72iae-skeleton-loading 1s linear infinite alternate}@keyframes svelte-1o72iae-skeleton-loading{0%{background-color:hsl(200, 20%, 80%)}100%{background-color:hsl(200, 20%, 95%)}}");
	}

	function create_fragment$u(ctx) {
		let div;

		return {
			c() {
				div = element("div");
				attr(div, "class", "skeleton svelte-1o72iae");
				set_style(div, "height", /*height*/ ctx[0] + "px");
				set_style(div, "width", /*width*/ ctx[1] + "px");
			},
			m(target, anchor) {
				insert(target, div, anchor);
			},
			p(ctx, [dirty]) {
				if (dirty & /*height*/ 1) {
					set_style(div, "height", /*height*/ ctx[0] + "px");
				}

				if (dirty & /*width*/ 2) {
					set_style(div, "width", /*width*/ ctx[1] + "px");
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	function instance$u($$self, $$props, $$invalidate) {
		let { height = "0" } = $$props;
		let { width = "0" } = $$props;

		$$self.$$set = $$props => {
			if ('height' in $$props) $$invalidate(0, height = $$props.height);
			if ('width' in $$props) $$invalidate(1, width = $$props.width);
		};

		return [height, width];
	}

	class Eas_rectangle_skeleton_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$u, create_fragment$u, safe_not_equal, { height: 0, width: 1 }, add_css$t);
		}

		get height() {
			return this.$$.ctx[0];
		}

		set height(height) {
			this.$$set({ height });
			flush();
		}

		get width() {
			return this.$$.ctx[1];
		}

		set width(width) {
			this.$$set({ width });
			flush();
		}
	}

	customElements.define("eas-rectangle-skeleton", create_custom_element(Eas_rectangle_skeleton_component, {"height":{},"width":{}}, [], [], true));

	/* src\lib\web-components\tab-control\eas-tab-control.component.svelte generated by Svelte v4.2.19 */

	function add_css$s(target) {
		append_styles(target, "svelte-14rzj12", ".tab.svelte-14rzj12{padding:15px 25px 15px 25px;border:none;font-size:20px;font-weight:bold;background-color:rgba(0, 0, 0, 0.1);margin-right:10px;cursor:pointer}.selected.svelte-14rzj12{border-top:5px solid red;background-color:rgba(0, 0, 0, 0)}.tab-content.svelte-14rzj12{padding:10px 0 0 15px;width:75vw}");
	}

	function get_each_context_1$4(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[14] = list[i];
		return child_ctx;
	}

	function get_each_context_2$3(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[14] = list[i];
		return child_ctx;
	}

	function get_each_context$9(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[11] = list[i];
		child_ctx[13] = i;
		return child_ctx;
	}

	// (53:8) {:else}
	function create_else_block$8(ctx) {
		let div1;
		let div0;
		let t;
		let each_value_2 = ensure_array_like(/*data*/ ctx[0]);
		let each_blocks_1 = [];

		for (let i = 0; i < each_value_2.length; i += 1) {
			each_blocks_1[i] = create_each_block_2$3(get_each_context_2$3(ctx, each_value_2, i));
		}

		let each_value_1 = ensure_array_like(/*data*/ ctx[0]);
		let each_blocks = [];

		for (let i = 0; i < each_value_1.length; i += 1) {
			each_blocks[i] = create_each_block_1$4(get_each_context_1$4(ctx, each_value_1, i));
		}

		return {
			c() {
				div1 = element("div");
				div0 = element("div");

				for (let i = 0; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].c();
				}

				t = space();

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				attr(div0, "class", "tab-list");
				attr(div1, "class", "tabs");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, div0);

				for (let i = 0; i < each_blocks_1.length; i += 1) {
					if (each_blocks_1[i]) {
						each_blocks_1[i].m(div0, null);
					}
				}

				append(div1, t);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div1, null);
					}
				}
			},
			p(ctx, dirty) {
				if (dirty & /*data, onSelect*/ 9) {
					each_value_2 = ensure_array_like(/*data*/ ctx[0]);
					let i;

					for (i = 0; i < each_value_2.length; i += 1) {
						const child_ctx = get_each_context_2$3(ctx, each_value_2, i);

						if (each_blocks_1[i]) {
							each_blocks_1[i].p(child_ctx, dirty);
						} else {
							each_blocks_1[i] = create_each_block_2$3(child_ctx);
							each_blocks_1[i].c();
							each_blocks_1[i].m(div0, null);
						}
					}

					for (; i < each_blocks_1.length; i += 1) {
						each_blocks_1[i].d(1);
					}

					each_blocks_1.length = each_value_2.length;
				}

				if (dirty & /*data*/ 1) {
					each_value_1 = ensure_array_like(/*data*/ ctx[0]);
					let i;

					for (i = 0; i < each_value_1.length; i += 1) {
						const child_ctx = get_each_context_1$4(ctx, each_value_1, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_1$4(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div1, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_1.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div1);
				}

				destroy_each(each_blocks_1, detaching);
				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (40:8) {#if showskeleton == true}
	function create_if_block_1$f(ctx) {
		let div2;
		let div0;
		let each_blocks = [];
		let each_1_lookup = new Map();
		let t;
		let div1;
		let each_value = ensure_array_like(Array(4));
		const get_key = ctx => /*index*/ ctx[13];

		for (let i = 0; i < each_value.length; i += 1) {
			let child_ctx = get_each_context$9(ctx, each_value, i);
			let key = get_key(child_ctx);
			each_1_lookup.set(key, each_blocks[i] = create_each_block$9(key));
		}

		return {
			c() {
				div2 = element("div");
				div0 = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t = space();
				div1 = element("div");
				div1.innerHTML = `<eas-rectangle-skeleton height="500" width="1000"></eas-rectangle-skeleton>`;
				set_style(div0, "display", "flex");
				set_style(div0, "flex-direction", "row");
				set_style(div0, "margin-top", "5px");
				set_style(div1, "margin-top", "15px");
				set_style(div2, "display", "flex");
				set_style(div2, "flex-direction", "column");
			},
			m(target, anchor) {
				insert(target, div2, anchor);
				append(div2, div0);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div0, null);
					}
				}

				append(div2, t);
				append(div2, div1);
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(div2);
				}

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].d();
				}
			}
		};
	}

	// (37:4) {#if showError == true}
	function create_if_block$h(ctx) {
		let eas_validation_message;
		let mounted;
		let dispose;

		return {
			c() {
				eas_validation_message = element("eas-validation-message");
				set_custom_element_data(eas_validation_message, "message", errorMessage$1);
				set_custom_element_data(eas_validation_message, "type", "error");
				set_custom_element_data(eas_validation_message, "showError", /*showError*/ ctx[2]);
				set_custom_element_data(eas_validation_message, "width", "800");
			},
			m(target, anchor) {
				insert(target, eas_validation_message, anchor);

				if (!mounted) {
					dispose = listen(eas_validation_message, "errorclose", /*errorclose_handler*/ ctx[6]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*showError*/ 4) {
					set_custom_element_data(eas_validation_message, "showError", /*showError*/ ctx[2]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(eas_validation_message);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (56:20) {#each data as item}
	function create_each_block_2$3(ctx) {
		let button;
		let t0_value = /*item*/ ctx[14].tab + "";
		let t0;
		let t1;
		let button_class_value;
		let mounted;
		let dispose;

		function click_handler(...args) {
			return /*click_handler*/ ctx[7](/*item*/ ctx[14], ...args);
		}

		return {
			c() {
				button = element("button");
				t0 = text(t0_value);
				t1 = space();
				attr(button, "class", button_class_value = "" + (null_to_empty(/*item*/ ctx[14].current ? 'selected tab' : 'tab') + " svelte-14rzj12"));
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, t0);
				append(button, t1);

				if (!mounted) {
					dispose = listen(button, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*data*/ 1 && t0_value !== (t0_value = /*item*/ ctx[14].tab + "")) set_data(t0, t0_value);

				if (dirty & /*data*/ 1 && button_class_value !== (button_class_value = "" + (null_to_empty(/*item*/ ctx[14].current ? 'selected tab' : 'tab') + " svelte-14rzj12"))) {
					attr(button, "class", button_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (63:20) {#if item.current}
	function create_if_block_2$b(ctx) {
		let div;
		let raw_value = /*item*/ ctx[14].tabContent + "";

		return {
			c() {
				div = element("div");
				attr(div, "class", "tab-content svelte-14rzj12");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				div.innerHTML = raw_value;
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 1 && raw_value !== (raw_value = /*item*/ ctx[14].tabContent + "")) div.innerHTML = raw_value;		},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (62:16) {#each data as item}
	function create_each_block_1$4(ctx) {
		let if_block_anchor;
		let if_block = /*item*/ ctx[14].current && create_if_block_2$b(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*item*/ ctx[14].current) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_2$b(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(if_block_anchor);
				}

				if (if_block) if_block.d(detaching);
			}
		};
	}

	// (43:20) {#each Array(4) as _, index (index)}
	function create_each_block$9(key_1, ctx) {
		let div;

		return {
			key: key_1,
			first: null,
			c() {
				div = element("div");
				div.innerHTML = `<eas-rectangle-skeleton height="50" width="150"></eas-rectangle-skeleton> `;
				set_style(div, "margin-right", "5px");
				this.first = div;
			},
			m(target, anchor) {
				insert(target, div, anchor);
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	function create_fragment$t(ctx) {
		let div;

		function select_block_type(ctx, dirty) {
			if (/*showError*/ ctx[2] == true) return create_if_block$h;
			if (/*showskeleton*/ ctx[1] == true) return create_if_block_1$f;
			return create_else_block$8;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				div = element("div");
				if_block.c();
				set_style(div, "margin-top", "5px");
				set_style(div, "display", "flex");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if_block.m(div, null);
			},
			p(ctx, [dirty]) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(div, null);
					}
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(div);
				}

				if_block.d();
			}
		};
	}

	let errorMessage$1 = '';

	function instance$t($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { data = [] } = $$props;
		let { showskeleton } = $$props;
		let { tabindex = 1 } = $$props;
		let currentTab;
		let showError = false;

		function onSelect(e, item) {
			setCurrentTab(e, item.tab);
		}

		function setCurrentTab(e, tabName) {
			if (tabName === currentTab) return;

			data.forEach(x => {
				if (x.tab === tabName) x.current = true; else x.current = false;
			});

			$$invalidate(0, data = [...data]);
			let detail = { tabName };
			currentTab = tabName;
			svelteDispatch("navigate", detail);
		}

		function onErrorClose(e) {
			$$invalidate(2, showError = false);
		}

		const errorclose_handler = e => onErrorClose();
		const click_handler = (item, e) => onSelect(e, item);

		$$self.$$set = $$props => {
			if ('data' in $$props) $$invalidate(0, data = $$props.data);
			if ('showskeleton' in $$props) $$invalidate(1, showskeleton = $$props.showskeleton);
			if ('tabindex' in $$props) $$invalidate(5, tabindex = $$props.tabindex);
		};

		console.log('----------EAS Svelte Tab control---------');

		return [
			data,
			showskeleton,
			showError,
			onSelect,
			onErrorClose,
			tabindex,
			errorclose_handler,
			click_handler
		];
	}

	class Eas_tab_control_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$t, create_fragment$t, safe_not_equal, { data: 0, showskeleton: 1, tabindex: 5 }, add_css$s);
		}

		get data() {
			return this.$$.ctx[0];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}

		get showskeleton() {
			return this.$$.ctx[1];
		}

		set showskeleton(showskeleton) {
			this.$$set({ showskeleton });
			flush();
		}

		get tabindex() {
			return this.$$.ctx[5];
		}

		set tabindex(tabindex) {
			this.$$set({ tabindex });
			flush();
		}
	}

	customElements.define("eas-tab-control", create_custom_element(Eas_tab_control_component, {"data":{},"showskeleton":{},"tabindex":{}}, [], [], true));

	/* src\lib\web-components\table\eas-table-control.component.svelte generated by Svelte v4.2.19 */

	function add_css$r(target) {
		append_styles(target, "svelte-1upvl27", "table.svelte-1upvl27{border-collapse:collapse;width:100%}th.svelte-1upvl27,td.svelte-1upvl27{text-align:left;padding:8px;word-wrap:break-word}.filter-input.svelte-1upvl27{width:90%;padding:5px}tr.svelte-1upvl27:nth-child(odd){background-color:rgba(0, 0, 0, 0.1)}.header.svelte-1upvl27{display:flex;flex-direction:row;justify-content:space-between}.header-icons.svelte-1upvl27{display:flex;flex-direction:row;justify-content:space-between}.header-title.svelte-1upvl27{font-size:15px;width:90%\r\n    }.sort.svelte-1upvl27,.filter.svelte-1upvl27,.next.svelte-1upvl27,.previous.svelte-1upvl27{padding:0 2px;cursor:pointer;align-self:center}.footer-content.svelte-1upvl27{display:flex;flex-direction:row;justify-content:end;margin:5px 0}.page-size.svelte-1upvl27,.current-page.svelte-1upvl27{font-size:20px;font-weight:bold;margin-right:10px}.next.svelte-1upvl27{margin-left:10px;margin-right:20px}.previous.svelte-1upvl27{margin-right:10px;margin-left:10px}.pages.svelte-1upvl27{display:flex;flex-direction:row;align-items:center}.current-page.svelte-1upvl27{border-bottom:1px blue solid}.page.svelte-1upvl27{cursor:pointer}.comment-box.svelte-1upvl27{border-width:2px;border-style:groove;border-color:rgb(192, 192, 192);border-image:initial;background-color:white}.closeIcon.svelte-1upvl27{float:inline-end;padding-right:10px;padding-top:5px}.commentText.svelte-1upvl27{padding:15px}");
	}

	function get_each_context$8(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[53] = list[i];
		child_ctx[55] = i;
		return child_ctx;
	}

	function get_each_context_1$3(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[56] = list[i];
		return child_ctx;
	}

	function get_each_context_2$2(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[59] = list[i];
		return child_ctx;
	}

	function get_each_context_3(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[59] = list[i];
		return child_ctx;
	}

	function get_each_context_4(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[53] = list[i];
		child_ctx[64] = list;
		child_ctx[65] = i;
		return child_ctx;
	}

	// (329:62) 
	function create_if_block_2$a(ctx) {
		let div;
		let table;
		let t0;
		let t1;
		let if_block0 = /*displayheader*/ ctx[4] && create_if_block_14(ctx);
		let if_block1 = /*displayRows*/ ctx[10] && /*displayRows*/ ctx[10].length > 0 && create_if_block_5$3(ctx);
		let if_block2 = /*data*/ ctx[0]?.rows?.length > /*pagesize*/ ctx[3] && /*displayfooter*/ ctx[5] && create_if_block_3$6(ctx);

		return {
			c() {
				div = element("div");
				table = element("table");
				if (if_block0) if_block0.c();
				t0 = space();
				if (if_block1) if_block1.c();
				t1 = space();
				if (if_block2) if_block2.c();
				attr(table, "id", /*id*/ ctx[2]);
				attr(table, "class", "svelte-1upvl27");
				set_style(div, "padding", "20px");
				set_style(div, "background", "white");
				set_style(div, "width", /*width*/ ctx[1]);
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, table);
				if (if_block0) if_block0.m(table, null);
				append(table, t0);
				if (if_block1) if_block1.m(table, null);
				append(table, t1);
				if (if_block2) if_block2.m(table, null);
			},
			p(ctx, dirty) {
				if (/*displayheader*/ ctx[4]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_14(ctx);
						if_block0.c();
						if_block0.m(table, t0);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*displayRows*/ ctx[10] && /*displayRows*/ ctx[10].length > 0) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_5$3(ctx);
						if_block1.c();
						if_block1.m(table, t1);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*data*/ ctx[0]?.rows?.length > /*pagesize*/ ctx[3] && /*displayfooter*/ ctx[5]) {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_3$6(ctx);
						if_block2.c();
						if_block2.m(table, null);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}

				if (dirty[0] & /*id*/ 4) {
					attr(table, "id", /*id*/ ctx[2]);
				}

				if (dirty[0] & /*width*/ 2) {
					set_style(div, "width", /*width*/ ctx[1]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				if (if_block2) if_block2.d();
			}
		};
	}

	// (327:22) 
	function create_if_block_1$e(ctx) {
		let eas_validation_message;
		let mounted;
		let dispose;

		return {
			c() {
				eas_validation_message = element("eas-validation-message");
				set_custom_element_data(eas_validation_message, "message", /*emptymessage*/ ctx[7]);
				set_custom_element_data(eas_validation_message, "type", "info");
				set_custom_element_data(eas_validation_message, "showInfo", /*isempty*/ ctx[6]);
				set_custom_element_data(eas_validation_message, "width", "800");
			},
			m(target, anchor) {
				insert(target, eas_validation_message, anchor);

				if (!mounted) {
					dispose = listen(eas_validation_message, "infoclose", /*infoclose_handler*/ ctx[28]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*emptymessage*/ 128) {
					set_custom_element_data(eas_validation_message, "message", /*emptymessage*/ ctx[7]);
				}

				if (dirty[0] & /*isempty*/ 64) {
					set_custom_element_data(eas_validation_message, "showInfo", /*isempty*/ ctx[6]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(eas_validation_message);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (325:4) {#if showError}
	function create_if_block$g(ctx) {
		let eas_validation_message;
		let mounted;
		let dispose;

		return {
			c() {
				eas_validation_message = element("eas-validation-message");
				set_custom_element_data(eas_validation_message, "message", errorMessage);
				set_custom_element_data(eas_validation_message, "type", "error");
				set_custom_element_data(eas_validation_message, "showError", /*showError*/ ctx[9]);
				set_custom_element_data(eas_validation_message, "width", "800");
			},
			m(target, anchor) {
				insert(target, eas_validation_message, anchor);

				if (!mounted) {
					dispose = listen(eas_validation_message, "errorclose", /*errorclose_handler*/ ctx[27]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*showError*/ 512) {
					set_custom_element_data(eas_validation_message, "showError", /*showError*/ ctx[9]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(eas_validation_message);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (332:16) {#if displayheader}
	function create_if_block_14(ctx) {
		let tr;
		let each_value_4 = ensure_array_like(/*data*/ ctx[0].header);
		let each_blocks = [];

		for (let i = 0; i < each_value_4.length; i += 1) {
			each_blocks[i] = create_each_block_4(get_each_context_4(ctx, each_value_4, i));
		}

		return {
			c() {
				tr = element("tr");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				attr(tr, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, tr, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(tr, null);
					}
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*data, filter, sort, applyFilter*/ 1835009) {
					each_value_4 = ensure_array_like(/*data*/ ctx[0].header);
					let i;

					for (i = 0; i < each_value_4.length; i += 1) {
						const child_ctx = get_each_context_4(ctx, each_value_4, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_4(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(tr, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_4.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(tr);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (341:40) {:else}
	function create_else_block$7(ctx) {
		let input;
		let mounted;
		let dispose;

		function keyup_handler() {
			return /*keyup_handler*/ ctx[29](/*item*/ ctx[53]);
		}

		function input_input_handler() {
			/*input_input_handler*/ ctx[30].call(input, /*each_value_4*/ ctx[64], /*item_index*/ ctx[65]);
		}

		return {
			c() {
				input = element("input");
				attr(input, "class", "filter-input svelte-1upvl27");
				attr(input, "type", "text");
				attr(input, "placeholder", "Enter filter data");
			},
			m(target, anchor) {
				insert(target, input, anchor);
				set_input_value(input, /*item*/ ctx[53].filterValue);

				if (!mounted) {
					dispose = [
						listen(input, "keyup", keyup_handler),
						listen(input, "input", input_input_handler)
					];

					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;

				if (dirty[0] & /*data*/ 1 && input.value !== /*item*/ ctx[53].filterValue) {
					set_input_value(input, /*item*/ ctx[53].filterValue);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(input);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (339:40) {#if !item.filterOn}
	function create_if_block_17(ctx) {
		let t_value = /*item*/ ctx[53].name + "";
		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*data*/ 1 && t_value !== (t_value = /*item*/ ctx[53].name + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(t);
				}
			}
		};
	}

	// (347:44) {#if item.sortDirection === 'asc'}
	function create_if_block_16(ctx) {
		let i;
		let mounted;
		let dispose;

		function click_handler() {
			return /*click_handler*/ ctx[31](/*item*/ ctx[53]);
		}

		return {
			c() {
				i = element("i");
				attr(i, "class", "fa fa-arrow-circle-down");
			},
			m(target, anchor) {
				insert(target, i, anchor);

				if (!mounted) {
					dispose = [listen(i, "keyup", keyup_handler_1$4), listen(i, "click", click_handler)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
			},
			d(detaching) {
				if (detaching) {
					detach(i);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (350:44) {#if item.sortDirection === 'desc'}
	function create_if_block_15(ctx) {
		let i;
		let mounted;
		let dispose;

		function click_handler_1() {
			return /*click_handler_1*/ ctx[32](/*item*/ ctx[53]);
		}

		return {
			c() {
				i = element("i");
				attr(i, "class", "fa fa-arrow-circle-up");
			},
			m(target, anchor) {
				insert(target, i, anchor);

				if (!mounted) {
					dispose = [listen(i, "keyup", keyup_handler_2$2), listen(i, "click", click_handler_1)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
			},
			d(detaching) {
				if (detaching) {
					detach(i);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (334:24) {#each data.header as item}
	function create_each_block_4(ctx) {
		let th;
		let div4;
		let div0;
		let t0;
		let div3;
		let div1;
		let t1;
		let t2;
		let div2;
		let i;
		let t3;
		let mounted;
		let dispose;

		function select_block_type_1(ctx, dirty) {
			if (!/*item*/ ctx[53].filterOn) return create_if_block_17;
			return create_else_block$7;
		}

		let current_block_type = select_block_type_1(ctx);
		let if_block0 = current_block_type(ctx);
		let if_block1 = /*item*/ ctx[53].sortDirection === 'asc' && create_if_block_16(ctx);
		let if_block2 = /*item*/ ctx[53].sortDirection === 'desc' && create_if_block_15(ctx);

		function click_handler_2() {
			return /*click_handler_2*/ ctx[33](/*item*/ ctx[53]);
		}

		return {
			c() {
				th = element("th");
				div4 = element("div");
				div0 = element("div");
				if_block0.c();
				t0 = space();
				div3 = element("div");
				div1 = element("div");
				if (if_block1) if_block1.c();
				t1 = space();
				if (if_block2) if_block2.c();
				t2 = space();
				div2 = element("div");
				i = element("i");
				t3 = space();
				attr(div0, "class", "header-title svelte-1upvl27");
				attr(div1, "class", "sort svelte-1upvl27");
				attr(i, "class", "fa fa-filter");
				attr(div2, "class", "filter svelte-1upvl27");
				attr(div3, "class", "header-icons svelte-1upvl27");
				attr(div4, "class", "header svelte-1upvl27");
				set_style(th, "width", /*item*/ ctx[53].width ? /*item*/ ctx[53].width : 'auto');
				attr(th, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, th, anchor);
				append(th, div4);
				append(div4, div0);
				if_block0.m(div0, null);
				append(div4, t0);
				append(div4, div3);
				append(div3, div1);
				if (if_block1) if_block1.m(div1, null);
				append(div1, t1);
				if (if_block2) if_block2.m(div1, null);
				append(div3, t2);
				append(div3, div2);
				append(div2, i);
				append(th, t3);

				if (!mounted) {
					dispose = [listen(i, "keyup", keyup_handler_3$2), listen(i, "click", click_handler_2)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;

				if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0.d(1);
					if_block0 = current_block_type(ctx);

					if (if_block0) {
						if_block0.c();
						if_block0.m(div0, null);
					}
				}

				if (/*item*/ ctx[53].sortDirection === 'asc') {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_16(ctx);
						if_block1.c();
						if_block1.m(div1, t1);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*item*/ ctx[53].sortDirection === 'desc') {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_15(ctx);
						if_block2.c();
						if_block2.m(div1, null);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}

				if (dirty[0] & /*data*/ 1) {
					set_style(th, "width", /*item*/ ctx[53].width ? /*item*/ ctx[53].width : 'auto');
				}
			},
			d(detaching) {
				if (detaching) {
					detach(th);
				}

				if_block0.d();
				if (if_block1) if_block1.d();
				if (if_block2) if_block2.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (363:16) {#if displayRows && displayRows.length > 0}
	function create_if_block_5$3(ctx) {
		let each_1_anchor;
		let each_value_1 = ensure_array_like(/*displayRows*/ ctx[10]);
		let each_blocks = [];

		for (let i = 0; i < each_value_1.length; i += 1) {
			each_blocks[i] = create_each_block_1$3(get_each_context_1$3(ctx, each_value_1, i));
		}

		return {
			c() {
				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty();
			},
			m(target, anchor) {
				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*displayRows, closeTextAreaClick, showCommentBoxIndex, handleButtonClick, handleIconLinkClick, handleLinkClick*/ 62923776) {
					each_value_1 = ensure_array_like(/*displayRows*/ ctx[10]);
					let i;

					for (i = 0; i < each_value_1.length; i += 1) {
						const child_ctx = get_each_context_1$3(ctx, each_value_1, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_1$3(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_1.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(each_1_anchor);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (367:32) {#if column.type === 'text'}
	function create_if_block_13(ctx) {
		let td;
		let t_value = /*column*/ ctx[59].value + "";
		let t;

		return {
			c() {
				td = element("td");
				t = text(t_value);
				attr(td, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, t);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*displayRows*/ 1024 && t_value !== (t_value = /*column*/ ctx[59].value + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}
			}
		};
	}

	// (370:32) {#if column.type === 'link'}
	function create_if_block_12(ctx) {
		let td;
		let a;
		let t_value = /*column*/ ctx[59].displayValue + "";
		let t;
		let a_href_value;
		let mounted;
		let dispose;

		function click_handler_3(...args) {
			return /*click_handler_3*/ ctx[34](/*column*/ ctx[59], ...args);
		}

		return {
			c() {
				td = element("td");
				a = element("a");
				t = text(t_value);
				attr(a, "href", a_href_value = /*column*/ ctx[59].value.href);
				attr(td, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, a);
				append(a, t);

				if (!mounted) {
					dispose = [listen(a, "keyup", keyup_handler_4$1), listen(a, "click", click_handler_3)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty[0] & /*displayRows*/ 1024 && t_value !== (t_value = /*column*/ ctx[59].displayValue + "")) set_data(t, t_value);

				if (dirty[0] & /*displayRows*/ 1024 && a_href_value !== (a_href_value = /*column*/ ctx[59].value.href)) {
					attr(a, "href", a_href_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (373:32) {#if column.type === 'inlineLink'}
	function create_if_block_11(ctx) {
		let td;
		let t0_value = /*column*/ ctx[59].value.beforeLinkText + "";
		let t0;
		let a;
		let t1_value = /*column*/ ctx[59].displayValue + "";
		let t1;
		let a_href_value;
		let a_style_value;
		let t2_value = /*column*/ ctx[59].value.afterLinkText + "";
		let t2;
		let mounted;
		let dispose;

		function click_handler_4(...args) {
			return /*click_handler_4*/ ctx[35](/*column*/ ctx[59], ...args);
		}

		return {
			c() {
				td = element("td");
				t0 = text(t0_value);
				a = element("a");
				t1 = text(t1_value);
				t2 = text(t2_value);
				attr(a, "href", a_href_value = /*column*/ ctx[59].value.href);
				attr(a, "style", a_style_value = /*column*/ ctx[59].value.style);
				attr(td, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, t0);
				append(td, a);
				append(a, t1);
				append(td, t2);

				if (!mounted) {
					dispose = [listen(a, "keyup", keyup_handler_5), listen(a, "click", click_handler_4)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty[0] & /*displayRows*/ 1024 && t0_value !== (t0_value = /*column*/ ctx[59].value.beforeLinkText + "")) set_data(t0, t0_value);
				if (dirty[0] & /*displayRows*/ 1024 && t1_value !== (t1_value = /*column*/ ctx[59].displayValue + "")) set_data(t1, t1_value);

				if (dirty[0] & /*displayRows*/ 1024 && a_href_value !== (a_href_value = /*column*/ ctx[59].value.href)) {
					attr(a, "href", a_href_value);
				}

				if (dirty[0] & /*displayRows*/ 1024 && a_style_value !== (a_style_value = /*column*/ ctx[59].value.style)) {
					attr(a, "style", a_style_value);
				}

				if (dirty[0] & /*displayRows*/ 1024 && t2_value !== (t2_value = /*column*/ ctx[59].value.afterLinkText + "")) set_data(t2, t2_value);
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (376:32) {#if column.type === 'button'}
	function create_if_block_10$1(ctx) {
		let td;
		let button;
		let t_value = /*column*/ ctx[59].displayValue + "";
		let t;
		let mounted;
		let dispose;

		function click_handler_5(...args) {
			return /*click_handler_5*/ ctx[36](/*column*/ ctx[59], ...args);
		}

		return {
			c() {
				td = element("td");
				button = element("button");
				t = text(t_value);
				attr(td, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, button);
				append(button, t);

				if (!mounted) {
					dispose = [
						listen(button, "keyup", keyup_handler_6),
						listen(button, "click", click_handler_5)
					];

					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty[0] & /*displayRows*/ 1024 && t_value !== (t_value = /*column*/ ctx[59].displayValue + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (379:32) {#if column.type === 'linkicon'}
	function create_if_block_9$2(ctx) {
		let td;
		let a;
		let i;
		let i_class_value;
		let a_href_value;
		let a_style_value;
		let mounted;
		let dispose;

		function click_handler_6(...args) {
			return /*click_handler_6*/ ctx[37](/*column*/ ctx[59], /*row*/ ctx[56], ...args);
		}

		return {
			c() {
				td = element("td");
				a = element("a");
				i = element("i");
				attr(i, "class", i_class_value = "" + (null_to_empty(/*column*/ ctx[59].value.iconClass) + " svelte-1upvl27"));
				attr(a, "href", a_href_value = /*column*/ ctx[59].value.href);
				attr(a, "style", a_style_value = /*column*/ ctx[59].value.linkStyle);
				attr(td, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, a);
				append(a, i);

				if (!mounted) {
					dispose = [listen(a, "keyup", keyup_handler_7), listen(a, "click", click_handler_6)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;

				if (dirty[0] & /*displayRows*/ 1024 && i_class_value !== (i_class_value = "" + (null_to_empty(/*column*/ ctx[59].value.iconClass) + " svelte-1upvl27"))) {
					attr(i, "class", i_class_value);
				}

				if (dirty[0] & /*displayRows*/ 1024 && a_href_value !== (a_href_value = /*column*/ ctx[59].value.href)) {
					attr(a, "href", a_href_value);
				}

				if (dirty[0] & /*displayRows*/ 1024 && a_style_value !== (a_style_value = /*column*/ ctx[59].value.linkStyle)) {
					attr(a, "style", a_style_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (382:32) {#if column.type === 'button'}
	function create_if_block_8$2(ctx) {
		let td;
		let button;
		let t_value = /*column*/ ctx[59].displayValue + "";
		let t;
		let mounted;
		let dispose;

		function click_handler_7(...args) {
			return /*click_handler_7*/ ctx[38](/*column*/ ctx[59], ...args);
		}

		return {
			c() {
				td = element("td");
				button = element("button");
				t = text(t_value);
				attr(td, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, button);
				append(button, t);

				if (!mounted) {
					dispose = [
						listen(button, "keyup", keyup_handler_8),
						listen(button, "click", click_handler_7)
					];

					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty[0] & /*displayRows*/ 1024 && t_value !== (t_value = /*column*/ ctx[59].displayValue + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (366:28) {#each row.columns as column}
	function create_each_block_3(ctx) {
		let t0;
		let t1;
		let t2;
		let t3;
		let t4;
		let if_block5_anchor;
		let if_block0 = /*column*/ ctx[59].type === 'text' && create_if_block_13(ctx);
		let if_block1 = /*column*/ ctx[59].type === 'link' && create_if_block_12(ctx);
		let if_block2 = /*column*/ ctx[59].type === 'inlineLink' && create_if_block_11(ctx);
		let if_block3 = /*column*/ ctx[59].type === 'button' && create_if_block_10$1(ctx);
		let if_block4 = /*column*/ ctx[59].type === 'linkicon' && create_if_block_9$2(ctx);
		let if_block5 = /*column*/ ctx[59].type === 'button' && create_if_block_8$2(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t0 = space();
				if (if_block1) if_block1.c();
				t1 = space();
				if (if_block2) if_block2.c();
				t2 = space();
				if (if_block3) if_block3.c();
				t3 = space();
				if (if_block4) if_block4.c();
				t4 = space();
				if (if_block5) if_block5.c();
				if_block5_anchor = empty();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t0, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, t1, anchor);
				if (if_block2) if_block2.m(target, anchor);
				insert(target, t2, anchor);
				if (if_block3) if_block3.m(target, anchor);
				insert(target, t3, anchor);
				if (if_block4) if_block4.m(target, anchor);
				insert(target, t4, anchor);
				if (if_block5) if_block5.m(target, anchor);
				insert(target, if_block5_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*column*/ ctx[59].type === 'text') {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_13(ctx);
						if_block0.c();
						if_block0.m(t0.parentNode, t0);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*column*/ ctx[59].type === 'link') {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_12(ctx);
						if_block1.c();
						if_block1.m(t1.parentNode, t1);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*column*/ ctx[59].type === 'inlineLink') {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_11(ctx);
						if_block2.c();
						if_block2.m(t2.parentNode, t2);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}

				if (/*column*/ ctx[59].type === 'button') {
					if (if_block3) {
						if_block3.p(ctx, dirty);
					} else {
						if_block3 = create_if_block_10$1(ctx);
						if_block3.c();
						if_block3.m(t3.parentNode, t3);
					}
				} else if (if_block3) {
					if_block3.d(1);
					if_block3 = null;
				}

				if (/*column*/ ctx[59].type === 'linkicon') {
					if (if_block4) {
						if_block4.p(ctx, dirty);
					} else {
						if_block4 = create_if_block_9$2(ctx);
						if_block4.c();
						if_block4.m(t4.parentNode, t4);
					}
				} else if (if_block4) {
					if_block4.d(1);
					if_block4 = null;
				}

				if (/*column*/ ctx[59].type === 'button') {
					if (if_block5) {
						if_block5.p(ctx, dirty);
					} else {
						if_block5 = create_if_block_8$2(ctx);
						if_block5.c();
						if_block5.m(if_block5_anchor.parentNode, if_block5_anchor);
					}
				} else if (if_block5) {
					if_block5.d(1);
					if_block5 = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(t0);
					detach(t1);
					detach(t2);
					detach(t3);
					detach(t4);
					detach(if_block5_anchor);
				}

				if (if_block0) if_block0.d(detaching);
				if (if_block1) if_block1.d(detaching);
				if (if_block2) if_block2.d(detaching);
				if (if_block3) if_block3.d(detaching);
				if (if_block4) if_block4.d(detaching);
				if (if_block5) if_block5.d(detaching);
			}
		};
	}

	// (388:24) {#if displayRows.indexOf(row) == showCommentBoxIndex}
	function create_if_block_6$3(ctx) {
		let tr;
		let td;
		let div2;
		let div1;
		let a;
		let t0;
		let div0;
		let t1;
		let mounted;
		let dispose;
		let each_value_2 = ensure_array_like(/*row*/ ctx[56].columns);
		let each_blocks = [];

		for (let i = 0; i < each_value_2.length; i += 1) {
			each_blocks[i] = create_each_block_2$2(get_each_context_2$2(ctx, each_value_2, i));
		}

		return {
			c() {
				tr = element("tr");
				td = element("td");
				div2 = element("div");
				div1 = element("div");
				a = element("a");
				a.innerHTML = `<i class="fa-sharp fa-solid fa-xmark"></i>`;
				t0 = space();
				div0 = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t1 = space();
				attr(a, "class", "absolute close font-15 font-black closeIcon svelte-1upvl27");
				attr(div0, "class", "width-full p-5 gap-10 commentText svelte-1upvl27");
				attr(div1, "class", "card__content p-5");
				attr(div2, "class", "comment-box svelte-1upvl27");
				attr(td, "colspan", "5");
				attr(td, "class", "inset-blur fade svelte-1upvl27");
				attr(tr, "class", "comment-background svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, tr, anchor);
				append(tr, td);
				append(td, div2);
				append(div2, div1);
				append(div1, a);
				append(div1, t0);
				append(div1, div0);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div0, null);
					}
				}

				append(tr, t1);

				if (!mounted) {
					dispose = [
						listen(a, "keyup", keyup_handler_9),
						listen(a, "click", /*click_handler_8*/ ctx[39])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*displayRows*/ 1024) {
					each_value_2 = ensure_array_like(/*row*/ ctx[56].columns);
					let i;

					for (i = 0; i < each_value_2.length; i += 1) {
						const child_ctx = get_each_context_2$2(ctx, each_value_2, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_2$2(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div0, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_2.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(tr);
				}

				destroy_each(each_blocks, detaching);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (398:52) {#if column.type === 'linkicon'}
	function create_if_block_7$3(ctx) {
		let div;
		let t0_value = /*column*/ ctx[59].displayValue + "";
		let t0;
		let t1;

		return {
			c() {
				div = element("div");
				t0 = text(t0_value);
				t1 = space();
				attr(div, "class", "form_text_wrap left-align pl-10 pr-10");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t0);
				append(div, t1);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*displayRows*/ 1024 && t0_value !== (t0_value = /*column*/ ctx[59].displayValue + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (397:48) {#each row.columns as column}
	function create_each_block_2$2(ctx) {
		let if_block_anchor;
		let if_block = /*column*/ ctx[59].type === 'linkicon' && create_if_block_7$3(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*column*/ ctx[59].type === 'linkicon') {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_7$3(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(if_block_anchor);
				}

				if (if_block) if_block.d(detaching);
			}
		};
	}

	// (364:20) {#each displayRows as row}
	function create_each_block_1$3(ctx) {
		let tr;
		let t;
		let show_if = /*displayRows*/ ctx[10].indexOf(/*row*/ ctx[56]) == /*showCommentBoxIndex*/ ctx[13];
		let if_block_anchor;
		let each_value_3 = ensure_array_like(/*row*/ ctx[56].columns);
		let each_blocks = [];

		for (let i = 0; i < each_value_3.length; i += 1) {
			each_blocks[i] = create_each_block_3(get_each_context_3(ctx, each_value_3, i));
		}

		let if_block = show_if && create_if_block_6$3(ctx);

		return {
			c() {
				tr = element("tr");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty();
				attr(tr, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, tr, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(tr, null);
					}
				}

				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*handleButtonClick, displayRows, handleIconLinkClick, handleLinkClick*/ 29361152) {
					each_value_3 = ensure_array_like(/*row*/ ctx[56].columns);
					let i;

					for (i = 0; i < each_value_3.length; i += 1) {
						const child_ctx = get_each_context_3(ctx, each_value_3, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_3(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(tr, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_3.length;
				}

				if (dirty[0] & /*displayRows, showCommentBoxIndex*/ 9216) show_if = /*displayRows*/ ctx[10].indexOf(/*row*/ ctx[56]) == /*showCommentBoxIndex*/ ctx[13];

				if (show_if) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_6$3(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(tr);
					detach(t);
					detach(if_block_anchor);
				}

				destroy_each(each_blocks, detaching);
				if (if_block) if_block.d(detaching);
			}
		};
	}

	// (412:16) {#if data?.rows?.length > pagesize && displayfooter}
	function create_if_block_3$6(ctx) {
		let tr;
		let td;
		let div;
		let td_colspan_value;
		let if_block = create_if_block_4$5(ctx);

		return {
			c() {
				tr = element("tr");
				td = element("td");
				div = element("div");
				if (if_block) if_block.c();
				attr(div, "class", "footer-content svelte-1upvl27");
				attr(td, "colspan", td_colspan_value = /*data*/ ctx[0]?.header?.length);
				attr(td, "class", "svelte-1upvl27");
				attr(tr, "class", "svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, tr, anchor);
				append(tr, td);
				append(td, div);
				if (if_block) if_block.m(div, null);
			},
			p(ctx, dirty) {
				if_block.p(ctx, dirty);

				if (dirty[0] & /*data*/ 1 && td_colspan_value !== (td_colspan_value = /*data*/ ctx[0]?.header?.length)) {
					attr(td, "colspan", td_colspan_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(tr);
				}

				if (if_block) if_block.d();
			}
		};
	}

	// (416:32) {#if !disablePagination}
	function create_if_block_4$5(ctx) {
		let div0;
		let i0;
		let t0;
		let div1;
		let t1;
		let div2;
		let i1;
		let mounted;
		let dispose;
		let each_value = ensure_array_like(/*totalPageGroupCount*/ ctx[11][Math.floor((/*currentPage*/ ctx[8] - 1) / 10)].pages);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$8(get_each_context$8(ctx, each_value, i));
		}

		return {
			c() {
				div0 = element("div");
				i0 = element("i");
				t0 = space();
				div1 = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t1 = space();
				div2 = element("div");
				i1 = element("i");
				attr(i0, "class", "fa fa-chevron-left");
				attr(div0, "class", "previous svelte-1upvl27");
				attr(div1, "class", "pages svelte-1upvl27");
				attr(i1, "class", "fa fa-chevron-right");
				attr(div2, "class", "next svelte-1upvl27");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				append(div0, i0);
				insert(target, t0, anchor);
				insert(target, div1, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div1, null);
					}
				}

				insert(target, t1, anchor);
				insert(target, div2, anchor);
				append(div2, i1);

				if (!mounted) {
					dispose = [
						listen(i0, "keyup", keyup_handler_10),
						listen(i0, "click", /*click_handler_9*/ ctx[40]),
						listen(i1, "keyup", keyup_handler_12),
						listen(i1, "click", /*click_handler_11*/ ctx[42])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*currentPage, totalPageGroupCount, goToPage*/ 2099456) {
					each_value = ensure_array_like(/*totalPageGroupCount*/ ctx[11][Math.floor((/*currentPage*/ ctx[8] - 1) / 10)].pages);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$8(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$8(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div1, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div0);
					detach(t0);
					detach(div1);
					detach(t1);
					detach(div2);
				}

				destroy_each(each_blocks, detaching);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (421:40) {#each totalPageGroupCount[Math.floor((currentPage-1)/10)].pages as item, index}
	function create_each_block$8(ctx) {
		let div;
		let t_value = /*item*/ ctx[53] + "";
		let t;
		let div_class_value;
		let mounted;
		let dispose;

		function click_handler_10(...args) {
			return /*click_handler_10*/ ctx[41](/*item*/ ctx[53], ...args);
		}

		return {
			c() {
				div = element("div");
				t = text(t_value);

				attr(div, "class", div_class_value = "page " + (/*currentPage*/ ctx[8] === /*item*/ ctx[53]
				? 'current-page'
				: '') + " svelte-1upvl27");

				set_style(div, "margin", "0 5px");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t);

				if (!mounted) {
					dispose = [
						listen(div, "keyup", keyup_handler_11),
						listen(div, "click", click_handler_10)
					];

					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty[0] & /*totalPageGroupCount, currentPage*/ 2304 && t_value !== (t_value = /*item*/ ctx[53] + "")) set_data(t, t_value);

				if (dirty[0] & /*currentPage, totalPageGroupCount*/ 2304 && div_class_value !== (div_class_value = "page " + (/*currentPage*/ ctx[8] === /*item*/ ctx[53]
				? 'current-page'
				: '') + " svelte-1upvl27")) {
					attr(div, "class", div_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	function create_fragment$s(ctx) {
		let link;
		let t;
		let div;

		function select_block_type(ctx, dirty) {
			if (/*showError*/ ctx[9]) return create_if_block$g;
			if (/*isempty*/ ctx[6]) return create_if_block_1$e;
			if (/*isFilterOn*/ ctx[12] || /*data*/ ctx[0].rows && /*data*/ ctx[0].rows.length > 0) return create_if_block_2$a;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type && current_block_type(ctx);

		return {
			c() {
				link = element("link");
				t = space();
				div = element("div");
				if (if_block) if_block.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t, anchor);
				insert(target, div, anchor);
				if (if_block) if_block.m(div, null);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if (if_block) if_block.d(1);
					if_block = current_block_type && current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(div, null);
					}
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t);
					detach(div);
				}

				if (if_block) {
					if_block.d();
				}
			}
		};
	}

	let errorMessage = '';

	function calculatePagesCount(pageSize, totalCount) {
		return totalCount < pageSize
		? 1
		: Math.ceil(totalCount / pageSize);
	}

	const keyup_handler_1$4 = e => {
		
	};

	const keyup_handler_2$2 = e => {
		
	};

	const keyup_handler_3$2 = e => {
		
	};

	const keyup_handler_4$1 = e => {
		
	};

	const keyup_handler_5 = e => {
		
	};

	const keyup_handler_6 = e => {
		
	};

	const keyup_handler_7 = e => {
		
	};

	const keyup_handler_8 = e => {
		
	};

	const keyup_handler_9 = e => {
		
	};

	const keyup_handler_10 = e => {
		
	};

	const keyup_handler_11 = e => {
		
	};

	const keyup_handler_12 = e => {
		
	};

	function instance$s($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { data } = $$props;
		let { width = '500' } = $$props;
		let { id = '' } = $$props;
		let { pagesize = 10 } = $$props;
		let { displayheader = true } = $$props;
		let { displayfooter = true } = $$props;
		let { isempty = false } = $$props;
		let { emptymessage = "Empty Results" } = $$props;
		let dataBackup = [...data.rows];
		let showError = false;
		let currentPage = 1;
		let displayRows = [];
		let totalPages = 0;
		let totalPageGroupCount = [];
		let isFilterOn = false;
		let showCommentBoxIndex = -1;

		function createPageGroupCountList(totalPageCount) {
			let pageGroupCount = Math.floor(totalPageCount / 10);
			let counter = 1;

			for (var i = 1; i <= pageGroupCount; i++) {
				let pages = [];

				for (var j = 1; j <= 10; j++) {
					pages = [...pages, counter];
					counter++;
				}

				$$invalidate(11, totalPageGroupCount = [...totalPageGroupCount, { groupIndex: i, pages }]);
			}

			if (totalPageCount % 10 > 0) {
				let pages = [];

				for (var j = 1; j <= totalPageCount % 10; j++) {
					pages = [...pages, counter];
					counter++;
				}

				$$invalidate(11, totalPageGroupCount = [
					...totalPageGroupCount,
					{
						groupIndex: Math.ceil(totalPageCount / 10),
						pages
					}
				]);
			}

			return totalPageGroupCount;
		}

		function previousPage(e) {
			if (currentPage > 1) {
				$$invalidate(8, currentPage--, currentPage);
			}

			if (data.rows?.length === 0) {
				$$invalidate(0, data.rows = dataBackup, data);

				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (currentPage - 1) * pagesize;
					let end = currentPage * pagesize;
					if (index >= start && index < end) return true;
				}));
			} else {
				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (currentPage - 1) * pagesize;
					let end = currentPage * pagesize;
					if (index >= start && index < end) return true;
				}));
			}

			$$invalidate(10, displayRows = [...displayRows]);
		}

		function nextPage(e) {
			if (data.rows?.length === 0) {
				$$invalidate(0, data.rows = dataBackup, data);

				if (currentPage * pagesize < data.rows.length) {
					$$invalidate(8, currentPage++, currentPage);
				}

				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (currentPage - 1) * pagesize;
					let end = currentPage * pagesize;
					if (index >= start && index < end) return true;
				}));
			} else {
				if (currentPage * pagesize < data.rows?.length) {
					$$invalidate(8, currentPage++, currentPage);
				}

				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (currentPage - 1) * pagesize;
					let end = currentPage * pagesize;
					if (index >= start && index < end) return true;
				}));
			}

			$$invalidate(0, data = { ...data });
			$$invalidate(10, displayRows = [...displayRows]);
		}

		function onErrorClose(e) {
			$$invalidate(9, showError = false);
		}

		function onInfoClose(e) {
		}

		function sort(item) {
			if (item.name.toLowerCase().includes('date')) {
				sortDate(item);
				return;
			}

			if (item.sortDirection === 'asc') {
				item.sortDirection = 'desc';

				$$invalidate(
					0,
					data.rows = data.rows.sort((a, b) => {
						return a.columns[item.index].value < b.columns[item.index].value
						? -1
						: 1;
					}),
					data
				);

				$$invalidate(8, currentPage = 1);
				setDisplayRows();
				goToPage(currentPage);
			} else if (item.sortDirection === 'desc') {
				item.sortDirection = 'asc';

				$$invalidate(
					0,
					data.rows = data.rows.sort((a, b) => {
						return a.columns[item.index].value > b.columns[item.index].value
						? -1
						: 1;
					}),
					data
				);

				$$invalidate(8, currentPage = 1);
				setDisplayRows();
				goToPage(currentPage);
			}

			return;
		}

		function sortDate(item) {
			if (item.sortDirection === 'asc') {
				item.sortDirection = 'desc';

				$$invalidate(
					0,
					data.rows = data.rows.sort((a, b) => {
						return new Date(a.columns[item.index].value.toString()) < new Date(b.columns[item.index].value.toString())
						? -1
						: 1;
					}),
					data
				);

				$$invalidate(8, currentPage = 1);
				setDisplayRows();
				goToPage(currentPage);
			} else if (item.sortDirection === 'desc') {
				item.sortDirection = 'asc';

				$$invalidate(
					0,
					data.rows = data.rows.sort((a, b) => {
						return new Date(a.columns[item.index].value.toString()) > new Date(b.columns[item.index].value.toString())
						? -1
						: 1;
					}),
					data
				);

				$$invalidate(8, currentPage = 1);
				setDisplayRows();
				goToPage(currentPage);
			}

			return;
		}

		function setDisplayRows() {
			if (data.rows?.length === 0) {
				$$invalidate(0, data.rows = [...data.rows], data);

				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (currentPage - 1) * pagesize;
					let end = currentPage * pagesize;
					if (index >= start && index < end) return true;
				}));
			} else {
				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (currentPage - 1) * pagesize;
					let end = currentPage * pagesize;
					if (index >= start && index < end) return true;
				}));
			}

			$$invalidate(10, displayRows = [...displayRows]);
		}

		function filter(item) {
			$$invalidate(0, data.rows = [...dataBackup], data);

			data.header.forEach(x => {
				if (x.name === item.name) {
					x.filterOn = !x.filterOn;
				} else {
					x.filterOn = false;
				}

				if (!x.filterOn) {
					item.filterValue = '';

					$$invalidate(10, displayRows = data.rows.filter((row, index) => {
						let start = (currentPage - 1) * pagesize;
						let end = currentPage * pagesize;
						if (index >= start && index < end) return true;
					}));
				} else {
					$$invalidate(0, data.rows = [...data.rows], data);
				}
			});

			$$invalidate(0, data = { ...data });
			$$invalidate(12, isFilterOn = data.header.some(x => x.filterOn));
		}

		function applyFilter(item) {
			$$invalidate(0, data.rows = [...dataBackup], data);

			if (item.filterValue && item.filterValue !== '') {
				let returnValue = false;
				let beforeLinkText = '';
				let displayValue = '';
				let afterLinkText = '';

				$$invalidate(
					0,
					data.rows = data.rows.filter(row => {
						if (row.columns[item.index].value) {
							beforeLinkText = row.columns[item.index].value.beforeLinkText
							? row.columns[item.index].value.beforeLinkText
							: '';

							displayValue = row.columns[item.index].displayValue
							? row.columns[item.index].displayValue
							: '';

							afterLinkText = row.columns[item.index].value.afterLinkText
							? row.columns[item.index].value.afterLinkText
							: '';

							returnValue = `${beforeLinkText.toLowerCase()} ${displayValue.toLowerCase()} ${afterLinkText.toLowerCase()}`.indexOf(item.filterValue.toLowerCase()) > -1;
						} else {
							displayValue = row.columns[item.index].displayValue
							? row.columns[item.index].displayValue
							: '';

							returnValue = displayValue.toLowerCase().indexOf(item.filterValue.toLowerCase()) > -1;
						}

						return returnValue;
					}),
					data
				);

				$$invalidate(26, totalPages = calculatePagesCount(pagesize, data.rows?.length));
				$$invalidate(11, totalPageGroupCount = []);
				$$invalidate(11, totalPageGroupCount = createPageGroupCountList(totalPages));

				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (currentPage - 1) * pagesize;
					let end = currentPage * pagesize;
					if (index >= start && index < end) return true;
				}));
			} else {
				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (currentPage - 1) * pagesize;
					let end = currentPage * pagesize;
					if (index >= start && index < end) return true;
				}));
			}

			$$invalidate(0, data.rows = [...data.rows], data);
		}

		function goToPage(page) {
			if (data.rows?.length === 0) {
				$$invalidate(0, data.rows = [...data.rows], data);
				$$invalidate(8, currentPage = page);

				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (page - 1) * pagesize;
					let end = page * pagesize;
					if (index >= start && index < end) return true;
				}));
			} else {
				$$invalidate(8, currentPage = page);

				$$invalidate(10, displayRows = data.rows.filter((row, index) => {
					let start = (page - 1) * pagesize;
					let end = page * pagesize;
					if (index >= start && index < end) return true;
				}));
			}
		}

		function handleLinkClick(e, data) {
			let detail = { rowData: data };
			svelteDispatch("rowlinkclicked", detail);
			return false;
		}

		function handleButtonClick(e, data) {
			let detail = { rowData: data };
			svelteDispatch("rowbuttonclicked", detail);
		}

		function handleIconLinkClick(e, data, showComment, displayCommentRowindex, columnIndex) {
			if (showComment) {
				$$invalidate(13, showCommentBoxIndex = displayCommentRowindex);
				return false;
			} else {
				let detail = { rowData: data };
				svelteDispatch("rowbuttonclicked", detail);
			}
		}

		function closeTextAreaClick() {
			$$invalidate(13, showCommentBoxIndex = -1);
			return false;
		}

		const errorclose_handler = e => onErrorClose();
		const infoclose_handler = e => onInfoClose();

		const keyup_handler = item => {
			applyFilter(item);
		};

		function input_input_handler(each_value_4, item_index) {
			each_value_4[item_index].filterValue = this.value;
			((($$invalidate(0, data), $$invalidate(3, pagesize)), $$invalidate(26, totalPages)), $$invalidate(8, currentPage));
		}

		const click_handler = item => {
			sort(item);
		};

		const click_handler_1 = item => {
			sort(item);
		};

		const click_handler_2 = item => {
			filter(item);
		};

		const click_handler_3 = (column, e) => handleLinkClick(e, column.value.click);
		const click_handler_4 = (column, e) => handleLinkClick(e, column.value.click);
		const click_handler_5 = (column, e) => handleButtonClick(e, column.value.click);
		const click_handler_6 = (column, row, e) => handleIconLinkClick(e, column.value.click, column.value.showComment, displayRows.indexOf(row), row.columns.indexOf(column));
		const click_handler_7 = (column, e) => handleButtonClick(e, column.value.click);
		const click_handler_8 = e => closeTextAreaClick();

		const click_handler_9 = e => {
			previousPage();
		};

		const click_handler_10 = (item, e) => {
			goToPage(item);
		};

		const click_handler_11 = e => {
			nextPage();
		};

		$$self.$$set = $$props => {
			if ('data' in $$props) $$invalidate(0, data = $$props.data);
			if ('width' in $$props) $$invalidate(1, width = $$props.width);
			if ('id' in $$props) $$invalidate(2, id = $$props.id);
			if ('pagesize' in $$props) $$invalidate(3, pagesize = $$props.pagesize);
			if ('displayheader' in $$props) $$invalidate(4, displayheader = $$props.displayheader);
			if ('displayfooter' in $$props) $$invalidate(5, displayfooter = $$props.displayfooter);
			if ('isempty' in $$props) $$invalidate(6, isempty = $$props.isempty);
			if ('emptymessage' in $$props) $$invalidate(7, emptymessage = $$props.emptymessage);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty[0] & /*data, pagesize, totalPages, currentPage*/ 67109129) {
				{
					if (data.rows.length > 0) {
						$$invalidate(26, totalPages = calculatePagesCount(pagesize, data.rows.length));
						$$invalidate(11, totalPageGroupCount = []);
						$$invalidate(11, totalPageGroupCount = createPageGroupCountList(totalPages));
					}

					$$invalidate(10, displayRows = data.rows.filter((row, index) => {
						let start = (currentPage - 1) * pagesize;
						let end = currentPage * pagesize;
						if (index >= start && index < end) return true;
					}));

					if (data.rows.length === pagesize) ;

					$$invalidate(0, data = { ...data });
				}
			}

			if ($$self.$$.dirty[0] & /*data*/ 1) {
				console.log('----------EAS Svelte Table data---------', data);
			}

			if ($$self.$$.dirty[0] & /*width*/ 2) {
				$$invalidate(1, width = width && width.slice(-1) === '%' ? width : `${width}px`);
			}
		};

		console.log('----------EAS Svelte Table control---------');

		return [
			data,
			width,
			id,
			pagesize,
			displayheader,
			displayfooter,
			isempty,
			emptymessage,
			currentPage,
			showError,
			displayRows,
			totalPageGroupCount,
			isFilterOn,
			showCommentBoxIndex,
			previousPage,
			nextPage,
			onErrorClose,
			onInfoClose,
			sort,
			filter,
			applyFilter,
			goToPage,
			handleLinkClick,
			handleButtonClick,
			handleIconLinkClick,
			closeTextAreaClick,
			totalPages,
			errorclose_handler,
			infoclose_handler,
			keyup_handler,
			input_input_handler,
			click_handler,
			click_handler_1,
			click_handler_2,
			click_handler_3,
			click_handler_4,
			click_handler_5,
			click_handler_6,
			click_handler_7,
			click_handler_8,
			click_handler_9,
			click_handler_10,
			click_handler_11
		];
	}

	class Eas_table_control_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$s,
				create_fragment$s,
				safe_not_equal,
				{
					data: 0,
					width: 1,
					id: 2,
					pagesize: 3,
					displayheader: 4,
					displayfooter: 5,
					isempty: 6,
					emptymessage: 7
				},
				add_css$r,
				[-1, -1, -1]
			);
		}

		get data() {
			return this.$$.ctx[0];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}

		get width() {
			return this.$$.ctx[1];
		}

		set width(width) {
			this.$$set({ width });
			flush();
		}

		get id() {
			return this.$$.ctx[2];
		}

		set id(id) {
			this.$$set({ id });
			flush();
		}

		get pagesize() {
			return this.$$.ctx[3];
		}

		set pagesize(pagesize) {
			this.$$set({ pagesize });
			flush();
		}

		get displayheader() {
			return this.$$.ctx[4];
		}

		set displayheader(displayheader) {
			this.$$set({ displayheader });
			flush();
		}

		get displayfooter() {
			return this.$$.ctx[5];
		}

		set displayfooter(displayfooter) {
			this.$$set({ displayfooter });
			flush();
		}

		get isempty() {
			return this.$$.ctx[6];
		}

		set isempty(isempty) {
			this.$$set({ isempty });
			flush();
		}

		get emptymessage() {
			return this.$$.ctx[7];
		}

		set emptymessage(emptymessage) {
			this.$$set({ emptymessage });
			flush();
		}
	}

	customElements.define("eas-table-control", create_custom_element(Eas_table_control_component, {"data":{},"width":{},"id":{},"pagesize":{},"displayheader":{"type":"Boolean"},"displayfooter":{"type":"Boolean"},"isempty":{"type":"Boolean"},"emptymessage":{}}, [], [], true));

	class DocumentService extends ServiceBase {
	    getDocumentCount(moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey) {
	        if (!assetTemplateKey || !compositeOwnerSourceKey) {
	            console.error(`getDocumentCount: invalid parameters assetTemplateKey: ${assetTemplateKey} , compositeOwnerSourceKey: ${compositeOwnerSourceKey}`);
	            return new Promise((resolve) => {
	                resolve(0);
	            });
	        }
	        const _url = `${this.easUtilityUrl}/api/v1/Document/documents/count?moduleKey=${moduleKey}` +
	            `&assetTemplateKey=${assetTemplateKey}&detailKey=${compositeOwnerSourceKey}` +
	            (immediateOwnerSourceKey ?
	                `&immediateOwnerSourceKey=${immediateOwnerSourceKey}&immediateOwnerTypeKey=${immediateOwnerTypeKey}` : '') +
	            (compositeOwnerTypeKey ?
	                `&compositeOwnerTypeKey=${compositeOwnerTypeKey}` : '');
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(_url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getDocuments(moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, itemContextKey = 0) {
	        if (!assetTemplateKey || !compositeOwnerSourceKey) {
	            console.error(`getDocuments: invalid parameters assetTemplateKey: ${assetTemplateKey} , compositeOwnerSourceKey: ${compositeOwnerSourceKey}`);
	            return new Promise((resolve) => {
	                resolve([]);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/Document/documents?moduleKey=${moduleKey}` +
	            `&assetTemplateKey=${assetTemplateKey}&detailKey=${compositeOwnerSourceKey}&compositeOwnerTypeKey=${compositeOwnerTypeKey}` +
	            `&immediateOwnerSourceKey=${immediateOwnerSourceKey}&immediateOwnerTypeKey=${immediateOwnerTypeKey}`;
	        if (itemContextKey && itemContextKey != 0) {
	            url += `&itemContextKey=${itemContextKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getFileTypes() {
	        let _url = `${this.easUtilityUrl}/api/v1/Document/filetypes`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(_url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getDocTypes(moduleKey, assetTemplateKey, ownerTypeKey, type, itemContextKey = 0) {
	        if (!assetTemplateKey || !ownerTypeKey || !type) {
	            console.error(`getDocTypes: invalid parameters assetTemplateKey: ${assetTemplateKey} , ownerTypeKey: ${ownerTypeKey} , type: ${type}`);
	            return new Promise((resolve) => {
	                resolve([]);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/Document/doctypes?moduleKey=${moduleKey}&assetTemplateKey=${assetTemplateKey}&detailKey=${ownerTypeKey}&type=${type}`;
	        if (itemContextKey && itemContextKey != 0) {
	            url += `&itemContextKey=${itemContextKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getAllowedDocTypes(moduleKey, assetTemplateKey, ownerTypeKey, type, itemContext) {
	        let result = new Promise((resolve, reject) => {
	            this.getDocTypes(moduleKey, assetTemplateKey, ownerTypeKey, type, itemContext)
	                .then((items) => {
	                resolve(items.filter((item) => item.permission.create));
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getDocPermissions(moduleKey, assetTemplateKey, immediateOwnerSourceKey, itemContext = 0) {
	        if (!assetTemplateKey || !immediateOwnerSourceKey) {
	            console.error(`getDocPermissions: invalid parameters assetTemplateKey: ${assetTemplateKey} , immediateOwnerSourceKey: ${immediateOwnerSourceKey}`);
	            let retVal = { read: false, create: false, update: false, delete: false, approve: false, authorizeChange: false };
	            return new Promise((resolve) => {
	                resolve(retVal);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/Document/permissions?moduleKey=${moduleKey}&assetTemplateKey=${assetTemplateKey}&detailKey=${immediateOwnerSourceKey}&assetType=uicomp&childAssetTypeName=AddDocuments`;
	        if (itemContext && itemContext != 0) {
	            url += `&itemContextKey=${itemContext}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    uploadDocument(data, moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, docTypeKey, docTypeDescription, itemContextKey) {
	        let url = `${this.easUtilityUrl}/api/v1/Document/documents/saved?moduleKey=${moduleKey}` +
	            `&detailKey=${compositeOwnerSourceKey}&assetTemplateKey=${assetTemplateKey}&docType=${docTypeKey}` +
	            `&docTypeName=${docTypeDescription.split(' ').join('_')}` +
	            (immediateOwnerSourceKey ?
	                `&immediateOwnerSourceKey=${immediateOwnerSourceKey}&immediateOwnerTypeKey=${immediateOwnerTypeKey}` : '') +
	            (compositeOwnerTypeKey ?
	                `&compositeOwnerTypeKey=${compositeOwnerTypeKey}` : '');
	        if (itemContextKey != 0) {
	            url += `&itemContextKey=${itemContextKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.uploadFile(url, data)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    deleteDocument(data) {
	        let _url = `${this.easUtilityUrl}//api/v1/document/documents/deleted`;
	        let result = new Promise((resolve, reject) => {
	            this.putJSON(_url, data)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    downloadDocument(document) {
	        const _url = `${this.easUtilityUrl}/api/v1/Document/documents/file/${document.docKey}?moduleKey=${document.moduleKey}` +
	            `&assetTemplateKey=${document.assetTemplateKey}&detailKey=${document.documentCompositeOwnerSourceKey}` +
	            (document.documentImmediateOwnerSourceKey ?
	                `&immediateOwnerSourceKey=${document.documentImmediateOwnerSourceKey}&immediateOwnerTypeKey=${document.documentImmediateOwnerTypeKey}` : '') +
	            (document.documentCompositeOwnerTypeKey ?
	                `&compositeOwnerTypeKey=${document.documentCompositeOwnerTypeKey}` : '');
	        let result = new Promise((resolve, reject) => {
	            this.getFile(_url)
	                .then((response) => {
	                resolve(response.blob());
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getDocStatuses(moduleKey, assetTemplateKey, documentRelationInstancekey, itemContextKey) {
	        if (!moduleKey || !assetTemplateKey || !documentRelationInstancekey || moduleKey == 0 || assetTemplateKey == 0 || documentRelationInstancekey == 0) {
	            console.error(`getDocStatuses: invalid parameters assetTemplateKey: ${assetTemplateKey} , documentRelationInstancekey: ${documentRelationInstancekey}`);
	            let retVal = { authorizedToUpdate: false, documentStatuses: [] };
	            return new Promise((resolve) => {
	                resolve(retVal);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/Document/statuses?moduleKey=${moduleKey}&assetTemplateKey=${assetTemplateKey}&documentRelationInstanceKey=${documentRelationInstancekey}`;
	        if (itemContextKey && itemContextKey != 0) {
	            url += `&itemContextKey=${itemContextKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    updateDocument(updateDocumentModel) {
	        let url = `${this.easUtilityUrl}/api/v1/Document/documents`;
	        let result = new Promise((resolve, reject) => {
	            this.putJSON(url, updateDocumentModel)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	}

	/* src\lib\web-components\upload\eas-upload-control.component.svelte generated by Svelte v4.2.19 */

	function add_css$q(target) {
		append_styles(target, "svelte-6b68l8", ".hover-blue-200.svelte-6b68l8:hover{background:#e2ebf2}.error-border.svelte-6b68l8{border-color:red!important}.error-text.svelte-6b68l8{color:red}.drop-area.svelte-6b68l8{display:flex;justify-content:center;align-items:center;height:250px;width:100%;border-style:dotted;border-color:#A1A1A1;background-color:#E8E8E8}.drop-area-message.svelte-6b68l8{font-weight:bold;color:#A1A1A1;padding:20px;font-size:18px}.input-file.svelte-6b68l8{visibility:hidden;position:absolute;overflow:hidden;width:0px;height:0px;border:none;margin:0;padding:0\r\n    }.error-text.svelte-6b68l8{color:red}");
	}

	function get_each_context$7(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[62] = list[i];
		return child_ctx;
	}

	function get_each_context_1$2(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[62] = list[i];
		return child_ctx;
	}

	// (384:4) {#if primary}
	function create_if_block_9$1(ctx) {
		let div1;
		let div0;
		let mounted;
		let dispose;

		return {
			c() {
				div1 = element("div");
				div0 = element("div");
				div0.textContent = "Drag file(s) here to upload or click here to browse for files.";
				attr(div0, "class", "drop-area-message svelte-6b68l8");
				set_style(div1, "width", /*width*/ ctx[0] + "px");
				attr(div1, "class", "hover-blue-200 drop-area svelte-6b68l8");
				toggle_class(div1, "error-border", /*errorPrimary*/ ctx[15]);
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, div0);
				/*div0_binding*/ ctx[26](div0);
				/*div1_binding*/ ctx[27](div1);

				if (!mounted) {
					dispose = [
						listen(div1, "drop", /*drop_handler*/ ctx[28]),
						listen(div1, "dragover", /*dragover_handler*/ ctx[29]),
						listen(div1, "click", /*click_handler*/ ctx[30]),
						listen(div1, "keyup", keyup_handler$3)
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*width*/ 1) {
					set_style(div1, "width", /*width*/ ctx[0] + "px");
				}

				if (dirty[0] & /*errorPrimary*/ 32768) {
					toggle_class(div1, "error-border", /*errorPrimary*/ ctx[15]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div1);
				}

				/*div0_binding*/ ctx[26](null);
				/*div1_binding*/ ctx[27](null);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (391:4) {#if !primary}
	function create_if_block_8$1(ctx) {
		let div1;
		let div0;
		let mounted;
		let dispose;

		return {
			c() {
				div1 = element("div");
				div0 = element("div");
				div0.textContent = "Drag file(s) here to upload or click here to browse for files.";
				attr(div0, "class", "drop-area-message svelte-6b68l8");
				set_style(div1, "width", /*width*/ ctx[0] + "px");
				attr(div1, "class", "hover-blue-200 drop-area svelte-6b68l8");
				toggle_class(div1, "error-border", /*error*/ ctx[14]);
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, div0);
				/*div0_binding_1*/ ctx[31](div0);
				/*div1_binding_1*/ ctx[32](div1);

				if (!mounted) {
					dispose = [
						listen(div1, "drop", /*drop_handler_1*/ ctx[33]),
						listen(div1, "dragover", /*dragover_handler_1*/ ctx[34]),
						listen(div1, "click", /*click_handler_1*/ ctx[35]),
						listen(div1, "keyup", keyup_handler_1$3)
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*width*/ 1) {
					set_style(div1, "width", /*width*/ ctx[0] + "px");
				}

				if (dirty[0] & /*error*/ 16384) {
					toggle_class(div1, "error-border", /*error*/ ctx[14]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div1);
				}

				/*div0_binding_1*/ ctx[31](null);
				/*div1_binding_1*/ ctx[32](null);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (402:4) {#if primary}
	function create_if_block_4$4(ctx) {
		let t;
		let each_1_anchor;
		let if_block = /*errorPrimary*/ ctx[15] && create_if_block_7$2(ctx);
		let each_value_1 = ensure_array_like(/*uploadfilesPrimary*/ ctx[6]);
		let each_blocks = [];

		for (let i = 0; i < each_value_1.length; i += 1) {
			each_blocks[i] = create_each_block_1$2(get_each_context_1$2(ctx, each_value_1, i));
		}

		return {
			c() {
				if (if_block) if_block.c();
				t = space();

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, t, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*errorPrimary*/ ctx[15]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_7$2(ctx);
						if_block.c();
						if_block.m(t.parentNode, t);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}

				if (dirty[0] & /*percent, progressBar, completed, uploadStatusPrimary, uploadfilesPrimary*/ 15424) {
					each_value_1 = ensure_array_like(/*uploadfilesPrimary*/ ctx[6]);
					let i;

					for (i = 0; i < each_value_1.length; i += 1) {
						const child_ctx = get_each_context_1$2(ctx, each_value_1, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_1$2(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_1.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(t);
					detach(each_1_anchor);
				}

				if (if_block) if_block.d(detaching);
				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (403:8) {#if errorPrimary}
	function create_if_block_7$2(ctx) {
		let div;
		let t;

		return {
			c() {
				div = element("div");
				t = text(/*errorMessagePrimary*/ ctx[8]);
				attr(div, "class", "error-text svelte-6b68l8");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*errorMessagePrimary*/ 256) set_data(t, /*errorMessagePrimary*/ ctx[8]);
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (407:12) {#if uploadStatusPrimary}
	function create_if_block_6$2(ctx) {
		let h3;
		let t0_value = /*file*/ ctx[62] + "";
		let t0;
		let t1;
		let t2;

		return {
			c() {
				h3 = element("h3");
				t0 = text(t0_value);
				t1 = text(" : ");
				t2 = text(/*uploadStatusPrimary*/ ctx[10]);
			},
			m(target, anchor) {
				insert(target, h3, anchor);
				append(h3, t0);
				append(h3, t1);
				append(h3, t2);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*uploadfilesPrimary*/ 64 && t0_value !== (t0_value = /*file*/ ctx[62] + "")) set_data(t0, t0_value);
				if (dirty[0] & /*uploadStatusPrimary*/ 1024) set_data(t2, /*uploadStatusPrimary*/ ctx[10]);
			},
			d(detaching) {
				if (detaching) {
					detach(h3);
				}
			}
		};
	}

	// (410:12) {#if !completed}
	function create_if_block_5$2(ctx) {
		let progress;

		return {
			c() {
				progress = element("progress");
				progress.value = /*percent*/ ctx[12];
				attr(progress, "max", "100");
				set_style(progress, "width", "1200px");
				set_style(progress, "height", "50px");
			},
			m(target, anchor) {
				insert(target, progress, anchor);
				/*progress_binding*/ ctx[38](progress);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*percent*/ 4096) {
					progress.value = /*percent*/ ctx[12];
				}
			},
			d(detaching) {
				if (detaching) {
					detach(progress);
				}

				/*progress_binding*/ ctx[38](null);
			}
		};
	}

	// (406:8) {#each uploadfilesPrimary as file}
	function create_each_block_1$2(ctx) {
		let t;
		let if_block1_anchor;
		let if_block0 = /*uploadStatusPrimary*/ ctx[10] && create_if_block_6$2(ctx);
		let if_block1 = !/*completed*/ ctx[13] && create_if_block_5$2(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*uploadStatusPrimary*/ ctx[10]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_6$2(ctx);
						if_block0.c();
						if_block0.m(t.parentNode, t);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (!/*completed*/ ctx[13]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_5$2(ctx);
						if_block1.c();
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(t);
					detach(if_block1_anchor);
				}

				if (if_block0) if_block0.d(detaching);
				if (if_block1) if_block1.d(detaching);
			}
		};
	}

	// (415:4) {#if !primary}
	function create_if_block$f(ctx) {
		let t;
		let each_1_anchor;
		let if_block = /*error*/ ctx[14] && create_if_block_3$5(ctx);
		let each_value = ensure_array_like(/*uploadfiles*/ ctx[5]);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$7(get_each_context$7(ctx, each_value, i));
		}

		return {
			c() {
				if (if_block) if_block.c();
				t = space();

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, t, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*error*/ ctx[14]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_3$5(ctx);
						if_block.c();
						if_block.m(t.parentNode, t);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}

				if (dirty[0] & /*percent, progressBar, completed, uploadStatus, uploadfiles*/ 14880) {
					each_value = ensure_array_like(/*uploadfiles*/ ctx[5]);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$7(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$7(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(t);
					detach(each_1_anchor);
				}

				if (if_block) if_block.d(detaching);
				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (416:8) {#if error}
	function create_if_block_3$5(ctx) {
		let div;
		let t;

		return {
			c() {
				div = element("div");
				t = text(/*errorMessage*/ ctx[7]);
				attr(div, "class", "error-text svelte-6b68l8");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*errorMessage*/ 128) set_data(t, /*errorMessage*/ ctx[7]);
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (420:12) {#if uploadStatus}
	function create_if_block_2$9(ctx) {
		let h3;
		let t0_value = /*file*/ ctx[62] + "";
		let t0;
		let t1;
		let t2;

		return {
			c() {
				h3 = element("h3");
				t0 = text(t0_value);
				t1 = text(" : ");
				t2 = text(/*uploadStatus*/ ctx[9]);
			},
			m(target, anchor) {
				insert(target, h3, anchor);
				append(h3, t0);
				append(h3, t1);
				append(h3, t2);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*uploadfiles*/ 32 && t0_value !== (t0_value = /*file*/ ctx[62] + "")) set_data(t0, t0_value);
				if (dirty[0] & /*uploadStatus*/ 512) set_data(t2, /*uploadStatus*/ ctx[9]);
			},
			d(detaching) {
				if (detaching) {
					detach(h3);
				}
			}
		};
	}

	// (423:12) {#if !completed}
	function create_if_block_1$d(ctx) {
		let progress;

		return {
			c() {
				progress = element("progress");
				progress.value = /*percent*/ ctx[12];
				attr(progress, "max", "100");
				set_style(progress, "width", "1200px");
				set_style(progress, "height", "50px");
			},
			m(target, anchor) {
				insert(target, progress, anchor);
				/*progress_binding_1*/ ctx[39](progress);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*percent*/ 4096) {
					progress.value = /*percent*/ ctx[12];
				}
			},
			d(detaching) {
				if (detaching) {
					detach(progress);
				}

				/*progress_binding_1*/ ctx[39](null);
			}
		};
	}

	// (419:8) {#each uploadfiles as file}
	function create_each_block$7(ctx) {
		let t;
		let if_block1_anchor;
		let if_block0 = /*uploadStatus*/ ctx[9] && create_if_block_2$9(ctx);
		let if_block1 = !/*completed*/ ctx[13] && create_if_block_1$d(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*uploadStatus*/ ctx[9]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_2$9(ctx);
						if_block0.c();
						if_block0.m(t.parentNode, t);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (!/*completed*/ ctx[13]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_1$d(ctx);
						if_block1.c();
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(t);
					detach(if_block1_anchor);
				}

				if (if_block0) if_block0.d(detaching);
				if (if_block1) if_block1.d(detaching);
			}
		};
	}

	function create_fragment$r(ctx) {
		let div;
		let t0;
		let t1;
		let span;
		let input;
		let t2;
		let t3;
		let mounted;
		let dispose;
		let if_block0 = /*primary*/ ctx[1] && create_if_block_9$1(ctx);
		let if_block1 = !/*primary*/ ctx[1] && create_if_block_8$1(ctx);
		let if_block2 = /*primary*/ ctx[1] && create_if_block_4$4(ctx);
		let if_block3 = !/*primary*/ ctx[1] && create_if_block$f(ctx);

		return {
			c() {
				div = element("div");
				if (if_block0) if_block0.c();
				t0 = space();
				if (if_block1) if_block1.c();
				t1 = space();
				span = element("span");
				input = element("input");
				t2 = space();
				if (if_block2) if_block2.c();
				t3 = space();
				if (if_block3) if_block3.c();
				attr(input, "type", "file");
				attr(input, "name", "file");
				attr(input, "id", "file");
				attr(span, "class", "input-file svelte-6b68l8");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if (if_block0) if_block0.m(div, null);
				append(div, t0);
				if (if_block1) if_block1.m(div, null);
				append(div, t1);
				append(div, span);
				append(span, input);
				/*input_binding*/ ctx[36](input);
				append(div, t2);
				if (if_block2) if_block2.m(div, null);
				append(div, t3);
				if (if_block3) if_block3.m(div, null);

				if (!mounted) {
					dispose = listen(input, "change", /*change_handler*/ ctx[37]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (/*primary*/ ctx[1]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_9$1(ctx);
						if_block0.c();
						if_block0.m(div, t0);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (!/*primary*/ ctx[1]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_8$1(ctx);
						if_block1.c();
						if_block1.m(div, t1);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*primary*/ ctx[1]) {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_4$4(ctx);
						if_block2.c();
						if_block2.m(div, t3);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}

				if (!/*primary*/ ctx[1]) {
					if (if_block3) {
						if_block3.p(ctx, dirty);
					} else {
						if_block3 = create_if_block$f(ctx);
						if_block3.c();
						if_block3.m(div, null);
					}
				} else if (if_block3) {
					if_block3.d(1);
					if_block3 = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(div);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				/*input_binding*/ ctx[36](null);
				if (if_block2) if_block2.d();
				if (if_block3) if_block3.d();
				mounted = false;
				dispose();
			}
		};
	}

	const MAX_FILE_SIZE_MB = 100;

	function dragOverHandler(e) {
		e.preventDefault();
	}

	const keyup_handler$3 = e => {
		
	};

	const keyup_handler_1$3 = e => {
		
	};

	function instance$r($$self, $$props, $$invalidate) {
		let { documentuploadlimitprimary = 1 } = $$props;
		let { documentuploadlimit = 100 } = $$props;
		let { width = "" } = $$props;
		let { primary = false } = $$props;
		let { selecteddoctype = 0 } = $$props;
		let { loadrequestinstancekey } = $$props;
		let { reset = false } = $$props;
		const uploadMaxFileSize = MAX_FILE_SIZE_MB * 1024 * 1024;
		const svelteDispatch = createEventDispatcher();
		let thumbnails = [];
		let documentService = new DocumentService();
		let errorMsg = "";
		let uploadfiles = [];
		let uploadfilesPrimary = [];
		let allowedExtensions = "";
		let inputFile;
		let dropZoneElement;
		let promptContainer;
		let errorMessage;
		let errorMessagePrimary;
		let uploadStatus;
		let uploadStatusPrimary;
		let progressBar;
		let percent = 0;
		let completed = true;
		let numberOfFilesUploaded = 0;
		let numberOfFilesUploadedPrimary = 0;
		let error = false;
		let errorPrimary = false;

		onMount(async () => {
			getFileTypes();
		});

		function getFileTypes() {
			documentService.getFileTypes().then(result => {
				allowedExtensions = result.map(x => x.fileExt).join(", ");
			});
		}

		function raiseValidationError(docTypeError, fileUploadError, validationMessage) {
			let detail = {
				validationMessage,
				docTypeError,
				fileUploadError
			};

			svelteDispatch("validationerror", detail);
		}

		function raiseUploadEvent(fileName, data) {
			let detail = { fileName, fileData: data };
			svelteDispatch("fileupload", detail);
			return false;
		}

		function resetValidationError() {
			raiseValidationError(false, false, '');
		}

		function dropHandler(e) {
			$$invalidate(14, error = false);
			resetValidationError();
			e.preventDefault();

			if (selecteddoctype === 0 || !selecteddoctype) {
				$$invalidate(25, errorMsg = `Please select document type before dropping files for upload`);
				raiseValidationError(true, false, errorMsg);
				return;
			}

			if (!isUploadLimitValid()) {
				return;
			}

			if (e.dataTransfer.items) {
				if (!isSelectionLimitValid(e.dataTransfer.items.length)) {
					return;
				}

				// Use DataTransferItemList interface to access the file(s)
				[...e.dataTransfer.items].forEach((item, i) => {
					// If dropped items aren't files, reject them
					if (item.kind === "file") {
						const file = item.getAsFile();
						var extension = file.name.split(".")[file.name.split(".").length - 1].toLowerCase();

						if (!isValidExtension(`.${extension}`)) {
							if (primary) setErrorMessage(false, true, `${file.name} : Primary data file cannot have file extensions other than .xls, .xlsx, .csv`); else setErrorMessage(false, true, `${file.name} : Supporting data file canoot have file extensions .msi, .exe`);
						} else if (file.size > uploadMaxFileSize) {
							setErrorMessage(false, true, `${file.name} is larger than size limit(100MB).`);
						} else {
							uploadFile(file);
						}
					}
				});
			} else {
				if (!isSelectionLimitValid(e.dataTransfer.items.length)) {
					return;
				}

				// Use DataTransfer interface to access the file(s)
				[...e.dataTransfer.files].forEach((file, i) => {
					var extension = file.name.split(".")[file.name.split(".").length - 1].toLowerCase();

					if (!isValidExtension(`.${extension}`)) {
						if (primary) setErrorMessage(false, true, `${file.name} : Primary data file cannot have file extensions other than .xls, .xlsx, .csv`); else setErrorMessage(false, true, `${file.name} : Supporting data file canot have file extensions .msi, .exe`);
					} else if (file.size > uploadMaxFileSize) {
						setErrorMessage(false, true, `${file.name} is larger than size limit(100MB).`);
					} else {
						updateThumbnail(file);
						uploadFile(file);
					}
				});
			}
		}

		function isUploadLimitValid() {
			let returnValue = true;

			if (primary) {
				if (numberOfFilesUploadedPrimary >= documentuploadlimitprimary) {
					setErrorMessage(false, true, 'You have exceeded document(s) upload limit(-uploadLimit-)');
					returnValue = false;
				}
			} else {
				if (numberOfFilesUploaded >= documentuploadlimit) {
					setErrorMessage(false, true, 'You have exceeded document(s) upload limit(-uploadLimit-)');
					returnValue = false;
				}
			}

			return returnValue;
		}

		function isSelectionLimitValid(selectionLength) {
			let returnValue = true;

			if (primary) {
				if (selectionLength > documentuploadlimitprimary) {
					setErrorMessage(false, true, 'You have selected more than -uploadLimit- document(s) to upload');
					returnValue = false;
				}
			} else {
				if (selectionLength > documentuploadlimit) {
					setErrorMessage(false, true, 'You have selected more than -uploadLimit- document(s) to upload');
					returnValue = false;
				}
			}

			return returnValue;
		}

		function setErrorMessage(docTypeError, fileUploadError, message) {
			if (primary) {
				$$invalidate(8, errorMessagePrimary = message.replace('-uploadLimit-', documentuploadlimitprimary?.toString()));
				raiseValidationError(false, true, '');
				$$invalidate(15, errorPrimary = true);
				$$invalidate(14, error = false);
				$$invalidate(7, errorMessage = '');
			} else {
				$$invalidate(7, errorMessage = message.replace('-uploadLimit-', documentuploadlimit?.toString()));
				raiseValidationError(false, true, '');
				$$invalidate(14, error = true);
				$$invalidate(8, errorMessagePrimary = '');
				$$invalidate(15, errorPrimary = false);
			}
		}

		function uploadFile(file) {
			if (primary) $$invalidate(6, uploadfilesPrimary = [...uploadfiles, file.name]); else $$invalidate(5, uploadfiles = [...uploadfiles, file.name]);
			let formData = new FormData();
			formData.append("file", file);
			let httpRequest = new XMLHttpRequest();
			httpRequest.upload.addEventListener("progress", progressHandler, false);
			httpRequest.upload.addEventListener("error", errorHandler, false);
			httpRequest.upload.addEventListener("abort", abortHandler, false);
			httpRequest.open("POST", `${sessionStorage.getItem("EAS_Dataload_Base_Url")}/api/v1/LoadRequest/Document?LoadRequestInstanceKey=${loadrequestinstancekey}&IsPrimary=${primary}`);
			httpRequest.setRequestHeader("claims", JSON.parse(sessionStorage.getItem('claims'))['claimsJwt']);
			httpRequest.setRequestHeader("Authorization", `Bearer ${JSON.parse(sessionStorage.getItem('accessToken'))['accessToken']}`);

			httpRequest.onload = () => {
				console.log('eas-upload-control onload response', httpRequest.response, httpRequest.status, httpRequest.statusText);

				if (httpRequest.status >= 300) {
					setErrorMessage(false, true, httpRequest.response);
					$$invalidate(13, completed = true);

					if (primary) {
						$$invalidate(10, uploadStatusPrimary = '');
						numberOfFilesUploadedPrimary--;
					} else {
						$$invalidate(9, uploadStatus = '');
						numberOfFilesUploaded--;
					}
				} else {
					raiseUploadEvent(file.name, httpRequest.response);
					$$invalidate(13, completed = true);
					numberOfFilesUploaded++;

					if (primary) {
						numberOfFilesUploadedPrimary++;
						$$invalidate(10, uploadStatusPrimary = 'Upload completed');
						$$invalidate(15, errorPrimary = false);
					} else {
						numberOfFilesUploaded++;
						$$invalidate(9, uploadStatus = 'Upload completed');
						$$invalidate(14, error = false);
					}

					if (progressBar) $$invalidate(11, progressBar.value = 0, progressBar);
					updateThumbnail(file);
				}
			};

			httpRequest.send(formData);
		}

		function progressHandler(event) {
			$$invalidate(13, completed = false);
			$$invalidate(12, percent = event.loaded / event.total * 100);

			if (primary) $$invalidate(10, uploadStatusPrimary = `${Math.round(percent)}% uploaded... please wait`); else {
				$$invalidate(9, uploadStatus = `${Math.round(percent)}% uploaded... please wait`);
			}
		}

		function errorHandler(event) {
			if (primary) $$invalidate(10, uploadStatusPrimary = "Upload Failed!"); else {
				$$invalidate(9, uploadStatus = "Upload Failed!");
			}
		}

		function abortHandler(event) {
			if (primary) $$invalidate(10, uploadStatusPrimary = "Upload Aborted!"); else {
				$$invalidate(9, uploadStatus = "Upload Aborted!");
			}
		}

		function isValidExtension(extension) {
			if (primary && !(extension === '.xlsx' || extension === '.xls' || '.csv')) {
				return false;
			}

			if (!primary) {
				if (extension === '.exe' || extension === '.msi') {
					return false;
				} else {
					return true;
				}
			}

			return allowedExtensions.indexOf(extension) > -1;
		}

		function dropZoneClickHandler() {
			inputFile.click();
		}

		function inputFileChangeHandler() {
			$$invalidate(14, error = false);
			resetValidationError();

			if (selecteddoctype === 0 || !selecteddoctype) {
				$$invalidate(25, errorMsg = `Please select document type before dropping files for upload`);
				raiseValidationError(true, false, errorMsg);
				return;
			}

			if (!isUploadLimitValid()) {
				return;
			}

			if (!isSelectionLimitValid(inputFile.files.length)) {
				return;
			}

			var extension = inputFile.files[0]?.name.split(".")[inputFile.files[0]?.name.split(".").length - 1].toLowerCase();

			if (!isValidExtension(`.${extension}`)) {
				if (primary) setErrorMessage(false, true, `${inputFile.files[0]?.name} : Primary data file cannot have file extensions other than .xls/.xlsx/.csv`); else setErrorMessage(false, true, `${inputFile.files[0]?.name} : Supporting data file can have file extensions other than .msi .exe`);
			} else if (inputFile.files[0].size > uploadMaxFileSize) {
				setErrorMessage(false, true, `${inputFile.files[0]?.name} is larger than size limit(100MB).`);
			} else {
				uploadFile(inputFile.files[0]);
				$$invalidate(2, inputFile.value = "", inputFile);
			}
		}

		function updateThumbnail(file) {
			promptContainer.remove();

			//first time, if there is no thumbnail element, create it
			let thumbnailElement = document.createElement("div");

			$$invalidate(24, thumbnails = [
				...thumbnails,
				{
					key: selecteddoctype,
					thumbnail: thumbnailElement
				}
			]);

			thumbnailElement.style.cssText = 'margin: 10px;display:flex; justify-concent: center; align-items: center;width: 100px; height:100px; border-radius: 10px;overflow: hidden;background-color: #cccccc;background-size: cover;position: relative;padding:15px';
			thumbnailElement.dataset.label = file.name;

			thumbnailElement.innerText = file.name.length > 15
			? `${file.name.substring(0, 15)}...`
			: file.name;

			dropZoneElement.appendChild(thumbnailElement);

			//show thumbnail for image
			if (file.type.startsWith("image/")) {
				const reader = new FileReader();
				reader.readAsDataURL(file);

				reader.onload = () => {
					thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
				};
			} else {
				thumbnailElement.style.backgroundImage = null;
			}
		}

		function div0_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				promptContainer = $$value;
				$$invalidate(4, promptContainer);
			});
		}

		function div1_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				dropZoneElement = $$value;
				(((((($$invalidate(3, dropZoneElement), $$invalidate(19, reset)), $$invalidate(24, thumbnails)), $$invalidate(4, promptContainer)), $$invalidate(2, inputFile)), $$invalidate(22, selecteddoctype)), $$invalidate(1, primary));
			});
		}

		const drop_handler = e => dropHandler(e);
		const dragover_handler = e => dragOverHandler(e);

		const click_handler = e => {
			dropZoneClickHandler();
		};

		function div0_binding_1($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				promptContainer = $$value;
				$$invalidate(4, promptContainer);
			});
		}

		function div1_binding_1($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				dropZoneElement = $$value;
				(((((($$invalidate(3, dropZoneElement), $$invalidate(19, reset)), $$invalidate(24, thumbnails)), $$invalidate(4, promptContainer)), $$invalidate(2, inputFile)), $$invalidate(22, selecteddoctype)), $$invalidate(1, primary));
			});
		}

		const drop_handler_1 = e => dropHandler(e);
		const dragover_handler_1 = e => dragOverHandler(e);

		const click_handler_1 = e => {
			dropZoneClickHandler();
		};

		function input_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				inputFile = $$value;
				(((((($$invalidate(2, inputFile), $$invalidate(19, reset)), $$invalidate(24, thumbnails)), $$invalidate(3, dropZoneElement)), $$invalidate(4, promptContainer)), $$invalidate(22, selecteddoctype)), $$invalidate(1, primary));
			});
		}

		const change_handler = () => {
			inputFileChangeHandler();
		};

		function progress_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				progressBar = $$value;
				$$invalidate(11, progressBar);
			});
		}

		function progress_binding_1($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				progressBar = $$value;
				$$invalidate(11, progressBar);
			});
		}

		$$self.$$set = $$props => {
			if ('documentuploadlimitprimary' in $$props) $$invalidate(20, documentuploadlimitprimary = $$props.documentuploadlimitprimary);
			if ('documentuploadlimit' in $$props) $$invalidate(21, documentuploadlimit = $$props.documentuploadlimit);
			if ('width' in $$props) $$invalidate(0, width = $$props.width);
			if ('primary' in $$props) $$invalidate(1, primary = $$props.primary);
			if ('selecteddoctype' in $$props) $$invalidate(22, selecteddoctype = $$props.selecteddoctype);
			if ('loadrequestinstancekey' in $$props) $$invalidate(23, loadrequestinstancekey = $$props.loadrequestinstancekey);
			if ('reset' in $$props) $$invalidate(19, reset = $$props.reset);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty[0] & /*reset, thumbnails, dropZoneElement, promptContainer, inputFile, selecteddoctype, primary*/ 21495838) {
				{
					if (reset) {
						$$invalidate(14, error = false);
						$$invalidate(24, thumbnails = []);
						$$invalidate(7, errorMessage = '');
						$$invalidate(25, errorMsg = '');
						$$invalidate(8, errorMessagePrimary = '');
						$$invalidate(15, errorPrimary = false);
						$$invalidate(10, uploadStatusPrimary = '');
						$$invalidate(9, uploadStatus = '');
						$$invalidate(6, uploadfilesPrimary = []);
						$$invalidate(5, uploadfiles = []);
						thumbnails.forEach(x => x.thumbnail.remove());
						$$invalidate(3, dropZoneElement.innerHTML = '', dropZoneElement);
						dropZoneElement?.appendChild(promptContainer);
						numberOfFilesUploadedPrimary = 0;
						numberOfFilesUploaded = 0;
						$$invalidate(2, inputFile.value = "", inputFile);
						$$invalidate(19, reset = false);
					} else {
						if (inputFile) $$invalidate(2, inputFile.value = "", inputFile);
						thumbnails.forEach(x => x.thumbnail.remove());
						let filteredThumbnails = thumbnails.filter(x => x.key === selecteddoctype);

						if (filteredThumbnails.length > 0) {
							$$invalidate(2, inputFile.value = "", inputFile);
							promptContainer.remove();
							filteredThumbnails.forEach(x => x.thumbnail.remove());
							filteredThumbnails.forEach(x => dropZoneElement.appendChild(x.thumbnail));
						} else {
							thumbnails.filter(x => x.thumbnail.remove());
							dropZoneElement?.appendChild(promptContainer);

							if (primary) $$invalidate(15, errorPrimary = false); else {
								$$invalidate(14, error = false);
							}
						}
					}
				}
			}

			if ($$self.$$.dirty[0] & /*selecteddoctype, errorMsg*/ 37748736) {
				if (selecteddoctype && selecteddoctype > 0) {
					$$invalidate(25, errorMsg = '');

					let detail = {
						validationMessage: errorMsg,
						docTypeError: false,
						fileUploadError: false
					};

					svelteDispatch("validationerror", detail);
				}
			}
		};

		return [
			width,
			primary,
			inputFile,
			dropZoneElement,
			promptContainer,
			uploadfiles,
			uploadfilesPrimary,
			errorMessage,
			errorMessagePrimary,
			uploadStatus,
			uploadStatusPrimary,
			progressBar,
			percent,
			completed,
			error,
			errorPrimary,
			dropHandler,
			dropZoneClickHandler,
			inputFileChangeHandler,
			reset,
			documentuploadlimitprimary,
			documentuploadlimit,
			selecteddoctype,
			loadrequestinstancekey,
			thumbnails,
			errorMsg,
			div0_binding,
			div1_binding,
			drop_handler,
			dragover_handler,
			click_handler,
			div0_binding_1,
			div1_binding_1,
			drop_handler_1,
			dragover_handler_1,
			click_handler_1,
			input_binding,
			change_handler,
			progress_binding,
			progress_binding_1
		];
	}

	class Eas_upload_control_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$r,
				create_fragment$r,
				safe_not_equal,
				{
					documentuploadlimitprimary: 20,
					documentuploadlimit: 21,
					width: 0,
					primary: 1,
					selecteddoctype: 22,
					loadrequestinstancekey: 23,
					reset: 19
				},
				add_css$q,
				[-1, -1, -1]
			);
		}

		get documentuploadlimitprimary() {
			return this.$$.ctx[20];
		}

		set documentuploadlimitprimary(documentuploadlimitprimary) {
			this.$$set({ documentuploadlimitprimary });
			flush();
		}

		get documentuploadlimit() {
			return this.$$.ctx[21];
		}

		set documentuploadlimit(documentuploadlimit) {
			this.$$set({ documentuploadlimit });
			flush();
		}

		get width() {
			return this.$$.ctx[0];
		}

		set width(width) {
			this.$$set({ width });
			flush();
		}

		get primary() {
			return this.$$.ctx[1];
		}

		set primary(primary) {
			this.$$set({ primary });
			flush();
		}

		get selecteddoctype() {
			return this.$$.ctx[22];
		}

		set selecteddoctype(selecteddoctype) {
			this.$$set({ selecteddoctype });
			flush();
		}

		get loadrequestinstancekey() {
			return this.$$.ctx[23];
		}

		set loadrequestinstancekey(loadrequestinstancekey) {
			this.$$set({ loadrequestinstancekey });
			flush();
		}

		get reset() {
			return this.$$.ctx[19];
		}

		set reset(reset) {
			this.$$set({ reset });
			flush();
		}
	}

	customElements.define("eas-upload-control", create_custom_element(Eas_upload_control_component, {"documentuploadlimitprimary":{},"documentuploadlimit":{},"width":{},"primary":{"type":"Boolean"},"selecteddoctype":{},"loadrequestinstancekey":{},"reset":{"type":"Boolean"}}, [], [], true));

	/* src\lib\web-components\validation-message\eas-validation-message.component.svelte generated by Svelte v4.2.19 */

	function add_css$p(target) {
		append_styles(target, "svelte-2kei5o", ".message-container.svelte-2kei5o{display:flex;justify-content:space-between;padding:20px;margin-bottom:20px}.blue-color.svelte-2kei5o{color:#5480A9\r\n    }.green-color.svelte-2kei5o{color:#238722}.teal-color.svelte-2kei5o{color:#5480A9}.yellow-color.svelte-2kei5o{color:#F5C044}.red-color.svelte-2kei5o{color:#DF4743}.icon.svelte-2kei5o{width:50px\r\n    }.warning.svelte-2kei5o{text-align:center}.success.svelte-2kei5o{text-align:center}.info.svelte-2kei5o{text-align:center}.error.svelte-2kei5o{text-align:center}.close.svelte-2kei5o{cursor:pointer}");
	}

	// (49:0) {#if type === 'error' && showerror}
	function create_if_block_3$4(ctx) {
		let div3;
		let div0;
		let t0;
		let div1;
		let t1;
		let t2;
		let div2;
		let mounted;
		let dispose;
		let if_block = /*linkdata*/ ctx[6].click && create_if_block_4$3(ctx);

		return {
			c() {
				div3 = element("div");
				div0 = element("div");
				div0.innerHTML = `<i class="fa fa-exclamation-circle fa-xl red-color svelte-2kei5o"></i>`;
				t0 = space();
				div1 = element("div");
				t1 = text(/*message*/ ctx[2]);
				if (if_block) if_block.c();
				t2 = space();
				div2 = element("div");
				div2.innerHTML = `<i class="fa-solid fa-xmark fa-xl red-color svelte-2kei5o"></i>`;
				attr(div0, "class", "icon svelte-2kei5o");
				attr(div1, "class", "error svelte-2kei5o");
				attr(div2, "class", "close svelte-2kei5o");
				attr(div3, "class", "message-container svelte-2kei5o");
				set_style(div3, "background-color", "#F2C6C6");
				set_style(div3, "border-left", "5px solid #DF4743");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div0);
				append(div3, t0);
				append(div3, div1);
				append(div1, t1);
				if (if_block) if_block.m(div1, null);
				append(div3, t2);
				append(div3, div2);

				if (!mounted) {
					dispose = [
						listen(div2, "click", /*click_handler_1*/ ctx[15]),
						listen(div2, "keyup", keyup_handler_1$2)
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*message*/ 4) set_data(t1, /*message*/ ctx[2]);

				if (/*linkdata*/ ctx[6].click) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_4$3(ctx);
						if_block.c();
						if_block.m(div1, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div3);
				}

				if (if_block) if_block.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (52:36) {#if linkdata.click}
	function create_if_block_4$3(ctx) {
		let a;
		let mounted;
		let dispose;

		return {
			c() {
				a = element("a");
				a.textContent = "Load Request";
				attr(a, "href", "javascript:void(0)");
			},
			m(target, anchor) {
				insert(target, a, anchor);

				if (!mounted) {
					dispose = [
						listen(a, "keyup", keyup_handler$2),
						listen(a, "click", /*click_handler*/ ctx[14])
					];

					mounted = true;
				}
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(a);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (56:0) {#if type === 'info' && showinfo}
	function create_if_block_2$8(ctx) {
		let div3;
		let div0;
		let t0;
		let div1;
		let t1;
		let t2;
		let div2;
		let mounted;
		let dispose;

		return {
			c() {
				div3 = element("div");
				div0 = element("div");
				div0.innerHTML = `<i class="fa fa-info-circle fa-xl teal-color svelte-2kei5o"></i>`;
				t0 = space();
				div1 = element("div");
				t1 = text(/*message*/ ctx[2]);
				t2 = space();
				div2 = element("div");
				div2.innerHTML = `<i class="fa-solid fa-xmark fa-xl blue-color svelte-2kei5o"></i>`;
				attr(div0, "class", "icon svelte-2kei5o");
				attr(div1, "class", "info svelte-2kei5o");
				attr(div2, "class", "close svelte-2kei5o");
				attr(div3, "class", "message-container svelte-2kei5o");
				set_style(div3, "background-color", "#add8e6");
				set_style(div3, "border-left", "5px solid #5480A9");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div0);
				append(div3, t0);
				append(div3, div1);
				append(div1, t1);
				append(div3, t2);
				append(div3, div2);

				if (!mounted) {
					dispose = [
						listen(div2, "click", /*click_handler_2*/ ctx[16]),
						listen(div2, "keyup", keyup_handler_2$1)
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*message*/ 4) set_data(t1, /*message*/ ctx[2]);
			},
			d(detaching) {
				if (detaching) {
					detach(div3);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (63:0) {#if type === 'success' && showsuccess}
	function create_if_block_1$c(ctx) {
		let div3;
		let div0;
		let t0;
		let div1;
		let t1;
		let t2;
		let div2;
		let mounted;
		let dispose;

		return {
			c() {
				div3 = element("div");
				div0 = element("div");
				div0.innerHTML = `<i class="fa fa-check-circle fa-xl green-color svelte-2kei5o"></i>`;
				t0 = space();
				div1 = element("div");
				t1 = text(/*message*/ ctx[2]);
				t2 = space();
				div2 = element("div");
				div2.innerHTML = `<i class="fa-solid fa-xmark fa-xl green-color svelte-2kei5o"></i>`;
				attr(div0, "class", "icon svelte-2kei5o");
				attr(div1, "class", "success svelte-2kei5o");
				attr(div2, "class", "close svelte-2kei5o");
				attr(div3, "class", "message-container svelte-2kei5o");
				set_style(div3, "background-color", "#d4f8d4");
				set_style(div3, "border-left", "5px solid green");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div0);
				append(div3, t0);
				append(div3, div1);
				append(div1, t1);
				append(div3, t2);
				append(div3, div2);

				if (!mounted) {
					dispose = [
						listen(div2, "click", /*click_handler_3*/ ctx[17]),
						listen(div2, "keyup", keyup_handler_3$1)
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*message*/ 4) set_data(t1, /*message*/ ctx[2]);
			},
			d(detaching) {
				if (detaching) {
					detach(div3);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (70:0) {#if type === 'warning'  && showwarning}
	function create_if_block$e(ctx) {
		let div3;
		let div0;
		let t0;
		let div1;
		let t1;
		let t2;
		let div2;
		let mounted;
		let dispose;

		return {
			c() {
				div3 = element("div");
				div0 = element("div");
				div0.innerHTML = `<i class="fa fa-exclamation-triangle fa-xl yellow-color svelte-2kei5o"></i>`;
				t0 = space();
				div1 = element("div");
				t1 = text(/*message*/ ctx[2]);
				t2 = space();
				div2 = element("div");
				div2.innerHTML = `<i class="fa-solid fa-xmark fa-xl yellow-color svelte-2kei5o"></i>`;
				attr(div0, "class", "icon svelte-2kei5o");
				attr(div1, "class", "warning svelte-2kei5o");
				attr(div2, "class", "close svelte-2kei5o");
				attr(div3, "class", "message-container svelte-2kei5o");
				set_style(div3, "background-color", "#FFFFE0");
				set_style(div3, "border-left", "5px solid yellow");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div0);
				append(div3, t0);
				append(div3, div1);
				append(div1, t1);
				append(div3, t2);
				append(div3, div2);

				if (!mounted) {
					dispose = [
						listen(div2, "click", /*click_handler_4*/ ctx[18]),
						listen(div2, "keydown", keydown_handler),
						listen(div2, "keyup", keyup_handler_4)
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*message*/ 4) set_data(t1, /*message*/ ctx[2]);
			},
			d(detaching) {
				if (detaching) {
					detach(div3);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	function create_fragment$q(ctx) {
		let link;
		let t0;
		let t1;
		let t2;
		let t3;
		let if_block3_anchor;
		let if_block0 = /*type*/ ctx[3] === 'error' && /*showerror*/ ctx[4] && create_if_block_3$4(ctx);
		let if_block1 = /*type*/ ctx[3] === 'info' && /*showinfo*/ ctx[0] && create_if_block_2$8(ctx);
		let if_block2 = /*type*/ ctx[3] === 'success' && /*showsuccess*/ ctx[1] && create_if_block_1$c(ctx);
		let if_block3 = /*type*/ ctx[3] === 'warning' && /*showwarning*/ ctx[5] && create_if_block$e(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				if (if_block0) if_block0.c();
				t1 = space();
				if (if_block1) if_block1.c();
				t2 = space();
				if (if_block2) if_block2.c();
				t3 = space();
				if (if_block3) if_block3.c();
				if_block3_anchor = empty();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t1, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, t2, anchor);
				if (if_block2) if_block2.m(target, anchor);
				insert(target, t3, anchor);
				if (if_block3) if_block3.m(target, anchor);
				insert(target, if_block3_anchor, anchor);
			},
			p(ctx, [dirty]) {
				if (/*type*/ ctx[3] === 'error' && /*showerror*/ ctx[4]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_3$4(ctx);
						if_block0.c();
						if_block0.m(t1.parentNode, t1);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*type*/ ctx[3] === 'info' && /*showinfo*/ ctx[0]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_2$8(ctx);
						if_block1.c();
						if_block1.m(t2.parentNode, t2);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*type*/ ctx[3] === 'success' && /*showsuccess*/ ctx[1]) {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_1$c(ctx);
						if_block2.c();
						if_block2.m(t3.parentNode, t3);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}

				if (/*type*/ ctx[3] === 'warning' && /*showwarning*/ ctx[5]) {
					if (if_block3) {
						if_block3.p(ctx, dirty);
					} else {
						if_block3 = create_if_block$e(ctx);
						if_block3.c();
						if_block3.m(if_block3_anchor.parentNode, if_block3_anchor);
					}
				} else if (if_block3) {
					if_block3.d(1);
					if_block3 = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(t1);
					detach(t2);
					detach(t3);
					detach(if_block3_anchor);
				}

				if (if_block0) if_block0.d(detaching);
				if (if_block1) if_block1.d(detaching);
				if (if_block2) if_block2.d(detaching);
				if (if_block3) if_block3.d(detaching);
			}
		};
	}

	const keyup_handler$2 = e => {
		
	};

	const keyup_handler_1$2 = e => {
		
	};

	const keyup_handler_2$1 = e => {
		
	};

	const keyup_handler_3$1 = e => {
		
	};

	const keydown_handler = e => {
		
	};

	const keyup_handler_4 = e => {
		
	};

	function instance$q($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { message } = $$props;
		let { type } = $$props;
		let { width = '500' } = $$props;
		let { showerror = false } = $$props;
		let { showinfo = false } = $$props;
		let { showwarning = false } = $$props;
		let { showsuccess = false } = $$props;
		let { fadeAfter10Seconds = true } = $$props;
		let { linkdata = {} } = $$props;

		function onErrorclose(e) {
			let detailData = { shouldClose: true };
			svelteDispatch("errorclose", detailData);
		}

		function onInfoclose(e) {
			let detailData = { shouldClose: true };
			svelteDispatch("infoclose", detailData);
		}

		function onSuccessclose(e) {
			let detailData = { shouldClose: true };
			svelteDispatch("successclose", detailData);
		}

		function onWarningclose(e) {
			let detailData = { shouldClose: true };
			svelteDispatch("warningclose", detailData);
		}

		function handleLinkClick(e, data) {
			let detail = { linkData: data };
			svelteDispatch("validationlinkclicked", detail);
			return false;
		}

		const click_handler = e => handleLinkClick(e, linkdata.click);
		const click_handler_1 = e => onErrorclose();
		const click_handler_2 = e => onInfoclose();
		const click_handler_3 = e => onSuccessclose();
		const click_handler_4 = e => onWarningclose();

		$$self.$$set = $$props => {
			if ('message' in $$props) $$invalidate(2, message = $$props.message);
			if ('type' in $$props) $$invalidate(3, type = $$props.type);
			if ('width' in $$props) $$invalidate(12, width = $$props.width);
			if ('showerror' in $$props) $$invalidate(4, showerror = $$props.showerror);
			if ('showinfo' in $$props) $$invalidate(0, showinfo = $$props.showinfo);
			if ('showwarning' in $$props) $$invalidate(5, showwarning = $$props.showwarning);
			if ('showsuccess' in $$props) $$invalidate(1, showsuccess = $$props.showsuccess);
			if ('fadeAfter10Seconds' in $$props) $$invalidate(13, fadeAfter10Seconds = $$props.fadeAfter10Seconds);
			if ('linkdata' in $$props) $$invalidate(6, linkdata = $$props.linkdata);
		};

		if (sessionStorage.getItem('fadeAfter10Seconds')) {
			setTimeout(
				() => {
					$$invalidate(0, showinfo = false);
					$$invalidate(1, showsuccess = false);
				},
				10000
			);
		}

		return [
			showinfo,
			showsuccess,
			message,
			type,
			showerror,
			showwarning,
			linkdata,
			onErrorclose,
			onInfoclose,
			onSuccessclose,
			onWarningclose,
			handleLinkClick,
			width,
			fadeAfter10Seconds,
			click_handler,
			click_handler_1,
			click_handler_2,
			click_handler_3,
			click_handler_4
		];
	}

	class Eas_validation_message_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$q,
				create_fragment$q,
				safe_not_equal,
				{
					message: 2,
					type: 3,
					width: 12,
					showerror: 4,
					showinfo: 0,
					showwarning: 5,
					showsuccess: 1,
					fadeAfter10Seconds: 13,
					linkdata: 6
				},
				add_css$p
			);
		}

		get message() {
			return this.$$.ctx[2];
		}

		set message(message) {
			this.$$set({ message });
			flush();
		}

		get type() {
			return this.$$.ctx[3];
		}

		set type(type) {
			this.$$set({ type });
			flush();
		}

		get width() {
			return this.$$.ctx[12];
		}

		set width(width) {
			this.$$set({ width });
			flush();
		}

		get showerror() {
			return this.$$.ctx[4];
		}

		set showerror(showerror) {
			this.$$set({ showerror });
			flush();
		}

		get showinfo() {
			return this.$$.ctx[0];
		}

		set showinfo(showinfo) {
			this.$$set({ showinfo });
			flush();
		}

		get showwarning() {
			return this.$$.ctx[5];
		}

		set showwarning(showwarning) {
			this.$$set({ showwarning });
			flush();
		}

		get showsuccess() {
			return this.$$.ctx[1];
		}

		set showsuccess(showsuccess) {
			this.$$set({ showsuccess });
			flush();
		}

		get fadeAfter10Seconds() {
			return this.$$.ctx[13];
		}

		set fadeAfter10Seconds(fadeAfter10Seconds) {
			this.$$set({ fadeAfter10Seconds });
			flush();
		}

		get linkdata() {
			return this.$$.ctx[6];
		}

		set linkdata(linkdata) {
			this.$$set({ linkdata });
			flush();
		}
	}

	customElements.define("eas-validation-message", create_custom_element(Eas_validation_message_component, {"message":{},"type":{},"width":{},"showerror":{"type":"Boolean"},"showinfo":{"type":"Boolean"},"showwarning":{"type":"Boolean"},"showsuccess":{"type":"Boolean"},"fadeAfter10Seconds":{"type":"Boolean"},"linkdata":{}}, [], [], true));

	/* src\lib\web-components\dialog\eas-dialog.component.svelte generated by Svelte v4.2.19 */

	function add_css$o(target) {
		append_styles(target, "svelte-ox4ceq", ".cancel.svelte-ox4ceq.svelte-ox4ceq{padding:10px;margin:10px;border-radius:50px;color:red;font-size:18px;width:100px;text-align:center;cursor:pointer;border:3px solid #EA1014}.cancel.svelte-ox4ceq.svelte-ox4ceq:focus,.cancel.svelte-ox4ceq.svelte-ox4ceq:hover{border-radius:50px;text-align:center;cursor:pointer;margin:10px;border:3px solid #EA1014;background:#EA1014;color:white}.submit.svelte-ox4ceq.svelte-ox4ceq{padding:10px;margin:10px;border-radius:50px;color:white;background:black;font-size:18px;width:100px;text-align:center;cursor:pointer;border:3px solid black}.submit.svelte-ox4ceq.svelte-ox4ceq:focus,.submit.svelte-ox4ceq.svelte-ox4ceq:hover{border-radius:50px;text-align:center;cursor:pointer;margin:10px;border:3px solid #0674ab;background:#0674ab;color:white}.open.svelte-ox4ceq.svelte-ox4ceq{opacity:1;pointer-events:all}.close.svelte-ox4ceq.svelte-ox4ceq{opacity:0;pointer-events:none}#actions.svelte-ox4ceq.svelte-ox4ceq{border-top:1px solid #ccc;padding:1rem;display:flex;justify-content:flex-end}header.svelte-ox4ceq.svelte-ox4ceq{padding:1 rem}header.svelte-ox4ceq h1.svelte-ox4ceq{text-align:center;font-size:20px}.backdrop.svelte-ox4ceq.svelte-ox4ceq{position:fixed;top:0;left:0;width:100%;height:100vh;background:rgba(0,0,0,0.75);z-index:10;opacity:0;pointer-events:none}#main.svelte-ox4ceq.svelte-ox4ceq{padding:1rem;font-size:18px;text-align:center}.modal.svelte-ox4ceq.svelte-ox4ceq{position:fixed;top:15vh;left:25%;width:50%;z-index:100;background:white;border-radius:5px;box-shadow:0 2px 8px rgba(0,0,0,0.26);display:flex;flex-direction:column;justify-content:space-between;pointer-events:auto;max-height:500px;font-family:'Source Sans Pro', sans-serif}");
	}

	const get_dialogcontent_slot_changes = dirty => ({});
	const get_dialogcontent_slot_context = ctx => ({});

	// (29:0) {#if open}
	function create_if_block$d(ctx) {
		let div0;
		let t0;
		let div0_class_value;
		let t1;
		let div2;
		let header;
		let h1;
		let t2;
		let t3;
		let section0;
		let t4;
		let section1;
		let div1;
		let t5;
		let t6;
		let div2_class_value;
		let current;
		let mounted;
		let dispose;
		const dialogcontent_slot_template = /*#slots*/ ctx[8].dialogcontent;
		const dialogcontent_slot = create_slot(dialogcontent_slot_template, ctx, /*$$scope*/ ctx[7], get_dialogcontent_slot_context);
		let if_block = !/*shouldhideok*/ ctx[2] && create_if_block_1$b(ctx);

		return {
			c() {
				div0 = element("div");
				t0 = text("This is dialog");
				t1 = space();
				div2 = element("div");
				header = element("header");
				h1 = element("h1");
				t2 = text(/*heading*/ ctx[1]);
				t3 = space();
				section0 = element("section");
				if (dialogcontent_slot) dialogcontent_slot.c();
				t4 = space();
				section1 = element("section");
				div1 = element("div");
				t5 = text(/*canceltext*/ ctx[3]);
				t6 = space();
				if (if_block) if_block.c();
				attr(div0, "class", div0_class_value = "backdrop " + (/*open*/ ctx[0] ? 'open' : 'close') + " svelte-ox4ceq");
				attr(h1, "class", "svelte-ox4ceq");
				attr(header, "class", "svelte-ox4ceq");
				attr(section0, "id", "main");
				attr(section0, "class", "svelte-ox4ceq");
				attr(div1, "class", "cancel svelte-ox4ceq");
				attr(section1, "id", "actions");
				attr(section1, "class", "svelte-ox4ceq");
				attr(div2, "class", div2_class_value = "modal " + (/*open*/ ctx[0] ? 'open' : 'close') + " svelte-ox4ceq");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				append(div0, t0);
				insert(target, t1, anchor);
				insert(target, div2, anchor);
				append(div2, header);
				append(header, h1);
				append(h1, t2);
				append(div2, t3);
				append(div2, section0);

				if (dialogcontent_slot) {
					dialogcontent_slot.m(section0, null);
				}

				append(div2, t4);
				append(div2, section1);
				append(section1, div1);
				append(div1, t5);
				append(section1, t6);
				if (if_block) if_block.m(section1, null);
				current = true;

				if (!mounted) {
					dispose = [
						listen(div1, "keyup", keyup_handler$1),
						listen(div1, "click", /*click_handler*/ ctx[9])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (!current || dirty & /*open*/ 1 && div0_class_value !== (div0_class_value = "backdrop " + (/*open*/ ctx[0] ? 'open' : 'close') + " svelte-ox4ceq")) {
					attr(div0, "class", div0_class_value);
				}

				if (!current || dirty & /*heading*/ 2) set_data(t2, /*heading*/ ctx[1]);

				if (dialogcontent_slot) {
					if (dialogcontent_slot.p && (!current || dirty & /*$$scope*/ 128)) {
						update_slot_base(
							dialogcontent_slot,
							dialogcontent_slot_template,
							ctx,
							/*$$scope*/ ctx[7],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[7])
							: get_slot_changes(dialogcontent_slot_template, /*$$scope*/ ctx[7], dirty, get_dialogcontent_slot_changes),
							get_dialogcontent_slot_context
						);
					}
				}

				if (!current || dirty & /*canceltext*/ 8) set_data(t5, /*canceltext*/ ctx[3]);

				if (!/*shouldhideok*/ ctx[2]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_1$b(ctx);
						if_block.c();
						if_block.m(section1, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}

				if (!current || dirty & /*open*/ 1 && div2_class_value !== (div2_class_value = "modal " + (/*open*/ ctx[0] ? 'open' : 'close') + " svelte-ox4ceq")) {
					attr(div2, "class", div2_class_value);
				}
			},
			i(local) {
				if (current) return;
				transition_in(dialogcontent_slot, local);
				current = true;
			},
			o(local) {
				transition_out(dialogcontent_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(div0);
					detach(t1);
					detach(div2);
				}

				if (dialogcontent_slot) dialogcontent_slot.d(detaching);
				if (if_block) if_block.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (41:8) {#if !shouldhideok}
	function create_if_block_1$b(ctx) {
		let div;
		let t;
		let mounted;
		let dispose;

		return {
			c() {
				div = element("div");
				t = text(/*oktext*/ ctx[4]);
				attr(div, "class", "submit svelte-ox4ceq");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t);

				if (!mounted) {
					dispose = [
						listen(div, "keyup", keyup_handler_1$1),
						listen(div, "click", /*click_handler_1*/ ctx[10])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*oktext*/ 16) set_data(t, /*oktext*/ ctx[4]);
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	function create_fragment$p(ctx) {
		let script;
		let script_src_value;
		let t;
		let if_block_anchor;
		let current;
		let if_block = /*open*/ ctx[0] && create_if_block$d(ctx);

		return {
			c() {
				script = element("script");
				script.innerHTML = ``;
				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty();
				if (!src_url_equal(script.src, script_src_value = "https://kit.fontawesome.com/a5cccf28a6.js")) attr(script, "src", script_src_value);
				attr(script, "crossorigin", "anonymous");
			},
			m(target, anchor) {
				append(document.head, script);
				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				if (/*open*/ ctx[0]) {
					if (if_block) {
						if_block.p(ctx, dirty);

						if (dirty & /*open*/ 1) {
							transition_in(if_block, 1);
						}
					} else {
						if_block = create_if_block$d(ctx);
						if_block.c();
						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					group_outros();

					transition_out(if_block, 1, 1, () => {
						if_block = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(t);
					detach(if_block_anchor);
				}

				detach(script);
				if (if_block) if_block.d(detaching);
			}
		};
	}

	const keyup_handler$1 = e => {
		
	};

	const keyup_handler_1$1 = e => {
		
	};

	function instance$p($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		let { heading = 'Please specify heading' } = $$props;
		let { open = false } = $$props;
		let { shouldhideok = false } = $$props;
		let { canceltext = 'Cancel' } = $$props;
		let { oktext = 'Ok' } = $$props;
		const svelteDispatch = createEventDispatcher();

		function onCancelClick(e) {
			$$invalidate(0, open = false);
			svelteDispatch("cancelclick", {});
		}

		function onOKClick(e) {
			$$invalidate(0, open = false);
			e.stopPropagation();
			svelteDispatch("submitclick", {});
		}

		const click_handler = e => onCancelClick();
		const click_handler_1 = e => onOKClick(e);

		$$self.$$set = $$props => {
			if ('heading' in $$props) $$invalidate(1, heading = $$props.heading);
			if ('open' in $$props) $$invalidate(0, open = $$props.open);
			if ('shouldhideok' in $$props) $$invalidate(2, shouldhideok = $$props.shouldhideok);
			if ('canceltext' in $$props) $$invalidate(3, canceltext = $$props.canceltext);
			if ('oktext' in $$props) $$invalidate(4, oktext = $$props.oktext);
			if ('$$scope' in $$props) $$invalidate(7, $$scope = $$props.$$scope);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*heading*/ 2) {
				console.log('heading ', heading);
			}

			if ($$self.$$.dirty & /*open*/ 1) {
				console.log('open ', open);
			}

			if ($$self.$$.dirty & /*shouldhideok*/ 4) {
				console.log('shouldhideok ', shouldhideok);
			}

			if ($$self.$$.dirty & /*canceltext*/ 8) {
				console.log('canceltext ', canceltext);
			}

			if ($$self.$$.dirty & /*oktext*/ 16) {
				console.log('oktext ', oktext);
			}
		};

		console.log('----------EAS Svelte Dialog Cmmponent---------');

		return [
			open,
			heading,
			shouldhideok,
			canceltext,
			oktext,
			onCancelClick,
			onOKClick,
			$$scope,
			slots,
			click_handler,
			click_handler_1
		];
	}

	class Eas_dialog_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$p,
				create_fragment$p,
				safe_not_equal,
				{
					heading: 1,
					open: 0,
					shouldhideok: 2,
					canceltext: 3,
					oktext: 4
				},
				add_css$o
			);
		}

		get heading() {
			return this.$$.ctx[1];
		}

		set heading(heading) {
			this.$$set({ heading });
			flush();
		}

		get open() {
			return this.$$.ctx[0];
		}

		set open(open) {
			this.$$set({ open });
			flush();
		}

		get shouldhideok() {
			return this.$$.ctx[2];
		}

		set shouldhideok(shouldhideok) {
			this.$$set({ shouldhideok });
			flush();
		}

		get canceltext() {
			return this.$$.ctx[3];
		}

		set canceltext(canceltext) {
			this.$$set({ canceltext });
			flush();
		}

		get oktext() {
			return this.$$.ctx[4];
		}

		set oktext(oktext) {
			this.$$set({ oktext });
			flush();
		}
	}

	customElements.define("eas-dialog", create_custom_element(Eas_dialog_component, {"heading":{},"open":{"type":"Boolean"},"shouldhideok":{"type":"Boolean"},"canceltext":{},"oktext":{}}, ["dialogcontent"], [], true));

	/* src\lib\web-components\eas-application-container-desktop\eas-application-container-desktop.svelte generated by Svelte v4.2.19 */

	function add_css$n(target) {
		append_styles(target, "svelte-11i57yb", ".svelte-11i57yb{margin:0;padding:0;box-sizing:border-box}.svelte-11i57yb::-webkit-scrollbar{width:10px}.svelte-11i57yb::-webkit-scrollbar-track{background:#f1f1f1}.svelte-11i57yb::-webkit-scrollbar-thumb{background:#888}.svelte-11i57yb::-webkit-scrollbar-thumb:hover{background:#555}.container.svelte-11i57yb{display:flex;flex-direction:column}.header.svelte-11i57yb{box-shadow:0px 6px 4px 0px rgba(0, 0, 0, 0.31);margin-bottom:8px}.main.svelte-11i57yb{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:start;align-items:stretch;overflow:hidden;width:100%;height:100%}.left-container.svelte-11i57yb{flex:1 1 auto;order:0;display:flex}.right-container.svelte-11i57yb{flex:1 1 auto;order:2\r\n        }.side-close.svelte-11i57yb{display:none;width:0\r\n        }.side-open.svelte-11i57yb{display:flex;width:16vw\r\n        }.side.svelte-11i57yb{height:88vh;border-right-color:rgb(0, 0, 0);border-right-width:1px;border-right-style:solid;width:16vw\r\n        }.content-container.svelte-11i57yb{flex-direction:column;justify-content:center;align-items:center;height:88vh;overflow-y:scroll;flex:1 1 auto}.footer.svelte-11i57yb{justify-content:center;align-items:center}.utility-container-close.svelte-11i57yb{display:none}.drag-bar-close.svelte-11i57yb{display:none}.drag-bar-open.svelte-11i57yb{display:flex;width:11px}.utility-container.svelte-11i57yb{justify-content:center;align-items:center;width:30vw;height:88vh;overflow-y:scroll}.utility-toolbar-close.svelte-11i57yb{display:none!important}.utility-toolbar-open.svelte-11i57yb{display:flex}.utility-toolbar.svelte-11i57yb{display:flex;height:88vh;flex-direction:column;order:3}.drag-bar.svelte-11i57yb{background-color:#a1a1a1;cursor:col-resize;order:1;align-items:center;justify-content:center;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==);background-repeat:no-repeat;background-position:center center}");
	}

	const get_utilitytoolbar_slot_changes$1 = dirty => ({});
	const get_utilitytoolbar_slot_context$1 = ctx => ({});
	const get_utilitycontainer_slot_changes$1 = dirty => ({});
	const get_utilitycontainer_slot_context$1 = ctx => ({});
	const get_footer_slot_changes$1 = dirty => ({});
	const get_footer_slot_context$1 = ctx => ({});
	const get_content_slot_changes$1 = dirty => ({});
	const get_content_slot_context$1 = ctx => ({});
	const get_side_slot_changes$1 = dirty => ({});
	const get_side_slot_context$1 = ctx => ({});
	const get_header_slot_changes$1 = dirty => ({});
	const get_header_slot_context$1 = ctx => ({});

	function create_fragment$o(ctx) {
		let div11;
		let div0;
		let t0;
		let div10;
		let div5;
		let div1;
		let div1_class_value;
		let t1;
		let div4;
		let div2;
		let t2;
		let div3;
		let t3;
		let div7;
		let div6;
		let div7_class_value;
		let t4;
		let div8;
		let div8_class_value;
		let t5;
		let div9;
		let div9_class_value;
		let current;
		const header_slot_template = /*#slots*/ ctx[10].header;
		const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[9], get_header_slot_context$1);
		const side_slot_template = /*#slots*/ ctx[10].side;
		const side_slot = create_slot(side_slot_template, ctx, /*$$scope*/ ctx[9], get_side_slot_context$1);
		const content_slot_template = /*#slots*/ ctx[10].content;
		const content_slot = create_slot(content_slot_template, ctx, /*$$scope*/ ctx[9], get_content_slot_context$1);
		const footer_slot_template = /*#slots*/ ctx[10].footer;
		const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[9], get_footer_slot_context$1);
		const utilitycontainer_slot_template = /*#slots*/ ctx[10].utilitycontainer;
		const utilitycontainer_slot = create_slot(utilitycontainer_slot_template, ctx, /*$$scope*/ ctx[9], get_utilitycontainer_slot_context$1);
		const utilitytoolbar_slot_template = /*#slots*/ ctx[10].utilitytoolbar;
		const utilitytoolbar_slot = create_slot(utilitytoolbar_slot_template, ctx, /*$$scope*/ ctx[9], get_utilitytoolbar_slot_context$1);

		return {
			c() {
				div11 = element("div");
				div0 = element("div");
				if (header_slot) header_slot.c();
				t0 = space();
				div10 = element("div");
				div5 = element("div");
				div1 = element("div");
				if (side_slot) side_slot.c();
				t1 = space();
				div4 = element("div");
				div2 = element("div");
				if (content_slot) content_slot.c();
				t2 = space();
				div3 = element("div");
				if (footer_slot) footer_slot.c();
				t3 = space();
				div7 = element("div");
				div6 = element("div");
				if (utilitycontainer_slot) utilitycontainer_slot.c();
				t4 = space();
				div8 = element("div");
				if (utilitytoolbar_slot) utilitytoolbar_slot.c();
				t5 = space();
				div9 = element("div");
				attr(div0, "class", "header svelte-11i57yb");
				attr(div1, "class", div1_class_value = "side " + (/*sideclose*/ ctx[1] ? 'side-close' : 'side-open') + " svelte-11i57yb");
				attr(div2, "class", "content svelte-11i57yb");
				attr(div3, "class", "footer svelte-11i57yb");
				attr(div4, "id", "contentContainer");
				attr(div4, "class", "content-container svelte-11i57yb");
				attr(div5, "class", "left-container svelte-11i57yb");
				attr(div6, "id", "utilityContainer");
				attr(div6, "class", "svelte-11i57yb");

				attr(div7, "class", div7_class_value = "right-container utility-container " + (/*utilitycontainerclose*/ ctx[0]
				? 'utility-container-close'
				: 'utility-container-open') + " svelte-11i57yb");

				attr(div8, "class", div8_class_value = "utility-toolbar " + (/*displayUtilityBar*/ ctx[2]
				? 'utility-toolbar-open'
				: 'utility-toolbar-close') + " svelte-11i57yb");

				attr(div9, "id", "dragBar");

				attr(div9, "class", div9_class_value = "drag-bar " + (/*utilitycontainerclose*/ ctx[0]
				? 'drag-bar-close'
				: 'drag-bar-open') + " svelte-11i57yb");

				attr(div10, "class", "main svelte-11i57yb");
				attr(div11, "class", "container svelte-11i57yb");
			},
			m(target, anchor) {
				insert(target, div11, anchor);
				append(div11, div0);

				if (header_slot) {
					header_slot.m(div0, null);
				}

				append(div11, t0);
				append(div11, div10);
				append(div10, div5);
				append(div5, div1);

				if (side_slot) {
					side_slot.m(div1, null);
				}

				/*div1_binding*/ ctx[11](div1);
				append(div5, t1);
				append(div5, div4);
				append(div4, div2);

				if (content_slot) {
					content_slot.m(div2, null);
				}

				append(div4, t2);
				append(div4, div3);

				if (footer_slot) {
					footer_slot.m(div3, null);
				}

				/*div5_binding*/ ctx[12](div5);
				append(div10, t3);
				append(div10, div7);
				append(div7, div6);

				if (utilitycontainer_slot) {
					utilitycontainer_slot.m(div6, null);
				}

				/*div7_binding*/ ctx[13](div7);
				append(div10, t4);
				append(div10, div8);

				if (utilitytoolbar_slot) {
					utilitytoolbar_slot.m(div8, null);
				}

				append(div10, t5);
				append(div10, div9);
				/*div9_binding*/ ctx[14](div9);
				/*div11_binding*/ ctx[15](div11);
				current = true;
			},
			p(ctx, [dirty]) {
				if (header_slot) {
					if (header_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							header_slot,
							header_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(header_slot_template, /*$$scope*/ ctx[9], dirty, get_header_slot_changes$1),
							get_header_slot_context$1
						);
					}
				}

				if (side_slot) {
					if (side_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							side_slot,
							side_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(side_slot_template, /*$$scope*/ ctx[9], dirty, get_side_slot_changes$1),
							get_side_slot_context$1
						);
					}
				}

				if (!current || dirty & /*sideclose*/ 2 && div1_class_value !== (div1_class_value = "side " + (/*sideclose*/ ctx[1] ? 'side-close' : 'side-open') + " svelte-11i57yb")) {
					attr(div1, "class", div1_class_value);
				}

				if (content_slot) {
					if (content_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							content_slot,
							content_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(content_slot_template, /*$$scope*/ ctx[9], dirty, get_content_slot_changes$1),
							get_content_slot_context$1
						);
					}
				}

				if (footer_slot) {
					if (footer_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							footer_slot,
							footer_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(footer_slot_template, /*$$scope*/ ctx[9], dirty, get_footer_slot_changes$1),
							get_footer_slot_context$1
						);
					}
				}

				if (utilitycontainer_slot) {
					if (utilitycontainer_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							utilitycontainer_slot,
							utilitycontainer_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(utilitycontainer_slot_template, /*$$scope*/ ctx[9], dirty, get_utilitycontainer_slot_changes$1),
							get_utilitycontainer_slot_context$1
						);
					}
				}

				if (!current || dirty & /*utilitycontainerclose*/ 1 && div7_class_value !== (div7_class_value = "right-container utility-container " + (/*utilitycontainerclose*/ ctx[0]
				? 'utility-container-close'
				: 'utility-container-open') + " svelte-11i57yb")) {
					attr(div7, "class", div7_class_value);
				}

				if (utilitytoolbar_slot) {
					if (utilitytoolbar_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							utilitytoolbar_slot,
							utilitytoolbar_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(utilitytoolbar_slot_template, /*$$scope*/ ctx[9], dirty, get_utilitytoolbar_slot_changes$1),
							get_utilitytoolbar_slot_context$1
						);
					}
				}

				if (!current || dirty & /*displayUtilityBar*/ 4 && div8_class_value !== (div8_class_value = "utility-toolbar " + (/*displayUtilityBar*/ ctx[2]
				? 'utility-toolbar-open'
				: 'utility-toolbar-close') + " svelte-11i57yb")) {
					attr(div8, "class", div8_class_value);
				}

				if (!current || dirty & /*utilitycontainerclose*/ 1 && div9_class_value !== (div9_class_value = "drag-bar " + (/*utilitycontainerclose*/ ctx[0]
				? 'drag-bar-close'
				: 'drag-bar-open') + " svelte-11i57yb")) {
					attr(div9, "class", div9_class_value);
				}
			},
			i(local) {
				if (current) return;
				transition_in(header_slot, local);
				transition_in(side_slot, local);
				transition_in(content_slot, local);
				transition_in(footer_slot, local);
				transition_in(utilitycontainer_slot, local);
				transition_in(utilitytoolbar_slot, local);
				current = true;
			},
			o(local) {
				transition_out(header_slot, local);
				transition_out(side_slot, local);
				transition_out(content_slot, local);
				transition_out(footer_slot, local);
				transition_out(utilitycontainer_slot, local);
				transition_out(utilitytoolbar_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(div11);
				}

				if (header_slot) header_slot.d(detaching);
				if (side_slot) side_slot.d(detaching);
				/*div1_binding*/ ctx[11](null);
				if (content_slot) content_slot.d(detaching);
				if (footer_slot) footer_slot.d(detaching);
				/*div5_binding*/ ctx[12](null);
				if (utilitycontainer_slot) utilitycontainer_slot.d(detaching);
				/*div7_binding*/ ctx[13](null);
				if (utilitytoolbar_slot) utilitytoolbar_slot.d(detaching);
				/*div9_binding*/ ctx[14](null);
				/*div11_binding*/ ctx[15](null);
			}
		};
	}

	function instance$o($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		let { utilitycontainerclose = true } = $$props;
		let { sideclose = false } = $$props;
		let { displayUtilityBar = true } = $$props;
		let { sideContainer = true } = $$props;
		let dragBar;
		let contentContainer;
		let sideMenuContainer;
		let utilityContainer;
		let mainContainer;
		let isDragbarDragging = false;
		let dragbarOffsetWidth = 0;

		onMount(async () => {
			$$invalidate(4, contentContainer.style.width = '100%', contentContainer);

			dragBar.addEventListener('mousedown', function (e) {
				if (e.target.id === 'dragBar') {
					isDragbarDragging = true;
					dragbarOffsetWidth = e.clientX;
				}
			});

			document.addEventListener('mousemove', function (e) {
				if (!isDragbarDragging) {
					return false;
				}

				var pointerRelativeXpos = dragbarOffsetWidth - e.clientX > 0
				? dragbarOffsetWidth - e.clientX
				: e.clientX - dragbarOffsetWidth;

				$$invalidate(
					4,
					contentContainer.style.width = sideclose
					? (dragbarOffsetWidth - e.clientX > 0
						? dragbarOffsetWidth - pointerRelativeXpos
						: dragbarOffsetWidth + pointerRelativeXpos) + 'px'
					: (dragbarOffsetWidth - e.clientX > 0
						? dragbarOffsetWidth - pointerRelativeXpos
						: dragbarOffsetWidth + pointerRelativeXpos) - sideMenuContainer.offsetWidth + 'px',
					contentContainer
				);
			});

			document.addEventListener('mouseup', function (e) {
				isDragbarDragging = false;
			});
		});

		function div1_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				sideMenuContainer = $$value;
				$$invalidate(5, sideMenuContainer);
			});
		}

		function div5_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				contentContainer = $$value;
				$$invalidate(4, contentContainer);
			});
		}

		function div7_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				utilityContainer = $$value;
				$$invalidate(6, utilityContainer);
			});
		}

		function div9_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				dragBar = $$value;
				$$invalidate(3, dragBar);
			});
		}

		function div11_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				mainContainer = $$value;
				$$invalidate(7, mainContainer);
			});
		}

		$$self.$$set = $$props => {
			if ('utilitycontainerclose' in $$props) $$invalidate(0, utilitycontainerclose = $$props.utilitycontainerclose);
			if ('sideclose' in $$props) $$invalidate(1, sideclose = $$props.sideclose);
			if ('displayUtilityBar' in $$props) $$invalidate(2, displayUtilityBar = $$props.displayUtilityBar);
			if ('sideContainer' in $$props) $$invalidate(8, sideContainer = $$props.sideContainer);
			if ('$$scope' in $$props) $$invalidate(9, $$scope = $$props.$$scope);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*utilitycontainerclose*/ 1) {
				console.log('utilitycontainerclose ', utilitycontainerclose);
			}

			if ($$self.$$.dirty & /*sideclose*/ 2) {
				console.log('sideclose ', sideclose);
			}
		};

		console.log('----------EAS Svelte Application Container Cmmponent---------');

		return [
			utilitycontainerclose,
			sideclose,
			displayUtilityBar,
			dragBar,
			contentContainer,
			sideMenuContainer,
			utilityContainer,
			mainContainer,
			sideContainer,
			$$scope,
			slots,
			div1_binding,
			div5_binding,
			div7_binding,
			div9_binding,
			div11_binding
		];
	}

	class Eas_application_container_desktop extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$o,
				create_fragment$o,
				safe_not_equal,
				{
					utilitycontainerclose: 0,
					sideclose: 1,
					displayUtilityBar: 2,
					sideContainer: 8
				},
				add_css$n
			);
		}

		get utilitycontainerclose() {
			return this.$$.ctx[0];
		}

		set utilitycontainerclose(utilitycontainerclose) {
			this.$$set({ utilitycontainerclose });
			flush();
		}

		get sideclose() {
			return this.$$.ctx[1];
		}

		set sideclose(sideclose) {
			this.$$set({ sideclose });
			flush();
		}

		get displayUtilityBar() {
			return this.$$.ctx[2];
		}

		set displayUtilityBar(displayUtilityBar) {
			this.$$set({ displayUtilityBar });
			flush();
		}

		get sideContainer() {
			return this.$$.ctx[8];
		}

		set sideContainer(sideContainer) {
			this.$$set({ sideContainer });
			flush();
		}
	}

	customElements.define("eas-application-container-desktop-swc", create_custom_element(Eas_application_container_desktop, {"utilitycontainerclose":{"type":"Boolean"},"sideclose":{"type":"Boolean"},"displayUtilityBar":{"type":"Boolean"},"sideContainer":{"type":"Boolean"}}, ["header","side","content","footer","utilitycontainer","utilitytoolbar"], [], true));

	/* src\lib\web-components\eas-application-container-desktop-iop\eas-application-container-desktop-iop.svelte generated by Svelte v4.2.19 */

	function add_css$m(target) {
		append_styles(target, "svelte-1u8231b", ".svelte-1u8231b{margin:0;padding:0;box-sizing:border-box}.svelte-1u8231b::-webkit-scrollbar{width:10px}.svelte-1u8231b::-webkit-scrollbar-track{background:#f1f1f1}.svelte-1u8231b::-webkit-scrollbar-thumb{background:#888}.svelte-1u8231b::-webkit-scrollbar-thumb:hover{background:#555}.container.svelte-1u8231b{display:flex;flex-direction:column}.header.svelte-1u8231b{box-shadow:0px 6px 4px 0px rgba(0, 0, 0, 0.31);margin-bottom:8px}.main.svelte-1u8231b{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:start;align-items:stretch;overflow:hidden;width:100%;height:100%}.left-container.svelte-1u8231b{flex:1 1 auto;order:0;display:flex}.right-container.svelte-1u8231b{flex:1 1 auto;order:2\r\n        }.side-close.svelte-1u8231b{display:none;width:0\r\n        }.side-open.svelte-1u8231b{display:flex;width:16vw\r\n        }.side.svelte-1u8231b{height:88vh;border-right-color:rgb(0, 0, 0);border-right-width:1px;border-right-style:solid;width:16vw\r\n        }.content-container.svelte-1u8231b{flex-direction:column;justify-content:center;align-items:center;height:88vh;overflow-y:scroll;flex:1 1 auto}.footer.svelte-1u8231b{justify-content:center;align-items:center}.utility-container-close.svelte-1u8231b{display:none}.drag-bar-close.svelte-1u8231b{display:none}.drag-bar-open.svelte-1u8231b{display:flex;width:11px}.utility-container.svelte-1u8231b{justify-content:center;align-items:center;width:30vw;height:88vh}.utility-toolbar-close.svelte-1u8231b{display:none!important}.utility-toolbar-open.svelte-1u8231b{display:flex}.utility-toolbar.svelte-1u8231b{display:flex;height:88vh;flex-direction:column;order:3}.drag-bar.svelte-1u8231b{background-color:#a1a1a1;cursor:col-resize;order:1;align-items:center;justify-content:center;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==);background-repeat:no-repeat;background-position:center center}");
	}

	const get_utilitytoolbar_slot_changes = dirty => ({});
	const get_utilitytoolbar_slot_context = ctx => ({});
	const get_utilitycontainer_slot_changes = dirty => ({});
	const get_utilitycontainer_slot_context = ctx => ({});
	const get_footer_slot_changes = dirty => ({});
	const get_footer_slot_context = ctx => ({});
	const get_content_slot_changes = dirty => ({});
	const get_content_slot_context = ctx => ({});
	const get_side_slot_changes = dirty => ({});
	const get_side_slot_context = ctx => ({});
	const get_header_slot_changes = dirty => ({});
	const get_header_slot_context = ctx => ({});

	function create_fragment$n(ctx) {
		let div11;
		let div0;
		let t0;
		let div10;
		let div5;
		let div1;
		let div1_class_value;
		let t1;
		let div4;
		let div2;
		let t2;
		let div3;
		let t3;
		let div7;
		let div6;
		let div7_class_value;
		let t4;
		let div8;
		let div8_class_value;
		let t5;
		let div9;
		let div9_class_value;
		let current;
		const header_slot_template = /*#slots*/ ctx[11].header;
		const header_slot = create_slot(header_slot_template, ctx, /*$$scope*/ ctx[10], get_header_slot_context);
		const side_slot_template = /*#slots*/ ctx[11].side;
		const side_slot = create_slot(side_slot_template, ctx, /*$$scope*/ ctx[10], get_side_slot_context);
		const content_slot_template = /*#slots*/ ctx[11].content;
		const content_slot = create_slot(content_slot_template, ctx, /*$$scope*/ ctx[10], get_content_slot_context);
		const footer_slot_template = /*#slots*/ ctx[11].footer;
		const footer_slot = create_slot(footer_slot_template, ctx, /*$$scope*/ ctx[10], get_footer_slot_context);
		const utilitycontainer_slot_template = /*#slots*/ ctx[11].utilitycontainer;
		const utilitycontainer_slot = create_slot(utilitycontainer_slot_template, ctx, /*$$scope*/ ctx[10], get_utilitycontainer_slot_context);
		const utilitytoolbar_slot_template = /*#slots*/ ctx[11].utilitytoolbar;
		const utilitytoolbar_slot = create_slot(utilitytoolbar_slot_template, ctx, /*$$scope*/ ctx[10], get_utilitytoolbar_slot_context);

		return {
			c() {
				div11 = element("div");
				div0 = element("div");
				if (header_slot) header_slot.c();
				t0 = space();
				div10 = element("div");
				div5 = element("div");
				div1 = element("div");
				if (side_slot) side_slot.c();
				t1 = space();
				div4 = element("div");
				div2 = element("div");
				if (content_slot) content_slot.c();
				t2 = space();
				div3 = element("div");
				if (footer_slot) footer_slot.c();
				t3 = space();
				div7 = element("div");
				div6 = element("div");
				if (utilitycontainer_slot) utilitycontainer_slot.c();
				t4 = space();
				div8 = element("div");
				if (utilitytoolbar_slot) utilitytoolbar_slot.c();
				t5 = space();
				div9 = element("div");
				attr(div0, "class", "header svelte-1u8231b");
				attr(div1, "class", div1_class_value = "side " + (/*sideclose*/ ctx[1] ? 'side-close' : 'side-open') + " svelte-1u8231b");
				attr(div2, "class", "content svelte-1u8231b");
				attr(div3, "class", "footer svelte-1u8231b");
				attr(div4, "id", "contentContainer");
				attr(div4, "class", "content-container svelte-1u8231b");
				attr(div5, "class", "left-container svelte-1u8231b");
				attr(div6, "id", "utilityContainer");
				attr(div6, "class", "svelte-1u8231b");
				attr(div7, "style", /*customUtilityContainer*/ ctx[3]);

				attr(div7, "class", div7_class_value = "right-container utility-container " + (/*utilitycontainerclose*/ ctx[0]
				? 'utility-container-close'
				: 'utility-container-open') + " svelte-1u8231b");

				attr(div8, "class", div8_class_value = "utility-toolbar " + (/*displayUtilityBar*/ ctx[2]
				? 'utility-toolbar-open'
				: 'utility-toolbar-close') + " svelte-1u8231b");

				attr(div9, "id", "dragBar");

				attr(div9, "class", div9_class_value = "drag-bar " + (/*utilitycontainerclose*/ ctx[0]
				? 'drag-bar-close'
				: 'drag-bar-open') + " svelte-1u8231b");

				attr(div10, "class", "main svelte-1u8231b");
				attr(div11, "class", "container svelte-1u8231b");
			},
			m(target, anchor) {
				insert(target, div11, anchor);
				append(div11, div0);

				if (header_slot) {
					header_slot.m(div0, null);
				}

				append(div11, t0);
				append(div11, div10);
				append(div10, div5);
				append(div5, div1);

				if (side_slot) {
					side_slot.m(div1, null);
				}

				/*div1_binding*/ ctx[12](div1);
				append(div5, t1);
				append(div5, div4);
				append(div4, div2);

				if (content_slot) {
					content_slot.m(div2, null);
				}

				append(div4, t2);
				append(div4, div3);

				if (footer_slot) {
					footer_slot.m(div3, null);
				}

				/*div5_binding*/ ctx[13](div5);
				append(div10, t3);
				append(div10, div7);
				append(div7, div6);

				if (utilitycontainer_slot) {
					utilitycontainer_slot.m(div6, null);
				}

				/*div7_binding*/ ctx[14](div7);
				append(div10, t4);
				append(div10, div8);

				if (utilitytoolbar_slot) {
					utilitytoolbar_slot.m(div8, null);
				}

				append(div10, t5);
				append(div10, div9);
				/*div9_binding*/ ctx[15](div9);
				/*div11_binding*/ ctx[16](div11);
				current = true;
			},
			p(ctx, [dirty]) {
				if (header_slot) {
					if (header_slot.p && (!current || dirty & /*$$scope*/ 1024)) {
						update_slot_base(
							header_slot,
							header_slot_template,
							ctx,
							/*$$scope*/ ctx[10],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[10])
							: get_slot_changes(header_slot_template, /*$$scope*/ ctx[10], dirty, get_header_slot_changes),
							get_header_slot_context
						);
					}
				}

				if (side_slot) {
					if (side_slot.p && (!current || dirty & /*$$scope*/ 1024)) {
						update_slot_base(
							side_slot,
							side_slot_template,
							ctx,
							/*$$scope*/ ctx[10],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[10])
							: get_slot_changes(side_slot_template, /*$$scope*/ ctx[10], dirty, get_side_slot_changes),
							get_side_slot_context
						);
					}
				}

				if (!current || dirty & /*sideclose*/ 2 && div1_class_value !== (div1_class_value = "side " + (/*sideclose*/ ctx[1] ? 'side-close' : 'side-open') + " svelte-1u8231b")) {
					attr(div1, "class", div1_class_value);
				}

				if (content_slot) {
					if (content_slot.p && (!current || dirty & /*$$scope*/ 1024)) {
						update_slot_base(
							content_slot,
							content_slot_template,
							ctx,
							/*$$scope*/ ctx[10],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[10])
							: get_slot_changes(content_slot_template, /*$$scope*/ ctx[10], dirty, get_content_slot_changes),
							get_content_slot_context
						);
					}
				}

				if (footer_slot) {
					if (footer_slot.p && (!current || dirty & /*$$scope*/ 1024)) {
						update_slot_base(
							footer_slot,
							footer_slot_template,
							ctx,
							/*$$scope*/ ctx[10],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[10])
							: get_slot_changes(footer_slot_template, /*$$scope*/ ctx[10], dirty, get_footer_slot_changes),
							get_footer_slot_context
						);
					}
				}

				if (utilitycontainer_slot) {
					if (utilitycontainer_slot.p && (!current || dirty & /*$$scope*/ 1024)) {
						update_slot_base(
							utilitycontainer_slot,
							utilitycontainer_slot_template,
							ctx,
							/*$$scope*/ ctx[10],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[10])
							: get_slot_changes(utilitycontainer_slot_template, /*$$scope*/ ctx[10], dirty, get_utilitycontainer_slot_changes),
							get_utilitycontainer_slot_context
						);
					}
				}

				if (!current || dirty & /*customUtilityContainer*/ 8) {
					attr(div7, "style", /*customUtilityContainer*/ ctx[3]);
				}

				if (!current || dirty & /*utilitycontainerclose*/ 1 && div7_class_value !== (div7_class_value = "right-container utility-container " + (/*utilitycontainerclose*/ ctx[0]
				? 'utility-container-close'
				: 'utility-container-open') + " svelte-1u8231b")) {
					attr(div7, "class", div7_class_value);
				}

				if (utilitytoolbar_slot) {
					if (utilitytoolbar_slot.p && (!current || dirty & /*$$scope*/ 1024)) {
						update_slot_base(
							utilitytoolbar_slot,
							utilitytoolbar_slot_template,
							ctx,
							/*$$scope*/ ctx[10],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[10])
							: get_slot_changes(utilitytoolbar_slot_template, /*$$scope*/ ctx[10], dirty, get_utilitytoolbar_slot_changes),
							get_utilitytoolbar_slot_context
						);
					}
				}

				if (!current || dirty & /*displayUtilityBar*/ 4 && div8_class_value !== (div8_class_value = "utility-toolbar " + (/*displayUtilityBar*/ ctx[2]
				? 'utility-toolbar-open'
				: 'utility-toolbar-close') + " svelte-1u8231b")) {
					attr(div8, "class", div8_class_value);
				}

				if (!current || dirty & /*utilitycontainerclose*/ 1 && div9_class_value !== (div9_class_value = "drag-bar " + (/*utilitycontainerclose*/ ctx[0]
				? 'drag-bar-close'
				: 'drag-bar-open') + " svelte-1u8231b")) {
					attr(div9, "class", div9_class_value);
				}
			},
			i(local) {
				if (current) return;
				transition_in(header_slot, local);
				transition_in(side_slot, local);
				transition_in(content_slot, local);
				transition_in(footer_slot, local);
				transition_in(utilitycontainer_slot, local);
				transition_in(utilitytoolbar_slot, local);
				current = true;
			},
			o(local) {
				transition_out(header_slot, local);
				transition_out(side_slot, local);
				transition_out(content_slot, local);
				transition_out(footer_slot, local);
				transition_out(utilitycontainer_slot, local);
				transition_out(utilitytoolbar_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(div11);
				}

				if (header_slot) header_slot.d(detaching);
				if (side_slot) side_slot.d(detaching);
				/*div1_binding*/ ctx[12](null);
				if (content_slot) content_slot.d(detaching);
				if (footer_slot) footer_slot.d(detaching);
				/*div5_binding*/ ctx[13](null);
				if (utilitycontainer_slot) utilitycontainer_slot.d(detaching);
				/*div7_binding*/ ctx[14](null);
				if (utilitytoolbar_slot) utilitytoolbar_slot.d(detaching);
				/*div9_binding*/ ctx[15](null);
				/*div11_binding*/ ctx[16](null);
			}
		};
	}

	function instance$n($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		let { utilitycontainerclose = true } = $$props;
		let { sideclose = false } = $$props;
		let { displayUtilityBar = true } = $$props;
		let { sideContainer = true } = $$props;
		let { customUtilityContainer = "" } = $$props;
		let dragBar;
		let contentContainer;
		let sideMenuContainer;
		let utilityContainer;
		let mainContainer;
		let isDragbarDragging = false;
		let dragbarOffsetWidth = 0;

		onMount(async () => {
			$$invalidate(5, contentContainer.style.width = '100%', contentContainer);

			dragBar.addEventListener('mousedown', function (e) {
				if (e.target.id === 'dragBar') {
					isDragbarDragging = true;
					dragbarOffsetWidth = e.clientX;
				}
			});

			document.addEventListener('mousemove', function (e) {
				if (!isDragbarDragging) {
					return false;
				}

				var pointerRelativeXpos = dragbarOffsetWidth - e.clientX > 0
				? dragbarOffsetWidth - e.clientX
				: e.clientX - dragbarOffsetWidth;

				$$invalidate(
					5,
					contentContainer.style.width = sideclose
					? (dragbarOffsetWidth - e.clientX > 0
						? dragbarOffsetWidth - pointerRelativeXpos
						: dragbarOffsetWidth + pointerRelativeXpos) + 'px'
					: (dragbarOffsetWidth - e.clientX > 0
						? dragbarOffsetWidth - pointerRelativeXpos
						: dragbarOffsetWidth + pointerRelativeXpos) - sideMenuContainer.offsetWidth + 'px',
					contentContainer
				);
			});

			document.addEventListener('mouseup', function (e) {
				isDragbarDragging = false;
			});
		});

		function div1_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				sideMenuContainer = $$value;
				$$invalidate(6, sideMenuContainer);
			});
		}

		function div5_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				contentContainer = $$value;
				$$invalidate(5, contentContainer);
			});
		}

		function div7_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				utilityContainer = $$value;
				$$invalidate(7, utilityContainer);
			});
		}

		function div9_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				dragBar = $$value;
				$$invalidate(4, dragBar);
			});
		}

		function div11_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				mainContainer = $$value;
				$$invalidate(8, mainContainer);
			});
		}

		$$self.$$set = $$props => {
			if ('utilitycontainerclose' in $$props) $$invalidate(0, utilitycontainerclose = $$props.utilitycontainerclose);
			if ('sideclose' in $$props) $$invalidate(1, sideclose = $$props.sideclose);
			if ('displayUtilityBar' in $$props) $$invalidate(2, displayUtilityBar = $$props.displayUtilityBar);
			if ('sideContainer' in $$props) $$invalidate(9, sideContainer = $$props.sideContainer);
			if ('customUtilityContainer' in $$props) $$invalidate(3, customUtilityContainer = $$props.customUtilityContainer);
			if ('$$scope' in $$props) $$invalidate(10, $$scope = $$props.$$scope);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*utilitycontainerclose*/ 1) {
				console.log('utilitycontainerclose ', utilitycontainerclose);
			}

			if ($$self.$$.dirty & /*sideclose*/ 2) {
				console.log('sideclose ', sideclose);
			}
		};

		console.log('----------EAS Svelte Application Container Cmmponent---------');

		return [
			utilitycontainerclose,
			sideclose,
			displayUtilityBar,
			customUtilityContainer,
			dragBar,
			contentContainer,
			sideMenuContainer,
			utilityContainer,
			mainContainer,
			sideContainer,
			$$scope,
			slots,
			div1_binding,
			div5_binding,
			div7_binding,
			div9_binding,
			div11_binding
		];
	}

	class Eas_application_container_desktop_iop extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$n,
				create_fragment$n,
				safe_not_equal,
				{
					utilitycontainerclose: 0,
					sideclose: 1,
					displayUtilityBar: 2,
					sideContainer: 9,
					customUtilityContainer: 3
				},
				add_css$m
			);
		}

		get utilitycontainerclose() {
			return this.$$.ctx[0];
		}

		set utilitycontainerclose(utilitycontainerclose) {
			this.$$set({ utilitycontainerclose });
			flush();
		}

		get sideclose() {
			return this.$$.ctx[1];
		}

		set sideclose(sideclose) {
			this.$$set({ sideclose });
			flush();
		}

		get displayUtilityBar() {
			return this.$$.ctx[2];
		}

		set displayUtilityBar(displayUtilityBar) {
			this.$$set({ displayUtilityBar });
			flush();
		}

		get sideContainer() {
			return this.$$.ctx[9];
		}

		set sideContainer(sideContainer) {
			this.$$set({ sideContainer });
			flush();
		}

		get customUtilityContainer() {
			return this.$$.ctx[3];
		}

		set customUtilityContainer(customUtilityContainer) {
			this.$$set({ customUtilityContainer });
			flush();
		}
	}

	customElements.define("eas-application-container-desktop-iop-swc", create_custom_element(Eas_application_container_desktop_iop, {"utilitycontainerclose":{"type":"Boolean"},"sideclose":{"type":"Boolean"},"displayUtilityBar":{"type":"Boolean"},"sideContainer":{"type":"Boolean"},"customUtilityContainer":{}}, ["header","side","content","footer","utilitycontainer","utilitytoolbar"], [], true));

	/* src\lib\web-components\utility-container\eas-utility-container.component.svelte generated by Svelte v4.2.19 */

	function add_css$l(target) {
		append_styles(target, "svelte-ya459o", ".utility-container.svelte-ya459o{height:100%;font-family:\"Source Sans Pro\", sans-serif;-webkit-font-smoothing:antialiased}");
	}

	const get_comment_slot_changes = dirty => ({});
	const get_comment_slot_context = ctx => ({});
	const get_communication_slot_changes$1 = dirty => ({});
	const get_communication_slot_context$1 = ctx => ({});
	const get_export_slot_changes$1 = dirty => ({});
	const get_export_slot_context$1 = ctx => ({});
	const get_history_slot_changes$1 = dirty => ({});
	const get_history_slot_context$1 = ctx => ({});
	const get_contact_slot_changes = dirty => ({});
	const get_contact_slot_context = ctx => ({});
	const get_validation_slot_changes = dirty => ({});
	const get_validation_slot_context = ctx => ({});
	const get_document_slot_changes = dirty => ({});
	const get_document_slot_context = ctx => ({});
	const get_info_slot_changes = dirty => ({});
	const get_info_slot_context = ctx => ({});
	const get_help_slot_changes = dirty => ({});
	const get_help_slot_context = ctx => ({});

	function create_fragment$m(ctx) {
		let link;
		let t0;
		let div9;
		let div0;
		let t1;
		let div1;
		let t2;
		let div2;
		let t3;
		let div3;
		let t4;
		let div4;
		let t5;
		let div5;
		let t6;
		let div6;
		let t7;
		let div7;
		let t8;
		let div8;
		let current;
		const help_slot_template = /*#slots*/ ctx[2].help;
		const help_slot = create_slot(help_slot_template, ctx, /*$$scope*/ ctx[1], get_help_slot_context);
		const info_slot_template = /*#slots*/ ctx[2].info;
		const info_slot = create_slot(info_slot_template, ctx, /*$$scope*/ ctx[1], get_info_slot_context);
		const document_slot_template = /*#slots*/ ctx[2].document;
		const document_slot = create_slot(document_slot_template, ctx, /*$$scope*/ ctx[1], get_document_slot_context);
		const validation_slot_template = /*#slots*/ ctx[2].validation;
		const validation_slot = create_slot(validation_slot_template, ctx, /*$$scope*/ ctx[1], get_validation_slot_context);
		const contact_slot_template = /*#slots*/ ctx[2].contact;
		const contact_slot = create_slot(contact_slot_template, ctx, /*$$scope*/ ctx[1], get_contact_slot_context);
		const history_slot_template = /*#slots*/ ctx[2].history;
		const history_slot = create_slot(history_slot_template, ctx, /*$$scope*/ ctx[1], get_history_slot_context$1);
		const export_slot_template = /*#slots*/ ctx[2].export;
		const export_slot = create_slot(export_slot_template, ctx, /*$$scope*/ ctx[1], get_export_slot_context$1);
		const communication_slot_template = /*#slots*/ ctx[2].communication;
		const communication_slot = create_slot(communication_slot_template, ctx, /*$$scope*/ ctx[1], get_communication_slot_context$1);
		const comment_slot_template = /*#slots*/ ctx[2].comment;
		const comment_slot = create_slot(comment_slot_template, ctx, /*$$scope*/ ctx[1], get_comment_slot_context);

		return {
			c() {
				link = element("link");
				t0 = space();
				div9 = element("div");
				div0 = element("div");
				if (help_slot) help_slot.c();
				t1 = space();
				div1 = element("div");
				if (info_slot) info_slot.c();
				t2 = space();
				div2 = element("div");
				if (document_slot) document_slot.c();
				t3 = space();
				div3 = element("div");
				if (validation_slot) validation_slot.c();
				t4 = space();
				div4 = element("div");
				if (contact_slot) contact_slot.c();
				t5 = space();
				div5 = element("div");
				if (history_slot) history_slot.c();
				t6 = space();
				div6 = element("div");
				if (export_slot) export_slot.c();
				t7 = space();
				div7 = element("div");
				if (communication_slot) communication_slot.c();
				t8 = space();
				div8 = element("div");
				if (comment_slot) comment_slot.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(div0, "class", "help");
				attr(div1, "class", "info");
				attr(div2, "class", "document");
				attr(div3, "class", "validation");
				attr(div4, "class", "contact");
				attr(div5, "class", "history");
				attr(div6, "class", "export");
				attr(div7, "class", "communication");
				attr(div8, "class", "comment");
				attr(div9, "class", "utility-container svelte-ya459o");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div9, anchor);
				append(div9, div0);

				if (help_slot) {
					help_slot.m(div0, null);
				}

				append(div9, t1);
				append(div9, div1);

				if (info_slot) {
					info_slot.m(div1, null);
				}

				append(div9, t2);
				append(div9, div2);

				if (document_slot) {
					document_slot.m(div2, null);
				}

				append(div9, t3);
				append(div9, div3);

				if (validation_slot) {
					validation_slot.m(div3, null);
				}

				append(div9, t4);
				append(div9, div4);

				if (contact_slot) {
					contact_slot.m(div4, null);
				}

				append(div9, t5);
				append(div9, div5);

				if (history_slot) {
					history_slot.m(div5, null);
				}

				append(div9, t6);
				append(div9, div6);

				if (export_slot) {
					export_slot.m(div6, null);
				}

				append(div9, t7);
				append(div9, div7);

				if (communication_slot) {
					communication_slot.m(div7, null);
				}

				append(div9, t8);
				append(div9, div8);

				if (comment_slot) {
					comment_slot.m(div8, null);
				}

				current = true;
			},
			p(ctx, [dirty]) {
				if (help_slot) {
					if (help_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							help_slot,
							help_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(help_slot_template, /*$$scope*/ ctx[1], dirty, get_help_slot_changes),
							get_help_slot_context
						);
					}
				}

				if (info_slot) {
					if (info_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							info_slot,
							info_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(info_slot_template, /*$$scope*/ ctx[1], dirty, get_info_slot_changes),
							get_info_slot_context
						);
					}
				}

				if (document_slot) {
					if (document_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							document_slot,
							document_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(document_slot_template, /*$$scope*/ ctx[1], dirty, get_document_slot_changes),
							get_document_slot_context
						);
					}
				}

				if (validation_slot) {
					if (validation_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							validation_slot,
							validation_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(validation_slot_template, /*$$scope*/ ctx[1], dirty, get_validation_slot_changes),
							get_validation_slot_context
						);
					}
				}

				if (contact_slot) {
					if (contact_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							contact_slot,
							contact_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(contact_slot_template, /*$$scope*/ ctx[1], dirty, get_contact_slot_changes),
							get_contact_slot_context
						);
					}
				}

				if (history_slot) {
					if (history_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							history_slot,
							history_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(history_slot_template, /*$$scope*/ ctx[1], dirty, get_history_slot_changes$1),
							get_history_slot_context$1
						);
					}
				}

				if (export_slot) {
					if (export_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							export_slot,
							export_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(export_slot_template, /*$$scope*/ ctx[1], dirty, get_export_slot_changes$1),
							get_export_slot_context$1
						);
					}
				}

				if (communication_slot) {
					if (communication_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							communication_slot,
							communication_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(communication_slot_template, /*$$scope*/ ctx[1], dirty, get_communication_slot_changes$1),
							get_communication_slot_context$1
						);
					}
				}

				if (comment_slot) {
					if (comment_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							comment_slot,
							comment_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(comment_slot_template, /*$$scope*/ ctx[1], dirty, get_comment_slot_changes),
							get_comment_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(help_slot, local);
				transition_in(info_slot, local);
				transition_in(document_slot, local);
				transition_in(validation_slot, local);
				transition_in(contact_slot, local);
				transition_in(history_slot, local);
				transition_in(export_slot, local);
				transition_in(communication_slot, local);
				transition_in(comment_slot, local);
				current = true;
			},
			o(local) {
				transition_out(help_slot, local);
				transition_out(info_slot, local);
				transition_out(document_slot, local);
				transition_out(validation_slot, local);
				transition_out(contact_slot, local);
				transition_out(history_slot, local);
				transition_out(export_slot, local);
				transition_out(communication_slot, local);
				transition_out(comment_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div9);
				}

				if (help_slot) help_slot.d(detaching);
				if (info_slot) info_slot.d(detaching);
				if (document_slot) document_slot.d(detaching);
				if (validation_slot) validation_slot.d(detaching);
				if (contact_slot) contact_slot.d(detaching);
				if (history_slot) history_slot.d(detaching);
				if (export_slot) export_slot.d(detaching);
				if (communication_slot) communication_slot.d(detaching);
				if (comment_slot) comment_slot.d(detaching);
			}
		};
	}

	function instance$m($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		let { moduleKey } = $$props;

		afterUpdate(() => {
			sessionStorage.setItem('AppModuleKey', `${moduleKey}`);
		});

		$$self.$$set = $$props => {
			if ('moduleKey' in $$props) $$invalidate(0, moduleKey = $$props.moduleKey);
			if ('$$scope' in $$props) $$invalidate(1, $$scope = $$props.$$scope);
		};

		return [moduleKey, $$scope, slots];
	}

	class Eas_utility_container_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$m, create_fragment$m, safe_not_equal, { moduleKey: 0 }, add_css$l);
		}

		get moduleKey() {
			return this.$$.ctx[0];
		}

		set moduleKey(moduleKey) {
			this.$$set({ moduleKey });
			flush();
		}
	}

	customElements.define("eas-utility-container-swc", create_custom_element(
		Eas_utility_container_component,
		{"moduleKey":{}},
		[
			"help","info","document","validation","contact","history","export","communication","comment"
		],
		[],
		true
	));

	class UtilityService extends ServiceBase {
	    utilityDataApiPath = `${this.easBaseUrl}/api/v1/utilitytabs`;
	    subjectCountApiPath = `${this.monitoringBaseUrl}api/v1/utility/Comments/count`;
	    getUtilityData(assetTemplateKey, moduleKey, pageAssetTemplateKey) {
	        if (!assetTemplateKey || assetTemplateKey <= 0 || !moduleKey && moduleKey <= 0) {
	            console.error(`getUtilityData: invalid parameters assetTemplateKey: ${assetTemplateKey}, moduleKey: ${moduleKey}`);
	            return new Promise((resolve) => {
	                resolve([]);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/utilitytabs/${assetTemplateKey}`;
	        url += `?moduleKey=${moduleKey}`;
	        if (pageAssetTemplateKey) {
	            url += `&pageAssetTemplateKey=${pageAssetTemplateKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((utilityTabs) => {
	                resolve(utilityTabs);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getSubjectsCountData(assetTemplateKey, moduleKey, immediateOwnerTypeKey, compositeOwnerSourceKey) {
	        let url = `${this.subjectCountApiPath}`;
	        if (assetTemplateKey) {
	            url += `?assetTemplateKey=${assetTemplateKey}&immediateOwnerSourceKey=${assetTemplateKey}`;
	        }
	        if (immediateOwnerTypeKey) {
	            url += `&immediateOwnerTypeKey=${immediateOwnerTypeKey}`;
	        }
	        if (compositeOwnerSourceKey) {
	            url += `&compOwnerSourceKey=${compositeOwnerSourceKey}`;
	        }
	        if (moduleKey) {
	            url += `&moduleKey=${moduleKey}&compOwnerTypeKey=${moduleKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((count) => {
	                resolve(count);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getRelatedContactTypes(moduleKey, parentAssetTemplateKey, sourceTypeKey) {
	        const url = `${this.easUtilityUrl}/api/v1/Contact/relatedContact/refdata?moduleKey=${moduleKey}&contactParentAssetKey=${parentAssetTemplateKey}&sourceTypeKey=${sourceTypeKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getAssignmentContactTypes(moduleKey, parentAssetTemplateKey, sourceTypeKey) {
	        const url = `${this.easUtilityUrl}/api/v1/Contact/assignment/refdata?moduleKey=${moduleKey}&contactParentAssetKey=${parentAssetTemplateKey}&sourceTypeKey=${sourceTypeKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getAssignableContactsByContactType(moduleKey, irn, contactTypeKey, parentAssetTemplateKey, contactGroupKey) {
	        let url = `${this.easUtilityUrl}/api/v1/Contact/assignableContacts/${contactTypeKey}?moduleKey=${moduleKey}&contactParentAssetKey=${parentAssetTemplateKey}&Source=Utility`;
	        if (contactGroupKey != ContactGroup.SEA) {
	            irn = irn.toString().padStart(6, '0');
	            url = `${url}&irn=${irn}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getInformationalContactTypes(moduleKey, parentAssetTemplateKey, sourceTypeKey) {
	        const url = `${this.easUtilityUrl}/api/v1/Contact/informational/refdata?moduleKey=${moduleKey}&contactParentAssetKey=${parentAssetTemplateKey}&sourceTypeKey=${sourceTypeKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	}

	/* src\lib\web-components\toolbar\eas-toolbar.component.svelte generated by Svelte v4.2.19 */

	function add_css$k(target) {
		append_styles(target, "svelte-1tcw2yw", ".utilities-container.svelte-1tcw2yw.svelte-1tcw2yw{display:inline-flex;height:100%;right:0}.utilities.svelte-1tcw2yw.svelte-1tcw2yw{padding:10px;padding-top:22px;background-color:#fff}.utilities--ul.svelte-1tcw2yw.svelte-1tcw2yw{list-style:none;padding-left:0;margin-top:0;margin-bottom:0}.utilities--ul--li.svelte-1tcw2yw.svelte-1tcw2yw{padding-top:10px;padding-bottom:10px;text-align:center}.utilities--a.svelte-1tcw2yw.svelte-1tcw2yw{color:#525051;width:20px;text-decoration:none;width:23px;text-decoration:none;display:block}.utilities--a.svelte-1tcw2yw.svelte-1tcw2yw:hover{color:#65101c}.utilities--a.svelte-1tcw2yw i.svelte-1tcw2yw{font-size:27px}@media(max-width: 425px){.utilities.svelte-1tcw2yw.svelte-1tcw2yw{display:inline-block;width:100%}.utilities-container.svelte-1tcw2yw.svelte-1tcw2yw{width:100%;position:unset}.utilities--ul.svelte-1tcw2yw.svelte-1tcw2yw{display:flex}.utilities--ul--li.svelte-1tcw2yw.svelte-1tcw2yw{width:20%;padding-bottom:0}.utilities-container.svelte-1tcw2yw.svelte-1tcw2yw{right:0;top:0;height:unset;margin-top:6px}.utilities--a.svelte-1tcw2yw.svelte-1tcw2yw{display:inline-block}.utilities--ul--li.svelte-1tcw2yw:nth-of-type(2) .utilities--a.svelte-1tcw2yw,.utilities--ul--li.svelte-1tcw2yw:nth-of-type(4) .utilities--a.svelte-1tcw2yw{width:29px}.utilities--ul--li.svelte-1tcw2yw:nth-of-type(5) .utilities--a.svelte-1tcw2yw{width:26px}.utilities--ul--li.svelte-1tcw2yw:nth-of-type(3) .utilities--a.svelte-1tcw2yw{width:18px}.utilities.svelte-1tcw2yw.svelte-1tcw2yw{border-bottom:1px solid #d8d8d8;border-left:none;padding:0;padding-bottom:3px}}");
	}

	const get_export_slot_changes = dirty => ({});
	const get_export_slot_context = ctx => ({});
	const get_history_slot_changes = dirty => ({});
	const get_history_slot_context = ctx => ({});
	const get_validations_slot_changes = dirty => ({});
	const get_validations_slot_context = ctx => ({});
	const get_contacts_slot_changes = dirty => ({});
	const get_contacts_slot_context = ctx => ({});
	const get_flags_slot_changes = dirty => ({});
	const get_flags_slot_context = ctx => ({});
	const get_communication_slot_changes = dirty => ({});
	const get_communication_slot_context = ctx => ({});
	const get_comments_slot_changes = dirty => ({});
	const get_comments_slot_context = ctx => ({});
	const get_documents_slot_changes = dirty => ({});
	const get_documents_slot_context = ctx => ({});

	// (86:3) {#if hasHelpPermission}
	function create_if_block_7$1(ctx) {
		let li;
		let a;
		let mounted;
		let dispose;

		return {
			c() {
				li = element("li");
				a = element("a");
				a.innerHTML = `<i class="fa-solid fa-circle-info svelte-1tcw2yw"></i>`;
				attr(a, "class", "utilities--a svelte-1tcw2yw");
				attr(a, "href", "javascript:void(0)");
				attr(a, "title", "View Page Information");
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, a);

				if (!mounted) {
					dispose = listen(a, "click", /*click_handler*/ ctx[17]);
					mounted = true;
				}
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (99:3) {#if hasDocumentPermission}
	function create_if_block_6$1(ctx) {
		let li;
		let current;
		const documents_slot_template = /*#slots*/ ctx[16].documents;
		const documents_slot = create_slot(documents_slot_template, ctx, /*$$scope*/ ctx[15], get_documents_slot_context);

		return {
			c() {
				li = element("li");
				if (documents_slot) documents_slot.c();
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, li, anchor);

				if (documents_slot) {
					documents_slot.m(li, null);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (documents_slot) {
					if (documents_slot.p && (!current || dirty & /*$$scope*/ 32768)) {
						update_slot_base(
							documents_slot,
							documents_slot_template,
							ctx,
							/*$$scope*/ ctx[15],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[15])
							: get_slot_changes(documents_slot_template, /*$$scope*/ ctx[15], dirty, get_documents_slot_changes),
							get_documents_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(documents_slot, local);
				current = true;
			},
			o(local) {
				transition_out(documents_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (documents_slot) documents_slot.d(detaching);
			}
		};
	}

	// (105:3) {#if hasCommentPermission}
	function create_if_block_5$1(ctx) {
		let li;
		let current;
		const comments_slot_template = /*#slots*/ ctx[16].comments;
		const comments_slot = create_slot(comments_slot_template, ctx, /*$$scope*/ ctx[15], get_comments_slot_context);

		return {
			c() {
				li = element("li");
				if (comments_slot) comments_slot.c();
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, li, anchor);

				if (comments_slot) {
					comments_slot.m(li, null);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (comments_slot) {
					if (comments_slot.p && (!current || dirty & /*$$scope*/ 32768)) {
						update_slot_base(
							comments_slot,
							comments_slot_template,
							ctx,
							/*$$scope*/ ctx[15],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[15])
							: get_slot_changes(comments_slot_template, /*$$scope*/ ctx[15], dirty, get_comments_slot_changes),
							get_comments_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(comments_slot, local);
				current = true;
			},
			o(local) {
				transition_out(comments_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (comments_slot) comments_slot.d(detaching);
			}
		};
	}

	// (117:3) {#if hasFlagPermission}
	function create_if_block_4$2(ctx) {
		let li;
		let current;
		const flags_slot_template = /*#slots*/ ctx[16].flags;
		const flags_slot = create_slot(flags_slot_template, ctx, /*$$scope*/ ctx[15], get_flags_slot_context);

		return {
			c() {
				li = element("li");
				if (flags_slot) flags_slot.c();
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, li, anchor);

				if (flags_slot) {
					flags_slot.m(li, null);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (flags_slot) {
					if (flags_slot.p && (!current || dirty & /*$$scope*/ 32768)) {
						update_slot_base(
							flags_slot,
							flags_slot_template,
							ctx,
							/*$$scope*/ ctx[15],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[15])
							: get_slot_changes(flags_slot_template, /*$$scope*/ ctx[15], dirty, get_flags_slot_changes),
							get_flags_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(flags_slot, local);
				current = true;
			},
			o(local) {
				transition_out(flags_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (flags_slot) flags_slot.d(detaching);
			}
		};
	}

	// (123:3) {#if hasContactPermission}
	function create_if_block_3$3(ctx) {
		let li;
		let current;
		const contacts_slot_template = /*#slots*/ ctx[16].contacts;
		const contacts_slot = create_slot(contacts_slot_template, ctx, /*$$scope*/ ctx[15], get_contacts_slot_context);

		return {
			c() {
				li = element("li");
				if (contacts_slot) contacts_slot.c();
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, li, anchor);

				if (contacts_slot) {
					contacts_slot.m(li, null);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (contacts_slot) {
					if (contacts_slot.p && (!current || dirty & /*$$scope*/ 32768)) {
						update_slot_base(
							contacts_slot,
							contacts_slot_template,
							ctx,
							/*$$scope*/ ctx[15],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[15])
							: get_slot_changes(contacts_slot_template, /*$$scope*/ ctx[15], dirty, get_contacts_slot_changes),
							get_contacts_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(contacts_slot, local);
				current = true;
			},
			o(local) {
				transition_out(contacts_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (contacts_slot) contacts_slot.d(detaching);
			}
		};
	}

	// (129:3) {#if hasValidationPermission}
	function create_if_block_2$7(ctx) {
		let li;
		let current;
		const validations_slot_template = /*#slots*/ ctx[16].validations;
		const validations_slot = create_slot(validations_slot_template, ctx, /*$$scope*/ ctx[15], get_validations_slot_context);

		return {
			c() {
				li = element("li");
				if (validations_slot) validations_slot.c();
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, li, anchor);

				if (validations_slot) {
					validations_slot.m(li, null);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (validations_slot) {
					if (validations_slot.p && (!current || dirty & /*$$scope*/ 32768)) {
						update_slot_base(
							validations_slot,
							validations_slot_template,
							ctx,
							/*$$scope*/ ctx[15],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[15])
							: get_slot_changes(validations_slot_template, /*$$scope*/ ctx[15], dirty, get_validations_slot_changes),
							get_validations_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(validations_slot, local);
				current = true;
			},
			o(local) {
				transition_out(validations_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (validations_slot) validations_slot.d(detaching);
			}
		};
	}

	// (135:3) {#if hasWorkflowHistoryPermission}
	function create_if_block_1$a(ctx) {
		let li;
		let current;
		const history_slot_template = /*#slots*/ ctx[16].history;
		const history_slot = create_slot(history_slot_template, ctx, /*$$scope*/ ctx[15], get_history_slot_context);

		return {
			c() {
				li = element("li");
				if (history_slot) history_slot.c();
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, li, anchor);

				if (history_slot) {
					history_slot.m(li, null);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (history_slot) {
					if (history_slot.p && (!current || dirty & /*$$scope*/ 32768)) {
						update_slot_base(
							history_slot,
							history_slot_template,
							ctx,
							/*$$scope*/ ctx[15],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[15])
							: get_slot_changes(history_slot_template, /*$$scope*/ ctx[15], dirty, get_history_slot_changes),
							get_history_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(history_slot, local);
				current = true;
			},
			o(local) {
				transition_out(history_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (history_slot) history_slot.d(detaching);
			}
		};
	}

	// (141:3) {#if hasExportPermission}
	function create_if_block$c(ctx) {
		let li;
		let current;
		const export_slot_template = /*#slots*/ ctx[16].export;
		const export_slot = create_slot(export_slot_template, ctx, /*$$scope*/ ctx[15], get_export_slot_context);

		return {
			c() {
				li = element("li");
				if (export_slot) export_slot.c();
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, li, anchor);

				if (export_slot) {
					export_slot.m(li, null);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (export_slot) {
					if (export_slot.p && (!current || dirty & /*$$scope*/ 32768)) {
						update_slot_base(
							export_slot,
							export_slot_template,
							ctx,
							/*$$scope*/ ctx[15],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[15])
							: get_slot_changes(export_slot_template, /*$$scope*/ ctx[15], dirty, get_export_slot_changes),
							get_export_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(export_slot, local);
				current = true;
			},
			o(local) {
				transition_out(export_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (export_slot) export_slot.d(detaching);
			}
		};
	}

	function create_fragment$l(ctx) {
		let link;
		let t0;
		let div1;
		let div0;
		let ul;
		let t1;
		let t2;
		let t3;
		let li;
		let t4;
		let t5;
		let t6;
		let t7;
		let t8;
		let current;
		let if_block0 = /*hasHelpPermission*/ ctx[0] && create_if_block_7$1(ctx);
		let if_block1 = /*hasDocumentPermission*/ ctx[1] && create_if_block_6$1(ctx);
		let if_block2 = /*hasCommentPermission*/ ctx[2] && create_if_block_5$1(ctx);
		const communication_slot_template = /*#slots*/ ctx[16].communication;
		const communication_slot = create_slot(communication_slot_template, ctx, /*$$scope*/ ctx[15], get_communication_slot_context);
		let if_block3 = /*hasFlagPermission*/ ctx[3] && create_if_block_4$2(ctx);
		let if_block4 = /*hasContactPermission*/ ctx[4] && create_if_block_3$3(ctx);
		let if_block5 = /*hasValidationPermission*/ ctx[5] && create_if_block_2$7(ctx);
		let if_block6 = /*hasWorkflowHistoryPermission*/ ctx[6] && create_if_block_1$a(ctx);
		let if_block7 = /*hasExportPermission*/ ctx[7] && create_if_block$c(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div1 = element("div");
				div0 = element("div");
				ul = element("ul");
				if (if_block0) if_block0.c();
				t1 = space();
				if (if_block1) if_block1.c();
				t2 = space();
				if (if_block2) if_block2.c();
				t3 = space();
				li = element("li");
				if (communication_slot) communication_slot.c();
				t4 = space();
				if (if_block3) if_block3.c();
				t5 = space();
				if (if_block4) if_block4.c();
				t6 = space();
				if (if_block5) if_block5.c();
				t7 = space();
				if (if_block6) if_block6.c();
				t8 = space();
				if (if_block7) if_block7.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(li, "class", "utilities--ul--li svelte-1tcw2yw");
				attr(ul, "class", "utilities--ul svelte-1tcw2yw");
				attr(div0, "class", "utilities svelte-1tcw2yw");
				attr(div1, "class", "utilities-container svelte-1tcw2yw");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div1, anchor);
				append(div1, div0);
				append(div0, ul);
				if (if_block0) if_block0.m(ul, null);
				append(ul, t1);
				if (if_block1) if_block1.m(ul, null);
				append(ul, t2);
				if (if_block2) if_block2.m(ul, null);
				append(ul, t3);
				append(ul, li);

				if (communication_slot) {
					communication_slot.m(li, null);
				}

				append(ul, t4);
				if (if_block3) if_block3.m(ul, null);
				append(ul, t5);
				if (if_block4) if_block4.m(ul, null);
				append(ul, t6);
				if (if_block5) if_block5.m(ul, null);
				append(ul, t7);
				if (if_block6) if_block6.m(ul, null);
				append(ul, t8);
				if (if_block7) if_block7.m(ul, null);
				current = true;
			},
			p(ctx, [dirty]) {
				if (/*hasHelpPermission*/ ctx[0]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_7$1(ctx);
						if_block0.c();
						if_block0.m(ul, t1);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*hasDocumentPermission*/ ctx[1]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*hasDocumentPermission*/ 2) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block_6$1(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(ul, t2);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				if (/*hasCommentPermission*/ ctx[2]) {
					if (if_block2) {
						if_block2.p(ctx, dirty);

						if (dirty & /*hasCommentPermission*/ 4) {
							transition_in(if_block2, 1);
						}
					} else {
						if_block2 = create_if_block_5$1(ctx);
						if_block2.c();
						transition_in(if_block2, 1);
						if_block2.m(ul, t3);
					}
				} else if (if_block2) {
					group_outros();

					transition_out(if_block2, 1, 1, () => {
						if_block2 = null;
					});

					check_outros();
				}

				if (communication_slot) {
					if (communication_slot.p && (!current || dirty & /*$$scope*/ 32768)) {
						update_slot_base(
							communication_slot,
							communication_slot_template,
							ctx,
							/*$$scope*/ ctx[15],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[15])
							: get_slot_changes(communication_slot_template, /*$$scope*/ ctx[15], dirty, get_communication_slot_changes),
							get_communication_slot_context
						);
					}
				}

				if (/*hasFlagPermission*/ ctx[3]) {
					if (if_block3) {
						if_block3.p(ctx, dirty);

						if (dirty & /*hasFlagPermission*/ 8) {
							transition_in(if_block3, 1);
						}
					} else {
						if_block3 = create_if_block_4$2(ctx);
						if_block3.c();
						transition_in(if_block3, 1);
						if_block3.m(ul, t5);
					}
				} else if (if_block3) {
					group_outros();

					transition_out(if_block3, 1, 1, () => {
						if_block3 = null;
					});

					check_outros();
				}

				if (/*hasContactPermission*/ ctx[4]) {
					if (if_block4) {
						if_block4.p(ctx, dirty);

						if (dirty & /*hasContactPermission*/ 16) {
							transition_in(if_block4, 1);
						}
					} else {
						if_block4 = create_if_block_3$3(ctx);
						if_block4.c();
						transition_in(if_block4, 1);
						if_block4.m(ul, t6);
					}
				} else if (if_block4) {
					group_outros();

					transition_out(if_block4, 1, 1, () => {
						if_block4 = null;
					});

					check_outros();
				}

				if (/*hasValidationPermission*/ ctx[5]) {
					if (if_block5) {
						if_block5.p(ctx, dirty);

						if (dirty & /*hasValidationPermission*/ 32) {
							transition_in(if_block5, 1);
						}
					} else {
						if_block5 = create_if_block_2$7(ctx);
						if_block5.c();
						transition_in(if_block5, 1);
						if_block5.m(ul, t7);
					}
				} else if (if_block5) {
					group_outros();

					transition_out(if_block5, 1, 1, () => {
						if_block5 = null;
					});

					check_outros();
				}

				if (/*hasWorkflowHistoryPermission*/ ctx[6]) {
					if (if_block6) {
						if_block6.p(ctx, dirty);

						if (dirty & /*hasWorkflowHistoryPermission*/ 64) {
							transition_in(if_block6, 1);
						}
					} else {
						if_block6 = create_if_block_1$a(ctx);
						if_block6.c();
						transition_in(if_block6, 1);
						if_block6.m(ul, t8);
					}
				} else if (if_block6) {
					group_outros();

					transition_out(if_block6, 1, 1, () => {
						if_block6 = null;
					});

					check_outros();
				}

				if (/*hasExportPermission*/ ctx[7]) {
					if (if_block7) {
						if_block7.p(ctx, dirty);

						if (dirty & /*hasExportPermission*/ 128) {
							transition_in(if_block7, 1);
						}
					} else {
						if_block7 = create_if_block$c(ctx);
						if_block7.c();
						transition_in(if_block7, 1);
						if_block7.m(ul, null);
					}
				} else if (if_block7) {
					group_outros();

					transition_out(if_block7, 1, 1, () => {
						if_block7 = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block1);
				transition_in(if_block2);
				transition_in(communication_slot, local);
				transition_in(if_block3);
				transition_in(if_block4);
				transition_in(if_block5);
				transition_in(if_block6);
				transition_in(if_block7);
				current = true;
			},
			o(local) {
				transition_out(if_block1);
				transition_out(if_block2);
				transition_out(communication_slot, local);
				transition_out(if_block3);
				transition_out(if_block4);
				transition_out(if_block5);
				transition_out(if_block6);
				transition_out(if_block7);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div1);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				if (if_block2) if_block2.d();
				if (communication_slot) communication_slot.d(detaching);
				if (if_block3) if_block3.d();
				if (if_block4) if_block4.d();
				if (if_block5) if_block5.d();
				if (if_block6) if_block6.d();
				if (if_block7) if_block7.d();
			}
		};
	}

	function instance$l($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		const svelteDispatch = createEventDispatcher();
		let utilities = [];
		let { assettemplatekey } = $$props;
		let { pageassettemplatekey } = $$props;
		let { modulekey = 0 } = $$props;
		let { immediateownertypekey } = $$props;
		let { compositeownersourcekey } = $$props;
		let { compositeownertypekey } = $$props;
		let hasHelpPermission = false;
		let hasDocumentPermission = false;
		let hasCommentPermission = false;
		let hasCommunicationPermission = false;
		let hasFlagPermission = false;
		let hasContactPermission = false;
		let hasValidationPermission = false;
		let hasWorkflowHistoryPermission = false;
		let hasExportPermission = false;
		let utilityService = new UtilityService();

		onMount(async () => {
			console.log('getUtilityData', assettemplatekey, modulekey, pageassettemplatekey);
			getUtilityData(assettemplatekey, modulekey, pageassettemplatekey);
		});

		function onInfoCloseClick(e) {
			console.log('info clicked');

			let eventData = {
				...e,
				detail: { label: 'Info', url: window.location.href }
			};

			e.stopPropagation();
			svelteDispatch('infoclick', eventData);
		}

		function getUtilityData(assetTemplateKey, moduleKey, pageAssetTemplateKey) {
			utilityService.getUtilityData(assetTemplateKey, moduleKey, pageAssetTemplateKey).then(result => {
				console.log('utilities result', result);
				utilities = result;
				console.log('utilities', utilities);

				if (utilities && utilities.length > 0) {
					$$invalidate(0, hasHelpPermission = utilities.some(x => x === 'Help'));
					$$invalidate(1, hasDocumentPermission = utilities.some(x => x === 'Documents'));
					$$invalidate(2, hasCommentPermission = utilities.some(x => x === 'Comments'));
					hasCommunicationPermission = utilities.some(x => x === 'Communications');
					$$invalidate(3, hasFlagPermission = utilities.some(x => x === 'Flags'));
					$$invalidate(4, hasContactPermission = utilities.some(x => x === 'Contacts'));
					$$invalidate(5, hasValidationPermission = utilities.some(x => x === 'Validations'));
					$$invalidate(6, hasWorkflowHistoryPermission = utilities.some(x => x === 'History'));
					$$invalidate(7, hasExportPermission = utilities.some(x => x === 'Export'));

					const permission = {
						help: hasHelpPermission,
						comment: hasCommentPermission,
						document: hasDocumentPermission,
						communication: hasCommunicationPermission,
						flag: hasFlagPermission,
						contact: hasContactPermission,
						validation: hasValidationPermission,
						workflow: hasWorkflowHistoryPermission,
						export: hasExportPermission
					};

					svelteDispatch("getPermission", permission);
				}
			}).catch(error => {
				console.error('error in getUtilityData: ', error);
			});
		}

		const click_handler = e => onInfoCloseClick(e);

		$$self.$$set = $$props => {
			if ('assettemplatekey' in $$props) $$invalidate(9, assettemplatekey = $$props.assettemplatekey);
			if ('pageassettemplatekey' in $$props) $$invalidate(10, pageassettemplatekey = $$props.pageassettemplatekey);
			if ('modulekey' in $$props) $$invalidate(11, modulekey = $$props.modulekey);
			if ('immediateownertypekey' in $$props) $$invalidate(12, immediateownertypekey = $$props.immediateownertypekey);
			if ('compositeownersourcekey' in $$props) $$invalidate(13, compositeownersourcekey = $$props.compositeownersourcekey);
			if ('compositeownertypekey' in $$props) $$invalidate(14, compositeownertypekey = $$props.compositeownertypekey);
			if ('$$scope' in $$props) $$invalidate(15, $$scope = $$props.$$scope);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*assettemplatekey*/ 512) {
				console.log('assettemplatekey ', assettemplatekey);
			}

			if ($$self.$$.dirty & /*modulekey*/ 2048) {
				console.log('modulekey ', modulekey);
			}

			if ($$self.$$.dirty & /*immediateownertypekey*/ 4096) {
				console.log('immediateownertypekey ', immediateownertypekey);
			}

			if ($$self.$$.dirty & /*compositeownersourcekey*/ 8192) {
				console.log('compositeownersourcekey ', compositeownersourcekey);
			}

			if ($$self.$$.dirty & /*compositeownertypekey*/ 16384) {
				console.log('compositeownertypekey ', compositeownertypekey);
			}
		};

		console.log('----------EAS Svelte Toolbar Cmmponent---------');

		return [
			hasHelpPermission,
			hasDocumentPermission,
			hasCommentPermission,
			hasFlagPermission,
			hasContactPermission,
			hasValidationPermission,
			hasWorkflowHistoryPermission,
			hasExportPermission,
			onInfoCloseClick,
			assettemplatekey,
			pageassettemplatekey,
			modulekey,
			immediateownertypekey,
			compositeownersourcekey,
			compositeownertypekey,
			$$scope,
			slots,
			click_handler
		];
	}

	class Eas_toolbar_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$l,
				create_fragment$l,
				safe_not_equal,
				{
					assettemplatekey: 9,
					pageassettemplatekey: 10,
					modulekey: 11,
					immediateownertypekey: 12,
					compositeownersourcekey: 13,
					compositeownertypekey: 14
				},
				add_css$k
			);
		}

		get assettemplatekey() {
			return this.$$.ctx[9];
		}

		set assettemplatekey(assettemplatekey) {
			this.$$set({ assettemplatekey });
			flush();
		}

		get pageassettemplatekey() {
			return this.$$.ctx[10];
		}

		set pageassettemplatekey(pageassettemplatekey) {
			this.$$set({ pageassettemplatekey });
			flush();
		}

		get modulekey() {
			return this.$$.ctx[11];
		}

		set modulekey(modulekey) {
			this.$$set({ modulekey });
			flush();
		}

		get immediateownertypekey() {
			return this.$$.ctx[12];
		}

		set immediateownertypekey(immediateownertypekey) {
			this.$$set({ immediateownertypekey });
			flush();
		}

		get compositeownersourcekey() {
			return this.$$.ctx[13];
		}

		set compositeownersourcekey(compositeownersourcekey) {
			this.$$set({ compositeownersourcekey });
			flush();
		}

		get compositeownertypekey() {
			return this.$$.ctx[14];
		}

		set compositeownertypekey(compositeownertypekey) {
			this.$$set({ compositeownertypekey });
			flush();
		}
	}

	customElements.define("eas-toolbar-swc", create_custom_element(
		Eas_toolbar_component,
		{"assettemplatekey":{},"pageassettemplatekey":{},"modulekey":{},"immediateownertypekey":{},"compositeownersourcekey":{},"compositeownertypekey":{}},
		[
			"documents","comments","communication","flags","contacts","validations","history","export"
		],
		[],
		true
	));

	/* src\lib\web-components\footer\eas-footer.component.svelte generated by Svelte v4.2.19 */

	function add_css$j(target) {
		append_styles(target, "svelte-1759by3", ".alerts.svelte-1759by3{margin-left:5px}.footer-title.svelte-1759by3{display:flex;font-size:18px;margin:5px 0 15px 0;color:rgb(234, 16, 20);font-weight:bold}.dept-head-container.svelte-1759by3{display:flex;flex-direction:column}.footer-container.svelte-1759by3{display:flex;justify-content:center;align-items:center;flex-direction:column;background:#F2F2F2;border-top:1px solid rgba(0, 0, 0, 0.2);font:14px \"Open Sans\", Arial, sans-serif\r\n    }.footer-title.svelte-1759by3{display:flex;margin:5px 0 15px 0;color:#c52229;font-weight:700;text-decoration:none;cursor:pointer;font-size:17px}.footer-title.svelte-1759by3:hover{text-decoration:underline}.privacy-jobs-employees.svelte-1759by3,.site-map-contact.svelte-1759by3{display:flex;flex-direction:row;justify-content:center;align-items:center}a.svelte-1759by3{display:flex;color:rgb(61, 122, 169);font-weight:bold;cursor:pointer;text-decoration:none;font-weight:700\r\n    }a.svelte-1759by3:hover{text-decoration:underline}.dept-head-title.svelte-1759by3{display:flex}.separator.svelte-1759by3{display:none}.hide-separator.svelte-1759by3{margin:0 3px 0 3px;display:flex}.dept-head-details.svelte-1759by3{display:flex;margin:3px 0 10px 0;flex-direction:column;justify-content:center;align-items:center;font:18px \"Open Sans\", Arial, sans-serif}.dept-head-name.svelte-1759by3{display:flex;flex-direction:row;font:18px \"Open Sans\", Arial, sans-serif;justify-content:center;align-items:center}.governor-details.svelte-1759by3{display:flex;flex-direction:column;color:rgb(61, 122, 169);margin:0 0 10px 0;font:18px \"Open Sans\", Arial, sans-serif}.equal-opportunity.svelte-1759by3{color:#fff;background:#525051;width:100%;display:flex;justify-content:center;align-items:center;padding:5px 0;font-size:14px;text-align:center}@media(min-width: 576px){.dept-head-container.svelte-1759by3{display:flex;flex-direction:row}.separator.svelte-1759by3{margin:0 3px 0 3px;display:flex}.hide-separator.svelte-1759by3{display:none}.dept-head-name.svelte-1759by3{display:flex;font-size:14px}.dept-head-details.svelte-1759by3{display:flex;margin:3px 0 10px 0;flex-direction:row}.governor-details.svelte-1759by3{display:flex;flex-direction:row;color:rgb(61, 122, 169);margin:0 0 10px 0}.privacy-jobs-employees.svelte-1759by3,.site-map-contact.svelte-1759by3{display:flex;flex-direction:row}.equal-opportunity.svelte-1759by3{color:#fff;background:#525051;width:100%;display:flex;justify-content:center;align-items:center;padding:5px 0;font-size:13px}}");
	}

	function create_fragment$k(ctx) {
		let link;
		let t0;
		let div18;
		let a0;
		let t1;
		let t2;
		let div4;
		let div1;
		let a1;
		let t3;
		let t4;
		let div0;
		let t5;
		let div2;
		let t7;
		let div3;
		let t8;
		let div8;
		let div5;
		let t9;
		let div6;
		let t11;
		let a2;
		let t12;
		let i;
		let t13;
		let div7;
		let t15;
		let a3;
		let t16;
		let t17;
		let div16;
		let a4;
		let t18;
		let t19;
		let t20;
		let div12;
		let div9;
		let t22;
		let a5;
		let t23;
		let t24;
		let div10;
		let t26;
		let a6;
		let t27;
		let t28;
		let div11;
		let t30;
		let a7;
		let t31;
		let t32;
		let div15;
		let div13;
		let t34;
		let a8;
		let t35;
		let t36;
		let div14;
		let t38;
		let a9;
		let t39;
		let t40;
		let div17;
		let mounted;
		let dispose;

		return {
			c() {
				link = element("link");
				t0 = space();
				div18 = element("div");
				a0 = element("a");
				t1 = text(/*deptTitle*/ ctx[4]);
				t2 = space();
				div4 = element("div");
				div1 = element("div");
				a1 = element("a");
				t3 = text(/*deptHeadName*/ ctx[5]);
				t4 = space();
				div0 = element("div");
				t5 = space();
				div2 = element("div");
				div2.textContent = "|";
				t7 = space();
				div3 = element("div");
				t8 = space();
				div8 = element("div");
				div5 = element("div");
				t9 = space();
				div6 = element("div");
				div6.textContent = "|";
				t11 = space();
				a2 = element("a");
				t12 = text(/*alertsTitle*/ ctx[6]);
				i = element("i");
				t13 = space();
				div7 = element("div");
				div7.textContent = "|";
				t15 = space();
				a3 = element("a");
				t16 = text(/*eduContactEmail*/ ctx[7]);
				t17 = space();
				div16 = element("div");
				a4 = element("a");
				t18 = text(/*governorName*/ ctx[8]);
				t19 = text(/*governorTitle*/ ctx[9]);
				t20 = space();
				div12 = element("div");
				div9 = element("div");
				div9.textContent = "|";
				t22 = space();
				a5 = element("a");
				t23 = text(/*privacy*/ ctx[10]);
				t24 = space();
				div10 = element("div");
				div10.textContent = "|";
				t26 = space();
				a6 = element("a");
				t27 = text(/*jobs*/ ctx[11]);
				t28 = space();
				div11 = element("div");
				div11.textContent = "|";
				t30 = space();
				a7 = element("a");
				t31 = text(/*employees*/ ctx[12]);
				t32 = space();
				div15 = element("div");
				div13 = element("div");
				div13.textContent = "|";
				t34 = space();
				a8 = element("a");
				t35 = text(/*siteMap*/ ctx[13]);
				t36 = space();
				div14 = element("div");
				div14.textContent = "|";
				t38 = space();
				a9 = element("a");
				t39 = text(/*contact*/ ctx[14]);
				t40 = space();
				div17 = element("div");
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(a0, "class", "footer-title svelte-1759by3");
				attr(a0, "href", "http://education.ohio.gov/");
				attr(a0, "target", "_blank");
				attr(a1, "href", "https://education.ohio.gov/About/About-The-Director");
				attr(a1, "class", "svelte-1759by3");
				attr(div0, "class", "dept-head-title svelte-1759by3");
				attr(div0, "contenteditable", "false");
				if (/*deptHeadTitle*/ ctx[0] === void 0) add_render_callback(() => /*div0_input_handler*/ ctx[15].call(div0));
				attr(div1, "class", "dept-head-name svelte-1759by3");
				attr(div2, "class", "separator svelte-1759by3");
				attr(div3, "class", "dept-head-address");
				attr(div3, "contenteditable", "false");
				if (/*deptHeadAddress*/ ctx[1] === void 0) add_render_callback(() => /*div3_input_handler*/ ctx[16].call(div3));
				attr(div4, "class", "dept-head-container svelte-1759by3");
				attr(div5, "class", "dept-head-phone-number");
				attr(div5, "contenteditable", "false");
				if (/*deptHeadPhoneNumber*/ ctx[2] === void 0) add_render_callback(() => /*div5_input_handler*/ ctx[17].call(div5));
				attr(div6, "class", "separator svelte-1759by3");
				attr(i, "class", "alerts fa-solid fa-comment svelte-1759by3");
				attr(a2, "href", "https://public.govdelivery.com/accounts/OHED/subscriber/new");
				attr(a2, "class", "svelte-1759by3");
				attr(div7, "class", "separator svelte-1759by3");
				attr(a3, "class", "dept-head-contact-email svelte-1759by3");
				attr(a3, "href", "mailto:contact.center@education.ohio.gov");
				attr(div8, "class", "dept-head-details svelte-1759by3");
				attr(a4, "class", "governor-name svelte-1759by3");
				attr(a4, "href", "http://www.governor.ohio.gov/");
				attr(div9, "class", "separator svelte-1759by3");
				attr(a5, "class", "privacy svelte-1759by3");
				attr(a5, "href", "http://education.ohio.gov/Miscellaneous/Privacy");
				attr(div10, "class", "separator hide-separator svelte-1759by3");
				attr(a6, "class", "jobs svelte-1759by3");
				attr(a6, "href", "http://education.ohio.gov/About/Education-Jobs");
				attr(div11, "class", "separator hide-separator svelte-1759by3");
				attr(a7, "class", "employees svelte-1759by3");
				attr(a7, "href", "http://education.ohio.gov/Miscellaneous/Employees");
				attr(div12, "class", "privacy-jobs-employees svelte-1759by3");
				attr(div13, "class", "separator svelte-1759by3");
				attr(a8, "class", "site-map svelte-1759by3");
				attr(a8, "href", "http://education.ohio.gov/Miscellaneous/Sitemap");
				attr(div14, "class", "separator hide-separator svelte-1759by3");
				attr(a9, "class", "contact svelte-1759by3");
				attr(a9, "href", "http://education.ohio.gov/Contact");
				attr(div15, "class", "site-map-contact svelte-1759by3");
				attr(div16, "class", "governor-details svelte-1759by3");
				attr(div17, "class", "equal-opportunity svelte-1759by3");
				attr(div17, "contenteditable", "false");
				if (/*equalOpportunity*/ ctx[3] === void 0) add_render_callback(() => /*div17_input_handler*/ ctx[18].call(div17));
				attr(div18, "class", "footer-container svelte-1759by3");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div18, anchor);
				append(div18, a0);
				append(a0, t1);
				append(div18, t2);
				append(div18, div4);
				append(div4, div1);
				append(div1, a1);
				append(a1, t3);
				append(div1, t4);
				append(div1, div0);

				if (/*deptHeadTitle*/ ctx[0] !== void 0) {
					div0.innerText = /*deptHeadTitle*/ ctx[0];
				}

				append(div4, t5);
				append(div4, div2);
				append(div4, t7);
				append(div4, div3);

				if (/*deptHeadAddress*/ ctx[1] !== void 0) {
					div3.innerText = /*deptHeadAddress*/ ctx[1];
				}

				append(div18, t8);
				append(div18, div8);
				append(div8, div5);

				if (/*deptHeadPhoneNumber*/ ctx[2] !== void 0) {
					div5.innerText = /*deptHeadPhoneNumber*/ ctx[2];
				}

				append(div8, t9);
				append(div8, div6);
				append(div8, t11);
				append(div8, a2);
				append(a2, t12);
				append(a2, i);
				append(div8, t13);
				append(div8, div7);
				append(div8, t15);
				append(div8, a3);
				append(a3, t16);
				append(div18, t17);
				append(div18, div16);
				append(div16, a4);
				append(a4, t18);
				append(a4, t19);
				append(div16, t20);
				append(div16, div12);
				append(div12, div9);
				append(div12, t22);
				append(div12, a5);
				append(a5, t23);
				append(div12, t24);
				append(div12, div10);
				append(div12, t26);
				append(div12, a6);
				append(a6, t27);
				append(div12, t28);
				append(div12, div11);
				append(div12, t30);
				append(div12, a7);
				append(a7, t31);
				append(div16, t32);
				append(div16, div15);
				append(div15, div13);
				append(div15, t34);
				append(div15, a8);
				append(a8, t35);
				append(div15, t36);
				append(div15, div14);
				append(div15, t38);
				append(div15, a9);
				append(a9, t39);
				append(div18, t40);
				append(div18, div17);

				if (/*equalOpportunity*/ ctx[3] !== void 0) {
					div17.innerText = /*equalOpportunity*/ ctx[3];
				}

				if (!mounted) {
					dispose = [
						listen(div0, "input", /*div0_input_handler*/ ctx[15]),
						listen(div3, "input", /*div3_input_handler*/ ctx[16]),
						listen(div5, "input", /*div5_input_handler*/ ctx[17]),
						listen(div17, "input", /*div17_input_handler*/ ctx[18])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*deptTitle*/ 16) set_data(t1, /*deptTitle*/ ctx[4]);
				if (dirty & /*deptHeadName*/ 32) set_data(t3, /*deptHeadName*/ ctx[5]);

				if (dirty & /*deptHeadTitle*/ 1 && /*deptHeadTitle*/ ctx[0] !== div0.innerText) {
					div0.innerText = /*deptHeadTitle*/ ctx[0];
				}

				if (dirty & /*deptHeadAddress*/ 2 && /*deptHeadAddress*/ ctx[1] !== div3.innerText) {
					div3.innerText = /*deptHeadAddress*/ ctx[1];
				}

				if (dirty & /*deptHeadPhoneNumber*/ 4 && /*deptHeadPhoneNumber*/ ctx[2] !== div5.innerText) {
					div5.innerText = /*deptHeadPhoneNumber*/ ctx[2];
				}

				if (dirty & /*alertsTitle*/ 64) set_data(t12, /*alertsTitle*/ ctx[6]);
				if (dirty & /*eduContactEmail*/ 128) set_data(t16, /*eduContactEmail*/ ctx[7]);
				if (dirty & /*governorName*/ 256) set_data(t18, /*governorName*/ ctx[8]);
				if (dirty & /*governorTitle*/ 512) set_data(t19, /*governorTitle*/ ctx[9]);
				if (dirty & /*privacy*/ 1024) set_data(t23, /*privacy*/ ctx[10]);
				if (dirty & /*jobs*/ 2048) set_data(t27, /*jobs*/ ctx[11]);
				if (dirty & /*employees*/ 4096) set_data(t31, /*employees*/ ctx[12]);
				if (dirty & /*siteMap*/ 8192) set_data(t35, /*siteMap*/ ctx[13]);
				if (dirty & /*contact*/ 16384) set_data(t39, /*contact*/ ctx[14]);

				if (dirty & /*equalOpportunity*/ 8 && /*equalOpportunity*/ ctx[3] !== div17.innerText) {
					div17.innerText = /*equalOpportunity*/ ctx[3];
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div18);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$k($$self, $$props, $$invalidate) {
		createEventDispatcher();
		let { deptTitle = 'Ohio Department Of Education and Workforce' } = $$props;
		let { deptHeadName = 'Stephen D. Dackin' } = $$props;
		let { deptHeadTitle = ', Director' } = $$props;
		let { deptHeadAddress = '25 South Front Street, Columbus, Ohio 43215' } = $$props;
		let { deptHeadPhoneNumber = '1-877-644-6338' } = $$props;
		let { alertsTitle = 'Sign-up for Alerts' } = $$props;
		let { eduContactEmail = 'contact.center@education.ohio.gov' } = $$props;
		let { governorName = 'Michael DeWine' } = $$props;
		let { governorTitle = ', Governor' } = $$props;
		let { privacy = 'Privacy' } = $$props;
		let { jobs = 'Jobs' } = $$props;
		let { employees = 'Employees' } = $$props;
		let { siteMap = 'Site Map' } = $$props;
		let { contact = 'Contact DEW' } = $$props;
		let { equalOpportunity = 'The Department of Education and Workforce is an equal opportunity provider of ADA services' } = $$props;

		onMount(async () => {
			
		});

		function div0_input_handler() {
			deptHeadTitle = this.innerText;
			$$invalidate(0, deptHeadTitle);
		}

		function div3_input_handler() {
			deptHeadAddress = this.innerText;
			$$invalidate(1, deptHeadAddress);
		}

		function div5_input_handler() {
			deptHeadPhoneNumber = this.innerText;
			$$invalidate(2, deptHeadPhoneNumber);
		}

		function div17_input_handler() {
			equalOpportunity = this.innerText;
			$$invalidate(3, equalOpportunity);
		}

		$$self.$$set = $$props => {
			if ('deptTitle' in $$props) $$invalidate(4, deptTitle = $$props.deptTitle);
			if ('deptHeadName' in $$props) $$invalidate(5, deptHeadName = $$props.deptHeadName);
			if ('deptHeadTitle' in $$props) $$invalidate(0, deptHeadTitle = $$props.deptHeadTitle);
			if ('deptHeadAddress' in $$props) $$invalidate(1, deptHeadAddress = $$props.deptHeadAddress);
			if ('deptHeadPhoneNumber' in $$props) $$invalidate(2, deptHeadPhoneNumber = $$props.deptHeadPhoneNumber);
			if ('alertsTitle' in $$props) $$invalidate(6, alertsTitle = $$props.alertsTitle);
			if ('eduContactEmail' in $$props) $$invalidate(7, eduContactEmail = $$props.eduContactEmail);
			if ('governorName' in $$props) $$invalidate(8, governorName = $$props.governorName);
			if ('governorTitle' in $$props) $$invalidate(9, governorTitle = $$props.governorTitle);
			if ('privacy' in $$props) $$invalidate(10, privacy = $$props.privacy);
			if ('jobs' in $$props) $$invalidate(11, jobs = $$props.jobs);
			if ('employees' in $$props) $$invalidate(12, employees = $$props.employees);
			if ('siteMap' in $$props) $$invalidate(13, siteMap = $$props.siteMap);
			if ('contact' in $$props) $$invalidate(14, contact = $$props.contact);
			if ('equalOpportunity' in $$props) $$invalidate(3, equalOpportunity = $$props.equalOpportunity);
		};

		return [
			deptHeadTitle,
			deptHeadAddress,
			deptHeadPhoneNumber,
			equalOpportunity,
			deptTitle,
			deptHeadName,
			alertsTitle,
			eduContactEmail,
			governorName,
			governorTitle,
			privacy,
			jobs,
			employees,
			siteMap,
			contact,
			div0_input_handler,
			div3_input_handler,
			div5_input_handler,
			div17_input_handler
		];
	}

	class Eas_footer_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$k,
				create_fragment$k,
				safe_not_equal,
				{
					deptTitle: 4,
					deptHeadName: 5,
					deptHeadTitle: 0,
					deptHeadAddress: 1,
					deptHeadPhoneNumber: 2,
					alertsTitle: 6,
					eduContactEmail: 7,
					governorName: 8,
					governorTitle: 9,
					privacy: 10,
					jobs: 11,
					employees: 12,
					siteMap: 13,
					contact: 14,
					equalOpportunity: 3
				},
				add_css$j
			);
		}

		get deptTitle() {
			return this.$$.ctx[4];
		}

		set deptTitle(deptTitle) {
			this.$$set({ deptTitle });
			flush();
		}

		get deptHeadName() {
			return this.$$.ctx[5];
		}

		set deptHeadName(deptHeadName) {
			this.$$set({ deptHeadName });
			flush();
		}

		get deptHeadTitle() {
			return this.$$.ctx[0];
		}

		set deptHeadTitle(deptHeadTitle) {
			this.$$set({ deptHeadTitle });
			flush();
		}

		get deptHeadAddress() {
			return this.$$.ctx[1];
		}

		set deptHeadAddress(deptHeadAddress) {
			this.$$set({ deptHeadAddress });
			flush();
		}

		get deptHeadPhoneNumber() {
			return this.$$.ctx[2];
		}

		set deptHeadPhoneNumber(deptHeadPhoneNumber) {
			this.$$set({ deptHeadPhoneNumber });
			flush();
		}

		get alertsTitle() {
			return this.$$.ctx[6];
		}

		set alertsTitle(alertsTitle) {
			this.$$set({ alertsTitle });
			flush();
		}

		get eduContactEmail() {
			return this.$$.ctx[7];
		}

		set eduContactEmail(eduContactEmail) {
			this.$$set({ eduContactEmail });
			flush();
		}

		get governorName() {
			return this.$$.ctx[8];
		}

		set governorName(governorName) {
			this.$$set({ governorName });
			flush();
		}

		get governorTitle() {
			return this.$$.ctx[9];
		}

		set governorTitle(governorTitle) {
			this.$$set({ governorTitle });
			flush();
		}

		get privacy() {
			return this.$$.ctx[10];
		}

		set privacy(privacy) {
			this.$$set({ privacy });
			flush();
		}

		get jobs() {
			return this.$$.ctx[11];
		}

		set jobs(jobs) {
			this.$$set({ jobs });
			flush();
		}

		get employees() {
			return this.$$.ctx[12];
		}

		set employees(employees) {
			this.$$set({ employees });
			flush();
		}

		get siteMap() {
			return this.$$.ctx[13];
		}

		set siteMap(siteMap) {
			this.$$set({ siteMap });
			flush();
		}

		get contact() {
			return this.$$.ctx[14];
		}

		set contact(contact) {
			this.$$set({ contact });
			flush();
		}

		get equalOpportunity() {
			return this.$$.ctx[3];
		}

		set equalOpportunity(equalOpportunity) {
			this.$$set({ equalOpportunity });
			flush();
		}
	}

	customElements.define("eas-footer-swc", create_custom_element(Eas_footer_component, {"deptTitle":{},"deptHeadName":{},"deptHeadTitle":{},"deptHeadAddress":{},"deptHeadPhoneNumber":{},"alertsTitle":{},"eduContactEmail":{},"governorName":{},"governorTitle":{},"privacy":{},"jobs":{},"employees":{},"siteMap":{},"contact":{},"equalOpportunity":{}}, [], [], true));

	/* src\lib\web-components\stepper\eas-stepper.component.svelte generated by Svelte v4.2.19 */

	function add_css$i(target) {
		append_styles(target, "svelte-18pa9lr", ".body-div.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{height:100%;margin:0;padding:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#000;font-family:'Source Sans Pro', sans-serif}.ptb-20.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{padding-top:20px !important;padding-bottom:20px !important}section.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr,div.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{background:transparent;transition:all .2s ease-in-out}.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr,.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr:after,.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr:before{box-sizing:border-box;padding:0;margin:0}li.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{max-width:720px}ol.svelte-18pa9lr>li.svelte-18pa9lr.svelte-18pa9lr{padding:8px 10px 8px 8px;line-height:24px}.sr-only.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{position:absolute;left:-999em;right:auto}.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr::before,.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment.step-indicator__segment--complete.svelte-18pa9lr.svelte-18pa9lr::before,.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::before{content:'';position:absolute;left:0;top:calc(50% - 20px);z-index:0;display:flex;align-items:center;justify-content:center;height:40px;width:40px;border-radius:50%;font-weight:400;font-size:18px;line-height:0;background:transparent;cursor:pointer}.step-indicator__segments.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{max-width:100%!important;display:flex;list-style:none;margin:0;padding:0}.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr{position:relative;flex:1 1 0%;min-height:8px;max-width:240px}ol.step-indicator__segments.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{counter-reset:step-indicator}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr{counter-increment:step-indicatior}.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr::before,.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--complete.svelte-18pa9lr.svelte-18pa9lr::before,.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::before{content:counter(step-indicatior);font-feature-settings:\"tnum\" 1,\"kern\" 1}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr::before{content:counter(step-indicatior);border:3px solid transparent;color:#2c2c2c;font-weight:600;background:#D9D9D9}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--complete.svelte-18pa9lr.svelte-18pa9lr::before{border:3px solid transparent!important;color:white}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::before{font-weight:600;border:3px solid transparent!important;color:white;background:#2c2c2c}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr>.step-indicator__segment-label.svelte-18pa9lr{font-weight:600}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr::after{content:'';position:absolute;left:37px;display:flex;justify-content:center;width:calc(100% - 35px);max-width:80%;height:5px;background:#D9D9D9}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::after{max-width:calc(100% - 50px);border:3px solid transparent!important;background:#BFBFBF;color:white}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--complete.svelte-18pa9lr.svelte-18pa9lr::after{border:3px solid transparent!important;background:#3C7AA9;color:white;max-width:100%\r\n}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr:last-of-type::after{content:'';display:none}ol.step-indicator__segments.step--number.steps-blue-800.svelte-18pa9lr>.step-indicator__segment--complete.svelte-18pa9lr.svelte-18pa9lr::before{background:#f45a5c!important}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--complete.svelte-18pa9lr.svelte-18pa9lr::after{border:3px solid transparent!important;background:#f45a5c;color:white;max-width:100%\r\n}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::before{font-weight:600;border:3px solid transparent!important;color:white;background:#f45a5c}ol.step-indicator__segments.step--number.steps-blue-800.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::after{background:#f45a5c!important}.step-indicator__segments.svelte-18pa9lr>li.step-indicator__segment.svelte-18pa9lr>.step-indicator__segment-label.svelte-18pa9lr{position:absolute;display:block;font-size:16px;font-weight:400;padding-right:15px;text-align:left;margin-top:30px;color:black;user-select:none}@media screen and (max-width: 768px){.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr::before,.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--complete.svelte-18pa9lr.svelte-18pa9lr::before,.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::before{display:none!important}ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr:last-of-type::after,ol.step-indicator__segments.step--number.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr::after{content:'';position:absolute;left:0!important;display:flex;justify-content:center;width:calc(100% - 1px)!important;max-width:100%!important;height:6px!important}ol.step-indicator__segments.svelte-18pa9lr>li.step-indicator__segment.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::after{width:calc(100% - 1px)!important}.step-indicator__segment-label.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{margin-top:20px!important}}@media screen and (max-width: 512px){.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr::before,.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment--complete.svelte-18pa9lr.svelte-18pa9lr::before,.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::before{display:none!important}.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr:last-of-type::after,.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment.svelte-18pa9lr.svelte-18pa9lr::after{content:'';position:absolute;left:0;display:flex;justify-content:center;width:calc(100% - 1px);max-width:100%}.step-indicator__segments.svelte-18pa9lr>.step-indicator__segment--current.svelte-18pa9lr.svelte-18pa9lr::after{max-width:100%!important}.step-indicator__segment-label.svelte-18pa9lr.svelte-18pa9lr.svelte-18pa9lr{display:none!important}}");
	}

	function get_each_context$6(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[12] = list[i];
		child_ctx[14] = i;
		return child_ctx;
	}

	// (50:0) {#if stepperdata && stepperdata.length > 0}
	function create_if_block$b(ctx) {
		let div1;
		let br0;
		let t0;
		let section;
		let div0;
		let ol;
		let t1;
		let br1;
		let each_value = ensure_array_like(/*stepperdata*/ ctx[0]);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$6(get_each_context$6(ctx, each_value, i));
		}

		return {
			c() {
				div1 = element("div");
				br0 = element("br");
				t0 = space();
				section = element("section");
				div0 = element("div");
				ol = element("ol");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t1 = space();
				br1 = element("br");
				attr(br0, "class", "svelte-18pa9lr");
				attr(ol, "class", "step-indicator__segments step--number steps-blue-800 svelte-18pa9lr");
				attr(div0, "class", "step-container ptb-20 svelte-18pa9lr");
				attr(div0, "aria-label", "progress");
				attr(section, "class", "body-div svelte-18pa9lr");
				attr(br1, "class", "svelte-18pa9lr");
				attr(div1, "class", "svelte-18pa9lr");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, br0);
				append(div1, t0);
				append(div1, section);
				append(section, div0);
				append(div0, ol);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(ol, null);
					}
				}

				append(div1, t1);
				append(div1, br1);
			},
			p(ctx, dirty) {
				if (dirty & /*onClick, stepperdata*/ 3) {
					each_value = ensure_array_like(/*stepperdata*/ ctx[0]);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$6(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$6(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(ol, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div1);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (76:16) {:else}
	function create_else_block$6(ctx) {
		let li;
		let span1;
		let t0_value = /*item*/ ctx[12].label + "";
		let t0;
		let t1;
		let span0;
		let t3;
		let mounted;
		let dispose;

		function click_handler_2(...args) {
			return /*click_handler_2*/ ctx[4](/*item*/ ctx[12], ...args);
		}

		return {
			c() {
				li = element("li");
				span1 = element("span");
				t0 = text(t0_value);
				t1 = space();
				span0 = element("span");
				span0.textContent = "not started";
				t3 = space();
				attr(span0, "class", "sr-only svelte-18pa9lr");
				attr(span1, "class", "step-indicator__segment-label svelte-18pa9lr");
				attr(li, "class", "step-indicator__segment svelte-18pa9lr");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, span1);
				append(span1, t0);
				append(span1, t1);
				append(span1, span0);
				append(li, t3);

				if (!mounted) {
					dispose = listen(li, "click", click_handler_2);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*stepperdata*/ 1 && t0_value !== (t0_value = /*item*/ ctx[12].label + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (68:39) 
	function create_if_block_2$6(ctx) {
		let li;
		let span1;
		let t0_value = /*item*/ ctx[12].label + "";
		let t0;
		let t1;
		let span0;
		let t3;
		let mounted;
		let dispose;

		function click_handler_1(...args) {
			return /*click_handler_1*/ ctx[3](/*item*/ ctx[12], ...args);
		}

		return {
			c() {
				li = element("li");
				span1 = element("span");
				t0 = text(t0_value);
				t1 = space();
				span0 = element("span");
				span0.textContent = "not completed";
				t3 = space();
				attr(span0, "class", "sr-only svelte-18pa9lr");
				attr(span1, "class", "step-indicator__segment-label svelte-18pa9lr");
				attr(li, "class", "step-indicator__segment step-indicator__segment--current svelte-18pa9lr");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, span1);
				append(span1, t0);
				append(span1, t1);
				append(span1, span0);
				append(li, t3);

				if (!mounted) {
					dispose = listen(li, "click", click_handler_1);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*stepperdata*/ 1 && t0_value !== (t0_value = /*item*/ ctx[12].label + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (60:16) {#if item.completed}
	function create_if_block_1$9(ctx) {
		let li;
		let span1;
		let t0_value = /*item*/ ctx[12].label + "";
		let t0;
		let t1;
		let span0;
		let t3;
		let mounted;
		let dispose;

		function click_handler(...args) {
			return /*click_handler*/ ctx[2](/*item*/ ctx[12], ...args);
		}

		return {
			c() {
				li = element("li");
				span1 = element("span");
				t0 = text(t0_value);
				t1 = space();
				span0 = element("span");
				span0.textContent = "completed";
				t3 = space();
				attr(span0, "class", "sr-only svelte-18pa9lr");
				attr(span1, "class", "step-indicator__segment-label svelte-18pa9lr");
				attr(li, "class", "step-indicator__segment step-indicator__segment--complete svelte-18pa9lr");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, span1);
				append(span1, t0);
				append(span1, t1);
				append(span1, span0);
				append(li, t3);

				if (!mounted) {
					dispose = listen(li, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*stepperdata*/ 1 && t0_value !== (t0_value = /*item*/ ctx[12].label + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (58:16) {#each stepperdata as item, index}
	function create_each_block$6(ctx) {
		let if_block_anchor;

		function select_block_type(ctx, dirty) {
			if (/*item*/ ctx[12].completed) return create_if_block_1$9;
			if (/*item*/ ctx[12].current) return create_if_block_2$6;
			return create_else_block$6;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty();
			},
			m(target, anchor) {
				if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				}
			},
			d(detaching) {
				if (detaching) {
					detach(if_block_anchor);
				}

				if_block.d(detaching);
			}
		};
	}

	function create_fragment$j(ctx) {
		let if_block_anchor;
		let if_block = /*stepperdata*/ ctx[0] && /*stepperdata*/ ctx[0].length > 0 && create_if_block$b(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, [dirty]) {
				if (/*stepperdata*/ ctx[0] && /*stepperdata*/ ctx[0].length > 0) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$b(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(if_block_anchor);
				}

				if (if_block) if_block.d(detaching);
			}
		};
	}

	function instance$j($$self, $$props, $$invalidate) {
		let { stepperdata = [] } = $$props;
		const svelteDispatch = createEventDispatcher();

		beforeUpdate(() => {
			if (typeof stepperdata === "string") {
				$$invalidate(0, stepperdata = JSON.parse(stepperdata));
			}
		});

		onMount(() => {
			if (typeof stepperdata === "string") {
				$$invalidate(0, stepperdata = JSON.parse(stepperdata));
			}
		});

		function onClick(item, e) {
			let eventData = { ...e, detail: item };
			console.log('clicked event data=', eventData);
			console.log(' $$props= ', $$props);
			e.stopPropagation();

			//setActive(item);
			svelteDispatch("click", item);
		}

		const click_handler = (item, e) => onClick(item, e);
		const click_handler_1 = (item, e) => onClick(item, e);
		const click_handler_2 = (item, e) => onClick(item, e);

		$$self.$$set = $$new_props => {
			$$invalidate(11, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
			if ('stepperdata' in $$new_props) $$invalidate(0, stepperdata = $$new_props.stepperdata);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*stepperdata*/ 1) {
				[...stepperdata].findIndex(t => t.selected) + 1;
			}

			if ($$self.$$.dirty & /*stepperdata*/ 1) {
				[...stepperdata].findIndex(t => t.current) + 1;
			}
		};

		$$props = exclude_internal_props($$props);
		return [stepperdata, onClick, click_handler, click_handler_1, click_handler_2];
	}

	class Eas_stepper_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$j, create_fragment$j, safe_not_equal, { stepperdata: 0 }, add_css$i);
		}

		get stepperdata() {
			return this.$$.ctx[0];
		}

		set stepperdata(stepperdata) {
			this.$$set({ stepperdata });
			flush();
		}
	}

	customElements.define("eas-stepper-swc", create_custom_element(Eas_stepper_component, {"stepperdata":{}}, [], [], true));

	/* src\lib\web-components\graphic-stepper\eas-graphic-stepper.component.svelte generated by Svelte v4.2.19 */

	function add_css$h(target) {
		append_styles(target, "svelte-1sxxh7g", ".body-div.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{height:100%;margin:0;padding:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#000;font-family:'Source Sans Pro', sans-serif}.ptb-20.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{padding-top:20px !important;padding-bottom:20px !important}section.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g,div.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{background:transparent;transition:all .2s ease-in-out}.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g,.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g:after,.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g:before{box-sizing:border-box;padding:0;margin:0}ul.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g,li.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{max-width:720px}ul.svelte-1sxxh7g>li.svelte-1sxxh7g.svelte-1sxxh7g{padding:8px 10px 8px 8px;line-height:24px}.sr-only.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{position:absolute;left:-999em;right:auto}.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment.step-indicator__segment--complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::before{content:'';position:absolute;left:0;top:calc(50% - 20px);z-index:100;display:flex;align-items:center;justify-content:center;height:40px;width:40px;border-radius:50%;font-weight:400;font-size:18px;line-height:0;background:transparent}.step-indicator__segments.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{max-width:100%!important;display:flex;list-style:none;margin:0;padding:0}.step-indicator__segment---current.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{width:17px;color:rgb(255, 255, 255);position:absolute;z-index:999;top:-3px;left:12px}.step-indicator__segment---complete.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{width:17px;color:rgb(255, 255, 255);position:absolute;z-index:999;top:-3px;left:12px}.step-indicator__segment---current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{width:17px;color:#000;position:absolute;z-index:999;top:-3px;left:12px}.step-indicator__segments.step--icon.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{max-width:100%!important;display:flex;list-style:none;margin:0;padding:0}.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g{position:relative;flex:1 1 0%;min-height:8px;max-width:240px}.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.step-indicator__segment--complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::before{content:''}.step-indicator__segments.step--icon.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g::before{content:'';background:#D9D9D9;color:#D9D9D9;border:3px solid transparent!important}.step-indicator__segments.step--icon.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::before{content:'';font-weight:400;font-size:18px;border:0em solid black;background:black;color:white}.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g::after{content:'';position:absolute;left:38px;display:flex;justify-content:center;width:calc(100% - 36px);max-width:80%;height:5px;background:#D9D9D9}.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::after,.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::after{border:3px solid transparent!important;background:#D9D9D9;color:white;max-width:calc(100% - 50px)}.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::after{max-width:calc(100% - 36px)!important}.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment--complete.svelte-1sxxh7g.svelte-1sxxh7g::after{border:3px solid transparent!important;background:#D9D9D9;color:white;max-width:100%}.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g:last-of-type::after{content:'';display:none}.step-indicator__segments.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g>.step-indicator__segment-label.svelte-1sxxh7g,.step-indicator__segments.svelte-1sxxh7g>li.step-indicator__segment.svelte-1sxxh7g>.step-indicator__segment-label.svelte-1sxxh7g{position:absolute;display:block;font-size:16px;font-weight:400;padding-right:15px;text-align:left;margin-top:30px;color:black;user-select:none}.step-indicator__segments.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g>.step-indicator__segment-label.svelte-1sxxh7g{font-weight:bold}.step-indicator__segments.steps-red-600.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--complete.svelte-1sxxh7g.svelte-1sxxh7g::before{border:3px solid transparent!important;background:#F45A5C}.step-indicator__segments.steps-red-600.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.steps-red-600.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::before{font-weight:400;font-size:18px;border:0em solid #F45A5C!important;background:#F45A5C!important;color:white}.step-indicator__segments.steps-red-600.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before{border:0em solid #d9d9d9!important;background:#d9d9d9!important;color:#000 !important}.step-indicator__segments.steps-red-600.svelte-1sxxh7g>li.step-indicator__segment--current.svelte-1sxxh7g>.step-indicator__segment-label.svelte-1sxxh7g{font-weight:600;color:#F45A5C}.step-indicator__segments.steps-red-600.svelte-1sxxh7g>.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::after{border:3px solid transparent!important;background:#d9d9d9;color:white}.step-indicator__segments.steps-red-600.svelte-1sxxh7g>.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::after{border:3px solid transparent!important;background:#F45A5C;color:white}.step-indicator__segments.steps-red-600.svelte-1sxxh7g>.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::after{border:3px solid transparent!important;background:#d9d9d9;color:white}.step-indicator__segments.steps-red-600.svelte-1sxxh7g>.step-indicator__segment--complete.svelte-1sxxh7g.svelte-1sxxh7g::after{border:3px solid transparent!important;background:#F45A5C;color:white}.step-indicator__segments.step--icon.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::before{content:'';font-weight:400;font-size:18px;border:0em solid black;background:black;color:white;font-family:'font awesome 5 pro'}.step-indicator__segments.step--icon.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--complete.svelte-1sxxh7g.svelte-1sxxh7g::before{border:3px solid transparent!important;color:white;font-family:'font awesome 5 pro';font-family:'FontAwesome'}.step-indicator__segments.step--icon.marker-icon.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.marker-icon.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::before{font-weight:bold}a.click.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{position:absolute;display:block;width:39px;height:39px;z-index:9999;border-radius:50%;top:-12px;left:0}@media screen and (max-width: 768px){.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment--complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::before{display:none!important}ul.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g:last-of-type::after,ul.step-indicator__segments.step--icon.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g::after{content:'';position:absolute;left:0!important;display:flex;justify-content:center;width:calc(100% - 1px)!important;max-width:100%!important;height:6px!important}ul.step-indicator__segments.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::after,ul.step-indicator__segments.svelte-1sxxh7g>li.step-indicator__segment.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::after{width:calc(100% - 1px)!important}.step-indicator__segment-label.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{margin-top:20px!important}}@media screen and (max-width: 512px){.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment--complete.svelte-1sxxh7g.svelte-1sxxh7g::before,.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::before{display:none!important}.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g:last-of-type::after,.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment.svelte-1sxxh7g.svelte-1sxxh7g::after{content:'';position:absolute;left:0;display:flex;justify-content:center;width:calc(100% - 1px);max-width:100%}.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g::after,.step-indicator__segments.svelte-1sxxh7g>.step-indicator__segment--current.svelte-1sxxh7g.svelte-1sxxh7g::after,.step-indicator__segment--current--not-complete.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g,.step-indicator__segment---current.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{max-width:100%!important}.step-indicator__segment-label.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{display:none!important}.step-indicator__segment---current.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{display:none}.step-indicator__segment---complete.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{display:none}}@media screen and (max-width: 414px){a.click.svelte-1sxxh7g.svelte-1sxxh7g.svelte-1sxxh7g{width:100%;height:7px;z-index:9999;border-radius:0;top:8px;left:0}}");
	}

	function get_each_context$5(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[1] = list[i];
		child_ctx[14] = i;
		return child_ctx;
	}

	// (105:0) {#if stepper.items.length > 0}
	function create_if_block$a(ctx) {
		let div1;
		let section;
		let div0;
		let ul;
		let each_value = ensure_array_like(/*stepper*/ ctx[0].items);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$5(get_each_context$5(ctx, each_value, i));
		}

		return {
			c() {
				div1 = element("div");
				section = element("section");
				div0 = element("div");
				ul = element("ul");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				attr(ul, "class", "step-indicator__segments step--icon steps-red-600 marker-icon svelte-1sxxh7g");
				attr(div0, "class", "step-container ptb-20 svelte-1sxxh7g");
				attr(div0, "aria-label", "progress");
				attr(section, "class", "body-div svelte-1sxxh7g");
				attr(div1, "class", "svelte-1sxxh7g");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, section);
				append(section, div0);
				append(div0, ul);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(ul, null);
					}
				}
			},
			p(ctx, dirty) {
				if (dirty & /*stepper, onClick*/ 5) {
					each_value = ensure_array_like(/*stepper*/ ctx[0].items);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$5(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$5(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(ul, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div1);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (147:20) {:else}
	function create_else_block$5(ctx) {
		let li;
		let span1;
		let t0_value = /*item*/ ctx[1].label + "";
		let t0;
		let t1;
		let span0;
		let t3;

		return {
			c() {
				li = element("li");
				span1 = element("span");
				t0 = text(t0_value);
				t1 = space();
				span0 = element("span");
				span0.textContent = "not completed";
				t3 = space();
				attr(span0, "class", "sr-only svelte-1sxxh7g");
				attr(span1, "class", "step-indicator__segment-label svelte-1sxxh7g");
				attr(li, "class", "step-indicator__segment svelte-1sxxh7g");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, span1);
				append(span1, t0);
				append(span1, t1);
				append(span1, span0);
				append(li, t3);
			},
			p(ctx, dirty) {
				if (dirty & /*stepper*/ 1 && t0_value !== (t0_value = /*item*/ ctx[1].label + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}
			}
		};
	}

	// (136:62) 
	function create_if_block_3$2(ctx) {
		let li;
		let a;
		let t0;
		let div;
		let t1;
		let span1;
		let t2_value = /*item*/ ctx[1].label + "";
		let t2;
		let t3;
		let span0;
		let t5;
		let mounted;
		let dispose;

		function click_handler_2(...args) {
			return /*click_handler_2*/ ctx[9](/*item*/ ctx[1], ...args);
		}

		return {
			c() {
				li = element("li");
				a = element("a");
				t0 = space();
				div = element("div");
				div.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svelte-1sxxh7g"><path fill="currentColor" d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z" class="svelte-1sxxh7g"></path></svg>`;
				t1 = space();
				span1 = element("span");
				t2 = text(t2_value);
				t3 = space();
				span0 = element("span");
				span0.textContent = "not completed";
				t5 = space();
				attr(a, "href", "javascript:void(0)");
				attr(a, "class", "click svelte-1sxxh7g");
				attr(div, "class", "step-indicator__segment---current--not-complete svelte-1sxxh7g");
				attr(span0, "class", "sr-only svelte-1sxxh7g");
				attr(span1, "class", "step-indicator__segment-label svelte-1sxxh7g");
				attr(li, "class", "step-indicator__segment step-indicator__segment--current--not-complete svelte-1sxxh7g");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, a);
				append(li, t0);
				append(li, div);
				append(li, t1);
				append(li, span1);
				append(span1, t2);
				append(span1, t3);
				append(span1, span0);
				append(li, t5);

				if (!mounted) {
					dispose = listen(a, "click", click_handler_2);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*stepper*/ 1 && t2_value !== (t2_value = /*item*/ ctx[1].label + "")) set_data(t2, t2_value);
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (125:62) 
	function create_if_block_2$5(ctx) {
		let li;
		let a;
		let t0;
		let div;
		let t1;
		let span1;
		let t2_value = /*item*/ ctx[1].label + "";
		let t2;
		let t3;
		let span0;
		let t5;
		let mounted;
		let dispose;

		function click_handler_1(...args) {
			return /*click_handler_1*/ ctx[8](/*item*/ ctx[1], ...args);
		}

		return {
			c() {
				li = element("li");
				a = element("a");
				t0 = space();
				div = element("div");
				div.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svelte-1sxxh7g"><path fill="currentColor" d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z" class="svelte-1sxxh7g"></path></svg>`;
				t1 = space();
				span1 = element("span");
				t2 = text(t2_value);
				t3 = space();
				span0 = element("span");
				span0.textContent = "completed";
				t5 = space();
				attr(a, "href", "javascript:void(0)");
				attr(a, "class", "click svelte-1sxxh7g");
				attr(div, "class", "step-indicator__segment---current svelte-1sxxh7g");
				attr(span0, "class", "sr-only svelte-1sxxh7g");
				attr(span1, "class", "step-indicator__segment-label svelte-1sxxh7g");
				attr(li, "class", "step-indicator__segment step-indicator__segment--current svelte-1sxxh7g");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, a);
				append(li, t0);
				append(li, div);
				append(li, t1);
				append(li, span1);
				append(span1, t2);
				append(span1, t3);
				append(span1, span0);
				append(li, t5);

				if (!mounted) {
					dispose = listen(a, "click", click_handler_1);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*stepper*/ 1 && t2_value !== (t2_value = /*item*/ ctx[1].label + "")) set_data(t2, t2_value);
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (113:20) {#if item.completed && !item.selected}
	function create_if_block_1$8(ctx) {
		let li;
		let a;
		let t0;
		let div;
		let t1;
		let span1;
		let t2_value = /*item*/ ctx[1].label + "";
		let t2;
		let t3;
		let span0;
		let t5;
		let mounted;
		let dispose;

		function click_handler(...args) {
			return /*click_handler*/ ctx[7](/*item*/ ctx[1], ...args);
		}

		return {
			c() {
				li = element("li");
				a = element("a");
				t0 = space();
				div = element("div");
				div.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svelte-1sxxh7g"><path fill="currentColor" d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" class="svelte-1sxxh7g"></path></svg>`;
				t1 = space();
				span1 = element("span");
				t2 = text(t2_value);
				t3 = space();
				span0 = element("span");
				span0.textContent = "completed";
				t5 = space();
				attr(a, "href", "javascript:void(0)");
				attr(a, "class", "click svelte-1sxxh7g");
				attr(div, "class", "step-indicator__segment---complete svelte-1sxxh7g");
				attr(span0, "class", "sr-only svelte-1sxxh7g");
				attr(span1, "class", "step-indicator__segment-label svelte-1sxxh7g");
				attr(li, "class", "step-indicator__segment step-indicator__segment--complete svelte-1sxxh7g");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, a);
				append(li, t0);
				append(li, div);
				append(li, t1);
				append(li, span1);
				append(span1, t2);
				append(span1, t3);
				append(span1, span0);
				append(li, t5);

				if (!mounted) {
					dispose = listen(a, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*stepper*/ 1 && t2_value !== (t2_value = /*item*/ ctx[1].label + "")) set_data(t2, t2_value);
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (111:16) {#each stepper.items as item, index}
	function create_each_block$5(ctx) {
		let if_block_anchor;

		function select_block_type(ctx, dirty) {
			if (/*item*/ ctx[1].completed && !/*item*/ ctx[1].selected) return create_if_block_1$8;
			if (/*item*/ ctx[1].selected && /*item*/ ctx[1].completed) return create_if_block_2$5;
			if (/*item*/ ctx[1].current && !/*item*/ ctx[1].completed) return create_if_block_3$2;
			return create_else_block$5;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty();
			},
			m(target, anchor) {
				if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				}
			},
			d(detaching) {
				if (detaching) {
					detach(if_block_anchor);
				}

				if_block.d(detaching);
			}
		};
	}

	function create_fragment$i(ctx) {
		let if_block_anchor;
		let if_block = /*stepper*/ ctx[0].items.length > 0 && create_if_block$a(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, [dirty]) {
				if (/*stepper*/ ctx[0].items.length > 0) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$a(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(if_block_anchor);
				}

				if (if_block) if_block.d(detaching);
			}
		};
	}

	function instance$i($$self, $$props, $$invalidate) {
		let { stepper = { items: [] } } = $$props;
		let { clickpos = 0 } = $$props;
		let { currentpos = 0 } = $$props;
		const svelteDispatch = createEventDispatcher();
		let item = { url: window.location.href };

		function resetSteps() {
			stepper.items?.forEach(i => (i.current = false, i.completed = false));
			$$invalidate(4, currentpos = 0);
			$$invalidate(3, clickpos = 0);
			$$invalidate(0, stepper.items[currentpos].current = true, stepper);
			$$invalidate(0, stepper.items[currentpos].selected = true, stepper);
			$$invalidate(0, stepper.items = [...stepper.items], stepper);
			$$invalidate(1, item = stepper.items[currentpos]);
			let eventData = { detail: item };
			console.log('eventData=', eventData);
			svelteDispatch("reset", eventData);
		}

		function handleStepProgress(step) {
			stepper.items?.forEach(i => i.current = false);
			stepper.items?.forEach(i => i.selected = false);

			if (step == 1) {
				$$invalidate(4, currentpos++, currentpos);
			} else if (step == -1) {
				$$invalidate(4, currentpos--, currentpos);
			}

			console.log('component currentpos=', currentpos);

			if (stepper.items.length > 0 && currentpos >= 0 && stepper.items.length > currentpos) {
				for (let i = 0; i < currentpos; i++) {
					$$invalidate(0, stepper.items[i].completed = true, stepper);
				}

				$$invalidate(0, stepper.items[currentpos].current = true, stepper);
				$$invalidate(0, stepper.items[currentpos].selected = true, stepper);
				$$invalidate(0, stepper.items[currentpos].completed = false, stepper);
				$$invalidate(0, stepper.items = [...stepper.items], stepper);
				$$invalidate(1, item = stepper.items[currentpos]);
				$$invalidate(1, item.isFirst = false, item);
				$$invalidate(1, item.isLast = false, item);
				if (currentpos == stepper.items.length - 1) $$invalidate(1, item.isLast = true, item); else if (currentpos == 0) $$invalidate(1, item.isFirst = true, item);
				if (step == 1) svelteDispatch("next", item); else if (step == -1) svelteDispatch("prev", item);
			}
		}

		function onClick(item, e) {
			item.url = window.location.href;
			({ ...e, detail: item });

			// console.log('component clicked event data=', eventData);
			e.stopPropagation();

			setActive(item);

			// console.log('after setActive: currentpos|clickpos=', currentpos, '|', clickpos);
			svelteDispatch("click", item);
		} // dispatch("click", item, new CustomEvent("click", eventData));

		function setActive(item) {
			let selectedItem = stepper.items.find(i => i === item);
			stepper.items?.forEach(i => i.selected = false);
			selectedItem.selected = true;
			stepper.items?.forEach(i => i.current = false);
			selectedItem.current = true;
			$$invalidate(3, clickpos = stepper.items.findIndex(t => t.selected));
			$$invalidate(4, currentpos = stepper.items.findIndex(t => t.current));

			// console.log('selectedItem=', selectedItem);
			for (let i = 0; i < stepper.items.length; i++) {
				$$invalidate(0, stepper.items[i].completed = i < currentpos ? true : false, stepper);
			}

			$$invalidate(0, stepper.items = [...stepper.items], stepper);
		}

		beforeUpdate(() => {
			if (typeof stepper === "string") {
				$$invalidate(0, stepper = JSON.parse(stepper));
			}
		});

		onMount(() => {
			if (typeof stepper === "string") {
				$$invalidate(0, stepper = JSON.parse(stepper));
			}
		});

		const click_handler = (item, e) => onClick(item, e);
		const click_handler_1 = (item, e) => onClick(item, e);
		const click_handler_2 = (item, e) => onClick(item, e);

		$$self.$$set = $$props => {
			if ('stepper' in $$props) $$invalidate(0, stepper = $$props.stepper);
			if ('clickpos' in $$props) $$invalidate(3, clickpos = $$props.clickpos);
			if ('currentpos' in $$props) $$invalidate(4, currentpos = $$props.currentpos);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*stepper*/ 1) {
				$$invalidate(3, clickpos = stepper.items.findIndex(t => t.selected));
			}

			if ($$self.$$.dirty & /*stepper*/ 1) {
				$$invalidate(4, currentpos = stepper.items.findIndex(t => t.current));
			}
		};

		return [
			stepper,
			item,
			onClick,
			clickpos,
			currentpos,
			resetSteps,
			handleStepProgress,
			click_handler,
			click_handler_1,
			click_handler_2
		];
	}

	class Eas_graphic_stepper_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$i,
				create_fragment$i,
				safe_not_equal,
				{
					stepper: 0,
					clickpos: 3,
					currentpos: 4,
					resetSteps: 5,
					handleStepProgress: 6
				},
				add_css$h
			);
		}

		get stepper() {
			return this.$$.ctx[0];
		}

		set stepper(stepper) {
			this.$$set({ stepper });
			flush();
		}

		get clickpos() {
			return this.$$.ctx[3];
		}

		set clickpos(clickpos) {
			this.$$set({ clickpos });
			flush();
		}

		get currentpos() {
			return this.$$.ctx[4];
		}

		set currentpos(currentpos) {
			this.$$set({ currentpos });
			flush();
		}

		get resetSteps() {
			return this.$$.ctx[5];
		}

		get handleStepProgress() {
			return this.$$.ctx[6];
		}
	}

	customElements.define("eas-graphic-stepper-swc", create_custom_element(Eas_graphic_stepper_component, {"stepper":{},"clickpos":{},"currentpos":{}}, [], ["resetSteps","handleStepProgress"], true));

	/* src\lib\web-components\header\eas-header.component.svelte generated by Svelte v4.2.19 */

	function add_css$g(target) {
		append_styles(target, "svelte-xh3nj", ".logo.svelte-xh3nj.svelte-xh3nj{width:175px}.container-header.svelte-xh3nj.svelte-xh3nj{font-family:\"Source Sans Pro\", Tahoma, Verdana, Segoe, sans-serif;width:100%;background-color:#fff}.top-links-container.svelte-xh3nj.svelte-xh3nj{border:1px solid #d8d8d8;background-color:#f2f2f2}.top-links.svelte-xh3nj.svelte-xh3nj{display:flex;list-style:none;gap:1em;margin:3px}.top-links-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(1){margin-left:auto}.top-links--a.svelte-xh3nj.svelte-xh3nj{color:#525051;text-decoration:none}.top-links--a.svelte-xh3nj.svelte-xh3nj:hover{color:#000;text-decoration:none}.header-container.svelte-xh3nj.svelte-xh3nj{flex-grow:1;padding-right:10px}.header-content.svelte-xh3nj.svelte-xh3nj{display:flex;list-style:none;padding-left:0;gap:1em;margin-top:0;margin-bottom:0;height:71px}.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(1){width:63px}.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(3){margin-left:auto}.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(4){margin-left:auto;border-left:1px solid #a1a1a1;margin-top:8px;margin-bottom:8px}.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(6){margin-left:10px}.hamburger--a.svelte-xh3nj.svelte-xh3nj{text-decoration:none;width:33px;display:block;transition:0.2s;padding-top:8px;padding-left:15px;color:#4a4a4a}.hamburger--a.svelte-xh3nj.svelte-xh3nj:hover{color:#65101c}.hamburger--a.svelte-xh3nj:hover img.svelte-xh3nj{fill:#65101c}.user--a.svelte-xh3nj.svelte-xh3nj{text-decoration:none;display:block;color:#4a4a4a;font-size:48px;transition:0.2s;border-bottom:7px solid transparent}.user--a.svelte-xh3nj.svelte-xh3nj:hover{color:#65101c;border-bottom:7px solid #65101c}.active.user--a.svelte-xh3nj.svelte-xh3nj{color:#65101c;border-bottom:7px solid #65101c;text-decoration:none;transition:all 0.5s ease;padding-bottom:0}.help--a.svelte-xh3nj.svelte-xh3nj{text-decoration:none;width:37px;display:block;color:#4a4a4a;font-size:48px;transition:0.2s;border-bottom:7px solid transparent;margin-top:1px}.help--a.svelte-xh3nj.svelte-xh3nj:hover{color:#65101c;border-bottom:7px solid #65101c}.active.help--a.svelte-xh3nj.svelte-xh3nj{color:#65101c;border-bottom:7px solid #65101c;text-decoration:none;transition:all 0.5s ease;padding-bottom:0}.icon-text.svelte-xh3nj.svelte-xh3nj{font-size:9px;display:block;text-align:center;margin-top:9px;opacity:0.8}.hamburger--a.svelte-xh3nj .icon-text.svelte-xh3nj{margin-top:-8px;position:absolute}.icon-text.user-text.svelte-xh3nj.svelte-xh3nj{margin-top:-8px}.logo-container.svelte-xh3nj.svelte-xh3nj{width:192px;height:29px;position:relative;top:20px;top:17px}.top-logo.svelte-xh3nj.svelte-xh3nj{width:70px;margin-top:4px;margin-right:3px}@media(max-width: 768px){.logo-container.svelte-xh3nj.svelte-xh3nj{width:160px}.user--a.svelte-xh3nj.svelte-xh3nj,.help--a.svelte-xh3nj.svelte-xh3nj{font-size:43px;padding-top:5px;height:56px}}@media(max-width: 425px){.icon-text.svelte-xh3nj.svelte-xh3nj{font-size:12px}.top-links-container.svelte-xh3nj.svelte-xh3nj,.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(1),.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(4),.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(5),.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(6),.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(3){display:none}.header-content-li.svelte-xh3nj.svelte-xh3nj:nth-of-type(2){padding-left:8px}.header-content.svelte-xh3nj.svelte-xh3nj{margin-bottom:10px}}");
	}

	const get_menu_slot_changes = dirty => ({});
	const get_menu_slot_context = ctx => ({});

	function create_fragment$h(ctx) {
		let div4;
		let div1;
		let t10;
		let div3;
		let ul1;
		let li6;
		let a6;
		let img1;
		let img1_src_value;
		let t11;
		let span0;
		let t12;
		let t13;
		let li7;
		let t14;
		let li8;
		let t15;
		let li9;
		let t16;
		let li10;
		let a8;
		let img3;
		let img3_src_value;
		let t17;
		let span1;
		let t19;
		let li11;
		let a9;
		let img4;
		let img4_src_value;
		let t20;
		let span2;
		let current;
		let mounted;
		let dispose;
		const menu_slot_template = /*#slots*/ ctx[14].menu;
		const menu_slot = create_slot(menu_slot_template, ctx, /*$$scope*/ ctx[13], get_menu_slot_context);

		return {
			c() {
				div4 = element("div");
				div1 = element("div");
				div1.innerHTML = `<ul class="top-links svelte-xh3nj"><li class="top-links-li svelte-xh3nj"><a class="top-links--a svelte-xh3nj" href="https://education.ohio.gov/About">About</a></li> <li class="top-links-li svelte-xh3nj"><a class="top-links--a svelte-xh3nj" href="https://safe.ode.state.oh.us/portal/">DEW</a></li> <li class="top-links-li svelte-xh3nj"><a class="top-links--a svelte-xh3nj" href="https://ohio.gov">State</a></li> <li class="top-links-li svelte-xh3nj"><a class="top-links--a svelte-xh3nj" href="https://ohio.gov/agencies">Agencies</a></li> <li class="top-links-li svelte-xh3nj"><a class="top-links--a svelte-xh3nj" href="https://ohio.gov/services">Online Services</a></li> <li class="top-links-li svelte-xh3nj"><a class="top-links--a svelte-xh3nj" href="https://ohio.gov"><div class="top-logo svelte-xh3nj"><img src="assets/dist/assets/svg/DepartmentofEducationandWorkforce.svg"/></div></a></li></ul>`;
				t10 = space();
				div3 = element("div");
				ul1 = element("ul");
				li6 = element("li");
				a6 = element("a");
				img1 = element("img");
				t11 = space();
				span0 = element("span");
				t12 = text(/*togglemessage*/ ctx[3]);
				t13 = space();
				li7 = element("li");
				li7.innerHTML = `<div class="logo-container svelte-xh3nj"><a href="/"><img alt="logo" class="logo svelte-xh3nj" src="assets/dist/assets/svg/DepartmentofEducationandWorkforce.svg"/></a></div>`;
				t14 = space();
				li8 = element("li");
				if (menu_slot) menu_slot.c();
				t15 = space();
				li9 = element("li");
				t16 = space();
				li10 = element("li");
				a8 = element("a");
				img3 = element("img");
				t17 = space();
				span1 = element("span");
				span1.textContent = "User";
				t19 = space();
				li11 = element("li");
				a9 = element("a");
				img4 = element("img");
				t20 = space();
				span2 = element("span");
				span2.textContent = "Help";
				attr(div1, "class", "top-links-container svelte-xh3nj");
				set_style(img1, "margin-top", "5px");
				if (!src_url_equal(img1.src, img1_src_value = /*barsimage*/ ctx[2])) attr(img1, "src", img1_src_value);
				attr(img1, "class", "svelte-xh3nj");
				attr(span0, "class", "icon-text svelte-xh3nj");
				attr(a6, "class", "hamburger--a svelte-xh3nj");
				attr(a6, "href", "javascript:void(0)");
				attr(li6, "class", "header-content-li svelte-xh3nj");
				attr(li7, "class", "header-content-li svelte-xh3nj");
				attr(li8, "class", "header-content-li svelte-xh3nj");
				attr(li9, "class", "header-content-li svelte-xh3nj");
				if (!src_url_equal(img3.src, img3_src_value = /*userimage*/ ctx[0])) attr(img3, "src", img3_src_value);
				attr(span1, "class", "icon-text user-text svelte-xh3nj");
				attr(a8, "class", "" + (null_to_empty("user--a") + " svelte-xh3nj"));
				attr(a8, "href", "javascript:void(0)");
				attr(li10, "class", "header-content-li svelte-xh3nj");
				if (!src_url_equal(img4.src, img4_src_value = /*helpimage*/ ctx[1])) attr(img4, "src", img4_src_value);
				attr(span2, "class", "icon-text user-text svelte-xh3nj");
				attr(a9, "class", "" + (null_to_empty("help--a") + " svelte-xh3nj"));
				attr(a9, "href", "javascript:void(0)");
				attr(li11, "class", "header-content-li svelte-xh3nj");
				attr(ul1, "class", "header-content svelte-xh3nj");
				attr(div3, "class", "header-container svelte-xh3nj");
				attr(div4, "class", "container-header svelte-xh3nj");
			},
			m(target, anchor) {
				insert(target, div4, anchor);
				append(div4, div1);
				append(div4, t10);
				append(div4, div3);
				append(div3, ul1);
				append(ul1, li6);
				append(li6, a6);
				append(a6, img1);
				append(a6, t11);
				append(a6, span0);
				append(span0, t12);
				append(ul1, t13);
				append(ul1, li7);
				append(ul1, t14);
				append(ul1, li8);

				if (menu_slot) {
					menu_slot.m(li8, null);
				}

				append(ul1, t15);
				append(ul1, li9);
				append(ul1, t16);
				append(ul1, li10);
				append(li10, a8);
				append(a8, img3);
				append(a8, t17);
				append(a8, span1);
				append(ul1, t19);
				append(ul1, li11);
				append(li11, a9);
				append(a9, img4);
				append(a9, t20);
				append(a9, span2);
				current = true;

				if (!mounted) {
					dispose = [
						listen(img1, "click", /*click_handler*/ ctx[15]),
						listen(img1, "mouseover", /*mouseover_handler*/ ctx[16]),
						listen(img1, "mouseout", /*mouseout_handler*/ ctx[17]),
						listen(img3, "mouseover", /*mouseover_handler_1*/ ctx[18]),
						listen(img3, "mouseout", /*mouseout_handler_1*/ ctx[19]),
						listen(a8, "click", /*click_handler_1*/ ctx[20]),
						listen(li10, "click", /*click_handler_2*/ ctx[21]),
						listen(img4, "mouseover", /*mouseover_handler_2*/ ctx[22]),
						listen(img4, "mouseout", /*mouseout_handler_2*/ ctx[23]),
						listen(a9, "click", /*click_handler_3*/ ctx[24]),
						listen(li11, "click", /*click_handler_4*/ ctx[25])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (!current || dirty & /*barsimage*/ 4 && !src_url_equal(img1.src, img1_src_value = /*barsimage*/ ctx[2])) {
					attr(img1, "src", img1_src_value);
				}

				if (!current || dirty & /*togglemessage*/ 8) set_data(t12, /*togglemessage*/ ctx[3]);

				if (menu_slot) {
					if (menu_slot.p && (!current || dirty & /*$$scope*/ 8192)) {
						update_slot_base(
							menu_slot,
							menu_slot_template,
							ctx,
							/*$$scope*/ ctx[13],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[13])
							: get_slot_changes(menu_slot_template, /*$$scope*/ ctx[13], dirty, get_menu_slot_changes),
							get_menu_slot_context
						);
					}
				}

				if (!current || dirty & /*userimage*/ 1 && !src_url_equal(img3.src, img3_src_value = /*userimage*/ ctx[0])) {
					attr(img3, "src", img3_src_value);
				}

				if (!current || dirty & /*helpimage*/ 2 && !src_url_equal(img4.src, img4_src_value = /*helpimage*/ ctx[1])) {
					attr(img4, "src", img4_src_value);
				}
			},
			i(local) {
				if (current) return;
				transition_in(menu_slot, local);
				current = true;
			},
			o(local) {
				transition_out(menu_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(div4);
				}

				if (menu_slot) menu_slot.d(detaching);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$h($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		const svelteDispatch = createEventDispatcher();

		const dispatch = (name, data, event) => {
			svelteDispatch(name, data);
		};

		let { userimage = 'assets/dist/assets/svg/user-solid-2.svg' } = $$props;
		let { helpimage = 'assets/dist/assets/svg/question-circle-solid-2.svg' } = $$props;
		let { barsimage = 'assets/dist/assets/svg/fas fa-bars.svg' } = $$props;
		let { togglemessage = 'Close Menu' } = $$props;
		let shouldShowSideMenu = true;

		function onProfileClick(e) {
			let detail = { menu: "profile" };
			({ ...e, detail });
			e.stopPropagation();
			dispatch("profileclick", detail);
		}

		function onHelpClick(e) {
			let detail = { close: true };
			({ ...e, detail });
			e.stopPropagation();
			dispatch("helpclick", detail);
		}

		function onProfileMouseover(e) {
			$$invalidate(0, userimage = 'assets/dist/assets/svg/user-solid-2-hover.svg');
		}

		function onProfileMouseout(e) {
			$$invalidate(0, userimage = 'assets/dist/assets/svg/user-solid-2.svg');
		}

		function onHelpMouseover(e) {
			$$invalidate(1, helpimage = 'assets/dist/assets/svg/question-circle-solid-2-hover.svg');
		}

		function onHelpMouseout(e) {
			$$invalidate(1, helpimage = 'assets/dist/assets/svg/question-circle-solid-2.svg');
		}

		function onBarsMouseover(e) {
			$$invalidate(2, barsimage = 'assets/dist/assets/svg/fas fa-bars-hover.svg');
		}

		function onBarsMouseout(e) {
			$$invalidate(2, barsimage = 'assets/dist/assets/svg/fas fa-bars.svg');
		}

		function onBarClick(e) {
			shouldShowSideMenu = !shouldShowSideMenu;
			if (!shouldShowSideMenu) $$invalidate(3, togglemessage = 'Close Menu'); else $$invalidate(3, togglemessage = 'Open Menu');

			let eventData = {
				detail: { fullwidth: shouldShowSideMenu }
			};

			dispatch("barclick", eventData);
		}

		const click_handler = e => onBarClick();
		const mouseover_handler = e => onBarsMouseover();
		const mouseout_handler = e => onBarsMouseout();
		const mouseover_handler_1 = e => onProfileMouseover();
		const mouseout_handler_1 = e => onProfileMouseout();
		const click_handler_1 = e => onProfileClick(e);
		const click_handler_2 = e => onProfileClick(e);
		const mouseover_handler_2 = e => onHelpMouseover();
		const mouseout_handler_2 = e => onHelpMouseout();
		const click_handler_3 = e => onHelpClick(e);
		const click_handler_4 = e => onHelpClick(e);

		$$self.$$set = $$props => {
			if ('userimage' in $$props) $$invalidate(0, userimage = $$props.userimage);
			if ('helpimage' in $$props) $$invalidate(1, helpimage = $$props.helpimage);
			if ('barsimage' in $$props) $$invalidate(2, barsimage = $$props.barsimage);
			if ('togglemessage' in $$props) $$invalidate(3, togglemessage = $$props.togglemessage);
			if ('$$scope' in $$props) $$invalidate(13, $$scope = $$props.$$scope);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*userimage*/ 1) {
				console.log('userimage ', userimage);
			}

			if ($$self.$$.dirty & /*helpimage*/ 2) {
				console.log('helpimage ', helpimage);
			}

			if ($$self.$$.dirty & /*barsimage*/ 4) {
				console.log('barsimage ', barsimage);
			}

			if ($$self.$$.dirty & /*togglemessage*/ 8) {
				console.log('togglemessage ', togglemessage);
			}
		};

		console.log('----------EAS Svelte Header Cmmponent---------');

		return [
			userimage,
			helpimage,
			barsimage,
			togglemessage,
			onProfileClick,
			onHelpClick,
			onProfileMouseover,
			onProfileMouseout,
			onHelpMouseover,
			onHelpMouseout,
			onBarsMouseover,
			onBarsMouseout,
			onBarClick,
			$$scope,
			slots,
			click_handler,
			mouseover_handler,
			mouseout_handler,
			mouseover_handler_1,
			mouseout_handler_1,
			click_handler_1,
			click_handler_2,
			mouseover_handler_2,
			mouseout_handler_2,
			click_handler_3,
			click_handler_4
		];
	}

	class Eas_header_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$h,
				create_fragment$h,
				safe_not_equal,
				{
					userimage: 0,
					helpimage: 1,
					barsimage: 2,
					togglemessage: 3
				},
				add_css$g
			);
		}

		get userimage() {
			return this.$$.ctx[0];
		}

		set userimage(userimage) {
			this.$$set({ userimage });
			flush();
		}

		get helpimage() {
			return this.$$.ctx[1];
		}

		set helpimage(helpimage) {
			this.$$set({ helpimage });
			flush();
		}

		get barsimage() {
			return this.$$.ctx[2];
		}

		set barsimage(barsimage) {
			this.$$set({ barsimage });
			flush();
		}

		get togglemessage() {
			return this.$$.ctx[3];
		}

		set togglemessage(togglemessage) {
			this.$$set({ togglemessage });
			flush();
		}
	}

	customElements.define("eas-header-swc", create_custom_element(Eas_header_component, {"userimage":{},"helpimage":{},"barsimage":{},"togglemessage":{}}, ["menu"], [], true));

	/*
	Adapted from https://github.com/mattdesl
	Distributed under MIT License https://github.com/mattdesl/eases/blob/master/LICENSE.md
	*/

	/**
	 * https://svelte.dev/docs/svelte-easing
	 * @param {number} t
	 * @returns {number}
	 */
	function cubicOut(t) {
		const f = t - 1.0;
		return f * f * f + 1.0;
	}

	/**
	 * Slides an element in and out.
	 *
	 * https://svelte.dev/docs/svelte-transition#slide
	 * @param {Element} node
	 * @param {import('./public').SlideParams} [params]
	 * @returns {import('./public').TransitionConfig}
	 */
	function slide(node, { delay = 0, duration = 400, easing = cubicOut, axis = 'y' } = {}) {
		const style = getComputedStyle(node);
		const opacity = +style.opacity;
		const primary_property = axis === 'y' ? 'height' : 'width';
		const primary_property_value = parseFloat(style[primary_property]);
		const secondary_properties = axis === 'y' ? ['top', 'bottom'] : ['left', 'right'];
		const capitalized_secondary_properties = secondary_properties.map(
			(e) => `${e[0].toUpperCase()}${e.slice(1)}`
		);
		const padding_start_value = parseFloat(style[`padding${capitalized_secondary_properties[0]}`]);
		const padding_end_value = parseFloat(style[`padding${capitalized_secondary_properties[1]}`]);
		const margin_start_value = parseFloat(style[`margin${capitalized_secondary_properties[0]}`]);
		const margin_end_value = parseFloat(style[`margin${capitalized_secondary_properties[1]}`]);
		const border_width_start_value = parseFloat(
			style[`border${capitalized_secondary_properties[0]}Width`]
		);
		const border_width_end_value = parseFloat(
			style[`border${capitalized_secondary_properties[1]}Width`]
		);
		return {
			delay,
			duration,
			easing,
			css: (t) =>
				'overflow: hidden;' +
				`opacity: ${Math.min(t * 20, 1) * opacity};` +
				`${primary_property}: ${t * primary_property_value}px;` +
				`padding-${secondary_properties[0]}: ${t * padding_start_value}px;` +
				`padding-${secondary_properties[1]}: ${t * padding_end_value}px;` +
				`margin-${secondary_properties[0]}: ${t * margin_start_value}px;` +
				`margin-${secondary_properties[1]}: ${t * margin_end_value}px;` +
				`border-${secondary_properties[0]}-width: ${t * border_width_start_value}px;` +
				`border-${secondary_properties[1]}-width: ${t * border_width_end_value}px;`
		};
	}

	/* src\lib\web-components\toggle-switch\eas-toggle-switch.component.svelte generated by Svelte v4.2.19 */

	function add_css$f(target) {
		append_styles(target, "svelte-g2iic8", ".question.svelte-g2iic8.svelte-g2iic8{align-self:center;margin-left:10px;font-size:var(--question-font-size-, 20px);font-family:var(--question-font-family-, sans-serif)}.toggle-container.svelte-g2iic8.svelte-g2iic8{display:flex;flex-direction:row}.switch.svelte-g2iic8.svelte-g2iic8{position:relative;display:inline-block;width:var(--toggle-switch-width, 60px);height:var(--toggle-switch-height, 34px)}.switch.svelte-g2iic8 input.svelte-g2iic8{opacity:0;width:0;height:0}.slider.svelte-g2iic8.svelte-g2iic8{position:absolute;cursor:pointer;top:0;right:0;left:0;bottom:0;background-color:var(--toggle-switch-off-background-color, #ccc);-webkit-transition:.4s;transition:.4s}.slider.svelte-g2iic8.svelte-g2iic8::before{position:absolute;content:\"\";height:26px;width:26px;left:26px;left:4px;bottom:4px;background-color:var(--toggle-switcher-background-color, white);-webkit-transition:0.4s;transition:0.4s}input.svelte-g2iic8:checked+.slider.svelte-g2iic8{background-color:var(--toggle-switch-on-background-color, #2196F3)}input.svelte-g2iic8:focus+.slider.svelte-g2iic8{box-shadow:0 0 1px #2196F3}input.svelte-g2iic8:checked+.slider.svelte-g2iic8::before{-webkit-transform:translate((26px));-ms-transform:translate(26px);transform:translate(26px)}.slider.round.svelte-g2iic8.svelte-g2iic8{border-radius:34px}.slider.round.svelte-g2iic8.svelte-g2iic8:before{border-radius:50%}");
	}

	function create_fragment$g(ctx) {
		let link;
		let t0;
		let div1;
		let label_1;
		let input;
		let t1;
		let span;
		let span_transition;
		let t2;
		let div0;
		let t3;
		let current;
		let mounted;
		let dispose;

		return {
			c() {
				link = element("link");
				t0 = space();
				div1 = element("div");
				label_1 = element("label");
				input = element("input");
				t1 = space();
				span = element("span");
				t2 = space();
				div0 = element("div");
				t3 = text(/*label*/ ctx[1]);
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(input, "type", "checkbox");
				input.checked = /*toggleState*/ ctx[0];
				attr(input, "class", "svelte-g2iic8");
				attr(span, "class", "slider round svelte-g2iic8");
				attr(label_1, "class", "switch svelte-g2iic8");
				attr(div0, "class", "question svelte-g2iic8");
				attr(div1, "class", "toggle-container svelte-g2iic8");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div1, anchor);
				append(div1, label_1);
				append(label_1, input);
				append(label_1, t1);
				append(label_1, span);
				append(div1, t2);
				append(div1, div0);
				append(div0, t3);
				current = true;

				if (!mounted) {
					dispose = listen(input, "change", /*onCheckBoxChanged*/ ctx[2]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (!current || dirty & /*toggleState*/ 1) {
					input.checked = /*toggleState*/ ctx[0];
				}

				if (!current || dirty & /*label*/ 2) set_data(t3, /*label*/ ctx[1]);
			},
			i(local) {
				if (current) return;

				if (local) {
					add_render_callback(() => {
						if (!current) return;
						if (!span_transition) span_transition = create_bidirectional_transition(span, slide, {}, true);
						span_transition.run(1);
					});
				}

				current = true;
			},
			o(local) {
				if (local) {
					if (!span_transition) span_transition = create_bidirectional_transition(span, slide, {}, false);
					span_transition.run(0);
				}

				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div1);
				}

				if (detaching && span_transition) span_transition.end();
				mounted = false;
				dispose();
			}
		};
	}

	function instance$g($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { toggleState = true } = $$props;
		let { label = "On" } = $$props;

		onMount(async () => {
			
		}); //toggleState = true;

		function onCheckBoxChanged(e) {
			console.log("onCheckBoxChanged");
			$$invalidate(0, toggleState = !toggleState);
			svelteDispatch("toggle", { toggleState });
		}

		$$self.$$set = $$props => {
			if ('toggleState' in $$props) $$invalidate(0, toggleState = $$props.toggleState);
			if ('label' in $$props) $$invalidate(1, label = $$props.label);
		};

		return [toggleState, label, onCheckBoxChanged];
	}

	class Eas_toggle_switch_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$g, create_fragment$g, safe_not_equal, { toggleState: 0, label: 1 }, add_css$f);
		}

		get toggleState() {
			return this.$$.ctx[0];
		}

		set toggleState(toggleState) {
			this.$$set({ toggleState });
			flush();
		}

		get label() {
			return this.$$.ctx[1];
		}

		set label(label) {
			this.$$set({ label });
			flush();
		}
	}

	customElements.define("eas-toggle-switch-swc", create_custom_element(Eas_toggle_switch_component, {"toggleState":{"type":"Boolean"},"label":{}}, [], [], true));

	/* src\lib\web-components\button\eas-button.component.svelte generated by Svelte v4.2.19 */

	function add_css$e(target) {
		append_styles(target, "svelte-ao454x", ":host,:root{--gray-800:#2c2c2c;--gray-700:#434343;--gray-600:#8c8c8c;--gray-500:#bfbfbf;--gray-400:#d9d9d9;--gray-300:#e8e8e8;--gray-250:#f0f0f0;--gray-200:#f2f2f2;--gray-100:#f6f6f6;--gray-50:#f7f7f7;--maroon-800:#700017;--maroon-700:#8b3043;--maroon-600:#99495a;--maroon-500:#aa6d7e;--maroon-400:#bf95a5;--maroon-300:#e9d9dc;--maroon-200:#f5eeee;--maroon-100:#faf6f6;--maroon-lte-100:#faf6f6;--maroon-lte-200:#f5eeee;--red-800:#ea1014;--red-700:#f1353a;--red-600:#f4595c;--red-500:#f57174;--red-400:#f7888b;--red-300:#f9acae;--red-200:#fbc4c5;--red-100:#fde7e7;--red-50:#faf6f6;--blue-800:#3d7aa9;--blue-700:#4781ad;--blue-600:#5f91b7;--blue-500:#749fc1;--blue-400:#9ebcd4;--blue-300:#c4d7e5;--blue-200:#e2ebf2;--blue-100:#f4f7fa;--blue-lte-100:#eff0f5;--lte-blue-800:#73a5cc;--lte-blue-700:#88b2d4;--lte-blue-600:#a4c4de;--lte-blue-500:#c0d6e8;--lte-blue-400:#cee0ed;--lte-blue-300:#dce8f2;--lte-blue-200:#eaf2f7;--lte-blue-100:#f4f8fb;--gold-800:#ffbe0e;--gold-700:#ffce4a;--gold-600:#fad87b;--gold-500:#f8de9b;--gold-400:#f6e2b2;--gold-300:#f4e7ca;--gold-200:#f2ebdd;--gold-100:#f3f1ed;--drk-green-800:#5e8000;--drk-green-700:#6e8c19;--drk-green-600:#7e9933;--drk-green-500:#8ea64c;--drk-green-400:#aebf7f;--drk-green-300:#c7d3a6;--drk-green-200:#dfe6cc;--drk-green-100:#eff2e5;--green-800:#b5dc10;--green-700:#bcdf27;--green-600:#c4e340;--green-500:#cbe657;--green-400:#daed87;--green-300:#e5f3ac;--green-200:#f0f8cf;--green-100:#f7fbe7;--ohid-blue-100:#ebf7ff;--ohid-blue-200:#d9efff;--ohid-blue-300:#bfe5ff;--ohid-blue-400:#a6daff;--ohid-blue-500:#8cd0ff;--ohid-blue-600:#59bbff;--ohid-blue-700:#26a6ff;--ohid-blue-800:#0096ff;--ohid-drk-blue-100:#ecf0f4;--ohid-drk-blue-200:#dae3e9;--ohid-drk-blue-300:#c2d0db;--ohid-drk-blue-400:#a9bdcc;--ohid-drk-blue-500:#91aabe;--ohid-drk-blue-600:#6084a1;--ohid-drk-blue-700:#2f5e84;--ohid-drk-blue-800:#0a426e;--iop-lt-blue-800:#40b0ff;--iop-blue-800:#0096ff;--iop-drk-blue-800:#004393;--lte:300;--reg:400;--semi:600;--bold:700}.btn.svelte-ao454x.svelte-ao454x{align-items:center;justify-content:center;width:max-content;padding:0 20px;border-radius:5px;font-size:16px;cursor:pointer;transition:all 0.2s ease-in-out !important;border:2px solid var(--blue-800);margin:0px 10px}.btn.border-red.svelte-ao454x.svelte-ao454x{border-color:var(--red-800)}.btn.border-black.svelte-ao454x.svelte-ao454x{border-color:#000}.btn.border-blue.svelte-ao454x.svelte-ao454x{border-color:var(--blue-800)}.btn:hover.hover-red.svelte-ao454x.svelte-ao454x{background:var(--red-800) !important;color:white !important}.btn:hover.hover-black.svelte-ao454x.svelte-ao454x{background:#000 !important;color:white !important}.btn:hover.hover-blue.svelte-ao454x.svelte-ao454x,button:hover.hover-blue.svelte-ao454x.svelte-ao454x{background:var(--blue-800) !important;color:white !important}.btn-txt.svelte-ao454x.svelte-ao454x{transition:all 0.2s ease-in-out !important;font-weight:var(--bold) !important}.btn-txt.red.svelte-ao454x.svelte-ao454x{color:var(--red-800)}.btn-txt.blue.svelte-ao454x.svelte-ao454x{color:var(--blue-800)}.btn-txt.black.svelte-ao454x.svelte-ao454x{color:#000}.btn-txt.white.svelte-ao454x.svelte-ao454x{color:var(--main-page-button-text, white)}button.disabled.svelte-ao454x.svelte-ao454x{position:relative;pointer-events:none;background:var(--gray-400) !important;border-color:var(--gray-500) !important;z-index:0}.icon.svelte-ao454x.svelte-ao454x{color:var(--blue-800);width:35px;padding:0;display:block;cursor:pointer;border:none;background:transparent}.icon.svelte-ao454x.svelte-ao454x:hover{background:var(--blue-800) !important;color:white !important}.flex-row-reverse.svelte-ao454x.svelte-ao454x{flex-direction:row-reverse !important}:hover.hover-font-white.svelte-ao454x>.svelte-ao454x{color:white !important}button.secondary.svelte-ao454x.svelte-ao454x{border:2px;border-style:solid;background:transparent;width:25px;height:25px;padding:0px;cursor:pointer;color:var(--blue-800)}button.rounded-full.svelte-ao454x.svelte-ao454x{border-radius:100px !important}button.border-blue.svelte-ao454x.svelte-ao454x{border-color:var(--blue-800)}");
	}

	// (27:0) {#if type === 'button'}
	function create_if_block_1$7(ctx) {
		let button;
		let div;
		let t;
		let div_class_value;
		let button_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				t = text(/*text*/ ctx[0]);
				attr(div, "class", div_class_value = "btn-txt " + /*color*/ ctx[2] + " svelte-ao454x");
				set_style(button, "background", /*defaultbackground*/ ctx[5]);
				set_style(button, "height", /*defaultbuttonheight*/ ctx[6]);
				attr(button, "class", button_class_value = "btn border-" + /*color*/ ctx[2] + " hover-" + /*color*/ ctx[2] + " hover-font-white flex-row-reverse " + (/*uiblock*/ ctx[3] ? 'disabled' : '') + " svelte-ao454x");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);
				append(div, t);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler*/ ctx[12]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*text*/ 1) set_data(t, /*text*/ ctx[0]);

				if (dirty & /*color*/ 4 && div_class_value !== (div_class_value = "btn-txt " + /*color*/ ctx[2] + " svelte-ao454x")) {
					attr(div, "class", div_class_value);
				}

				if (dirty & /*color, uiblock*/ 12 && button_class_value !== (button_class_value = "btn border-" + /*color*/ ctx[2] + " hover-" + /*color*/ ctx[2] + " hover-font-white flex-row-reverse " + (/*uiblock*/ ctx[3] ? 'disabled' : '') + " svelte-ao454x")) {
					attr(button, "class", button_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (39:0) {#if type === 'icon'}
	function create_if_block$9(ctx) {
		let button;
		let i;
		let i_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				i = element("i");
				attr(i, "class", i_class_value = "" + (null_to_empty(/*iconproperties*/ ctx[4]) + " svelte-ao454x"));
				attr(button, "class", "" + (null_to_empty(/*defaultutilitystyle*/ ctx[7]) + " svelte-ao454x"));
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, i);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler_1*/ ctx[13]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*iconproperties*/ 16 && i_class_value !== (i_class_value = "" + (null_to_empty(/*iconproperties*/ ctx[4]) + " svelte-ao454x"))) {
					attr(i, "class", i_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$f(ctx) {
		let link;
		let t0;
		let t1;
		let if_block1_anchor;
		let if_block0 = /*type*/ ctx[1] === 'button' && create_if_block_1$7(ctx);
		let if_block1 = /*type*/ ctx[1] === 'icon' && create_if_block$9(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				if (if_block0) if_block0.c();
				t1 = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t1, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
			},
			p(ctx, [dirty]) {
				if (/*type*/ ctx[1] === 'button') {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_1$7(ctx);
						if_block0.c();
						if_block0.m(t1.parentNode, t1);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*type*/ ctx[1] === 'icon') {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block$9(ctx);
						if_block1.c();
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(t1);
					detach(if_block1_anchor);
				}

				if (if_block0) if_block0.d(detaching);
				if (if_block1) if_block1.d(detaching);
			}
		};
	}

	function instance$f($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { text } = $$props;
		let { type } = $$props;
		let { color } = $$props;
		let { uiblock = false } = $$props;
		let { background } = $$props;
		let { iconproperties } = $$props;
		let { buttonheight } = $$props;
		let { utilitystyle } = $$props;
		const defaultbackground = background || 'transparent';
		const defaultbuttonheight = buttonheight || '45px';
		const defaultutilitystyle = utilitystyle || 'icon';

		onMount(async () => {
			
		});

		function onButtonClick(e) {
			svelteDispatch('buttonClick', e);
		}

		const click_handler = e => onButtonClick(e);
		const click_handler_1 = e => onButtonClick(e);

		$$self.$$set = $$props => {
			if ('text' in $$props) $$invalidate(0, text = $$props.text);
			if ('type' in $$props) $$invalidate(1, type = $$props.type);
			if ('color' in $$props) $$invalidate(2, color = $$props.color);
			if ('uiblock' in $$props) $$invalidate(3, uiblock = $$props.uiblock);
			if ('background' in $$props) $$invalidate(9, background = $$props.background);
			if ('iconproperties' in $$props) $$invalidate(4, iconproperties = $$props.iconproperties);
			if ('buttonheight' in $$props) $$invalidate(10, buttonheight = $$props.buttonheight);
			if ('utilitystyle' in $$props) $$invalidate(11, utilitystyle = $$props.utilitystyle);
		};

		return [
			text,
			type,
			color,
			uiblock,
			iconproperties,
			defaultbackground,
			defaultbuttonheight,
			defaultutilitystyle,
			onButtonClick,
			background,
			buttonheight,
			utilitystyle,
			click_handler,
			click_handler_1
		];
	}

	class Eas_button_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$f,
				create_fragment$f,
				safe_not_equal,
				{
					text: 0,
					type: 1,
					color: 2,
					uiblock: 3,
					background: 9,
					iconproperties: 4,
					buttonheight: 10,
					utilitystyle: 11
				},
				add_css$e
			);
		}

		get text() {
			return this.$$.ctx[0];
		}

		set text(text) {
			this.$$set({ text });
			flush();
		}

		get type() {
			return this.$$.ctx[1];
		}

		set type(type) {
			this.$$set({ type });
			flush();
		}

		get color() {
			return this.$$.ctx[2];
		}

		set color(color) {
			this.$$set({ color });
			flush();
		}

		get uiblock() {
			return this.$$.ctx[3];
		}

		set uiblock(uiblock) {
			this.$$set({ uiblock });
			flush();
		}

		get background() {
			return this.$$.ctx[9];
		}

		set background(background) {
			this.$$set({ background });
			flush();
		}

		get iconproperties() {
			return this.$$.ctx[4];
		}

		set iconproperties(iconproperties) {
			this.$$set({ iconproperties });
			flush();
		}

		get buttonheight() {
			return this.$$.ctx[10];
		}

		set buttonheight(buttonheight) {
			this.$$set({ buttonheight });
			flush();
		}

		get utilitystyle() {
			return this.$$.ctx[11];
		}

		set utilitystyle(utilitystyle) {
			this.$$set({ utilitystyle });
			flush();
		}
	}

	customElements.define("eas-button-swc", create_custom_element(Eas_button_component, {"text":{},"type":{},"color":{},"uiblock":{"type":"Boolean"},"background":{},"iconproperties":{},"buttonheight":{},"utilitystyle":{}}, [], [], true));

	/* src\lib\web-components\link\eas-link.component.svelte generated by Svelte v4.2.19 */

	function add_css$d(target) {
		append_styles(target, "svelte-1ig8ly6", ".default.svelte-1ig8ly6 a.svelte-1ig8ly6{display:flex;color:rgb(61, 122, 169);font-weight:bold;cursor:pointer;text-decoration:none;font-weight:700}a.svelte-1ig8ly6.svelte-1ig8ly6:hover{text-decoration:underline}");
	}

	function create_fragment$e(ctx) {
		let link;
		let t0;
		let span;
		let a;
		let t1;
		let mounted;
		let dispose;

		return {
			c() {
				link = element("link");
				t0 = space();
				span = element("span");
				a = element("a");
				t1 = text(/*linktext*/ ctx[0]);
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(a, "style", /*customStyle*/ ctx[3]);
				attr(a, "href", /*href*/ ctx[1]);
				attr(a, "target", /*target*/ ctx[2]);
				attr(a, "class", "svelte-1ig8ly6");
				attr(span, "class", "default svelte-1ig8ly6");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, span, anchor);
				append(span, a);
				append(a, t1);

				if (!mounted) {
					dispose = listen(a, "click", /*click_handler*/ ctx[6]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*linktext*/ 1) set_data(t1, /*linktext*/ ctx[0]);

				if (dirty & /*customStyle*/ 8) {
					attr(a, "style", /*customStyle*/ ctx[3]);
				}

				if (dirty & /*href*/ 2) {
					attr(a, "href", /*href*/ ctx[1]);
				}

				if (dirty & /*target*/ 4) {
					attr(a, "target", /*target*/ ctx[2]);
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(span);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function instance$e($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { linktext = 'Link' } = $$props;
		let { href = 'javascript:void(0)' } = $$props;
		let { target = '_self' } = $$props;
		let { customstyles = [] } = $$props;
		let customStyle = '';

		function onclick(e) {
			svelteDispatch('click', e);
		}

		const click_handler = e => onclick(e);

		$$self.$$set = $$props => {
			if ('linktext' in $$props) $$invalidate(0, linktext = $$props.linktext);
			if ('href' in $$props) $$invalidate(1, href = $$props.href);
			if ('target' in $$props) $$invalidate(2, target = $$props.target);
			if ('customstyles' in $$props) $$invalidate(5, customstyles = $$props.customstyles);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*customstyles, customStyle*/ 40) {
				customstyles.map(x => {
					$$invalidate(3, customStyle += x.key + ':' + x.value + ';');
				});
			}
		};

		return [linktext, href, target, customStyle, onclick, customstyles, click_handler];
	}

	class Eas_link_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$e,
				create_fragment$e,
				safe_not_equal,
				{
					linktext: 0,
					href: 1,
					target: 2,
					customstyles: 5
				},
				add_css$d
			);
		}

		get linktext() {
			return this.$$.ctx[0];
		}

		set linktext(linktext) {
			this.$$set({ linktext });
			flush();
		}

		get href() {
			return this.$$.ctx[1];
		}

		set href(href) {
			this.$$set({ href });
			flush();
		}

		get target() {
			return this.$$.ctx[2];
		}

		set target(target) {
			this.$$set({ target });
			flush();
		}

		get customstyles() {
			return this.$$.ctx[5];
		}

		set customstyles(customstyles) {
			this.$$set({ customstyles });
			flush();
		}
	}

	customElements.define("eas-link-swc", create_custom_element(Eas_link_component, {"linktext":{},"href":{},"target":{},"customstyles":{}}, [], [], true));

	/* src\lib\web-components\checkbox\eas-checkbox.component.svelte generated by Svelte v4.2.19 */

	function add_css$c(target) {
		append_styles(target, "svelte-1r6zwz3", ".checkbox-wrapper-with-border.svelte-1r6zwz3.svelte-1r6zwz3{background-color:var(--checkbox-background-color,#f3c04e);width:fit-content;border-radius:var(--checkbox-border-radius,5px);padding:15px;width:fit-content}.checkbox-wrapper.svelte-1r6zwz3.svelte-1r6zwz3{width:fit-content}.checkbox.svelte-1r6zwz3.svelte-1r6zwz3{font-size:var(--checkbox-font-size,18px);font-weight:var(--checkbox-font-weight,400);;;font-style:var(--checkbox-font-style,sans-serif);padding-left:5px}.checkbox-wrapper.svelte-1r6zwz3 label.svelte-1r6zwz3{padding:5px;margin:0 auto}.checkbox-input.svelte-1r6zwz3.svelte-1r6zwz3{border:2px #2196F3 solid;-webkit-appearance:none;appearance:none;vertical-align:middle;background:var(--checkbox-background-color, #fff);font-size:var(--checkbox-font-size, 20px);border-radius:0.125em;display:inline-block;width:25px;height:25px;position:relative}.checkbox-wrapper.svelte-1r6zwz3 input[type=checkbox].svelte-1r6zwz3:before,.checkbox-wrapper.svelte-1r6zwz3 input[type=checkbox].svelte-1r6zwz3:after{content:\"\";position:absolute;background:var(--checkbox-border-color, #2196F3);width:calc(var(--checkbox-width, 5px));height:var(--checkbox-height, 2px);top:50%;left:25%;transform-origin:left center}.checkbox-wrapper.svelte-1r6zwz3 input[type=checkbox].svelte-1r6zwz3:before{transform:rotate(45deg) translate(calc(var(--checkbox-border-width, 2px) / -2), calc(var(--checkbox-border-width, 2px) / -2)) scaleX(0);transition:transform 200ms ease-in 200ms}.checkbox-wrapper.svelte-1r6zwz3 input[type=checkbox].svelte-1r6zwz3:after{width:calc(var(--borderWidth) * 5);transform:rotate(-45deg) translateY(calc(var(--checkbox-border-width, 2px) * 2)) scaleX(0);transform-origin:left center;transition:transform 200ms ease-in}.checkbox-wrapper.svelte-1r6zwz3 input[type=checkbox].svelte-1r6zwz3:checked:before{transform:rotate(45deg) translate(calc(var(--checkbox-border-width, 2px) / -2), calc(var(--checkbox-border-width, 2px) / -2)) scaleX(1);transition:transform 200ms ease-in}.checkbox-wrapper.svelte-1r6zwz3 input[type=checkbox].svelte-1r6zwz3:checked:after{width:calc(var(--checkbox-border-width, 2px) * 5);transform:rotate(-45deg) translateY(calc(var(--checkbox-border-width, 2px) * 2)) scaleX(1);transition:transform 200ms ease-out 200ms}.checkbox-wrapper.svelte-1r6zwz3 input[type=checkbox].svelte-1r6zwz3:focus{outline:calc(var(--borderWidth) / 2) dotted rgba(0, 0, 0, 0.25)}.question.svelte-1r6zwz3.svelte-1r6zwz3{align-self:center;margin-left:10px;font-size:var(--question-font-size, 16px);font-family:var(--question-font-family, sans-serif)}.toggle-container.svelte-1r6zwz3.svelte-1r6zwz3{display:flex;flex-direction:row}.switch.svelte-1r6zwz3.svelte-1r6zwz3{position:relative;display:inline-block;width:var(--toggle-switch-width, 50px);height:var(--toggle-switch-height, 20px)}.switch.svelte-1r6zwz3 input.svelte-1r6zwz3{opacity:0;width:0;height:0}.slider.svelte-1r6zwz3.svelte-1r6zwz3{position:absolute;cursor:pointer;top:0;right:0;left:0;bottom:0;background-color:var(--toggle-switch-off-background-color, #ccc);-webkit-transition:.4s;transition:.4s}.slider.svelte-1r6zwz3.svelte-1r6zwz3::before{position:absolute;content:\"\";height:15px;width:15px;left:5px;bottom:3px;background-color:var(--toggle-switcher-background-color, white);-webkit-transition:0.4s;transition:0.4s}input.svelte-1r6zwz3:checked+.slider.svelte-1r6zwz3{background-color:var(--toggle-switch-on-background-color, #2196F3)}input.svelte-1r6zwz3:focus+.slider.svelte-1r6zwz3{box-shadow:0 0 1px #2196F3}input.svelte-1r6zwz3:checked+.slider.svelte-1r6zwz3::before{-webkit-transform:translate((26px));-ms-transform:translate(26px);transform:translate(26px)}.slider.round.svelte-1r6zwz3.svelte-1r6zwz3{border-radius:34px}.slider.round.svelte-1r6zwz3.svelte-1r6zwz3:before{border-radius:50%}");
	}

	// (22:6) {:else}
	function create_else_block_1$3(ctx) {
		let input;
		let input_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				input = element("input");
				attr(input, "type", "checkbox");
				attr(input, "class", input_class_value = "" + (null_to_empty(/*type*/ ctx[1] === 'toggle' ? '' : 'checkbox-input') + " svelte-1r6zwz3"));
			},
			m(target, anchor) {
				insert(target, input, anchor);

				if (!mounted) {
					dispose = listen(input, "change", /*change_handler_1*/ ctx[5]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*type*/ 2 && input_class_value !== (input_class_value = "" + (null_to_empty(/*type*/ ctx[1] === 'toggle' ? '' : 'checkbox-input') + " svelte-1r6zwz3"))) {
					attr(input, "class", input_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(input);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (20:6) {#if checkboxState}
	function create_if_block_2$4(ctx) {
		let input;
		let input_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				input = element("input");
				attr(input, "type", "checkbox");
				attr(input, "class", input_class_value = "" + (null_to_empty(/*type*/ ctx[1] === 'toggle' ? '' : 'checkbox-input') + " svelte-1r6zwz3"));
				input.checked = true;
			},
			m(target, anchor) {
				insert(target, input, anchor);

				if (!mounted) {
					dispose = listen(input, "change", /*change_handler*/ ctx[4]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*type*/ 2 && input_class_value !== (input_class_value = "" + (null_to_empty(/*type*/ ctx[1] === 'toggle' ? '' : 'checkbox-input') + " svelte-1r6zwz3"))) {
					attr(input, "class", input_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(input);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (28:6) {:else}
	function create_else_block$4(ctx) {
		let span;
		let t;

		return {
			c() {
				span = element("span");
				t = text(/*label*/ ctx[0]);
				attr(span, "class", "checkbox svelte-1r6zwz3");
			},
			m(target, anchor) {
				insert(target, span, anchor);
				append(span, t);
			},
			p(ctx, dirty) {
				if (dirty & /*label*/ 1) set_data(t, /*label*/ ctx[0]);
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(span);
				}
			}
		};
	}

	// (26:6) {#if type === 'toggle'}
	function create_if_block_1$6(ctx) {
		let span;
		let span_transition;
		let current;

		return {
			c() {
				span = element("span");
				attr(span, "class", "slider round svelte-1r6zwz3");
			},
			m(target, anchor) {
				insert(target, span, anchor);
				current = true;
			},
			p: noop,
			i(local) {
				if (current) return;

				if (local) {
					add_render_callback(() => {
						if (!current) return;
						if (!span_transition) span_transition = create_bidirectional_transition(span, slide, {}, true);
						span_transition.run(1);
					});
				}

				current = true;
			},
			o(local) {
				if (local) {
					if (!span_transition) span_transition = create_bidirectional_transition(span, slide, {}, false);
					span_transition.run(0);
				}

				current = false;
			},
			d(detaching) {
				if (detaching) {
					detach(span);
				}

				if (detaching && span_transition) span_transition.end();
			}
		};
	}

	// (32:2) {#if type === 'toggle'}
	function create_if_block$8(ctx) {
		let div;
		let t;

		return {
			c() {
				div = element("div");
				t = text(/*label*/ ctx[0]);
				attr(div, "class", "question svelte-1r6zwz3");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t);
			},
			p(ctx, dirty) {
				if (dirty & /*label*/ 1) set_data(t, /*label*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	function create_fragment$d(ctx) {
		let link;
		let t0;
		let div;
		let label_1;
		let t1;
		let current_block_type_index;
		let if_block1;
		let label_1_class_value;
		let t2;
		let div_class_value;

		function select_block_type(ctx, dirty) {
			if (/*checkboxState*/ ctx[2]) return create_if_block_2$4;
			return create_else_block_1$3;
		}

		let current_block_type = select_block_type(ctx);
		let if_block0 = current_block_type(ctx);
		const if_block_creators = [create_if_block_1$6, create_else_block$4];
		const if_blocks = [];

		function select_block_type_1(ctx, dirty) {
			if (/*type*/ ctx[1] === 'toggle') return 0;
			return 1;
		}

		current_block_type_index = select_block_type_1(ctx);
		if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		let if_block2 = /*type*/ ctx[1] === 'toggle' && create_if_block$8(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div = element("div");
				label_1 = element("label");
				if_block0.c();
				t1 = space();
				if_block1.c();
				t2 = space();
				if (if_block2) if_block2.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(label_1, "class", label_1_class_value = "" + (null_to_empty(/*type*/ ctx[1] === 'toggle' ? 'switch' : '') + " svelte-1r6zwz3"));

				attr(div, "class", div_class_value = "" + (null_to_empty(/*type*/ ctx[1] === 'toggle'
				? 'toggle-container'
				: /*type*/ ctx[1] == 'checkbox-with-background'
					? 'checkbox-wrapper-with-border'
					: 'checkbox-wrapper') + " svelte-1r6zwz3"));
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div, anchor);
				append(div, label_1);
				if_block0.m(label_1, null);
				append(label_1, t1);
				if_blocks[current_block_type_index].m(label_1, null);
				append(div, t2);
				if (if_block2) if_block2.m(div, null);
			},
			p(ctx, [dirty]) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0.d(1);
					if_block0 = current_block_type(ctx);

					if (if_block0) {
						if_block0.c();
						if_block0.m(label_1, t1);
					}
				}

				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_1(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block1 = if_blocks[current_block_type_index];

					if (!if_block1) {
						if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block1.c();
					} else {
						if_block1.p(ctx, dirty);
					}

					transition_in(if_block1, 1);
					if_block1.m(label_1, null);
				}

				if (dirty & /*type*/ 2 && label_1_class_value !== (label_1_class_value = "" + (null_to_empty(/*type*/ ctx[1] === 'toggle' ? 'switch' : '') + " svelte-1r6zwz3"))) {
					attr(label_1, "class", label_1_class_value);
				}

				if (/*type*/ ctx[1] === 'toggle') {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block$8(ctx);
						if_block2.c();
						if_block2.m(div, null);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}

				if (dirty & /*type*/ 2 && div_class_value !== (div_class_value = "" + (null_to_empty(/*type*/ ctx[1] === 'toggle'
				? 'toggle-container'
				: /*type*/ ctx[1] == 'checkbox-with-background'
					? 'checkbox-wrapper-with-border'
					: 'checkbox-wrapper') + " svelte-1r6zwz3"))) {
					attr(div, "class", div_class_value);
				}
			},
			i(local) {
				transition_in(if_block1);
			},
			o(local) {
				transition_out(if_block1);
			},
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div);
				}

				if_block0.d();
				if_blocks[current_block_type_index].d();
				if (if_block2) if_block2.d();
			}
		};
	}

	function instance$d($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();

		//let checkboxState = false;
		let checkboxState = false;

		let { label = "On" } = $$props;
		let { type = "checkbox" } = $$props;

		onMount(async () => {
			
		});

		function onCheckBoxChanged(e) {
			$$invalidate(2, checkboxState = !checkboxState);
			svelteDispatch("toggle", { checked: checkboxState });
		}

		const change_handler = e => {
			onCheckBoxChanged();
		};

		const change_handler_1 = e => {
			onCheckBoxChanged();
		};

		$$self.$$set = $$props => {
			if ('label' in $$props) $$invalidate(0, label = $$props.label);
			if ('type' in $$props) $$invalidate(1, type = $$props.type);
		};

		return [
			label,
			type,
			checkboxState,
			onCheckBoxChanged,
			change_handler,
			change_handler_1
		];
	}

	class Eas_checkbox_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$d, create_fragment$d, safe_not_equal, { label: 0, type: 1 }, add_css$c);
		}

		get label() {
			return this.$$.ctx[0];
		}

		set label(label) {
			this.$$set({ label });
			flush();
		}

		get type() {
			return this.$$.ctx[1];
		}

		set type(type) {
			this.$$set({ type });
			flush();
		}
	}

	customElements.define("eas-checkbox-swc", create_custom_element(Eas_checkbox_component, {"label":{},"type":{}}, [], [], true));

	/* src\lib\web-components\side-menu\eas-side-menu.component.svelte generated by Svelte v4.2.19 */

	function add_css$b(target) {
		append_styles(target, "svelte-x1ta18", ".container-menu.svelte-x1ta18.svelte-x1ta18{font-family:\"Source Sans Pro\", Tahoma, Verdana, Segoe, sans-serif;font-size:16px;display:inline-flex;width:310px;background-color:#fff;border-right:1px solid #d8d8d8;left:0}.nav.svelte-x1ta18.svelte-x1ta18{padding-top:45px;padding-left:5px;width:15.5vw;position:fixed}.nav--header.svelte-x1ta18.svelte-x1ta18{font-weight:bold;color:#FF0021;background-color:#FFE6E6;padding:10px}.nav--menu-container.svelte-x1ta18.svelte-x1ta18{padding-left:5px;padding-right:0;margin-top:5px;overflow:auto}.nav--menu-ul.svelte-x1ta18.svelte-x1ta18{list-style:none;padding-left:0;font-size:16px;overflow:auto}.nav--menu--li.svelte-x1ta18.svelte-x1ta18{transition:ease-in .2s}.nav--menu--li.svelte-x1ta18.svelte-x1ta18:hover{text-decoration:none;color:#525051;background-color:#DDD}.nav--a.svelte-x1ta18.svelte-x1ta18{display:block;color:#525051;font-weight:normal;text-decoration:none;padding-bottom:10px;padding-top:10px;padding-left:7px}.arrow-down.svelte-x1ta18.svelte-x1ta18,.arrow-up.svelte-x1ta18.svelte-x1ta18{padding:0 6px 0 4px;font-size:24px;float:right;width:15px;margin-top:-5px}.arrow-up.svelte-x1ta18.svelte-x1ta18{color:#FF0021}.active-open.nav--menu--li.svelte-x1ta18.svelte-x1ta18{color:#525051;background-color:#ECECEC;margin-left:0;font-size:18px}.sub-list--white.svelte-x1ta18.svelte-x1ta18{background:#fff;margin-top:8px;padding-left:15px;padding-top:8px;padding-bottom:8px}.sub-list.svelte-x1ta18 .nav--menu--li.svelte-x1ta18{font-size:14px}.sub-list--adjust.svelte-x1ta18.svelte-x1ta18{padding-left:5px}.sub-list.svelte-x1ta18.svelte-x1ta18{margin-top:5px;padding-left:5px}.nav--menu--li.sub-list--adjust.svelte-x1ta18.svelte-x1ta18:last-child{border-bottom-left-radius:8px;border-bottom-right-radius:8px}@media(max-width: 425px){}");
	}

	function get_each_context$4(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[19] = list[i];
		child_ctx[21] = i;
		return child_ctx;
	}

	function get_each_context_1$1(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[22] = list[i];
		child_ctx[24] = i;
		return child_ctx;
	}

	function get_each_context_2$1(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[25] = list[i];
		child_ctx[24] = i;
		return child_ctx;
	}

	// (109:16) {#if menudata && menudata.submenu && menudata.submenu.length > 0}
	function create_if_block$7(ctx) {
		let each_1_anchor;
		let each_value = ensure_array_like(/*menudata*/ ctx[0].submenu);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$4(get_each_context$4(ctx, each_value, i));
		}

		return {
			c() {
				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty();
			},
			m(target, anchor) {
				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata, onItemClickedNew, onItemClickedSub, onItemClickedMain*/ 7) {
					each_value = ensure_array_like(/*menudata*/ ctx[0].submenu);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$4(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$4(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(each_1_anchor);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (115:24) {#if item.submenu && item.submenu.length > 0 && item.expanded}
	function create_if_block_10(ctx) {
		let div;
		let svg;
		let path;
		let div_class_value;

		return {
			c() {
				div = element("div");
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill", "currentColor");
				attr(path, "d", "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "aria-hidden", "true");
				attr(svg, "focusable", "false");
				attr(svg, "data-prefix", "fas");
				attr(svg, "data-icon", "chevron-up");
				attr(svg, "class", "svg-inline--fa fa-chevron-up fa-w-14");
				attr(svg, "role", "img");
				attr(svg, "viewBox", "0 0 448 512");

				attr(div, "class", div_class_value = "arrow-" + (/*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && /*item*/ ctx[19].expanded
				? 'up'
				: 'none') + " svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, svg);
				append(svg, path);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata*/ 1 && div_class_value !== (div_class_value = "arrow-" + (/*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && /*item*/ ctx[19].expanded
				? 'up'
				: 'none') + " svelte-x1ta18")) {
					attr(div, "class", div_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (133:24) {#if item.submenu && item.submenu.length > 0 && (!item.expanded)}
	function create_if_block_9(ctx) {
		let div;
		let svg;
		let path;
		let div_class_value;

		return {
			c() {
				div = element("div");
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill", "currentColor");
				attr(path, "d", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "aria-hidden", "true");
				attr(svg, "focusable", "false");
				attr(svg, "data-prefix", "fas");
				attr(svg, "data-icon", "chevron-down");
				attr(svg, "class", "svg-inline--fa fa-chevron-down fa-w-14");
				attr(svg, "role", "img");
				attr(svg, "viewBox", "0 0 448 512");

				attr(div, "class", div_class_value = "arrow-" + (/*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && !/*item*/ ctx[19].expanded
				? 'down'
				: 'none') + " svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, svg);
				append(svg, path);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata*/ 1 && div_class_value !== (div_class_value = "arrow-" + (/*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && !/*item*/ ctx[19].expanded
				? 'down'
				: 'none') + " svelte-x1ta18")) {
					attr(div, "class", div_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (152:20) {#if item.submenu && item.submenu.length > 0 && (item.expanded)}
	function create_if_block_1$5(ctx) {
		let div;
		let ul;
		let if_block = /*item*/ ctx[19] && /*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && create_if_block_2$3(ctx);

		return {
			c() {
				div = element("div");
				ul = element("ul");
				if (if_block) if_block.c();
				attr(ul, "class", "nav--menu-ul svelte-x1ta18");
				attr(div, "class", "sub-list svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, ul);
				if (if_block) if_block.m(ul, null);
			},
			p(ctx, dirty) {
				if (/*item*/ ctx[19] && /*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_2$3(ctx);
						if_block.c();
						if_block.m(ul, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}

				if (if_block) if_block.d();
			}
		};
	}

	// (155:28) {#if item && item.submenu && item.submenu.length > 0}
	function create_if_block_2$3(ctx) {
		let each_1_anchor;
		let each_value_1 = ensure_array_like(/*item*/ ctx[19].submenu);
		let each_blocks = [];

		for (let i = 0; i < each_value_1.length; i += 1) {
			each_blocks[i] = create_each_block_1$1(get_each_context_1$1(ctx, each_value_1, i));
		}

		return {
			c() {
				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty();
			},
			m(target, anchor) {
				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata, onItemClickedNew, onItemClickedSub*/ 5) {
					each_value_1 = ensure_array_like(/*item*/ ctx[19].submenu);
					let i;

					for (i = 0; i < each_value_1.length; i += 1) {
						const child_ctx = get_each_context_1$1(ctx, each_value_1, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_1$1(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_1.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(each_1_anchor);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (160:44) {#if subItem.submenu && subItem.submenu.length > 0 && subItem.expanded}
	function create_if_block_8(ctx) {
		let div;
		let svg;
		let path;
		let div_class_value;

		return {
			c() {
				div = element("div");
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill", "currentColor");
				attr(path, "d", "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "aria-hidden", "true");
				attr(svg, "focusable", "false");
				attr(svg, "data-prefix", "fas");
				attr(svg, "data-icon", "chevron-up");
				attr(svg, "class", "svg-inline--fa fa-chevron-up fa-w-14");
				attr(svg, "role", "img");
				attr(svg, "viewBox", "0 0 448 512");

				attr(div, "class", div_class_value = "arrow-" + (/*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && /*subItem*/ ctx[22].expanded
				? 'up'
				: 'none') + " svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, svg);
				append(svg, path);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata*/ 1 && div_class_value !== (div_class_value = "arrow-" + (/*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && /*subItem*/ ctx[22].expanded
				? 'up'
				: 'none') + " svelte-x1ta18")) {
					attr(div, "class", div_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (178:44) {#if subItem.submenu && subItem.submenu.length > 0 && (!subItem.expanded)}
	function create_if_block_7(ctx) {
		let div;
		let svg;
		let path;
		let div_class_value;

		return {
			c() {
				div = element("div");
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill", "currentColor");
				attr(path, "d", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "aria-hidden", "true");
				attr(svg, "focusable", "false");
				attr(svg, "data-prefix", "fas");
				attr(svg, "data-icon", "chevron-down");
				attr(svg, "class", "svg-inline--fa fa-chevron-down fa-w-14");
				attr(svg, "role", "img");
				attr(svg, "viewBox", "0 0 448 512");

				attr(div, "class", div_class_value = "arrow-" + (/*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && !/*subItem*/ ctx[22].expanded
				? 'down'
				: 'none') + " svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, svg);
				append(svg, path);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata*/ 1 && div_class_value !== (div_class_value = "arrow-" + (/*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && !/*subItem*/ ctx[22].expanded
				? 'down'
				: 'none') + " svelte-x1ta18")) {
					attr(div, "class", div_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (197:40) {#if subItem.submenu && subItem.submenu.length > 0 && (subItem.expanded)}
	function create_if_block_3$1(ctx) {
		let div;
		let ul;
		let if_block = /*subItem*/ ctx[22] && /*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && create_if_block_4$1(ctx);

		return {
			c() {
				div = element("div");
				ul = element("ul");
				if (if_block) if_block.c();
				attr(ul, "class", "nav--menu-ul round-8 svelte-x1ta18");
				set_style(div, "padding-left", "10px");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, ul);
				if (if_block) if_block.m(ul, null);
			},
			p(ctx, dirty) {
				if (/*subItem*/ ctx[22] && /*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_4$1(ctx);
						if_block.c();
						if_block.m(ul, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}

				if (if_block) if_block.d();
			}
		};
	}

	// (200:52) {#if subItem && subItem.submenu && subItem.submenu.length > 0}
	function create_if_block_4$1(ctx) {
		let each_1_anchor;
		let each_value_2 = ensure_array_like(/*subItem*/ ctx[22].submenu);
		let each_blocks = [];

		for (let i = 0; i < each_value_2.length; i += 1) {
			each_blocks[i] = create_each_block_2$1(get_each_context_2$1(ctx, each_value_2, i));
		}

		return {
			c() {
				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty();
			},
			m(target, anchor) {
				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata, onItemClickedNew*/ 1) {
					each_value_2 = ensure_array_like(/*subItem*/ ctx[22].submenu);
					let i;

					for (i = 0; i < each_value_2.length; i += 1) {
						const child_ctx = get_each_context_2$1(ctx, each_value_2, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_2$1(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_2.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(each_1_anchor);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (205:60) {#if subSubItem.submenu && subSubItem.submenu.length > 0 && subSubItem.expanded}
	function create_if_block_6(ctx) {
		let div;
		let svg;
		let path;
		let div_class_value;

		return {
			c() {
				div = element("div");
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill", "currentColor");
				attr(path, "d", "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "aria-hidden", "true");
				attr(svg, "focusable", "false");
				attr(svg, "data-prefix", "fas");
				attr(svg, "data-icon", "chevron-up");
				attr(svg, "class", "svg-inline--fa fa-chevron-up fa-w-14");
				attr(svg, "role", "img");
				attr(svg, "viewBox", "0 0 448 512");

				attr(div, "class", div_class_value = "arrow-" + (/*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length > 0 && /*subSubItem*/ ctx[25].expanded
				? 'up'
				: 'none') + " svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, svg);
				append(svg, path);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata*/ 1 && div_class_value !== (div_class_value = "arrow-" + (/*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length > 0 && /*subSubItem*/ ctx[25].expanded
				? 'up'
				: 'none') + " svelte-x1ta18")) {
					attr(div, "class", div_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (223:60) {#if subSubItem.submenu && subSubItem.submenu.length > 0 && (!subSubItem.expanded)}
	function create_if_block_5(ctx) {
		let div;
		let svg;
		let path;
		let div_class_value;

		return {
			c() {
				div = element("div");
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill", "currentColor");
				attr(path, "d", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "aria-hidden", "true");
				attr(svg, "focusable", "false");
				attr(svg, "data-prefix", "fas");
				attr(svg, "data-icon", "chevron-down");
				attr(svg, "class", "svg-inline--fa fa-chevron-down fa-w-14");
				attr(svg, "role", "img");
				attr(svg, "viewBox", "0 0 448 512");

				attr(div, "class", div_class_value = "arrow-" + (/*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length > 0 && !/*subSubItem*/ ctx[25].expanded
				? 'down'
				: 'none') + " svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, svg);
				append(svg, path);
			},
			p(ctx, dirty) {
				if (dirty & /*menudata*/ 1 && div_class_value !== (div_class_value = "arrow-" + (/*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length > 0 && !/*subSubItem*/ ctx[25].expanded
				? 'down'
				: 'none') + " svelte-x1ta18")) {
					attr(div, "class", div_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (201:52) {#each subItem.submenu as subSubItem, subItemIndex}
	function create_each_block_2$1(ctx) {
		let li;
		let a;
		let t0_value = /*subSubItem*/ ctx[25].label + "";
		let t0;
		let t1;
		let t2;
		let t3;
		let li_class_value;
		let mounted;
		let dispose;
		let if_block0 = /*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length > 0 && /*subSubItem*/ ctx[25].expanded && create_if_block_6(ctx);
		let if_block1 = /*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length > 0 && !/*subSubItem*/ ctx[25].expanded && create_if_block_5(ctx);

		function click_handler_2(...args) {
			return /*click_handler_2*/ ctx[9](/*subSubItem*/ ctx[25], ...args);
		}

		return {
			c() {
				li = element("li");
				a = element("a");
				t0 = text(t0_value);
				t1 = space();
				if (if_block0) if_block0.c();
				t2 = space();
				if (if_block1) if_block1.c();
				t3 = space();
				attr(a, "class", "nav--a svelte-x1ta18");
				attr(a, "href", "javascript:void(0)");

				attr(li, "class", li_class_value = "nav--menu--li " + (/*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length === 0 && /*subSubItem*/ ctx[25].selected
				? 'sub-list--white'
				: '') + " svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, a);
				append(a, t0);
				append(a, t1);
				if (if_block0) if_block0.m(a, null);
				append(a, t2);
				if (if_block1) if_block1.m(a, null);
				append(li, t3);

				if (!mounted) {
					dispose = listen(a, "click", click_handler_2);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*menudata*/ 1 && t0_value !== (t0_value = /*subSubItem*/ ctx[25].label + "")) set_data(t0, t0_value);

				if (/*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length > 0 && /*subSubItem*/ ctx[25].expanded) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_6(ctx);
						if_block0.c();
						if_block0.m(a, t2);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length > 0 && !/*subSubItem*/ ctx[25].expanded) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_5(ctx);
						if_block1.c();
						if_block1.m(a, null);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (dirty & /*menudata*/ 1 && li_class_value !== (li_class_value = "nav--menu--li " + (/*subSubItem*/ ctx[25].submenu && /*subSubItem*/ ctx[25].submenu.length === 0 && /*subSubItem*/ ctx[25].selected
				? 'sub-list--white'
				: '') + " svelte-x1ta18")) {
					attr(li, "class", li_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				mounted = false;
				dispose();
			}
		};
	}

	// (156:28) {#each item.submenu as subItem, subItemIndex}
	function create_each_block_1$1(ctx) {
		let li;
		let a;
		let t0_value = /*subItem*/ ctx[22].label + "";
		let t0;
		let t1;
		let t2;
		let t3;
		let t4;
		let mounted;
		let dispose;
		let if_block0 = /*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && /*subItem*/ ctx[22].expanded && create_if_block_8(ctx);
		let if_block1 = /*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && !/*subItem*/ ctx[22].expanded && create_if_block_7(ctx);

		function click_handler_1(...args) {
			return /*click_handler_1*/ ctx[8](/*subItem*/ ctx[22], ...args);
		}

		let if_block2 = /*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && /*subItem*/ ctx[22].expanded && create_if_block_3$1(ctx);

		return {
			c() {
				li = element("li");
				a = element("a");
				t0 = text(t0_value);
				t1 = space();
				if (if_block0) if_block0.c();
				t2 = space();
				if (if_block1) if_block1.c();
				t3 = space();
				if (if_block2) if_block2.c();
				t4 = space();
				attr(a, "class", "nav--a svelte-x1ta18");
				attr(a, "href", "javascript:void(0)");
				attr(li, "class", "nav--menu--li sub-list--adjust svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, a);
				append(a, t0);
				append(a, t1);
				if (if_block0) if_block0.m(a, null);
				append(a, t2);
				if (if_block1) if_block1.m(a, null);
				append(li, t3);
				if (if_block2) if_block2.m(li, null);
				append(li, t4);

				if (!mounted) {
					dispose = listen(a, "click", click_handler_1);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*menudata*/ 1 && t0_value !== (t0_value = /*subItem*/ ctx[22].label + "")) set_data(t0, t0_value);

				if (/*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && /*subItem*/ ctx[22].expanded) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_8(ctx);
						if_block0.c();
						if_block0.m(a, t2);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && !/*subItem*/ ctx[22].expanded) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_7(ctx);
						if_block1.c();
						if_block1.m(a, null);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*subItem*/ ctx[22].submenu && /*subItem*/ ctx[22].submenu.length > 0 && /*subItem*/ ctx[22].expanded) {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_3$1(ctx);
						if_block2.c();
						if_block2.m(li, t4);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				if (if_block2) if_block2.d();
				mounted = false;
				dispose();
			}
		};
	}

	// (110:16) {#each menudata.submenu as item, itemIndex}
	function create_each_block$4(ctx) {
		let li;
		let a;
		let t0_value = /*item*/ ctx[19].label + "";
		let t0;
		let t1;
		let t2;
		let t3;
		let t4;
		let mounted;
		let dispose;
		let if_block0 = /*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && /*item*/ ctx[19].expanded && create_if_block_10(ctx);
		let if_block1 = /*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && !/*item*/ ctx[19].expanded && create_if_block_9(ctx);

		function click_handler(...args) {
			return /*click_handler*/ ctx[7](/*item*/ ctx[19], ...args);
		}

		let if_block2 = /*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && /*item*/ ctx[19].expanded && create_if_block_1$5(ctx);

		return {
			c() {
				li = element("li");
				a = element("a");
				t0 = text(t0_value);
				t1 = space();
				if (if_block0) if_block0.c();
				t2 = space();
				if (if_block1) if_block1.c();
				t3 = space();
				if (if_block2) if_block2.c();
				t4 = space();
				attr(a, "href", "javascript:void(0)");
				attr(a, "class", "nav--a svelte-x1ta18");
				attr(li, "class", "nav--menu--li active-open round-8 svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, li, anchor);
				append(li, a);
				append(a, t0);
				append(a, t1);
				if (if_block0) if_block0.m(a, null);
				append(a, t2);
				if (if_block1) if_block1.m(a, null);
				append(li, t3);
				if (if_block2) if_block2.m(li, null);
				append(li, t4);

				if (!mounted) {
					dispose = listen(a, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*menudata*/ 1 && t0_value !== (t0_value = /*item*/ ctx[19].label + "")) set_data(t0, t0_value);

				if (/*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && /*item*/ ctx[19].expanded) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_10(ctx);
						if_block0.c();
						if_block0.m(a, t2);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && !/*item*/ ctx[19].expanded) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_9(ctx);
						if_block1.c();
						if_block1.m(a, null);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*item*/ ctx[19].submenu && /*item*/ ctx[19].submenu.length > 0 && /*item*/ ctx[19].expanded) {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_1$5(ctx);
						if_block2.c();
						if_block2.m(li, t4);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(li);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				if (if_block2) if_block2.d();
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$c(ctx) {
		let link;
		let t0;
		let div3;
		let div2;
		let div0;
		let t1_value = (/*menudata*/ ctx[0] ? /*menudata*/ ctx[0].label : '') + "";
		let t1;
		let t2;
		let div1;
		let ul;
		let if_block = /*menudata*/ ctx[0] && /*menudata*/ ctx[0].submenu && /*menudata*/ ctx[0].submenu.length > 0 && create_if_block$7(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div3 = element("div");
				div2 = element("div");
				div0 = element("div");
				t1 = text(t1_value);
				t2 = space();
				div1 = element("div");
				ul = element("ul");
				if (if_block) if_block.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(div0, "class", "nav--header svelte-x1ta18");
				attr(ul, "class", "nav--menu-ul svelte-x1ta18");
				attr(div1, "class", "nav--menu-container svelte-x1ta18");
				attr(div2, "class", "nav svelte-x1ta18");
				attr(div3, "class", "container-menu svelte-x1ta18");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div3, anchor);
				append(div3, div2);
				append(div2, div0);
				append(div0, t1);
				append(div2, t2);
				append(div2, div1);
				append(div1, ul);
				if (if_block) if_block.m(ul, null);
			},
			p(ctx, [dirty]) {
				if (dirty & /*menudata*/ 1 && t1_value !== (t1_value = (/*menudata*/ ctx[0] ? /*menudata*/ ctx[0].label : '') + "")) set_data(t1, t1_value);

				if (/*menudata*/ ctx[0] && /*menudata*/ ctx[0].submenu && /*menudata*/ ctx[0].submenu.length > 0) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$7(ctx);
						if_block.c();
						if_block.m(ul, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div3);
				}

				if (if_block) if_block.d();
			}
		};
	}

	function instance$c($$self, $$props, $$invalidate) {
		let { groupedmenudata = [] } = $$props;
		let { menudata = {} } = $$props;
		let { shoulddisplay = false } = $$props;
		let { shoulddisplaysection = false } = $$props;
		let { selectedmenuitem = '' } = $$props;
		const svelteDispatch = createEventDispatcher();

		function getSelectedKeys(nodes, key) {
			for (const node of nodes || []) {
				if (node.menuKey == key) {
					if (node.parentMenuKey) getSelectedKeys(nodes, node.parentMenuKey);
				} else getSelectedKeys(node.submenu, key);
			}
		}

		function onItemClickedMain(e, item) {
			let eventData = {
				...e,
				item: { ...item, "expanded": !item.expanded }
			};

			svelteDispatch("sidemenuItemClicked", eventData);
		}

		function onItemClickedSub(e, item) {
			let eventData = {
				...e,
				item: { ...item, "expanded": true }
			};

			svelteDispatch("sidemenuItemClicked", eventData);
		}

		const click_handler = (item, e) => onItemClickedMain(e, item);
		const click_handler_1 = (subItem, e) => onItemClickedSub(e, subItem);
		const click_handler_2 = (subSubItem, e) => onItemClickedNew(e, subSubItem);

		$$self.$$set = $$props => {
			if ('groupedmenudata' in $$props) $$invalidate(3, groupedmenudata = $$props.groupedmenudata);
			if ('menudata' in $$props) $$invalidate(0, menudata = $$props.menudata);
			if ('shoulddisplay' in $$props) $$invalidate(4, shoulddisplay = $$props.shoulddisplay);
			if ('shoulddisplaysection' in $$props) $$invalidate(5, shoulddisplaysection = $$props.shoulddisplaysection);
			if ('selectedmenuitem' in $$props) $$invalidate(6, selectedmenuitem = $$props.selectedmenuitem);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*selectedmenuitem*/ 64) {
				console.log('selectedmenuitem ', selectedmenuitem);
			}

			if ($$self.$$.dirty & /*groupedmenudata*/ 8) {
				console.log('groupedmenudata ', groupedmenudata);
			}

			if ($$self.$$.dirty & /*shoulddisplay*/ 16) {
				console.log('shoulddisplay ', shoulddisplay);
			}

			if ($$self.$$.dirty & /*shoulddisplaysection*/ 32) {
				console.log('shoulddisplaysection ', shoulddisplaysection);
			}

			if ($$self.$$.dirty & /*menudata*/ 1) {
				console.log('menudata ', menudata);
			}

			if ($$self.$$.dirty & /*groupedmenudata, selectedmenuitem*/ 72) {
				{
					groupedmenudata.forEach(x => {
						getSelectedKeys(x[1], selectedmenuitem);
					});
				}
			}

			if ($$self.$$.dirty & /*groupedmenudata*/ 8) {
				groupedmenudata ? [...groupedmenudata] : [];
			}
		};

		console.log('----------EAS Svelte Side Menu Cmmponent---------');

		return [
			menudata,
			onItemClickedMain,
			onItemClickedSub,
			groupedmenudata,
			shoulddisplay,
			shoulddisplaysection,
			selectedmenuitem,
			click_handler,
			click_handler_1,
			click_handler_2
		];
	}

	class Eas_side_menu_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$c,
				create_fragment$c,
				safe_not_equal,
				{
					groupedmenudata: 3,
					menudata: 0,
					shoulddisplay: 4,
					shoulddisplaysection: 5,
					selectedmenuitem: 6
				},
				add_css$b
			);
		}

		get groupedmenudata() {
			return this.$$.ctx[3];
		}

		set groupedmenudata(groupedmenudata) {
			this.$$set({ groupedmenudata });
			flush();
		}

		get menudata() {
			return this.$$.ctx[0];
		}

		set menudata(menudata) {
			this.$$set({ menudata });
			flush();
		}

		get shoulddisplay() {
			return this.$$.ctx[4];
		}

		set shoulddisplay(shoulddisplay) {
			this.$$set({ shoulddisplay });
			flush();
		}

		get shoulddisplaysection() {
			return this.$$.ctx[5];
		}

		set shoulddisplaysection(shoulddisplaysection) {
			this.$$set({ shoulddisplaysection });
			flush();
		}

		get selectedmenuitem() {
			return this.$$.ctx[6];
		}

		set selectedmenuitem(selectedmenuitem) {
			this.$$set({ selectedmenuitem });
			flush();
		}
	}

	customElements.define("eas-side-menu-swc", create_custom_element(Eas_side_menu_component, {"groupedmenudata":{},"menudata":{},"shoulddisplay":{"type":"Boolean"},"shoulddisplaysection":{"type":"Boolean"},"selectedmenuitem":{}}, [], [], true));

	/* src\lib\web-components\spinner\eas-spinner.component.svelte generated by Svelte v4.2.19 */

	function add_css$a(target) {
		append_styles(target, "svelte-rgrnvo", ".spinner-overlay.svelte-rgrnvo.svelte-rgrnvo{z-index:99999;position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(255, 255, 255, 0.7)}.lds-spinner.svelte-rgrnvo.svelte-rgrnvo{color:official;display:inline-block;position:absolute;top:calc(50% - 40px);left:50%;width:80px;height:80px}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo{transform-origin:40px 40px;animation:svelte-rgrnvo-lds-spinner 1.2s linear infinite}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:after{content:\" \";display:block;position:absolute;top:3px;left:37px;width:6px;height:18px;border-radius:20%;background:var(--blue-800, #3d7aa9) !important}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(1){transform:rotate(0deg);animation-delay:-1.1s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(2){transform:rotate(30deg);animation-delay:-1s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(3){transform:rotate(60deg);animation-delay:-0.9s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(4){transform:rotate(90deg);animation-delay:-0.8s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(5){transform:rotate(120deg);animation-delay:-0.7s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(6){transform:rotate(150deg);animation-delay:-0.6s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(7){transform:rotate(180deg);animation-delay:-0.5s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(8){transform:rotate(210deg);animation-delay:-0.4s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(9){transform:rotate(240deg);animation-delay:-0.3s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(10){transform:rotate(270deg);animation-delay:-0.2s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(11){transform:rotate(300deg);animation-delay:-0.1s}.lds-spinner.svelte-rgrnvo div.svelte-rgrnvo:nth-child(12){transform:rotate(330deg);animation-delay:0s}@keyframes svelte-rgrnvo-lds-spinner{0%{opacity:1}100%{opacity:0}}");
	}

	function create_fragment$b(ctx) {
		let link;
		let t0;
		let div13;
		let div12;
		let div0;
		let t1;
		let div1;
		let t2;
		let div2;
		let t3;
		let div3;
		let t4;
		let div4;
		let t5;
		let div5;
		let t6;
		let div6;
		let t7;
		let div7;
		let t8;
		let div8;
		let t9;
		let div9;
		let t10;
		let div10;
		let t11;
		let div11;
		let div12_style_value;
		let div13_style_value;

		return {
			c() {
				link = element("link");
				t0 = space();
				div13 = element("div");
				div12 = element("div");
				div0 = element("div");
				t1 = space();
				div1 = element("div");
				t2 = space();
				div2 = element("div");
				t3 = space();
				div3 = element("div");
				t4 = space();
				div4 = element("div");
				t5 = space();
				div5 = element("div");
				t6 = space();
				div6 = element("div");
				t7 = space();
				div7 = element("div");
				t8 = space();
				div8 = element("div");
				t9 = space();
				div9 = element("div");
				t10 = space();
				div10 = element("div");
				t11 = space();
				div11 = element("div");
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(div0, "class", "svelte-rgrnvo");
				attr(div1, "class", "svelte-rgrnvo");
				attr(div2, "class", "svelte-rgrnvo");
				attr(div3, "class", "svelte-rgrnvo");
				attr(div4, "class", "svelte-rgrnvo");
				attr(div5, "class", "svelte-rgrnvo");
				attr(div6, "class", "svelte-rgrnvo");
				attr(div7, "class", "svelte-rgrnvo");
				attr(div8, "class", "svelte-rgrnvo");
				attr(div9, "class", "svelte-rgrnvo");
				attr(div10, "class", "svelte-rgrnvo");
				attr(div11, "class", "svelte-rgrnvo");
				attr(div12, "class", "lds-spinner svelte-rgrnvo");
				attr(div12, "style", div12_style_value = "width:50px;height:50px; " + /*customStyle*/ ctx[1]);
				attr(div13, "class", "spinner-overlay svelte-rgrnvo");
				attr(div13, "style", div13_style_value = /*uiblock*/ ctx[0] ? 'display:block' : 'display: none');
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div13, anchor);
				append(div13, div12);
				append(div12, div0);
				append(div12, t1);
				append(div12, div1);
				append(div12, t2);
				append(div12, div2);
				append(div12, t3);
				append(div12, div3);
				append(div12, t4);
				append(div12, div4);
				append(div12, t5);
				append(div12, div5);
				append(div12, t6);
				append(div12, div6);
				append(div12, t7);
				append(div12, div7);
				append(div12, t8);
				append(div12, div8);
				append(div12, t9);
				append(div12, div9);
				append(div12, t10);
				append(div12, div10);
				append(div12, t11);
				append(div12, div11);
			},
			p(ctx, [dirty]) {
				if (dirty & /*customStyle*/ 2 && div12_style_value !== (div12_style_value = "width:50px;height:50px; " + /*customStyle*/ ctx[1])) {
					attr(div12, "style", div12_style_value);
				}

				if (dirty & /*uiblock*/ 1 && div13_style_value !== (div13_style_value = /*uiblock*/ ctx[0] ? 'display:block' : 'display: none')) {
					attr(div13, "style", div13_style_value);
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div13);
				}
			}
		};
	}

	function instance$b($$self, $$props, $$invalidate) {
		let { customstyles = [] } = $$props;
		let { uiblock } = $$props;
		let customStyle = '';

		$$self.$$set = $$props => {
			if ('customstyles' in $$props) $$invalidate(2, customstyles = $$props.customstyles);
			if ('uiblock' in $$props) $$invalidate(0, uiblock = $$props.uiblock);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*customstyles, customStyle*/ 6) {
				customstyles.map(x => {
					$$invalidate(1, customStyle += x.key + ':' + x.value + ';');
				});
			}
		};

		return [uiblock, customStyle, customstyles];
	}

	class Eas_spinner_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$b, create_fragment$b, safe_not_equal, { customstyles: 2, uiblock: 0 }, add_css$a);
		}

		get customstyles() {
			return this.$$.ctx[2];
		}

		set customstyles(customstyles) {
			this.$$set({ customstyles });
			flush();
		}

		get uiblock() {
			return this.$$.ctx[0];
		}

		set uiblock(uiblock) {
			this.$$set({ uiblock });
			flush();
		}
	}

	customElements.define("eas-spinner-swc", create_custom_element(Eas_spinner_component, {"customstyles":{},"uiblock":{}}, [], [], true));

	/* src\lib\web-components\ribbon\eas-ribbon.component.svelte generated by Svelte v4.2.19 */

	function add_css$9(target) {
		append_styles(target, "svelte-1g1ru5l", ".ribbon-container.svelte-1g1ru5l.svelte-1g1ru5l{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif}button.svelte-1g1ru5l.svelte-1g1ru5l{padding:0 10px;height:38px}button.svelte-1g1ru5l.svelte-1g1ru5l{position:relative;display:flex;align-items:center;justify-content:center;height:44px;width:max-content;padding:0 20px;border:0;font-size:16px;cursor:pointer;background:transparent;transition:all 0.2s ease-in-out !important}.rounded-4.svelte-1g1ru5l.svelte-1g1ru5l{border-radius:4px !important}.flex-row-reverse.svelte-1g1ru5l.svelte-1g1ru5l{flex-direction:row-reverse !important}button.border-black.svelte-1g1ru5l.svelte-1g1ru5l:hover{border-color:transparent}button.secondary.svelte-1g1ru5l.svelte-1g1ru5l{border:2px;border-style:solid;background:transparent}.hover-blue-800.svelte-1g1ru5l.svelte-1g1ru5l:hover{background:#3d7aa9 !important}button.border-black.svelte-1g1ru5l.svelte-1g1ru5l{border-color:black}button.border-grey.svelte-1g1ru5l.svelte-1g1ru5l{border-color:grey}.width-full.svelte-1g1ru5l.svelte-1g1ru5l{width:100% !important;max-width:100% !important}.border-gray-600.svelte-1g1ru5l.svelte-1g1ru5l{border-color:#8c8c8c !important}.border-bottom.svelte-1g1ru5l.svelte-1g1ru5l{border-bottom:1px solid #d9d9d9}ul.ribbon.svelte-1g1ru5l.svelte-1g1ru5l{list-style-type:none;padding-left:0;margin-left:0 !important;margin-bottom:10px;margin-top:0;display:flex}ul.ribbon.svelte-1g1ru5l li.svelte-1g1ru5l{padding:4px}ul.ribbon.svelte-1g1ru5l li.svelte-1g1ru5l:nth-of-type(3){margin-left:auto;margin-right:auto;text-align:center}button.border-black.svelte-1g1ru5l.svelte-1g1ru5l:hover{border-color:transparent}button.svelte-1g1ru5l.svelte-1g1ru5l{padding:0 10px;height:38px}.bold.svelte-1g1ru5l.svelte-1g1ru5l{font-weight:bold !important}:hover.hover-font-white.svelte-1g1ru5l>.svelte-1g1ru5l{color:white !important}");
	}

	// (47:0) {#if name && stat}
	function create_if_block$6(ctx) {
		let div4;
		let div3;
		let nav;
		let ul;
		let li0;
		let button;
		let div0;
		let t0;
		let li1;
		let t1;
		let li2;
		let div1;
		let b0;
		let t2;
		let t3;
		let div2;
		let span1;
		let t5;
		let span2;
		let b1;
		let t6;
		let t7;
		let li3;
		let mounted;
		let dispose;

		function select_block_type(ctx, dirty) {
			if (/*reachedbegining*/ ctx[0] === true) return create_if_block_2$2;
			return create_else_block_1$2;
		}

		let current_block_type = select_block_type(ctx);
		let if_block0 = current_block_type(ctx);

		function select_block_type_1(ctx, dirty) {
			if (/*reachedend*/ ctx[1] === true) return create_if_block_1$4;
			return create_else_block$3;
		}

		let current_block_type_1 = select_block_type_1(ctx);
		let if_block1 = current_block_type_1(ctx);

		return {
			c() {
				div4 = element("div");
				div3 = element("div");
				nav = element("nav");
				ul = element("ul");
				li0 = element("li");
				button = element("button");
				div0 = element("div");
				div0.innerHTML = `<span><i class="fa-solid fa-list"></i></span>`;
				t0 = space();
				li1 = element("li");
				if_block0.c();
				t1 = space();
				li2 = element("li");
				div1 = element("div");
				b0 = element("b");
				t2 = text(/*name*/ ctx[3]);
				t3 = space();
				div2 = element("div");
				span1 = element("span");
				span1.textContent = "Status:";
				t5 = space();
				span2 = element("span");
				b1 = element("b");
				t6 = text(/*stat*/ ctx[2]);
				t7 = space();
				li3 = element("li");
				if_block1.c();
				attr(div0, "class", "btn-txt font-black bold svelte-1g1ru5l");
				attr(button, "id", "");
				attr(button, "class", "secondary border-black rounded-4 hover-blue-800 hover-font-white flex-row-reverse mobile svelte-1g1ru5l");
				attr(li0, "class", "svelte-1g1ru5l");
				attr(li1, "class", "svelte-1g1ru5l");
				attr(li2, "class", "svelte-1g1ru5l");
				attr(li3, "class", "svelte-1g1ru5l");
				attr(ul, "class", "ribbon border-bottom border-gray-600 svelte-1g1ru5l");
				attr(div3, "class", "width-full svelte-1g1ru5l");
				attr(div4, "class", "ribbon-container svelte-1g1ru5l");
			},
			m(target, anchor) {
				insert(target, div4, anchor);
				append(div4, div3);
				append(div3, nav);
				append(nav, ul);
				append(ul, li0);
				append(li0, button);
				append(button, div0);
				append(ul, t0);
				append(ul, li1);
				if_block0.m(li1, null);
				append(ul, t1);
				append(ul, li2);
				append(li2, div1);
				append(div1, b0);
				append(b0, t2);
				append(li2, t3);
				append(li2, div2);
				append(div2, span1);
				append(div2, t5);
				append(div2, span2);
				append(span2, b1);
				append(b1, t6);
				append(ul, t7);
				append(ul, li3);
				if_block1.m(li3, null);

				if (!mounted) {
					dispose = listen(div0, "click", /*click_handler*/ ctx[9]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0.d(1);
					if_block0 = current_block_type(ctx);

					if (if_block0) {
						if_block0.c();
						if_block0.m(li1, null);
					}
				}

				if (dirty & /*name*/ 8) set_data(t2, /*name*/ ctx[3]);
				if (dirty & /*stat*/ 4) set_data(t6, /*stat*/ ctx[2]);

				if (current_block_type_1 === (current_block_type_1 = select_block_type_1(ctx)) && if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1.d(1);
					if_block1 = current_block_type_1(ctx);

					if (if_block1) {
						if_block1.c();
						if_block1.m(li3, null);
					}
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div4);
				}

				if_block0.d();
				if_block1.d();
				mounted = false;
				dispose();
			}
		};
	}

	// (76:5) {:else}
	function create_else_block_1$2(ctx) {
		let button;
		let div;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				div.innerHTML = `<span><i class="fa-solid fa-arrow-left fa-lg"></i></span>`;
				attr(div, "class", "btn-txt font-black bold svelte-1g1ru5l");
				attr(button, "id", "");
				attr(button, "class", "secondary border-black rounded-4 hover-blue-800 hover-font-white flex-row-reverse mobile svelte-1g1ru5l");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);

				if (!mounted) {
					dispose = listen(div, "click", /*click_handler_2*/ ctx[11]);
					mounted = true;
				}
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (65:5) {#if reachedbegining === true}
	function create_if_block_2$2(ctx) {
		let button;
		let div;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				div.innerHTML = `<span><i class="fa-solid fa-arrow-left fa-lg"></i></span>`;
				attr(div, "class", "btn-txt font-black bold svelte-1g1ru5l");
				button.disabled = true;
				attr(button, "id", "");
				attr(button, "class", "secondary border-grey rounded-4 hover-font-white flex-row-reverse mobile svelte-1g1ru5l");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);

				if (!mounted) {
					dispose = listen(div, "click", /*click_handler_1*/ ctx[10]);
					mounted = true;
				}
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (108:5) {:else}
	function create_else_block$3(ctx) {
		let button;
		let div;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				div.innerHTML = `<span><i class="fa-solid fa-arrow-right fa-lg"></i></span>`;
				attr(div, "class", "btn-txt font-black bold svelte-1g1ru5l");
				attr(button, "id", "");
				attr(button, "class", "secondary border-black rounded-4 hover-blue-800 hover-font-white flex-row-reverse mobile svelte-1g1ru5l");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);

				if (!mounted) {
					dispose = listen(div, "click", /*click_handler_4*/ ctx[13]);
					mounted = true;
				}
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (97:5) {#if reachedend === true}
	function create_if_block_1$4(ctx) {
		let button;
		let div;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				div.innerHTML = `<span><i class="fa-solid fa-arrow-right fa-lg"></i></span>`;
				attr(div, "class", "btn-txt font-black bold svelte-1g1ru5l");
				button.disabled = true;
				attr(button, "id", "");
				attr(button, "class", "secondary border-grey rounded-4 hover-font-white flex-row-reverse mobile svelte-1g1ru5l");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);

				if (!mounted) {
					dispose = listen(div, "click", /*click_handler_3*/ ctx[12]);
					mounted = true;
				}
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$a(ctx) {
		let link;
		let t;
		let if_block_anchor;
		let if_block = /*name*/ ctx[3] && /*stat*/ ctx[2] && create_if_block$6(ctx);

		return {
			c() {
				link = element("link");
				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, [dirty]) {
				if (/*name*/ ctx[3] && /*stat*/ ctx[2]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$6(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t);
					detach(if_block_anchor);
				}

				if (if_block) if_block.d(detaching);
			}
		};
	}

	function instance$a($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { carouseldata } = $$props;
		let { contactkey } = $$props;
		let { reachedbegining } = $$props;
		let { reachedend } = $$props;
		let stat = '';
		let name = '';
		let currentIndex;

		function onPreviousClick(e) {
			if (currentIndex > 0 && currentIndex < carouseldata.length) {
				currentIndex--;
				$$invalidate(2, stat = carouseldata[currentIndex].requestType);
				$$invalidate(3, name = carouseldata[currentIndex].status);

				svelteDispatch('newPreviousRequestInstanceKey', {
					contactkey: carouseldata[currentIndex].key,
					currentIndex
				});
			} else {
				svelteDispatch('newPreviousRequestInstanceKey', { contactkey: -1 });
			}
		}

		function onNextClick(e) {
			currentIndex = carouseldata.findIndex(x => x.key === contactkey);

			if (currentIndex >= 0 && currentIndex < carouseldata.length - 1) {
				currentIndex++;
				$$invalidate(2, stat = carouseldata[currentIndex].requestType);
				$$invalidate(3, name = carouseldata[currentIndex].status);

				svelteDispatch('newNextRequestInstanceKey', {
					contactkey: carouseldata[currentIndex].key,
					currentIndex
				});
			} else {
				svelteDispatch('newNextRequestInstanceKey', { contactkey: -1 });
			}
		}

		function navigateToSearch(e) {
			svelteDispatch("navigateToSearch", e);
		}

		const click_handler = e => {
			navigateToSearch(e);
		};

		const click_handler_1 = e => {
			onPreviousClick();
		};

		const click_handler_2 = e => {
			onPreviousClick();
		};

		const click_handler_3 = e => {
			onNextClick();
		};

		const click_handler_4 = e => {
			onNextClick();
		};

		$$self.$$set = $$props => {
			if ('carouseldata' in $$props) $$invalidate(7, carouseldata = $$props.carouseldata);
			if ('contactkey' in $$props) $$invalidate(8, contactkey = $$props.contactkey);
			if ('reachedbegining' in $$props) $$invalidate(0, reachedbegining = $$props.reachedbegining);
			if ('reachedend' in $$props) $$invalidate(1, reachedend = $$props.reachedend);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*carouseldata, contactkey*/ 384) {
				{
					$$invalidate(2, stat = carouseldata?.filter(x => x.key === contactkey)[0]?.requestType);
					$$invalidate(3, name = carouseldata?.filter(x => x.key === contactkey)[0]?.status);
					currentIndex = carouseldata?.findIndex(x => x.key === contactkey);
				}
			}
		};

		return [
			reachedbegining,
			reachedend,
			stat,
			name,
			onPreviousClick,
			onNextClick,
			navigateToSearch,
			carouseldata,
			contactkey,
			click_handler,
			click_handler_1,
			click_handler_2,
			click_handler_3,
			click_handler_4
		];
	}

	class Eas_ribbon_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$a,
				create_fragment$a,
				safe_not_equal,
				{
					carouseldata: 7,
					contactkey: 8,
					reachedbegining: 0,
					reachedend: 1
				},
				add_css$9
			);
		}

		get carouseldata() {
			return this.$$.ctx[7];
		}

		set carouseldata(carouseldata) {
			this.$$set({ carouseldata });
			flush();
		}

		get contactkey() {
			return this.$$.ctx[8];
		}

		set contactkey(contactkey) {
			this.$$set({ contactkey });
			flush();
		}

		get reachedbegining() {
			return this.$$.ctx[0];
		}

		set reachedbegining(reachedbegining) {
			this.$$set({ reachedbegining });
			flush();
		}

		get reachedend() {
			return this.$$.ctx[1];
		}

		set reachedend(reachedend) {
			this.$$set({ reachedend });
			flush();
		}
	}

	customElements.define("eas-ribbon-swc", create_custom_element(Eas_ribbon_component, {"carouseldata":{},"contactkey":{},"reachedbegining":{},"reachedend":{}}, [], [], true));

	/* src\lib\web-components\select-new\eas-select-newest.component.svelte generated by Svelte v4.2.19 */

	function add_css$8(target) {
		append_styles(target, "svelte-1m7z9te", ".rounded-4.svelte-1m7z9te.svelte-1m7z9te{border-radius:4px !important}.ds-floating-label.svelte-1m7z9te.svelte-1m7z9te{text-decoration:inherit;text-transform:inherit;position:absolute;transform-origin:left top;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);line-height:1.15rem;text-align:left;font-size:1rem;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;padding-right:16px}.ds-select-field.gray.svelte-1m7z9te.svelte-1m7z9te{background:white}.select-container.edit.svelte-1m7z9te.svelte-1m7z9te{margin-bottom:5px}.svelte-1m7z9te.svelte-1m7z9te,.svelte-1m7z9te.svelte-1m7z9te::after,.svelte-1m7z9te.svelte-1m7z9te::before{box-sizing:border-box;padding:0px;margin:0px}.hover-gray-300.svelte-1m7z9te.svelte-1m7z9te:hover{background:#e8e8e8 !important}.border-gray-600.svelte-1m7z9te.svelte-1m7z9te{border-color:#8c8c8c !important}.border-bottom.svelte-1m7z9te.svelte-1m7z9te{border-bottom:1px solid #d9d9d9}.width-full.svelte-1m7z9te.svelte-1m7z9te{width:100% !important;max-width:100% !important}div.svelte-1m7z9te.svelte-1m7z9te{background:transparent;transition:all 0.2s ease-in-out 0s}.select-container.svelte-1m7z9te.svelte-1m7z9te{position:relative}.border-gray-600.svelte-1m7z9te.svelte-1m7z9te{border-color:var(--gray-600) !important}select.svelte-1m7z9te.svelte-1m7z9te{appearance:none;-webkit-appearence:none;-moz-appearance:none}.ds-select-field.svelte-1m7z9te.svelte-1m7z9te{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif;display:inline-flex;position:relative;height:56px;width:100%;font-size:16px;color:black;border-radius:4px 4px 0 0;padding:20px 20px 0 20px;margin-bottom:35px;margin:0;border:0;outline:none;cursor:pointer;box-sizing:border-box;overflow:hidden;background:white;transition:all 0.2s ease-in-out}.select-container.chevron.svelte-1m7z9te.svelte-1m7z9te::before{content:'\\f078';position:absolute;top:23px;right:20px;font-family:'font awesome 5 pro';font-weight:800;pointer-events:none;z-index:100}.select-container.chevron.svelte-1m7z9te::before>select.svelte-1m7z9te:active{content:'\\f078';position:absolute;top:18px;right:20px;font-family:'font awesome 5 pro';transform:rotate(180deg);pointer-events:none}select.svelte-1m7z9te:invalid~.ds-floating-label.svelte-1m7z9te{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif;left:0;right:initial;top:30%;width:100%;padding:0 20px;font-size:0.875rem;transform:translateY(-30%);pointer-events:none;color:#434343}select.svelte-1m7z9te:valid~.ds-floating-label.svelte-1m7z9te{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif;left:0;right:initial;top:30%;width:100%;padding:0 20px;font-size:0.875rem;transform:translateY(-30%);pointer-events:none;color:#434343}select.svelte-1m7z9te:focus~.ds-floating-label.svelte-1m7z9te{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif;left:0;right:initial;top:30%;width:100%;padding:0 20px;font-size:0.875rem;transform:translateY(-30%);pointer-events:none;color:#434343}select:focus.ds-select-field.svelte-1m7z9te.svelte-1m7z9te{background:#dfdfdf}select:focus.ds-select-field.svelte-1m7z9te.svelte-1m7z9te:hover{background:#dfdfdf}select.svelte-1m7z9te.svelte-1m7z9te::-ms-expand{display:none}.select-container.svelte-1m7z9te.svelte-1m7z9te{position:relative}.select-container.svelte-1m7z9te .error.svelte-1m7z9te{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif;position:absolute;bottom:-13px;left:15px;height:10px;width:calc(100% - 15px);padding:0 0 0 10px;font-size:15px;color:#EA1014;transition:all .2s ease-in-out}.select-container.svelte-1m7z9te .error.svelte-1m7z9te::after{content:'';position:absolute;left:0;top:8px;width:4px;height:4px;border-radius:50%;background:#EA1014}.select-container.svelte-1m7z9te .error.svelte-1m7z9te::before{content:'';font-family:\"Font Awesome 5 Pro\";position:absolute;bottom:22px;right:15px;height:30px;width:30px;padding:0 0 0 10px;font-size:22px;font-weight:800;color:#EA1014;z-index:100;pointer-events:none}");
	}

	function get_each_context$3(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[16] = list[i];
		return child_ctx;
	}

	// (47:3) {:else}
	function create_else_block_1$1(ctx) {
		let option;
		let t0_value = /*item*/ ctx[16].value + "";
		let t0;
		let t1;
		let option_value_value;

		return {
			c() {
				option = element("option");
				t0 = text(t0_value);
				t1 = space();
				option.__value = option_value_value = /*item*/ ctx[16].key;
				set_input_value(option, option.__value);
				attr(option, "class", "svelte-1m7z9te");
			},
			m(target, anchor) {
				insert(target, option, anchor);
				append(option, t0);
				append(option, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 2 && t0_value !== (t0_value = /*item*/ ctx[16].value + "")) set_data(t0, t0_value);

				if (dirty & /*data*/ 2 && option_value_value !== (option_value_value = /*item*/ ctx[16].key)) {
					option.__value = option_value_value;
					set_input_value(option, option.__value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(option);
				}
			}
		};
	}

	// (37:3) {#if selecteditem}
	function create_if_block_1$3(ctx) {
		let show_if;
		let if_block_anchor;

		function select_block_type_1(ctx, dirty) {
			if (dirty & /*selecteditem, data*/ 3) show_if = null;
			if (show_if == null) show_if = !!(Number(/*selecteditem*/ ctx[0]) === /*item*/ ctx[16].key);
			if (show_if) return create_if_block_2$1;
			return create_else_block$2;
		}

		let current_block_type = select_block_type_1(ctx, -1);
		let if_block = current_block_type(ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty();
			},
			m(target, anchor) {
				if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				}
			},
			d(detaching) {
				if (detaching) {
					detach(if_block_anchor);
				}

				if_block.d(detaching);
			}
		};
	}

	// (42:4) {:else}
	function create_else_block$2(ctx) {
		let option;
		let t0_value = /*item*/ ctx[16].value + "";
		let t0;
		let t1;
		let option_value_value;

		return {
			c() {
				option = element("option");
				t0 = text(t0_value);
				t1 = space();
				option.__value = option_value_value = /*item*/ ctx[16].key;
				set_input_value(option, option.__value);
				attr(option, "class", "svelte-1m7z9te");
			},
			m(target, anchor) {
				insert(target, option, anchor);
				append(option, t0);
				append(option, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 2 && t0_value !== (t0_value = /*item*/ ctx[16].value + "")) set_data(t0, t0_value);

				if (dirty & /*data*/ 2 && option_value_value !== (option_value_value = /*item*/ ctx[16].key)) {
					option.__value = option_value_value;
					set_input_value(option, option.__value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(option);
				}
			}
		};
	}

	// (38:4) {#if Number(selecteditem) === item.key}
	function create_if_block_2$1(ctx) {
		let option;
		let t0_value = /*item*/ ctx[16].value + "";
		let t0;
		let t1;
		let option_value_value;

		return {
			c() {
				option = element("option");
				t0 = text(t0_value);
				t1 = space();
				option.__value = option_value_value = /*item*/ ctx[16].key;
				set_input_value(option, option.__value);
				option.selected = true;
				attr(option, "class", "svelte-1m7z9te");
			},
			m(target, anchor) {
				insert(target, option, anchor);
				append(option, t0);
				append(option, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 2 && t0_value !== (t0_value = /*item*/ ctx[16].value + "")) set_data(t0, t0_value);

				if (dirty & /*data*/ 2 && option_value_value !== (option_value_value = /*item*/ ctx[16].key)) {
					option.__value = option_value_value;
					set_input_value(option, option.__value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(option);
				}
			}
		};
	}

	// (36:2) {#each data as item (item.value)}
	function create_each_block$3(key_1, ctx) {
		let first;
		let if_block_anchor;

		function select_block_type(ctx, dirty) {
			if (/*selecteditem*/ ctx[0]) return create_if_block_1$3;
			return create_else_block_1$1;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			key: key_1,
			first: null,
			c() {
				first = empty();
				if_block.c();
				if_block_anchor = empty();
				this.first = first;
			},
			m(target, anchor) {
				insert(target, first, anchor);
				if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;

				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				}
			},
			d(detaching) {
				if (detaching) {
					detach(first);
					detach(if_block_anchor);
				}

				if_block.d(detaching);
			}
		};
	}

	// (57:1) {#if error}
	function create_if_block$5(ctx) {
		let div;
		let t;

		return {
			c() {
				div = element("div");
				t = text(/*errormessage*/ ctx[4]);
				attr(div, "class", "error svelte-1m7z9te");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t);
			},
			p(ctx, dirty) {
				if (dirty & /*errormessage*/ 16) set_data(t, /*errormessage*/ ctx[4]);
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	function create_fragment$9(ctx) {
		let link;
		let t0;
		let div;
		let select_1;
		let option;
		let each_blocks = [];
		let each_1_lookup = new Map();
		let t1;
		let label;
		let t2;
		let t3;
		let span;
		let t4;
		let mounted;
		let dispose;
		let each_value = ensure_array_like(/*data*/ ctx[1]);
		const get_key = ctx => /*item*/ ctx[16].value;

		for (let i = 0; i < each_value.length; i += 1) {
			let child_ctx = get_each_context$3(ctx, each_value, i);
			let key = get_key(child_ctx);
			each_1_lookup.set(key, each_blocks[i] = create_each_block$3(key, child_ctx));
		}

		let if_block = /*error*/ ctx[3] && create_if_block$5(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div = element("div");
				select_1 = element("select");
				option = element("option");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t1 = space();
				label = element("label");
				t2 = text(/*placeholder*/ ctx[2]);
				t3 = space();
				span = element("span");
				t4 = space();
				if (if_block) if_block.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(link, "class", "svelte-1m7z9te");
				option.__value = "";
				set_input_value(option, option.__value);
				option.disabled = true;
				option.selected = true;
				attr(option, "class", "svelte-1m7z9te");
				attr(select_1, "class", "ds-select-field gray rounded-4 hover-gray-300 svelte-1m7z9te");
				set_style(select_1, "width", "100%");
				select_1.required = true;
				if (/*selecteditem*/ ctx[0] === void 0) add_render_callback(() => /*select_1_change_handler*/ ctx[11].call(select_1));
				attr(label, "class", "ds-floating-label svelte-1m7z9te");
				attr(span, "class", "help svelte-1m7z9te");
				attr(div, "class", "select-container edit chevron border-bottom border-gray-600 width-full svelte-1m7z9te");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div, anchor);
				append(div, select_1);
				append(select_1, option);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(select_1, null);
					}
				}

				/*select_1_binding*/ ctx[10](select_1);
				select_option(select_1, /*selecteditem*/ ctx[0], true);
				append(div, t1);
				append(div, label);
				append(label, t2);
				append(div, t3);
				append(div, span);
				append(div, t4);
				if (if_block) if_block.m(div, null);

				if (!mounted) {
					dispose = [
						listen(select_1, "change", /*select_1_change_handler*/ ctx[11]),
						listen(select_1, "change", /*change_handler*/ ctx[12])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*data, Number, selecteditem*/ 3) {
					each_value = ensure_array_like(/*data*/ ctx[1]);
					each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, select_1, destroy_block, create_each_block$3, null, get_each_context$3);
				}

				if (dirty & /*selecteditem, data*/ 3) {
					select_option(select_1, /*selecteditem*/ ctx[0]);
				}

				if (dirty & /*placeholder*/ 4) set_data(t2, /*placeholder*/ ctx[2]);

				if (/*error*/ ctx[3]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$5(ctx);
						if_block.c();
						if_block.m(div, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div);
				}

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].d();
				}

				/*select_1_binding*/ ctx[10](null);
				if (if_block) if_block.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$9($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { data } = $$props;
		let { selecteditem } = $$props;
		let { controlid } = $$props;
		let { customstyles = [] } = $$props;
		let { placeholder = "" } = $$props;
		let { error } = $$props;
		let { errormessage } = $$props;
		let { width = 250 } = $$props;
		let select = {};

		function onSelect() {
			let value = select.options[select.selectedIndex].innerText;
			let key = select.value;
			svelteDispatch("itemselected", { key, value });
		}

		let customStyle = '';

		function select_1_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				select = $$value;
				(($$invalidate(5, select), $$invalidate(1, data)), $$invalidate(0, selecteditem));
			});
		}

		function select_1_change_handler() {
			selecteditem = select_value(this);
			$$invalidate(0, selecteditem);
			$$invalidate(1, data);
		}

		const change_handler = () => onSelect();

		$$self.$$set = $$props => {
			if ('data' in $$props) $$invalidate(1, data = $$props.data);
			if ('selecteditem' in $$props) $$invalidate(0, selecteditem = $$props.selecteditem);
			if ('controlid' in $$props) $$invalidate(7, controlid = $$props.controlid);
			if ('customstyles' in $$props) $$invalidate(8, customstyles = $$props.customstyles);
			if ('placeholder' in $$props) $$invalidate(2, placeholder = $$props.placeholder);
			if ('error' in $$props) $$invalidate(3, error = $$props.error);
			if ('errormessage' in $$props) $$invalidate(4, errormessage = $$props.errormessage);
			if ('width' in $$props) $$invalidate(9, width = $$props.width);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*select, data, selecteditem*/ 35) {
				if (select) {
					const index = data.findIndex(option => option.key === selecteditem);
					$$invalidate(5, select.selectedIndex = index !== -1 ? index : 0, select);
				}
			}

			if ($$self.$$.dirty & /*customstyles, customStyle*/ 8448) {
				customstyles.map(x => {
					customStyle += x.key + ':' + x.value + ';';
				});
			}
		};

		return [
			selecteditem,
			data,
			placeholder,
			error,
			errormessage,
			select,
			onSelect,
			controlid,
			customstyles,
			width,
			select_1_binding,
			select_1_change_handler,
			change_handler
		];
	}

	class Eas_select_newest_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$9,
				create_fragment$9,
				safe_not_equal,
				{
					data: 1,
					selecteditem: 0,
					controlid: 7,
					customstyles: 8,
					placeholder: 2,
					error: 3,
					errormessage: 4,
					width: 9
				},
				add_css$8
			);
		}

		get data() {
			return this.$$.ctx[1];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}

		get selecteditem() {
			return this.$$.ctx[0];
		}

		set selecteditem(selecteditem) {
			this.$$set({ selecteditem });
			flush();
		}

		get controlid() {
			return this.$$.ctx[7];
		}

		set controlid(controlid) {
			this.$$set({ controlid });
			flush();
		}

		get customstyles() {
			return this.$$.ctx[8];
		}

		set customstyles(customstyles) {
			this.$$set({ customstyles });
			flush();
		}

		get placeholder() {
			return this.$$.ctx[2];
		}

		set placeholder(placeholder) {
			this.$$set({ placeholder });
			flush();
		}

		get error() {
			return this.$$.ctx[3];
		}

		set error(error) {
			this.$$set({ error });
			flush();
		}

		get errormessage() {
			return this.$$.ctx[4];
		}

		set errormessage(errormessage) {
			this.$$set({ errormessage });
			flush();
		}

		get width() {
			return this.$$.ctx[9];
		}

		set width(width) {
			this.$$set({ width });
			flush();
		}
	}

	customElements.define("eas-select-newest-swc", create_custom_element(Eas_select_newest_component, {"data":{},"selecteditem":{},"controlid":{},"customstyles":{},"placeholder":{},"error":{},"errormessage":{},"width":{}}, [], [], true));

	/* src\lib\web-components\select-multi\eas-select-multi.component.svelte generated by Svelte v4.2.19 */

	function add_css$7(target) {
		append_styles(target, "svelte-xygi3u", ".multi-select-container.svelte-xygi3u.svelte-xygi3u{width:100%;display:flex;flex-direction:column;padding:10px 0 10px 20px;margin-bottom:10px;border-radius:4px 4px 0 0;box-sizing:border-box;background:var(--background, #ebebeb);border-bottom-color:0 0 0 0.43\r\n    }select.svelte-xygi3u option.svelte-xygi3u{background-color:white;font-size:var(--multi-select-font-size, 0.875rem)}Select.svelte-xygi3u option[disabled].svelte-xygi3u{font-size:16px}");
	}

	function get_each_context$2(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[12] = list[i];
		return child_ctx;
	}

	// (41:8) {:else}
	function create_else_block$1(ctx) {
		let option;

		return {
			c() {
				option = element("option");
				option.textContent = "Select";
				attr(option, "style", "font-size=16px");
				option.__value = "";
				set_input_value(option, option.__value);
				option.disabled = true;
				option.selected = true;
				attr(option, "class", "svelte-xygi3u");
			},
			m(target, anchor) {
				insert(target, option, anchor);
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(option);
				}
			}
		};
	}

	// (39:8) {#if selecteditem}
	function create_if_block_1$2(ctx) {
		let option;
		let t;

		return {
			c() {
				option = element("option");
				t = text(/*placeholder*/ ctx[0]);
				attr(option, "style", "font-size=large");
				option.__value = "";
				set_input_value(option, option.__value);
				option.disabled = true;
				attr(option, "class", "svelte-xygi3u");
			},
			m(target, anchor) {
				insert(target, option, anchor);
				append(option, t);
			},
			p(ctx, dirty) {
				if (dirty & /*placeholder*/ 1) set_data(t, /*placeholder*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) {
					detach(option);
				}
			}
		};
	}

	// (44:8) {#if data}
	function create_if_block$4(ctx) {
		let each_1_anchor;
		let each_value = ensure_array_like(/*data*/ ctx[2]);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
		}

		return {
			c() {
				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty();
			},
			m(target, anchor) {
				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 4) {
					each_value = ensure_array_like(/*data*/ ctx[2]);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$2(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$2(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(each_1_anchor);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (45:12) {#each data as item}
	function create_each_block$2(ctx) {
		let option;
		let t0_value = /*item*/ ctx[12].value + "";
		let t0;
		let t1;
		let option_value_value;

		return {
			c() {
				option = element("option");
				t0 = text(t0_value);
				t1 = space();
				option.__value = option_value_value = /*item*/ ctx[12].key;
				set_input_value(option, option.__value);
				attr(option, "class", "svelte-xygi3u");
			},
			m(target, anchor) {
				insert(target, option, anchor);
				append(option, t0);
				append(option, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 4 && t0_value !== (t0_value = /*item*/ ctx[12].value + "")) set_data(t0, t0_value);

				if (dirty & /*data*/ 4 && option_value_value !== (option_value_value = /*item*/ ctx[12].key)) {
					option.__value = option_value_value;
					set_input_value(option, option.__value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(option);
				}
			}
		};
	}

	function create_fragment$8(ctx) {
		let link;
		let t0;
		let div1;
		let div0;
		let t1;
		let t2;
		let select;
		let if_block0_anchor;
		let mounted;
		let dispose;

		function select_block_type(ctx, dirty) {
			if (/*selecteditem*/ ctx[1]) return create_if_block_1$2;
			return create_else_block$1;
		}

		let current_block_type = select_block_type(ctx);
		let if_block0 = current_block_type(ctx);
		let if_block1 = /*data*/ ctx[2] && create_if_block$4(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div1 = element("div");
				div0 = element("div");
				t1 = text(/*placeholder*/ ctx[0]);
				t2 = space();
				select = element("select");
				if_block0.c();
				if_block0_anchor = empty();
				if (if_block1) if_block1.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				set_style(div0, "width", "100%");
				set_style(select, "width", "100%");
				set_style(select, "border", "none");
				set_style(select, "outline", "none");
				select.multiple = true;
				attr(select, "class", "svelte-xygi3u");
				if (/*selectedOptions*/ ctx[3] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[8].call(select));
				attr(div1, "class", "multi-select-container svelte-xygi3u");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div1, anchor);
				append(div1, div0);
				append(div0, t1);
				append(div1, t2);
				append(div1, select);
				if_block0.m(select, null);
				append(select, if_block0_anchor);
				if (if_block1) if_block1.m(select, null);
				/*select_binding*/ ctx[7](select);
				select_options(select, /*selectedOptions*/ ctx[3]);

				if (!mounted) {
					dispose = [
						listen(select, "change", /*select_change_handler*/ ctx[8]),
						listen(select, "change", /*change_handler*/ ctx[9])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*placeholder*/ 1) set_data(t1, /*placeholder*/ ctx[0]);

				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0.d(1);
					if_block0 = current_block_type(ctx);

					if (if_block0) {
						if_block0.c();
						if_block0.m(select, if_block0_anchor);
					}
				}

				if (/*data*/ ctx[2]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block$4(ctx);
						if_block1.c();
						if_block1.m(select, null);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (dirty & /*selectedOptions, data*/ 12) {
					select_options(select, /*selectedOptions*/ ctx[3]);
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div1);
				}

				if_block0.d();
				if (if_block1) if_block1.d();
				/*select_binding*/ ctx[7](null);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$8($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let selectedOptions = [];
		let { placeholder = "" } = $$props;
		let { selecteditem } = $$props;
		let { background = "white" } = $$props;
		let { data } = $$props;
		let selectedItems = [];
		let multiselect;

		function onSelect() {
			for (let i = 0; i < multiselect.options.length; i++) {
				if (multiselect.options[i].selected) {
					if (!selectedItems.some(x => x.key === multiselect.options[i].value)) {
						selectedItems.push({
							key: multiselect.options[i].value,
							value: multiselect.options[i].innerText
						});
					} else {
						selectedItems.splice(i, 1);
					}
				}
			}

			for (let j = 0; j < selectedItems.length; j++) {
				for (let i = 0; i < multiselect.options.length; i++) {
					if (multiselect.options[i].value === selectedItems[j].key) {
						multiselect.options[i].setAttribute('style', 'background-color: #0166d5; color: black;');
					}
				}
			}
			svelteDispatch("itemsselected", selectedItems);
		}

		function select_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				multiselect = $$value;
				$$invalidate(4, multiselect);
			});
		}

		function select_change_handler() {
			selectedOptions = select_multiple_value(this);
			$$invalidate(3, selectedOptions);
			$$invalidate(2, data);
		}

		const change_handler = () => onSelect();

		$$self.$$set = $$props => {
			if ('placeholder' in $$props) $$invalidate(0, placeholder = $$props.placeholder);
			if ('selecteditem' in $$props) $$invalidate(1, selecteditem = $$props.selecteditem);
			if ('background' in $$props) $$invalidate(6, background = $$props.background);
			if ('data' in $$props) $$invalidate(2, data = $$props.data);
		};

		return [
			placeholder,
			selecteditem,
			data,
			selectedOptions,
			multiselect,
			onSelect,
			background,
			select_binding,
			select_change_handler,
			change_handler
		];
	}

	class Eas_select_multi_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$8,
				create_fragment$8,
				safe_not_equal,
				{
					placeholder: 0,
					selecteditem: 1,
					background: 6,
					data: 2
				},
				add_css$7
			);
		}

		get placeholder() {
			return this.$$.ctx[0];
		}

		set placeholder(placeholder) {
			this.$$set({ placeholder });
			flush();
		}

		get selecteditem() {
			return this.$$.ctx[1];
		}

		set selecteditem(selecteditem) {
			this.$$set({ selecteditem });
			flush();
		}

		get background() {
			return this.$$.ctx[6];
		}

		set background(background) {
			this.$$set({ background });
			flush();
		}

		get data() {
			return this.$$.ctx[2];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}
	}

	customElements.define("eas-select-multi-swc", create_custom_element(Eas_select_multi_component, {"placeholder":{},"selecteditem":{},"background":{},"data":{}}, [], [], true));

	/* src\lib\web-components\title\eas-title.component.svelte generated by Svelte v4.2.19 */

	function add_css$6(target) {
		append_styles(target, "svelte-1u9ukw6", ".title.svelte-1u9ukw6{width:100%;max-width:100%;padding-bottom:5px;margin:0 20px}");
	}

	function create_fragment$7(ctx) {
		let link;
		let t0;
		let div;
		let b;
		let t1;

		return {
			c() {
				link = element("link");
				t0 = space();
				div = element("div");
				b = element("b");
				t1 = text(/*title*/ ctx[0]);
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(div, "class", "title svelte-1u9ukw6");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div, anchor);
				append(div, b);
				append(b, t1);
			},
			p(ctx, [dirty]) {
				if (dirty & /*title*/ 1) set_data(t1, /*title*/ ctx[0]);
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div);
				}
			}
		};
	}

	function instance$7($$self, $$props, $$invalidate) {
		createEventDispatcher();
		let { title } = $$props;

		$$self.$$set = $$props => {
			if ('title' in $$props) $$invalidate(0, title = $$props.title);
		};

		return [title];
	}

	class Eas_title_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$7, create_fragment$7, safe_not_equal, { title: 0 }, add_css$6);
		}

		get title() {
			return this.$$.ctx[0];
		}

		set title(title) {
			this.$$set({ title });
			flush();
		}
	}

	customElements.define("eas-title-swc", create_custom_element(Eas_title_component, {"title":{}}, [], [], true));

	/* src\lib\web-components\button\eas-main-button.component.svelte generated by Svelte v4.2.19 */

	function add_css$5(target) {
		append_styles(target, "svelte-1455rqq", ".btn.svelte-1455rqq{align-items:center;justify-content:center;width:max-content;padding:0 20px;border-radius:5px;font-size:16px;cursor:pointer;transition:all 0.2s ease-in-out;margin:0px 10px;color:white}.btn.svelte-1455rqq:hover{background:var(--blue-800, red) !important;border:2px solid  var(--blue-800, red)}.disabled.svelte-1455rqq{position:relative;pointer-events:none;background:var(--gray-400);border-color:var(--gray-500);z-index:0}.btn-txt.svelte-1455rqq{transition:all 0.2s ease-in-out;font-weight:var(--button-text-font-weight, bold) }");
	}

	// (22:0) {#if type === 'button'}
	function create_if_block$3(ctx) {
		let button;
		let div;
		let t;
		let button_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				t = text(/*text*/ ctx[0]);
				attr(div, "class", "btn-txt svelte-1455rqq");
				set_style(button, "background", /*defaultbackground*/ ctx[3]);
				set_style(button, "height", /*defaultbuttonheight*/ ctx[4]);
				attr(button, "class", button_class_value = "btn " + (/*uiblock*/ ctx[2] ? 'disabled' : '') + " svelte-1455rqq");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);
				append(div, t);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler*/ ctx[9]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*text*/ 1) set_data(t, /*text*/ ctx[0]);

				if (dirty & /*uiblock*/ 4 && button_class_value !== (button_class_value = "btn " + (/*uiblock*/ ctx[2] ? 'disabled' : '') + " svelte-1455rqq")) {
					attr(button, "class", button_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$6(ctx) {
		let link;
		let t;
		let if_block_anchor;
		let if_block = /*type*/ ctx[1] === 'button' && create_if_block$3(ctx);

		return {
			c() {
				link = element("link");
				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, [dirty]) {
				if (/*type*/ ctx[1] === 'button') {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$3(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t);
					detach(if_block_anchor);
				}

				if (if_block) if_block.d(detaching);
			}
		};
	}

	function instance$6($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { text } = $$props;
		let { type } = $$props;
		let { uiblock = false } = $$props;
		let { background } = $$props;
		let { buttonheight } = $$props;
		let { utilitystyle } = $$props;
		const defaultbackground = background || 'transparent';
		const defaultbuttonheight = buttonheight || '45px';

		onMount(async () => {
			
		});

		function onButtonClick(e) {
			svelteDispatch('buttonClick', e);
		}

		const click_handler = e => onButtonClick(e);

		$$self.$$set = $$props => {
			if ('text' in $$props) $$invalidate(0, text = $$props.text);
			if ('type' in $$props) $$invalidate(1, type = $$props.type);
			if ('uiblock' in $$props) $$invalidate(2, uiblock = $$props.uiblock);
			if ('background' in $$props) $$invalidate(6, background = $$props.background);
			if ('buttonheight' in $$props) $$invalidate(7, buttonheight = $$props.buttonheight);
			if ('utilitystyle' in $$props) $$invalidate(8, utilitystyle = $$props.utilitystyle);
		};

		return [
			text,
			type,
			uiblock,
			defaultbackground,
			defaultbuttonheight,
			onButtonClick,
			background,
			buttonheight,
			utilitystyle,
			click_handler
		];
	}

	class Eas_main_button_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$6,
				create_fragment$6,
				safe_not_equal,
				{
					text: 0,
					type: 1,
					uiblock: 2,
					background: 6,
					buttonheight: 7,
					utilitystyle: 8
				},
				add_css$5
			);
		}

		get text() {
			return this.$$.ctx[0];
		}

		set text(text) {
			this.$$set({ text });
			flush();
		}

		get type() {
			return this.$$.ctx[1];
		}

		set type(type) {
			this.$$set({ type });
			flush();
		}

		get uiblock() {
			return this.$$.ctx[2];
		}

		set uiblock(uiblock) {
			this.$$set({ uiblock });
			flush();
		}

		get background() {
			return this.$$.ctx[6];
		}

		set background(background) {
			this.$$set({ background });
			flush();
		}

		get buttonheight() {
			return this.$$.ctx[7];
		}

		set buttonheight(buttonheight) {
			this.$$set({ buttonheight });
			flush();
		}

		get utilitystyle() {
			return this.$$.ctx[8];
		}

		set utilitystyle(utilitystyle) {
			this.$$set({ utilitystyle });
			flush();
		}
	}

	customElements.define("eas-main-button-swc", create_custom_element(Eas_main_button_component, {"text":{},"type":{},"uiblock":{"type":"Boolean"},"background":{},"buttonheight":{},"utilitystyle":{}}, [], [], true));

	/* src\lib\web-components\table\eas-table-control-new.component.svelte generated by Svelte v4.2.19 */

	function add_css$4(target) {
		append_styles(target, "svelte-124ugzf", "table.svelte-124ugzf{border-width:var(--table-width, 1px);border-color:var(--table-border-color, #D8D8D8);border-style:var(--table-border-style, solid);border-collapse:var(--table-border-collapse, collapse);text-align:var(--table-content-alignment, left);width:100%}thead.svelte-124ugzf{background:var(--table-header-background, #F2F2F2);border-bottom:1px solid #D8D8D8}th.svelte-124ugzf:first-child{border-left:none}th.svelte-124ugzf{font-size:var(--table-header-font-size, 15px);font-weight:var(--table-header-font-weight, bold);color:var(--table-header-font-color, #000000);text-align:var(--table-header-text-align, left);padding:var(--table-header-padding, 8px);border-width:var(--table-header-width, 1px);border-color:var(--table-header-border-color, #D8D8D8);border-style:var(--table-header-border-style, solid)}tbody.svelte-124ugzf{font-size:var(--table-header-font-size, 15px);color:var(--table-header-font-color, #000000);text-align:var(--table-header-text-align, left);padding:var(--table-header-padding, 8px);border-width:var(--table-header-width, 1px);border-color:var(--table-header-border-color, #D8D8D8);border-style:var(--table-header-border-style, solid)}td.svelte-124ugzf{padding:8px;border-bottom:1px solid #D8D8D8}a.svelte-124ugzf{text-decoration:none;color:var(--blue-800, #3d7aa9);font-weight:bold}tr.svelte-124ugzf:nth-child(even){background-color:#f2f2f2}");
	}

	function get_each_context$1(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[11] = list[i];
		return child_ctx;
	}

	function get_each_context_1(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[14] = list[i];
		return child_ctx;
	}

	function get_each_context_2(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[17] = list[i];
		return child_ctx;
	}

	// (40:16) {#each data.header as item}
	function create_each_block_2(ctx) {
		let th;
		let t0_value = /*item*/ ctx[17].name + "";
		let t0;
		let t1;

		return {
			c() {
				th = element("th");
				t0 = text(t0_value);
				t1 = space();
				attr(th, "class", "svelte-124ugzf");
			},
			m(target, anchor) {
				insert(target, th, anchor);
				append(th, t0);
				append(th, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 1 && t0_value !== (t0_value = /*item*/ ctx[17].name + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) {
					detach(th);
				}
			}
		};
	}

	// (59:59) 
	function create_if_block_4(ctx) {
		let td;
		let button;
		let t_value = /*column*/ ctx[14].displayValue + "";
		let t;
		let mounted;
		let dispose;

		function click_handler_3(...args) {
			return /*click_handler_3*/ ctx[8](/*column*/ ctx[14], ...args);
		}

		return {
			c() {
				td = element("td");
				button = element("button");
				t = text(t_value);
				attr(td, "class", "svelte-124ugzf");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, button);
				append(button, t);

				if (!mounted) {
					dispose = [
						listen(button, "keyup", keyup_handler_3),
						listen(button, "click", click_handler_3)
					];

					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*data*/ 1 && t_value !== (t_value = /*column*/ ctx[14].displayValue + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (57:61) 
	function create_if_block_3(ctx) {
		let td;
		let a;
		let i;
		let i_class_value;
		let a_href_value;
		let a_style_value;
		let mounted;
		let dispose;

		function click_handler_2(...args) {
			return /*click_handler_2*/ ctx[7](/*column*/ ctx[14], /*row*/ ctx[11], ...args);
		}

		return {
			c() {
				td = element("td");
				a = element("a");
				i = element("i");
				attr(i, "class", i_class_value = /*column*/ ctx[14].value.iconClass);
				attr(a, "href", a_href_value = /*column*/ ctx[14].value.href);
				attr(a, "style", a_style_value = /*column*/ ctx[14].value.linkStyle);
				attr(a, "class", "svelte-124ugzf");
				attr(td, "class", "svelte-124ugzf");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, a);
				append(a, i);

				if (!mounted) {
					dispose = [listen(a, "keyup", keyup_handler_2), listen(a, "click", click_handler_2)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;

				if (dirty & /*data*/ 1 && i_class_value !== (i_class_value = /*column*/ ctx[14].value.iconClass)) {
					attr(i, "class", i_class_value);
				}

				if (dirty & /*data*/ 1 && a_href_value !== (a_href_value = /*column*/ ctx[14].value.href)) {
					attr(a, "href", a_href_value);
				}

				if (dirty & /*data*/ 1 && a_style_value !== (a_style_value = /*column*/ ctx[14].value.linkStyle)) {
					attr(a, "style", a_style_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (55:63) 
	function create_if_block_2(ctx) {
		let td;
		let t0_value = /*column*/ ctx[14].value.beforeLinkText + "";
		let t0;
		let a;
		let t1_value = /*column*/ ctx[14].displayValue + "";
		let t1;
		let a_href_value;
		let a_style_value;
		let t2_value = /*column*/ ctx[14].value.afterLinkText + "";
		let t2;
		let mounted;
		let dispose;

		function click_handler_1(...args) {
			return /*click_handler_1*/ ctx[6](/*column*/ ctx[14], ...args);
		}

		return {
			c() {
				td = element("td");
				t0 = text(t0_value);
				a = element("a");
				t1 = text(t1_value);
				t2 = text(t2_value);
				attr(a, "href", a_href_value = /*column*/ ctx[14].value.href);
				attr(a, "style", a_style_value = /*column*/ ctx[14].value.style);
				attr(a, "class", "svelte-124ugzf");
				attr(td, "class", "svelte-124ugzf");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, t0);
				append(td, a);
				append(a, t1);
				append(td, t2);

				if (!mounted) {
					dispose = [listen(a, "keyup", keyup_handler_1), listen(a, "click", click_handler_1)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*data*/ 1 && t0_value !== (t0_value = /*column*/ ctx[14].value.beforeLinkText + "")) set_data(t0, t0_value);
				if (dirty & /*data*/ 1 && t1_value !== (t1_value = /*column*/ ctx[14].displayValue + "")) set_data(t1, t1_value);

				if (dirty & /*data*/ 1 && a_href_value !== (a_href_value = /*column*/ ctx[14].value.href)) {
					attr(a, "href", a_href_value);
				}

				if (dirty & /*data*/ 1 && a_style_value !== (a_style_value = /*column*/ ctx[14].value.style)) {
					attr(a, "style", a_style_value);
				}

				if (dirty & /*data*/ 1 && t2_value !== (t2_value = /*column*/ ctx[14].value.afterLinkText + "")) set_data(t2, t2_value);
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (53:57) 
	function create_if_block_1$1(ctx) {
		let td;
		let a;
		let t_value = /*column*/ ctx[14].displayValue + "";
		let t;
		let a_href_value;
		let mounted;
		let dispose;

		function click_handler(...args) {
			return /*click_handler*/ ctx[5](/*column*/ ctx[14], ...args);
		}

		return {
			c() {
				td = element("td");
				a = element("a");
				t = text(t_value);
				attr(a, "href", a_href_value = /*column*/ ctx[14].value.href);
				attr(a, "class", "svelte-124ugzf");
				attr(td, "class", "svelte-124ugzf");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, a);
				append(a, t);

				if (!mounted) {
					dispose = [listen(a, "keyup", keyup_handler), listen(a, "click", click_handler)];
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*data*/ 1 && t_value !== (t_value = /*column*/ ctx[14].displayValue + "")) set_data(t, t_value);

				if (dirty & /*data*/ 1 && a_href_value !== (a_href_value = /*column*/ ctx[14].value.href)) {
					attr(a, "href", a_href_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (51:24) {#if column.type === 'text'}
	function create_if_block$2(ctx) {
		let td;
		let t_value = /*column*/ ctx[14].value + "";
		let t;

		return {
			c() {
				td = element("td");
				t = text(t_value);
				attr(td, "class", "svelte-124ugzf");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, t);
			},
			p(ctx, dirty) {
				if (dirty & /*data*/ 1 && t_value !== (t_value = /*column*/ ctx[14].value + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}
			}
		};
	}

	// (50:20) {#each row.columns as column}
	function create_each_block_1(ctx) {
		let if_block_anchor;

		function select_block_type(ctx, dirty) {
			if (/*column*/ ctx[14].type === 'text') return create_if_block$2;
			if (/*column*/ ctx[14].type === 'link') return create_if_block_1$1;
			if (/*column*/ ctx[14].type === 'inlineLink') return create_if_block_2;
			if (/*column*/ ctx[14].type === 'linkicon') return create_if_block_3;
			if (/*column*/ ctx[14].type === 'button') return create_if_block_4;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type && current_block_type(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if (if_block) if_block.d(1);
					if_block = current_block_type && current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				}
			},
			d(detaching) {
				if (detaching) {
					detach(if_block_anchor);
				}

				if (if_block) {
					if_block.d(detaching);
				}
			}
		};
	}

	// (48:12) {#each data.rows as row}
	function create_each_block$1(ctx) {
		let tr;
		let t;
		let each_value_1 = ensure_array_like(/*row*/ ctx[11].columns);
		let each_blocks = [];

		for (let i = 0; i < each_value_1.length; i += 1) {
			each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
		}

		return {
			c() {
				tr = element("tr");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t = space();
				attr(tr, "class", "svelte-124ugzf");
			},
			m(target, anchor) {
				insert(target, tr, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(tr, null);
					}
				}

				append(tr, t);
			},
			p(ctx, dirty) {
				if (dirty & /*data, handleLinkClick, handleIconLinkClick, displayRows, handleButtonClick*/ 31) {
					each_value_1 = ensure_array_like(/*row*/ ctx[11].columns);
					let i;

					for (i = 0; i < each_value_1.length; i += 1) {
						const child_ctx = get_each_context_1(ctx, each_value_1, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block_1(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(tr, t);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value_1.length;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(tr);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	function create_fragment$5(ctx) {
		let link;
		let t0;
		let div;
		let table;
		let thead;
		let tr;
		let t1;
		let tbody;
		let each_value_2 = ensure_array_like(/*data*/ ctx[0].header);
		let each_blocks_1 = [];

		for (let i = 0; i < each_value_2.length; i += 1) {
			each_blocks_1[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
		}

		let each_value = ensure_array_like(/*data*/ ctx[0].rows);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
		}

		return {
			c() {
				link = element("link");
				t0 = space();
				div = element("div");
				table = element("table");
				thead = element("thead");
				tr = element("tr");

				for (let i = 0; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].c();
				}

				t1 = space();
				tbody = element("tbody");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(tr, "class", "svelte-124ugzf");
				attr(thead, "class", "svelte-124ugzf");
				attr(tbody, "class", "svelte-124ugzf");
				attr(table, "class", "svelte-124ugzf");
				attr(div, "class", "table-container");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div, anchor);
				append(div, table);
				append(table, thead);
				append(thead, tr);

				for (let i = 0; i < each_blocks_1.length; i += 1) {
					if (each_blocks_1[i]) {
						each_blocks_1[i].m(tr, null);
					}
				}

				append(table, t1);
				append(table, tbody);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(tbody, null);
					}
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*data*/ 1) {
					each_value_2 = ensure_array_like(/*data*/ ctx[0].header);
					let i;

					for (i = 0; i < each_value_2.length; i += 1) {
						const child_ctx = get_each_context_2(ctx, each_value_2, i);

						if (each_blocks_1[i]) {
							each_blocks_1[i].p(child_ctx, dirty);
						} else {
							each_blocks_1[i] = create_each_block_2(child_ctx);
							each_blocks_1[i].c();
							each_blocks_1[i].m(tr, null);
						}
					}

					for (; i < each_blocks_1.length; i += 1) {
						each_blocks_1[i].d(1);
					}

					each_blocks_1.length = each_value_2.length;
				}

				if (dirty & /*data, handleLinkClick, handleIconLinkClick, displayRows, handleButtonClick*/ 31) {
					each_value = ensure_array_like(/*data*/ ctx[0].rows);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$1(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$1(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(tbody, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div);
				}

				destroy_each(each_blocks_1, detaching);
				destroy_each(each_blocks, detaching);
			}
		};
	}

	const keyup_handler = e => {
		
	};

	const keyup_handler_1 = e => {
		
	};

	const keyup_handler_2 = e => {
		
	};

	const keyup_handler_3 = e => {
		
	};

	function instance$5($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { data } = $$props;
		let displayRows = [];

		function handleLinkClick(e, data) {
			let detail = { rowData: data };
			svelteDispatch("rowlinkclicked", detail);
			return false;
		}

		function handleButtonClick(e, data) {
			let detail = { rowData: data };
			svelteDispatch("rowbuttonclicked", detail);
		}

		function handleIconLinkClick(e, data, showComment, displayCommentRowindex, columnIndex) {
			if (showComment) {
				return false;
			} else {
				let detail = { rowData: data };
				svelteDispatch("rowbuttonclicked", detail);
			}
		}

		const click_handler = (column, e) => handleLinkClick(e, column.value.click);
		const click_handler_1 = (column, e) => handleLinkClick(e, column.value.click);
		const click_handler_2 = (column, row, e) => handleIconLinkClick(e, column.value.click, column.value.showComment, displayRows.indexOf(row), row.columns.indexOf(column));
		const click_handler_3 = (column, e) => handleButtonClick(e, column.value.click);

		$$self.$$set = $$props => {
			if ('data' in $$props) $$invalidate(0, data = $$props.data);
		};

		return [
			data,
			displayRows,
			handleLinkClick,
			handleButtonClick,
			handleIconLinkClick,
			click_handler,
			click_handler_1,
			click_handler_2,
			click_handler_3
		];
	}

	class Eas_table_control_new_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$5, create_fragment$5, safe_not_equal, { data: 0 }, add_css$4);
		}

		get data() {
			return this.$$.ctx[0];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}
	}

	customElements.define("eas-table-new-swc", create_custom_element(Eas_table_control_new_component, {"data":{}}, [], [], true));

	/* src\lib\web-components\paginator\eas-paginator.component.svelte generated by Svelte v4.2.19 */

	function add_css$3(target) {
		append_styles(target, "svelte-wy2cjk", ".pagination-container.svelte-wy2cjk.svelte-wy2cjk{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif}.ds-text-field__input.svelte-wy2cjk.svelte-wy2cjk{align-self:flex-end;width:inherit;height:100%;padding:20px 20px 0px;font-size:1rem;text-decoration:inherit;text-transform:inherit;border-radius:4px 4px 0 0;border:none;border-bottom:1px solid;box-sizing:border-box;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);background:none;appearance:none}.ds-text-field.svelte-wy2cjk:not(.ds-text-field--disabled) .ds-text-field__input.svelte-wy2cjk{border-bottom-color:rgba(0, 0, 0, 0.42)}.ds-text-field__input.svelte-wy2cjk.svelte-wy2cjk:focus{outline:none;background:#dcdcdc}.ds-text-field.svelte-wy2cjk:not(.ds-text-field--disabled) .ds-text-field__input.svelte-wy2cjk:focus{border-bottom-color:rgba(0, 0, 0, 0.87)}.ds-text-field.svelte-wy2cjk.svelte-wy2cjk{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif;display:inline-flex;position:relative;height:56px;width:100%;border-radius:4px 4px 0 0;margin-bottom:5px;box-sizing:border-box;overflow:hidden;background:#f2f2f2;overflow:visible}.ds-text-field.svelte-wy2cjk:not(.ds-text-field--disabled) .ds-text-field__input.svelte-wy2cjk{border-bottom-color:rgba(0, 0, 0, 0.42)}.ds-text-field.svelte-wy2cjk.svelte-wy2cjk{z-index:0}.svelte-wy2cjk.svelte-wy2cjk,.svelte-wy2cjk.svelte-wy2cjk::after,.svelte-wy2cjk.svelte-wy2cjk::before{box-sizing:border-box;padding:0px;margin:0px}div.svelte-wy2cjk.svelte-wy2cjk{background:transparent;transition:all 0.2s ease-in-out 0s}.width-full.svelte-wy2cjk.svelte-wy2cjk{width:100%}.mlr-5.svelte-wy2cjk.svelte-wy2cjk{margin-left:5px;margin-right:5px}.flex.svelte-wy2cjk.svelte-wy2cjk{display:flex}button.disabled.svelte-wy2cjk.svelte-wy2cjk{position:relative;pointer-events:none;background:#d9d9d9 !important;border-color:#bfbfbf !important;z-index:0}button.disabled.svelte-wy2cjk>.btn-txt.svelte-wy2cjk{color:#a1a1a1 !important}button.svelte-wy2cjk.svelte-wy2cjk{position:relative;display:flex;align-items:center;justify-content:center;height:44px;width:max-content;padding:0 20px;border:0;font-size:16px;cursor:pointer;background:transparent;transition:all 0.2s ease-in-out !important}button.svelte-wy2cjk .btn-txt.svelte-wy2cjk{display:flex;justify-content:center;min-width:max-content;font-size:16px}nav.svelte-wy2cjk.svelte-wy2cjk{flex-grow:1}ul.button-container.svelte-wy2cjk.svelte-wy2cjk{list-style-type:none;padding-left:0;margin-left:0 !important;margin-bottom:10px;margin-top:0;display:flex}ul.button-container.svelte-wy2cjk li.svelte-wy2cjk{padding:4px}ul.button-container.svelte-wy2cjk li.svelte-wy2cjk:nth-of-type(2){margin-left:auto;text-align:center}.black.svelte-wy2cjk.svelte-wy2cjk{background:rgb(0, 0, 0) !important}.font-white.svelte-wy2cjk.svelte-wy2cjk{color:white !important}.hover-blue-800.svelte-wy2cjk.svelte-wy2cjk:hover{background:#3d7aa9 !important}.disabled.svelte-wy2cjk .font-white.svelte-wy2cjk{color:#a1a1a1 !important}.rounded-4.svelte-wy2cjk.svelte-wy2cjk{border-radius:4px !important}ul.workflow li.svelte-wy2cjk button.svelte-wy2cjk{display:inline-block;margin-right:10px}.ds-text-field.svelte-wy2cjk.svelte-wy2cjk{width:70px;background:#f2f2f2;padding:5px 5px 0 0;height:32px}button.svelte-wy2cjk.svelte-wy2cjk{height:32px}.text.svelte-wy2cjk.svelte-wy2cjk{top:8px}.relative.svelte-wy2cjk.svelte-wy2cjk{position:relative}.disabled.svelte-wy2cjk.svelte-wy2cjk{position:relative;pointer-events:none;background:#d9d9d9 !important;border-color:#bfbfbf !important;z-index:0}button.disabled.svelte-wy2cjk .btn-txt.svelte-wy2cjk{color:#8c8c8c !important}.ds-text-field__input.svelte-wy2cjk.svelte-wy2cjk{padding:0px 20px}@media screen and (max-width: 425px){.relative.mobile.svelte-wy2cjk.svelte-wy2cjk{position:unset;text-align:left}.ds-text-field.svelte-wy2cjk.svelte-wy2cjk,ul.button-container.svelte-wy2cjk.svelte-wy2cjk,.flex.mobile.svelte-wy2cjk.svelte-wy2cjk{display:block}.mb-mobile.svelte-wy2cjk.svelte-wy2cjk{margin-bottom:10px}.mt-mobile.svelte-wy2cjk.svelte-wy2cjk{margin-top:10px}}");
	}

	// (46:6) {:else}
	function create_else_block_1(ctx) {
		let button;
		let div;
		let t0;
		let t1;
		let t2;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				t0 = text("Previous ");
				t1 = text(/*previouspagesize*/ ctx[0]);
				t2 = text(" Results");
				attr(div, "class", "btn-txt font-white svelte-wy2cjk");
				attr(button, "title", "Previous Set of Results");
				attr(button, "class", "rounded-4 hover-blue-800 black svelte-wy2cjk");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);
				append(div, t0);
				append(div, t1);
				append(div, t2);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler_2*/ ctx[10]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*previouspagesize*/ 1) set_data(t1, /*previouspagesize*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (42:6) {#if gotopage === 1}
	function create_if_block_1(ctx) {
		let button;
		let div;
		let t0;
		let t1;
		let t2;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				t0 = text("Previous ");
				t1 = text(/*previouspagesize*/ ctx[0]);
				t2 = text(" Results");
				attr(div, "class", "btn-txt font-white svelte-wy2cjk");
				attr(button, "title", "Previous Set of Results");
				attr(button, "class", "rounded-4 hover-blue-800 black disabled svelte-wy2cjk");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);
				append(div, t0);
				append(div, t1);
				append(div, t2);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler_1*/ ctx[9]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*previouspagesize*/ 1) set_data(t1, /*previouspagesize*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (73:6) {:else}
	function create_else_block(ctx) {
		let button;
		let div;
		let t0;
		let t1;
		let t2;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				t0 = text("Next ");
				t1 = text(/*nextpagesize*/ ctx[1]);
				t2 = text(" Results");
				attr(div, "class", "btn-txt font-white svelte-wy2cjk");
				attr(button, "title", "Next Set of Results");
				attr(button, "class", "rounded-4 hover-blue-800 black svelte-wy2cjk");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);
				append(div, t0);
				append(div, t1);
				append(div, t2);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler_4*/ ctx[14]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*nextpagesize*/ 2) set_data(t1, /*nextpagesize*/ ctx[1]);
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (69:6) {#if gotopage === totalpages}
	function create_if_block$1(ctx) {
		let button;
		let div;
		let t0;
		let t1;
		let t2;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				div = element("div");
				t0 = text("Next ");
				t1 = text(/*nextpagesize*/ ctx[1]);
				t2 = text(" Results");
				attr(div, "class", "btn-txt font-white svelte-wy2cjk");
				attr(button, "title", "Next Set of Results");
				attr(button, "class", "rounded-4 hover-blue-800 black disabled svelte-wy2cjk");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);
				append(div, t0);
				append(div, t1);
				append(div, t2);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler_3*/ ctx[13]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*nextpagesize*/ 2) set_data(t1, /*nextpagesize*/ ctx[1]);
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$4(ctx) {
		let link;
		let t0;
		let div8;
		let nav;
		let ul;
		let li0;
		let button;
		let div0;
		let t2;
		let li1;
		let div7;
		let div1;
		let t3;
		let div2;
		let t5;
		let div4;
		let input;
		let t6;
		let div3;
		let t7;
		let span0;
		let t8;
		let span1;
		let t9;
		let div5;
		let t10;
		let t11;
		let t12;
		let div6;
		let mounted;
		let dispose;

		function select_block_type(ctx, dirty) {
			if (/*gotopage*/ ctx[3] === 1) return create_if_block_1;
			return create_else_block_1;
		}

		let current_block_type = select_block_type(ctx);
		let if_block0 = current_block_type(ctx);

		function select_block_type_1(ctx, dirty) {
			if (/*gotopage*/ ctx[3] === /*totalpages*/ ctx[2]) return create_if_block$1;
			return create_else_block;
		}

		let current_block_type_1 = select_block_type_1(ctx);
		let if_block1 = current_block_type_1(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div8 = element("div");
				nav = element("nav");
				ul = element("ul");
				li0 = element("li");
				button = element("button");
				div0 = element("div");
				div0.textContent = "export";
				t2 = space();
				li1 = element("li");
				div7 = element("div");
				div1 = element("div");
				if_block0.c();
				t3 = space();
				div2 = element("div");
				div2.textContent = "Go to page";
				t5 = space();
				div4 = element("div");
				input = element("input");
				t6 = space();
				div3 = element("div");
				t7 = space();
				span0 = element("span");
				t8 = space();
				span1 = element("span");
				t9 = space();
				div5 = element("div");
				t10 = text("of ");
				t11 = text(/*totalpages*/ ctx[2]);
				t12 = space();
				div6 = element("div");
				if_block1.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(link, "class", "svelte-wy2cjk");
				attr(div0, "class", "btn-txt font-white svelte-wy2cjk");
				attr(button, "title", "Previous Set of Results");
				attr(button, "class", "rounded-4 hover-blue-800 black svelte-wy2cjk");
				attr(li0, "class", "svelte-wy2cjk");
				attr(div1, "class", "svelte-wy2cjk");
				attr(div2, "class", "relative mobile text mlr-5 mt-mobile svelte-wy2cjk");
				attr(input, "class", "ds-text-field__input svelte-wy2cjk");
				attr(input, "id", "page");
				attr(input, "type", "text");
				attr(input, "name", "page");
				attr(input, "autocomplete", "off");
				attr(div3, "class", "field-line-ripple blue svelte-wy2cjk");
				attr(span0, "class", "help display-none svelte-wy2cjk");
				attr(span1, "class", "error display-none svelte-wy2cjk");
				attr(div4, "class", "ds-text-field svelte-wy2cjk");
				attr(div5, "class", "relative mobile text mlr-5 mb-mobile svelte-wy2cjk");
				attr(div6, "class", "svelte-wy2cjk");
				attr(div7, "class", "flex mobile svelte-wy2cjk");
				attr(li1, "class", "svelte-wy2cjk");
				attr(ul, "class", "button-container svelte-wy2cjk");
				attr(nav, "class", "svelte-wy2cjk");
				attr(div8, "class", "width-full pagination-container svelte-wy2cjk");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div8, anchor);
				append(div8, nav);
				append(nav, ul);
				append(ul, li0);
				append(li0, button);
				append(button, div0);
				append(ul, t2);
				append(ul, li1);
				append(li1, div7);
				append(div7, div1);
				if_block0.m(div1, null);
				append(div7, t3);
				append(div7, div2);
				append(div7, t5);
				append(div7, div4);
				append(div4, input);
				set_input_value(input, /*gotopage*/ ctx[3]);
				append(div4, t6);
				append(div4, div3);
				append(div4, t7);
				append(div4, span0);
				append(div4, t8);
				append(div4, span1);
				append(div7, t9);
				append(div7, div5);
				append(div5, t10);
				append(div5, t11);
				append(div7, t12);
				append(div7, div6);
				if_block1.m(div6, null);

				if (!mounted) {
					dispose = [
						listen(div0, "click", /*click_handler*/ ctx[8]),
						listen(input, "input", /*input_input_handler*/ ctx[11]),
						listen(input, "change", /*change_handler*/ ctx[12])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0.d(1);
					if_block0 = current_block_type(ctx);

					if (if_block0) {
						if_block0.c();
						if_block0.m(div1, null);
					}
				}

				if (dirty & /*gotopage*/ 8 && input.value !== /*gotopage*/ ctx[3]) {
					set_input_value(input, /*gotopage*/ ctx[3]);
				}

				if (dirty & /*totalpages*/ 4) set_data(t11, /*totalpages*/ ctx[2]);

				if (current_block_type_1 === (current_block_type_1 = select_block_type_1(ctx)) && if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1.d(1);
					if_block1 = current_block_type_1(ctx);

					if (if_block1) {
						if_block1.c();
						if_block1.m(div6, null);
					}
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div8);
				}

				if_block0.d();
				if_block1.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$4($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { previouspagesize = '25' } = $$props;
		let { nextpagesize = '25' } = $$props;
		let { totalpages = 25 } = $$props;
		let gotopage = 1;

		function onPreviousClick(e) {
			if (gotopage > 1) $$invalidate(3, gotopage--, gotopage);
			svelteDispatch('previousClick', e);
		}

		function onNextClick(e) {
			if (gotopage < totalpages) $$invalidate(3, gotopage++, gotopage);
			svelteDispatch('nextClick', e);
		}

		function onChange(e) {
			if (gotopage > 0 && gotopage <= totalpages) svelteDispatch('gotoPage', gotopage);
		}

		function onExportClick(e) {
			svelteDispatch('export', e);
		}

		const click_handler = e => onExportClick(e);
		const click_handler_1 = e => onPreviousClick(e);
		const click_handler_2 = e => onPreviousClick(e);

		function input_input_handler() {
			gotopage = this.value;
			$$invalidate(3, gotopage);
		}

		const change_handler = e => onChange();
		const click_handler_3 = e => onNextClick(e);
		const click_handler_4 = e => onNextClick(e);

		$$self.$$set = $$props => {
			if ('previouspagesize' in $$props) $$invalidate(0, previouspagesize = $$props.previouspagesize);
			if ('nextpagesize' in $$props) $$invalidate(1, nextpagesize = $$props.nextpagesize);
			if ('totalpages' in $$props) $$invalidate(2, totalpages = $$props.totalpages);
		};

		return [
			previouspagesize,
			nextpagesize,
			totalpages,
			gotopage,
			onPreviousClick,
			onNextClick,
			onChange,
			onExportClick,
			click_handler,
			click_handler_1,
			click_handler_2,
			input_input_handler,
			change_handler,
			click_handler_3,
			click_handler_4
		];
	}

	class Eas_paginator_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$4,
				create_fragment$4,
				safe_not_equal,
				{
					previouspagesize: 0,
					nextpagesize: 1,
					totalpages: 2
				},
				add_css$3
			);
		}

		get previouspagesize() {
			return this.$$.ctx[0];
		}

		set previouspagesize(previouspagesize) {
			this.$$set({ previouspagesize });
			flush();
		}

		get nextpagesize() {
			return this.$$.ctx[1];
		}

		set nextpagesize(nextpagesize) {
			this.$$set({ nextpagesize });
			flush();
		}

		get totalpages() {
			return this.$$.ctx[2];
		}

		set totalpages(totalpages) {
			this.$$set({ totalpages });
			flush();
		}
	}

	customElements.define("eas-paginator-swc", create_custom_element(Eas_paginator_component, {"previouspagesize":{},"nextpagesize":{},"totalpages":{}}, [], [], true));

	var SectionDisplay;
	(function (SectionDisplay) {
	    SectionDisplay[SectionDisplay["List"] = 1] = "List";
	    SectionDisplay[SectionDisplay["Add"] = 2] = "Add";
	    SectionDisplay[SectionDisplay["Preview"] = 3] = "Preview";
	})(SectionDisplay || (SectionDisplay = {}));
	var TypeOfCommunication;
	(function (TypeOfCommunication) {
	    TypeOfCommunication[TypeOfCommunication["Email"] = 1] = "Email";
	    TypeOfCommunication[TypeOfCommunication["at"] = 2] = "at";
	})(TypeOfCommunication || (TypeOfCommunication = {}));
	var AlertStatus;
	(function (AlertStatus) {
	    AlertStatus["Success"] = "Success";
	    AlertStatus["Error"] = "Error";
	    AlertStatus["Warning"] = "Warning";
	    AlertStatus["Information"] = "Information";
	})(AlertStatus || (AlertStatus = {}));

	/* src\lib\web-components\alert\eas-alert.component.svelte generated by Svelte v4.2.19 */

	function add_css$2(target) {
		append_styles(target, "svelte-eq41nj", ".alert.svelte-eq41nj.svelte-eq41nj{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:'Source Sans Pro', sans-serif}.pr-20.svelte-eq41nj.svelte-eq41nj{padding-right:20px}a.svelte-eq41nj.svelte-eq41nj{text-decoration:none;color:#3d7aa9;font-weight:bold;transition:0.2s}a.svelte-eq41nj.svelte-eq41nj:hover{color:#285170}a.close.svelte-eq41nj.svelte-eq41nj{position:absolute;right:10px;top:-5px;font-size:24px;border:none}.fade.svelte-eq41nj.svelte-eq41nj{-webkit-animation:fadeEffect 0.4s;animation:fadeEffect 0.4s}.mbt-20.svelte-eq41nj.svelte-eq41nj{margin-bottom:20px !important;margin-top:20px !important}.flex.svelte-eq41nj.svelte-eq41nj{display:flex}.svelte-eq41nj.svelte-eq41nj,.svelte-eq41nj.svelte-eq41nj::after,.svelte-eq41nj.svelte-eq41nj::before{box-sizing:border-box;padding:0px;margin:0px}div.svelte-eq41nj.svelte-eq41nj{background:transparent;transition:all 0.2s ease-in-out 0s}.fade.svelte-eq41nj.svelte-eq41nj{animation-timeline:auto;animation-range-start:normal;animation-range-end:normal;animation:0.4s ease 0s 1 normal none running fadeEffect}.warn-page-alert.svelte-eq41nj.svelte-eq41nj{background-color:#fcf2d5;border-left:4px solid #f5c044}.info-page-alert.svelte-eq41nj.svelte-eq41nj{background-color:#e4ebf1;border-left:4px solid #5480a9}.error-page-alert.svelte-eq41nj.svelte-eq41nj{background-color:#f2c6c6;border-left:4px solid #df4743}.success-page-alert.svelte-eq41nj.svelte-eq41nj{background-color:#deedde;border-left:4px solid #238722}.alert-page-details.svelte-eq41nj.svelte-eq41nj{margin:0}.icon-container.svelte-eq41nj.svelte-eq41nj{margin-right:10px;margin-left:10px}.error-page-alert.svelte-eq41nj .icon-container.svelte-eq41nj{padding:10px 17px;border-radius:100px;background-color:#f3a8a6}.error-page-alert.svelte-eq41nj .alert-icon i.svelte-eq41nj{color:#df4743}a.close.error.svelte-eq41nj.svelte-eq41nj{color:#df4743 !important}.warn-page-alert.svelte-eq41nj .icon-container.svelte-eq41nj{background-color:#fcf2d5;width:0;height:0;border-left:15px solid transparent;border-right:15px solid transparent;border-bottom:25px solid #f5c044}.warn-page-alert.svelte-eq41nj .alert-icon i.svelte-eq41nj{color:#fcf2d5;margin-top:7px;margin-left:-3px}a.close.warn.svelte-eq41nj.svelte-eq41nj{color:#f5c044 !important}.info-page-alert.svelte-eq41nj .icon-container.svelte-eq41nj{padding:10px 17px;border-radius:100px;background-color:#c8d6e3}.info-page-alert.svelte-eq41nj .alert-icon i.svelte-eq41nj{color:#5480a9}a.close.info.svelte-eq41nj.svelte-eq41nj{color:#5480a9 !important}.success-page-alert.svelte-eq41nj .icon-container.svelte-eq41nj{background-color:#bfd8bb;border-radius:100px;padding:10px}.success-page-alert.svelte-eq41nj .alert-icon i.svelte-eq41nj{color:#238728}a.close.success.svelte-eq41nj.svelte-eq41nj{color:#238722 !important}.alert-page-details.svelte-eq41nj.svelte-eq41nj{max-width:unset}a.close.svelte-eq41nj.svelte-eq41nj{right:10px;top:50%;-ms-transform:translateY(-50%);transform:translateY(-50%)}.relative.svelte-eq41nj.svelte-eq41nj{position:relative}.absolute.svelte-eq41nj.svelte-eq41nj{position:absolute}.align-center.svelte-eq41nj.svelte-eq41nj{align-items:center !important}.ptb-20.svelte-eq41nj.svelte-eq41nj{padding-top:20px !important;padding-bottom:20px !important}.semibold.svelte-eq41nj.svelte-eq41nj{font-weight:800}h5.svelte-eq41nj.svelte-eq41nj{font-size:18px}");
	}

	// (88:0) {#if status && statusMessage?.length > 0}
	function create_if_block(ctx) {
		let div4;
		let div3;
		let div1;
		let div0;
		let i0;
		let i0_class_value;
		let t0;
		let a;
		let i1;
		let a_class_value;
		let t1;
		let div2;
		let h5;
		let t2;
		let t3;
		let p;
		let t4;
		let div3_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				div4 = element("div");
				div3 = element("div");
				div1 = element("div");
				div0 = element("div");
				i0 = element("i");
				t0 = space();
				a = element("a");
				i1 = element("i");
				t1 = space();
				div2 = element("div");
				h5 = element("h5");
				t2 = text(/*status*/ ctx[1]);
				t3 = space();
				p = element("p");
				t4 = text(/*statusMessage*/ ctx[0]);
				attr(i0, "class", i0_class_value = "fas " + /*statusIconClass*/ ctx[3] + " svelte-eq41nj");
				attr(div0, "class", "alert-icon svelte-eq41nj");
				attr(div1, "class", "icon-container svelte-eq41nj");
				attr(i1, "class", "fa-sharp fa-solid fa-xmark svelte-eq41nj");
				attr(a, "href", "javascript:void(0)");
				attr(a, "class", a_class_value = "absolute close " + /*statusXmarkClass*/ ctx[4] + " svelte-eq41nj");
				attr(h5, "class", "semibold svelte-eq41nj");
				attr(p, "class", "alert-page-details svelte-eq41nj");
				attr(div2, "class", "plr-10 ptb-20 pr-20 svelte-eq41nj");
				attr(div3, "class", div3_class_value = "flex align-center " + /*statusColorClass*/ ctx[2] + " relative" + " svelte-eq41nj");
				attr(div4, "role", "alert");
				attr(div4, "class", "mbt-20 fade alert svelte-eq41nj");
			},
			m(target, anchor) {
				insert(target, div4, anchor);
				append(div4, div3);
				append(div3, div1);
				append(div1, div0);
				append(div0, i0);
				append(div3, t0);
				append(div3, a);
				append(a, i1);
				append(div3, t1);
				append(div3, div2);
				append(div2, h5);
				append(h5, t2);
				append(div2, t3);
				append(div2, p);
				append(p, t4);

				if (!mounted) {
					dispose = listen(i1, "click", /*click_handler*/ ctx[7]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*statusIconClass*/ 8 && i0_class_value !== (i0_class_value = "fas " + /*statusIconClass*/ ctx[3] + " svelte-eq41nj")) {
					attr(i0, "class", i0_class_value);
				}

				if (dirty & /*statusXmarkClass*/ 16 && a_class_value !== (a_class_value = "absolute close " + /*statusXmarkClass*/ ctx[4] + " svelte-eq41nj")) {
					attr(a, "class", a_class_value);
				}

				if (dirty & /*status*/ 2) set_data(t2, /*status*/ ctx[1]);
				if (dirty & /*statusMessage*/ 1) set_data(t4, /*statusMessage*/ ctx[0]);

				if (dirty & /*statusColorClass*/ 4 && div3_class_value !== (div3_class_value = "flex align-center " + /*statusColorClass*/ ctx[2] + " relative" + " svelte-eq41nj")) {
					attr(div3, "class", div3_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div4);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$3(ctx) {
		let link;
		let t0;
		let script;
		let script_src_value;
		let t1;
		let if_block_anchor;
		let if_block = /*status*/ ctx[1] && /*statusMessage*/ ctx[0]?.length > 0 && create_if_block(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				script = element("script");
				script.innerHTML = ``;
				t1 = space();
				if (if_block) if_block.c();
				if_block_anchor = empty();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(link, "class", "svelte-eq41nj");
				if (!src_url_equal(script.src, script_src_value = "https://kit.fontawesome.com/a5cccf28a6.js")) attr(script, "src", script_src_value);
				attr(script, "crossorigin", "anonymous");
				attr(script, "class", "svelte-eq41nj");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				append(document.head, script);
				insert(target, t1, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, [dirty]) {
				if (/*status*/ ctx[1] && /*statusMessage*/ ctx[0]?.length > 0) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(t1);
					detach(if_block_anchor);
				}

				detach(script);
				if (if_block) if_block.d(detaching);
			}
		};
	}

	function instance$3($$self, $$props, $$invalidate) {
		let { alert } = $$props;
		const svelteDispatch = createEventDispatcher();
		let statusMessage;
		let status;
		let statusColorClass;
		let statusIconClass;
		let statusXmarkClass;

		function handleAlert(alert) {
			if (alert) {
				$$invalidate(1, status = alert.status);
				$$invalidate(0, statusMessage = alert.message);
				$$invalidate(2, statusColorClass = getStatusColorClass(status));
				$$invalidate(3, statusIconClass = getStatusIconClass(status));
				$$invalidate(4, statusXmarkClass = getStatusXmarkClass(status));
			} else {
				$$invalidate(1, status = null);
				$$invalidate(0, statusMessage = '');
				$$invalidate(2, statusColorClass = '');
				$$invalidate(3, statusIconClass = '');
				$$invalidate(4, statusXmarkClass = '');
			}
		}

		function getStatusColorClass(input) {
			switch (input) {
				case AlertStatus.Success:
					return 'success-page-alert';
				case AlertStatus.Warning:
					return 'warn-page-alert';
				case AlertStatus.Error:
					return 'error-page-alert';
				case AlertStatus.Information:
					return 'info-page-alert';
				default:
					return '';
			}
		}

		function getStatusIconClass(input) {
			switch (input) {
				case AlertStatus.Success:
					return 'fa-check';
				case AlertStatus.Warning:
					return 'fa-exclamation';
				case AlertStatus.Error:
					return 'fa-exclamation';
				case AlertStatus.Information:
					return 'fa-info';
				default:
					return '';
			}
		}

		function getStatusXmarkClass(input) {
			switch (input) {
				case AlertStatus.Success:
					return 'success';
				case AlertStatus.Warning:
					return 'warn';
				case AlertStatus.Error:
					return 'error';
				case AlertStatus.Information:
					return 'info';
				default:
					return '';
			}
		}

		function clearAlert() {
			$$invalidate(6, alert = null);
			svelteDispatch('clearAlert');
		}

		const click_handler = () => clearAlert();

		$$self.$$set = $$props => {
			if ('alert' in $$props) $$invalidate(6, alert = $$props.alert);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*alert*/ 64) {
				console.log('alert ', alert);
			}

			if ($$self.$$.dirty & /*alert*/ 64) {
				handleAlert(alert);
			}
		};

		console.log('----------EAS Alert Component---------');

		return [
			statusMessage,
			status,
			statusColorClass,
			statusIconClass,
			statusXmarkClass,
			clearAlert,
			alert,
			click_handler
		];
	}

	class Eas_alert_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$3, create_fragment$3, safe_not_equal, { alert: 6 }, add_css$2);
		}

		get alert() {
			return this.$$.ctx[6];
		}

		set alert(alert) {
			this.$$set({ alert });
			flush();
		}
	}

	customElements.define("eas-alert-swc", create_custom_element(Eas_alert_component, {"alert":{}}, [], [], true));

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

	var freeGlobal$1 = freeGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal$1 || freeSelf || Function('return this')();

	var root$1 = root;

	/** Built-in value references. */
	var Symbol = root$1.Symbol;

	var Symbol$1 = Symbol;

	/** Used for built-in method references. */
	var objectProto$f = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$c = objectProto$f.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$f.toString;

	/** Built-in value references. */
	var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty$c.call(value, symToStringTag$1),
	      tag = value[symToStringTag$1];

	  try {
	    value[symToStringTag$1] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString$1.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag$1] = tag;
	    } else {
	      delete value[symToStringTag$1];
	    }
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var objectProto$e = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto$e.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	var isArray$1 = isArray;

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}

	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag$2 = '[object Function]',
	    genTag$1 = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
	}

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root$1['__core-js_shared__'];

	var coreJsData$1 = coreJsData;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/** Used for built-in method references. */
	var funcProto$2 = Function.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$2 = funcProto$2.toString;

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString$2.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used for built-in method references. */
	var funcProto$1 = Function.prototype,
	    objectProto$d = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$1 = funcProto$1.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$b = objectProto$d.hasOwnProperty;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString$1.call(hasOwnProperty$b).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/* Built-in method references that are verified to be native. */
	var WeakMap$1 = getNative(root$1, 'WeakMap');

	var WeakMap$2 = WeakMap$1;

	/** Built-in value references. */
	var objectCreate = Object.create;

	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());

	var baseCreate$1 = baseCreate;

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;

	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;

	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);

	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}

	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());

	var defineProperty$1 = defineProperty;

	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty$1 ? identity : function(func, string) {
	  return defineProperty$1(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};

	var baseSetToString$1 = baseSetToString;

	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString$1);

	var setToString$1 = setToString;

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER$1 : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty$1) {
	    defineProperty$1(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/** Used for built-in method references. */
	var objectProto$c = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$a = objectProto$c.hasOwnProperty;

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty$a.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;

	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;

	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);

	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}

	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString$1(overRest(func, start, identity), func + '');
	}

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}

	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;

	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;

	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}

	/** Used for built-in method references. */
	var objectProto$b = Object.prototype;

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$b;

	  return value === proto;
	}

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/** `Object#toString` result references. */
	var argsTag$3 = '[object Arguments]';

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
	}

	/** Used for built-in method references. */
	var objectProto$a = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

	/** Built-in value references. */
	var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty$9.call(value, 'callee') &&
	    !propertyIsEnumerable$1.call(value, 'callee');
	};

	var isArguments$1 = isArguments;

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	/** Detect free variable `exports`. */
	var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

	/** Built-in value references. */
	var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	var isBuffer$1 = isBuffer;

	/** `Object#toString` result references. */
	var argsTag$2 = '[object Arguments]',
	    arrayTag$2 = '[object Array]',
	    boolTag$3 = '[object Boolean]',
	    dateTag$3 = '[object Date]',
	    errorTag$2 = '[object Error]',
	    funcTag$1 = '[object Function]',
	    mapTag$5 = '[object Map]',
	    numberTag$3 = '[object Number]',
	    objectTag$4 = '[object Object]',
	    regexpTag$3 = '[object RegExp]',
	    setTag$5 = '[object Set]',
	    stringTag$3 = '[object String]',
	    weakMapTag$2 = '[object WeakMap]';

	var arrayBufferTag$3 = '[object ArrayBuffer]',
	    dataViewTag$4 = '[object DataView]',
	    float32Tag$2 = '[object Float32Array]',
	    float64Tag$2 = '[object Float64Array]',
	    int8Tag$2 = '[object Int8Array]',
	    int16Tag$2 = '[object Int16Array]',
	    int32Tag$2 = '[object Int32Array]',
	    uint8Tag$2 = '[object Uint8Array]',
	    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
	    uint16Tag$2 = '[object Uint16Array]',
	    uint32Tag$2 = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
	typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
	typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
	typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
	typedArrayTags[uint32Tag$2] = true;
	typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
	typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] =
	typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] =
	typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] =
	typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] =
	typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] =
	typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] =
	typedArrayTags[weakMapTag$2] = false;

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	/** Detect free variable `exports`. */
	var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports$1 && freeGlobal$1.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	var nodeUtil$1 = nodeUtil;

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	var isTypedArray$1 = isTypedArray;

	/** Used for built-in method references. */
	var objectProto$9 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray$1(value),
	      isArg = !isArr && isArguments$1(value),
	      isBuff = !isArr && !isArg && isBuffer$1(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$8.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);

	var nativeKeys$1 = nativeKeys;

	/** Used for built-in method references. */
	var objectProto$8 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys$1(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var objectProto$7 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];

	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty$6.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}

	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');

	var nativeCreate$1 = nativeCreate;

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

	/** Used for built-in method references. */
	var objectProto$6 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate$1) {
	    var result = data[key];
	    return result === HASH_UNDEFINED$2 ? undefined : result;
	  }
	  return hasOwnProperty$5.call(data, key) ? data[key] : undefined;
	}

	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$4.call(data, key);
	}

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED$1 : value;
	  return this;
	}

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;

	/** Built-in value references. */
	var splice = arrayProto.splice;

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/* Built-in method references that are verified to be native. */
	var Map$1 = getNative(root$1, 'Map');

	var Map$2 = Map$1;

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map$2 || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);

	var getPrototype$1 = getPrototype;

	/** `Object#toString` result references. */
	var objectTag$3 = '[object Object]';

	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto$4 = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);

	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
	    return false;
	  }
	  var proto = getPrototype$1(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty$3.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}

	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}

	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root$1.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};

	var getSymbols$1 = getSymbols;

	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols$1(source), object);
	}

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;

	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols$1(object));
	    object = getPrototype$1(object);
	  }
	  return result;
	};

	var getSymbolsIn$1 = getSymbolsIn;

	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn$1(source), object);
	}

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
	}

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols$1);
	}

	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
	}

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root$1, 'DataView');

	var DataView$1 = DataView;

	/* Built-in method references that are verified to be native. */
	var Promise$1 = getNative(root$1, 'Promise');

	var Promise$2 = Promise$1;

	/* Built-in method references that are verified to be native. */
	var Set$1 = getNative(root$1, 'Set');

	var Set$2 = Set$1;

	/** `Object#toString` result references. */
	var mapTag$4 = '[object Map]',
	    objectTag$2 = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag$4 = '[object Set]',
	    weakMapTag$1 = '[object WeakMap]';

	var dataViewTag$3 = '[object DataView]';

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView$1),
	    mapCtorString = toSource(Map$2),
	    promiseCtorString = toSource(Promise$2),
	    setCtorString = toSource(Set$2),
	    weakMapCtorString = toSource(WeakMap$2);

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3) ||
	    (Map$2 && getTag(new Map$2) != mapTag$4) ||
	    (Promise$2 && getTag(Promise$2.resolve()) != promiseTag) ||
	    (Set$2 && getTag(new Set$2) != setTag$4) ||
	    (WeakMap$2 && getTag(new WeakMap$2) != weakMapTag$1)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag$2 ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag$3;
	        case mapCtorString: return mapTag$4;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag$4;
	        case weakMapCtorString: return weakMapTag$1;
	      }
	    }
	    return result;
	  };
	}

	var getTag$1 = getTag;

	/** Used for built-in method references. */
	var objectProto$2 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);

	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty$2.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}

	/** Built-in value references. */
	var Uint8Array = root$1.Uint8Array;

	var Uint8Array$1 = Uint8Array;

	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
	  return result;
	}

	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;

	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}

	/** Used to convert symbols to primitives and strings. */
	var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
	    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
	}

	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}

	/** `Object#toString` result references. */
	var boolTag$2 = '[object Boolean]',
	    dateTag$2 = '[object Date]',
	    mapTag$3 = '[object Map]',
	    numberTag$2 = '[object Number]',
	    regexpTag$2 = '[object RegExp]',
	    setTag$3 = '[object Set]',
	    stringTag$2 = '[object String]',
	    symbolTag$2 = '[object Symbol]';

	var arrayBufferTag$2 = '[object ArrayBuffer]',
	    dataViewTag$2 = '[object DataView]',
	    float32Tag$1 = '[object Float32Array]',
	    float64Tag$1 = '[object Float64Array]',
	    int8Tag$1 = '[object Int8Array]',
	    int16Tag$1 = '[object Int16Array]',
	    int32Tag$1 = '[object Int32Array]',
	    uint8Tag$1 = '[object Uint8Array]',
	    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
	    uint16Tag$1 = '[object Uint16Array]',
	    uint32Tag$1 = '[object Uint32Array]';

	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag$2:
	      return cloneArrayBuffer(object);

	    case boolTag$2:
	    case dateTag$2:
	      return new Ctor(+object);

	    case dataViewTag$2:
	      return cloneDataView(object, isDeep);

	    case float32Tag$1: case float64Tag$1:
	    case int8Tag$1: case int16Tag$1: case int32Tag$1:
	    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
	      return cloneTypedArray(object, isDeep);

	    case mapTag$3:
	      return new Ctor;

	    case numberTag$2:
	    case stringTag$2:
	      return new Ctor(object);

	    case regexpTag$2:
	      return cloneRegExp(object);

	    case setTag$3:
	      return new Ctor;

	    case symbolTag$2:
	      return cloneSymbol(object);
	  }
	}

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate$1(getPrototype$1(object))
	    : {};
	}

	/** `Object#toString` result references. */
	var mapTag$2 = '[object Map]';

	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag$1(value) == mapTag$2;
	}

	/* Node.js helper references. */
	var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

	var isMap$1 = isMap;

	/** `Object#toString` result references. */
	var setTag$2 = '[object Set]';

	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag$1(value) == setTag$2;
	}

	/* Node.js helper references. */
	var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

	var isSet$1 = isSet;

	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG$1 = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG$1 = 4;

	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]',
	    arrayTag$1 = '[object Array]',
	    boolTag$1 = '[object Boolean]',
	    dateTag$1 = '[object Date]',
	    errorTag$1 = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag$1 = '[object Map]',
	    numberTag$1 = '[object Number]',
	    objectTag$1 = '[object Object]',
	    regexpTag$1 = '[object RegExp]',
	    setTag$1 = '[object Set]',
	    stringTag$1 = '[object String]',
	    symbolTag$1 = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag$1 = '[object ArrayBuffer]',
	    dataViewTag$1 = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] =
	cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] =
	cloneableTags[boolTag$1] = cloneableTags[dateTag$1] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag$1] =
	cloneableTags[numberTag$1] = cloneableTags[objectTag$1] =
	cloneableTags[regexpTag$1] = cloneableTags[setTag$1] =
	cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag$1] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;

	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG$1,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray$1(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag$1(value),
	        isFunc = tag == funcTag || tag == genTag;

	    if (isBuffer$1(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag$1 || tag == argsTag$1 || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);

	  if (isSet$1(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap$1(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }

	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);

	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}

	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;

	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep$1(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;

	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}

	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$3 = 1,
	    COMPARE_UNORDERED_FLAG$1 = 2;

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG$1) ? new SetCache : undefined;

	  stack.set(array, other);
	  stack.set(other, array);

	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$2 = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
	        return false;
	      }
	      return true;

	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);

	    case errorTag:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');

	    case mapTag:
	      var convert = mapToArray;

	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
	      convert || (convert = setToArray);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;

	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$1 = 1;

	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);

	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray$1(object),
	      othIsArr = isArray$1(other),
	      objTag = objIsArr ? arrayTag : getTag$1(object),
	      othTag = othIsArr ? arrayTag : getTag$1(other);

	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;

	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer$1(object)) {
	    if (!isBuffer$1(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray$1(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;

	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}

	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();

	var baseFor$1 = baseFor;

	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }

	  if (key == '__proto__') {
	    return;
	  }

	  return object[key];
	}

	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}

	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);

	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;

	  var isCommon = newValue === undefined;

	  if (isCommon) {
	    var isArr = isArray$1(srcValue),
	        isBuff = !isArr && isBuffer$1(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);

	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray$1(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments$1(srcValue)) {
	      newValue = objValue;
	      if (isArguments$1(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}

	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor$1(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;

	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}

	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual$2(value, other) {
	  return baseIsEqual(value, other);
	}

	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});

	var merge$1 = merge;

	var Scope = /* @__PURE__ */ ((Scope2) => (Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))(Scope || {});
	class Attributor {
	  constructor(attrName, keyName, options = {}) {
	    this.attrName = attrName, this.keyName = keyName;
	    const attributeBit = Scope.TYPE & Scope.ATTRIBUTE;
	    this.scope = options.scope != null ? (
	      // Ignore type bits, force attribute bit
	      options.scope & Scope.LEVEL | attributeBit
	    ) : Scope.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
	  }
	  static keys(node) {
	    return Array.from(node.attributes).map((item) => item.name);
	  }
	  add(node, value) {
	    return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
	  }
	  canAdd(_node, value) {
	    return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
	  }
	  remove(node) {
	    node.removeAttribute(this.keyName);
	  }
	  value(node) {
	    const value = node.getAttribute(this.keyName);
	    return this.canAdd(node, value) && value ? value : "";
	  }
	}
	class ParchmentError extends Error {
	  constructor(message) {
	    message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
	  }
	}
	const _Registry = class _Registry {
	  constructor() {
	    this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
	  }
	  static find(node, bubble = !1) {
	    if (node == null)
	      return null;
	    if (this.blots.has(node))
	      return this.blots.get(node) || null;
	    if (bubble) {
	      let parentNode = null;
	      try {
	        parentNode = node.parentNode;
	      } catch {
	        return null;
	      }
	      return this.find(parentNode, bubble);
	    }
	    return null;
	  }
	  create(scroll, input, value) {
	    const match2 = this.query(input);
	    if (match2 == null)
	      throw new ParchmentError(`Unable to create ${input} blot`);
	    const blotClass = match2, node = (
	      // @ts-expect-error Fix me later
	      input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value)
	    ), blot = new blotClass(scroll, node, value);
	    return _Registry.blots.set(blot.domNode, blot), blot;
	  }
	  find(node, bubble = !1) {
	    return _Registry.find(node, bubble);
	  }
	  query(query, scope = Scope.ANY) {
	    let match2;
	    return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & Scope.LEVEL & Scope.BLOCK ? match2 = this.types.block : query & Scope.LEVEL & Scope.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name) => (match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & Scope.LEVEL & match2.scope && scope & Scope.TYPE & match2.scope ? match2 : null;
	  }
	  register(...definitions) {
	    return definitions.map((definition) => {
	      const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
	      if (!isBlot && !isAttr)
	        throw new ParchmentError("Invalid definition");
	      if (isBlot && definition.blotName === "abstract")
	        throw new ParchmentError("Cannot register abstract class");
	      const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
	      return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName) => tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [definition.tagName]).forEach((tag) => {
	        (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
	      }))), definition;
	    });
	  }
	};
	_Registry.blots = /* @__PURE__ */ new WeakMap();
	let Registry = _Registry;
	function match(node, prefix) {
	  return (node.getAttribute("class") || "").split(/\s+/).filter((name) => name.indexOf(`${prefix}-`) === 0);
	}
	class ClassAttributor extends Attributor {
	  static keys(node) {
	    return (node.getAttribute("class") || "").split(/\s+/).map((name) => name.split("-").slice(0, -1).join("-"));
	  }
	  add(node, value) {
	    return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
	  }
	  remove(node) {
	    match(node, this.keyName).forEach((name) => {
	      node.classList.remove(name);
	    }), node.classList.length === 0 && node.removeAttribute("class");
	  }
	  value(node) {
	    const value = (match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
	    return this.canAdd(node, value) ? value : "";
	  }
	}
	const ClassAttributor$1 = ClassAttributor;
	function camelize(name) {
	  const parts = name.split("-"), rest = parts.slice(1).map((part) => part[0].toUpperCase() + part.slice(1)).join("");
	  return parts[0] + rest;
	}
	class StyleAttributor extends Attributor {
	  static keys(node) {
	    return (node.getAttribute("style") || "").split(";").map((value) => value.split(":")[0].trim());
	  }
	  add(node, value) {
	    return this.canAdd(node, value) ? (node.style[camelize(this.keyName)] = value, !0) : !1;
	  }
	  remove(node) {
	    node.style[camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
	  }
	  value(node) {
	    const value = node.style[camelize(this.keyName)];
	    return this.canAdd(node, value) ? value : "";
	  }
	}
	const StyleAttributor$1 = StyleAttributor;
	class AttributorStore {
	  constructor(domNode) {
	    this.attributes = {}, this.domNode = domNode, this.build();
	  }
	  attribute(attribute, value) {
	    value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
	  }
	  build() {
	    this.attributes = {};
	    const blot = Registry.find(this.domNode);
	    if (blot == null)
	      return;
	    const attributes = Attributor.keys(this.domNode), classes = ClassAttributor$1.keys(this.domNode), styles = StyleAttributor$1.keys(this.domNode);
	    attributes.concat(classes).concat(styles).forEach((name) => {
	      const attr = blot.scroll.query(name, Scope.ATTRIBUTE);
	      attr instanceof Attributor && (this.attributes[attr.attrName] = attr);
	    });
	  }
	  copy(target) {
	    Object.keys(this.attributes).forEach((key) => {
	      const value = this.attributes[key].value(this.domNode);
	      target.format(key, value);
	    });
	  }
	  move(target) {
	    this.copy(target), Object.keys(this.attributes).forEach((key) => {
	      this.attributes[key].remove(this.domNode);
	    }), this.attributes = {};
	  }
	  values() {
	    return Object.keys(this.attributes).reduce(
	      (attributes, name) => (attributes[name] = this.attributes[name].value(this.domNode), attributes),
	      {}
	    );
	  }
	}
	const AttributorStore$1 = AttributorStore, _ShadowBlot = class _ShadowBlot {
	  constructor(scroll, domNode) {
	    this.scroll = scroll, this.domNode = domNode, Registry.blots.set(domNode, this), this.prev = null, this.next = null;
	  }
	  static create(rawValue) {
	    if (this.tagName == null)
	      throw new ParchmentError("Blot definition missing tagName");
	    let node, value;
	    return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
	  }
	  // Hack for accessing inherited static methods
	  get statics() {
	    return this.constructor;
	  }
	  attach() {
	  }
	  clone() {
	    const domNode = this.domNode.cloneNode(!1);
	    return this.scroll.create(domNode);
	  }
	  detach() {
	    this.parent != null && this.parent.removeChild(this), Registry.blots.delete(this.domNode);
	  }
	  deleteAt(index, length) {
	    this.isolate(index, length).remove();
	  }
	  formatAt(index, length, name, value) {
	    const blot = this.isolate(index, length);
	    if (this.scroll.query(name, Scope.BLOT) != null && value)
	      blot.wrap(name, value);
	    else if (this.scroll.query(name, Scope.ATTRIBUTE) != null) {
	      const parent = this.scroll.create(this.statics.scope);
	      blot.wrap(parent), parent.format(name, value);
	    }
	  }
	  insertAt(index, value, def) {
	    const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
	    this.parent.insertBefore(blot, ref || void 0);
	  }
	  isolate(index, length) {
	    const target = this.split(index);
	    if (target == null)
	      throw new Error("Attempt to isolate at end");
	    return target.split(length), target;
	  }
	  length() {
	    return 1;
	  }
	  offset(root = this.parent) {
	    return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
	  }
	  optimize(_context) {
	    this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
	  }
	  remove() {
	    this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
	  }
	  replaceWith(name, value) {
	    const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
	    return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
	  }
	  split(index, _force) {
	    return index === 0 ? this : this.next;
	  }
	  update(_mutations, _context) {
	  }
	  wrap(name, value) {
	    const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
	    if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function")
	      throw new ParchmentError(`Cannot wrap ${name}`);
	    return wrapper.appendChild(this), wrapper;
	  }
	};
	_ShadowBlot.blotName = "abstract";
	let ShadowBlot = _ShadowBlot;
	const _LeafBlot = class _LeafBlot extends ShadowBlot {
	  /**
	   * Returns the value represented by domNode if it is this Blot's type
	   * No checking that domNode can represent this Blot type is required so
	   * applications needing it should check externally before calling.
	   */
	  static value(_domNode) {
	    return !0;
	  }
	  /**
	   * Given location represented by node and offset from DOM Selection Range,
	   * return index to that location.
	   */
	  index(node, offset) {
	    return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
	  }
	  /**
	   * Given index to location within blot, return node and offset representing
	   * that location, consumable by DOM Selection Range
	   */
	  position(index, _inclusive) {
	    let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
	    return index > 0 && (offset += 1), [this.parent.domNode, offset];
	  }
	  /**
	   * Return value represented by this blot
	   * Should not change without interaction from API or
	   * user change detectable by update()
	   */
	  value() {
	    return {
	      [this.statics.blotName]: this.statics.value(this.domNode) || !0
	    };
	  }
	};
	_LeafBlot.scope = Scope.INLINE_BLOT;
	let LeafBlot = _LeafBlot;
	const LeafBlot$1 = LeafBlot;
	class LinkedList {
	  constructor() {
	    this.head = null, this.tail = null, this.length = 0;
	  }
	  append(...nodes) {
	    if (this.insertBefore(nodes[0], null), nodes.length > 1) {
	      const rest = nodes.slice(1);
	      this.append(...rest);
	    }
	  }
	  at(index) {
	    const next = this.iterator();
	    let cur = next();
	    for (; cur && index > 0; )
	      index -= 1, cur = next();
	    return cur;
	  }
	  contains(node) {
	    const next = this.iterator();
	    let cur = next();
	    for (; cur; ) {
	      if (cur === node)
	        return !0;
	      cur = next();
	    }
	    return !1;
	  }
	  indexOf(node) {
	    const next = this.iterator();
	    let cur = next(), index = 0;
	    for (; cur; ) {
	      if (cur === node)
	        return index;
	      index += 1, cur = next();
	    }
	    return -1;
	  }
	  insertBefore(node, refNode) {
	    node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
	  }
	  offset(target) {
	    let index = 0, cur = this.head;
	    for (; cur != null; ) {
	      if (cur === target)
	        return index;
	      index += cur.length(), cur = cur.next;
	    }
	    return -1;
	  }
	  remove(node) {
	    this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
	  }
	  iterator(curNode = this.head) {
	    return () => {
	      const ret = curNode;
	      return curNode != null && (curNode = curNode.next), ret;
	    };
	  }
	  find(index, inclusive = !1) {
	    const next = this.iterator();
	    let cur = next();
	    for (; cur; ) {
	      const length = cur.length();
	      if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0))
	        return [cur, index];
	      index -= length, cur = next();
	    }
	    return [null, 0];
	  }
	  forEach(callback) {
	    const next = this.iterator();
	    let cur = next();
	    for (; cur; )
	      callback(cur), cur = next();
	  }
	  forEachAt(index, length, callback) {
	    if (length <= 0)
	      return;
	    const [startNode, offset] = this.find(index);
	    let curIndex = index - offset;
	    const next = this.iterator(startNode);
	    let cur = next();
	    for (; cur && curIndex < index + length; ) {
	      const curLength = cur.length();
	      index > curIndex ? callback(
	        cur,
	        index - curIndex,
	        Math.min(length, curIndex + curLength - index)
	      ) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
	    }
	  }
	  map(callback) {
	    return this.reduce((memo, cur) => (memo.push(callback(cur)), memo), []);
	  }
	  reduce(callback, memo) {
	    const next = this.iterator();
	    let cur = next();
	    for (; cur; )
	      memo = callback(memo, cur), cur = next();
	    return memo;
	  }
	}
	function makeAttachedBlot(node, scroll) {
	  const found = scroll.find(node);
	  if (found)
	    return found;
	  try {
	    return scroll.create(node);
	  } catch {
	    const blot = scroll.create(Scope.INLINE);
	    return Array.from(node.childNodes).forEach((child) => {
	      blot.domNode.appendChild(child);
	    }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
	  }
	}
	const _ParentBlot = class _ParentBlot extends ShadowBlot {
	  constructor(scroll, domNode) {
	    super(scroll, domNode), this.uiNode = null, this.build();
	  }
	  appendChild(other) {
	    this.insertBefore(other);
	  }
	  attach() {
	    super.attach(), this.children.forEach((child) => {
	      child.attach();
	    });
	  }
	  attachUI(node) {
	    this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
	  }
	  /**
	   * Called during construction, should fill its own children LinkedList.
	   */
	  build() {
	    this.children = new LinkedList(), Array.from(this.domNode.childNodes).filter((node) => node !== this.uiNode).reverse().forEach((node) => {
	      try {
	        const child = makeAttachedBlot(node, this.scroll);
	        this.insertBefore(child, this.children.head || void 0);
	      } catch (err) {
	        if (err instanceof ParchmentError)
	          return;
	        throw err;
	      }
	    });
	  }
	  deleteAt(index, length) {
	    if (index === 0 && length === this.length())
	      return this.remove();
	    this.children.forEachAt(index, length, (child, offset, childLength) => {
	      child.deleteAt(offset, childLength);
	    });
	  }
	  descendant(criteria, index = 0) {
	    const [child, offset] = this.children.find(index);
	    return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [child, offset] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [null, -1];
	  }
	  descendants(criteria, index = 0, length = Number.MAX_VALUE) {
	    let descendants = [], lengthLeft = length;
	    return this.children.forEachAt(
	      index,
	      length,
	      (child, childIndex, childLength) => {
	        (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(
	          child.descendants(criteria, childIndex, lengthLeft)
	        )), lengthLeft -= childLength;
	      }
	    ), descendants;
	  }
	  detach() {
	    this.children.forEach((child) => {
	      child.detach();
	    }), super.detach();
	  }
	  enforceAllowedChildren() {
	    let done = !1;
	    this.children.forEach((child) => {
	      done || this.statics.allowedChildren.some(
	        (def) => child instanceof def
	      ) || (child.statics.scope === Scope.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
	    });
	  }
	  formatAt(index, length, name, value) {
	    this.children.forEachAt(index, length, (child, offset, childLength) => {
	      child.formatAt(offset, childLength, name, value);
	    });
	  }
	  insertAt(index, value, def) {
	    const [child, offset] = this.children.find(index);
	    if (child)
	      child.insertAt(offset, value, def);
	    else {
	      const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
	      this.appendChild(blot);
	    }
	  }
	  insertBefore(childBlot, refBlot) {
	    childBlot.parent != null && childBlot.parent.children.remove(childBlot);
	    let refDomNode = null;
	    this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
	  }
	  length() {
	    return this.children.reduce((memo, child) => memo + child.length(), 0);
	  }
	  moveChildren(targetParent, refNode) {
	    this.children.forEach((child) => {
	      targetParent.insertBefore(child, refNode);
	    });
	  }
	  optimize(context) {
	    if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0)
	      if (this.statics.defaultChild != null) {
	        const child = this.scroll.create(this.statics.defaultChild.blotName);
	        this.appendChild(child);
	      } else
	        this.remove();
	  }
	  path(index, inclusive = !1) {
	    const [child, offset] = this.children.find(index, inclusive), position = [[this, index]];
	    return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([child, offset]), position);
	  }
	  removeChild(child) {
	    this.children.remove(child);
	  }
	  replaceWith(name, value) {
	    const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
	    return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
	  }
	  split(index, force = !1) {
	    if (!force) {
	      if (index === 0)
	        return this;
	      if (index === this.length())
	        return this.next;
	    }
	    const after = this.clone();
	    return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length) => {
	      const split = child.split(offset, force);
	      split != null && after.appendChild(split);
	    }), after;
	  }
	  splitAfter(child) {
	    const after = this.clone();
	    for (; child.next != null; )
	      after.appendChild(child.next);
	    return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
	  }
	  unwrap() {
	    this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
	  }
	  update(mutations, _context) {
	    const addedNodes = [], removedNodes = [];
	    mutations.forEach((mutation) => {
	      mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
	    }), removedNodes.forEach((node) => {
	      if (node.parentNode != null && // @ts-expect-error Fix me later
	      node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY)
	        return;
	      const blot = this.scroll.find(node);
	      blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
	    }), addedNodes.filter((node) => node.parentNode === this.domNode && node !== this.uiNode).sort((a, b) => a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node) => {
	      let refBlot = null;
	      node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
	      const blot = makeAttachedBlot(node, this.scroll);
	      (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
	    }), this.enforceAllowedChildren();
	  }
	};
	_ParentBlot.uiClass = "";
	let ParentBlot = _ParentBlot;
	const ParentBlot$1 = ParentBlot;
	function isEqual$1(obj1, obj2) {
	  if (Object.keys(obj1).length !== Object.keys(obj2).length)
	    return !1;
	  for (const prop in obj1)
	    if (obj1[prop] !== obj2[prop])
	      return !1;
	  return !0;
	}
	const _InlineBlot = class _InlineBlot extends ParentBlot$1 {
	  static create(value) {
	    return super.create(value);
	  }
	  static formats(domNode, scroll) {
	    const match2 = scroll.query(_InlineBlot.blotName);
	    if (!(match2 != null && domNode.tagName === match2.tagName)) {
	      if (typeof this.tagName == "string")
	        return !0;
	      if (Array.isArray(this.tagName))
	        return domNode.tagName.toLowerCase();
	    }
	  }
	  constructor(scroll, domNode) {
	    super(scroll, domNode), this.attributes = new AttributorStore$1(this.domNode);
	  }
	  format(name, value) {
	    if (name === this.statics.blotName && !value)
	      this.children.forEach((child) => {
	        child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
	      }), this.unwrap();
	    else {
	      const format = this.scroll.query(name, Scope.INLINE);
	      if (format == null)
	        return;
	      format instanceof Attributor ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
	    }
	  }
	  formats() {
	    const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
	    return format != null && (formats[this.statics.blotName] = format), formats;
	  }
	  formatAt(index, length, name, value) {
	    this.formats()[name] != null || this.scroll.query(name, Scope.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
	  }
	  optimize(context) {
	    super.optimize(context);
	    const formats = this.formats();
	    if (Object.keys(formats).length === 0)
	      return this.unwrap();
	    const next = this.next;
	    next instanceof _InlineBlot && next.prev === this && isEqual$1(formats, next.formats()) && (next.moveChildren(this), next.remove());
	  }
	  replaceWith(name, value) {
	    const replacement = super.replaceWith(name, value);
	    return this.attributes.copy(replacement), replacement;
	  }
	  update(mutations, context) {
	    super.update(mutations, context), mutations.some(
	      (mutation) => mutation.target === this.domNode && mutation.type === "attributes"
	    ) && this.attributes.build();
	  }
	  wrap(name, value) {
	    const wrapper = super.wrap(name, value);
	    return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
	  }
	};
	_InlineBlot.allowedChildren = [_InlineBlot, LeafBlot$1], _InlineBlot.blotName = "inline", _InlineBlot.scope = Scope.INLINE_BLOT, _InlineBlot.tagName = "SPAN";
	let InlineBlot = _InlineBlot;
	const InlineBlot$1 = InlineBlot, _BlockBlot = class _BlockBlot extends ParentBlot$1 {
	  static create(value) {
	    return super.create(value);
	  }
	  static formats(domNode, scroll) {
	    const match2 = scroll.query(_BlockBlot.blotName);
	    if (!(match2 != null && domNode.tagName === match2.tagName)) {
	      if (typeof this.tagName == "string")
	        return !0;
	      if (Array.isArray(this.tagName))
	        return domNode.tagName.toLowerCase();
	    }
	  }
	  constructor(scroll, domNode) {
	    super(scroll, domNode), this.attributes = new AttributorStore$1(this.domNode);
	  }
	  format(name, value) {
	    const format = this.scroll.query(name, Scope.BLOCK);
	    format != null && (format instanceof Attributor ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
	  }
	  formats() {
	    const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
	    return format != null && (formats[this.statics.blotName] = format), formats;
	  }
	  formatAt(index, length, name, value) {
	    this.scroll.query(name, Scope.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
	  }
	  insertAt(index, value, def) {
	    if (def == null || this.scroll.query(value, Scope.INLINE) != null)
	      super.insertAt(index, value, def);
	    else {
	      const after = this.split(index);
	      if (after != null) {
	        const blot = this.scroll.create(value, def);
	        after.parent.insertBefore(blot, after);
	      } else
	        throw new Error("Attempt to insertAt after block boundaries");
	    }
	  }
	  replaceWith(name, value) {
	    const replacement = super.replaceWith(name, value);
	    return this.attributes.copy(replacement), replacement;
	  }
	  update(mutations, context) {
	    super.update(mutations, context), mutations.some(
	      (mutation) => mutation.target === this.domNode && mutation.type === "attributes"
	    ) && this.attributes.build();
	  }
	};
	_BlockBlot.blotName = "block", _BlockBlot.scope = Scope.BLOCK_BLOT, _BlockBlot.tagName = "P", _BlockBlot.allowedChildren = [
	  InlineBlot$1,
	  _BlockBlot,
	  LeafBlot$1
	];
	let BlockBlot = _BlockBlot;
	const BlockBlot$1 = BlockBlot, _ContainerBlot = class _ContainerBlot extends ParentBlot$1 {
	  checkMerge() {
	    return this.next !== null && this.next.statics.blotName === this.statics.blotName;
	  }
	  deleteAt(index, length) {
	    super.deleteAt(index, length), this.enforceAllowedChildren();
	  }
	  formatAt(index, length, name, value) {
	    super.formatAt(index, length, name, value), this.enforceAllowedChildren();
	  }
	  insertAt(index, value, def) {
	    super.insertAt(index, value, def), this.enforceAllowedChildren();
	  }
	  optimize(context) {
	    super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
	  }
	};
	_ContainerBlot.blotName = "container", _ContainerBlot.scope = Scope.BLOCK_BLOT;
	let ContainerBlot = _ContainerBlot;
	const ContainerBlot$1 = ContainerBlot;
	class EmbedBlot extends LeafBlot$1 {
	  static formats(_domNode, _scroll) {
	  }
	  format(name, value) {
	    super.formatAt(0, this.length(), name, value);
	  }
	  formatAt(index, length, name, value) {
	    index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
	  }
	  formats() {
	    return this.statics.formats(this.domNode, this.scroll);
	  }
	}
	const EmbedBlot$1 = EmbedBlot, OBSERVER_CONFIG = {
	  attributes: !0,
	  characterData: !0,
	  characterDataOldValue: !0,
	  childList: !0,
	  subtree: !0
	}, MAX_OPTIMIZE_ITERATIONS = 100, _ScrollBlot = class _ScrollBlot extends ParentBlot$1 {
	  constructor(registry, node) {
	    super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations) => {
	      this.update(mutations);
	    }), this.observer.observe(this.domNode, OBSERVER_CONFIG), this.attach();
	  }
	  create(input, value) {
	    return this.registry.create(this, input, value);
	  }
	  find(node, bubble = !1) {
	    const blot = this.registry.find(node, bubble);
	    return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
	  }
	  query(query, scope = Scope.ANY) {
	    return this.registry.query(query, scope);
	  }
	  register(...definitions) {
	    return this.registry.register(...definitions);
	  }
	  build() {
	    this.scroll != null && super.build();
	  }
	  detach() {
	    super.detach(), this.observer.disconnect();
	  }
	  deleteAt(index, length) {
	    this.update(), index === 0 && length === this.length() ? this.children.forEach((child) => {
	      child.remove();
	    }) : super.deleteAt(index, length);
	  }
	  formatAt(index, length, name, value) {
	    this.update(), super.formatAt(index, length, name, value);
	  }
	  insertAt(index, value, def) {
	    this.update(), super.insertAt(index, value, def);
	  }
	  optimize(mutations = [], context = {}) {
	    super.optimize(context);
	    const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
	    let records = Array.from(this.observer.takeRecords());
	    for (; records.length > 0; )
	      mutations.push(records.pop());
	    const mark = (blot, markParent = !0) => {
	      blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
	    }, optimize = (blot) => {
	      mutationsMap.has(blot.domNode) && (blot instanceof ParentBlot$1 && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
	    };
	    let remaining = mutations;
	    for (let i = 0; remaining.length > 0; i += 1) {
	      if (i >= MAX_OPTIMIZE_ITERATIONS)
	        throw new Error("[Parchment] Maximum optimize iterations reached");
	      for (remaining.forEach((mutation) => {
	        const blot = this.find(mutation.target, !0);
	        blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node) => {
	          const child = this.find(node, !1);
	          mark(child, !1), child instanceof ParentBlot$1 && child.children.forEach((grandChild) => {
	            mark(grandChild, !1);
	          });
	        })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
	      }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0; )
	        mutations.push(records.pop());
	    }
	  }
	  update(mutations, context = {}) {
	    mutations = mutations || this.observer.takeRecords();
	    const mutationsMap = /* @__PURE__ */ new WeakMap();
	    mutations.map((mutation) => {
	      const blot = this.find(mutation.target, !0);
	      return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [mutation]), blot);
	    }).forEach((blot) => {
	      blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
	    }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
	  }
	};
	_ScrollBlot.blotName = "scroll", _ScrollBlot.defaultChild = BlockBlot$1, _ScrollBlot.allowedChildren = [BlockBlot$1, ContainerBlot$1], _ScrollBlot.scope = Scope.BLOCK_BLOT, _ScrollBlot.tagName = "DIV";
	let ScrollBlot = _ScrollBlot;
	const ScrollBlot$1 = ScrollBlot, _TextBlot = class _TextBlot extends LeafBlot$1 {
	  static create(value) {
	    return document.createTextNode(value);
	  }
	  static value(domNode) {
	    return domNode.data;
	  }
	  constructor(scroll, node) {
	    super(scroll, node), this.text = this.statics.value(this.domNode);
	  }
	  deleteAt(index, length) {
	    this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	  }
	  index(node, offset) {
	    return this.domNode === node ? offset : -1;
	  }
	  insertAt(index, value, def) {
	    def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
	  }
	  length() {
	    return this.text.length;
	  }
	  optimize(context) {
	    super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
	  }
	  position(index, _inclusive = !1) {
	    return [this.domNode, index];
	  }
	  split(index, force = !1) {
	    if (!force) {
	      if (index === 0)
	        return this;
	      if (index === this.length())
	        return this.next;
	    }
	    const after = this.scroll.create(this.domNode.splitText(index));
	    return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
	  }
	  update(mutations, _context) {
	    mutations.some((mutation) => mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
	  }
	  value() {
	    return this.text;
	  }
	};
	_TextBlot.blotName = "text", _TextBlot.scope = Scope.INLINE_BLOT;
	let TextBlot = _TextBlot;
	const TextBlot$1 = TextBlot;

	var Parchment = /*#__PURE__*/Object.freeze({
		__proto__: null,
		Attributor: Attributor,
		AttributorStore: AttributorStore$1,
		BlockBlot: BlockBlot$1,
		ClassAttributor: ClassAttributor$1,
		ContainerBlot: ContainerBlot$1,
		EmbedBlot: EmbedBlot$1,
		InlineBlot: InlineBlot$1,
		LeafBlot: LeafBlot$1,
		ParentBlot: ParentBlot$1,
		Registry: Registry,
		Scope: Scope,
		ScrollBlot: ScrollBlot$1,
		StyleAttributor: StyleAttributor$1,
		TextBlot: TextBlot$1
	});

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	var Delta$1 = {exports: {}};

	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */

	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;

	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
	 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
	  // Check for equality
	  if (text1 === text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }

	  if (cursor_pos != null) {
	    var editdiff = find_cursor_edit_diff(text1, text2, cursor_pos);
	    if (editdiff) {
	      return editdiff;
	    }
	  }

	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);

	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);

	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);

	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs, _fix_unicode);
	  if (cleanup) {
	    diff_cleanupSemantic(diffs);
	  }
	  return diffs;
	}

	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;

	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }

	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }

	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i !== -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [
	      [DIFF_INSERT, longtext.substring(0, i)],
	      [DIFF_EQUAL, shorttext],
	      [DIFF_INSERT, longtext.substring(i + shorttext.length)],
	    ];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }

	  if (shorttext.length === 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [
	      [DIFF_DELETE, text1],
	      [DIFF_INSERT, text2],
	    ];
	  }

	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }

	  return diff_bisect_(text1, text2);
	}

	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = delta % 2 !== 0;
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 === -d || (k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (
	        x1 < text1_length &&
	        y1 < text2_length &&
	        text1.charAt(x1) === text2.charAt(y1)
	      ) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }

	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 === -d || (k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (
	        x2 < text1_length &&
	        y2 < text2_length &&
	        text1.charAt(text1_length - x2 - 1) ===
	          text2.charAt(text2_length - y2 - 1)
	      ) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [
	    [DIFF_DELETE, text1],
	    [DIFF_INSERT, text2],
	  ];
	}

	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);

	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);

	  return diffs.concat(diffsb);
	}

	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (
	      text1.substring(pointerstart, pointermid) ==
	      text2.substring(pointerstart, pointermid)
	    ) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }

	  if (is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) {
	    pointermid--;
	  }

	  return pointermid;
	}

	/**
	 * Determine if the suffix of one string is the prefix of another.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of the first
	 *     string and the start of the second string.
	 * @private
	 */
	function diff_commonOverlap_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  // Eliminate the null case.
	  if (text1_length == 0 || text2_length == 0) {
	    return 0;
	  }
	  // Truncate the longer string.
	  if (text1_length > text2_length) {
	    text1 = text1.substring(text1_length - text2_length);
	  } else if (text1_length < text2_length) {
	    text2 = text2.substring(0, text1_length);
	  }
	  var text_length = Math.min(text1_length, text2_length);
	  // Quick check for the worst case.
	  if (text1 == text2) {
	    return text_length;
	  }

	  // Start by looking for a single character match
	  // and increase length until no match is found.
	  // Performance analysis: http://neil.fraser.name/news/2010/11/04/
	  var best = 0;
	  var length = 1;
	  while (true) {
	    var pattern = text1.substring(text_length - length);
	    var found = text2.indexOf(pattern);
	    if (found == -1) {
	      return best;
	    }
	    length += found;
	    if (
	      found == 0 ||
	      text1.substring(text_length - length) == text2.substring(0, length)
	    ) {
	      best = length;
	      length++;
	    }
	  }
	}

	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (
	      text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	      text2.substring(text2.length - pointermid, text2.length - pointerend)
	    ) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }

	  if (is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) {
	    pointermid--;
	  }

	  return pointermid;
	}

	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null; // Pointless.
	  }

	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = "";
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) !== -1) {
	      var prefixLength = diff_commonPrefix(
	        longtext.substring(i),
	        shorttext.substring(j)
	      );
	      var suffixLength = diff_commonSuffix(
	        longtext.substring(0, i),
	        shorttext.substring(0, j)
	      );
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common =
	          shorttext.substring(j - suffixLength, j) +
	          shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [
	        best_longtext_a,
	        best_longtext_b,
	        best_shorttext_a,
	        best_shorttext_b,
	        best_common,
	      ];
	    } else {
	      return null;
	    }
	  }

	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(
	    longtext,
	    shorttext,
	    Math.ceil(longtext.length / 4)
	  );
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(
	    longtext,
	    shorttext,
	    Math.ceil(longtext.length / 2)
	  );
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }

	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	}

	/**
	 * Reduce the number of edits by eliminating semantically trivial equalities.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	function diff_cleanupSemantic(diffs) {
	  var changes = false;
	  var equalities = []; // Stack of indices where equalities are found.
	  var equalitiesLength = 0; // Keeping our own length var is faster in JS.
	  /** @type {?string} */
	  var lastequality = null;
	  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
	  var pointer = 0; // Index of current position.
	  // Number of characters that changed prior to the equality.
	  var length_insertions1 = 0;
	  var length_deletions1 = 0;
	  // Number of characters that changed after the equality.
	  var length_insertions2 = 0;
	  var length_deletions2 = 0;
	  while (pointer < diffs.length) {
	    if (diffs[pointer][0] == DIFF_EQUAL) {
	      // Equality found.
	      equalities[equalitiesLength++] = pointer;
	      length_insertions1 = length_insertions2;
	      length_deletions1 = length_deletions2;
	      length_insertions2 = 0;
	      length_deletions2 = 0;
	      lastequality = diffs[pointer][1];
	    } else {
	      // An insertion or deletion.
	      if (diffs[pointer][0] == DIFF_INSERT) {
	        length_insertions2 += diffs[pointer][1].length;
	      } else {
	        length_deletions2 += diffs[pointer][1].length;
	      }
	      // Eliminate an equality that is smaller or equal to the edits on both
	      // sides of it.
	      if (
	        lastequality &&
	        lastequality.length <=
	          Math.max(length_insertions1, length_deletions1) &&
	        lastequality.length <= Math.max(length_insertions2, length_deletions2)
	      ) {
	        // Duplicate record.
	        diffs.splice(equalities[equalitiesLength - 1], 0, [
	          DIFF_DELETE,
	          lastequality,
	        ]);
	        // Change second copy to insert.
	        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
	        // Throw away the equality we just deleted.
	        equalitiesLength--;
	        // Throw away the previous equality (it needs to be reevaluated).
	        equalitiesLength--;
	        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
	        length_insertions1 = 0; // Reset the counters.
	        length_deletions1 = 0;
	        length_insertions2 = 0;
	        length_deletions2 = 0;
	        lastequality = null;
	        changes = true;
	      }
	    }
	    pointer++;
	  }

	  // Normalize the diff.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	  diff_cleanupSemanticLossless(diffs);

	  // Find any overlaps between deletions and insertions.
	  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
	  //   -> <del>abc</del>xxx<ins>def</ins>
	  // e.g: <del>xxxabc</del><ins>defxxx</ins>
	  //   -> <ins>def</ins>xxx<del>abc</del>
	  // Only extract an overlap if it is as big as the edit ahead or behind it.
	  pointer = 1;
	  while (pointer < diffs.length) {
	    if (
	      diffs[pointer - 1][0] == DIFF_DELETE &&
	      diffs[pointer][0] == DIFF_INSERT
	    ) {
	      var deletion = diffs[pointer - 1][1];
	      var insertion = diffs[pointer][1];
	      var overlap_length1 = diff_commonOverlap_(deletion, insertion);
	      var overlap_length2 = diff_commonOverlap_(insertion, deletion);
	      if (overlap_length1 >= overlap_length2) {
	        if (
	          overlap_length1 >= deletion.length / 2 ||
	          overlap_length1 >= insertion.length / 2
	        ) {
	          // Overlap found.  Insert an equality and trim the surrounding edits.
	          diffs.splice(pointer, 0, [
	            DIFF_EQUAL,
	            insertion.substring(0, overlap_length1),
	          ]);
	          diffs[pointer - 1][1] = deletion.substring(
	            0,
	            deletion.length - overlap_length1
	          );
	          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
	          pointer++;
	        }
	      } else {
	        if (
	          overlap_length2 >= deletion.length / 2 ||
	          overlap_length2 >= insertion.length / 2
	        ) {
	          // Reverse overlap found.
	          // Insert an equality and swap and trim the surrounding edits.
	          diffs.splice(pointer, 0, [
	            DIFF_EQUAL,
	            deletion.substring(0, overlap_length2),
	          ]);
	          diffs[pointer - 1][0] = DIFF_INSERT;
	          diffs[pointer - 1][1] = insertion.substring(
	            0,
	            insertion.length - overlap_length2
	          );
	          diffs[pointer + 1][0] = DIFF_DELETE;
	          diffs[pointer + 1][1] = deletion.substring(overlap_length2);
	          pointer++;
	        }
	      }
	      pointer++;
	    }
	    pointer++;
	  }
	}

	var nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
	var whitespaceRegex_ = /\s/;
	var linebreakRegex_ = /[\r\n]/;
	var blanklineEndRegex_ = /\n\r?\n$/;
	var blanklineStartRegex_ = /^\r?\n\r?\n/;

	/**
	 * Look for single edits surrounded on both sides by equalities
	 * which can be shifted sideways to align the edit to a word boundary.
	 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
	 */
	function diff_cleanupSemanticLossless(diffs) {
	  /**
	   * Given two strings, compute a score representing whether the internal
	   * boundary falls on logical boundaries.
	   * Scores range from 6 (best) to 0 (worst).
	   * Closure, but does not reference any external variables.
	   * @param {string} one First string.
	   * @param {string} two Second string.
	   * @return {number} The score.
	   * @private
	   */
	  function diff_cleanupSemanticScore_(one, two) {
	    if (!one || !two) {
	      // Edges are the best.
	      return 6;
	    }

	    // Each port of this function behaves slightly differently due to
	    // subtle differences in each language's definition of things like
	    // 'whitespace'.  Since this function's purpose is largely cosmetic,
	    // the choice has been made to use each language's native features
	    // rather than force total conformity.
	    var char1 = one.charAt(one.length - 1);
	    var char2 = two.charAt(0);
	    var nonAlphaNumeric1 = char1.match(nonAlphaNumericRegex_);
	    var nonAlphaNumeric2 = char2.match(nonAlphaNumericRegex_);
	    var whitespace1 = nonAlphaNumeric1 && char1.match(whitespaceRegex_);
	    var whitespace2 = nonAlphaNumeric2 && char2.match(whitespaceRegex_);
	    var lineBreak1 = whitespace1 && char1.match(linebreakRegex_);
	    var lineBreak2 = whitespace2 && char2.match(linebreakRegex_);
	    var blankLine1 = lineBreak1 && one.match(blanklineEndRegex_);
	    var blankLine2 = lineBreak2 && two.match(blanklineStartRegex_);

	    if (blankLine1 || blankLine2) {
	      // Five points for blank lines.
	      return 5;
	    } else if (lineBreak1 || lineBreak2) {
	      // Four points for line breaks.
	      return 4;
	    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
	      // Three points for end of sentences.
	      return 3;
	    } else if (whitespace1 || whitespace2) {
	      // Two points for whitespace.
	      return 2;
	    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
	      // One point for non-alphanumeric.
	      return 1;
	    }
	    return 0;
	  }

	  var pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (
	      diffs[pointer - 1][0] == DIFF_EQUAL &&
	      diffs[pointer + 1][0] == DIFF_EQUAL
	    ) {
	      // This is a single edit surrounded by equalities.
	      var equality1 = diffs[pointer - 1][1];
	      var edit = diffs[pointer][1];
	      var equality2 = diffs[pointer + 1][1];

	      // First, shift the edit as far left as possible.
	      var commonOffset = diff_commonSuffix(equality1, edit);
	      if (commonOffset) {
	        var commonString = edit.substring(edit.length - commonOffset);
	        equality1 = equality1.substring(0, equality1.length - commonOffset);
	        edit = commonString + edit.substring(0, edit.length - commonOffset);
	        equality2 = commonString + equality2;
	      }

	      // Second, step character by character right, looking for the best fit.
	      var bestEquality1 = equality1;
	      var bestEdit = edit;
	      var bestEquality2 = equality2;
	      var bestScore =
	        diff_cleanupSemanticScore_(equality1, edit) +
	        diff_cleanupSemanticScore_(edit, equality2);
	      while (edit.charAt(0) === equality2.charAt(0)) {
	        equality1 += edit.charAt(0);
	        edit = edit.substring(1) + equality2.charAt(0);
	        equality2 = equality2.substring(1);
	        var score =
	          diff_cleanupSemanticScore_(equality1, edit) +
	          diff_cleanupSemanticScore_(edit, equality2);
	        // The >= encourages trailing rather than leading whitespace on edits.
	        if (score >= bestScore) {
	          bestScore = score;
	          bestEquality1 = equality1;
	          bestEdit = edit;
	          bestEquality2 = equality2;
	        }
	      }

	      if (diffs[pointer - 1][1] != bestEquality1) {
	        // We have an improvement, save it back to the diff.
	        if (bestEquality1) {
	          diffs[pointer - 1][1] = bestEquality1;
	        } else {
	          diffs.splice(pointer - 1, 1);
	          pointer--;
	        }
	        diffs[pointer][1] = bestEdit;
	        if (bestEquality2) {
	          diffs[pointer + 1][1] = bestEquality2;
	        } else {
	          diffs.splice(pointer + 1, 1);
	          pointer--;
	        }
	      }
	    }
	    pointer++;
	  }
	}

	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
	 */
	function diff_cleanupMerge(diffs, fix_unicode) {
	  diffs.push([DIFF_EQUAL, ""]); // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = "";
	  var text_insert = "";
	  var commonlength;
	  while (pointer < diffs.length) {
	    if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
	      diffs.splice(pointer, 1);
	      continue;
	    }
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        var previous_equality = pointer - count_insert - count_delete - 1;
	        if (fix_unicode) {
	          // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
	          // we assume that the old and new text in the diff are complete and correct
	          // unicode-encoded JS strings, but the tuple boundaries may fall between
	          // surrogate pairs.  we fix this by shaving off stray surrogates from the end
	          // of the previous equality and the beginning of this equality.  this may create
	          // empty equalities or a common prefix or suffix.  for example, if AB and AC are
	          // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
	          // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
	          // particular case, both equalities go away, we absorb any previous inequalities,
	          // and we keep scanning for the next equality before rewriting the tuples.
	          if (
	            previous_equality >= 0 &&
	            ends_with_pair_start(diffs[previous_equality][1])
	          ) {
	            var stray = diffs[previous_equality][1].slice(-1);
	            diffs[previous_equality][1] = diffs[previous_equality][1].slice(
	              0,
	              -1
	            );
	            text_delete = stray + text_delete;
	            text_insert = stray + text_insert;
	            if (!diffs[previous_equality][1]) {
	              // emptied out previous equality, so delete it and include previous delete/insert
	              diffs.splice(previous_equality, 1);
	              pointer--;
	              var k = previous_equality - 1;
	              if (diffs[k] && diffs[k][0] === DIFF_INSERT) {
	                count_insert++;
	                text_insert = diffs[k][1] + text_insert;
	                k--;
	              }
	              if (diffs[k] && diffs[k][0] === DIFF_DELETE) {
	                count_delete++;
	                text_delete = diffs[k][1] + text_delete;
	                k--;
	              }
	              previous_equality = k;
	            }
	          }
	          if (starts_with_pair_end(diffs[pointer][1])) {
	            var stray = diffs[pointer][1].charAt(0);
	            diffs[pointer][1] = diffs[pointer][1].slice(1);
	            text_delete += stray;
	            text_insert += stray;
	          }
	        }
	        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
	          // for empty equality not at end, wait for next equality
	          diffs.splice(pointer, 1);
	          break;
	        }
	        if (text_delete.length > 0 || text_insert.length > 0) {
	          // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
	          if (text_delete.length > 0 && text_insert.length > 0) {
	            // Factor out any common prefixes.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if (previous_equality >= 0) {
	                diffs[previous_equality][1] += text_insert.substring(
	                  0,
	                  commonlength
	                );
	              } else {
	                diffs.splice(0, 0, [
	                  DIFF_EQUAL,
	                  text_insert.substring(0, commonlength),
	                ]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixes.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] =
	                text_insert.substring(text_insert.length - commonlength) +
	                diffs[pointer][1];
	              text_insert = text_insert.substring(
	                0,
	                text_insert.length - commonlength
	              );
	              text_delete = text_delete.substring(
	                0,
	                text_delete.length - commonlength
	              );
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          var n = count_insert + count_delete;
	          if (text_delete.length === 0 && text_insert.length === 0) {
	            diffs.splice(pointer - n, n);
	            pointer = pointer - n;
	          } else if (text_delete.length === 0) {
	            diffs.splice(pointer - n, n, [DIFF_INSERT, text_insert]);
	            pointer = pointer - n + 1;
	          } else if (text_insert.length === 0) {
	            diffs.splice(pointer - n, n, [DIFF_DELETE, text_delete]);
	            pointer = pointer - n + 1;
	          } else {
	            diffs.splice(
	              pointer - n,
	              n,
	              [DIFF_DELETE, text_delete],
	              [DIFF_INSERT, text_insert]
	            );
	            pointer = pointer - n + 2;
	          }
	        }
	        if (pointer !== 0 && diffs[pointer - 1][0] === DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = "";
	        text_insert = "";
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === "") {
	    diffs.pop(); // Remove the dummy entry at the end.
	  }

	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (
	      diffs[pointer - 1][0] === DIFF_EQUAL &&
	      diffs[pointer + 1][0] === DIFF_EQUAL
	    ) {
	      // This is a single edit surrounded by equalities.
	      if (
	        diffs[pointer][1].substring(
	          diffs[pointer][1].length - diffs[pointer - 1][1].length
	        ) === diffs[pointer - 1][1]
	      ) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] =
	          diffs[pointer - 1][1] +
	          diffs[pointer][1].substring(
	            0,
	            diffs[pointer][1].length - diffs[pointer - 1][1].length
	          );
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (
	        diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	        diffs[pointer + 1][1]
	      ) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	          diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	          diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs, fix_unicode);
	  }
	}

	function is_surrogate_pair_start(charCode) {
	  return charCode >= 0xd800 && charCode <= 0xdbff;
	}

	function is_surrogate_pair_end(charCode) {
	  return charCode >= 0xdc00 && charCode <= 0xdfff;
	}

	function starts_with_pair_end(str) {
	  return is_surrogate_pair_end(str.charCodeAt(0));
	}

	function ends_with_pair_start(str) {
	  return is_surrogate_pair_start(str.charCodeAt(str.length - 1));
	}

	function remove_empty_tuples(tuples) {
	  var ret = [];
	  for (var i = 0; i < tuples.length; i++) {
	    if (tuples[i][1].length > 0) {
	      ret.push(tuples[i]);
	    }
	  }
	  return ret;
	}

	function make_edit_splice(before, oldMiddle, newMiddle, after) {
	  if (ends_with_pair_start(before) || starts_with_pair_end(after)) {
	    return null;
	  }
	  return remove_empty_tuples([
	    [DIFF_EQUAL, before],
	    [DIFF_DELETE, oldMiddle],
	    [DIFF_INSERT, newMiddle],
	    [DIFF_EQUAL, after],
	  ]);
	}

	function find_cursor_edit_diff(oldText, newText, cursor_pos) {
	  // note: this runs after equality check has ruled out exact equality
	  var oldRange =
	    typeof cursor_pos === "number"
	      ? { index: cursor_pos, length: 0 }
	      : cursor_pos.oldRange;
	  var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
	  // take into account the old and new selection to generate the best diff
	  // possible for a text edit.  for example, a text change from "xxx" to "xx"
	  // could be a delete or forwards-delete of any one of the x's, or the
	  // result of selecting two of the x's and typing "x".
	  var oldLength = oldText.length;
	  var newLength = newText.length;
	  if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
	    // see if we have an insert or delete before or after cursor
	    var oldCursor = oldRange.index;
	    var oldBefore = oldText.slice(0, oldCursor);
	    var oldAfter = oldText.slice(oldCursor);
	    var maybeNewCursor = newRange ? newRange.index : null;
	    editBefore: {
	      // is this an insert or delete right before oldCursor?
	      var newCursor = oldCursor + newLength - oldLength;
	      if (maybeNewCursor !== null && maybeNewCursor !== newCursor) {
	        break editBefore;
	      }
	      if (newCursor < 0 || newCursor > newLength) {
	        break editBefore;
	      }
	      var newBefore = newText.slice(0, newCursor);
	      var newAfter = newText.slice(newCursor);
	      if (newAfter !== oldAfter) {
	        break editBefore;
	      }
	      var prefixLength = Math.min(oldCursor, newCursor);
	      var oldPrefix = oldBefore.slice(0, prefixLength);
	      var newPrefix = newBefore.slice(0, prefixLength);
	      if (oldPrefix !== newPrefix) {
	        break editBefore;
	      }
	      var oldMiddle = oldBefore.slice(prefixLength);
	      var newMiddle = newBefore.slice(prefixLength);
	      return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
	    }
	    editAfter: {
	      // is this an insert or delete right after oldCursor?
	      if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) {
	        break editAfter;
	      }
	      var cursor = oldCursor;
	      var newBefore = newText.slice(0, cursor);
	      var newAfter = newText.slice(cursor);
	      if (newBefore !== oldBefore) {
	        break editAfter;
	      }
	      var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
	      var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
	      var newSuffix = newAfter.slice(newAfter.length - suffixLength);
	      if (oldSuffix !== newSuffix) {
	        break editAfter;
	      }
	      var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
	      var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
	      return make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
	    }
	  }
	  if (oldRange.length > 0 && newRange && newRange.length === 0) {
	    replaceRange: {
	      // see if diff could be a splice of the old selection range
	      var oldPrefix = oldText.slice(0, oldRange.index);
	      var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
	      var prefixLength = oldPrefix.length;
	      var suffixLength = oldSuffix.length;
	      if (newLength < prefixLength + suffixLength) {
	        break replaceRange;
	      }
	      var newPrefix = newText.slice(0, prefixLength);
	      var newSuffix = newText.slice(newLength - suffixLength);
	      if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) {
	        break replaceRange;
	      }
	      var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
	      var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
	      return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
	    }
	  }

	  return null;
	}

	function diff(text1, text2, cursor_pos, cleanup) {
	  // only pass fix_unicode=true at the top level, not when diff_main is
	  // recursively invoked
	  return diff_main(text1, text2, cursor_pos, cleanup, true);
	}

	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;

	var diff_1 = diff;

	var lodash_clonedeep = {exports: {}};

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	lodash_clonedeep.exports;

	(function (module, exports) {
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;

		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';

		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;

		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    weakMapTag = '[object WeakMap]';

		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';

		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

		/** Used to match `RegExp` flags from their coerced string values. */
		var reFlags = /\w*$/;

		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;

		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;

		/** Used to identify `toStringTag` values supported by `_.clone`. */
		var cloneableTags = {};
		cloneableTags[argsTag] = cloneableTags[arrayTag] =
		cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
		cloneableTags[boolTag] = cloneableTags[dateTag] =
		cloneableTags[float32Tag] = cloneableTags[float64Tag] =
		cloneableTags[int8Tag] = cloneableTags[int16Tag] =
		cloneableTags[int32Tag] = cloneableTags[mapTag] =
		cloneableTags[numberTag] = cloneableTags[objectTag] =
		cloneableTags[regexpTag] = cloneableTags[setTag] =
		cloneableTags[stringTag] = cloneableTags[symbolTag] =
		cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
		cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
		cloneableTags[errorTag] = cloneableTags[funcTag] =
		cloneableTags[weakMapTag] = false;

		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/**
		 * Adds the key-value `pair` to `map`.
		 *
		 * @private
		 * @param {Object} map The map to modify.
		 * @param {Array} pair The key-value pair to add.
		 * @returns {Object} Returns `map`.
		 */
		function addMapEntry(map, pair) {
		  // Don't return `map.set` because it's not chainable in IE 11.
		  map.set(pair[0], pair[1]);
		  return map;
		}

		/**
		 * Adds `value` to `set`.
		 *
		 * @private
		 * @param {Object} set The set to modify.
		 * @param {*} value The value to add.
		 * @returns {Object} Returns `set`.
		 */
		function addSetEntry(set, value) {
		  // Don't return `set.add` because it's not chainable in IE 11.
		  set.add(value);
		  return set;
		}

		/**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */
		function arrayEach(array, iteratee) {
		  var index = -1,
		      length = array ? array.length : 0;

		  while (++index < length) {
		    if (iteratee(array[index], index, array) === false) {
		      break;
		    }
		  }
		  return array;
		}

		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;

		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}

		/**
		 * A specialized version of `_.reduce` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {*} [accumulator] The initial value.
		 * @param {boolean} [initAccum] Specify using the first element of `array` as
		 *  the initial value.
		 * @returns {*} Returns the accumulated value.
		 */
		function arrayReduce(array, iteratee, accumulator, initAccum) {
		  var index = -1,
		      length = array ? array.length : 0;

		  if (initAccum && length) {
		    accumulator = array[++index];
		  }
		  while (++index < length) {
		    accumulator = iteratee(accumulator, array[index], index, array);
		  }
		  return accumulator;
		}

		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);

		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}

		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}

		/**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */
		function isHostObject(value) {
		  // Many host objects are `Object` objects that can coerce to strings
		  // despite having improperly defined `toString` methods.
		  var result = false;
		  if (value != null && typeof value.toString != 'function') {
		    try {
		      result = !!(value + '');
		    } catch (e) {}
		  }
		  return result;
		}

		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);

		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}

		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}

		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);

		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}

		/** Used for built-in method references. */
		var arrayProto = Array.prototype,
		    funcProto = Function.prototype,
		    objectProto = Object.prototype;

		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];

		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());

		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;

		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;

		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;

		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);

		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    Symbol = root.Symbol,
		    Uint8Array = root.Uint8Array,
		    getPrototype = overArg(Object.getPrototypeOf, Object),
		    objectCreate = Object.create,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
		    splice = arrayProto.splice;

		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols,
		    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
		    nativeKeys = overArg(Object.keys, Object);

		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView'),
		    Map = getNative(root, 'Map'),
		    Promise = getNative(root, 'Promise'),
		    Set = getNative(root, 'Set'),
		    WeakMap = getNative(root, 'WeakMap'),
		    nativeCreate = getNative(Object, 'create');

		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);

		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		}

		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  return this.has(key) && delete this.__data__[key];
		}

		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}

		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
		}

		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}

		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;

		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		}

		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  return true;
		}

		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  return index < 0 ? undefined : data[index][1];
		}

		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}

		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}

		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;

		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}

		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  return getMapData(this, key)['delete'](key);
		}

		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}

		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}

		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  getMapData(this, key).set(key, value);
		  return this;
		}

		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;

		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  this.__data__ = new ListCache(entries);
		}

		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		}

		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  return this.__data__['delete'](key);
		}

		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}

		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}

		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var cache = this.__data__;
		  if (cache instanceof ListCache) {
		    var pairs = cache.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      return this;
		    }
		    cache = this.__data__ = new MapCache(pairs);
		  }
		  cache.set(key, value);
		  return this;
		}

		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;

		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
		  // Safari 9 makes `arguments.length` enumerable in strict mode.
		  var result = (isArray(value) || isArguments(value))
		    ? baseTimes(value.length, String)
		    : [];

		  var length = result.length,
		      skipIndexes = !!length;

		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignValue(object, key, value) {
		  var objValue = object[key];
		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
		      (value === undefined && !(key in object))) {
		    object[key] = value;
		  }
		}

		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}

		/**
		 * The base implementation of `_.assign` without support for multiple sources
		 * or `customizer` functions.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @returns {Object} Returns `object`.
		 */
		function baseAssign(object, source) {
		  return object && copyObject(source, keys(source), object);
		}

		/**
		 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
		 * traversed objects.
		 *
		 * @private
		 * @param {*} value The value to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @param {boolean} [isFull] Specify a clone including symbols.
		 * @param {Function} [customizer] The function to customize cloning.
		 * @param {string} [key] The key of `value`.
		 * @param {Object} [object] The parent object of `value`.
		 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
		 * @returns {*} Returns the cloned value.
		 */
		function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
		  var result;
		  if (customizer) {
		    result = object ? customizer(value, key, object, stack) : customizer(value);
		  }
		  if (result !== undefined) {
		    return result;
		  }
		  if (!isObject(value)) {
		    return value;
		  }
		  var isArr = isArray(value);
		  if (isArr) {
		    result = initCloneArray(value);
		    if (!isDeep) {
		      return copyArray(value, result);
		    }
		  } else {
		    var tag = getTag(value),
		        isFunc = tag == funcTag || tag == genTag;

		    if (isBuffer(value)) {
		      return cloneBuffer(value, isDeep);
		    }
		    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
		      if (isHostObject(value)) {
		        return object ? value : {};
		      }
		      result = initCloneObject(isFunc ? {} : value);
		      if (!isDeep) {
		        return copySymbols(value, baseAssign(result, value));
		      }
		    } else {
		      if (!cloneableTags[tag]) {
		        return object ? value : {};
		      }
		      result = initCloneByTag(value, tag, baseClone, isDeep);
		    }
		  }
		  // Check for circular references and return its corresponding clone.
		  stack || (stack = new Stack);
		  var stacked = stack.get(value);
		  if (stacked) {
		    return stacked;
		  }
		  stack.set(value, result);

		  if (!isArr) {
		    var props = isFull ? getAllKeys(value) : keys(value);
		  }
		  arrayEach(props || value, function(subValue, key) {
		    if (props) {
		      key = subValue;
		      subValue = value[key];
		    }
		    // Recursively populate clone (susceptible to call stack limits).
		    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
		  });
		  return result;
		}

		/**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} prototype The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */
		function baseCreate(proto) {
		  return isObject(proto) ? objectCreate(proto) : {};
		}

		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}

		/**
		 * The base implementation of `getTag`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  return objectToString.call(value);
		}

		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}

		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * Creates a clone of  `buffer`.
		 *
		 * @private
		 * @param {Buffer} buffer The buffer to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Buffer} Returns the cloned buffer.
		 */
		function cloneBuffer(buffer, isDeep) {
		  if (isDeep) {
		    return buffer.slice();
		  }
		  var result = new buffer.constructor(buffer.length);
		  buffer.copy(result);
		  return result;
		}

		/**
		 * Creates a clone of `arrayBuffer`.
		 *
		 * @private
		 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
		 * @returns {ArrayBuffer} Returns the cloned array buffer.
		 */
		function cloneArrayBuffer(arrayBuffer) {
		  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
		  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
		  return result;
		}

		/**
		 * Creates a clone of `dataView`.
		 *
		 * @private
		 * @param {Object} dataView The data view to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned data view.
		 */
		function cloneDataView(dataView, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
		  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
		}

		/**
		 * Creates a clone of `map`.
		 *
		 * @private
		 * @param {Object} map The map to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned map.
		 */
		function cloneMap(map, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
		  return arrayReduce(array, addMapEntry, new map.constructor);
		}

		/**
		 * Creates a clone of `regexp`.
		 *
		 * @private
		 * @param {Object} regexp The regexp to clone.
		 * @returns {Object} Returns the cloned regexp.
		 */
		function cloneRegExp(regexp) {
		  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
		  result.lastIndex = regexp.lastIndex;
		  return result;
		}

		/**
		 * Creates a clone of `set`.
		 *
		 * @private
		 * @param {Object} set The set to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned set.
		 */
		function cloneSet(set, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
		  return arrayReduce(array, addSetEntry, new set.constructor);
		}

		/**
		 * Creates a clone of the `symbol` object.
		 *
		 * @private
		 * @param {Object} symbol The symbol object to clone.
		 * @returns {Object} Returns the cloned symbol object.
		 */
		function cloneSymbol(symbol) {
		  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
		}

		/**
		 * Creates a clone of `typedArray`.
		 *
		 * @private
		 * @param {Object} typedArray The typed array to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned typed array.
		 */
		function cloneTypedArray(typedArray, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
		  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
		}

		/**
		 * Copies the values of `source` to `array`.
		 *
		 * @private
		 * @param {Array} source The array to copy values from.
		 * @param {Array} [array=[]] The array to copy values to.
		 * @returns {Array} Returns `array`.
		 */
		function copyArray(source, array) {
		  var index = -1,
		      length = source.length;

		  array || (array = Array(length));
		  while (++index < length) {
		    array[index] = source[index];
		  }
		  return array;
		}

		/**
		 * Copies properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy properties from.
		 * @param {Array} props The property identifiers to copy.
		 * @param {Object} [object={}] The object to copy properties to.
		 * @param {Function} [customizer] The function to customize copied values.
		 * @returns {Object} Returns `object`.
		 */
		function copyObject(source, props, object, customizer) {
		  object || (object = {});

		  var index = -1,
		      length = props.length;

		  while (++index < length) {
		    var key = props[index];

		    var newValue = customizer
		      ? customizer(object[key], source[key], key, object, source)
		      : undefined;

		    assignValue(object, key, newValue === undefined ? source[key] : newValue);
		  }
		  return object;
		}

		/**
		 * Copies own symbol properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy symbols from.
		 * @param {Object} [object={}] The object to copy symbols to.
		 * @returns {Object} Returns `object`.
		 */
		function copySymbols(source, object) {
		  return copyObject(source, getSymbols(source), object);
		}

		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}

		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}

		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}

		/**
		 * Creates an array of the own enumerable symbol properties of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;

		// Fallback for data views, maps, sets, and weak maps in IE 11,
		// for data views in Edge < 14, and promises in Node.js.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = objectToString.call(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : undefined;

		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}

		/**
		 * Initializes an array clone.
		 *
		 * @private
		 * @param {Array} array The array to clone.
		 * @returns {Array} Returns the initialized clone.
		 */
		function initCloneArray(array) {
		  var length = array.length,
		      result = array.constructor(length);

		  // Add properties assigned by `RegExp#exec`.
		  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
		    result.index = array.index;
		    result.input = array.input;
		  }
		  return result;
		}

		/**
		 * Initializes an object clone.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneObject(object) {
		  return (typeof object.constructor == 'function' && !isPrototype(object))
		    ? baseCreate(getPrototype(object))
		    : {};
		}

		/**
		 * Initializes an object clone based on its `toStringTag`.
		 *
		 * **Note:** This function only supports cloning values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @param {string} tag The `toStringTag` of the object to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneByTag(object, tag, cloneFunc, isDeep) {
		  var Ctor = object.constructor;
		  switch (tag) {
		    case arrayBufferTag:
		      return cloneArrayBuffer(object);

		    case boolTag:
		    case dateTag:
		      return new Ctor(+object);

		    case dataViewTag:
		      return cloneDataView(object, isDeep);

		    case float32Tag: case float64Tag:
		    case int8Tag: case int16Tag: case int32Tag:
		    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
		      return cloneTypedArray(object, isDeep);

		    case mapTag:
		      return cloneMap(object, isDeep, cloneFunc);

		    case numberTag:
		    case stringTag:
		      return new Ctor(object);

		    case regexpTag:
		      return cloneRegExp(object);

		    case setTag:
		      return cloneSet(object, isDeep, cloneFunc);

		    case symbolTag:
		      return cloneSymbol(object);
		  }
		}

		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}

		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}

		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}

		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

		  return value === proto;
		}

		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}

		/**
		 * This method is like `_.clone` except that it recursively clones `value`.
		 *
		 * @static
		 * @memberOf _
		 * @since 1.0.0
		 * @category Lang
		 * @param {*} value The value to recursively clone.
		 * @returns {*} Returns the deep cloned value.
		 * @see _.clone
		 * @example
		 *
		 * var objects = [{ 'a': 1 }, { 'b': 2 }];
		 *
		 * var deep = _.cloneDeep(objects);
		 * console.log(deep[0] === objects[0]);
		 * // => false
		 */
		function cloneDeep(value) {
		  return baseClone(value, true, true);
		}

		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}

		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		function isArguments(value) {
		  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
		  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
		    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
		}

		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;

		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}

		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}

		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;

		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 8-9 which returns 'object' for typed array and other constructors.
		  var tag = isObject(value) ? objectToString.call(value) : '';
		  return tag == funcTag || tag == genTag;
		}

		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}

		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}

		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return !!value && typeof value == 'object';
		}

		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}

		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}

		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}

		module.exports = cloneDeep; 
	} (lodash_clonedeep, lodash_clonedeep.exports));

	var lodash_clonedeepExports = lodash_clonedeep.exports;

	var lodash_isequal = {exports: {}};

	/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	lodash_isequal.exports;

	(function (module, exports) {
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;

		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';

		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;

		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;

		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    asyncTag = '[object AsyncFunction]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    nullTag = '[object Null]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    proxyTag = '[object Proxy]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    undefinedTag = '[object Undefined]',
		    weakMapTag = '[object WeakMap]';

		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';

		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;

		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;

		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;

		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;

		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());

		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

		/**
		 * A specialized version of `_.filter` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {Array} Returns the new filtered array.
		 */
		function arrayFilter(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      resIndex = 0,
		      result = [];

		  while (++index < length) {
		    var value = array[index];
		    if (predicate(value, index, array)) {
		      result[resIndex++] = value;
		    }
		  }
		  return result;
		}

		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;

		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}

		/**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length;

		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}

		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);

		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}

		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}

		/**
		 * Checks if a `cache` value for `key` exists.
		 *
		 * @private
		 * @param {Object} cache The cache to query.
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function cacheHas(cache, key) {
		  return cache.has(key);
		}

		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}

		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);

		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}

		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}

		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);

		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}

		/** Used for built-in method references. */
		var arrayProto = Array.prototype,
		    funcProto = Function.prototype,
		    objectProto = Object.prototype;

		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];

		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;

		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;

		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());

		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;

		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);

		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    Symbol = root.Symbol,
		    Uint8Array = root.Uint8Array,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
		    splice = arrayProto.splice,
		    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols,
		    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
		    nativeKeys = overArg(Object.keys, Object);

		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView'),
		    Map = getNative(root, 'Map'),
		    Promise = getNative(root, 'Promise'),
		    Set = getNative(root, 'Set'),
		    WeakMap = getNative(root, 'WeakMap'),
		    nativeCreate = getNative(Object, 'create');

		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);

		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  var result = this.has(key) && delete this.__data__[key];
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}

		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
		}

		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  this.size += this.has(key) ? 0 : 1;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}

		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;

		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  --this.size;
		  return true;
		}

		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  return index < 0 ? undefined : data[index][1];
		}

		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}

		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    ++this.size;
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}

		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;

		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.size = 0;
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}

		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  var result = getMapData(this, key)['delete'](key);
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}

		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}

		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  var data = getMapData(this, key),
		      size = data.size;

		  data.set(key, value);
		  this.size += data.size == size ? 0 : 1;
		  return this;
		}

		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;

		/**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */
		function SetCache(values) {
		  var index = -1,
		      length = values == null ? 0 : values.length;

		  this.__data__ = new MapCache;
		  while (++index < length) {
		    this.add(values[index]);
		  }
		}

		/**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */
		function setCacheAdd(value) {
		  this.__data__.set(value, HASH_UNDEFINED);
		  return this;
		}

		/**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */
		function setCacheHas(value) {
		  return this.__data__.has(value);
		}

		// Add methods to `SetCache`.
		SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
		SetCache.prototype.has = setCacheHas;

		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  var data = this.__data__ = new ListCache(entries);
		  this.size = data.size;
		}

		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  var data = this.__data__,
		      result = data['delete'](key);

		  this.size = data.size;
		  return result;
		}

		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}

		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}

		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var data = this.__data__;
		  if (data instanceof ListCache) {
		    var pairs = data.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      this.size = ++data.size;
		      return this;
		    }
		    data = this.__data__ = new MapCache(pairs);
		  }
		  data.set(key, value);
		  this.size = data.size;
		  return this;
		}

		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;

		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  var isArr = isArray(value),
		      isArg = !isArr && isArguments(value),
		      isBuff = !isArr && !isArg && isBuffer(value),
		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
		      skipIndexes = isArr || isArg || isBuff || isType,
		      result = skipIndexes ? baseTimes(value.length, String) : [],
		      length = result.length;

		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (
		           // Safari 9 has enumerable `arguments.length` in strict mode.
		           key == 'length' ||
		           // Node.js 0.10 has enumerable non-index properties on buffers.
		           (isBuff && (key == 'offset' || key == 'parent')) ||
		           // PhantomJS 2 has enumerable non-index properties on typed arrays.
		           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
		           // Skip index properties.
		           isIndex(key, length)
		        ))) {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}

		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}

		/**
		 * The base implementation of `getTag` without fallbacks for buggy environments.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  if (value == null) {
		    return value === undefined ? undefinedTag : nullTag;
		  }
		  return (symToStringTag && symToStringTag in Object(value))
		    ? getRawTag(value)
		    : objectToString(value);
		}

		/**
		 * The base implementation of `_.isArguments`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 */
		function baseIsArguments(value) {
		  return isObjectLike(value) && baseGetTag(value) == argsTag;
		}

		/**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {boolean} bitmask The bitmask flags.
		 *  1 - Unordered comparison
		 *  2 - Partial comparison
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, bitmask, customizer, stack) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
		}

		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = objIsArr ? arrayTag : getTag(object),
		      othTag = othIsArr ? arrayTag : getTag(other);

		  objTag = objTag == argsTag ? objectTag : objTag;
		  othTag = othTag == argsTag ? objectTag : othTag;

		  var objIsObj = objTag == objectTag,
		      othIsObj = othTag == objectTag,
		      isSameTag = objTag == othTag;

		  if (isSameTag && isBuffer(object)) {
		    if (!isBuffer(other)) {
		      return false;
		    }
		    objIsArr = true;
		    objIsObj = false;
		  }
		  if (isSameTag && !objIsObj) {
		    stack || (stack = new Stack);
		    return (objIsArr || isTypedArray(object))
		      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
		      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
		  }
		  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

		    if (objIsWrapped || othIsWrapped) {
		      var objUnwrapped = objIsWrapped ? object.value() : object,
		          othUnwrapped = othIsWrapped ? other.value() : other;

		      stack || (stack = new Stack);
		      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  stack || (stack = new Stack);
		  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
		}

		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}

		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
		}

		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      arrLength = array.length,
		      othLength = other.length;

		  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(array);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var index = -1,
		      result = true,
		      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

		  stack.set(array, other);
		  stack.set(other, array);

		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index];

		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, arrValue, index, other, array, stack)
		        : customizer(arrValue, othValue, index, array, other, stack);
		    }
		    if (compared !== undefined) {
		      if (compared) {
		        continue;
		      }
		      result = false;
		      break;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (seen) {
		      if (!arraySome(other, function(othValue, othIndex) {
		            if (!cacheHas(seen, othIndex) &&
		                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
		              return seen.push(othIndex);
		            }
		          })) {
		        result = false;
		        break;
		      }
		    } else if (!(
		          arrValue === othValue ||
		            equalFunc(arrValue, othValue, bitmask, customizer, stack)
		        )) {
		      result = false;
		      break;
		    }
		  }
		  stack['delete'](array);
		  stack['delete'](other);
		  return result;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
		  switch (tag) {
		    case dataViewTag:
		      if ((object.byteLength != other.byteLength) ||
		          (object.byteOffset != other.byteOffset)) {
		        return false;
		      }
		      object = object.buffer;
		      other = other.buffer;

		    case arrayBufferTag:
		      if ((object.byteLength != other.byteLength) ||
		          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
		        return false;
		      }
		      return true;

		    case boolTag:
		    case dateTag:
		    case numberTag:
		      // Coerce booleans to `1` or `0` and dates to milliseconds.
		      // Invalid dates are coerced to `NaN`.
		      return eq(+object, +other);

		    case errorTag:
		      return object.name == other.name && object.message == other.message;

		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings, primitives and objects,
		      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
		      // for more details.
		      return object == (other + '');

		    case mapTag:
		      var convert = mapToArray;

		    case setTag:
		      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
		      convert || (convert = setToArray);

		      if (object.size != other.size && !isPartial) {
		        return false;
		      }
		      // Assume cyclic values are equal.
		      var stacked = stack.get(object);
		      if (stacked) {
		        return stacked == other;
		      }
		      bitmask |= COMPARE_UNORDERED_FLAG;

		      // Recursively compare objects (susceptible to call stack limits).
		      stack.set(object, other);
		      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
		      stack['delete'](object);
		      return result;

		    case symbolTag:
		      if (symbolValueOf) {
		        return symbolValueOf.call(object) == symbolValueOf.call(other);
		      }
		  }
		  return false;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      objProps = getAllKeys(object),
		      objLength = objProps.length,
		      othProps = getAllKeys(other),
		      othLength = othProps.length;

		  if (objLength != othLength && !isPartial) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
		      return false;
		    }
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(object);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var result = true;
		  stack.set(object, other);
		  stack.set(other, object);

		  var skipCtor = isPartial;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key];

		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, objValue, key, other, object, stack)
		        : customizer(objValue, othValue, key, object, other, stack);
		    }
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(compared === undefined
		          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
		          : compared
		        )) {
		      result = false;
		      break;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (result && !skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;

		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor &&
		        ('constructor' in object && 'constructor' in other) &&
		        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
		          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      result = false;
		    }
		  }
		  stack['delete'](object);
		  stack['delete'](other);
		  return result;
		}

		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}

		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}

		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}

		/**
		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the raw `toStringTag`.
		 */
		function getRawTag(value) {
		  var isOwn = hasOwnProperty.call(value, symToStringTag),
		      tag = value[symToStringTag];

		  try {
		    value[symToStringTag] = undefined;
		    var unmasked = true;
		  } catch (e) {}

		  var result = nativeObjectToString.call(value);
		  if (unmasked) {
		    if (isOwn) {
		      value[symToStringTag] = tag;
		    } else {
		      delete value[symToStringTag];
		    }
		  }
		  return result;
		}

		/**
		 * Creates an array of the own enumerable symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
		  if (object == null) {
		    return [];
		  }
		  object = Object(object);
		  return arrayFilter(nativeGetSymbols(object), function(symbol) {
		    return propertyIsEnumerable.call(object, symbol);
		  });
		};

		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;

		// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = baseGetTag(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : '';

		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}

		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}

		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}

		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}

		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

		  return value === proto;
		}

		/**
		 * Converts `value` to a string using `Object.prototype.toString`.
		 *
		 * @private
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 */
		function objectToString(value) {
		  return nativeObjectToString.call(value);
		}

		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to convert.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}

		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}

		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
		  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
		    !propertyIsEnumerable.call(value, 'callee');
		};

		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;

		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}

		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;

		/**
		 * Performs a deep comparison between two values to determine if they are
		 * equivalent.
		 *
		 * **Note:** This method supports comparing arrays, array buffers, booleans,
		 * date objects, error objects, maps, numbers, `Object` objects, regexes,
		 * sets, strings, symbols, and typed arrays. `Object` objects are compared
		 * by their own, not inherited, enumerable properties. Functions and DOM
		 * nodes are compared by strict equality, i.e. `===`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.isEqual(object, other);
		 * // => true
		 *
		 * object === other;
		 * // => false
		 */
		function isEqual(value, other) {
		  return baseIsEqual(value, other);
		}

		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  if (!isObject(value)) {
		    return false;
		  }
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 9 which returns 'object' for typed arrays and other constructors.
		  var tag = baseGetTag(value);
		  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
		}

		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}

		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return value != null && (type == 'object' || type == 'function');
		}

		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return value != null && typeof value == 'object';
		}

		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}

		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}

		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}

		module.exports = isEqual; 
	} (lodash_isequal, lodash_isequal.exports));

	var lodash_isequalExports = lodash_isequal.exports;

	var AttributeMap$1 = {};

	Object.defineProperty(AttributeMap$1, "__esModule", { value: true });
	const cloneDeep = lodash_clonedeepExports;
	const isEqual = lodash_isequalExports;
	var AttributeMap;
	(function (AttributeMap) {
	    function compose(a = {}, b = {}, keepNull = false) {
	        if (typeof a !== 'object') {
	            a = {};
	        }
	        if (typeof b !== 'object') {
	            b = {};
	        }
	        let attributes = cloneDeep(b);
	        if (!keepNull) {
	            attributes = Object.keys(attributes).reduce((copy, key) => {
	                if (attributes[key] != null) {
	                    copy[key] = attributes[key];
	                }
	                return copy;
	            }, {});
	        }
	        for (const key in a) {
	            if (a[key] !== undefined && b[key] === undefined) {
	                attributes[key] = a[key];
	            }
	        }
	        return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	    AttributeMap.compose = compose;
	    function diff(a = {}, b = {}) {
	        if (typeof a !== 'object') {
	            a = {};
	        }
	        if (typeof b !== 'object') {
	            b = {};
	        }
	        const attributes = Object.keys(a)
	            .concat(Object.keys(b))
	            .reduce((attrs, key) => {
	            if (!isEqual(a[key], b[key])) {
	                attrs[key] = b[key] === undefined ? null : b[key];
	            }
	            return attrs;
	        }, {});
	        return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	    AttributeMap.diff = diff;
	    function invert(attr = {}, base = {}) {
	        attr = attr || {};
	        const baseInverted = Object.keys(base).reduce((memo, key) => {
	            if (base[key] !== attr[key] && attr[key] !== undefined) {
	                memo[key] = base[key];
	            }
	            return memo;
	        }, {});
	        return Object.keys(attr).reduce((memo, key) => {
	            if (attr[key] !== base[key] && base[key] === undefined) {
	                memo[key] = null;
	            }
	            return memo;
	        }, baseInverted);
	    }
	    AttributeMap.invert = invert;
	    function transform(a, b, priority = false) {
	        if (typeof a !== 'object') {
	            return b;
	        }
	        if (typeof b !== 'object') {
	            return undefined;
	        }
	        if (!priority) {
	            return b; // b simply overwrites us without priority
	        }
	        const attributes = Object.keys(b).reduce((attrs, key) => {
	            if (a[key] === undefined) {
	                attrs[key] = b[key]; // null is a valid value
	            }
	            return attrs;
	        }, {});
	        return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	    AttributeMap.transform = transform;
	})(AttributeMap || (AttributeMap = {}));
	AttributeMap$1.default = AttributeMap;

	var Op$1 = {};

	Object.defineProperty(Op$1, "__esModule", { value: true });
	var Op;
	(function (Op) {
	    function length(op) {
	        if (typeof op.delete === 'number') {
	            return op.delete;
	        }
	        else if (typeof op.retain === 'number') {
	            return op.retain;
	        }
	        else if (typeof op.retain === 'object' && op.retain !== null) {
	            return 1;
	        }
	        else {
	            return typeof op.insert === 'string' ? op.insert.length : 1;
	        }
	    }
	    Op.length = length;
	})(Op || (Op = {}));
	Op$1.default = Op;

	var OpIterator = {};

	Object.defineProperty(OpIterator, "__esModule", { value: true });
	const Op_1 = Op$1;
	class Iterator {
	    constructor(ops) {
	        this.ops = ops;
	        this.index = 0;
	        this.offset = 0;
	    }
	    hasNext() {
	        return this.peekLength() < Infinity;
	    }
	    next(length) {
	        if (!length) {
	            length = Infinity;
	        }
	        const nextOp = this.ops[this.index];
	        if (nextOp) {
	            const offset = this.offset;
	            const opLength = Op_1.default.length(nextOp);
	            if (length >= opLength - offset) {
	                length = opLength - offset;
	                this.index += 1;
	                this.offset = 0;
	            }
	            else {
	                this.offset += length;
	            }
	            if (typeof nextOp.delete === 'number') {
	                return { delete: length };
	            }
	            else {
	                const retOp = {};
	                if (nextOp.attributes) {
	                    retOp.attributes = nextOp.attributes;
	                }
	                if (typeof nextOp.retain === 'number') {
	                    retOp.retain = length;
	                }
	                else if (typeof nextOp.retain === 'object' &&
	                    nextOp.retain !== null) {
	                    // offset should === 0, length should === 1
	                    retOp.retain = nextOp.retain;
	                }
	                else if (typeof nextOp.insert === 'string') {
	                    retOp.insert = nextOp.insert.substr(offset, length);
	                }
	                else {
	                    // offset should === 0, length should === 1
	                    retOp.insert = nextOp.insert;
	                }
	                return retOp;
	            }
	        }
	        else {
	            return { retain: Infinity };
	        }
	    }
	    peek() {
	        return this.ops[this.index];
	    }
	    peekLength() {
	        if (this.ops[this.index]) {
	            // Should never return 0 if our index is being managed correctly
	            return Op_1.default.length(this.ops[this.index]) - this.offset;
	        }
	        else {
	            return Infinity;
	        }
	    }
	    peekType() {
	        const op = this.ops[this.index];
	        if (op) {
	            if (typeof op.delete === 'number') {
	                return 'delete';
	            }
	            else if (typeof op.retain === 'number' ||
	                (typeof op.retain === 'object' && op.retain !== null)) {
	                return 'retain';
	            }
	            else {
	                return 'insert';
	            }
	        }
	        return 'retain';
	    }
	    rest() {
	        if (!this.hasNext()) {
	            return [];
	        }
	        else if (this.offset === 0) {
	            return this.ops.slice(this.index);
	        }
	        else {
	            const offset = this.offset;
	            const index = this.index;
	            const next = this.next();
	            const rest = this.ops.slice(this.index);
	            this.offset = offset;
	            this.index = index;
	            return [next].concat(rest);
	        }
	    }
	}
	OpIterator.default = Iterator;

	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.AttributeMap = exports.OpIterator = exports.Op = void 0;
		const diff = diff_1;
		const cloneDeep = lodash_clonedeepExports;
		const isEqual = lodash_isequalExports;
		const AttributeMap_1 = AttributeMap$1;
		exports.AttributeMap = AttributeMap_1.default;
		const Op_1 = Op$1;
		exports.Op = Op_1.default;
		const OpIterator_1 = OpIterator;
		exports.OpIterator = OpIterator_1.default;
		const NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
		const getEmbedTypeAndData = (a, b) => {
		    if (typeof a !== 'object' || a === null) {
		        throw new Error(`cannot retain a ${typeof a}`);
		    }
		    if (typeof b !== 'object' || b === null) {
		        throw new Error(`cannot retain a ${typeof b}`);
		    }
		    const embedType = Object.keys(a)[0];
		    if (!embedType || embedType !== Object.keys(b)[0]) {
		        throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
		    }
		    return [embedType, a[embedType], b[embedType]];
		};
		class Delta {
		    constructor(ops) {
		        // Assume we are given a well formed ops
		        if (Array.isArray(ops)) {
		            this.ops = ops;
		        }
		        else if (ops != null && Array.isArray(ops.ops)) {
		            this.ops = ops.ops;
		        }
		        else {
		            this.ops = [];
		        }
		    }
		    static registerEmbed(embedType, handler) {
		        this.handlers[embedType] = handler;
		    }
		    static unregisterEmbed(embedType) {
		        delete this.handlers[embedType];
		    }
		    static getHandler(embedType) {
		        const handler = this.handlers[embedType];
		        if (!handler) {
		            throw new Error(`no handlers for embed type "${embedType}"`);
		        }
		        return handler;
		    }
		    insert(arg, attributes) {
		        const newOp = {};
		        if (typeof arg === 'string' && arg.length === 0) {
		            return this;
		        }
		        newOp.insert = arg;
		        if (attributes != null &&
		            typeof attributes === 'object' &&
		            Object.keys(attributes).length > 0) {
		            newOp.attributes = attributes;
		        }
		        return this.push(newOp);
		    }
		    delete(length) {
		        if (length <= 0) {
		            return this;
		        }
		        return this.push({ delete: length });
		    }
		    retain(length, attributes) {
		        if (typeof length === 'number' && length <= 0) {
		            return this;
		        }
		        const newOp = { retain: length };
		        if (attributes != null &&
		            typeof attributes === 'object' &&
		            Object.keys(attributes).length > 0) {
		            newOp.attributes = attributes;
		        }
		        return this.push(newOp);
		    }
		    push(newOp) {
		        let index = this.ops.length;
		        let lastOp = this.ops[index - 1];
		        newOp = cloneDeep(newOp);
		        if (typeof lastOp === 'object') {
		            if (typeof newOp.delete === 'number' &&
		                typeof lastOp.delete === 'number') {
		                this.ops[index - 1] = { delete: lastOp.delete + newOp.delete };
		                return this;
		            }
		            // Since it does not matter if we insert before or after deleting at the same index,
		            // always prefer to insert first
		            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
		                index -= 1;
		                lastOp = this.ops[index - 1];
		                if (typeof lastOp !== 'object') {
		                    this.ops.unshift(newOp);
		                    return this;
		                }
		            }
		            if (isEqual(newOp.attributes, lastOp.attributes)) {
		                if (typeof newOp.insert === 'string' &&
		                    typeof lastOp.insert === 'string') {
		                    this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
		                    if (typeof newOp.attributes === 'object') {
		                        this.ops[index - 1].attributes = newOp.attributes;
		                    }
		                    return this;
		                }
		                else if (typeof newOp.retain === 'number' &&
		                    typeof lastOp.retain === 'number') {
		                    this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
		                    if (typeof newOp.attributes === 'object') {
		                        this.ops[index - 1].attributes = newOp.attributes;
		                    }
		                    return this;
		                }
		            }
		        }
		        if (index === this.ops.length) {
		            this.ops.push(newOp);
		        }
		        else {
		            this.ops.splice(index, 0, newOp);
		        }
		        return this;
		    }
		    chop() {
		        const lastOp = this.ops[this.ops.length - 1];
		        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) {
		            this.ops.pop();
		        }
		        return this;
		    }
		    filter(predicate) {
		        return this.ops.filter(predicate);
		    }
		    forEach(predicate) {
		        this.ops.forEach(predicate);
		    }
		    map(predicate) {
		        return this.ops.map(predicate);
		    }
		    partition(predicate) {
		        const passed = [];
		        const failed = [];
		        this.forEach((op) => {
		            const target = predicate(op) ? passed : failed;
		            target.push(op);
		        });
		        return [passed, failed];
		    }
		    reduce(predicate, initialValue) {
		        return this.ops.reduce(predicate, initialValue);
		    }
		    changeLength() {
		        return this.reduce((length, elem) => {
		            if (elem.insert) {
		                return length + Op_1.default.length(elem);
		            }
		            else if (elem.delete) {
		                return length - elem.delete;
		            }
		            return length;
		        }, 0);
		    }
		    length() {
		        return this.reduce((length, elem) => {
		            return length + Op_1.default.length(elem);
		        }, 0);
		    }
		    slice(start = 0, end = Infinity) {
		        const ops = [];
		        const iter = new OpIterator_1.default(this.ops);
		        let index = 0;
		        while (index < end && iter.hasNext()) {
		            let nextOp;
		            if (index < start) {
		                nextOp = iter.next(start - index);
		            }
		            else {
		                nextOp = iter.next(end - index);
		                ops.push(nextOp);
		            }
		            index += Op_1.default.length(nextOp);
		        }
		        return new Delta(ops);
		    }
		    compose(other) {
		        const thisIter = new OpIterator_1.default(this.ops);
		        const otherIter = new OpIterator_1.default(other.ops);
		        const ops = [];
		        const firstOther = otherIter.peek();
		        if (firstOther != null &&
		            typeof firstOther.retain === 'number' &&
		            firstOther.attributes == null) {
		            let firstLeft = firstOther.retain;
		            while (thisIter.peekType() === 'insert' &&
		                thisIter.peekLength() <= firstLeft) {
		                firstLeft -= thisIter.peekLength();
		                ops.push(thisIter.next());
		            }
		            if (firstOther.retain - firstLeft > 0) {
		                otherIter.next(firstOther.retain - firstLeft);
		            }
		        }
		        const delta = new Delta(ops);
		        while (thisIter.hasNext() || otherIter.hasNext()) {
		            if (otherIter.peekType() === 'insert') {
		                delta.push(otherIter.next());
		            }
		            else if (thisIter.peekType() === 'delete') {
		                delta.push(thisIter.next());
		            }
		            else {
		                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
		                const thisOp = thisIter.next(length);
		                const otherOp = otherIter.next(length);
		                if (otherOp.retain) {
		                    const newOp = {};
		                    if (typeof thisOp.retain === 'number') {
		                        newOp.retain =
		                            typeof otherOp.retain === 'number' ? length : otherOp.retain;
		                    }
		                    else {
		                        if (typeof otherOp.retain === 'number') {
		                            if (thisOp.retain == null) {
		                                newOp.insert = thisOp.insert;
		                            }
		                            else {
		                                newOp.retain = thisOp.retain;
		                            }
		                        }
		                        else {
		                            const action = thisOp.retain == null ? 'insert' : 'retain';
		                            const [embedType, thisData, otherData] = getEmbedTypeAndData(thisOp[action], otherOp.retain);
		                            const handler = Delta.getHandler(embedType);
		                            newOp[action] = {
		                                [embedType]: handler.compose(thisData, otherData, action === 'retain'),
		                            };
		                        }
		                    }
		                    // Preserve null when composing with a retain, otherwise remove it for inserts
		                    const attributes = AttributeMap_1.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
		                    if (attributes) {
		                        newOp.attributes = attributes;
		                    }
		                    delta.push(newOp);
		                    // Optimization if rest of other is just retain
		                    if (!otherIter.hasNext() &&
		                        isEqual(delta.ops[delta.ops.length - 1], newOp)) {
		                        const rest = new Delta(thisIter.rest());
		                        return delta.concat(rest).chop();
		                    }
		                    // Other op should be delete, we could be an insert or retain
		                    // Insert + delete cancels out
		                }
		                else if (typeof otherOp.delete === 'number' &&
		                    (typeof thisOp.retain === 'number' ||
		                        (typeof thisOp.retain === 'object' && thisOp.retain !== null))) {
		                    delta.push(otherOp);
		                }
		            }
		        }
		        return delta.chop();
		    }
		    concat(other) {
		        const delta = new Delta(this.ops.slice());
		        if (other.ops.length > 0) {
		            delta.push(other.ops[0]);
		            delta.ops = delta.ops.concat(other.ops.slice(1));
		        }
		        return delta;
		    }
		    diff(other, cursor) {
		        if (this.ops === other.ops) {
		            return new Delta();
		        }
		        const strings = [this, other].map((delta) => {
		            return delta
		                .map((op) => {
		                if (op.insert != null) {
		                    return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
		                }
		                const prep = delta === other ? 'on' : 'with';
		                throw new Error('diff() called ' + prep + ' non-document');
		            })
		                .join('');
		        });
		        const retDelta = new Delta();
		        const diffResult = diff(strings[0], strings[1], cursor, true);
		        const thisIter = new OpIterator_1.default(this.ops);
		        const otherIter = new OpIterator_1.default(other.ops);
		        diffResult.forEach((component) => {
		            let length = component[1].length;
		            while (length > 0) {
		                let opLength = 0;
		                switch (component[0]) {
		                    case diff.INSERT:
		                        opLength = Math.min(otherIter.peekLength(), length);
		                        retDelta.push(otherIter.next(opLength));
		                        break;
		                    case diff.DELETE:
		                        opLength = Math.min(length, thisIter.peekLength());
		                        thisIter.next(opLength);
		                        retDelta.delete(opLength);
		                        break;
		                    case diff.EQUAL:
		                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
		                        const thisOp = thisIter.next(opLength);
		                        const otherOp = otherIter.next(opLength);
		                        if (isEqual(thisOp.insert, otherOp.insert)) {
		                            retDelta.retain(opLength, AttributeMap_1.default.diff(thisOp.attributes, otherOp.attributes));
		                        }
		                        else {
		                            retDelta.push(otherOp).delete(opLength);
		                        }
		                        break;
		                }
		                length -= opLength;
		            }
		        });
		        return retDelta.chop();
		    }
		    eachLine(predicate, newline = '\n') {
		        const iter = new OpIterator_1.default(this.ops);
		        let line = new Delta();
		        let i = 0;
		        while (iter.hasNext()) {
		            if (iter.peekType() !== 'insert') {
		                return;
		            }
		            const thisOp = iter.peek();
		            const start = Op_1.default.length(thisOp) - iter.peekLength();
		            const index = typeof thisOp.insert === 'string'
		                ? thisOp.insert.indexOf(newline, start) - start
		                : -1;
		            if (index < 0) {
		                line.push(iter.next());
		            }
		            else if (index > 0) {
		                line.push(iter.next(index));
		            }
		            else {
		                if (predicate(line, iter.next(1).attributes || {}, i) === false) {
		                    return;
		                }
		                i += 1;
		                line = new Delta();
		            }
		        }
		        if (line.length() > 0) {
		            predicate(line, {}, i);
		        }
		    }
		    invert(base) {
		        const inverted = new Delta();
		        this.reduce((baseIndex, op) => {
		            if (op.insert) {
		                inverted.delete(Op_1.default.length(op));
		            }
		            else if (typeof op.retain === 'number' && op.attributes == null) {
		                inverted.retain(op.retain);
		                return baseIndex + op.retain;
		            }
		            else if (op.delete || typeof op.retain === 'number') {
		                const length = (op.delete || op.retain);
		                const slice = base.slice(baseIndex, baseIndex + length);
		                slice.forEach((baseOp) => {
		                    if (op.delete) {
		                        inverted.push(baseOp);
		                    }
		                    else if (op.retain && op.attributes) {
		                        inverted.retain(Op_1.default.length(baseOp), AttributeMap_1.default.invert(op.attributes, baseOp.attributes));
		                    }
		                });
		                return baseIndex + length;
		            }
		            else if (typeof op.retain === 'object' && op.retain !== null) {
		                const slice = base.slice(baseIndex, baseIndex + 1);
		                const baseOp = new OpIterator_1.default(slice.ops).next();
		                const [embedType, opData, baseOpData] = getEmbedTypeAndData(op.retain, baseOp.insert);
		                const handler = Delta.getHandler(embedType);
		                inverted.retain({ [embedType]: handler.invert(opData, baseOpData) }, AttributeMap_1.default.invert(op.attributes, baseOp.attributes));
		                return baseIndex + 1;
		            }
		            return baseIndex;
		        }, 0);
		        return inverted.chop();
		    }
		    transform(arg, priority = false) {
		        priority = !!priority;
		        if (typeof arg === 'number') {
		            return this.transformPosition(arg, priority);
		        }
		        const other = arg;
		        const thisIter = new OpIterator_1.default(this.ops);
		        const otherIter = new OpIterator_1.default(other.ops);
		        const delta = new Delta();
		        while (thisIter.hasNext() || otherIter.hasNext()) {
		            if (thisIter.peekType() === 'insert' &&
		                (priority || otherIter.peekType() !== 'insert')) {
		                delta.retain(Op_1.default.length(thisIter.next()));
		            }
		            else if (otherIter.peekType() === 'insert') {
		                delta.push(otherIter.next());
		            }
		            else {
		                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
		                const thisOp = thisIter.next(length);
		                const otherOp = otherIter.next(length);
		                if (thisOp.delete) {
		                    // Our delete either makes their delete redundant or removes their retain
		                    continue;
		                }
		                else if (otherOp.delete) {
		                    delta.push(otherOp);
		                }
		                else {
		                    const thisData = thisOp.retain;
		                    const otherData = otherOp.retain;
		                    let transformedData = typeof otherData === 'object' && otherData !== null
		                        ? otherData
		                        : length;
		                    if (typeof thisData === 'object' &&
		                        thisData !== null &&
		                        typeof otherData === 'object' &&
		                        otherData !== null) {
		                        const embedType = Object.keys(thisData)[0];
		                        if (embedType === Object.keys(otherData)[0]) {
		                            const handler = Delta.getHandler(embedType);
		                            if (handler) {
		                                transformedData = {
		                                    [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority),
		                                };
		                            }
		                        }
		                    }
		                    // We retain either their retain or insert
		                    delta.retain(transformedData, AttributeMap_1.default.transform(thisOp.attributes, otherOp.attributes, priority));
		                }
		            }
		        }
		        return delta.chop();
		    }
		    transformPosition(index, priority = false) {
		        priority = !!priority;
		        const thisIter = new OpIterator_1.default(this.ops);
		        let offset = 0;
		        while (thisIter.hasNext() && offset <= index) {
		            const length = thisIter.peekLength();
		            const nextType = thisIter.peekType();
		            thisIter.next();
		            if (nextType === 'delete') {
		                index -= Math.min(length, index - offset);
		                continue;
		            }
		            else if (nextType === 'insert' && (offset < index || !priority)) {
		                index += length;
		            }
		            offset += length;
		        }
		        return index;
		    }
		}
		Delta.Op = Op_1.default;
		Delta.OpIterator = OpIterator_1.default;
		Delta.AttributeMap = AttributeMap_1.default;
		Delta.handlers = {};
		exports.default = Delta;
		{
		    module.exports = Delta;
		    module.exports.default = Delta;
		}
		
	} (Delta$1, Delta$1.exports));

	var DeltaExports = Delta$1.exports;
	var Delta = /*@__PURE__*/getDefaultExportFromCjs(DeltaExports);

	class Break extends EmbedBlot$1 {
	  static value() {
	    return undefined;
	  }
	  optimize() {
	    if (this.prev || this.next) {
	      this.remove();
	    }
	  }
	  length() {
	    return 0;
	  }
	  value() {
	    return '';
	  }
	}
	Break.blotName = 'break';
	Break.tagName = 'BR';

	let Text$1 = class Text extends TextBlot$1 {};
	function escapeText(text) {
	  return text.replace(/[&<>"']/g, s => {
	    // https://lodash.com/docs#escape
	    const entityMap = {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#39;'
	    };
	    return entityMap[s];
	  });
	}

	class Inline extends InlineBlot$1 {
	  static allowedChildren = [Inline, Break, EmbedBlot$1, Text$1];
	  // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	  static order = ['cursor', 'inline',
	  // Must be lower
	  'link',
	  // Chrome wants <a> to be lower
	  'underline', 'strike', 'italic', 'bold', 'script', 'code' // Must be higher
	  ];
	  static compare(self, other) {
	    const selfIndex = Inline.order.indexOf(self);
	    const otherIndex = Inline.order.indexOf(other);
	    if (selfIndex >= 0 || otherIndex >= 0) {
	      return selfIndex - otherIndex;
	    }
	    if (self === other) {
	      return 0;
	    }
	    if (self < other) {
	      return -1;
	    }
	    return 1;
	  }
	  formatAt(index, length, name, value) {
	    if (Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, Scope.BLOT)) {
	      const blot = this.isolate(index, length);
	      if (value) {
	        blot.wrap(name, value);
	      }
	    } else {
	      super.formatAt(index, length, name, value);
	    }
	  }
	  optimize(context) {
	    super.optimize(context);
	    if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	      const parent = this.parent.isolate(this.offset(), this.length());
	      // @ts-expect-error TODO: make isolate generic
	      this.moveChildren(parent);
	      parent.wrap(this);
	    }
	  }
	}

	const NEWLINE_LENGTH = 1;
	class Block extends BlockBlot$1 {
	  cache = {};
	  delta() {
	    if (this.cache.delta == null) {
	      this.cache.delta = blockDelta(this);
	    }
	    return this.cache.delta;
	  }
	  deleteAt(index, length) {
	    super.deleteAt(index, length);
	    this.cache = {};
	  }
	  formatAt(index, length, name, value) {
	    if (length <= 0) return;
	    if (this.scroll.query(name, Scope.BLOCK)) {
	      if (index + length === this.length()) {
	        this.format(name, value);
	      }
	    } else {
	      super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
	    }
	    this.cache = {};
	  }
	  insertAt(index, value, def) {
	    if (def != null) {
	      super.insertAt(index, value, def);
	      this.cache = {};
	      return;
	    }
	    if (value.length === 0) return;
	    const lines = value.split('\n');
	    const text = lines.shift();
	    if (text.length > 0) {
	      if (index < this.length() - 1 || this.children.tail == null) {
	        super.insertAt(Math.min(index, this.length() - 1), text);
	      } else {
	        this.children.tail.insertAt(this.children.tail.length(), text);
	      }
	      this.cache = {};
	    }
	    // TODO: Fix this next time the file is edited.
	    // eslint-disable-next-line @typescript-eslint/no-this-alias
	    let block = this;
	    lines.reduce((lineIndex, line) => {
	      // @ts-expect-error Fix me later
	      block = block.split(lineIndex, true);
	      block.insertAt(0, line);
	      return line.length;
	    }, index + text.length);
	  }
	  insertBefore(blot, ref) {
	    const {
	      head
	    } = this.children;
	    super.insertBefore(blot, ref);
	    if (head instanceof Break) {
	      head.remove();
	    }
	    this.cache = {};
	  }
	  length() {
	    if (this.cache.length == null) {
	      this.cache.length = super.length() + NEWLINE_LENGTH;
	    }
	    return this.cache.length;
	  }
	  moveChildren(target, ref) {
	    super.moveChildren(target, ref);
	    this.cache = {};
	  }
	  optimize(context) {
	    super.optimize(context);
	    this.cache = {};
	  }
	  path(index) {
	    return super.path(index, true);
	  }
	  removeChild(child) {
	    super.removeChild(child);
	    this.cache = {};
	  }
	  split(index) {
	    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	      const clone = this.clone();
	      if (index === 0) {
	        this.parent.insertBefore(clone, this);
	        return this;
	      }
	      this.parent.insertBefore(clone, this.next);
	      return clone;
	    }
	    const next = super.split(index, force);
	    this.cache = {};
	    return next;
	  }
	}
	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = Break;
	Block.allowedChildren = [Break, Inline, EmbedBlot$1, Text$1];
	class BlockEmbed extends EmbedBlot$1 {
	  attach() {
	    super.attach();
	    this.attributes = new AttributorStore$1(this.domNode);
	  }
	  delta() {
	    return new Delta().insert(this.value(), {
	      ...this.formats(),
	      ...this.attributes.values()
	    });
	  }
	  format(name, value) {
	    const attribute = this.scroll.query(name, Scope.BLOCK_ATTRIBUTE);
	    if (attribute != null) {
	      // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
	      this.attributes.attribute(attribute, value);
	    }
	  }
	  formatAt(index, length, name, value) {
	    this.format(name, value);
	  }
	  insertAt(index, value, def) {
	    if (def != null) {
	      super.insertAt(index, value, def);
	      return;
	    }
	    const lines = value.split('\n');
	    const text = lines.pop();
	    const blocks = lines.map(line => {
	      const block = this.scroll.create(Block.blotName);
	      block.insertAt(0, line);
	      return block;
	    });
	    const ref = this.split(index);
	    blocks.forEach(block => {
	      this.parent.insertBefore(block, ref);
	    });
	    if (text) {
	      this.parent.insertBefore(this.scroll.create('text', text), ref);
	    }
	  }
	}
	BlockEmbed.scope = Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements

	function blockDelta(blot) {
	  let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return blot.descendants(LeafBlot$1).reduce((delta, leaf) => {
	    if (leaf.length() === 0) {
	      return delta;
	    }
	    return delta.insert(leaf.value(), bubbleFormats(leaf, {}, filter));
	  }, new Delta()).insert('\n', bubbleFormats(blot));
	}
	function bubbleFormats(blot) {
	  let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  if (blot == null) return formats;
	  if ('formats' in blot && typeof blot.formats === 'function') {
	    formats = {
	      ...formats,
	      ...blot.formats()
	    };
	    if (filter) {
	      // exclude syntax highlighting from deltas and getFormat()
	      delete formats['code-token'];
	    }
	  }
	  if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats, filter);
	}

	class Cursor extends EmbedBlot$1 {
	  static blotName = 'cursor';
	  static className = 'ql-cursor';
	  static tagName = 'span';
	  static CONTENTS = '\uFEFF'; // Zero width no break space

	  static value() {
	    return undefined;
	  }
	  constructor(scroll, domNode, selection) {
	    super(scroll, domNode);
	    this.selection = selection;
	    this.textNode = document.createTextNode(Cursor.CONTENTS);
	    this.domNode.appendChild(this.textNode);
	    this.savedLength = 0;
	  }
	  detach() {
	    // super.detach() will also clear domNode.__blot
	    if (this.parent != null) this.parent.removeChild(this);
	  }
	  format(name, value) {
	    if (this.savedLength !== 0) {
	      super.format(name, value);
	      return;
	    }
	    // TODO: Fix this next time the file is edited.
	    // eslint-disable-next-line @typescript-eslint/no-this-alias
	    let target = this;
	    let index = 0;
	    while (target != null && target.statics.scope !== Scope.BLOCK_BLOT) {
	      index += target.offset(target.parent);
	      target = target.parent;
	    }
	    if (target != null) {
	      this.savedLength = Cursor.CONTENTS.length;
	      // @ts-expect-error TODO: allow empty context in Parchment
	      target.optimize();
	      target.formatAt(index, Cursor.CONTENTS.length, name, value);
	      this.savedLength = 0;
	    }
	  }
	  index(node, offset) {
	    if (node === this.textNode) return 0;
	    return super.index(node, offset);
	  }
	  length() {
	    return this.savedLength;
	  }
	  position() {
	    return [this.textNode, this.textNode.data.length];
	  }
	  remove() {
	    super.remove();
	    // @ts-expect-error Fix me later
	    this.parent = null;
	  }
	  restore() {
	    if (this.selection.composing || this.parent == null) return null;
	    const range = this.selection.getNativeRange();
	    // Browser may push down styles/nodes inside the cursor blot.
	    // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
	    while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	      // @ts-expect-error Fix me later
	      this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	    }
	    const prevTextBlot = this.prev instanceof Text$1 ? this.prev : null;
	    const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
	    const nextTextBlot = this.next instanceof Text$1 ? this.next : null;
	    // @ts-expect-error TODO: make TextBlot.text public
	    const nextText = nextTextBlot ? nextTextBlot.text : '';
	    const {
	      textNode
	    } = this;
	    // take text from inside this blot and reset it
	    const newText = textNode.data.split(Cursor.CONTENTS).join('');
	    textNode.data = Cursor.CONTENTS;

	    // proactively merge TextBlots around cursor so that optimization
	    // doesn't lose the cursor.  the reason we are here in cursor.restore
	    // could be that the user clicked in prevTextBlot or nextTextBlot, or
	    // the user typed something.
	    let mergedTextBlot;
	    if (prevTextBlot) {
	      mergedTextBlot = prevTextBlot;
	      if (newText || nextTextBlot) {
	        prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
	        if (nextTextBlot) {
	          nextTextBlot.remove();
	        }
	      }
	    } else if (nextTextBlot) {
	      mergedTextBlot = nextTextBlot;
	      nextTextBlot.insertAt(0, newText);
	    } else {
	      const newTextNode = document.createTextNode(newText);
	      mergedTextBlot = this.scroll.create(newTextNode);
	      this.parent.insertBefore(mergedTextBlot, this);
	    }
	    this.remove();
	    if (range) {
	      // calculate selection to restore
	      const remapOffset = (node, offset) => {
	        if (prevTextBlot && node === prevTextBlot.domNode) {
	          return offset;
	        }
	        if (node === textNode) {
	          return prevTextLength + offset - 1;
	        }
	        if (nextTextBlot && node === nextTextBlot.domNode) {
	          return prevTextLength + newText.length + offset;
	        }
	        return null;
	      };
	      const start = remapOffset(range.start.node, range.start.offset);
	      const end = remapOffset(range.end.node, range.end.offset);
	      if (start !== null && end !== null) {
	        return {
	          startNode: mergedTextBlot.domNode,
	          startOffset: start,
	          endNode: mergedTextBlot.domNode,
	          endOffset: end
	        };
	      }
	    }
	    return null;
	  }
	  update(mutations, context) {
	    if (mutations.some(mutation => {
	      return mutation.type === 'characterData' && mutation.target === this.textNode;
	    })) {
	      const range = this.restore();
	      if (range) context.range = range;
	    }
	  }

	  // Avoid .ql-cursor being a descendant of `<a/>`.
	  // The reason is Safari pushes down `<a/>` on text insertion.
	  // That will cause DOM nodes not sync with the model.
	  //
	  // For example ({I} is the caret), given the markup:
	  //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
	  // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
	  //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
	  // And then "x" will be inserted after `<a/>`:
	  //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
	  optimize(context) {
	    // @ts-expect-error Fix me later
	    super.optimize(context);
	    let {
	      parent
	    } = this;
	    while (parent) {
	      if (parent.domNode.tagName === 'A') {
	        this.savedLength = Cursor.CONTENTS.length;
	        // @ts-expect-error TODO: make isolate generic
	        parent.isolate(this.offset(parent), this.length()).unwrap();
	        this.savedLength = 0;
	        break;
	      }
	      parent = parent.parent;
	    }
	  }
	  value() {
	    return '';
	  }
	}

	var eventemitter3 = {exports: {}};

	(function (module) {

		var has = Object.prototype.hasOwnProperty
		  , prefix = '~';

		/**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */
		function Events() {}

		//
		// We try to not inherit from `Object.prototype`. In some engines creating an
		// instance in this way is faster than calling `Object.create(null)` directly.
		// If `Object.create(null)` is not supported we prefix the event names with a
		// character to make sure that the built-in object properties are not
		// overridden or used as an attack vector.
		//
		if (Object.create) {
		  Events.prototype = Object.create(null);

		  //
		  // This hack is needed because the `__proto__` property is still inherited in
		  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
		  //
		  if (!new Events().__proto__) prefix = false;
		}

		/**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */
		function EE(fn, context, once) {
		  this.fn = fn;
		  this.context = context;
		  this.once = once || false;
		}

		/**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */
		function addListener(emitter, event, fn, context, once) {
		  if (typeof fn !== 'function') {
		    throw new TypeError('The listener must be a function');
		  }

		  var listener = new EE(fn, context || emitter, once)
		    , evt = prefix ? prefix + event : event;

		  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
		  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
		  else emitter._events[evt] = [emitter._events[evt], listener];

		  return emitter;
		}

		/**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */
		function clearEvent(emitter, evt) {
		  if (--emitter._eventsCount === 0) emitter._events = new Events();
		  else delete emitter._events[evt];
		}

		/**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */
		function EventEmitter() {
		  this._events = new Events();
		  this._eventsCount = 0;
		}

		/**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */
		EventEmitter.prototype.eventNames = function eventNames() {
		  var names = []
		    , events
		    , name;

		  if (this._eventsCount === 0) return names;

		  for (name in (events = this._events)) {
		    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
		  }

		  if (Object.getOwnPropertySymbols) {
		    return names.concat(Object.getOwnPropertySymbols(events));
		  }

		  return names;
		};

		/**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */
		EventEmitter.prototype.listeners = function listeners(event) {
		  var evt = prefix ? prefix + event : event
		    , handlers = this._events[evt];

		  if (!handlers) return [];
		  if (handlers.fn) return [handlers.fn];

		  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
		    ee[i] = handlers[i].fn;
		  }

		  return ee;
		};

		/**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */
		EventEmitter.prototype.listenerCount = function listenerCount(event) {
		  var evt = prefix ? prefix + event : event
		    , listeners = this._events[evt];

		  if (!listeners) return 0;
		  if (listeners.fn) return 1;
		  return listeners.length;
		};

		/**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */
		EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
		  var evt = prefix ? prefix + event : event;

		  if (!this._events[evt]) return false;

		  var listeners = this._events[evt]
		    , len = arguments.length
		    , args
		    , i;

		  if (listeners.fn) {
		    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

		    switch (len) {
		      case 1: return listeners.fn.call(listeners.context), true;
		      case 2: return listeners.fn.call(listeners.context, a1), true;
		      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
		      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
		      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
		      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
		    }

		    for (i = 1, args = new Array(len -1); i < len; i++) {
		      args[i - 1] = arguments[i];
		    }

		    listeners.fn.apply(listeners.context, args);
		  } else {
		    var length = listeners.length
		      , j;

		    for (i = 0; i < length; i++) {
		      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

		      switch (len) {
		        case 1: listeners[i].fn.call(listeners[i].context); break;
		        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
		        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
		        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
		        default:
		          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
		            args[j - 1] = arguments[j];
		          }

		          listeners[i].fn.apply(listeners[i].context, args);
		      }
		    }
		  }

		  return true;
		};

		/**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.on = function on(event, fn, context) {
		  return addListener(this, event, fn, context, false);
		};

		/**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.once = function once(event, fn, context) {
		  return addListener(this, event, fn, context, true);
		};

		/**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
		  var evt = prefix ? prefix + event : event;

		  if (!this._events[evt]) return this;
		  if (!fn) {
		    clearEvent(this, evt);
		    return this;
		  }

		  var listeners = this._events[evt];

		  if (listeners.fn) {
		    if (
		      listeners.fn === fn &&
		      (!once || listeners.once) &&
		      (!context || listeners.context === context)
		    ) {
		      clearEvent(this, evt);
		    }
		  } else {
		    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
		      if (
		        listeners[i].fn !== fn ||
		        (once && !listeners[i].once) ||
		        (context && listeners[i].context !== context)
		      ) {
		        events.push(listeners[i]);
		      }
		    }

		    //
		    // Reset the array, or remove it completely if we have no more listeners.
		    //
		    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
		    else clearEvent(this, evt);
		  }

		  return this;
		};

		/**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
		  var evt;

		  if (event) {
		    evt = prefix ? prefix + event : event;
		    if (this._events[evt]) clearEvent(this, evt);
		  } else {
		    this._events = new Events();
		    this._eventsCount = 0;
		  }

		  return this;
		};

		//
		// Alias methods names because people roll like that.
		//
		EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
		EventEmitter.prototype.addListener = EventEmitter.prototype.on;

		//
		// Expose the prefix.
		//
		EventEmitter.prefixed = prefix;

		//
		// Allow `EventEmitter` to be imported as module namespace.
		//
		EventEmitter.EventEmitter = EventEmitter;

		//
		// Expose the module.
		//
		{
		  module.exports = EventEmitter;
		} 
	} (eventemitter3));

	var eventemitter3Exports = eventemitter3.exports;
	var EventEmitter = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

	var instances = new WeakMap();

	const levels = ['error', 'warn', 'log', 'info'];
	let level = 'warn';
	function debug$6(method) {
	  if (level) {
	    if (levels.indexOf(method) <= levels.indexOf(level)) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	      console[method](...args); // eslint-disable-line no-console
	    }
	  }
	}
	function namespace(ns) {
	  return levels.reduce((logger, method) => {
	    logger[method] = debug$6.bind(console, method, ns);
	    return logger;
	  }, {});
	}
	namespace.level = newLevel => {
	  level = newLevel;
	};
	debug$6.level = namespace.level;

	const debug$5 = namespace('quill:events');
	const EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
	EVENTS.forEach(eventName => {
	  document.addEventListener(eventName, function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    Array.from(document.querySelectorAll('.ql-container')).forEach(node => {
	      const quill = instances.get(node);
	      if (quill && quill.emitter) {
	        quill.emitter.handleDOM(...args);
	      }
	    });
	  });
	});
	class Emitter extends EventEmitter {
	  static events = {
	    EDITOR_CHANGE: 'editor-change',
	    SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	    SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
	    SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
	    SCROLL_OPTIMIZE: 'scroll-optimize',
	    SCROLL_UPDATE: 'scroll-update',
	    SCROLL_EMBED_UPDATE: 'scroll-embed-update',
	    SELECTION_CHANGE: 'selection-change',
	    TEXT_CHANGE: 'text-change',
	    COMPOSITION_BEFORE_START: 'composition-before-start',
	    COMPOSITION_START: 'composition-start',
	    COMPOSITION_BEFORE_END: 'composition-before-end',
	    COMPOSITION_END: 'composition-end'
	  };
	  static sources = {
	    API: 'api',
	    SILENT: 'silent',
	    USER: 'user'
	  };
	  constructor() {
	    super();
	    this.domListeners = {};
	    this.on('error', debug$5.error);
	  }
	  emit() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	    debug$5.log.call(debug$5, ...args);
	    // @ts-expect-error
	    return super.emit(...args);
	  }
	  handleDOM(event) {
	    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	    (this.domListeners[event.type] || []).forEach(_ref => {
	      let {
	        node,
	        handler
	      } = _ref;
	      if (event.target === node || node.contains(event.target)) {
	        handler(event, ...args);
	      }
	    });
	  }
	  listenDOM(eventName, node, handler) {
	    if (!this.domListeners[eventName]) {
	      this.domListeners[eventName] = [];
	    }
	    this.domListeners[eventName].push({
	      node,
	      handler
	    });
	  }
	}

	const debug$4 = namespace('quill:selection');
	class Range {
	  constructor(index) {
	    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    this.index = index;
	    this.length = length;
	  }
	}
	class Selection {
	  constructor(scroll, emitter) {
	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.mouseDown = false;
	    this.root = this.scroll.domNode;
	    // @ts-expect-error
	    this.cursor = this.scroll.create('cursor', this);
	    // savedRange is last non-null range
	    this.savedRange = new Range(0, 0);
	    this.lastRange = this.savedRange;
	    this.lastNative = null;
	    this.handleComposition();
	    this.handleDragging();
	    this.emitter.listenDOM('selectionchange', document, () => {
	      if (!this.mouseDown && !this.composing) {
	        setTimeout(this.update.bind(this, Emitter.sources.USER), 1);
	      }
	    });
	    this.emitter.on(Emitter.events.SCROLL_BEFORE_UPDATE, () => {
	      if (!this.hasFocus()) return;
	      const native = this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
	      this.emitter.once(Emitter.events.SCROLL_UPDATE, (source, mutations) => {
	        try {
	          if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) {
	            this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	          }
	          const triggeredByTyping = mutations.some(mutation => mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
	          this.update(triggeredByTyping ? Emitter.sources.SILENT : source);
	        } catch (ignored) {
	          // ignore
	        }
	      });
	    });
	    this.emitter.on(Emitter.events.SCROLL_OPTIMIZE, (mutations, context) => {
	      if (context.range) {
	        const {
	          startNode,
	          startOffset,
	          endNode,
	          endOffset
	        } = context.range;
	        this.setNativeRange(startNode, startOffset, endNode, endOffset);
	        this.update(Emitter.sources.SILENT);
	      }
	    });
	    this.update(Emitter.sources.SILENT);
	  }
	  handleComposition() {
	    this.emitter.on(Emitter.events.COMPOSITION_BEFORE_START, () => {
	      this.composing = true;
	    });
	    this.emitter.on(Emitter.events.COMPOSITION_END, () => {
	      this.composing = false;
	      if (this.cursor.parent) {
	        const range = this.cursor.restore();
	        if (!range) return;
	        setTimeout(() => {
	          this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	        }, 1);
	      }
	    });
	  }
	  handleDragging() {
	    this.emitter.listenDOM('mousedown', document.body, () => {
	      this.mouseDown = true;
	    });
	    this.emitter.listenDOM('mouseup', document.body, () => {
	      this.mouseDown = false;
	      this.update(Emitter.sources.USER);
	    });
	  }
	  focus() {
	    if (this.hasFocus()) return;
	    this.root.focus({
	      preventScroll: true
	    });
	    this.setRange(this.savedRange);
	  }
	  format(format, value) {
	    this.scroll.update();
	    const nativeRange = this.getNativeRange();
	    if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, Scope.BLOCK)) return;
	    if (nativeRange.start.node !== this.cursor.textNode) {
	      const blot = this.scroll.find(nativeRange.start.node, false);
	      if (blot == null) return;
	      // TODO Give blot ability to not split
	      if (blot instanceof LeafBlot$1) {
	        const after = blot.split(nativeRange.start.offset);
	        blot.parent.insertBefore(this.cursor, after);
	      } else {
	        // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
	        blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	      }
	      this.cursor.attach();
	    }
	    this.cursor.format(format, value);
	    this.scroll.optimize();
	    this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	    this.update();
	  }
	  getBounds(index) {
	    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    const scrollLength = this.scroll.length();
	    index = Math.min(index, scrollLength - 1);
	    length = Math.min(index + length, scrollLength - 1) - index;
	    let node;
	    let [leaf, offset] = this.scroll.leaf(index);
	    if (leaf == null) return null;
	    if (length > 0 && offset === leaf.length()) {
	      const [next] = this.scroll.leaf(index + 1);
	      if (next) {
	        const [line] = this.scroll.line(index);
	        const [nextLine] = this.scroll.line(index + 1);
	        if (line === nextLine) {
	          leaf = next;
	          offset = 0;
	        }
	      }
	    }
	    [node, offset] = leaf.position(offset, true);
	    const range = document.createRange();
	    if (length > 0) {
	      range.setStart(node, offset);
	      [leaf, offset] = this.scroll.leaf(index + length);
	      if (leaf == null) return null;
	      [node, offset] = leaf.position(offset, true);
	      range.setEnd(node, offset);
	      return range.getBoundingClientRect();
	    }
	    let side = 'left';
	    let rect;
	    if (node instanceof Text) {
	      // Return null if the text node is empty because it is
	      // not able to get a useful client rect:
	      // https://github.com/w3c/csswg-drafts/issues/2514.
	      // Empty text nodes are most likely caused by TextBlot#optimize()
	      // not getting called when editor content changes.
	      if (!node.data.length) {
	        return null;
	      }
	      if (offset < node.data.length) {
	        range.setStart(node, offset);
	        range.setEnd(node, offset + 1);
	      } else {
	        range.setStart(node, offset - 1);
	        range.setEnd(node, offset);
	        side = 'right';
	      }
	      rect = range.getBoundingClientRect();
	    } else {
	      if (!(leaf.domNode instanceof Element)) return null;
	      rect = leaf.domNode.getBoundingClientRect();
	      if (offset > 0) side = 'right';
	    }
	    return {
	      bottom: rect.top + rect.height,
	      height: rect.height,
	      left: rect[side],
	      right: rect[side],
	      top: rect.top,
	      width: 0
	    };
	  }
	  getNativeRange() {
	    const selection = document.getSelection();
	    if (selection == null || selection.rangeCount <= 0) return null;
	    const nativeRange = selection.getRangeAt(0);
	    if (nativeRange == null) return null;
	    const range = this.normalizeNative(nativeRange);
	    debug$4.info('getNativeRange', range);
	    return range;
	  }
	  getRange() {
	    const root = this.scroll.domNode;
	    if ('isConnected' in root && !root.isConnected) {
	      // document.getSelection() forces layout on Blink, so we trend to
	      // not calling it.
	      return [null, null];
	    }
	    const normalized = this.getNativeRange();
	    if (normalized == null) return [null, null];
	    const range = this.normalizedToRange(normalized);
	    return [range, normalized];
	  }
	  hasFocus() {
	    return document.activeElement === this.root || document.activeElement != null && contains(this.root, document.activeElement);
	  }
	  normalizedToRange(range) {
	    const positions = [[range.start.node, range.start.offset]];
	    if (!range.native.collapsed) {
	      positions.push([range.end.node, range.end.offset]);
	    }
	    const indexes = positions.map(position => {
	      const [node, offset] = position;
	      const blot = this.scroll.find(node, true);
	      // @ts-expect-error Fix me later
	      const index = blot.offset(this.scroll);
	      if (offset === 0) {
	        return index;
	      }
	      if (blot instanceof LeafBlot$1) {
	        return index + blot.index(node, offset);
	      }
	      // @ts-expect-error Fix me later
	      return index + blot.length();
	    });
	    const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
	    const start = Math.min(end, ...indexes);
	    return new Range(start, end - start);
	  }
	  normalizeNative(nativeRange) {
	    if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	      return null;
	    }
	    const range = {
	      start: {
	        node: nativeRange.startContainer,
	        offset: nativeRange.startOffset
	      },
	      end: {
	        node: nativeRange.endContainer,
	        offset: nativeRange.endOffset
	      },
	      native: nativeRange
	    };
	    [range.start, range.end].forEach(position => {
	      let {
	        node,
	        offset
	      } = position;
	      while (!(node instanceof Text) && node.childNodes.length > 0) {
	        if (node.childNodes.length > offset) {
	          node = node.childNodes[offset];
	          offset = 0;
	        } else if (node.childNodes.length === offset) {
	          // @ts-expect-error Fix me later
	          node = node.lastChild;
	          if (node instanceof Text) {
	            offset = node.data.length;
	          } else if (node.childNodes.length > 0) {
	            // Container case
	            offset = node.childNodes.length;
	          } else {
	            // Embed case
	            offset = node.childNodes.length + 1;
	          }
	        } else {
	          break;
	        }
	      }
	      position.node = node;
	      position.offset = offset;
	    });
	    return range;
	  }
	  rangeToNative(range) {
	    const scrollLength = this.scroll.length();
	    const getPosition = (index, inclusive) => {
	      index = Math.min(scrollLength - 1, index);
	      const [leaf, leafOffset] = this.scroll.leaf(index);
	      return leaf ? leaf.position(leafOffset, inclusive) : [null, -1];
	    };
	    return [...getPosition(range.index, false), ...getPosition(range.index + range.length, true)];
	  }
	  setNativeRange(startNode, startOffset) {
	    let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	    let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	    let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	    debug$4.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	    if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null ||
	    // @ts-expect-error Fix me later
	    endNode.parentNode == null)) {
	      return;
	    }
	    const selection = document.getSelection();
	    if (selection == null) return;
	    if (startNode != null) {
	      if (!this.hasFocus()) this.root.focus({
	        preventScroll: true
	      });
	      const {
	        native
	      } = this.getNativeRange() || {};
	      if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
	        if (startNode instanceof Element && startNode.tagName === 'BR') {
	          // @ts-expect-error Fix me later
	          startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
	          startNode = startNode.parentNode;
	        }
	        if (endNode instanceof Element && endNode.tagName === 'BR') {
	          // @ts-expect-error Fix me later
	          endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
	          endNode = endNode.parentNode;
	        }
	        const range = document.createRange();
	        // @ts-expect-error Fix me later
	        range.setStart(startNode, startOffset);
	        // @ts-expect-error Fix me later
	        range.setEnd(endNode, endOffset);
	        selection.removeAllRanges();
	        selection.addRange(range);
	      }
	    } else {
	      selection.removeAllRanges();
	      this.root.blur();
	    }
	  }
	  setRange(range) {
	    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Emitter.sources.API;
	    if (typeof force === 'string') {
	      source = force;
	      force = false;
	    }
	    debug$4.info('setRange', range);
	    if (range != null) {
	      const args = this.rangeToNative(range);
	      this.setNativeRange(...args, force);
	    } else {
	      this.setNativeRange(null);
	    }
	    this.update(source);
	  }
	  update() {
	    let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Emitter.sources.USER;
	    const oldRange = this.lastRange;
	    const [lastRange, nativeRange] = this.getRange();
	    this.lastRange = lastRange;
	    this.lastNative = nativeRange;
	    if (this.lastRange != null) {
	      this.savedRange = this.lastRange;
	    }
	    if (!isEqual$2(oldRange, this.lastRange)) {
	      if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	        const range = this.cursor.restore();
	        if (range) {
	          this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	        }
	      }
	      const args = [Emitter.events.SELECTION_CHANGE, cloneDeep$1(this.lastRange), cloneDeep$1(oldRange), source];
	      this.emitter.emit(Emitter.events.EDITOR_CHANGE, ...args);
	      if (source !== Emitter.sources.SILENT) {
	        this.emitter.emit(...args);
	      }
	    }
	  }
	}
	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
	  } catch (e) {
	    return false;
	  }
	  return parent.contains(descendant);
	}

	const ASCII = /^[ -~]*$/;
	class Editor {
	  constructor(scroll) {
	    this.scroll = scroll;
	    this.delta = this.getDelta();
	  }
	  applyDelta(delta) {
	    this.scroll.update();
	    let scrollLength = this.scroll.length();
	    this.scroll.batchStart();
	    const normalizedDelta = normalizeDelta(delta);
	    const deleteDelta = new Delta();
	    const normalizedOps = splitOpLines(normalizedDelta.ops.slice());
	    normalizedOps.reduce((index, op) => {
	      const length = DeltaExports.Op.length(op);
	      let attributes = op.attributes || {};
	      let isImplicitNewlinePrepended = false;
	      let isImplicitNewlineAppended = false;
	      if (op.insert != null) {
	        deleteDelta.retain(length);
	        if (typeof op.insert === 'string') {
	          const text = op.insert;
	          isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant(BlockEmbed, index)[0]);
	          this.scroll.insertAt(index, text);
	          const [line, offset] = this.scroll.line(index);
	          let formats = merge$1({}, bubbleFormats(line));
	          if (line instanceof Block) {
	            const [leaf] = line.descendant(LeafBlot$1, offset);
	            if (leaf) {
	              formats = merge$1(formats, bubbleFormats(leaf));
	            }
	          }
	          attributes = DeltaExports.AttributeMap.diff(formats, attributes) || {};
	        } else if (typeof op.insert === 'object') {
	          const key = Object.keys(op.insert)[0]; // There should only be one key
	          if (key == null) return index;
	          const isInlineEmbed = this.scroll.query(key, Scope.INLINE) != null;
	          if (isInlineEmbed) {
	            if (scrollLength <= index || !!this.scroll.descendant(BlockEmbed, index)[0]) {
	              isImplicitNewlineAppended = true;
	            }
	          } else if (index > 0) {
	            const [leaf, offset] = this.scroll.descendant(LeafBlot$1, index - 1);
	            if (leaf instanceof Text$1) {
	              const text = leaf.value();
	              if (text[offset] !== '\n') {
	                isImplicitNewlinePrepended = true;
	              }
	            } else if (leaf instanceof EmbedBlot$1 && leaf.statics.scope === Scope.INLINE_BLOT) {
	              isImplicitNewlinePrepended = true;
	            }
	          }
	          this.scroll.insertAt(index, key, op.insert[key]);
	          if (isInlineEmbed) {
	            const [leaf] = this.scroll.descendant(LeafBlot$1, index);
	            if (leaf) {
	              const formats = merge$1({}, bubbleFormats(leaf));
	              attributes = DeltaExports.AttributeMap.diff(formats, attributes) || {};
	            }
	          }
	        }
	        scrollLength += length;
	      } else {
	        deleteDelta.push(op);
	        if (op.retain !== null && typeof op.retain === 'object') {
	          const key = Object.keys(op.retain)[0];
	          if (key == null) return index;
	          this.scroll.updateEmbedAt(index, key, op.retain[key]);
	        }
	      }
	      Object.keys(attributes).forEach(name => {
	        this.scroll.formatAt(index, length, name, attributes[name]);
	      });
	      const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
	      const addedLength = isImplicitNewlineAppended ? 1 : 0;
	      scrollLength += prependedLength + addedLength;
	      deleteDelta.retain(prependedLength);
	      deleteDelta.delete(addedLength);
	      return index + length + prependedLength + addedLength;
	    }, 0);
	    deleteDelta.reduce((index, op) => {
	      if (typeof op.delete === 'number') {
	        this.scroll.deleteAt(index, op.delete);
	        return index;
	      }
	      return index + DeltaExports.Op.length(op);
	    }, 0);
	    this.scroll.batchEnd();
	    this.scroll.optimize();
	    return this.update(normalizedDelta);
	  }
	  deleteText(index, length) {
	    this.scroll.deleteAt(index, length);
	    return this.update(new Delta().retain(index).delete(length));
	  }
	  formatLine(index, length) {
	    let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    this.scroll.update();
	    Object.keys(formats).forEach(format => {
	      this.scroll.lines(index, Math.max(length, 1)).forEach(line => {
	        line.format(format, formats[format]);
	      });
	    });
	    this.scroll.optimize();
	    const delta = new Delta().retain(index).retain(length, cloneDeep$1(formats));
	    return this.update(delta);
	  }
	  formatText(index, length) {
	    let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    Object.keys(formats).forEach(format => {
	      this.scroll.formatAt(index, length, format, formats[format]);
	    });
	    const delta = new Delta().retain(index).retain(length, cloneDeep$1(formats));
	    return this.update(delta);
	  }
	  getContents(index, length) {
	    return this.delta.slice(index, index + length);
	  }
	  getDelta() {
	    return this.scroll.lines().reduce((delta, line) => {
	      return delta.concat(line.delta());
	    }, new Delta());
	  }
	  getFormat(index) {
	    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    let lines = [];
	    let leaves = [];
	    if (length === 0) {
	      this.scroll.path(index).forEach(path => {
	        const [blot] = path;
	        if (blot instanceof Block) {
	          lines.push(blot);
	        } else if (blot instanceof LeafBlot$1) {
	          leaves.push(blot);
	        }
	      });
	    } else {
	      lines = this.scroll.lines(index, length);
	      leaves = this.scroll.descendants(LeafBlot$1, index, length);
	    }
	    const [lineFormats, leafFormats] = [lines, leaves].map(blots => {
	      const blot = blots.shift();
	      if (blot == null) return {};
	      let formats = bubbleFormats(blot);
	      while (Object.keys(formats).length > 0) {
	        const blot = blots.shift();
	        if (blot == null) return formats;
	        formats = combineFormats(bubbleFormats(blot), formats);
	      }
	      return formats;
	    });
	    return {
	      ...lineFormats,
	      ...leafFormats
	    };
	  }
	  getHTML(index, length) {
	    const [line, lineOffset] = this.scroll.line(index);
	    if (line) {
	      const lineLength = line.length();
	      const isWithinLine = line.length() >= lineOffset + length;
	      if (isWithinLine && !(lineOffset === 0 && length === lineLength)) {
	        return convertHTML(line, lineOffset, length, true);
	      }
	      return convertHTML(this.scroll, index, length, true);
	    }
	    return '';
	  }
	  getText(index, length) {
	    return this.getContents(index, length).filter(op => typeof op.insert === 'string').map(op => op.insert).join('');
	  }
	  insertContents(index, contents) {
	    const normalizedDelta = normalizeDelta(contents);
	    const change = new Delta().retain(index).concat(normalizedDelta);
	    this.scroll.insertContents(index, normalizedDelta);
	    return this.update(change);
	  }
	  insertEmbed(index, embed, value) {
	    this.scroll.insertAt(index, embed, value);
	    return this.update(new Delta().retain(index).insert({
	      [embed]: value
	    }));
	  }
	  insertText(index, text) {
	    let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	    this.scroll.insertAt(index, text);
	    Object.keys(formats).forEach(format => {
	      this.scroll.formatAt(index, text.length, format, formats[format]);
	    });
	    return this.update(new Delta().retain(index).insert(text, cloneDeep$1(formats)));
	  }
	  isBlank() {
	    if (this.scroll.children.length === 0) return true;
	    if (this.scroll.children.length > 1) return false;
	    const blot = this.scroll.children.head;
	    if (blot?.statics.blotName !== Block.blotName) return false;
	    const block = blot;
	    if (block.children.length > 1) return false;
	    return block.children.head instanceof Break;
	  }
	  removeFormat(index, length) {
	    const text = this.getText(index, length);
	    const [line, offset] = this.scroll.line(index + length);
	    let suffixLength = 0;
	    let suffix = new Delta();
	    if (line != null) {
	      suffixLength = line.length() - offset;
	      suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	    }
	    const contents = this.getContents(index, length + suffixLength);
	    const diff = contents.diff(new Delta().insert(text).concat(suffix));
	    const delta = new Delta().retain(index).concat(diff);
	    return this.applyDelta(delta);
	  }
	  update(change) {
	    let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	    const oldDelta = this.delta;
	    if (mutations.length === 1 && mutations[0].type === 'characterData' &&
	    // @ts-expect-error Fix me later
	    mutations[0].target.data.match(ASCII) && this.scroll.find(mutations[0].target)) {
	      // Optimization for character changes
	      const textBlot = this.scroll.find(mutations[0].target);
	      const formats = bubbleFormats(textBlot);
	      const index = textBlot.offset(this.scroll);
	      // @ts-expect-error Fix me later
	      const oldValue = mutations[0].oldValue.replace(Cursor.CONTENTS, '');
	      const oldText = new Delta().insert(oldValue);
	      // @ts-expect-error
	      const newText = new Delta().insert(textBlot.value());
	      const relativeSelectionInfo = selectionInfo && {
	        oldRange: shiftRange$1(selectionInfo.oldRange, -index),
	        newRange: shiftRange$1(selectionInfo.newRange, -index)
	      };
	      const diffDelta = new Delta().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
	      change = diffDelta.reduce((delta, op) => {
	        if (op.insert) {
	          return delta.insert(op.insert, formats);
	        }
	        return delta.push(op);
	      }, new Delta());
	      this.delta = oldDelta.compose(change);
	    } else {
	      this.delta = this.getDelta();
	      if (!change || !isEqual$2(oldDelta.compose(change), this.delta)) {
	        change = oldDelta.diff(this.delta, selectionInfo);
	      }
	    }
	    return change;
	  }
	}
	function convertListHTML(items, lastIndent, types) {
	  if (items.length === 0) {
	    const [endTag] = getListType(types.pop());
	    if (lastIndent <= 0) {
	      return `</li></${endTag}>`;
	    }
	    return `</li></${endTag}>${convertListHTML([], lastIndent - 1, types)}`;
	  }
	  const [{
	    child,
	    offset,
	    length,
	    indent,
	    type
	  }, ...rest] = items;
	  const [tag, attribute] = getListType(type);
	  if (indent > lastIndent) {
	    types.push(type);
	    if (indent === lastIndent + 1) {
	      return `<${tag}><li${attribute}>${convertHTML(child, offset, length)}${convertListHTML(rest, indent, types)}`;
	    }
	    return `<${tag}><li>${convertListHTML(items, lastIndent + 1, types)}`;
	  }
	  const previousType = types[types.length - 1];
	  if (indent === lastIndent && type === previousType) {
	    return `</li><li${attribute}>${convertHTML(child, offset, length)}${convertListHTML(rest, indent, types)}`;
	  }
	  const [endTag] = getListType(types.pop());
	  return `</li></${endTag}>${convertListHTML(items, lastIndent - 1, types)}`;
	}
	function convertHTML(blot, index, length) {
	  let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  if ('html' in blot && typeof blot.html === 'function') {
	    return blot.html(index, length);
	  }
	  if (blot instanceof Text$1) {
	    return escapeText(blot.value().slice(index, index + length));
	  }
	  if (blot instanceof ParentBlot$1) {
	    // TODO fix API
	    if (blot.statics.blotName === 'list-container') {
	      const items = [];
	      blot.children.forEachAt(index, length, (child, offset, childLength) => {
	        const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
	        items.push({
	          child,
	          offset,
	          length: childLength,
	          indent: formats.indent || 0,
	          type: formats.list
	        });
	      });
	      return convertListHTML(items, -1, []);
	    }
	    const parts = [];
	    blot.children.forEachAt(index, length, (child, offset, childLength) => {
	      parts.push(convertHTML(child, offset, childLength));
	    });
	    if (isRoot || blot.statics.blotName === 'list') {
	      return parts.join('');
	    }
	    const {
	      outerHTML,
	      innerHTML
	    } = blot.domNode;
	    const [start, end] = outerHTML.split(`>${innerHTML}<`);
	    // TODO cleanup
	    if (start === '<table') {
	      return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
	    }
	    return `${start}>${parts.join('')}<${end}`;
	  }
	  return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
	}
	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce((merged, name) => {
	    if (formats[name] == null) return merged;
	    const combinedValue = combined[name];
	    if (combinedValue === formats[name]) {
	      merged[name] = combinedValue;
	    } else if (Array.isArray(combinedValue)) {
	      if (combinedValue.indexOf(formats[name]) < 0) {
	        merged[name] = combinedValue.concat([formats[name]]);
	      } else {
	        // If style already exists, don't add to an array, but don't lose other styles
	        merged[name] = combinedValue;
	      }
	    } else {
	      merged[name] = [combinedValue, formats[name]];
	    }
	    return merged;
	  }, {});
	}
	function getListType(type) {
	  const tag = type === 'ordered' ? 'ol' : 'ul';
	  switch (type) {
	    case 'checked':
	      return [tag, ' data-list="checked"'];
	    case 'unchecked':
	      return [tag, ' data-list="unchecked"'];
	    default:
	      return [tag, ''];
	  }
	}
	function normalizeDelta(delta) {
	  return delta.reduce((normalizedDelta, op) => {
	    if (typeof op.insert === 'string') {
	      const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return normalizedDelta.insert(text, op.attributes);
	    }
	    return normalizedDelta.push(op);
	  }, new Delta());
	}
	function shiftRange$1(_ref, amount) {
	  let {
	    index,
	    length
	  } = _ref;
	  return new Range(index + amount, length);
	}
	function splitOpLines(ops) {
	  const split = [];
	  ops.forEach(op => {
	    if (typeof op.insert === 'string') {
	      const lines = op.insert.split('\n');
	      lines.forEach((line, index) => {
	        if (index) split.push({
	          insert: '\n',
	          attributes: op.attributes
	        });
	        if (line) split.push({
	          insert: line,
	          attributes: op.attributes
	        });
	      });
	    } else {
	      split.push(op);
	    }
	  });
	  return split;
	}

	class Module {
	  static DEFAULTS = {};
	  constructor(quill) {
	    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    this.quill = quill;
	    this.options = options;
	  }
	}

	const GUARD_TEXT = '\uFEFF';
	class Embed extends EmbedBlot$1 {
	  constructor(scroll, node) {
	    super(scroll, node);
	    this.contentNode = document.createElement('span');
	    this.contentNode.setAttribute('contenteditable', 'false');
	    Array.from(this.domNode.childNodes).forEach(childNode => {
	      this.contentNode.appendChild(childNode);
	    });
	    this.leftGuard = document.createTextNode(GUARD_TEXT);
	    this.rightGuard = document.createTextNode(GUARD_TEXT);
	    this.domNode.appendChild(this.leftGuard);
	    this.domNode.appendChild(this.contentNode);
	    this.domNode.appendChild(this.rightGuard);
	  }
	  index(node, offset) {
	    if (node === this.leftGuard) return 0;
	    if (node === this.rightGuard) return 1;
	    return super.index(node, offset);
	  }
	  restore(node) {
	    let range = null;
	    let textNode;
	    const text = node.data.split(GUARD_TEXT).join('');
	    if (node === this.leftGuard) {
	      if (this.prev instanceof Text$1) {
	        const prevLength = this.prev.length();
	        this.prev.insertAt(prevLength, text);
	        range = {
	          startNode: this.prev.domNode,
	          startOffset: prevLength + text.length
	        };
	      } else {
	        textNode = document.createTextNode(text);
	        this.parent.insertBefore(this.scroll.create(textNode), this);
	        range = {
	          startNode: textNode,
	          startOffset: text.length
	        };
	      }
	    } else if (node === this.rightGuard) {
	      if (this.next instanceof Text$1) {
	        this.next.insertAt(0, text);
	        range = {
	          startNode: this.next.domNode,
	          startOffset: text.length
	        };
	      } else {
	        textNode = document.createTextNode(text);
	        this.parent.insertBefore(this.scroll.create(textNode), this.next);
	        range = {
	          startNode: textNode,
	          startOffset: text.length
	        };
	      }
	    }
	    node.data = GUARD_TEXT;
	    return range;
	  }
	  update(mutations, context) {
	    mutations.forEach(mutation => {
	      if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
	        const range = this.restore(mutation.target);
	        if (range) context.range = range;
	      }
	    });
	  }
	}

	class Composition {
	  isComposing = false;
	  constructor(scroll, emitter) {
	    this.scroll = scroll;
	    this.emitter = emitter;
	    this.setupListeners();
	  }
	  setupListeners() {
	    this.scroll.domNode.addEventListener('compositionstart', event => {
	      if (!this.isComposing) {
	        this.handleCompositionStart(event);
	      }
	    });
	    this.scroll.domNode.addEventListener('compositionend', event => {
	      if (this.isComposing) {
	        // Webkit makes DOM changes after compositionend, so we use microtask to
	        // ensure the order.
	        // https://bugs.webkit.org/show_bug.cgi?id=31902
	        queueMicrotask(() => {
	          this.handleCompositionEnd(event);
	        });
	      }
	    });
	  }
	  handleCompositionStart(event) {
	    const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
	    if (blot && !(blot instanceof Embed)) {
	      this.emitter.emit(Emitter.events.COMPOSITION_BEFORE_START, event);
	      this.scroll.batchStart();
	      this.emitter.emit(Emitter.events.COMPOSITION_START, event);
	      this.isComposing = true;
	    }
	  }
	  handleCompositionEnd(event) {
	    this.emitter.emit(Emitter.events.COMPOSITION_BEFORE_END, event);
	    this.scroll.batchEnd();
	    this.emitter.emit(Emitter.events.COMPOSITION_END, event);
	    this.isComposing = false;
	  }
	}

	class Theme {
	  static DEFAULTS = {
	    modules: {}
	  };
	  static themes = {
	    default: Theme
	  };
	  modules = {};
	  constructor(quill, options) {
	    this.quill = quill;
	    this.options = options;
	  }
	  init() {
	    Object.keys(this.options.modules).forEach(name => {
	      if (this.modules[name] == null) {
	        this.addModule(name);
	      }
	    });
	  }
	  addModule(name) {
	    // @ts-expect-error
	    const ModuleClass = this.quill.constructor.import(`modules/${name}`);
	    this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
	    return this.modules[name];
	  }
	}

	const getParentElement = element => element.parentElement || element.getRootNode().host || null;
	const getElementRect = element => {
	  const rect = element.getBoundingClientRect();
	  const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
	  const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
	  return {
	    top: rect.top,
	    right: rect.left + element.clientWidth * scaleX,
	    bottom: rect.top + element.clientHeight * scaleY,
	    left: rect.left
	  };
	};
	const paddingValueToInt = value => {
	  const number = parseInt(value, 10);
	  return Number.isNaN(number) ? 0 : number;
	};

	// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
	// assuming that the scroll option is set to 'nearest'.
	const getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd) => {
	  if (targetStart < scrollStart && targetEnd > scrollEnd) {
	    return 0;
	  }
	  if (targetStart < scrollStart) {
	    return -(scrollStart - targetStart + scrollPaddingStart);
	  }
	  if (targetEnd > scrollEnd) {
	    return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
	  }
	  return 0;
	};
	const scrollRectIntoView = (root, targetRect) => {
	  const document = root.ownerDocument;
	  let rect = targetRect;
	  let current = root;
	  while (current) {
	    const isDocumentBody = current === document.body;
	    const bounding = isDocumentBody ? {
	      top: 0,
	      right: window.visualViewport?.width ?? document.documentElement.clientWidth,
	      bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
	      left: 0
	    } : getElementRect(current);
	    const style = getComputedStyle(current);
	    const scrollDistanceX = getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, paddingValueToInt(style.scrollPaddingLeft), paddingValueToInt(style.scrollPaddingRight));
	    const scrollDistanceY = getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, paddingValueToInt(style.scrollPaddingTop), paddingValueToInt(style.scrollPaddingBottom));
	    if (scrollDistanceX || scrollDistanceY) {
	      if (isDocumentBody) {
	        document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
	      } else {
	        const {
	          scrollLeft,
	          scrollTop
	        } = current;
	        if (scrollDistanceY) {
	          current.scrollTop += scrollDistanceY;
	        }
	        if (scrollDistanceX) {
	          current.scrollLeft += scrollDistanceX;
	        }
	        const scrolledLeft = current.scrollLeft - scrollLeft;
	        const scrolledTop = current.scrollTop - scrollTop;
	        rect = {
	          left: rect.left - scrolledLeft,
	          top: rect.top - scrolledTop,
	          right: rect.right - scrolledLeft,
	          bottom: rect.bottom - scrolledTop
	        };
	      }
	    }
	    current = isDocumentBody || style.position === 'fixed' ? null : getParentElement(current);
	  }
	};

	const MAX_REGISTER_ITERATIONS = 100;
	const CORE_FORMATS = ['block', 'break', 'cursor', 'inline', 'scroll', 'text'];
	const createRegistryWithFormats = (formats, sourceRegistry, debug) => {
	  const registry = new Registry();
	  CORE_FORMATS.forEach(name => {
	    const coreBlot = sourceRegistry.query(name);
	    if (coreBlot) registry.register(coreBlot);
	  });
	  formats.forEach(name => {
	    let format = sourceRegistry.query(name);
	    if (!format) {
	      debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
	    }
	    let iterations = 0;
	    while (format) {
	      registry.register(format);
	      format = 'blotName' in format ? format.requiredContainer ?? null : null;
	      iterations += 1;
	      if (iterations > MAX_REGISTER_ITERATIONS) {
	        debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
	        break;
	      }
	    }
	  });
	  return registry;
	};

	const debug$3 = namespace('quill');
	const globalRegistry = new Registry();
	ParentBlot$1.uiClass = 'ql-ui';

	/**
	 * Options for initializing a Quill instance
	 */

	/**
	 * Similar to QuillOptions, but with all properties expanded to their default values,
	 * and all selectors resolved to HTMLElements.
	 */

	class Quill {
	  static DEFAULTS = {
	    bounds: null,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true,
	      uploader: true
	    },
	    placeholder: '',
	    readOnly: false,
	    registry: globalRegistry,
	    theme: 'default'
	  };
	  static events = Emitter.events;
	  static sources = Emitter.sources;
	  static version = "2.0.2";
	  static imports = {
	    delta: Delta,
	    parchment: Parchment,
	    'core/module': Module,
	    'core/theme': Theme
	  };
	  static debug(limit) {
	    if (limit === true) {
	      limit = 'log';
	    }
	    namespace.level(limit);
	  }
	  static find(node) {
	    let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    return instances.get(node) || globalRegistry.find(node, bubble);
	  }
	  static import(name) {
	    if (this.imports[name] == null) {
	      debug$3.error(`Cannot import ${name}. Are you sure it was registered?`);
	    }
	    return this.imports[name];
	  }
	  static register() {
	    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
	      const target = arguments.length <= 0 ? undefined : arguments[0];
	      const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
	      const name = 'attrName' in target ? target.attrName : target.blotName;
	      if (typeof name === 'string') {
	        // Shortcut for formats:
	        // register(Blot | Attributor, overwrite)
	        this.register(`formats/${name}`, target, overwrite);
	      } else {
	        Object.keys(target).forEach(key => {
	          this.register(key, target[key], overwrite);
	        });
	      }
	    } else {
	      const path = arguments.length <= 0 ? undefined : arguments[0];
	      const target = arguments.length <= 1 ? undefined : arguments[1];
	      const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
	      if (this.imports[path] != null && !overwrite) {
	        debug$3.warn(`Overwriting ${path} with`, target);
	      }
	      this.imports[path] = target;
	      if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') {
	        globalRegistry.register(target);
	      }
	      if (typeof target.register === 'function') {
	        target.register(globalRegistry);
	      }
	    }
	  }
	  constructor(container) {
	    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    this.options = expandConfig(container, options);
	    this.container = this.options.container;
	    if (this.container == null) {
	      debug$3.error('Invalid Quill container', container);
	      return;
	    }
	    if (this.options.debug) {
	      Quill.debug(this.options.debug);
	    }
	    const html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    instances.set(this.container, this);
	    this.root = this.addContainer('ql-editor');
	    this.root.classList.add('ql-blank');
	    this.emitter = new Emitter();
	    const scrollBlotName = ScrollBlot$1.blotName;
	    const ScrollBlot = this.options.registry.query(scrollBlotName);
	    if (!ScrollBlot || !('blotName' in ScrollBlot)) {
	      throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
	    }
	    this.scroll = new ScrollBlot(this.options.registry, this.root, {
	      emitter: this.emitter
	    });
	    this.editor = new Editor(this.scroll);
	    this.selection = new Selection(this.scroll, this.emitter);
	    this.composition = new Composition(this.scroll, this.emitter);
	    this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.uploader = this.theme.addModule('uploader');
	    this.theme.addModule('input');
	    this.theme.addModule('uiNode');
	    this.theme.init();
	    this.emitter.on(Emitter.events.EDITOR_CHANGE, type => {
	      if (type === Emitter.events.TEXT_CHANGE) {
	        this.root.classList.toggle('ql-blank', this.editor.isBlank());
	      }
	    });
	    this.emitter.on(Emitter.events.SCROLL_UPDATE, (source, mutations) => {
	      const oldRange = this.selection.lastRange;
	      const [newRange] = this.selection.getRange();
	      const selectionInfo = oldRange && newRange ? {
	        oldRange,
	        newRange
	      } : undefined;
	      modify.call(this, () => this.editor.update(null, mutations, selectionInfo), source);
	    });
	    this.emitter.on(Emitter.events.SCROLL_EMBED_UPDATE, (blot, delta) => {
	      const oldRange = this.selection.lastRange;
	      const [newRange] = this.selection.getRange();
	      const selectionInfo = oldRange && newRange ? {
	        oldRange,
	        newRange
	      } : undefined;
	      modify.call(this, () => {
	        const change = new Delta().retain(blot.offset(this)).retain({
	          [blot.statics.blotName]: delta
	        });
	        return this.editor.update(change, [], selectionInfo);
	      }, Quill.sources.USER);
	    });
	    if (html) {
	      const contents = this.clipboard.convert({
	        html: `${html}<p><br></p>`,
	        text: '\n'
	      });
	      this.setContents(contents);
	    }
	    this.history.clear();
	    if (this.options.placeholder) {
	      this.root.setAttribute('data-placeholder', this.options.placeholder);
	    }
	    if (this.options.readOnly) {
	      this.disable();
	    }
	    this.allowReadOnlyEdits = false;
	  }
	  addContainer(container) {
	    let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    if (typeof container === 'string') {
	      const className = container;
	      container = document.createElement('div');
	      container.classList.add(className);
	    }
	    this.container.insertBefore(container, refNode);
	    return container;
	  }
	  blur() {
	    this.selection.setRange(null);
	  }
	  deleteText(index, length, source) {
	    // @ts-expect-error
	    [index, length,, source] = overload(index, length, source);
	    return modify.call(this, () => {
	      return this.editor.deleteText(index, length);
	    }, source, index, -1 * length);
	  }
	  disable() {
	    this.enable(false);
	  }
	  editReadOnly(modifier) {
	    this.allowReadOnlyEdits = true;
	    const value = modifier();
	    this.allowReadOnlyEdits = false;
	    return value;
	  }
	  enable() {
	    let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    this.scroll.enable(enabled);
	    this.container.classList.toggle('ql-disabled', !enabled);
	  }
	  focus() {
	    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    this.selection.focus();
	    if (!options.preventScroll) {
	      this.scrollSelectionIntoView();
	    }
	  }
	  format(name, value) {
	    let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Emitter.sources.API;
	    return modify.call(this, () => {
	      const range = this.getSelection(true);
	      let change = new Delta();
	      if (range == null) return change;
	      if (this.scroll.query(name, Scope.BLOCK)) {
	        change = this.editor.formatLine(range.index, range.length, {
	          [name]: value
	        });
	      } else if (range.length === 0) {
	        this.selection.format(name, value);
	        return change;
	      } else {
	        change = this.editor.formatText(range.index, range.length, {
	          [name]: value
	        });
	      }
	      this.setSelection(range, Emitter.sources.SILENT);
	      return change;
	    }, source);
	  }
	  formatLine(index, length, name, value, source) {
	    let formats;
	    // eslint-disable-next-line prefer-const
	    [index, length, formats, source] = overload(index, length,
	    // @ts-expect-error
	    name, value, source);
	    return modify.call(this, () => {
	      return this.editor.formatLine(index, length, formats);
	    }, source, index, 0);
	  }
	  formatText(index, length, name, value, source) {
	    let formats;
	    // eslint-disable-next-line prefer-const
	    [index, length, formats, source] = overload(
	    // @ts-expect-error
	    index, length, name, value, source);
	    return modify.call(this, () => {
	      return this.editor.formatText(index, length, formats);
	    }, source, index, 0);
	  }
	  getBounds(index) {
	    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    let bounds = null;
	    if (typeof index === 'number') {
	      bounds = this.selection.getBounds(index, length);
	    } else {
	      bounds = this.selection.getBounds(index.index, index.length);
	    }
	    if (!bounds) return null;
	    const containerBounds = this.container.getBoundingClientRect();
	    return {
	      bottom: bounds.bottom - containerBounds.top,
	      height: bounds.height,
	      left: bounds.left - containerBounds.left,
	      right: bounds.right - containerBounds.left,
	      top: bounds.top - containerBounds.top,
	      width: bounds.width
	    };
	  }
	  getContents() {
	    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	    [index, length] = overload(index, length);
	    return this.editor.getContents(index, length);
	  }
	  getFormat() {
	    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
	    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    if (typeof index === 'number') {
	      return this.editor.getFormat(index, length);
	    }
	    return this.editor.getFormat(index.index, index.length);
	  }
	  getIndex(blot) {
	    return blot.offset(this.scroll);
	  }
	  getLength() {
	    return this.scroll.length();
	  }
	  getLeaf(index) {
	    return this.scroll.leaf(index);
	  }
	  getLine(index) {
	    return this.scroll.line(index);
	  }
	  getLines() {
	    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	    if (typeof index !== 'number') {
	      return this.scroll.lines(index.index, index.length);
	    }
	    return this.scroll.lines(index, length);
	  }
	  getModule(name) {
	    return this.theme.modules[name];
	  }
	  getSelection() {
	    let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    if (focus) this.focus();
	    this.update(); // Make sure we access getRange with editor in consistent state
	    return this.selection.getRange()[0];
	  }
	  getSemanticHTML() {
	    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    let length = arguments.length > 1 ? arguments[1] : undefined;
	    if (typeof index === 'number') {
	      length = length ?? this.getLength() - index;
	    }
	    // @ts-expect-error
	    [index, length] = overload(index, length);
	    return this.editor.getHTML(index, length);
	  }
	  getText() {
	    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    let length = arguments.length > 1 ? arguments[1] : undefined;
	    if (typeof index === 'number') {
	      length = length ?? this.getLength() - index;
	    }
	    // @ts-expect-error
	    [index, length] = overload(index, length);
	    return this.editor.getText(index, length);
	  }
	  hasFocus() {
	    return this.selection.hasFocus();
	  }
	  insertEmbed(index, embed, value) {
	    let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
	    return modify.call(this, () => {
	      return this.editor.insertEmbed(index, embed, value);
	    }, source, index);
	  }
	  insertText(index, text, name, value, source) {
	    let formats;
	    // eslint-disable-next-line prefer-const
	    // @ts-expect-error
	    [index,, formats, source] = overload(index, 0, name, value, source);
	    return modify.call(this, () => {
	      return this.editor.insertText(index, text, formats);
	    }, source, index, text.length);
	  }
	  isEnabled() {
	    return this.scroll.isEnabled();
	  }
	  off() {
	    return this.emitter.off(...arguments);
	  }
	  on() {
	    return this.emitter.on(...arguments);
	  }
	  once() {
	    return this.emitter.once(...arguments);
	  }
	  removeFormat(index, length, source) {
	    [index, length,, source] = overload(index, length, source);
	    return modify.call(this, () => {
	      return this.editor.removeFormat(index, length);
	    }, source, index);
	  }
	  scrollRectIntoView(rect) {
	    scrollRectIntoView(this.root, rect);
	  }

	  /**
	   * @deprecated Use Quill#scrollSelectionIntoView() instead.
	   */
	  scrollIntoView() {
	    console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
	    this.scrollSelectionIntoView();
	  }

	  /**
	   * Scroll the current selection into the visible area.
	   * If the selection is already visible, no scrolling will occur.
	   */
	  scrollSelectionIntoView() {
	    const range = this.selection.lastRange;
	    const bounds = range && this.selection.getBounds(range.index, range.length);
	    if (bounds) {
	      this.scrollRectIntoView(bounds);
	    }
	  }
	  setContents(delta) {
	    let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Emitter.sources.API;
	    return modify.call(this, () => {
	      delta = new Delta(delta);
	      const length = this.getLength();
	      // Quill will set empty editor to \n
	      const delete1 = this.editor.deleteText(0, length);
	      const applied = this.editor.insertContents(0, delta);
	      // Remove extra \n from empty editor initialization
	      const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
	      return delete1.compose(applied).compose(delete2);
	    }, source);
	  }
	  setSelection(index, length, source) {
	    if (index == null) {
	      // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
	      this.selection.setRange(null, length || Quill.sources.API);
	    } else {
	      // @ts-expect-error
	      [index, length,, source] = overload(index, length, source);
	      this.selection.setRange(new Range(Math.max(0, index), length), source);
	      if (source !== Emitter.sources.SILENT) {
	        this.scrollSelectionIntoView();
	      }
	    }
	  }
	  setText(text) {
	    let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Emitter.sources.API;
	    const delta = new Delta().insert(text);
	    return this.setContents(delta, source);
	  }
	  update() {
	    let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Emitter.sources.USER;
	    const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	    this.selection.update(source);
	    // TODO this is usually undefined
	    return change;
	  }
	  updateContents(delta) {
	    let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Emitter.sources.API;
	    return modify.call(this, () => {
	      delta = new Delta(delta);
	      return this.editor.applyDelta(delta);
	    }, source, true);
	  }
	}
	function resolveSelector(selector) {
	  return typeof selector === 'string' ? document.querySelector(selector) : selector;
	}
	function expandModuleConfig(config) {
	  return Object.entries(config ?? {}).reduce((expanded, _ref) => {
	    let [key, value] = _ref;
	    return {
	      ...expanded,
	      [key]: value === true ? {} : value
	    };
	  }, {});
	}
	function omitUndefinedValuesFromOptions(obj) {
	  return Object.fromEntries(Object.entries(obj).filter(entry => entry[1] !== undefined));
	}
	function expandConfig(containerOrSelector, options) {
	  const container = resolveSelector(containerOrSelector);
	  if (!container) {
	    throw new Error('Invalid Quill container');
	  }
	  const shouldUseDefaultTheme = !options.theme || options.theme === Quill.DEFAULTS.theme;
	  const theme = shouldUseDefaultTheme ? Theme : Quill.import(`themes/${options.theme}`);
	  if (!theme) {
	    throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
	  }
	  const {
	    modules: quillModuleDefaults,
	    ...quillDefaults
	  } = Quill.DEFAULTS;
	  const {
	    modules: themeModuleDefaults,
	    ...themeDefaults
	  } = theme.DEFAULTS;
	  let userModuleOptions = expandModuleConfig(options.modules);
	  // Special case toolbar shorthand
	  if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) {
	    userModuleOptions = {
	      ...userModuleOptions,
	      toolbar: {
	        container: userModuleOptions.toolbar
	      }
	    };
	  }
	  const modules = merge$1({}, expandModuleConfig(quillModuleDefaults), expandModuleConfig(themeModuleDefaults), userModuleOptions);
	  const config = {
	    ...quillDefaults,
	    ...omitUndefinedValuesFromOptions(themeDefaults),
	    ...omitUndefinedValuesFromOptions(options)
	  };
	  let registry = options.registry;
	  if (registry) {
	    if (options.formats) {
	      debug$3.warn('Ignoring "formats" option because "registry" is specified');
	    }
	  } else {
	    registry = options.formats ? createRegistryWithFormats(options.formats, config.registry, debug$3) : config.registry;
	  }
	  return {
	    ...config,
	    registry,
	    container,
	    theme,
	    modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2) => {
	      let [name, value] = _ref2;
	      if (!value) return modulesWithDefaults;
	      const moduleClass = Quill.import(`modules/${name}`);
	      if (moduleClass == null) {
	        debug$3.error(`Cannot load ${name} module. Are you sure you registered it?`);
	        return modulesWithDefaults;
	      }
	      return {
	        ...modulesWithDefaults,
	        // @ts-expect-error
	        [name]: merge$1({}, moduleClass.DEFAULTS || {}, value)
	      };
	    }, {}),
	    bounds: resolveSelector(config.bounds)
	  };
	}

	// Handle selection preservation and TEXT_CHANGE emission
	// common to modification APIs
	function modify(modifier, source, index, shift) {
	  if (!this.isEnabled() && source === Emitter.sources.USER && !this.allowReadOnlyEdits) {
	    return new Delta();
	  }
	  let range = index == null ? null : this.getSelection();
	  const oldDelta = this.editor.delta;
	  const change = modifier();
	  if (range != null) {
	    if (index === true) {
	      index = range.index; // eslint-disable-line prefer-destructuring
	    }
	    if (shift == null) {
	      range = shiftRange(range, change, source);
	    } else if (shift !== 0) {
	      // @ts-expect-error index should always be number
	      range = shiftRange(range, index, shift, source);
	    }
	    this.setSelection(range, Emitter.sources.SILENT);
	  }
	  if (change.length() > 0) {
	    const args = [Emitter.events.TEXT_CHANGE, change, oldDelta, source];
	    this.emitter.emit(Emitter.events.EDITOR_CHANGE, ...args);
	    if (source !== Emitter.sources.SILENT) {
	      this.emitter.emit(...args);
	    }
	  }
	  return change;
	}
	function overload(index, length, name, value, source) {
	  let formats = {};
	  // @ts-expect-error
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      // @ts-expect-error
	      source = value;
	      value = name;
	      name = length;
	      // @ts-expect-error
	      length = index.length; // eslint-disable-line prefer-destructuring
	      // @ts-expect-error
	      index = index.index; // eslint-disable-line prefer-destructuring
	    } else {
	      // @ts-expect-error
	      length = index.length; // eslint-disable-line prefer-destructuring
	      // @ts-expect-error
	      index = index.index; // eslint-disable-line prefer-destructuring
	    }
	  } else if (typeof length !== 'number') {
	    // @ts-expect-error
	    source = value;
	    value = name;
	    name = length;
	    length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if (typeof name === 'object') {
	    // @ts-expect-error Fix me later
	    formats = name;
	    // @ts-expect-error
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      // @ts-expect-error
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || Emitter.sources.API;
	  // @ts-expect-error
	  return [index, length, formats, source];
	}
	function shiftRange(range, index, lengthOrSource, source) {
	  const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
	  if (range == null) return null;
	  let start;
	  let end;
	  // @ts-expect-error -- TODO: add a better type guard around `index`
	  if (index && typeof index.transformPosition === 'function') {
	    [start, end] = [range.index, range.index + range.length].map(pos =>
	    // @ts-expect-error -- TODO: add a better type guard around `index`
	    index.transformPosition(pos, source !== Emitter.sources.USER));
	  } else {
	    [start, end] = [range.index, range.index + range.length].map(pos => {
	      // @ts-expect-error -- TODO: add a better type guard around `index`
	      if (pos < index || pos === index && source === Emitter.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      }
	      // @ts-expect-error -- TODO: add a better type guard around `index`
	      return Math.max(index, pos + length);
	    });
	  }
	  return new Range(start, end - start);
	}

	class Container extends ContainerBlot$1 {}

	function isLine$1(blot) {
	  return blot instanceof Block || blot instanceof BlockEmbed;
	}
	function isUpdatable(blot) {
	  return typeof blot.updateContent === 'function';
	}
	class Scroll extends ScrollBlot$1 {
	  static blotName = 'scroll';
	  static className = 'ql-editor';
	  static tagName = 'DIV';
	  static defaultChild = Block;
	  static allowedChildren = [Block, BlockEmbed, Container];
	  constructor(registry, domNode, _ref) {
	    let {
	      emitter
	    } = _ref;
	    super(registry, domNode);
	    this.emitter = emitter;
	    this.batch = false;
	    this.optimize();
	    this.enable();
	    this.domNode.addEventListener('dragstart', e => this.handleDragStart(e));
	  }
	  batchStart() {
	    if (!Array.isArray(this.batch)) {
	      this.batch = [];
	    }
	  }
	  batchEnd() {
	    if (!this.batch) return;
	    const mutations = this.batch;
	    this.batch = false;
	    this.update(mutations);
	  }
	  emitMount(blot) {
	    this.emitter.emit(Emitter.events.SCROLL_BLOT_MOUNT, blot);
	  }
	  emitUnmount(blot) {
	    this.emitter.emit(Emitter.events.SCROLL_BLOT_UNMOUNT, blot);
	  }
	  emitEmbedUpdate(blot, change) {
	    this.emitter.emit(Emitter.events.SCROLL_EMBED_UPDATE, blot, change);
	  }
	  deleteAt(index, length) {
	    const [first, offset] = this.line(index);
	    const [last] = this.line(index + length);
	    super.deleteAt(index, length);
	    if (last != null && first !== last && offset > 0) {
	      if (first instanceof BlockEmbed || last instanceof BlockEmbed) {
	        this.optimize();
	        return;
	      }
	      const ref = last.children.head instanceof Break ? null : last.children.head;
	      // @ts-expect-error
	      first.moveChildren(last, ref);
	      // @ts-expect-error
	      first.remove();
	    }
	    this.optimize();
	  }
	  enable() {
	    let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
	  }
	  formatAt(index, length, format, value) {
	    super.formatAt(index, length, format, value);
	    this.optimize();
	  }
	  insertAt(index, value, def) {
	    if (index >= this.length()) {
	      if (def == null || this.scroll.query(value, Scope.BLOCK) == null) {
	        const blot = this.scroll.create(this.statics.defaultChild.blotName);
	        this.appendChild(blot);
	        if (def == null && value.endsWith('\n')) {
	          blot.insertAt(0, value.slice(0, -1), def);
	        } else {
	          blot.insertAt(0, value, def);
	        }
	      } else {
	        const embed = this.scroll.create(value, def);
	        this.appendChild(embed);
	      }
	    } else {
	      super.insertAt(index, value, def);
	    }
	    this.optimize();
	  }
	  insertBefore(blot, ref) {
	    if (blot.statics.scope === Scope.INLINE_BLOT) {
	      const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
	      wrapper.appendChild(blot);
	      super.insertBefore(wrapper, ref);
	    } else {
	      super.insertBefore(blot, ref);
	    }
	  }
	  insertContents(index, delta) {
	    const renderBlocks = this.deltaToRenderBlocks(delta.concat(new Delta().insert('\n')));
	    const last = renderBlocks.pop();
	    if (last == null) return;
	    this.batchStart();
	    const first = renderBlocks.shift();
	    if (first) {
	      const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant(BlockEmbed, index)[0] && index < this.length());
	      const delta = first.type === 'block' ? first.delta : new Delta().insert({
	        [first.key]: first.value
	      });
	      insertInlineContents(this, index, delta);
	      const newlineCharLength = first.type === 'block' ? 1 : 0;
	      const lineEndIndex = index + delta.length() + newlineCharLength;
	      if (shouldInsertNewlineChar) {
	        this.insertAt(lineEndIndex - 1, '\n');
	      }
	      const formats = bubbleFormats(this.line(index)[0]);
	      const attributes = DeltaExports.AttributeMap.diff(formats, first.attributes) || {};
	      Object.keys(attributes).forEach(name => {
	        this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
	      });
	      index = lineEndIndex;
	    }
	    let [refBlot, refBlotOffset] = this.children.find(index);
	    if (renderBlocks.length) {
	      if (refBlot) {
	        refBlot = refBlot.split(refBlotOffset);
	        refBlotOffset = 0;
	      }
	      renderBlocks.forEach(renderBlock => {
	        if (renderBlock.type === 'block') {
	          const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
	          insertInlineContents(block, 0, renderBlock.delta);
	        } else {
	          const blockEmbed = this.create(renderBlock.key, renderBlock.value);
	          this.insertBefore(blockEmbed, refBlot || undefined);
	          Object.keys(renderBlock.attributes).forEach(name => {
	            blockEmbed.format(name, renderBlock.attributes[name]);
	          });
	        }
	      });
	    }
	    if (last.type === 'block' && last.delta.length()) {
	      const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
	      insertInlineContents(this, offset, last.delta);
	    }
	    this.batchEnd();
	    this.optimize();
	  }
	  isEnabled() {
	    return this.domNode.getAttribute('contenteditable') === 'true';
	  }
	  leaf(index) {
	    const last = this.path(index).pop();
	    if (!last) {
	      return [null, -1];
	    }
	    const [blot, offset] = last;
	    return blot instanceof LeafBlot$1 ? [blot, offset] : [null, -1];
	  }
	  line(index) {
	    if (index === this.length()) {
	      return this.line(index - 1);
	    }
	    // @ts-expect-error TODO: make descendant() generic
	    return this.descendant(isLine$1, index);
	  }
	  lines() {
	    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	    const getLines = (blot, blotIndex, blotLength) => {
	      let lines = [];
	      let lengthLeft = blotLength;
	      blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength) => {
	        if (isLine$1(child)) {
	          lines.push(child);
	        } else if (child instanceof ContainerBlot$1) {
	          lines = lines.concat(getLines(child, childIndex, lengthLeft));
	        }
	        lengthLeft -= childLength;
	      });
	      return lines;
	    };
	    return getLines(this, index, length);
	  }
	  optimize() {
	    let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    if (this.batch) return;
	    super.optimize(mutations, context);
	    if (mutations.length > 0) {
	      this.emitter.emit(Emitter.events.SCROLL_OPTIMIZE, mutations, context);
	    }
	  }
	  path(index) {
	    return super.path(index).slice(1); // Exclude self
	  }
	  remove() {
	    // Never remove self
	  }
	  update(mutations) {
	    if (this.batch) {
	      if (Array.isArray(mutations)) {
	        this.batch = this.batch.concat(mutations);
	      }
	      return;
	    }
	    let source = Emitter.sources.USER;
	    if (typeof mutations === 'string') {
	      source = mutations;
	    }
	    if (!Array.isArray(mutations)) {
	      mutations = this.observer.takeRecords();
	    }
	    mutations = mutations.filter(_ref2 => {
	      let {
	        target
	      } = _ref2;
	      const blot = this.find(target, true);
	      return blot && !isUpdatable(blot);
	    });
	    if (mutations.length > 0) {
	      this.emitter.emit(Emitter.events.SCROLL_BEFORE_UPDATE, source, mutations);
	    }
	    super.update(mutations.concat([])); // pass copy
	    if (mutations.length > 0) {
	      this.emitter.emit(Emitter.events.SCROLL_UPDATE, source, mutations);
	    }
	  }
	  updateEmbedAt(index, key, change) {
	    // Currently it only supports top-level embeds (BlockEmbed).
	    // We can update `ParentBlot` in parchment to support inline embeds.
	    const [blot] = this.descendant(b => b instanceof BlockEmbed, index);
	    if (blot && blot.statics.blotName === key && isUpdatable(blot)) {
	      blot.updateContent(change);
	    }
	  }
	  handleDragStart(event) {
	    event.preventDefault();
	  }
	  deltaToRenderBlocks(delta) {
	    const renderBlocks = [];
	    let currentBlockDelta = new Delta();
	    delta.forEach(op => {
	      const insert = op?.insert;
	      if (!insert) return;
	      if (typeof insert === 'string') {
	        const splitted = insert.split('\n');
	        splitted.slice(0, -1).forEach(text => {
	          currentBlockDelta.insert(text, op.attributes);
	          renderBlocks.push({
	            type: 'block',
	            delta: currentBlockDelta,
	            attributes: op.attributes ?? {}
	          });
	          currentBlockDelta = new Delta();
	        });
	        const last = splitted[splitted.length - 1];
	        if (last) {
	          currentBlockDelta.insert(last, op.attributes);
	        }
	      } else {
	        const key = Object.keys(insert)[0];
	        if (!key) return;
	        if (this.query(key, Scope.INLINE)) {
	          currentBlockDelta.push(op);
	        } else {
	          if (currentBlockDelta.length()) {
	            renderBlocks.push({
	              type: 'block',
	              delta: currentBlockDelta,
	              attributes: {}
	            });
	          }
	          currentBlockDelta = new Delta();
	          renderBlocks.push({
	            type: 'blockEmbed',
	            key,
	            value: insert[key],
	            attributes: op.attributes ?? {}
	          });
	        }
	      }
	    });
	    if (currentBlockDelta.length()) {
	      renderBlocks.push({
	        type: 'block',
	        delta: currentBlockDelta,
	        attributes: {}
	      });
	    }
	    return renderBlocks;
	  }
	  createBlock(attributes, refBlot) {
	    let blotName;
	    const formats = {};
	    Object.entries(attributes).forEach(_ref3 => {
	      let [key, value] = _ref3;
	      const isBlockBlot = this.query(key, Scope.BLOCK & Scope.BLOT) != null;
	      if (isBlockBlot) {
	        blotName = key;
	      } else {
	        formats[key] = value;
	      }
	    });
	    const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
	    this.insertBefore(block, refBlot || undefined);
	    const length = block.length();
	    Object.entries(formats).forEach(_ref4 => {
	      let [key, value] = _ref4;
	      block.formatAt(0, length, key, value);
	    });
	    return block;
	  }
	}
	function insertInlineContents(parent, index, inlineContents) {
	  inlineContents.reduce((index, op) => {
	    const length = DeltaExports.Op.length(op);
	    let attributes = op.attributes || {};
	    if (op.insert != null) {
	      if (typeof op.insert === 'string') {
	        const text = op.insert;
	        parent.insertAt(index, text);
	        const [leaf] = parent.descendant(LeafBlot$1, index);
	        const formats = bubbleFormats(leaf);
	        attributes = DeltaExports.AttributeMap.diff(formats, attributes) || {};
	      } else if (typeof op.insert === 'object') {
	        const key = Object.keys(op.insert)[0]; // There should only be one key
	        if (key == null) return index;
	        parent.insertAt(index, key, op.insert[key]);
	        const isInlineEmbed = parent.scroll.query(key, Scope.INLINE) != null;
	        if (isInlineEmbed) {
	          const [leaf] = parent.descendant(LeafBlot$1, index);
	          const formats = bubbleFormats(leaf);
	          attributes = DeltaExports.AttributeMap.diff(formats, attributes) || {};
	        }
	      }
	    }
	    Object.keys(attributes).forEach(key => {
	      parent.formatAt(index, length, key, attributes[key]);
	    });
	    return index + length;
	  }, index);
	}

	const config$2 = {
	  scope: Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};
	const AlignAttribute = new Attributor('align', 'align', config$2);
	const AlignClass = new ClassAttributor$1('align', 'ql-align', config$2);
	const AlignStyle = new StyleAttributor$1('align', 'text-align', config$2);

	class ColorAttributor extends StyleAttributor$1 {
	  value(domNode) {
	    let value = super.value(domNode);
	    if (!value.startsWith('rgb(')) return value;
	    value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	    const hex = value.split(',').map(component => `00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
	    return `#${hex}`;
	  }
	}
	const ColorClass = new ClassAttributor$1('color', 'ql-color', {
	  scope: Scope.INLINE
	});
	const ColorStyle = new ColorAttributor('color', 'color', {
	  scope: Scope.INLINE
	});

	const BackgroundClass = new ClassAttributor$1('background', 'ql-bg', {
	  scope: Scope.INLINE
	});
	const BackgroundStyle = new ColorAttributor('background', 'background-color', {
	  scope: Scope.INLINE
	});

	class CodeBlockContainer extends Container {
	  static create(value) {
	    const domNode = super.create(value);
	    domNode.setAttribute('spellcheck', 'false');
	    return domNode;
	  }
	  code(index, length) {
	    return this.children
	    // @ts-expect-error
	    .map(child => child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
	  }
	  html(index, length) {
	    // `\n`s are needed in order to support empty lines at the beginning and the end.
	    // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
	    return `<pre>\n${escapeText(this.code(index, length))}\n</pre>`;
	  }
	}
	class CodeBlock extends Block {
	  static TAB = '  ';
	  static register() {
	    Quill.register(CodeBlockContainer);
	  }
	}
	class Code extends Inline {}
	Code.blotName = 'code';
	Code.tagName = 'CODE';
	CodeBlock.blotName = 'code-block';
	CodeBlock.className = 'ql-code-block';
	CodeBlock.tagName = 'DIV';
	CodeBlockContainer.blotName = 'code-block-container';
	CodeBlockContainer.className = 'ql-code-block-container';
	CodeBlockContainer.tagName = 'DIV';
	CodeBlockContainer.allowedChildren = [CodeBlock];
	CodeBlock.allowedChildren = [Text$1, Break, Cursor];
	CodeBlock.requiredContainer = CodeBlockContainer;

	const config$1 = {
	  scope: Scope.BLOCK,
	  whitelist: ['rtl']
	};
	const DirectionAttribute = new Attributor('direction', 'dir', config$1);
	const DirectionClass = new ClassAttributor$1('direction', 'ql-direction', config$1);
	const DirectionStyle = new StyleAttributor$1('direction', 'direction', config$1);

	const config = {
	  scope: Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};
	const FontClass = new ClassAttributor$1('font', 'ql-font', config);
	class FontStyleAttributor extends StyleAttributor$1 {
	  value(node) {
	    return super.value(node).replace(/["']/g, '');
	  }
	}
	const FontStyle = new FontStyleAttributor('font', 'font-family', config);

	const SizeClass = new ClassAttributor$1('size', 'ql-size', {
	  scope: Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	const SizeStyle = new StyleAttributor$1('size', 'font-size', {
	  scope: Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});

	const debug$2 = namespace('quill:keyboard');
	const SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
	class Keyboard extends Module {
	  static match(evt, binding) {
	    if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(key => {
	      return !!binding[key] !== evt[key] && binding[key] !== null;
	    })) {
	      return false;
	    }
	    return binding.key === evt.key || binding.key === evt.which;
	  }
	  constructor(quill, options) {
	    super(quill, options);
	    this.bindings = {};
	    // @ts-expect-error Fix me later
	    Object.keys(this.options.bindings).forEach(name => {
	      // @ts-expect-error Fix me later
	      if (this.options.bindings[name]) {
	        // @ts-expect-error Fix me later
	        this.addBinding(this.options.bindings[name]);
	      }
	    });
	    this.addBinding({
	      key: 'Enter',
	      shiftKey: null
	    }, this.handleEnter);
	    this.addBinding({
	      key: 'Enter',
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null
	    }, () => {});
	    if (/Firefox/i.test(navigator.userAgent)) {
	      // Need to handle delete and backspace for Firefox in the general case #1171
	      this.addBinding({
	        key: 'Backspace'
	      }, {
	        collapsed: true
	      }, this.handleBackspace);
	      this.addBinding({
	        key: 'Delete'
	      }, {
	        collapsed: true
	      }, this.handleDelete);
	    } else {
	      this.addBinding({
	        key: 'Backspace'
	      }, {
	        collapsed: true,
	        prefix: /^.?$/
	      }, this.handleBackspace);
	      this.addBinding({
	        key: 'Delete'
	      }, {
	        collapsed: true,
	        suffix: /^.?$/
	      }, this.handleDelete);
	    }
	    this.addBinding({
	      key: 'Backspace'
	    }, {
	      collapsed: false
	    }, this.handleDeleteRange);
	    this.addBinding({
	      key: 'Delete'
	    }, {
	      collapsed: false
	    }, this.handleDeleteRange);
	    this.addBinding({
	      key: 'Backspace',
	      altKey: null,
	      ctrlKey: null,
	      metaKey: null,
	      shiftKey: null
	    }, {
	      collapsed: true,
	      offset: 0
	    }, this.handleBackspace);
	    this.listen();
	  }
	  addBinding(keyBinding) {
	    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    const binding = normalize$2(keyBinding);
	    if (binding == null) {
	      debug$2.warn('Attempted to add invalid keyboard binding', binding);
	      return;
	    }
	    if (typeof context === 'function') {
	      context = {
	        handler: context
	      };
	    }
	    if (typeof handler === 'function') {
	      handler = {
	        handler
	      };
	    }
	    const keys = Array.isArray(binding.key) ? binding.key : [binding.key];
	    keys.forEach(key => {
	      const singleBinding = {
	        ...binding,
	        key,
	        ...context,
	        ...handler
	      };
	      this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
	      this.bindings[singleBinding.key].push(singleBinding);
	    });
	  }
	  listen() {
	    this.quill.root.addEventListener('keydown', evt => {
	      if (evt.defaultPrevented || evt.isComposing) return;

	      // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
	      // https://bugs.webkit.org/show_bug.cgi?id=165004
	      const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
	      if (isComposing) return;
	      const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
	      const matches = bindings.filter(binding => Keyboard.match(evt, binding));
	      if (matches.length === 0) return;
	      // @ts-expect-error
	      const blot = Quill.find(evt.target, true);
	      if (blot && blot.scroll !== this.quill.scroll) return;
	      const range = this.quill.getSelection();
	      if (range == null || !this.quill.hasFocus()) return;
	      const [line, offset] = this.quill.getLine(range.index);
	      const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
	      const [leafEnd, offsetEnd] = range.length === 0 ? [leafStart, offsetStart] : this.quill.getLeaf(range.index + range.length);
	      const prefixText = leafStart instanceof TextBlot$1 ? leafStart.value().slice(0, offsetStart) : '';
	      const suffixText = leafEnd instanceof TextBlot$1 ? leafEnd.value().slice(offsetEnd) : '';
	      const curContext = {
	        collapsed: range.length === 0,
	        // @ts-expect-error Fix me later
	        empty: range.length === 0 && line.length() <= 1,
	        format: this.quill.getFormat(range),
	        line,
	        offset,
	        prefix: prefixText,
	        suffix: suffixText,
	        event: evt
	      };
	      const prevented = matches.some(binding => {
	        if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) {
	          return false;
	        }
	        if (binding.empty != null && binding.empty !== curContext.empty) {
	          return false;
	        }
	        if (binding.offset != null && binding.offset !== curContext.offset) {
	          return false;
	        }
	        if (Array.isArray(binding.format)) {
	          // any format is present
	          if (binding.format.every(name => curContext.format[name] == null)) {
	            return false;
	          }
	        } else if (typeof binding.format === 'object') {
	          // all formats must match
	          if (!Object.keys(binding.format).every(name => {
	            // @ts-expect-error Fix me later
	            if (binding.format[name] === true) return curContext.format[name] != null;
	            // @ts-expect-error Fix me later
	            if (binding.format[name] === false) return curContext.format[name] == null;
	            // @ts-expect-error Fix me later
	            return isEqual$2(binding.format[name], curContext.format[name]);
	          })) {
	            return false;
	          }
	        }
	        if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) {
	          return false;
	        }
	        if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) {
	          return false;
	        }
	        // @ts-expect-error Fix me later
	        return binding.handler.call(this, range, curContext, binding) !== true;
	      });
	      if (prevented) {
	        evt.preventDefault();
	      }
	    });
	  }
	  handleBackspace(range, context) {
	    // Check for astral symbols
	    const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
	    if (range.index === 0 || this.quill.getLength() <= 1) return;
	    let formats = {};
	    const [line] = this.quill.getLine(range.index);
	    let delta = new Delta().retain(range.index - length).delete(length);
	    if (context.offset === 0) {
	      // Always deleting newline here, length always 1
	      const [prev] = this.quill.getLine(range.index - 1);
	      if (prev) {
	        const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
	        if (!isPrevLineEmpty) {
	          // @ts-expect-error Fix me later
	          const curFormats = line.formats();
	          const prevFormats = this.quill.getFormat(range.index - 1, 1);
	          formats = DeltaExports.AttributeMap.diff(curFormats, prevFormats) || {};
	          if (Object.keys(formats).length > 0) {
	            // line.length() - 1 targets \n in line, another -1 for newline being deleted
	            const formatDelta = new Delta()
	            // @ts-expect-error Fix me later
	            .retain(range.index + line.length() - 2).retain(1, formats);
	            delta = delta.compose(formatDelta);
	          }
	        }
	      }
	    }
	    this.quill.updateContents(delta, Quill.sources.USER);
	    this.quill.focus();
	  }
	  handleDelete(range, context) {
	    // Check for astral symbols
	    const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
	    if (range.index >= this.quill.getLength() - length) return;
	    let formats = {};
	    const [line] = this.quill.getLine(range.index);
	    let delta = new Delta().retain(range.index).delete(length);
	    // @ts-expect-error Fix me later
	    if (context.offset >= line.length() - 1) {
	      const [next] = this.quill.getLine(range.index + 1);
	      if (next) {
	        // @ts-expect-error Fix me later
	        const curFormats = line.formats();
	        const nextFormats = this.quill.getFormat(range.index, 1);
	        formats = DeltaExports.AttributeMap.diff(curFormats, nextFormats) || {};
	        if (Object.keys(formats).length > 0) {
	          delta = delta.retain(next.length() - 1).retain(1, formats);
	        }
	      }
	    }
	    this.quill.updateContents(delta, Quill.sources.USER);
	    this.quill.focus();
	  }
	  handleDeleteRange(range) {
	    deleteRange({
	      range,
	      quill: this.quill
	    });
	    this.quill.focus();
	  }
	  handleEnter(range, context) {
	    const lineFormats = Object.keys(context.format).reduce((formats, format) => {
	      if (this.quill.scroll.query(format, Scope.BLOCK) && !Array.isArray(context.format[format])) {
	        formats[format] = context.format[format];
	      }
	      return formats;
	    }, {});
	    const delta = new Delta().retain(range.index).delete(range.length).insert('\n', lineFormats);
	    this.quill.updateContents(delta, Quill.sources.USER);
	    this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
	    this.quill.focus();
	  }
	}
	const defaultOptions = {
	  bindings: {
	    bold: makeFormatHandler('bold'),
	    italic: makeFormatHandler('italic'),
	    underline: makeFormatHandler('underline'),
	    indent: {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: 'Tab',
	      format: ['blockquote', 'indent', 'list'],
	      handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', Quill.sources.USER);
	        return false;
	      }
	    },
	    outdent: {
	      key: 'Tab',
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', Quill.sources.USER);
	        return false;
	      }
	    },
	    'outdent backspace': {
	      key: 'Backspace',
	      collapsed: true,
	      shiftKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null,
	      format: ['indent', 'list'],
	      offset: 0,
	      handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', Quill.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, Quill.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: 'Tab',
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler(range) {
	        this.quill.deleteText(range.index - 1, 1, Quill.sources.USER);
	      }
	    },
	    tab: {
	      key: 'Tab',
	      handler(range, context) {
	        if (context.format.table) return true;
	        this.quill.history.cutoff();
	        const delta = new Delta().retain(range.index).delete(range.length).insert('\t');
	        this.quill.updateContents(delta, Quill.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
	        return false;
	      }
	    },
	    'blockquote empty enter': {
	      key: 'Enter',
	      collapsed: true,
	      format: ['blockquote'],
	      empty: true,
	      handler() {
	        this.quill.format('blockquote', false, Quill.sources.USER);
	      }
	    },
	    'list empty enter': {
	      key: 'Enter',
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler(range, context) {
	        const formats = {
	          list: false
	        };
	        if (context.format.indent) {
	          formats.indent = false;
	        }
	        this.quill.formatLine(range.index, range.length, formats, Quill.sources.USER);
	      }
	    },
	    'checklist enter': {
	      key: 'Enter',
	      collapsed: true,
	      format: {
	        list: 'checked'
	      },
	      handler(range) {
	        const [line, offset] = this.quill.getLine(range.index);
	        const formats = {
	          // @ts-expect-error Fix me later
	          ...line.formats(),
	          list: 'checked'
	        };
	        const delta = new Delta().retain(range.index).insert('\n', formats)
	        // @ts-expect-error Fix me later
	        .retain(line.length() - offset - 1).retain(1, {
	          list: 'unchecked'
	        });
	        this.quill.updateContents(delta, Quill.sources.USER);
	        this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
	        this.quill.scrollSelectionIntoView();
	      }
	    },
	    'header enter': {
	      key: 'Enter',
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler(range, context) {
	        const [line, offset] = this.quill.getLine(range.index);
	        const delta = new Delta().retain(range.index).insert('\n', context.format)
	        // @ts-expect-error Fix me later
	        .retain(line.length() - offset - 1).retain(1, {
	          header: null
	        });
	        this.quill.updateContents(delta, Quill.sources.USER);
	        this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
	        this.quill.scrollSelectionIntoView();
	      }
	    },
	    'table backspace': {
	      key: 'Backspace',
	      format: ['table'],
	      collapsed: true,
	      offset: 0,
	      handler() {}
	    },
	    'table delete': {
	      key: 'Delete',
	      format: ['table'],
	      collapsed: true,
	      suffix: /^$/,
	      handler() {}
	    },
	    'table enter': {
	      key: 'Enter',
	      shiftKey: null,
	      format: ['table'],
	      handler(range) {
	        const module = this.quill.getModule('table');
	        if (module) {
	          // @ts-expect-error
	          const [table, row, cell, offset] = module.getTable(range);
	          const shift = tableSide(table, row, cell, offset);
	          if (shift == null) return;
	          let index = table.offset();
	          if (shift < 0) {
	            const delta = new Delta().retain(index).insert('\n');
	            this.quill.updateContents(delta, Quill.sources.USER);
	            this.quill.setSelection(range.index + 1, range.length, Quill.sources.SILENT);
	          } else if (shift > 0) {
	            index += table.length();
	            const delta = new Delta().retain(index).insert('\n');
	            this.quill.updateContents(delta, Quill.sources.USER);
	            this.quill.setSelection(index, Quill.sources.USER);
	          }
	        }
	      }
	    },
	    'table tab': {
	      key: 'Tab',
	      shiftKey: null,
	      format: ['table'],
	      handler(range, context) {
	        const {
	          event,
	          line: cell
	        } = context;
	        const offset = cell.offset(this.quill.scroll);
	        if (event.shiftKey) {
	          this.quill.setSelection(offset - 1, Quill.sources.USER);
	        } else {
	          this.quill.setSelection(offset + cell.length(), Quill.sources.USER);
	        }
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      shiftKey: null,
	      collapsed: true,
	      format: {
	        'code-block': false,
	        blockquote: false,
	        table: false
	      },
	      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
	      handler(range, context) {
	        if (this.quill.scroll.query('list') == null) return true;
	        const {
	          length
	        } = context.prefix;
	        const [line, offset] = this.quill.getLine(range.index);
	        if (offset > length) return true;
	        let value;
	        switch (context.prefix.trim()) {
	          case '[]':
	          case '[ ]':
	            value = 'unchecked';
	            break;
	          case '[x]':
	            value = 'checked';
	            break;
	          case '-':
	          case '*':
	            value = 'bullet';
	            break;
	          default:
	            value = 'ordered';
	        }
	        this.quill.insertText(range.index, ' ', Quill.sources.USER);
	        this.quill.history.cutoff();
	        const delta = new Delta().retain(range.index - offset).delete(length + 1)
	        // @ts-expect-error Fix me later
	        .retain(line.length() - 2 - offset).retain(1, {
	          list: value
	        });
	        this.quill.updateContents(delta, Quill.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index - length, Quill.sources.SILENT);
	        return false;
	      }
	    },
	    'code exit': {
	      key: 'Enter',
	      collapsed: true,
	      format: ['code-block'],
	      prefix: /^$/,
	      suffix: /^\s*$/,
	      handler(range) {
	        const [line, offset] = this.quill.getLine(range.index);
	        let numLines = 2;
	        let cur = line;
	        while (cur != null && cur.length() <= 1 && cur.formats()['code-block']) {
	          // @ts-expect-error
	          cur = cur.prev;
	          numLines -= 1;
	          // Requisite prev lines are empty
	          if (numLines <= 0) {
	            const delta = new Delta()
	            // @ts-expect-error Fix me later
	            .retain(range.index + line.length() - offset - 2).retain(1, {
	              'code-block': null
	            }).delete(1);
	            this.quill.updateContents(delta, Quill.sources.USER);
	            this.quill.setSelection(range.index - 1, Quill.sources.SILENT);
	            return false;
	          }
	        }
	        return true;
	      }
	    },
	    'embed left': makeEmbedArrowHandler('ArrowLeft', false),
	    'embed left shift': makeEmbedArrowHandler('ArrowLeft', true),
	    'embed right': makeEmbedArrowHandler('ArrowRight', false),
	    'embed right shift': makeEmbedArrowHandler('ArrowRight', true),
	    'table down': makeTableArrowHandler(false),
	    'table up': makeTableArrowHandler(true)
	  }
	};
	Keyboard.DEFAULTS = defaultOptions;
	function makeCodeBlockHandler(indent) {
	  return {
	    key: 'Tab',
	    shiftKey: !indent,
	    format: {
	      'code-block': true
	    },
	    handler(range, _ref) {
	      let {
	        event
	      } = _ref;
	      const CodeBlock = this.quill.scroll.query('code-block');
	      // @ts-expect-error
	      const {
	        TAB
	      } = CodeBlock;
	      if (range.length === 0 && !event.shiftKey) {
	        this.quill.insertText(range.index, TAB, Quill.sources.USER);
	        this.quill.setSelection(range.index + TAB.length, Quill.sources.SILENT);
	        return;
	      }
	      const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
	      let {
	        index,
	        length
	      } = range;
	      lines.forEach((line, i) => {
	        if (indent) {
	          line.insertAt(0, TAB);
	          if (i === 0) {
	            index += TAB.length;
	          } else {
	            length += TAB.length;
	          }
	          // @ts-expect-error Fix me later
	        } else if (line.domNode.textContent.startsWith(TAB)) {
	          line.deleteAt(0, TAB.length);
	          if (i === 0) {
	            index -= TAB.length;
	          } else {
	            length -= TAB.length;
	          }
	        }
	      });
	      this.quill.update(Quill.sources.USER);
	      this.quill.setSelection(index, length, Quill.sources.SILENT);
	    }
	  };
	}
	function makeEmbedArrowHandler(key, shiftKey) {
	  const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
	  return {
	    key,
	    shiftKey,
	    altKey: null,
	    [where]: /^$/,
	    handler(range) {
	      let {
	        index
	      } = range;
	      if (key === 'ArrowRight') {
	        index += range.length + 1;
	      }
	      const [leaf] = this.quill.getLeaf(index);
	      if (!(leaf instanceof EmbedBlot$1)) return true;
	      if (key === 'ArrowLeft') {
	        if (shiftKey) {
	          this.quill.setSelection(range.index - 1, range.length + 1, Quill.sources.USER);
	        } else {
	          this.quill.setSelection(range.index - 1, Quill.sources.USER);
	        }
	      } else if (shiftKey) {
	        this.quill.setSelection(range.index, range.length + 1, Quill.sources.USER);
	      } else {
	        this.quill.setSelection(range.index + range.length + 1, Quill.sources.USER);
	      }
	      return false;
	    }
	  };
	}
	function makeFormatHandler(format) {
	  return {
	    key: format[0],
	    shortKey: true,
	    handler(range, context) {
	      this.quill.format(format, !context.format[format], Quill.sources.USER);
	    }
	  };
	}
	function makeTableArrowHandler(up) {
	  return {
	    key: up ? 'ArrowUp' : 'ArrowDown',
	    collapsed: true,
	    format: ['table'],
	    handler(range, context) {
	      // TODO move to table module
	      const key = up ? 'prev' : 'next';
	      const cell = context.line;
	      const targetRow = cell.parent[key];
	      if (targetRow != null) {
	        if (targetRow.statics.blotName === 'table-row') {
	          // @ts-expect-error
	          let targetCell = targetRow.children.head;
	          let cur = cell;
	          while (cur.prev != null) {
	            // @ts-expect-error
	            cur = cur.prev;
	            targetCell = targetCell.next;
	          }
	          const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
	          this.quill.setSelection(index, 0, Quill.sources.USER);
	        }
	      } else {
	        // @ts-expect-error
	        const targetLine = cell.table()[key];
	        if (targetLine != null) {
	          if (up) {
	            this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, Quill.sources.USER);
	          } else {
	            this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, Quill.sources.USER);
	          }
	        }
	      }
	      return false;
	    }
	  };
	}
	function normalize$2(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    binding = {
	      key: binding
	    };
	  } else if (typeof binding === 'object') {
	    binding = cloneDeep$1(binding);
	  } else {
	    return null;
	  }
	  if (binding.shortKey) {
	    binding[SHORTKEY] = binding.shortKey;
	    delete binding.shortKey;
	  }
	  return binding;
	}

	// TODO: Move into quill.ts or editor.ts
	function deleteRange(_ref2) {
	  let {
	    quill,
	    range
	  } = _ref2;
	  const lines = quill.getLines(range);
	  let formats = {};
	  if (lines.length > 1) {
	    const firstFormats = lines[0].formats();
	    const lastFormats = lines[lines.length - 1].formats();
	    formats = DeltaExports.AttributeMap.diff(lastFormats, firstFormats) || {};
	  }
	  quill.deleteText(range, Quill.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    quill.formatLine(range.index, 1, formats, Quill.sources.USER);
	  }
	  quill.setSelection(range.index, Quill.sources.SILENT);
	}
	function tableSide(_table, row, cell, offset) {
	  if (row.prev == null && row.next == null) {
	    if (cell.prev == null && cell.next == null) {
	      return offset === 0 ? -1 : 1;
	    }
	    return cell.prev == null ? -1 : 1;
	  }
	  if (row.prev == null) {
	    return -1;
	  }
	  if (row.next == null) {
	    return 1;
	  }
	  return null;
	}

	const normalWeightRegexp = /font-weight:\s*normal/;
	const blockTagNames = ['P', 'OL', 'UL'];
	const isBlockElement = element => {
	  return element && blockTagNames.includes(element.tagName);
	};
	const normalizeEmptyLines = doc => {
	  Array.from(doc.querySelectorAll('br')).filter(br => isBlockElement(br.previousElementSibling) && isBlockElement(br.nextElementSibling)).forEach(br => {
	    br.parentNode?.removeChild(br);
	  });
	};
	const normalizeFontWeight = doc => {
	  Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter(node => node.getAttribute('style')?.match(normalWeightRegexp)).forEach(node => {
	    const fragment = doc.createDocumentFragment();
	    fragment.append(...node.childNodes);
	    node.parentNode?.replaceChild(fragment, node);
	  });
	};
	function normalize$1(doc) {
	  if (doc.querySelector('[id^="docs-internal-guid-"]')) {
	    normalizeFontWeight(doc);
	    normalizeEmptyLines(doc);
	  }
	}

	const ignoreRegexp = /\bmso-list:[^;]*ignore/i;
	const idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
	const indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
	const parseListItem = (element, html) => {
	  const style = element.getAttribute('style');
	  const idMatch = style?.match(idRegexp);
	  if (!idMatch) {
	    return null;
	  }
	  const id = Number(idMatch[1]);
	  const indentMatch = style?.match(indentRegexp);
	  const indent = indentMatch ? Number(indentMatch[1]) : 1;
	  const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
	  const typeMatch = html.match(typeRegexp);
	  const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
	  return {
	    id,
	    indent,
	    type,
	    element
	  };
	};

	// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
	// 1. "0" in "l0" means the list item id;
	// 2. "1" in "level1" means the indent level, starting from 1.
	const normalizeListItem = doc => {
	  const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
	  const ignored = [];
	  const others = [];
	  msoList.forEach(node => {
	    const shouldIgnore = (node.getAttribute('style') || '').match(ignoreRegexp);
	    if (shouldIgnore) {
	      ignored.push(node);
	    } else {
	      others.push(node);
	    }
	  });

	  // Each list item contains a marker wrapped with "mso-list: Ignore".
	  ignored.forEach(node => node.parentNode?.removeChild(node));

	  // The list stype is not defined inline with the tag, instead, it's in the
	  // style tag so we need to pass the html as a string.
	  const html = doc.documentElement.innerHTML;
	  const listItems = others.map(element => parseListItem(element, html)).filter(parsed => parsed);
	  while (listItems.length) {
	    const childListItems = [];
	    let current = listItems.shift();
	    // Group continuous items into the same group (aka "ul")
	    while (current) {
	      childListItems.push(current);
	      current = listItems.length && listItems[0]?.element === current.element.nextElementSibling &&
	      // Different id means the next item doesn't belong to this group.
	      listItems[0].id === current.id ? listItems.shift() : null;
	    }
	    const ul = document.createElement('ul');
	    childListItems.forEach(listItem => {
	      const li = document.createElement('li');
	      li.setAttribute('data-list', listItem.type);
	      if (listItem.indent > 1) {
	        li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
	      }
	      li.innerHTML = listItem.element.innerHTML;
	      ul.appendChild(li);
	    });
	    const element = childListItems[0]?.element;
	    const {
	      parentNode
	    } = element ?? {};
	    if (element) {
	      parentNode?.replaceChild(ul, element);
	    }
	    childListItems.slice(1).forEach(_ref => {
	      let {
	        element: e
	      } = _ref;
	      parentNode?.removeChild(e);
	    });
	  }
	};
	function normalize(doc) {
	  if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') {
	    normalizeListItem(doc);
	  }
	}

	const NORMALIZERS = [normalize, normalize$1];
	const normalizeExternalHTML = doc => {
	  if (doc.documentElement) {
	    NORMALIZERS.forEach(normalize => {
	      normalize(doc);
	    });
	  }
	};

	const debug$1 = namespace('quill:clipboard');
	const CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['ol, ul', matchList], ['pre', matchCodeBlock], ['tr', matchTable], ['b', createMatchAlias('bold')], ['i', createMatchAlias('italic')], ['strike', createMatchAlias('strike')], ['style', matchIgnore]];
	const ATTRIBUTE_ATTRIBUTORS = [AlignAttribute, DirectionAttribute].reduce((memo, attr) => {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	const STYLE_ATTRIBUTORS = [AlignStyle, BackgroundStyle, ColorStyle, DirectionStyle, FontStyle, SizeStyle].reduce((memo, attr) => {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	class Clipboard extends Module {
	  static DEFAULTS = {
	    matchers: []
	  };
	  constructor(quill, options) {
	    super(quill, options);
	    this.quill.root.addEventListener('copy', e => this.onCaptureCopy(e, false));
	    this.quill.root.addEventListener('cut', e => this.onCaptureCopy(e, true));
	    this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
	    this.matchers = [];
	    CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach(_ref => {
	      let [selector, matcher] = _ref;
	      this.addMatcher(selector, matcher);
	    });
	  }
	  addMatcher(selector, matcher) {
	    this.matchers.push([selector, matcher]);
	  }
	  convert(_ref2) {
	    let {
	      html,
	      text
	    } = _ref2;
	    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    if (formats[CodeBlock.blotName]) {
	      return new Delta().insert(text || '', {
	        [CodeBlock.blotName]: formats[CodeBlock.blotName]
	      });
	    }
	    if (!html) {
	      return new Delta().insert(text || '', formats);
	    }
	    const delta = this.convertHTML(html);
	    // Remove trailing newline
	    if (deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) {
	      return delta.compose(new Delta().retain(delta.length() - 1).delete(1));
	    }
	    return delta;
	  }
	  normalizeHTML(doc) {
	    normalizeExternalHTML(doc);
	  }
	  convertHTML(html) {
	    const doc = new DOMParser().parseFromString(html, 'text/html');
	    this.normalizeHTML(doc);
	    const container = doc.body;
	    const nodeMatches = new WeakMap();
	    const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
	    return traverse(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
	  }
	  dangerouslyPasteHTML(index, html) {
	    let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Quill.sources.API;
	    if (typeof index === 'string') {
	      const delta = this.convert({
	        html: index,
	        text: ''
	      });
	      // @ts-expect-error
	      this.quill.setContents(delta, html);
	      this.quill.setSelection(0, Quill.sources.SILENT);
	    } else {
	      const paste = this.convert({
	        html,
	        text: ''
	      });
	      this.quill.updateContents(new Delta().retain(index).concat(paste), source);
	      this.quill.setSelection(index + paste.length(), Quill.sources.SILENT);
	    }
	  }
	  onCaptureCopy(e) {
	    let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    if (e.defaultPrevented) return;
	    e.preventDefault();
	    const [range] = this.quill.selection.getRange();
	    if (range == null) return;
	    const {
	      html,
	      text
	    } = this.onCopy(range, isCut);
	    e.clipboardData?.setData('text/plain', text);
	    e.clipboardData?.setData('text/html', html);
	    if (isCut) {
	      deleteRange({
	        range,
	        quill: this.quill
	      });
	    }
	  }

	  /*
	   * https://www.iana.org/assignments/media-types/text/uri-list
	   */
	  normalizeURIList(urlList) {
	    return urlList.split(/\r?\n/)
	    // Ignore all comments
	    .filter(url => url[0] !== '#').join('\n');
	  }
	  onCapturePaste(e) {
	    if (e.defaultPrevented || !this.quill.isEnabled()) return;
	    e.preventDefault();
	    const range = this.quill.getSelection(true);
	    if (range == null) return;
	    const html = e.clipboardData?.getData('text/html');
	    let text = e.clipboardData?.getData('text/plain');
	    if (!html && !text) {
	      const urlList = e.clipboardData?.getData('text/uri-list');
	      if (urlList) {
	        text = this.normalizeURIList(urlList);
	      }
	    }
	    const files = Array.from(e.clipboardData?.files || []);
	    if (!html && files.length > 0) {
	      this.quill.uploader.upload(range, files);
	      return;
	    }
	    if (html && files.length > 0) {
	      const doc = new DOMParser().parseFromString(html, 'text/html');
	      if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
	        this.quill.uploader.upload(range, files);
	        return;
	      }
	    }
	    this.onPaste(range, {
	      html,
	      text
	    });
	  }
	  onCopy(range) {
	    const text = this.quill.getText(range);
	    const html = this.quill.getSemanticHTML(range);
	    return {
	      html,
	      text
	    };
	  }
	  onPaste(range, _ref3) {
	    let {
	      text,
	      html
	    } = _ref3;
	    const formats = this.quill.getFormat(range.index);
	    const pastedDelta = this.convert({
	      text,
	      html
	    }, formats);
	    debug$1.log('onPaste', pastedDelta, {
	      text,
	      html
	    });
	    const delta = new Delta().retain(range.index).delete(range.length).concat(pastedDelta);
	    this.quill.updateContents(delta, Quill.sources.USER);
	    // range.length contributes to delta.length()
	    this.quill.setSelection(delta.length() - range.length, Quill.sources.SILENT);
	    this.quill.scrollSelectionIntoView();
	  }
	  prepareMatching(container, nodeMatches) {
	    const elementMatchers = [];
	    const textMatchers = [];
	    this.matchers.forEach(pair => {
	      const [selector, matcher] = pair;
	      switch (selector) {
	        case Node.TEXT_NODE:
	          textMatchers.push(matcher);
	          break;
	        case Node.ELEMENT_NODE:
	          elementMatchers.push(matcher);
	          break;
	        default:
	          Array.from(container.querySelectorAll(selector)).forEach(node => {
	            if (nodeMatches.has(node)) {
	              const matches = nodeMatches.get(node);
	              matches?.push(matcher);
	            } else {
	              nodeMatches.set(node, [matcher]);
	            }
	          });
	          break;
	      }
	    });
	    return [elementMatchers, textMatchers];
	  }
	}
	function applyFormat(delta, format, value, scroll) {
	  if (!scroll.query(format)) {
	    return delta;
	  }
	  return delta.reduce((newDelta, op) => {
	    if (!op.insert) return newDelta;
	    if (op.attributes && op.attributes[format]) {
	      return newDelta.push(op);
	    }
	    const formats = value ? {
	      [format]: value
	    } : {};
	    return newDelta.insert(op.insert, {
	      ...formats,
	      ...op.attributes
	    });
	  }, new Delta());
	}
	function deltaEndsWith(delta, text) {
	  let endText = '';
	  for (let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
	  ) {
	    const op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}
	function isLine(node, scroll) {
	  if (!(node instanceof Element)) return false;
	  const match = scroll.query(node);
	  // @ts-expect-error
	  if (match && match.prototype instanceof EmbedBlot$1) return false;
	  return ['address', 'article', 'blockquote', 'canvas', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'iframe', 'li', 'main', 'nav', 'ol', 'output', 'p', 'pre', 'section', 'table', 'td', 'tr', 'ul', 'video'].includes(node.tagName.toLowerCase());
	}
	function isBetweenInlineElements(node, scroll) {
	  return node.previousElementSibling && node.nextElementSibling && !isLine(node.previousElementSibling, scroll) && !isLine(node.nextElementSibling, scroll);
	}
	const preNodes = new WeakMap();
	function isPre(node) {
	  if (node == null) return false;
	  if (!preNodes.has(node)) {
	    // @ts-expect-error
	    if (node.tagName === 'PRE') {
	      preNodes.set(node, true);
	    } else {
	      preNodes.set(node, isPre(node.parentNode));
	    }
	  }
	  return preNodes.get(node);
	}
	function traverse(scroll, node, elementMatchers, textMatchers, nodeMatches) {
	  // Post-order
	  if (node.nodeType === node.TEXT_NODE) {
	    return textMatchers.reduce((delta, matcher) => {
	      return matcher(node, delta, scroll);
	    }, new Delta());
	  }
	  if (node.nodeType === node.ELEMENT_NODE) {
	    return Array.from(node.childNodes || []).reduce((delta, childNode) => {
	      let childrenDelta = traverse(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
	      if (childNode.nodeType === node.ELEMENT_NODE) {
	        childrenDelta = elementMatchers.reduce((reducedDelta, matcher) => {
	          return matcher(childNode, reducedDelta, scroll);
	        }, childrenDelta);
	        childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher) => {
	          return matcher(childNode, reducedDelta, scroll);
	        }, childrenDelta);
	      }
	      return delta.concat(childrenDelta);
	    }, new Delta());
	  }
	  return new Delta();
	}
	function createMatchAlias(format) {
	  return (_node, delta, scroll) => {
	    return applyFormat(delta, format, true, scroll);
	  };
	}
	function matchAttributor(node, delta, scroll) {
	  const attributes = Attributor.keys(node);
	  const classes = ClassAttributor$1.keys(node);
	  const styles = StyleAttributor$1.keys(node);
	  const formats = {};
	  attributes.concat(classes).concat(styles).forEach(name => {
	    let attr = scroll.query(name, Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    attr = ATTRIBUTE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	    attr = STYLE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	  });
	  return Object.entries(formats).reduce((newDelta, _ref4) => {
	    let [name, value] = _ref4;
	    return applyFormat(newDelta, name, value, scroll);
	  }, delta);
	}
	function matchBlot(node, delta, scroll) {
	  const match = scroll.query(node);
	  if (match == null) return delta;
	  // @ts-expect-error
	  if (match.prototype instanceof EmbedBlot$1) {
	    const embed = {};
	    // @ts-expect-error
	    const value = match.value(node);
	    if (value != null) {
	      // @ts-expect-error
	      embed[match.blotName] = value;
	      // @ts-expect-error
	      return new Delta().insert(embed, match.formats(node, scroll));
	    }
	  } else {
	    // @ts-expect-error
	    if (match.prototype instanceof BlockBlot$1 && !deltaEndsWith(delta, '\n')) {
	      delta.insert('\n');
	    }
	    if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') {
	      return applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
	    }
	  }
	  return delta;
	}
	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}
	function matchCodeBlock(node, delta, scroll) {
	  const match = scroll.query('code-block');
	  const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
	  return applyFormat(delta, 'code-block', language, scroll);
	}
	function matchIgnore() {
	  return new Delta();
	}
	function matchIndent(node, delta, scroll) {
	  const match = scroll.query(node);
	  if (match == null ||
	  // @ts-expect-error
	  match.blotName !== 'list' || !deltaEndsWith(delta, '\n')) {
	    return delta;
	  }
	  let indent = -1;
	  let parent = node.parentNode;
	  while (parent != null) {
	    // @ts-expect-error
	    if (['OL', 'UL'].includes(parent.tagName)) {
	      indent += 1;
	    }
	    parent = parent.parentNode;
	  }
	  if (indent <= 0) return delta;
	  return delta.reduce((composed, op) => {
	    if (!op.insert) return composed;
	    if (op.attributes && typeof op.attributes.indent === 'number') {
	      return composed.push(op);
	    }
	    return composed.insert(op.insert, {
	      indent,
	      ...(op.attributes || {})
	    });
	  }, new Delta());
	}
	function matchList(node, delta, scroll) {
	  const element = node;
	  let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
	  const checkedAttr = element.getAttribute('data-checked');
	  if (checkedAttr) {
	    list = checkedAttr === 'true' ? 'checked' : 'unchecked';
	  }
	  return applyFormat(delta, 'list', list, scroll);
	}
	function matchNewline(node, delta, scroll) {
	  if (!deltaEndsWith(delta, '\n')) {
	    if (isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) {
	      return delta.insert('\n');
	    }
	    if (delta.length() > 0 && node.nextSibling) {
	      let nextSibling = node.nextSibling;
	      while (nextSibling != null) {
	        if (isLine(nextSibling, scroll)) {
	          return delta.insert('\n');
	        }
	        const match = scroll.query(nextSibling);
	        // @ts-expect-error
	        if (match && match.prototype instanceof BlockEmbed) {
	          return delta.insert('\n');
	        }
	        nextSibling = nextSibling.firstChild;
	      }
	    }
	  }
	  return delta;
	}
	function matchStyles(node, delta, scroll) {
	  const formats = {};
	  const style = node.style || {};
	  if (style.fontStyle === 'italic') {
	    formats.italic = true;
	  }
	  if (style.textDecoration === 'underline') {
	    formats.underline = true;
	  }
	  if (style.textDecoration === 'line-through') {
	    formats.strike = true;
	  }
	  if (style.fontWeight?.startsWith('bold') ||
	  // @ts-expect-error Fix me later
	  parseInt(style.fontWeight, 10) >= 700) {
	    formats.bold = true;
	  }
	  delta = Object.entries(formats).reduce((newDelta, _ref5) => {
	    let [name, value] = _ref5;
	    return applyFormat(newDelta, name, value, scroll);
	  }, delta);
	  // @ts-expect-error
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    return new Delta().insert('\t').concat(delta);
	  }
	  return delta;
	}
	function matchTable(node, delta, scroll) {
	  const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
	  if (table != null) {
	    const rows = Array.from(table.querySelectorAll('tr'));
	    const row = rows.indexOf(node) + 1;
	    return applyFormat(delta, 'table', row, scroll);
	  }
	  return delta;
	}
	function matchText(node, delta, scroll) {
	  // @ts-expect-error
	  let text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentElement?.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (!isPre(node)) {
	    if (text.trim().length === 0 && text.includes('\n') && !isBetweenInlineElements(node, scroll)) {
	      return delta;
	    }
	    const replacer = (collapse, match) => {
	      const replaced = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return replaced.length < 1 && collapse ? ' ' : replaced;
	    };
	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && node.parentElement != null && isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && isLine(node.previousSibling, scroll)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && node.parentElement != null && isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && isLine(node.nextSibling, scroll)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}

	class History extends Module {
	  static DEFAULTS = {
	    delay: 1000,
	    maxStack: 100,
	    userOnly: false
	  };
	  lastRecorded = 0;
	  ignoreChange = false;
	  stack = {
	    undo: [],
	    redo: []
	  };
	  currentRange = null;
	  constructor(quill, options) {
	    super(quill, options);
	    this.quill.on(Quill.events.EDITOR_CHANGE, (eventName, value, oldValue, source) => {
	      if (eventName === Quill.events.SELECTION_CHANGE) {
	        if (value && source !== Quill.sources.SILENT) {
	          this.currentRange = value;
	        }
	      } else if (eventName === Quill.events.TEXT_CHANGE) {
	        if (!this.ignoreChange) {
	          if (!this.options.userOnly || source === Quill.sources.USER) {
	            this.record(value, oldValue);
	          } else {
	            this.transform(value);
	          }
	        }
	        this.currentRange = transformRange(this.currentRange, value);
	      }
	    });
	    this.quill.keyboard.addBinding({
	      key: 'z',
	      shortKey: true
	    }, this.undo.bind(this));
	    this.quill.keyboard.addBinding({
	      key: ['z', 'Z'],
	      shortKey: true,
	      shiftKey: true
	    }, this.redo.bind(this));
	    if (/Win/i.test(navigator.platform)) {
	      this.quill.keyboard.addBinding({
	        key: 'y',
	        shortKey: true
	      }, this.redo.bind(this));
	    }
	    this.quill.root.addEventListener('beforeinput', event => {
	      if (event.inputType === 'historyUndo') {
	        this.undo();
	        event.preventDefault();
	      } else if (event.inputType === 'historyRedo') {
	        this.redo();
	        event.preventDefault();
	      }
	    });
	  }
	  change(source, dest) {
	    if (this.stack[source].length === 0) return;
	    const item = this.stack[source].pop();
	    if (!item) return;
	    const base = this.quill.getContents();
	    const inverseDelta = item.delta.invert(base);
	    this.stack[dest].push({
	      delta: inverseDelta,
	      range: transformRange(item.range, inverseDelta)
	    });
	    this.lastRecorded = 0;
	    this.ignoreChange = true;
	    this.quill.updateContents(item.delta, Quill.sources.USER);
	    this.ignoreChange = false;
	    this.restoreSelection(item);
	  }
	  clear() {
	    this.stack = {
	      undo: [],
	      redo: []
	    };
	  }
	  cutoff() {
	    this.lastRecorded = 0;
	  }
	  record(changeDelta, oldDelta) {
	    if (changeDelta.ops.length === 0) return;
	    this.stack.redo = [];
	    let undoDelta = changeDelta.invert(oldDelta);
	    let undoRange = this.currentRange;
	    const timestamp = Date.now();
	    if (
	    // @ts-expect-error Fix me later
	    this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	      const item = this.stack.undo.pop();
	      if (item) {
	        undoDelta = undoDelta.compose(item.delta);
	        undoRange = item.range;
	      }
	    } else {
	      this.lastRecorded = timestamp;
	    }
	    if (undoDelta.length() === 0) return;
	    this.stack.undo.push({
	      delta: undoDelta,
	      range: undoRange
	    });
	    // @ts-expect-error Fix me later
	    if (this.stack.undo.length > this.options.maxStack) {
	      this.stack.undo.shift();
	    }
	  }
	  redo() {
	    this.change('redo', 'undo');
	  }
	  transform(delta) {
	    transformStack(this.stack.undo, delta);
	    transformStack(this.stack.redo, delta);
	  }
	  undo() {
	    this.change('undo', 'redo');
	  }
	  restoreSelection(stackItem) {
	    if (stackItem.range) {
	      this.quill.setSelection(stackItem.range, Quill.sources.USER);
	    } else {
	      const index = getLastChangeIndex(this.quill.scroll, stackItem.delta);
	      this.quill.setSelection(index, Quill.sources.USER);
	    }
	  }
	}
	function transformStack(stack, delta) {
	  let remoteDelta = delta;
	  for (let i = stack.length - 1; i >= 0; i -= 1) {
	    const oldItem = stack[i];
	    stack[i] = {
	      delta: remoteDelta.transform(oldItem.delta, true),
	      range: oldItem.range && transformRange(oldItem.range, remoteDelta)
	    };
	    remoteDelta = oldItem.delta.transform(remoteDelta);
	    if (stack[i].delta.length() === 0) {
	      stack.splice(i, 1);
	    }
	  }
	}
	function endsWithNewlineChange(scroll, delta) {
	  const lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(attr => {
	      return scroll.query(attr, Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}
	function getLastChangeIndex(scroll, delta) {
	  const deleteLength = delta.reduce((length, op) => {
	    return length + (op.delete || 0);
	  }, 0);
	  let changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(scroll, delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}
	function transformRange(range, delta) {
	  if (!range) return range;
	  const start = delta.transformPosition(range.index);
	  const end = delta.transformPosition(range.index + range.length);
	  return {
	    index: start,
	    length: end - start
	  };
	}

	class Uploader extends Module {
	  constructor(quill, options) {
	    super(quill, options);
	    quill.root.addEventListener('drop', e => {
	      e.preventDefault();
	      let native = null;
	      if (document.caretRangeFromPoint) {
	        native = document.caretRangeFromPoint(e.clientX, e.clientY);
	        // @ts-expect-error
	      } else if (document.caretPositionFromPoint) {
	        // @ts-expect-error
	        const position = document.caretPositionFromPoint(e.clientX, e.clientY);
	        native = document.createRange();
	        native.setStart(position.offsetNode, position.offset);
	        native.setEnd(position.offsetNode, position.offset);
	      }
	      const normalized = native && quill.selection.normalizeNative(native);
	      if (normalized) {
	        const range = quill.selection.normalizedToRange(normalized);
	        if (e.dataTransfer?.files) {
	          this.upload(range, e.dataTransfer.files);
	        }
	      }
	    });
	  }
	  upload(range, files) {
	    const uploads = [];
	    Array.from(files).forEach(file => {
	      if (file && this.options.mimetypes?.includes(file.type)) {
	        uploads.push(file);
	      }
	    });
	    if (uploads.length > 0) {
	      // @ts-expect-error Fix me later
	      this.options.handler.call(this, range, uploads);
	    }
	  }
	}
	Uploader.DEFAULTS = {
	  mimetypes: ['image/png', 'image/jpeg'],
	  handler(range, files) {
	    if (!this.quill.scroll.query('image')) {
	      return;
	    }
	    const promises = files.map(file => {
	      return new Promise(resolve => {
	        const reader = new FileReader();
	        reader.onload = () => {
	          resolve(reader.result);
	        };
	        reader.readAsDataURL(file);
	      });
	    });
	    Promise.all(promises).then(images => {
	      const update = images.reduce((delta, image) => {
	        return delta.insert({
	          image
	        });
	      }, new Delta().retain(range.index).delete(range.length));
	      this.quill.updateContents(update, Emitter.sources.USER);
	      this.quill.setSelection(range.index + images.length, Emitter.sources.SILENT);
	    });
	  }
	};

	const INSERT_TYPES = ['insertText', 'insertReplacementText'];
	class Input extends Module {
	  constructor(quill, options) {
	    super(quill, options);
	    quill.root.addEventListener('beforeinput', event => {
	      this.handleBeforeInput(event);
	    });

	    // Gboard with English input on Android triggers `compositionstart` sometimes even
	    // users are not going to type anything.
	    if (!/Android/i.test(navigator.userAgent)) {
	      quill.on(Quill.events.COMPOSITION_BEFORE_START, () => {
	        this.handleCompositionStart();
	      });
	    }
	  }
	  deleteRange(range) {
	    deleteRange({
	      range,
	      quill: this.quill
	    });
	  }
	  replaceText(range) {
	    let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    if (range.length === 0) return false;
	    if (text) {
	      // Follow the native behavior that inherits the formats of the first character
	      const formats = this.quill.getFormat(range.index, 1);
	      this.deleteRange(range);
	      this.quill.updateContents(new Delta().retain(range.index).insert(text, formats), Quill.sources.USER);
	    } else {
	      this.deleteRange(range);
	    }
	    this.quill.setSelection(range.index + text.length, 0, Quill.sources.SILENT);
	    return true;
	  }
	  handleBeforeInput(event) {
	    if (this.quill.composition.isComposing || event.defaultPrevented || !INSERT_TYPES.includes(event.inputType)) {
	      return;
	    }
	    const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
	    if (!staticRange || staticRange.collapsed === true) {
	      return;
	    }
	    const text = getPlainTextFromInputEvent(event);
	    if (text == null) {
	      return;
	    }
	    const normalized = this.quill.selection.normalizeNative(staticRange);
	    const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
	    if (range && this.replaceText(range, text)) {
	      event.preventDefault();
	    }
	  }
	  handleCompositionStart() {
	    const range = this.quill.getSelection();
	    if (range) {
	      this.replaceText(range);
	    }
	  }
	}
	function getPlainTextFromInputEvent(event) {
	  // When `inputType` is "insertText":
	  // - `event.data` should be string (Safari uses `event.dataTransfer`).
	  // - `event.dataTransfer` should be null.
	  // When `inputType` is "insertReplacementText":
	  // - `event.data` should be null.
	  // - `event.dataTransfer` should contain "text/plain" data.

	  if (typeof event.data === 'string') {
	    return event.data;
	  }
	  if (event.dataTransfer?.types.includes('text/plain')) {
	    return event.dataTransfer.getData('text/plain');
	  }
	  return null;
	}

	const isMac = /Mac/i.test(navigator.platform);

	// Export for testing
	const TTL_FOR_VALID_SELECTION_CHANGE = 100;

	// A loose check to determine if the shortcut can move the caret before a UI node:
	// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
	const canMoveCaretBeforeUINode = event => {
	  if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' ||
	  // RTL scripts or moving from the end of the previous line
	  event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') {
	    return true;
	  }
	  if (isMac && event.key === 'a' && event.ctrlKey === true) {
	    return true;
	  }
	  return false;
	};
	class UINode extends Module {
	  isListening = false;
	  selectionChangeDeadline = 0;
	  constructor(quill, options) {
	    super(quill, options);
	    this.handleArrowKeys();
	    this.handleNavigationShortcuts();
	  }
	  handleArrowKeys() {
	    this.quill.keyboard.addBinding({
	      key: ['ArrowLeft', 'ArrowRight'],
	      offset: 0,
	      shiftKey: null,
	      handler(range, _ref) {
	        let {
	          line,
	          event
	        } = _ref;
	        if (!(line instanceof ParentBlot$1) || !line.uiNode) {
	          return true;
	        }
	        const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
	        if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') {
	          return true;
	        }
	        this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), Quill.sources.USER);
	        return false;
	      }
	    });
	  }
	  handleNavigationShortcuts() {
	    this.quill.root.addEventListener('keydown', event => {
	      if (!event.defaultPrevented && canMoveCaretBeforeUINode(event)) {
	        this.ensureListeningToSelectionChange();
	      }
	    });
	  }

	  /**
	   * We only listen to the `selectionchange` event when
	   * there is an intention of moving the caret to the beginning using shortcuts.
	   * This is primarily implemented to prevent infinite loops, as we are changing
	   * the selection within the handler of a `selectionchange` event.
	   */
	  ensureListeningToSelectionChange() {
	    this.selectionChangeDeadline = Date.now() + TTL_FOR_VALID_SELECTION_CHANGE;
	    if (this.isListening) return;
	    this.isListening = true;
	    const listener = () => {
	      this.isListening = false;
	      if (Date.now() <= this.selectionChangeDeadline) {
	        this.handleSelectionChange();
	      }
	    };
	    document.addEventListener('selectionchange', listener, {
	      once: true
	    });
	  }
	  handleSelectionChange() {
	    const selection = document.getSelection();
	    if (!selection) return;
	    const range = selection.getRangeAt(0);
	    if (range.collapsed !== true || range.startOffset !== 0) return;
	    const line = this.quill.scroll.find(range.startContainer);
	    if (!(line instanceof ParentBlot$1) || !line.uiNode) return;
	    const newRange = document.createRange();
	    newRange.setStartAfter(line.uiNode);
	    newRange.setEndAfter(line.uiNode);
	    selection.removeAllRanges();
	    selection.addRange(newRange);
	  }
	}

	Quill.register({
	  'blots/block': Block,
	  'blots/block/embed': BlockEmbed,
	  'blots/break': Break,
	  'blots/container': Container,
	  'blots/cursor': Cursor,
	  'blots/embed': Embed,
	  'blots/inline': Inline,
	  'blots/scroll': Scroll,
	  'blots/text': Text$1,
	  'modules/clipboard': Clipboard,
	  'modules/history': History,
	  'modules/keyboard': Keyboard,
	  'modules/uploader': Uploader,
	  'modules/input': Input,
	  'modules/uiNode': UINode
	});

	class IndentAttributor extends ClassAttributor$1 {
	  add(node, value) {
	    let normalizedValue = 0;
	    if (value === '+1' || value === '-1') {
	      const indent = this.value(node) || 0;
	      normalizedValue = value === '+1' ? indent + 1 : indent - 1;
	    } else if (typeof value === 'number') {
	      normalizedValue = value;
	    }
	    if (normalizedValue === 0) {
	      this.remove(node);
	      return true;
	    }
	    return super.add(node, normalizedValue.toString());
	  }
	  canAdd(node, value) {
	    return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
	  }
	  value(node) {
	    return parseInt(super.value(node), 10) || undefined; // Don't return NaN
	  }
	}
	const IndentClass = new IndentAttributor('indent', 'ql-indent', {
	  scope: Scope.BLOCK,
	  // @ts-expect-error
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});

	class Blockquote extends Block {
	  static blotName = 'blockquote';
	  static tagName = 'blockquote';
	}

	class Header extends Block {
	  static blotName = 'header';
	  static tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
	  static formats(domNode) {
	    return this.tagName.indexOf(domNode.tagName) + 1;
	  }
	}

	class ListContainer extends Container {}
	ListContainer.blotName = 'list-container';
	ListContainer.tagName = 'OL';
	class ListItem extends Block {
	  static create(value) {
	    const node = super.create();
	    node.setAttribute('data-list', value);
	    return node;
	  }
	  static formats(domNode) {
	    return domNode.getAttribute('data-list') || undefined;
	  }
	  static register() {
	    Quill.register(ListContainer);
	  }
	  constructor(scroll, domNode) {
	    super(scroll, domNode);
	    const ui = domNode.ownerDocument.createElement('span');
	    const listEventHandler = e => {
	      if (!scroll.isEnabled()) return;
	      const format = this.statics.formats(domNode, scroll);
	      if (format === 'checked') {
	        this.format('list', 'unchecked');
	        e.preventDefault();
	      } else if (format === 'unchecked') {
	        this.format('list', 'checked');
	        e.preventDefault();
	      }
	    };
	    ui.addEventListener('mousedown', listEventHandler);
	    ui.addEventListener('touchstart', listEventHandler);
	    this.attachUI(ui);
	  }
	  format(name, value) {
	    if (name === this.statics.blotName && value) {
	      this.domNode.setAttribute('data-list', value);
	    } else {
	      super.format(name, value);
	    }
	  }
	}
	ListItem.blotName = 'list';
	ListItem.tagName = 'LI';
	ListContainer.allowedChildren = [ListItem];
	ListItem.requiredContainer = ListContainer;

	class Bold extends Inline {
	  static blotName = 'bold';
	  static tagName = ['STRONG', 'B'];
	  static create() {
	    return super.create();
	  }
	  static formats() {
	    return true;
	  }
	  optimize(context) {
	    super.optimize(context);
	    if (this.domNode.tagName !== this.statics.tagName[0]) {
	      this.replaceWith(this.statics.blotName);
	    }
	  }
	}

	class Italic extends Bold {
	  static blotName = 'italic';
	  static tagName = ['EM', 'I'];
	}

	class Link extends Inline {
	  static blotName = 'link';
	  static tagName = 'A';
	  static SANITIZED_URL = 'about:blank';
	  static PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel', 'sms'];
	  static create(value) {
	    const node = super.create(value);
	    node.setAttribute('href', this.sanitize(value));
	    node.setAttribute('rel', 'noopener noreferrer');
	    node.setAttribute('target', '_blank');
	    return node;
	  }
	  static formats(domNode) {
	    return domNode.getAttribute('href');
	  }
	  static sanitize(url) {
	    return sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
	  }
	  format(name, value) {
	    if (name !== this.statics.blotName || !value) {
	      super.format(name, value);
	    } else {
	      // @ts-expect-error
	      this.domNode.setAttribute('href', this.constructor.sanitize(value));
	    }
	  }
	}
	function sanitize(url, protocols) {
	  const anchor = document.createElement('a');
	  anchor.href = url;
	  const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}

	class Script extends Inline {
	  static blotName = 'script';
	  static tagName = ['SUB', 'SUP'];
	  static create(value) {
	    if (value === 'super') {
	      return document.createElement('sup');
	    }
	    if (value === 'sub') {
	      return document.createElement('sub');
	    }
	    return super.create(value);
	  }
	  static formats(domNode) {
	    if (domNode.tagName === 'SUB') return 'sub';
	    if (domNode.tagName === 'SUP') return 'super';
	    return undefined;
	  }
	}

	class Strike extends Bold {
	  static blotName = 'strike';
	  static tagName = ['S', 'STRIKE'];
	}

	class Underline extends Inline {
	  static blotName = 'underline';
	  static tagName = 'U';
	}

	class Formula extends Embed {
	  static blotName = 'formula';
	  static className = 'ql-formula';
	  static tagName = 'SPAN';
	  static create(value) {
	    // @ts-expect-error
	    if (window.katex == null) {
	      throw new Error('Formula module requires KaTeX.');
	    }
	    const node = super.create(value);
	    if (typeof value === 'string') {
	      // @ts-expect-error
	      window.katex.render(value, node, {
	        throwOnError: false,
	        errorColor: '#f00'
	      });
	      node.setAttribute('data-value', value);
	    }
	    return node;
	  }
	  static value(domNode) {
	    return domNode.getAttribute('data-value');
	  }
	  html() {
	    const {
	      formula
	    } = this.value();
	    return `<span>${formula}</span>`;
	  }
	}

	const ATTRIBUTES$1 = ['alt', 'height', 'width'];
	class Image extends EmbedBlot$1 {
	  static blotName = 'image';
	  static tagName = 'IMG';
	  static create(value) {
	    const node = super.create(value);
	    if (typeof value === 'string') {
	      node.setAttribute('src', this.sanitize(value));
	    }
	    return node;
	  }
	  static formats(domNode) {
	    return ATTRIBUTES$1.reduce((formats, attribute) => {
	      if (domNode.hasAttribute(attribute)) {
	        formats[attribute] = domNode.getAttribute(attribute);
	      }
	      return formats;
	    }, {});
	  }
	  static match(url) {
	    return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
	  }
	  static sanitize(url) {
	    return sanitize(url, ['http', 'https', 'data']) ? url : '//:0';
	  }
	  static value(domNode) {
	    return domNode.getAttribute('src');
	  }
	  format(name, value) {
	    if (ATTRIBUTES$1.indexOf(name) > -1) {
	      if (value) {
	        this.domNode.setAttribute(name, value);
	      } else {
	        this.domNode.removeAttribute(name);
	      }
	    } else {
	      super.format(name, value);
	    }
	  }
	}

	const ATTRIBUTES = ['height', 'width'];
	class Video extends BlockEmbed {
	  static blotName = 'video';
	  static className = 'ql-video';
	  static tagName = 'IFRAME';
	  static create(value) {
	    const node = super.create(value);
	    node.setAttribute('frameborder', '0');
	    node.setAttribute('allowfullscreen', 'true');
	    node.setAttribute('src', this.sanitize(value));
	    return node;
	  }
	  static formats(domNode) {
	    return ATTRIBUTES.reduce((formats, attribute) => {
	      if (domNode.hasAttribute(attribute)) {
	        formats[attribute] = domNode.getAttribute(attribute);
	      }
	      return formats;
	    }, {});
	  }
	  static sanitize(url) {
	    return Link.sanitize(url);
	  }
	  static value(domNode) {
	    return domNode.getAttribute('src');
	  }
	  format(name, value) {
	    if (ATTRIBUTES.indexOf(name) > -1) {
	      if (value) {
	        this.domNode.setAttribute(name, value);
	      } else {
	        this.domNode.removeAttribute(name);
	      }
	    } else {
	      super.format(name, value);
	    }
	  }
	  html() {
	    const {
	      video
	    } = this.value();
	    return `<a href="${video}">${video}</a>`;
	  }
	}

	const TokenAttributor = new ClassAttributor$1('code-token', 'hljs', {
	  scope: Scope.INLINE
	});
	class CodeToken extends Inline {
	  static formats(node, scroll) {
	    while (node != null && node !== scroll.domNode) {
	      if (node.classList && node.classList.contains(CodeBlock.className)) {
	        // @ts-expect-error
	        return super.formats(node, scroll);
	      }
	      // @ts-expect-error
	      node = node.parentNode;
	    }
	    return undefined;
	  }
	  constructor(scroll, domNode, value) {
	    // @ts-expect-error
	    super(scroll, domNode, value);
	    TokenAttributor.add(this.domNode, value);
	  }
	  format(format, value) {
	    if (format !== CodeToken.blotName) {
	      super.format(format, value);
	    } else if (value) {
	      TokenAttributor.add(this.domNode, value);
	    } else {
	      TokenAttributor.remove(this.domNode);
	      this.domNode.classList.remove(this.statics.className);
	    }
	  }
	  optimize() {
	    // @ts-expect-error
	    super.optimize(...arguments);
	    if (!TokenAttributor.value(this.domNode)) {
	      this.unwrap();
	    }
	  }
	}
	CodeToken.blotName = 'code-token';
	CodeToken.className = 'ql-token';
	class SyntaxCodeBlock extends CodeBlock {
	  static create(value) {
	    const domNode = super.create(value);
	    if (typeof value === 'string') {
	      domNode.setAttribute('data-language', value);
	    }
	    return domNode;
	  }
	  static formats(domNode) {
	    // @ts-expect-error
	    return domNode.getAttribute('data-language') || 'plain';
	  }
	  static register() {} // Syntax module will register

	  format(name, value) {
	    if (name === this.statics.blotName && value) {
	      // @ts-expect-error
	      this.domNode.setAttribute('data-language', value);
	    } else {
	      super.format(name, value);
	    }
	  }
	  replaceWith(name, value) {
	    this.formatAt(0, this.length(), CodeToken.blotName, false);
	    return super.replaceWith(name, value);
	  }
	}
	class SyntaxCodeBlockContainer extends CodeBlockContainer {
	  attach() {
	    super.attach();
	    this.forceNext = false;
	    // @ts-expect-error
	    this.scroll.emitMount(this);
	  }
	  format(name, value) {
	    if (name === SyntaxCodeBlock.blotName) {
	      this.forceNext = true;
	      this.children.forEach(child => {
	        // @ts-expect-error
	        child.format(name, value);
	      });
	    }
	  }
	  formatAt(index, length, name, value) {
	    if (name === SyntaxCodeBlock.blotName) {
	      this.forceNext = true;
	    }
	    super.formatAt(index, length, name, value);
	  }
	  highlight(highlight) {
	    let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    if (this.children.head == null) return;
	    const nodes = Array.from(this.domNode.childNodes).filter(node => node !== this.uiNode);
	    const text = `${nodes.map(node => node.textContent).join('\n')}\n`;
	    const language = SyntaxCodeBlock.formats(this.children.head.domNode);
	    if (forced || this.forceNext || this.cachedText !== text) {
	      if (text.trim().length > 0 || this.cachedText == null) {
	        const oldDelta = this.children.reduce((delta, child) => {
	          // @ts-expect-error
	          return delta.concat(blockDelta(child, false));
	        }, new Delta());
	        const delta = highlight(text, language);
	        oldDelta.diff(delta).reduce((index, _ref) => {
	          let {
	            retain,
	            attributes
	          } = _ref;
	          // Should be all retains
	          if (!retain) return index;
	          if (attributes) {
	            Object.keys(attributes).forEach(format => {
	              if ([SyntaxCodeBlock.blotName, CodeToken.blotName].includes(format)) {
	                // @ts-expect-error
	                this.formatAt(index, retain, format, attributes[format]);
	              }
	            });
	          }
	          // @ts-expect-error
	          return index + retain;
	        }, 0);
	      }
	      this.cachedText = text;
	      this.forceNext = false;
	    }
	  }
	  html(index, length) {
	    const [codeBlock] = this.children.find(index);
	    const language = codeBlock ? SyntaxCodeBlock.formats(codeBlock.domNode) : 'plain';
	    return `<pre data-language="${language}">\n${escapeText(this.code(index, length))}\n</pre>`;
	  }
	  optimize(context) {
	    super.optimize(context);
	    if (this.parent != null && this.children.head != null && this.uiNode != null) {
	      const language = SyntaxCodeBlock.formats(this.children.head.domNode);
	      // @ts-expect-error
	      if (language !== this.uiNode.value) {
	        // @ts-expect-error
	        this.uiNode.value = language;
	      }
	    }
	  }
	}
	SyntaxCodeBlockContainer.allowedChildren = [SyntaxCodeBlock];
	SyntaxCodeBlock.requiredContainer = SyntaxCodeBlockContainer;
	SyntaxCodeBlock.allowedChildren = [CodeToken, Cursor, Text$1, Break];
	const highlight = (lib, language, text) => {
	  if (typeof lib.versionString === 'string') {
	    const majorVersion = lib.versionString.split('.')[0];
	    if (parseInt(majorVersion, 10) >= 11) {
	      return lib.highlight(text, {
	        language
	      }).value;
	    }
	  }
	  return lib.highlight(language, text).value;
	};
	class Syntax extends Module {
	  static register() {
	    Quill.register(CodeToken, true);
	    Quill.register(SyntaxCodeBlock, true);
	    Quill.register(SyntaxCodeBlockContainer, true);
	  }
	  constructor(quill, options) {
	    super(quill, options);
	    if (this.options.hljs == null) {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    // @ts-expect-error Fix me later
	    this.languages = this.options.languages.reduce((memo, _ref2) => {
	      let {
	        key
	      } = _ref2;
	      memo[key] = true;
	      return memo;
	    }, {});
	    this.highlightBlot = this.highlightBlot.bind(this);
	    this.initListener();
	    this.initTimer();
	  }
	  initListener() {
	    this.quill.on(Quill.events.SCROLL_BLOT_MOUNT, blot => {
	      if (!(blot instanceof SyntaxCodeBlockContainer)) return;
	      const select = this.quill.root.ownerDocument.createElement('select');
	      // @ts-expect-error Fix me later
	      this.options.languages.forEach(_ref3 => {
	        let {
	          key,
	          label
	        } = _ref3;
	        const option = select.ownerDocument.createElement('option');
	        option.textContent = label;
	        option.setAttribute('value', key);
	        select.appendChild(option);
	      });
	      select.addEventListener('change', () => {
	        blot.format(SyntaxCodeBlock.blotName, select.value);
	        this.quill.root.focus(); // Prevent scrolling
	        this.highlight(blot, true);
	      });
	      if (blot.uiNode == null) {
	        blot.attachUI(select);
	        if (blot.children.head) {
	          select.value = SyntaxCodeBlock.formats(blot.children.head.domNode);
	        }
	      }
	    });
	  }
	  initTimer() {
	    let timer = null;
	    this.quill.on(Quill.events.SCROLL_OPTIMIZE, () => {
	      if (timer) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(() => {
	        this.highlight();
	        timer = null;
	      }, this.options.interval);
	    });
	  }
	  highlight() {
	    let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    if (this.quill.selection.composing) return;
	    this.quill.update(Quill.sources.USER);
	    const range = this.quill.getSelection();
	    const blots = blot == null ? this.quill.scroll.descendants(SyntaxCodeBlockContainer) : [blot];
	    blots.forEach(container => {
	      container.highlight(this.highlightBlot, force);
	    });
	    this.quill.update(Quill.sources.SILENT);
	    if (range != null) {
	      this.quill.setSelection(range, Quill.sources.SILENT);
	    }
	  }
	  highlightBlot(text) {
	    let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
	    language = this.languages[language] ? language : 'plain';
	    if (language === 'plain') {
	      return escapeText(text).split('\n').reduce((delta, line, i) => {
	        if (i !== 0) {
	          delta.insert('\n', {
	            [CodeBlock.blotName]: language
	          });
	        }
	        return delta.insert(line);
	      }, new Delta());
	    }
	    const container = this.quill.root.ownerDocument.createElement('div');
	    container.classList.add(CodeBlock.className);
	    container.innerHTML = highlight(this.options.hljs, language, text);
	    return traverse(this.quill.scroll, container, [(node, delta) => {
	      // @ts-expect-error
	      const value = TokenAttributor.value(node);
	      if (value) {
	        return delta.compose(new Delta().retain(delta.length(), {
	          [CodeToken.blotName]: value
	        }));
	      }
	      return delta;
	    }], [(node, delta) => {
	      // @ts-expect-error
	      return node.data.split('\n').reduce((memo, nodeText, i) => {
	        if (i !== 0) memo.insert('\n', {
	          [CodeBlock.blotName]: language
	        });
	        return memo.insert(nodeText);
	      }, delta);
	    }], new WeakMap());
	  }
	}
	Syntax.DEFAULTS = {
	  hljs: (() => {
	    return window.hljs;
	  })(),
	  interval: 1000,
	  languages: [{
	    key: 'plain',
	    label: 'Plain'
	  }, {
	    key: 'bash',
	    label: 'Bash'
	  }, {
	    key: 'cpp',
	    label: 'C++'
	  }, {
	    key: 'cs',
	    label: 'C#'
	  }, {
	    key: 'css',
	    label: 'CSS'
	  }, {
	    key: 'diff',
	    label: 'Diff'
	  }, {
	    key: 'xml',
	    label: 'HTML/XML'
	  }, {
	    key: 'java',
	    label: 'Java'
	  }, {
	    key: 'javascript',
	    label: 'JavaScript'
	  }, {
	    key: 'markdown',
	    label: 'Markdown'
	  }, {
	    key: 'php',
	    label: 'PHP'
	  }, {
	    key: 'python',
	    label: 'Python'
	  }, {
	    key: 'ruby',
	    label: 'Ruby'
	  }, {
	    key: 'sql',
	    label: 'SQL'
	  }]
	};

	class TableCell extends Block {
	  static blotName = 'table';
	  static tagName = 'TD';
	  static create(value) {
	    const node = super.create();
	    if (value) {
	      node.setAttribute('data-row', value);
	    } else {
	      node.setAttribute('data-row', tableId());
	    }
	    return node;
	  }
	  static formats(domNode) {
	    if (domNode.hasAttribute('data-row')) {
	      return domNode.getAttribute('data-row');
	    }
	    return undefined;
	  }
	  cellOffset() {
	    if (this.parent) {
	      return this.parent.children.indexOf(this);
	    }
	    return -1;
	  }
	  format(name, value) {
	    if (name === TableCell.blotName && value) {
	      this.domNode.setAttribute('data-row', value);
	    } else {
	      super.format(name, value);
	    }
	  }
	  row() {
	    return this.parent;
	  }
	  rowOffset() {
	    if (this.row()) {
	      return this.row().rowOffset();
	    }
	    return -1;
	  }
	  table() {
	    return this.row() && this.row().table();
	  }
	}
	class TableRow extends Container {
	  static blotName = 'table-row';
	  static tagName = 'TR';
	  checkMerge() {
	    // @ts-expect-error
	    if (super.checkMerge() && this.next.children.head != null) {
	      // @ts-expect-error
	      const thisHead = this.children.head.formats();
	      // @ts-expect-error
	      const thisTail = this.children.tail.formats();
	      // @ts-expect-error
	      const nextHead = this.next.children.head.formats();
	      // @ts-expect-error
	      const nextTail = this.next.children.tail.formats();
	      return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
	    }
	    return false;
	  }
	  optimize(context) {
	    super.optimize(context);
	    this.children.forEach(child => {
	      if (child.next == null) return;
	      const childFormats = child.formats();
	      const nextFormats = child.next.formats();
	      if (childFormats.table !== nextFormats.table) {
	        const next = this.splitAfter(child);
	        if (next) {
	          // @ts-expect-error TODO: parameters of optimize() should be a optional
	          next.optimize();
	        }
	        // We might be able to merge with prev now
	        if (this.prev) {
	          // @ts-expect-error TODO: parameters of optimize() should be a optional
	          this.prev.optimize();
	        }
	      }
	    });
	  }
	  rowOffset() {
	    if (this.parent) {
	      return this.parent.children.indexOf(this);
	    }
	    return -1;
	  }
	  table() {
	    return this.parent && this.parent.parent;
	  }
	}
	class TableBody extends Container {
	  static blotName = 'table-body';
	  static tagName = 'TBODY';
	}
	class TableContainer extends Container {
	  static blotName = 'table-container';
	  static tagName = 'TABLE';
	  balanceCells() {
	    const rows = this.descendants(TableRow);
	    const maxColumns = rows.reduce((max, row) => {
	      return Math.max(row.children.length, max);
	    }, 0);
	    rows.forEach(row => {
	      new Array(maxColumns - row.children.length).fill(0).forEach(() => {
	        let value;
	        if (row.children.head != null) {
	          value = TableCell.formats(row.children.head.domNode);
	        }
	        const blot = this.scroll.create(TableCell.blotName, value);
	        row.appendChild(blot);
	        // @ts-expect-error TODO: parameters of optimize() should be a optional
	        blot.optimize(); // Add break blot
	      });
	    });
	  }
	  cells(column) {
	    return this.rows().map(row => row.children.at(column));
	  }
	  deleteColumn(index) {
	    // @ts-expect-error
	    const [body] = this.descendant(TableBody);
	    if (body == null || body.children.head == null) return;
	    body.children.forEach(row => {
	      const cell = row.children.at(index);
	      if (cell != null) {
	        cell.remove();
	      }
	    });
	  }
	  insertColumn(index) {
	    // @ts-expect-error
	    const [body] = this.descendant(TableBody);
	    if (body == null || body.children.head == null) return;
	    body.children.forEach(row => {
	      const ref = row.children.at(index);
	      // @ts-expect-error
	      const value = TableCell.formats(row.children.head.domNode);
	      const cell = this.scroll.create(TableCell.blotName, value);
	      row.insertBefore(cell, ref);
	    });
	  }
	  insertRow(index) {
	    // @ts-expect-error
	    const [body] = this.descendant(TableBody);
	    if (body == null || body.children.head == null) return;
	    const id = tableId();
	    const row = this.scroll.create(TableRow.blotName);
	    body.children.head.children.forEach(() => {
	      const cell = this.scroll.create(TableCell.blotName, id);
	      row.appendChild(cell);
	    });
	    const ref = body.children.at(index);
	    body.insertBefore(row, ref);
	  }
	  rows() {
	    const body = this.children.head;
	    if (body == null) return [];
	    return body.children.map(row => row);
	  }
	}
	TableContainer.allowedChildren = [TableBody];
	TableBody.requiredContainer = TableContainer;
	TableBody.allowedChildren = [TableRow];
	TableRow.requiredContainer = TableBody;
	TableRow.allowedChildren = [TableCell];
	TableCell.requiredContainer = TableRow;
	function tableId() {
	  const id = Math.random().toString(36).slice(2, 6);
	  return `row-${id}`;
	}

	class Table extends Module {
	  static register() {
	    Quill.register(TableCell);
	    Quill.register(TableRow);
	    Quill.register(TableBody);
	    Quill.register(TableContainer);
	  }
	  constructor() {
	    super(...arguments);
	    this.listenBalanceCells();
	  }
	  balanceTables() {
	    this.quill.scroll.descendants(TableContainer).forEach(table => {
	      table.balanceCells();
	    });
	  }
	  deleteColumn() {
	    const [table,, cell] = this.getTable();
	    if (cell == null) return;
	    // @ts-expect-error
	    table.deleteColumn(cell.cellOffset());
	    this.quill.update(Quill.sources.USER);
	  }
	  deleteRow() {
	    const [, row] = this.getTable();
	    if (row == null) return;
	    row.remove();
	    this.quill.update(Quill.sources.USER);
	  }
	  deleteTable() {
	    const [table] = this.getTable();
	    if (table == null) return;
	    // @ts-expect-error
	    const offset = table.offset();
	    // @ts-expect-error
	    table.remove();
	    this.quill.update(Quill.sources.USER);
	    this.quill.setSelection(offset, Quill.sources.SILENT);
	  }
	  getTable() {
	    let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
	    if (range == null) return [null, null, null, -1];
	    const [cell, offset] = this.quill.getLine(range.index);
	    if (cell == null || cell.statics.blotName !== TableCell.blotName) {
	      return [null, null, null, -1];
	    }
	    const row = cell.parent;
	    const table = row.parent.parent;
	    // @ts-expect-error
	    return [table, row, cell, offset];
	  }
	  insertColumn(offset) {
	    const range = this.quill.getSelection();
	    if (!range) return;
	    const [table, row, cell] = this.getTable(range);
	    if (cell == null) return;
	    const column = cell.cellOffset();
	    table.insertColumn(column + offset);
	    this.quill.update(Quill.sources.USER);
	    let shift = row.rowOffset();
	    if (offset === 0) {
	      shift += 1;
	    }
	    this.quill.setSelection(range.index + shift, range.length, Quill.sources.SILENT);
	  }
	  insertColumnLeft() {
	    this.insertColumn(0);
	  }
	  insertColumnRight() {
	    this.insertColumn(1);
	  }
	  insertRow(offset) {
	    const range = this.quill.getSelection();
	    if (!range) return;
	    const [table, row, cell] = this.getTable(range);
	    if (cell == null) return;
	    const index = row.rowOffset();
	    table.insertRow(index + offset);
	    this.quill.update(Quill.sources.USER);
	    if (offset > 0) {
	      this.quill.setSelection(range, Quill.sources.SILENT);
	    } else {
	      this.quill.setSelection(range.index + row.children.length, range.length, Quill.sources.SILENT);
	    }
	  }
	  insertRowAbove() {
	    this.insertRow(0);
	  }
	  insertRowBelow() {
	    this.insertRow(1);
	  }
	  insertTable(rows, columns) {
	    const range = this.quill.getSelection();
	    if (range == null) return;
	    const delta = new Array(rows).fill(0).reduce(memo => {
	      const text = new Array(columns).fill('\n').join('');
	      return memo.insert(text, {
	        table: tableId()
	      });
	    }, new Delta().retain(range.index));
	    this.quill.updateContents(delta, Quill.sources.USER);
	    this.quill.setSelection(range.index, Quill.sources.SILENT);
	    this.balanceTables();
	  }
	  listenBalanceCells() {
	    this.quill.on(Quill.events.SCROLL_OPTIMIZE, mutations => {
	      mutations.some(mutation => {
	        if (['TD', 'TR', 'TBODY', 'TABLE'].includes(mutation.target.tagName)) {
	          this.quill.once(Quill.events.TEXT_CHANGE, (delta, old, source) => {
	            if (source !== Quill.sources.USER) return;
	            this.balanceTables();
	          });
	          return true;
	        }
	        return false;
	      });
	    });
	  }
	}

	const debug = namespace('quill:toolbar');
	class Toolbar extends Module {
	  constructor(quill, options) {
	    super(quill, options);
	    if (Array.isArray(this.options.container)) {
	      const container = document.createElement('div');
	      container.setAttribute('role', 'toolbar');
	      addControls(container, this.options.container);
	      quill.container?.parentNode?.insertBefore(container, quill.container);
	      this.container = container;
	    } else if (typeof this.options.container === 'string') {
	      this.container = document.querySelector(this.options.container);
	    } else {
	      this.container = this.options.container;
	    }
	    if (!(this.container instanceof HTMLElement)) {
	      debug.error('Container required for toolbar', this.options);
	      return;
	    }
	    this.container.classList.add('ql-toolbar');
	    this.controls = [];
	    this.handlers = {};
	    if (this.options.handlers) {
	      Object.keys(this.options.handlers).forEach(format => {
	        const handler = this.options.handlers?.[format];
	        if (handler) {
	          this.addHandler(format, handler);
	        }
	      });
	    }
	    Array.from(this.container.querySelectorAll('button, select')).forEach(input => {
	      // @ts-expect-error
	      this.attach(input);
	    });
	    this.quill.on(Quill.events.EDITOR_CHANGE, () => {
	      const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
	      this.update(range);
	    });
	  }
	  addHandler(format, handler) {
	    this.handlers[format] = handler;
	  }
	  attach(input) {
	    let format = Array.from(input.classList).find(className => {
	      return className.indexOf('ql-') === 0;
	    });
	    if (!format) return;
	    format = format.slice('ql-'.length);
	    if (input.tagName === 'BUTTON') {
	      input.setAttribute('type', 'button');
	    }
	    if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
	      debug.warn('ignoring attaching to nonexistent format', format, input);
	      return;
	    }
	    const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	    input.addEventListener(eventName, e => {
	      let value;
	      if (input.tagName === 'SELECT') {
	        // @ts-expect-error
	        if (input.selectedIndex < 0) return;
	        // @ts-expect-error
	        const selected = input.options[input.selectedIndex];
	        if (selected.hasAttribute('selected')) {
	          value = false;
	        } else {
	          value = selected.value || false;
	        }
	      } else {
	        if (input.classList.contains('ql-active')) {
	          value = false;
	        } else {
	          // @ts-expect-error
	          value = input.value || !input.hasAttribute('value');
	        }
	        e.preventDefault();
	      }
	      this.quill.focus();
	      const [range] = this.quill.selection.getRange();
	      if (this.handlers[format] != null) {
	        this.handlers[format].call(this, value);
	      } else if (
	      // @ts-expect-error
	      this.quill.scroll.query(format).prototype instanceof EmbedBlot$1) {
	        value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
	        if (!value) return;
	        this.quill.updateContents(new Delta()
	        // @ts-expect-error Fix me later
	        .retain(range.index)
	        // @ts-expect-error Fix me later
	        .delete(range.length).insert({
	          [format]: value
	        }), Quill.sources.USER);
	      } else {
	        this.quill.format(format, value, Quill.sources.USER);
	      }
	      this.update(range);
	    });
	    this.controls.push([format, input]);
	  }
	  update(range) {
	    const formats = range == null ? {} : this.quill.getFormat(range);
	    this.controls.forEach(pair => {
	      const [format, input] = pair;
	      if (input.tagName === 'SELECT') {
	        let option = null;
	        if (range == null) {
	          option = null;
	        } else if (formats[format] == null) {
	          option = input.querySelector('option[selected]');
	        } else if (!Array.isArray(formats[format])) {
	          let value = formats[format];
	          if (typeof value === 'string') {
	            value = value.replace(/"/g, '\\"');
	          }
	          option = input.querySelector(`option[value="${value}"]`);
	        }
	        if (option == null) {
	          // @ts-expect-error TODO fix me later
	          input.value = ''; // TODO make configurable?
	          // @ts-expect-error TODO fix me later
	          input.selectedIndex = -1;
	        } else {
	          option.selected = true;
	        }
	      } else if (range == null) {
	        input.classList.remove('ql-active');
	        input.setAttribute('aria-pressed', 'false');
	      } else if (input.hasAttribute('value')) {
	        // both being null should match (default values)
	        // '1' should match with 1 (headers)
	        const value = formats[format];
	        const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
	        input.classList.toggle('ql-active', isActive);
	        input.setAttribute('aria-pressed', isActive.toString());
	      } else {
	        const isActive = formats[format] != null;
	        input.classList.toggle('ql-active', isActive);
	        input.setAttribute('aria-pressed', isActive.toString());
	      }
	    });
	  }
	}
	Toolbar.DEFAULTS = {};
	function addButton(container, format, value) {
	  const input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add(`ql-${format}`);
	  input.setAttribute('aria-pressed', 'false');
	  if (value != null) {
	    input.value = value;
	    input.setAttribute('aria-label', `${format}: ${value}`);
	  } else {
	    input.setAttribute('aria-label', format);
	  }
	  container.appendChild(input);
	}
	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    // @ts-expect-error
	    groups = [groups];
	  }
	  groups.forEach(controls => {
	    const group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(control => {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        const format = Object.keys(control)[0];
	        const value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}
	function addSelect(container, format, values) {
	  const input = document.createElement('select');
	  input.classList.add(`ql-${format}`);
	  values.forEach(value => {
	    const option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', String(value));
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}
	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean() {
	      const range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length === 0) {
	        const formats = this.quill.getFormat();
	        Object.keys(formats).forEach(name => {
	          // Clean functionality in existing apps only clean inline formats
	          if (this.quill.scroll.query(name, Scope.INLINE) != null) {
	            this.quill.format(name, false, Quill.sources.USER);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range.index, range.length, Quill.sources.USER);
	      }
	    },
	    direction(value) {
	      const {
	        align
	      } = this.quill.getFormat();
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', Quill.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, Quill.sources.USER);
	      }
	      this.quill.format('direction', value, Quill.sources.USER);
	    },
	    indent(value) {
	      const range = this.quill.getSelection();
	      // @ts-expect-error
	      const formats = this.quill.getFormat(range);
	      // @ts-expect-error
	      const indent = parseInt(formats.indent || 0, 10);
	      if (value === '+1' || value === '-1') {
	        let modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, Quill.sources.USER);
	      }
	    },
	    link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:'); // eslint-disable-line no-alert
	      }
	      this.quill.format('link', value, Quill.sources.USER);
	    },
	    list(value) {
	      const range = this.quill.getSelection();
	      // @ts-expect-error
	      const formats = this.quill.getFormat(range);
	      if (value === 'check') {
	        if (formats.list === 'checked' || formats.list === 'unchecked') {
	          this.quill.format('list', false, Quill.sources.USER);
	        } else {
	          this.quill.format('list', 'unchecked', Quill.sources.USER);
	        }
	      } else {
	        this.quill.format('list', value, Quill.sources.USER);
	      }
	    }
	  }
	};

	const alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
	const alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
	const alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
	const alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
	const backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
	const blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
	const boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
	const cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
	const codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
	const colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
	const directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
	const directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
	const formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
	const headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
	const header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
	const header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
	const header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
	const header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
	const header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
	const italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
	const imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
	const indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
	const outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
	const linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
	const listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
	const listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
	const listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
	const subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
	const superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
	const strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
	const tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
	const underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
	const videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
	var Icons = {
	  align: {
	    '': alignLeftIcon,
	    center: alignCenterIcon,
	    right: alignRightIcon,
	    justify: alignJustifyIcon
	  },
	  background: backgroundIcon,
	  blockquote: blockquoteIcon,
	  bold: boldIcon,
	  clean: cleanIcon,
	  code: codeIcon,
	  'code-block': codeIcon,
	  color: colorIcon,
	  direction: {
	    '': directionLeftToRightIcon,
	    rtl: directionRightToLeftIcon
	  },
	  formula: formulaIcon,
	  header: {
	    '1': headerIcon,
	    '2': header2Icon,
	    '3': header3Icon,
	    '4': header4Icon,
	    '5': header5Icon,
	    '6': header6Icon
	  },
	  italic: italicIcon,
	  image: imageIcon,
	  indent: {
	    '+1': indentIcon,
	    '-1': outdentIcon
	  },
	  link: linkIcon,
	  list: {
	    bullet: listBulletIcon,
	    check: listCheckIcon,
	    ordered: listOrderedIcon
	  },
	  script: {
	    sub: subscriptIcon,
	    super: superscriptIcon
	  },
	  strike: strikeIcon,
	  table: tableIcon,
	  underline: underlineIcon,
	  video: videoIcon
	};

	const DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
	let optionsCounter = 0;
	function toggleAriaAttribute(element, attribute) {
	  element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
	}
	class Picker {
	  constructor(select) {
	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    // @ts-expect-error Fix me later
	    this.select.parentNode.insertBefore(this.container, this.select);
	    this.label.addEventListener('mousedown', () => {
	      this.togglePicker();
	    });
	    this.label.addEventListener('keydown', event => {
	      switch (event.key) {
	        case 'Enter':
	          this.togglePicker();
	          break;
	        case 'Escape':
	          this.escape();
	          event.preventDefault();
	          break;
	      }
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }
	  togglePicker() {
	    this.container.classList.toggle('ql-expanded');
	    // Toggle aria-expanded and aria-hidden to make the picker accessible
	    toggleAriaAttribute(this.label, 'aria-expanded');
	    // @ts-expect-error
	    toggleAriaAttribute(this.options, 'aria-hidden');
	  }
	  buildItem(option) {
	    const item = document.createElement('span');
	    // @ts-expect-error
	    item.tabIndex = '0';
	    item.setAttribute('role', 'button');
	    item.classList.add('ql-picker-item');
	    const value = option.getAttribute('value');
	    if (value) {
	      item.setAttribute('data-value', value);
	    }
	    if (option.textContent) {
	      item.setAttribute('data-label', option.textContent);
	    }
	    item.addEventListener('click', () => {
	      this.selectItem(item, true);
	    });
	    item.addEventListener('keydown', event => {
	      switch (event.key) {
	        case 'Enter':
	          this.selectItem(item, true);
	          event.preventDefault();
	          break;
	        case 'Escape':
	          this.escape();
	          event.preventDefault();
	          break;
	      }
	    });
	    return item;
	  }
	  buildLabel() {
	    const label = document.createElement('span');
	    label.classList.add('ql-picker-label');
	    label.innerHTML = DropdownIcon;
	    // @ts-expect-error
	    label.tabIndex = '0';
	    label.setAttribute('role', 'button');
	    label.setAttribute('aria-expanded', 'false');
	    this.container.appendChild(label);
	    return label;
	  }
	  buildOptions() {
	    const options = document.createElement('span');
	    options.classList.add('ql-picker-options');

	    // Don't want screen readers to read this until options are visible
	    options.setAttribute('aria-hidden', 'true');
	    // @ts-expect-error
	    options.tabIndex = '-1';

	    // Need a unique id for aria-controls
	    options.id = `ql-picker-options-${optionsCounter}`;
	    optionsCounter += 1;
	    this.label.setAttribute('aria-controls', options.id);

	    // @ts-expect-error
	    this.options = options;
	    Array.from(this.select.options).forEach(option => {
	      const item = this.buildItem(option);
	      options.appendChild(item);
	      if (option.selected === true) {
	        this.selectItem(item);
	      }
	    });
	    this.container.appendChild(options);
	  }
	  buildPicker() {
	    Array.from(this.select.attributes).forEach(item => {
	      this.container.setAttribute(item.name, item.value);
	    });
	    this.container.classList.add('ql-picker');
	    this.label = this.buildLabel();
	    this.buildOptions();
	  }
	  escape() {
	    // Close menu and return focus to trigger label
	    this.close();
	    // Need setTimeout for accessibility to ensure that the browser executes
	    // focus on the next process thread and after any DOM content changes
	    setTimeout(() => this.label.focus(), 1);
	  }
	  close() {
	    this.container.classList.remove('ql-expanded');
	    this.label.setAttribute('aria-expanded', 'false');
	    // @ts-expect-error
	    this.options.setAttribute('aria-hidden', 'true');
	  }
	  selectItem(item) {
	    let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    const selected = this.container.querySelector('.ql-selected');
	    if (item === selected) return;
	    if (selected != null) {
	      selected.classList.remove('ql-selected');
	    }
	    if (item == null) return;
	    item.classList.add('ql-selected');
	    // @ts-expect-error Fix me later
	    this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
	    if (item.hasAttribute('data-value')) {
	      // @ts-expect-error Fix me later
	      this.label.setAttribute('data-value', item.getAttribute('data-value'));
	    } else {
	      this.label.removeAttribute('data-value');
	    }
	    if (item.hasAttribute('data-label')) {
	      // @ts-expect-error Fix me later
	      this.label.setAttribute('data-label', item.getAttribute('data-label'));
	    } else {
	      this.label.removeAttribute('data-label');
	    }
	    if (trigger) {
	      this.select.dispatchEvent(new Event('change'));
	      this.close();
	    }
	  }
	  update() {
	    let option;
	    if (this.select.selectedIndex > -1) {
	      const item =
	      // @ts-expect-error Fix me later
	      this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	      option = this.select.options[this.select.selectedIndex];
	      // @ts-expect-error
	      this.selectItem(item);
	    } else {
	      this.selectItem(null);
	    }
	    const isActive = option != null && option !== this.select.querySelector('option[selected]');
	    this.label.classList.toggle('ql-active', isActive);
	  }
	}

	class ColorPicker extends Picker {
	  constructor(select, label) {
	    super(select);
	    this.label.innerHTML = label;
	    this.container.classList.add('ql-color-picker');
	    Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach(item => {
	      item.classList.add('ql-primary');
	    });
	  }
	  buildItem(option) {
	    const item = super.buildItem(option);
	    item.style.backgroundColor = option.getAttribute('value') || '';
	    return item;
	  }
	  selectItem(item, trigger) {
	    super.selectItem(item, trigger);
	    const colorLabel = this.label.querySelector('.ql-color-label');
	    const value = item ? item.getAttribute('data-value') || '' : '';
	    if (colorLabel) {
	      if (colorLabel.tagName === 'line') {
	        colorLabel.style.stroke = value;
	      } else {
	        colorLabel.style.fill = value;
	      }
	    }
	  }
	}

	class IconPicker extends Picker {
	  constructor(select, icons) {
	    super(select);
	    this.container.classList.add('ql-icon-picker');
	    Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach(item => {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    this.defaultItem = this.container.querySelector('.ql-selected');
	    this.selectItem(this.defaultItem);
	  }
	  selectItem(target, trigger) {
	    super.selectItem(target, trigger);
	    const item = target || this.defaultItem;
	    if (item != null) {
	      if (this.label.innerHTML === item.innerHTML) return;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }
	}

	const isScrollable = el => {
	  const {
	    overflowY
	  } = getComputedStyle(el, null);
	  return overflowY !== 'visible' && overflowY !== 'clip';
	};
	class Tooltip {
	  constructor(quill, boundsContainer) {
	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    // @ts-expect-error
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    if (isScrollable(this.quill.root)) {
	      this.quill.root.addEventListener('scroll', () => {
	        this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
	      });
	    }
	    this.hide();
	  }
	  hide() {
	    this.root.classList.add('ql-hidden');
	  }
	  position(reference) {
	    const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	    // root.scrollTop should be 0 if scrollContainer !== root
	    const top = reference.bottom + this.quill.root.scrollTop;
	    this.root.style.left = `${left}px`;
	    this.root.style.top = `${top}px`;
	    this.root.classList.remove('ql-flip');
	    const containerBounds = this.boundsContainer.getBoundingClientRect();
	    const rootBounds = this.root.getBoundingClientRect();
	    let shift = 0;
	    if (rootBounds.right > containerBounds.right) {
	      shift = containerBounds.right - rootBounds.right;
	      this.root.style.left = `${left + shift}px`;
	    }
	    if (rootBounds.left < containerBounds.left) {
	      shift = containerBounds.left - rootBounds.left;
	      this.root.style.left = `${left + shift}px`;
	    }
	    if (rootBounds.bottom > containerBounds.bottom) {
	      const height = rootBounds.bottom - rootBounds.top;
	      const verticalShift = reference.bottom - reference.top + height;
	      this.root.style.top = `${top - verticalShift}px`;
	      this.root.classList.add('ql-flip');
	    }
	    return shift;
	  }
	  show() {
	    this.root.classList.remove('ql-editing');
	    this.root.classList.remove('ql-hidden');
	  }
	}

	const ALIGNS = [false, 'center', 'right', 'justify'];
	const COLORS = ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466'];
	const FONTS = [false, 'serif', 'monospace'];
	const HEADERS = ['1', '2', '3', false];
	const SIZES = ['small', false, 'large', 'huge'];
	class BaseTheme extends Theme {
	  constructor(quill, options) {
	    super(quill, options);
	    const listener = e => {
	      if (!document.body.contains(quill.root)) {
	        document.body.removeEventListener('click', listener);
	        return;
	      }
	      if (this.tooltip != null &&
	      // @ts-expect-error
	      !this.tooltip.root.contains(e.target) &&
	      // @ts-expect-error
	      document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) {
	        this.tooltip.hide();
	      }
	      if (this.pickers != null) {
	        this.pickers.forEach(picker => {
	          // @ts-expect-error
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    quill.emitter.listenDOM('click', document.body, listener);
	  }
	  addModule(name) {
	    const module = super.addModule(name);
	    if (name === 'toolbar') {
	      // @ts-expect-error
	      this.extendToolbar(module);
	    }
	    return module;
	  }
	  buildButtons(buttons, icons) {
	    Array.from(buttons).forEach(button => {
	      const className = button.getAttribute('class') || '';
	      className.split(/\s+/).forEach(name => {
	        if (!name.startsWith('ql-')) return;
	        name = name.slice('ql-'.length);
	        if (icons[name] == null) return;
	        if (name === 'direction') {
	          // @ts-expect-error
	          button.innerHTML = icons[name][''] + icons[name].rtl;
	        } else if (typeof icons[name] === 'string') {
	          // @ts-expect-error
	          button.innerHTML = icons[name];
	        } else {
	          // @ts-expect-error
	          const value = button.value || '';
	          // @ts-expect-error
	          if (value != null && icons[name][value]) {
	            // @ts-expect-error
	            button.innerHTML = icons[name][value];
	          }
	        }
	      });
	    });
	  }
	  buildPickers(selects, icons) {
	    this.pickers = Array.from(selects).map(select => {
	      if (select.classList.contains('ql-align')) {
	        if (select.querySelector('option') == null) {
	          fillSelect(select, ALIGNS);
	        }
	        if (typeof icons.align === 'object') {
	          return new IconPicker(select, icons.align);
	        }
	      }
	      if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	        const format = select.classList.contains('ql-background') ? 'background' : 'color';
	        if (select.querySelector('option') == null) {
	          fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	        }
	        return new ColorPicker(select, icons[format]);
	      }
	      if (select.querySelector('option') == null) {
	        if (select.classList.contains('ql-font')) {
	          fillSelect(select, FONTS);
	        } else if (select.classList.contains('ql-header')) {
	          fillSelect(select, HEADERS);
	        } else if (select.classList.contains('ql-size')) {
	          fillSelect(select, SIZES);
	        }
	      }
	      return new Picker(select);
	    });
	    const update = () => {
	      this.pickers.forEach(picker => {
	        picker.update();
	      });
	    };
	    this.quill.on(Emitter.events.EDITOR_CHANGE, update);
	  }
	}
	BaseTheme.DEFAULTS = merge$1({}, Theme.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula() {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image() {
	          let fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', () => {
	              const range = this.quill.getSelection(true);
	              this.quill.uploader.upload(range, fileInput.files);
	              fileInput.value = '';
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video() {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});
	class BaseTooltip extends Tooltip {
	  constructor(quill, boundsContainer) {
	    super(quill, boundsContainer);
	    this.textbox = this.root.querySelector('input[type="text"]');
	    this.listen();
	  }
	  listen() {
	    // @ts-expect-error Fix me later
	    this.textbox.addEventListener('keydown', event => {
	      if (event.key === 'Enter') {
	        this.save();
	        event.preventDefault();
	      } else if (event.key === 'Escape') {
	        this.cancel();
	        event.preventDefault();
	      }
	    });
	  }
	  cancel() {
	    this.hide();
	    this.restoreFocus();
	  }
	  edit() {
	    let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	    let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    this.root.classList.remove('ql-hidden');
	    this.root.classList.add('ql-editing');
	    if (this.textbox == null) return;
	    if (preview != null) {
	      this.textbox.value = preview;
	    } else if (mode !== this.root.getAttribute('data-mode')) {
	      this.textbox.value = '';
	    }
	    const bounds = this.quill.getBounds(this.quill.selection.savedRange);
	    if (bounds != null) {
	      this.position(bounds);
	    }
	    this.textbox.select();
	    this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
	    this.root.setAttribute('data-mode', mode);
	  }
	  restoreFocus() {
	    this.quill.focus({
	      preventScroll: true
	    });
	  }
	  save() {
	    // @ts-expect-error Fix me later
	    let {
	      value
	    } = this.textbox;
	    switch (this.root.getAttribute('data-mode')) {
	      case 'link':
	        {
	          const {
	            scrollTop
	          } = this.quill.root;
	          if (this.linkRange) {
	            this.quill.formatText(this.linkRange, 'link', value, Emitter.sources.USER);
	            delete this.linkRange;
	          } else {
	            this.restoreFocus();
	            this.quill.format('link', value, Emitter.sources.USER);
	          }
	          this.quill.root.scrollTop = scrollTop;
	          break;
	        }
	      case 'video':
	        {
	          value = extractVideoUrl(value);
	        }
	      // eslint-disable-next-line no-fallthrough
	      case 'formula':
	        {
	          if (!value) break;
	          const range = this.quill.getSelection(true);
	          if (range != null) {
	            const index = range.index + range.length;
	            this.quill.insertEmbed(index,
	            // @ts-expect-error Fix me later
	            this.root.getAttribute('data-mode'), value, Emitter.sources.USER);
	            if (this.root.getAttribute('data-mode') === 'formula') {
	              this.quill.insertText(index + 1, ' ', Emitter.sources.USER);
	            }
	            this.quill.setSelection(index + 2, Emitter.sources.USER);
	          }
	          break;
	        }
	    }
	    // @ts-expect-error Fix me later
	    this.textbox.value = '';
	    this.hide();
	  }
	}
	function extractVideoUrl(url) {
	  let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	  if (match) {
	    return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
	  }
	  // eslint-disable-next-line no-cond-assign
	  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
	    return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
	  }
	  return url;
	}
	function fillSelect(select, values) {
	  let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  values.forEach(value => {
	    const option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', String(value));
	    }
	    select.appendChild(option);
	  });
	}

	const TOOLBAR_CONFIG$1 = [['bold', 'italic', 'link'], [{
	  header: 1
	}, {
	  header: 2
	}, 'blockquote']];
	class BubbleTooltip extends BaseTooltip {
	  static TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
	  constructor(quill, bounds) {
	    super(quill, bounds);
	    this.quill.on(Emitter.events.EDITOR_CHANGE, (type, range, oldRange, source) => {
	      if (type !== Emitter.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0 && source === Emitter.sources.USER) {
	        this.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        this.root.style.left = '0px';
	        this.root.style.width = '';
	        this.root.style.width = `${this.root.offsetWidth}px`;
	        const lines = this.quill.getLines(range.index, range.length);
	        if (lines.length === 1) {
	          const bounds = this.quill.getBounds(range);
	          if (bounds != null) {
	            this.position(bounds);
	          }
	        } else {
	          const lastLine = lines[lines.length - 1];
	          const index = this.quill.getIndex(lastLine);
	          const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          const indexBounds = this.quill.getBounds(new Range(index, length));
	          if (indexBounds != null) {
	            this.position(indexBounds);
	          }
	        }
	      } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) {
	        this.hide();
	      }
	    });
	  }
	  listen() {
	    super.listen();
	    // @ts-expect-error Fix me later
	    this.root.querySelector('.ql-close').addEventListener('click', () => {
	      this.root.classList.remove('ql-editing');
	    });
	    this.quill.on(Emitter.events.SCROLL_OPTIMIZE, () => {
	      // Let selection be restored by toolbar handlers before repositioning
	      setTimeout(() => {
	        if (this.root.classList.contains('ql-hidden')) return;
	        const range = this.quill.getSelection();
	        if (range != null) {
	          const bounds = this.quill.getBounds(range);
	          if (bounds != null) {
	            this.position(bounds);
	          }
	        }
	      }, 1);
	    });
	  }
	  cancel() {
	    this.show();
	  }
	  position(reference) {
	    const shift = super.position(reference);
	    const arrow = this.root.querySelector('.ql-tooltip-arrow');
	    // @ts-expect-error
	    arrow.style.marginLeft = '';
	    if (shift !== 0) {
	      // @ts-expect-error
	      arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
	    }
	    return shift;
	  }
	}
	class BubbleTheme extends BaseTheme {
	  constructor(quill, options) {
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG$1;
	    }
	    super(quill, options);
	    this.quill.container.classList.add('ql-bubble');
	  }
	  extendToolbar(toolbar) {
	    // @ts-expect-error
	    this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	    if (toolbar.container != null) {
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons(toolbar.container.querySelectorAll('button'), Icons);
	      this.buildPickers(toolbar.container.querySelectorAll('select'), Icons);
	    }
	  }
	}
	BubbleTheme.DEFAULTS = merge$1({}, BaseTheme.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link(value) {
	          if (!value) {
	            this.quill.format('link', false, Quill.sources.USER);
	          } else {
	            // @ts-expect-error
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});

	const TOOLBAR_CONFIG = [[{
	  header: ['1', '2', '3', false]
	}], ['bold', 'italic', 'underline', 'link'], [{
	  list: 'ordered'
	}, {
	  list: 'bullet'
	}], ['clean']];
	class SnowTooltip extends BaseTooltip {
	  static TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');
	  preview = this.root.querySelector('a.ql-preview');
	  listen() {
	    super.listen();
	    // @ts-expect-error Fix me later
	    this.root.querySelector('a.ql-action').addEventListener('click', event => {
	      if (this.root.classList.contains('ql-editing')) {
	        this.save();
	      } else {
	        // @ts-expect-error Fix me later
	        this.edit('link', this.preview.textContent);
	      }
	      event.preventDefault();
	    });
	    // @ts-expect-error Fix me later
	    this.root.querySelector('a.ql-remove').addEventListener('click', event => {
	      if (this.linkRange != null) {
	        const range = this.linkRange;
	        this.restoreFocus();
	        this.quill.formatText(range, 'link', false, Emitter.sources.USER);
	        delete this.linkRange;
	      }
	      event.preventDefault();
	      this.hide();
	    });
	    this.quill.on(Emitter.events.SELECTION_CHANGE, (range, oldRange, source) => {
	      if (range == null) return;
	      if (range.length === 0 && source === Emitter.sources.USER) {
	        const [link, offset] = this.quill.scroll.descendant(Link, range.index);
	        if (link != null) {
	          this.linkRange = new Range(range.index - offset, link.length());
	          const preview = Link.formats(link.domNode);
	          // @ts-expect-error Fix me later
	          this.preview.textContent = preview;
	          // @ts-expect-error Fix me later
	          this.preview.setAttribute('href', preview);
	          this.show();
	          const bounds = this.quill.getBounds(this.linkRange);
	          if (bounds != null) {
	            this.position(bounds);
	          }
	          return;
	        }
	      } else {
	        delete this.linkRange;
	      }
	      this.hide();
	    });
	  }
	  show() {
	    super.show();
	    this.root.removeAttribute('data-mode');
	  }
	}
	class SnowTheme extends BaseTheme {
	  constructor(quill, options) {
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	    super(quill, options);
	    this.quill.container.classList.add('ql-snow');
	  }
	  extendToolbar(toolbar) {
	    if (toolbar.container != null) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons(toolbar.container.querySelectorAll('button'), Icons);
	      this.buildPickers(toolbar.container.querySelectorAll('select'), Icons);
	      // @ts-expect-error
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({
	          key: 'k',
	          shortKey: true
	        }, (_range, context) => {
	          toolbar.handlers.link.call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }
	}
	SnowTheme.DEFAULTS = merge$1({}, BaseTheme.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link(value) {
	          if (value) {
	            const range = this.quill.getSelection();
	            if (range == null || range.length === 0) return;
	            let preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = `mailto:${preview}`;
	            }
	            // @ts-expect-error
	            const {
	              tooltip
	            } = this.quill.theme;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false, Quill.sources.USER);
	          }
	        }
	      }
	    }
	  }
	});

	Quill.register({
	  'attributors/attribute/direction': DirectionAttribute,
	  'attributors/class/align': AlignClass,
	  'attributors/class/background': BackgroundClass,
	  'attributors/class/color': ColorClass,
	  'attributors/class/direction': DirectionClass,
	  'attributors/class/font': FontClass,
	  'attributors/class/size': SizeClass,
	  'attributors/style/align': AlignStyle,
	  'attributors/style/background': BackgroundStyle,
	  'attributors/style/color': ColorStyle,
	  'attributors/style/direction': DirectionStyle,
	  'attributors/style/font': FontStyle,
	  'attributors/style/size': SizeStyle
	}, true);
	Quill.register({
	  'formats/align': AlignClass,
	  'formats/direction': DirectionClass,
	  'formats/indent': IndentClass,
	  'formats/background': BackgroundStyle,
	  'formats/color': ColorStyle,
	  'formats/font': FontClass,
	  'formats/size': SizeClass,
	  'formats/blockquote': Blockquote,
	  'formats/code-block': CodeBlock,
	  'formats/header': Header,
	  'formats/list': ListItem,
	  'formats/bold': Bold,
	  'formats/code': Code,
	  'formats/italic': Italic,
	  'formats/link': Link,
	  'formats/script': Script,
	  'formats/strike': Strike,
	  'formats/underline': Underline,
	  'formats/formula': Formula,
	  'formats/image': Image,
	  'formats/video': Video,
	  'modules/syntax': Syntax,
	  'modules/table': Table,
	  'modules/toolbar': Toolbar,
	  'themes/bubble': BubbleTheme,
	  'themes/snow': SnowTheme,
	  'ui/icons': Icons,
	  'ui/picker': Picker,
	  'ui/icon-picker': IconPicker,
	  'ui/color-picker': ColorPicker,
	  'ui/tooltip': Tooltip
	}, true);

	/* src\lib\web-components\quill-container\eas-quill-container.component.svelte generated by Svelte v4.2.19 */

	function create_fragment$2(ctx) {
		let link;
		let t;
		let div;
		let div_class_value;
		let initializeEditor_action;
		let mounted;
		let dispose;

		return {
			c() {
				link = element("link");
				t = space();
				div = element("div");
				attr(link, "rel", "stylesheet");
				attr(link, "href", "https://cdn.jsdelivr.net/npm/quill@2.0.2/dist/quill.snow.css");
				attr(div, "class", div_class_value = /*$$props*/ ctx[3].class || '');
				attr(div, "style", /*editorStyle*/ ctx[1]);
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t, anchor);
				insert(target, div, anchor);

				if (!mounted) {
					dispose = action_destroyer(initializeEditor_action = /*initializeEditor*/ ctx[2].call(null, div, /*html*/ ctx[0]));
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*$$props*/ 8 && div_class_value !== (div_class_value = /*$$props*/ ctx[3].class || '')) {
					attr(div, "class", div_class_value);
				}

				if (dirty & /*editorStyle*/ 2) {
					attr(div, "style", /*editorStyle*/ ctx[1]);
				}

				if (initializeEditor_action && is_function(initializeEditor_action.update) && dirty & /*html*/ 1) initializeEditor_action.update.call(null, /*html*/ ctx[0]);
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t);
					detach(div);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function instance$2($$self, $$props, $$invalidate) {
		let { html = '' } = $$props;
		let { mode = 'full' } = $$props;
		let { placeholder = 'Insert text here...' } = $$props;
		let { theme = 'snow' } = $$props;
		let { linkPlaceholder = 'https://www.example.com' } = $$props;
		let { editorStyle = '' } = $$props;
		let { maxLength = 8000 } = $$props;
		let editor;
		const dispatch = createEventDispatcher();

		const handleChange = () => {
			if (!editor) return;

			if (editor.getLength() > maxLength) {
				editor.deleteText(maxLength, editor.getLength());
			}

			$$invalidate(0, html = editor.root.innerHTML);
			dispatch('htmlChange', html);
		};

		const insertHtml = html => {
			if (editor && editor.clipboard) {
				const delta = editor.clipboard.convert({ html, text: '' });
				editor.setContents(delta, 'silent');
			}
		};

		const toolbarOptionsMinimal = [
			['bold', 'italic', 'underline', 'strike'],
			[{ color: [] }, { background: [] }],
			['link']
		];

		const toolbarOptionsFull = [
			['bold', 'italic', 'underline', 'strike'],
			['blockquote', 'code-block'],
			[{ header: '1' }, { header: '2' }],
			[{ list: 'ordered' }, { list: 'bullet' }],
			[{ script: 'super' }, { script: 'sub' }],
			[{ indent: '-1' }, { indent: '+1' }],
			['direction'],
			[{ size: [] }, { header: [] }],
			[{ color: [] }, { background: [] }],
			[{ font: [] }],
			['align'],
			['clean'],
			['link', 'image', 'video']
		];

		const mountInShadowDom = (quill, container) => {
			editor = new quill(container,
			{
					modules: {
						toolbar: mode === 'minimal'
						? toolbarOptionsMinimal
						: toolbarOptionsFull
					},
					placeholder,
					theme
				});

			const linkElement = container.querySelector('input[data-link]');
			linkElement.setAttribute('data-link', linkPlaceholder);
			insertHtml(html);
			editor.on('text-change', handleChange);

			const getNativeSelection = rootNode => {
				try {
					if ('getSelection' in rootNode && typeof rootNode.getSelection === 'function') {
						return rootNode.getSelection();
					} else {
						return window.getSelection();
					}
				} catch {
					return null;
				}
			};

			// Each browser engine has a different implementation for retrieving the Range
			const getNativeRange = rootNode => {
				const selection = getNativeSelection(rootNode);
				if (!selection?.anchorNode) return null;

				if (selection && 'getComposedRanges' in selection && typeof selection.getComposedRanges === 'function') {
					// Webkit range retrieval is done with getComposedRanges (see: https://bugs.webkit.org/show_bug.cgi?id=163921)
					return selection.getComposedRanges(rootNode)[0];
				}

				// Chromium based brwosers implement the range API properly in Native Shadow
				// Gecko implements the range API properly in Native Shadow: https://developer.mozilla.org/en-US/docs/Web/API/Selection/getRangeAt
				return selection.getRangeAt(0);
			};

			/**
	 * Original implementation uses document.active element which does not work in Native Shadow.
	 * Replace document.activeElement with shadowRoot.activeElement
	 **/
			editor.selection.hasFocus = () => {
				const rootNode = editor.root.getRootNode();
				return rootNode.activeElement === editor.root;
			};

			/**
	 * Original implementation uses document.getSelection which does not work in Native Shadow.
	 * Replace document.getSelection with shadow dom equivalent (different for each browser)
	 **/
			editor.selection.getNativeRange = () => {
				const rootNode = editor.root.getRootNode();
				const nativeRange = getNativeRange(rootNode);

				return !!nativeRange
				? editor.selection.normalizeNative(nativeRange)
				: null;
			};

			/**
	 * Original implementation relies on Selection.addRange to programatically set the range, which does not work
	 * in Webkit with Native Shadow. Selection.addRange works fine in Chromium and Gecko.
	 **/
			editor.selection.setNativeRange = function (startNode, startOffset) {
				let endNode = arguments.length > 2 && arguments[2] !== undefined
				? arguments[2]
				: startNode;

				let endOffset = arguments.length > 3 && arguments[3] !== undefined
				? arguments[3]
				: startOffset;

				const force = arguments.length > 4 && arguments[4] !== undefined
				? arguments[4]
				: false;

				if (startNode != null && (editor.selection.root.parentNode == null || startNode.parentNode == null || endNode && endNode.parentNode == null)) {
					return;
				}

				const selection = document.getSelection();
				if (selection == null) return;

				if (startNode != null && endNode != null) {
					if (!editor.selection.hasFocus()) editor.selection.root.focus();
					const native = (editor.selection.getNativeRange() || {}).native;

					if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
						if ('tagName' in startNode && startNode.tagName == 'BR') {
							startOffset = [].indexOf.call(startNode?.parentNode?.childNodes, startNode);
							startNode = startNode.parentNode;
						}

						if ('tagName' in endNode && endNode.tagName == 'BR') {
							endOffset = [].indexOf.call(endNode?.parentNode?.childNodes, endNode);
							endNode = endNode.parentNode;
						}

						startNode && endNode && typeof startOffset === 'number' && typeof endOffset === 'number' && selection.setBaseAndExtent(startNode, startOffset, endNode, endOffset);
					}
				} else {
					selection.removeAllRanges();
					editor.selection.root.blur();
					container.focus();
				}
			};
		};

		const mountInDocumentDom = async (quill, container) => {
			editor = new quill(container,
			{
					modules: {
						toolbar: mode === 'minimal'
						? toolbarOptionsMinimal
						: toolbarOptionsFull
					},
					placeholder,
					theme
				});

			const linkElement = document.querySelector('input[data-link]');
			linkElement.setAttribute('data-link', linkPlaceholder);
			insertHtml(html);
			editor.on('text-change', handleChange);
		};

		const initializeEditor = editorElement => {
			const rootNode = editorElement.getRootNode();
			const isDocument = rootNode === document;

			isDocument
			? mountInDocumentDom(Quill, editorElement)
			: mountInShadowDom(Quill, editorElement);

			/**
	 * Subscribe to selection change separately, because emitter in Quill doesn't catch this event in Shadow DOM
	 **/
			const handleSelectionChange = () => {
				const { activeElement } = rootNode;
				const { tooltip } = editor.theme;
				if (!tooltip) return;

				if (tooltip.root !== activeElement && tooltip.textbox !== activeElement && !tooltip.root.contains(activeElement) && !editor.hasFocus()) {
					tooltip.hide();
					document.removeEventListener('selectionchange', handleSelectionChange);
					return;
				}

				!isDocument && editor.selection.update();
			};

			/**
	 * The 'selectionchange' event is not emitted in Shadow DOM, therefore listen for the
	 * 'selectstart' event first and then subscribe to the 'selectionchange' event on the document
	 */
			editorElement.addEventListener('selectstart', () => document.addEventListener('selectionchange', handleSelectionChange));

			return {
				update: html => !editor.hasFocus() && insertHtml(html),
				destroy: () => {
					if (editor) {
						editor.off('text-change', handleChange);
					}
				}
			};
		};

		$$self.$$set = $$new_props => {
			$$invalidate(3, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
			if ('html' in $$new_props) $$invalidate(0, html = $$new_props.html);
			if ('mode' in $$new_props) $$invalidate(4, mode = $$new_props.mode);
			if ('placeholder' in $$new_props) $$invalidate(5, placeholder = $$new_props.placeholder);
			if ('theme' in $$new_props) $$invalidate(6, theme = $$new_props.theme);
			if ('linkPlaceholder' in $$new_props) $$invalidate(7, linkPlaceholder = $$new_props.linkPlaceholder);
			if ('editorStyle' in $$new_props) $$invalidate(1, editorStyle = $$new_props.editorStyle);
			if ('maxLength' in $$new_props) $$invalidate(8, maxLength = $$new_props.maxLength);
		};

		$$props = exclude_internal_props($$props);

		return [
			html,
			editorStyle,
			initializeEditor,
			$$props,
			mode,
			placeholder,
			theme,
			linkPlaceholder,
			maxLength
		];
	}

	class Eas_quill_container_component extends SvelteComponent {
		constructor(options) {
			super();

			init(this, options, instance$2, create_fragment$2, safe_not_equal, {
				html: 0,
				mode: 4,
				placeholder: 5,
				theme: 6,
				linkPlaceholder: 7,
				editorStyle: 1,
				maxLength: 8
			});
		}

		get html() {
			return this.$$.ctx[0];
		}

		set html(html) {
			this.$$set({ html });
			flush();
		}

		get mode() {
			return this.$$.ctx[4];
		}

		set mode(mode) {
			this.$$set({ mode });
			flush();
		}

		get placeholder() {
			return this.$$.ctx[5];
		}

		set placeholder(placeholder) {
			this.$$set({ placeholder });
			flush();
		}

		get theme() {
			return this.$$.ctx[6];
		}

		set theme(theme) {
			this.$$set({ theme });
			flush();
		}

		get linkPlaceholder() {
			return this.$$.ctx[7];
		}

		set linkPlaceholder(linkPlaceholder) {
			this.$$set({ linkPlaceholder });
			flush();
		}

		get editorStyle() {
			return this.$$.ctx[1];
		}

		set editorStyle(editorStyle) {
			this.$$set({ editorStyle });
			flush();
		}

		get maxLength() {
			return this.$$.ctx[8];
		}

		set maxLength(maxLength) {
			this.$$set({ maxLength });
			flush();
		}
	}

	customElements.define("eas-quill-container-swc", create_custom_element(Eas_quill_container_component, {"html":{},"mode":{},"placeholder":{},"theme":{},"linkPlaceholder":{},"editorStyle":{},"maxLength":{}}, [], [], true));

	/* src\lib\web-components\tiles\eas-tiles.component.svelte generated by Svelte v4.2.19 */

	function add_css$1(target) {
		append_styles(target, "svelte-133v8n3", ".body.svelte-133v8n3.svelte-133v8n3{background-color:#f2f2f2;height:auto;height:100%}.container.svelte-133v8n3.svelte-133v8n3{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;font-family:\"Source Sans Pro\", sans-serif;-webkit-font-smoothing:antialiased;height:100%;padding-top:30px;padding-bottom:20px}.tile-container.svelte-133v8n3.svelte-133v8n3{margin-top:30px}.tile-container.svelte-133v8n3 span.svelte-133v8n3{width:48%;margin:5px;display:inline-block}@media(min-width: 1200px){.container.svelte-133v8n3.svelte-133v8n3{max-width:1140px}}@media(max-width: 1024px){.tile-container.svelte-133v8n3 span.svelte-133v8n3{width:100%}}");
	}

	function get_each_context(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[8] = list[i];
		child_ctx[10] = i;
		return child_ctx;
	}

	// (46:16) {#each tileData as item, index}
	function create_each_block(ctx) {
		let span;
		let eas_tile_swc;
		let eas_tile_swc_menukey_value;
		let eas_tile_swc_title_value;
		let eas_tile_swc_description_value;
		let eas_tile_swc_iconstyle_value;
		let mounted;
		let dispose;

		function click_handler(...args) {
			return /*click_handler*/ ctx[4](/*item*/ ctx[8], ...args);
		}

		return {
			c() {
				span = element("span");
				eas_tile_swc = element("eas-tile-swc");
				set_custom_element_data(eas_tile_swc, "menukey", eas_tile_swc_menukey_value = /*item*/ ctx[8].id);
				set_custom_element_data(eas_tile_swc, "title", eas_tile_swc_title_value = /*item*/ ctx[8].label);
				set_custom_element_data(eas_tile_swc, "description", eas_tile_swc_description_value = /*item*/ ctx[8].desc);
				set_custom_element_data(eas_tile_swc, "iconstyle", eas_tile_swc_iconstyle_value = /*item*/ ctx[8].iconStyle);
				set_custom_element_data(eas_tile_swc, "buttontitle", "open");
				attr(span, "class", "svelte-133v8n3");
			},
			m(target, anchor) {
				insert(target, span, anchor);
				append(span, eas_tile_swc);

				if (!mounted) {
					dispose = listen(eas_tile_swc, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;

				if (dirty & /*tileData*/ 1 && eas_tile_swc_menukey_value !== (eas_tile_swc_menukey_value = /*item*/ ctx[8].id)) {
					set_custom_element_data(eas_tile_swc, "menukey", eas_tile_swc_menukey_value);
				}

				if (dirty & /*tileData*/ 1 && eas_tile_swc_title_value !== (eas_tile_swc_title_value = /*item*/ ctx[8].label)) {
					set_custom_element_data(eas_tile_swc, "title", eas_tile_swc_title_value);
				}

				if (dirty & /*tileData*/ 1 && eas_tile_swc_description_value !== (eas_tile_swc_description_value = /*item*/ ctx[8].desc)) {
					set_custom_element_data(eas_tile_swc, "description", eas_tile_swc_description_value);
				}

				if (dirty & /*tileData*/ 1 && eas_tile_swc_iconstyle_value !== (eas_tile_swc_iconstyle_value = /*item*/ ctx[8].iconStyle)) {
					set_custom_element_data(eas_tile_swc, "iconstyle", eas_tile_swc_iconstyle_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(span);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$1(ctx) {
		let link;
		let t;
		let div3;
		let div2;
		let div1;
		let div0;
		let each_value = ensure_array_like(/*tileData*/ ctx[0]);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
		}

		return {
			c() {
				link = element("link");
				t = space();
				div3 = element("div");
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(div0, "class", "tile-container svelte-133v8n3");
				attr(div2, "class", "container svelte-133v8n3");
				attr(div3, "class", "body svelte-133v8n3");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t, anchor);
				insert(target, div3, anchor);
				append(div3, div2);
				append(div2, div1);
				append(div1, div0);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div0, null);
					}
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*tileData, onTileClicked*/ 3) {
					each_value = ensure_array_like(/*tileData*/ ctx[0]);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div0, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t);
					detach(div3);
				}

				destroy_each(each_blocks, detaching);
			}
		};
	}

	function instance$1($$self, $$props, $$invalidate) {
		let tileData;
		const svelteDispatch = createEventDispatcher();
		let { selectedsidemenuitemkey = '' } = $$props;
		let { tilesdata } = $$props;

		const onTileClicked = (e, item) => {
			let eventData = { ...e, detail: item };
			svelteDispatch("click", eventData);
			$$invalidate(0, tileData = item.submenu);
		};

		function findItems(menuKey, items) {
			if (menuKey === 0 || !items) {
				return items;
			}

			let foundItems = [];
			foundItems = items.filter(x => x.menuKey === menuKey);

			if (foundItems.length === 0) {
				items.forEach(x => {
					if (x.submenu && x.submenu.length > 0) {
						findItems(menuKey, x.submenu);
					}
				});
			} else {
				$$invalidate(0, tileData = foundItems[0].expanded
				? foundItems[0].submenu
				: foundItems);

				return tileData;
			}
		}

		const click_handler = (item, e) => onTileClicked(e, item);

		$$self.$$set = $$props => {
			if ('selectedsidemenuitemkey' in $$props) $$invalidate(2, selectedsidemenuitemkey = $$props.selectedsidemenuitemkey);
			if ('tilesdata' in $$props) $$invalidate(3, tilesdata = $$props.tilesdata);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*tilesdata, selectedsidemenuitemkey*/ 12) {
				$$invalidate(0, tileData = tilesdata && tilesdata.submenu.length == 1
				? findItems(selectedsidemenuitemkey, tilesdata.submenu)
				: tilesdata.submenu);
			}
		};
		return [tileData, onTileClicked, selectedsidemenuitemkey, tilesdata, click_handler];
	}

	class Eas_tiles_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$1, create_fragment$1, safe_not_equal, { selectedsidemenuitemkey: 2, tilesdata: 3 }, add_css$1);
		}

		get selectedsidemenuitemkey() {
			return this.$$.ctx[2];
		}

		set selectedsidemenuitemkey(selectedsidemenuitemkey) {
			this.$$set({ selectedsidemenuitemkey });
			flush();
		}

		get tilesdata() {
			return this.$$.ctx[3];
		}

		set tilesdata(tilesdata) {
			this.$$set({ tilesdata });
			flush();
		}
	}

	customElements.define("eas-tiles-swc", create_custom_element(Eas_tiles_component, {"selectedsidemenuitemkey":{},"tilesdata":{}}, [], [], true));

	/* src\lib\web-components\tile\eas-tile.component.svelte generated by Svelte v4.2.19 */

	function add_css(target) {
		append_styles(target, "svelte-onodvh", ".a--tile.svelte-onodvh{display:block;position:relative;align-items:center;height:auto;overflow:hidden;color:black;text-decoration:none;font-family:\"Source Sans Pro\", sans-serif;-webkit-font-smoothing:antialiased;outline:2px solid transparent;transition:all 0.2s ease-in-out;border:1px solid #d8d8d8}.a--tile.svelte-onodvh:focus{outline:2px solid #000;border:1px solid #000}.tile-content.svelte-onodvh{display:flex}.white.svelte-onodvh{background:#fff}.hover--shadow.svelte-onodvh:hover{box-shadow:0px 0 32px -10px rgb(0 0 0 / 18%)}.tile--img.svelte-onodvh{height:100%;width:100%;max-width:100px;min-height:120px;position:relative;top:0;background-color:#5079a4}.img--position.svelte-onodvh{margin:auto;transform:translateY(50%);text-align:center;width:45px}.tile--content.svelte-onodvh{padding:0 20px;position:relative;transform:translateY(45%);width:100%;height:100%}.tile--title.svelte-onodvh{font-size:18px;line-height:25px}.p--tile.svelte-onodvh{margin:5px 0 0 0;font-size:14px}@media(max-width: 1440px){.tile--content.svelte-onodvh{transform:translateY(5%)}}@media(max-width: 1024px){.tile--content.svelte-onodvh{transform:translateY(20%)}}@media(max-width: 425px){.p--tile.svelte-onodvh{height:50px;overflow:hidden}.tile--title.svelte-onodvh{font-size:17px;line-height:20px}.tile--content.svelte-onodvh{transform:translateY(7%)}}");
	}

	function create_fragment(ctx) {
		let link;
		let t0;
		let a;
		let div4;
		let div1;
		let div0;
		let img;
		let img_src_value;
		let t1;
		let div3;
		let header;
		let div2;
		let t2;
		let t3;
		let p;
		let t4;
		let mounted;
		let dispose;

		return {
			c() {
				link = element("link");
				t0 = space();
				a = element("a");
				div4 = element("div");
				div1 = element("div");
				div0 = element("div");
				img = element("img");
				t1 = space();
				div3 = element("div");
				header = element("header");
				div2 = element("div");
				t2 = text(/*title*/ ctx[1]);
				t3 = space();
				p = element("p");
				t4 = text(/*description*/ ctx[2]);
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				if (!src_url_equal(img.src, img_src_value = "assets/dist/assets/svg/" + /*iconstyle*/ ctx[0] + ".svg")) attr(img, "src", img_src_value);
				attr(div0, "class", "img--position svelte-onodvh");
				attr(div1, "class", "tile--img svelte-onodvh");
				attr(div2, "class", "tile--title svelte-onodvh");
				attr(header, "class", "header--tile");
				attr(p, "class", "p--tile svelte-onodvh");
				attr(div3, "class", "tile--content svelte-onodvh");
				attr(div4, "class", "tile-content svelte-onodvh");
				attr(a, "href", "javascript:void(0)");
				attr(a, "class", "a--tile white hover--shadow svelte-onodvh");
				set_style(a, "border-radius", "calc(8px)");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, a, anchor);
				append(a, div4);
				append(div4, div1);
				append(div1, div0);
				append(div0, img);
				append(div4, t1);
				append(div4, div3);
				append(div3, header);
				append(header, div2);
				append(div2, t2);
				append(div3, t3);
				append(div3, p);
				append(p, t4);

				if (!mounted) {
					dispose = listen(a, "click", /*click_handler*/ ctx[5]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*iconstyle*/ 1 && !src_url_equal(img.src, img_src_value = "assets/dist/assets/svg/" + /*iconstyle*/ ctx[0] + ".svg")) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*title*/ 2) set_data(t2, /*title*/ ctx[1]);
				if (dirty & /*description*/ 4) set_data(t4, /*description*/ ctx[2]);
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(a);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function instance($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { iconstyle = "" } = $$props;
		let { title = "Tile 1" } = $$props;
		let { description = "" } = $$props;
		let { data = {} } = $$props;

		function onClick(e) {
			e.stopPropagation();
			svelteDispatch("click", data);
		}

		const click_handler = e => {
			onClick(e);
		};

		$$self.$$set = $$props => {
			if ('iconstyle' in $$props) $$invalidate(0, iconstyle = $$props.iconstyle);
			if ('title' in $$props) $$invalidate(1, title = $$props.title);
			if ('description' in $$props) $$invalidate(2, description = $$props.description);
			if ('data' in $$props) $$invalidate(4, data = $$props.data);
		};

		return [iconstyle, title, description, onClick, data, click_handler];
	}

	class Eas_tile_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance,
				create_fragment,
				safe_not_equal,
				{
					iconstyle: 0,
					title: 1,
					description: 2,
					data: 4
				},
				add_css
			);
		}

		get iconstyle() {
			return this.$$.ctx[0];
		}

		set iconstyle(iconstyle) {
			this.$$set({ iconstyle });
			flush();
		}

		get title() {
			return this.$$.ctx[1];
		}

		set title(title) {
			this.$$set({ title });
			flush();
		}

		get description() {
			return this.$$.ctx[2];
		}

		set description(description) {
			this.$$set({ description });
			flush();
		}

		get data() {
			return this.$$.ctx[4];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}
	}

	customElements.define("eas-tile-swc", create_custom_element(Eas_tile_component, {"iconstyle":{},"title":{},"description":{},"data":{}}, [], [], true));

})();

(function () {
	'use strict';

	/** @returns {void} */
	function noop() {}

	function run(fn) {
		return fn();
	}

	function blank_object() {
		return Object.create(null);
	}

	/**
	 * @param {Function[]} fns
	 * @returns {void}
	 */
	function run_all(fns) {
		fns.forEach(run);
	}

	/**
	 * @param {any} thing
	 * @returns {thing is Function}
	 */
	function is_function(thing) {
		return typeof thing === 'function';
	}

	/** @returns {boolean} */
	function safe_not_equal(a, b) {
		return a != a ? b == b : a !== b || (a && typeof a === 'object') || typeof a === 'function';
	}

	let src_url_equal_anchor;

	/**
	 * @param {string} element_src
	 * @param {string} url
	 * @returns {boolean}
	 */
	function src_url_equal(element_src, url) {
		if (element_src === url) return true;
		if (!src_url_equal_anchor) {
			src_url_equal_anchor = document.createElement('a');
		}
		// This is actually faster than doing URL(..).href
		src_url_equal_anchor.href = url;
		return element_src === src_url_equal_anchor.href;
	}

	/** @returns {boolean} */
	function is_empty(obj) {
		return Object.keys(obj).length === 0;
	}

	function null_to_empty(value) {
		return value == null ? '' : value;
	}

	/** @type {typeof globalThis} */
	const globals =
		typeof window !== 'undefined'
			? window
			: typeof globalThis !== 'undefined'
			? globalThis
			: // @ts-ignore Node typings have this
			  global;

	/**
	 * @param {Node} target
	 * @param {Node} node
	 * @returns {void}
	 */
	function append(target, node) {
		target.appendChild(node);
	}

	/**
	 * @param {Node} target
	 * @param {string} style_sheet_id
	 * @param {string} styles
	 * @returns {void}
	 */
	function append_styles(target, style_sheet_id, styles) {
		const append_styles_to = get_root_for_style(target);
		if (!append_styles_to.getElementById(style_sheet_id)) {
			const style = element('style');
			style.id = style_sheet_id;
			style.textContent = styles;
			append_stylesheet(append_styles_to, style);
		}
	}

	/**
	 * @param {Node} node
	 * @returns {ShadowRoot | Document}
	 */
	function get_root_for_style(node) {
		if (!node) return document;
		const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
		if (root && /** @type {ShadowRoot} */ (root).host) {
			return /** @type {ShadowRoot} */ (root);
		}
		return node.ownerDocument;
	}

	/**
	 * @param {ShadowRoot | Document} node
	 * @param {HTMLStyleElement} style
	 * @returns {CSSStyleSheet}
	 */
	function append_stylesheet(node, style) {
		append(/** @type {Document} */ (node).head || node, style);
		return style.sheet;
	}

	/**
	 * @param {Node} target
	 * @param {Node} node
	 * @param {Node} [anchor]
	 * @returns {void}
	 */
	function insert(target, node, anchor) {
		target.insertBefore(node, anchor || null);
	}

	/**
	 * @param {Node} node
	 * @returns {void}
	 */
	function detach(node) {
		if (node.parentNode) {
			node.parentNode.removeChild(node);
		}
	}

	/**
	 * @returns {void} */
	function destroy_each(iterations, detaching) {
		for (let i = 0; i < iterations.length; i += 1) {
			if (iterations[i]) iterations[i].d(detaching);
		}
	}

	/**
	 * @template {keyof HTMLElementTagNameMap} K
	 * @param {K} name
	 * @returns {HTMLElementTagNameMap[K]}
	 */
	function element(name) {
		return document.createElement(name);
	}

	/**
	 * @param {string} data
	 * @returns {Text}
	 */
	function text(data) {
		return document.createTextNode(data);
	}

	/**
	 * @returns {Text} */
	function space() {
		return text(' ');
	}

	/**
	 * @returns {Text} */
	function empty() {
		return text('');
	}

	/**
	 * @param {EventTarget} node
	 * @param {string} event
	 * @param {EventListenerOrEventListenerObject} handler
	 * @param {boolean | AddEventListenerOptions | EventListenerOptions} [options]
	 * @returns {() => void}
	 */
	function listen(node, event, handler, options) {
		node.addEventListener(event, handler, options);
		return () => node.removeEventListener(event, handler, options);
	}

	/**
	 * @param {Element} node
	 * @param {string} attribute
	 * @param {string} [value]
	 * @returns {void}
	 */
	function attr(node, attribute, value) {
		if (value == null) node.removeAttribute(attribute);
		else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
	}

	/**
	 * @returns {void} */
	function set_custom_element_data(node, prop, value) {
		const lower = prop.toLowerCase(); // for backwards compatibility with existing behavior we do lowercase first
		if (lower in node) {
			node[lower] = typeof node[lower] === 'boolean' && value === '' ? true : value;
		} else if (prop in node) {
			node[prop] = typeof node[prop] === 'boolean' && value === '' ? true : value;
		} else {
			attr(node, prop, value);
		}
	}

	/**
	 * @param {Element} element
	 * @returns {ChildNode[]}
	 */
	function children(element) {
		return Array.from(element.childNodes);
	}

	/**
	 * @param {Text} text
	 * @param {unknown} data
	 * @returns {void}
	 */
	function set_data(text, data) {
		data = '' + data;
		if (text.data === data) return;
		text.data = /** @type {string} */ (data);
	}

	/**
	 * @returns {void} */
	function set_input_value(input, value) {
		input.value = value == null ? '' : value;
	}

	/**
	 * @returns {void} */
	function set_style(node, key, value, important) {
		if (value == null) {
			node.style.removeProperty(key);
		} else {
			node.style.setProperty(key, value, important ? 'important' : '');
		}
	}

	/**
	 * @returns {void} */
	function select_option(select, value, mounting) {
		for (let i = 0; i < select.options.length; i += 1) {
			const option = select.options[i];
			if (option.__value === value) {
				option.selected = true;
				return;
			}
		}
		if (!mounting || value !== undefined) {
			select.selectedIndex = -1; // no option should be selected
		}
	}

	function select_value(select) {
		const selected_option = select.querySelector(':checked');
		return selected_option && selected_option.__value;
	}

	/**
	 * @template T
	 * @param {string} type
	 * @param {T} [detail]
	 * @param {{ bubbles?: boolean, cancelable?: boolean }} [options]
	 * @returns {CustomEvent<T>}
	 */
	function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
		return new CustomEvent(type, { detail, bubbles, cancelable });
	}

	/**
	 * @param {HTMLElement} element
	 * @returns {{}}
	 */
	function get_custom_elements_slots(element) {
		const result = {};
		element.childNodes.forEach(
			/** @param {Element} node */ (node) => {
				result[node.slot || 'default'] = true;
			}
		);
		return result;
	}

	/**
	 * @typedef {Node & {
	 * 	claim_order?: number;
	 * 	hydrate_init?: true;
	 * 	actual_end_child?: NodeEx;
	 * 	childNodes: NodeListOf<NodeEx>;
	 * }} NodeEx
	 */

	/** @typedef {ChildNode & NodeEx} ChildNodeEx */

	/** @typedef {NodeEx & { claim_order: number }} NodeEx2 */

	/**
	 * @typedef {ChildNodeEx[] & {
	 * 	claim_info?: {
	 * 		last_index: number;
	 * 		total_claimed: number;
	 * 	};
	 * }} ChildNodeArray
	 */

	let current_component;

	/** @returns {void} */
	function set_current_component(component) {
		current_component = component;
	}

	function get_current_component() {
		if (!current_component) throw new Error('Function called outside component initialization');
		return current_component;
	}

	/**
	 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
	 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
	 * it can be called from an external module).
	 *
	 * If a function is returned _synchronously_ from `onMount`, it will be called when the component is unmounted.
	 *
	 * `onMount` does not run inside a [server-side component](https://svelte.dev/docs#run-time-server-side-component-api).
	 *
	 * https://svelte.dev/docs/svelte#onmount
	 * @template T
	 * @param {() => import('./private.js').NotFunction<T> | Promise<import('./private.js').NotFunction<T>> | (() => any)} fn
	 * @returns {void}
	 */
	function onMount(fn) {
		get_current_component().$$.on_mount.push(fn);
	}

	/**
	 * Schedules a callback to run immediately after the component has been updated.
	 *
	 * The first time the callback runs will be after the initial `onMount`
	 *
	 * https://svelte.dev/docs/svelte#afterupdate
	 * @param {() => any} fn
	 * @returns {void}
	 */
	function afterUpdate(fn) {
		get_current_component().$$.after_update.push(fn);
	}

	/**
	 * Creates an event dispatcher that can be used to dispatch [component events](https://svelte.dev/docs#template-syntax-component-directives-on-eventname).
	 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
	 *
	 * Component events created with `createEventDispatcher` create a
	 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
	 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
	 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
	 * property and can contain any type of data.
	 *
	 * The event dispatcher can be typed to narrow the allowed event names and the type of the `detail` argument:
	 * ```ts
	 * const dispatch = createEventDispatcher<{
	 *  loaded: never; // does not take a detail argument
	 *  change: string; // takes a detail argument of type string, which is required
	 *  optional: number | null; // takes an optional detail argument of type number
	 * }>();
	 * ```
	 *
	 * https://svelte.dev/docs/svelte#createeventdispatcher
	 * @template {Record<string, any>} [EventMap=any]
	 * @returns {import('./public.js').EventDispatcher<EventMap>}
	 */
	function createEventDispatcher() {
		const component = get_current_component();
		return (type, detail, { cancelable = false } = {}) => {
			const callbacks = component.$$.callbacks[type];
			if (callbacks) {
				// TODO are there situations where events could be dispatched
				// in a server (non-DOM) environment?
				const event = custom_event(/** @type {string} */ (type), detail, { cancelable });
				callbacks.slice().forEach((fn) => {
					fn.call(component, event);
				});
				return !event.defaultPrevented;
			}
			return true;
		};
	}

	const dirty_components = [];
	const binding_callbacks = [];

	let render_callbacks = [];

	const flush_callbacks = [];

	const resolved_promise = /* @__PURE__ */ Promise.resolve();

	let update_scheduled = false;

	/** @returns {void} */
	function schedule_update() {
		if (!update_scheduled) {
			update_scheduled = true;
			resolved_promise.then(flush);
		}
	}

	/** @returns {void} */
	function add_render_callback(fn) {
		render_callbacks.push(fn);
	}

	// flush() calls callbacks in this order:
	// 1. All beforeUpdate callbacks, in order: parents before children
	// 2. All bind:this callbacks, in reverse order: children before parents.
	// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
	//    for afterUpdates called during the initial onMount, which are called in
	//    reverse order: children before parents.
	// Since callbacks might update component values, which could trigger another
	// call to flush(), the following steps guard against this:
	// 1. During beforeUpdate, any updated components will be added to the
	//    dirty_components array and will cause a reentrant call to flush(). Because
	//    the flush index is kept outside the function, the reentrant call will pick
	//    up where the earlier call left off and go through all dirty components. The
	//    current_component value is saved and restored so that the reentrant call will
	//    not interfere with the "parent" flush() call.
	// 2. bind:this callbacks cannot trigger new flush() calls.
	// 3. During afterUpdate, any updated components will NOT have their afterUpdate
	//    callback called a second time; the seen_callbacks set, outside the flush()
	//    function, guarantees this behavior.
	const seen_callbacks = new Set();

	let flushidx = 0; // Do *not* move this inside the flush() function

	/** @returns {void} */
	function flush() {
		// Do not reenter flush while dirty components are updated, as this can
		// result in an infinite loop. Instead, let the inner flush handle it.
		// Reentrancy is ok afterwards for bindings etc.
		if (flushidx !== 0) {
			return;
		}
		const saved_component = current_component;
		do {
			// first, call beforeUpdate functions
			// and update components
			try {
				while (flushidx < dirty_components.length) {
					const component = dirty_components[flushidx];
					flushidx++;
					set_current_component(component);
					update(component.$$);
				}
			} catch (e) {
				// reset dirty state to not end up in a deadlocked state and then rethrow
				dirty_components.length = 0;
				flushidx = 0;
				throw e;
			}
			set_current_component(null);
			dirty_components.length = 0;
			flushidx = 0;
			while (binding_callbacks.length) binding_callbacks.pop()();
			// then, once components are updated, call
			// afterUpdate functions. This may cause
			// subsequent updates...
			for (let i = 0; i < render_callbacks.length; i += 1) {
				const callback = render_callbacks[i];
				if (!seen_callbacks.has(callback)) {
					// ...so guard against infinite loops
					seen_callbacks.add(callback);
					callback();
				}
			}
			render_callbacks.length = 0;
		} while (dirty_components.length);
		while (flush_callbacks.length) {
			flush_callbacks.pop()();
		}
		update_scheduled = false;
		seen_callbacks.clear();
		set_current_component(saved_component);
	}

	/** @returns {void} */
	function update($$) {
		if ($$.fragment !== null) {
			$$.update();
			run_all($$.before_update);
			const dirty = $$.dirty;
			$$.dirty = [-1];
			$$.fragment && $$.fragment.p($$.ctx, dirty);
			$$.after_update.forEach(add_render_callback);
		}
	}

	/**
	 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
	 * @param {Function[]} fns
	 * @returns {void}
	 */
	function flush_render_callbacks(fns) {
		const filtered = [];
		const targets = [];
		render_callbacks.forEach((c) => (fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c)));
		targets.forEach((c) => c());
		render_callbacks = filtered;
	}

	const outroing = new Set();

	/**
	 * @param {import('./private.js').Fragment} block
	 * @param {0 | 1} [local]
	 * @returns {void}
	 */
	function transition_in(block, local) {
		if (block && block.i) {
			outroing.delete(block);
			block.i(local);
		}
	}

	/** @typedef {1} INTRO */
	/** @typedef {0} OUTRO */
	/** @typedef {{ direction: 'in' | 'out' | 'both' }} TransitionOptions */
	/** @typedef {(node: Element, params: any, options: TransitionOptions) => import('../transition/public.js').TransitionConfig} TransitionFn */

	/**
	 * @typedef {Object} Outro
	 * @property {number} r
	 * @property {Function[]} c
	 * @property {Object} p
	 */

	/**
	 * @typedef {Object} PendingProgram
	 * @property {number} start
	 * @property {INTRO|OUTRO} b
	 * @property {Outro} [group]
	 */

	/**
	 * @typedef {Object} Program
	 * @property {number} a
	 * @property {INTRO|OUTRO} b
	 * @property {1|-1} d
	 * @property {number} duration
	 * @property {number} start
	 * @property {number} end
	 * @property {Outro} [group]
	 */

	// general each functions:

	function ensure_array_like(array_like_or_iterator) {
		return array_like_or_iterator?.length !== undefined
			? array_like_or_iterator
			: Array.from(array_like_or_iterator);
	}

	// keyed each functions:

	/** @returns {void} */
	function destroy_block(block, lookup) {
		block.d(1);
		lookup.delete(block.key);
	}

	/** @returns {any[]} */
	function update_keyed_each(
		old_blocks,
		dirty,
		get_key,
		dynamic,
		ctx,
		list,
		lookup,
		node,
		destroy,
		create_each_block,
		next,
		get_context
	) {
		let o = old_blocks.length;
		let n = list.length;
		let i = o;
		const old_indexes = {};
		while (i--) old_indexes[old_blocks[i].key] = i;
		const new_blocks = [];
		const new_lookup = new Map();
		const deltas = new Map();
		const updates = [];
		i = n;
		while (i--) {
			const child_ctx = get_context(ctx, list, i);
			const key = get_key(child_ctx);
			let block = lookup.get(key);
			if (!block) {
				block = create_each_block(key, child_ctx);
				block.c();
			} else if (dynamic) {
				// defer updates until all the DOM shuffling is done
				updates.push(() => block.p(child_ctx, dirty));
			}
			new_lookup.set(key, (new_blocks[i] = block));
			if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
		}
		const will_move = new Set();
		const did_move = new Set();
		/** @returns {void} */
		function insert(block) {
			transition_in(block, 1);
			block.m(node, next);
			lookup.set(block.key, block);
			next = block.first;
			n--;
		}
		while (o && n) {
			const new_block = new_blocks[n - 1];
			const old_block = old_blocks[o - 1];
			const new_key = new_block.key;
			const old_key = old_block.key;
			if (new_block === old_block) {
				// do nothing
				next = new_block.first;
				o--;
				n--;
			} else if (!new_lookup.has(old_key)) {
				// remove old block
				destroy(old_block, lookup);
				o--;
			} else if (!lookup.has(new_key) || will_move.has(new_key)) {
				insert(new_block);
			} else if (did_move.has(old_key)) {
				o--;
			} else if (deltas.get(new_key) > deltas.get(old_key)) {
				did_move.add(new_key);
				insert(new_block);
			} else {
				will_move.add(old_key);
				o--;
			}
		}
		while (o--) {
			const old_block = old_blocks[o];
			if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
		}
		while (n) insert(new_blocks[n - 1]);
		run_all(updates);
		return new_blocks;
	}

	/** @returns {void} */
	function mount_component(component, target, anchor) {
		const { fragment, after_update } = component.$$;
		fragment && fragment.m(target, anchor);
		// onMount happens before the initial afterUpdate
		add_render_callback(() => {
			const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
			// if the component was destroyed immediately
			// it will update the `$$.on_destroy` reference to `null`.
			// the destructured on_destroy may still reference to the old array
			if (component.$$.on_destroy) {
				component.$$.on_destroy.push(...new_on_destroy);
			} else {
				// Edge case - component was destroyed immediately,
				// most likely as a result of a binding initialising
				run_all(new_on_destroy);
			}
			component.$$.on_mount = [];
		});
		after_update.forEach(add_render_callback);
	}

	/** @returns {void} */
	function destroy_component(component, detaching) {
		const $$ = component.$$;
		if ($$.fragment !== null) {
			flush_render_callbacks($$.after_update);
			run_all($$.on_destroy);
			$$.fragment && $$.fragment.d(detaching);
			// TODO null out other refs, including component.$$ (but need to
			// preserve final state?)
			$$.on_destroy = $$.fragment = null;
			$$.ctx = [];
		}
	}

	/** @returns {void} */
	function make_dirty(component, i) {
		if (component.$$.dirty[0] === -1) {
			dirty_components.push(component);
			schedule_update();
			component.$$.dirty.fill(0);
		}
		component.$$.dirty[(i / 31) | 0] |= 1 << i % 31;
	}

	// TODO: Document the other params
	/**
	 * @param {SvelteComponent} component
	 * @param {import('./public.js').ComponentConstructorOptions} options
	 *
	 * @param {import('./utils.js')['not_equal']} not_equal Used to compare props and state values.
	 * @param {(target: Element | ShadowRoot) => void} [append_styles] Function that appends styles to the DOM when the component is first initialised.
	 * This will be the `add_css` function from the compiled component.
	 *
	 * @returns {void}
	 */
	function init(
		component,
		options,
		instance,
		create_fragment,
		not_equal,
		props,
		append_styles = null,
		dirty = [-1]
	) {
		const parent_component = current_component;
		set_current_component(component);
		/** @type {import('./private.js').T$$} */
		const $$ = (component.$$ = {
			fragment: null,
			ctx: [],
			// state
			props,
			update: noop,
			not_equal,
			bound: blank_object(),
			// lifecycle
			on_mount: [],
			on_destroy: [],
			on_disconnect: [],
			before_update: [],
			after_update: [],
			context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
			// everything else
			callbacks: blank_object(),
			dirty,
			skip_bound: false,
			root: options.target || parent_component.$$.root
		});
		append_styles && append_styles($$.root);
		let ready = false;
		$$.ctx = instance
			? instance(component, options.props || {}, (i, ret, ...rest) => {
					const value = rest.length ? rest[0] : ret;
					if ($$.ctx && not_equal($$.ctx[i], ($$.ctx[i] = value))) {
						if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
						if (ready) make_dirty(component, i);
					}
					return ret;
			  })
			: [];
		$$.update();
		ready = true;
		run_all($$.before_update);
		// `false` as a special case of no DOM component
		$$.fragment = create_fragment ? create_fragment($$.ctx) : false;
		if (options.target) {
			if (options.hydrate) {
				// TODO: what is the correct type here?
				// @ts-expect-error
				const nodes = children(options.target);
				$$.fragment && $$.fragment.l(nodes);
				nodes.forEach(detach);
			} else {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				$$.fragment && $$.fragment.c();
			}
			if (options.intro) transition_in(component.$$.fragment);
			mount_component(component, options.target, options.anchor);
			flush();
		}
		set_current_component(parent_component);
	}

	let SvelteElement;

	if (typeof HTMLElement === 'function') {
		SvelteElement = class extends HTMLElement {
			/** The Svelte component constructor */
			$$ctor;
			/** Slots */
			$$s;
			/** The Svelte component instance */
			$$c;
			/** Whether or not the custom element is connected */
			$$cn = false;
			/** Component props data */
			$$d = {};
			/** `true` if currently in the process of reflecting component props back to attributes */
			$$r = false;
			/** @type {Record<string, CustomElementPropDefinition>} Props definition (name, reflected, type etc) */
			$$p_d = {};
			/** @type {Record<string, Function[]>} Event listeners */
			$$l = {};
			/** @type {Map<Function, Function>} Event listener unsubscribe functions */
			$$l_u = new Map();

			constructor($$componentCtor, $$slots, use_shadow_dom) {
				super();
				this.$$ctor = $$componentCtor;
				this.$$s = $$slots;
				if (use_shadow_dom) {
					this.attachShadow({ mode: 'open' });
				}
			}

			addEventListener(type, listener, options) {
				// We can't determine upfront if the event is a custom event or not, so we have to
				// listen to both. If someone uses a custom event with the same name as a regular
				// browser event, this fires twice - we can't avoid that.
				this.$$l[type] = this.$$l[type] || [];
				this.$$l[type].push(listener);
				if (this.$$c) {
					const unsub = this.$$c.$on(type, listener);
					this.$$l_u.set(listener, unsub);
				}
				super.addEventListener(type, listener, options);
			}

			removeEventListener(type, listener, options) {
				super.removeEventListener(type, listener, options);
				if (this.$$c) {
					const unsub = this.$$l_u.get(listener);
					if (unsub) {
						unsub();
						this.$$l_u.delete(listener);
					}
				}
			}

			async connectedCallback() {
				this.$$cn = true;
				if (!this.$$c) {
					// We wait one tick to let possible child slot elements be created/mounted
					await Promise.resolve();
					if (!this.$$cn || this.$$c) {
						return;
					}
					function create_slot(name) {
						return () => {
							let node;
							const obj = {
								c: function create() {
									node = element('slot');
									if (name !== 'default') {
										attr(node, 'name', name);
									}
								},
								/**
								 * @param {HTMLElement} target
								 * @param {HTMLElement} [anchor]
								 */
								m: function mount(target, anchor) {
									insert(target, node, anchor);
								},
								d: function destroy(detaching) {
									if (detaching) {
										detach(node);
									}
								}
							};
							return obj;
						};
					}
					const $$slots = {};
					const existing_slots = get_custom_elements_slots(this);
					for (const name of this.$$s) {
						if (name in existing_slots) {
							$$slots[name] = [create_slot(name)];
						}
					}
					for (const attribute of this.attributes) {
						// this.$$data takes precedence over this.attributes
						const name = this.$$g_p(attribute.name);
						if (!(name in this.$$d)) {
							this.$$d[name] = get_custom_element_value(name, attribute.value, this.$$p_d, 'toProp');
						}
					}
					// Port over props that were set programmatically before ce was initialized
					for (const key in this.$$p_d) {
						if (!(key in this.$$d) && this[key] !== undefined) {
							this.$$d[key] = this[key]; // don't transform, these were set through JavaScript
							delete this[key]; // remove the property that shadows the getter/setter
						}
					}
					this.$$c = new this.$$ctor({
						target: this.shadowRoot || this,
						props: {
							...this.$$d,
							$$slots,
							$$scope: {
								ctx: []
							}
						}
					});

					// Reflect component props as attributes
					const reflect_attributes = () => {
						this.$$r = true;
						for (const key in this.$$p_d) {
							this.$$d[key] = this.$$c.$$.ctx[this.$$c.$$.props[key]];
							if (this.$$p_d[key].reflect) {
								const attribute_value = get_custom_element_value(
									key,
									this.$$d[key],
									this.$$p_d,
									'toAttribute'
								);
								if (attribute_value == null) {
									this.removeAttribute(this.$$p_d[key].attribute || key);
								} else {
									this.setAttribute(this.$$p_d[key].attribute || key, attribute_value);
								}
							}
						}
						this.$$r = false;
					};
					this.$$c.$$.after_update.push(reflect_attributes);
					reflect_attributes(); // once initially because after_update is added too late for first render

					for (const type in this.$$l) {
						for (const listener of this.$$l[type]) {
							const unsub = this.$$c.$on(type, listener);
							this.$$l_u.set(listener, unsub);
						}
					}
					this.$$l = {};
				}
			}

			// We don't need this when working within Svelte code, but for compatibility of people using this outside of Svelte
			// and setting attributes through setAttribute etc, this is helpful
			attributeChangedCallback(attr, _oldValue, newValue) {
				if (this.$$r) return;
				attr = this.$$g_p(attr);
				this.$$d[attr] = get_custom_element_value(attr, newValue, this.$$p_d, 'toProp');
				this.$$c?.$set({ [attr]: this.$$d[attr] });
			}

			disconnectedCallback() {
				this.$$cn = false;
				// In a microtask, because this could be a move within the DOM
				Promise.resolve().then(() => {
					if (!this.$$cn && this.$$c) {
						this.$$c.$destroy();
						this.$$c = undefined;
					}
				});
			}

			$$g_p(attribute_name) {
				return (
					Object.keys(this.$$p_d).find(
						(key) =>
							this.$$p_d[key].attribute === attribute_name ||
							(!this.$$p_d[key].attribute && key.toLowerCase() === attribute_name)
					) || attribute_name
				);
			}
		};
	}

	/**
	 * @param {string} prop
	 * @param {any} value
	 * @param {Record<string, CustomElementPropDefinition>} props_definition
	 * @param {'toAttribute' | 'toProp'} [transform]
	 */
	function get_custom_element_value(prop, value, props_definition, transform) {
		const type = props_definition[prop]?.type;
		value = type === 'Boolean' && typeof value !== 'boolean' ? value != null : value;
		if (!transform || !props_definition[prop]) {
			return value;
		} else if (transform === 'toAttribute') {
			switch (type) {
				case 'Object':
				case 'Array':
					return value == null ? null : JSON.stringify(value);
				case 'Boolean':
					return value ? '' : null;
				case 'Number':
					return value == null ? null : value;
				default:
					return value;
			}
		} else {
			switch (type) {
				case 'Object':
				case 'Array':
					return value && JSON.parse(value);
				case 'Boolean':
					return value; // conversion already handled above
				case 'Number':
					return value != null ? +value : value;
				default:
					return value;
			}
		}
	}

	/**
	 * @internal
	 *
	 * Turn a Svelte component into a custom element.
	 * @param {import('./public.js').ComponentType} Component  A Svelte component constructor
	 * @param {Record<string, CustomElementPropDefinition>} props_definition  The props to observe
	 * @param {string[]} slots  The slots to create
	 * @param {string[]} accessors  Other accessors besides the ones for props the component has
	 * @param {boolean} use_shadow_dom  Whether to use shadow DOM
	 * @param {(ce: new () => HTMLElement) => new () => HTMLElement} [extend]
	 */
	function create_custom_element(
		Component,
		props_definition,
		slots,
		accessors,
		use_shadow_dom,
		extend
	) {
		let Class = class extends SvelteElement {
			constructor() {
				super(Component, slots, use_shadow_dom);
				this.$$p_d = props_definition;
			}
			static get observedAttributes() {
				return Object.keys(props_definition).map((key) =>
					(props_definition[key].attribute || key).toLowerCase()
				);
			}
		};
		Object.keys(props_definition).forEach((prop) => {
			Object.defineProperty(Class.prototype, prop, {
				get() {
					return this.$$c && prop in this.$$c ? this.$$c[prop] : this.$$d[prop];
				},
				set(value) {
					value = get_custom_element_value(prop, value, props_definition);
					this.$$d[prop] = value;
					this.$$c?.$set({ [prop]: value });
				}
			});
		});
		accessors.forEach((accessor) => {
			Object.defineProperty(Class.prototype, accessor, {
				get() {
					return this.$$c?.[accessor];
				}
			});
		});
		if (extend) {
			// @ts-expect-error - assigning here is fine
			Class = extend(Class);
		}
		Component.element = /** @type {any} */ (Class);
		return Class;
	}

	/**
	 * Base class for Svelte components. Used when dev=false.
	 *
	 * @template {Record<string, any>} [Props=any]
	 * @template {Record<string, any>} [Events=any]
	 */
	class SvelteComponent {
		/**
		 * ### PRIVATE API
		 *
		 * Do not use, may change at any time
		 *
		 * @type {any}
		 */
		$$ = undefined;
		/**
		 * ### PRIVATE API
		 *
		 * Do not use, may change at any time
		 *
		 * @type {any}
		 */
		$$set = undefined;

		/** @returns {void} */
		$destroy() {
			destroy_component(this, 1);
			this.$destroy = noop;
		}

		/**
		 * @template {Extract<keyof Events, string>} K
		 * @param {K} type
		 * @param {((e: Events[K]) => void) | null | undefined} callback
		 * @returns {() => void}
		 */
		$on(type, callback) {
			if (!is_function(callback)) {
				return noop;
			}
			const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
			callbacks.push(callback);
			return () => {
				const index = callbacks.indexOf(callback);
				if (index !== -1) callbacks.splice(index, 1);
			};
		}

		/**
		 * @param {Partial<Props>} props
		 * @returns {void}
		 */
		$set(props) {
			if (this.$$set && !is_empty(props)) {
				this.$$.skip_bound = true;
				this.$$set(props);
				this.$$.skip_bound = false;
			}
		}
	}

	/**
	 * @typedef {Object} CustomElementPropDefinition
	 * @property {string} [attribute]
	 * @property {boolean} [reflect]
	 * @property {'String'|'Boolean'|'Number'|'Array'|'Object'} [type]
	 */

	// generated during release, do not modify

	const PUBLIC_VERSION = '4';

	if (typeof window !== 'undefined')
		// @ts-ignore
		(window.__svelte || (window.__svelte = { v: new Set() })).v.add(PUBLIC_VERSION);

	class KeyValuePair {
	    key;
	    value;
	    constructor(key, value) {
	        this.key = key;
	        this.value = value;
	    }
	}
	var SectionDisplay;
	(function (SectionDisplay) {
	    SectionDisplay[SectionDisplay["List"] = 1] = "List";
	    SectionDisplay[SectionDisplay["Add"] = 2] = "Add";
	    SectionDisplay[SectionDisplay["Preview"] = 3] = "Preview";
	})(SectionDisplay || (SectionDisplay = {}));
	var TypeOfCommunication;
	(function (TypeOfCommunication) {
	    TypeOfCommunication[TypeOfCommunication["Email"] = 1] = "Email";
	    TypeOfCommunication[TypeOfCommunication["at"] = 2] = "at";
	})(TypeOfCommunication || (TypeOfCommunication = {}));
	var AlertStatus;
	(function (AlertStatus) {
	    AlertStatus["Success"] = "Success";
	    AlertStatus["Error"] = "Error";
	    AlertStatus["Warning"] = "Warning";
	    AlertStatus["Information"] = "Information";
	})(AlertStatus || (AlertStatus = {}));

	class ServiceBase {
	    _headers = new Headers();
	    easBaseUrl;
	    easDataloadBaseUrl;
	    monitoringBaseUrl;
	    easAssetAuthUrl;
	    helpBaseUrl;
	    easUtilityUrl;
	    easWorkflowBaseUrl;
	    easContactBaseUrl;
	    validationResultsUrl;
	    validationRevalidateUrl;
	    apiEndPoint;
	    easCommunicationLogUrl;
	    easCommunicationUrl;
	    accessToken;
	    claimToken;
	    get headers() {
	        // Every time we get the headers, we need to check if the access token and claims token
	        // are already loaded. If not, we need to load them from session storage. 
	        // Otherwise it just returns the headers without any change. - kevin.low 01/02/24
	        if (!('accessToken' in this.accessToken)) {
	            console.error('accessToken not in this.accessToken. Reloading it from session storage.');
	            try {
	                this.accessToken = JSON.parse(sessionStorage.getItem('accessToken') ?? '{}');
	                if (!('accessToken' in this.accessToken)) {
	                    console.error('accessToken is still not found in session storage.');
	                }
	                else {
	                    this._headers.delete('Authorization');
	                    this._headers.append('Authorization', `Bearer ${this.accessToken?.accessToken}`);
	                }
	            }
	            catch (error) {
	                console.error(error);
	            }
	        }
	        try {
	            let updatedClaimToken = JSON.parse(sessionStorage.getItem('claims') ?? '{}');
	            if (!('claimsJwt' in this.claimToken)) {
	                console.error('claims is still not found in session storage.');
	            }
	            else {
	                if (this.claimToken?.claimsJwt != updatedClaimToken?.claimsJwt) {
	                    this._headers.delete('claims');
	                    this._headers.append('claims', this.claimToken?.claimsJwt);
	                }
	            }
	        }
	        catch (error) {
	            console.error(error);
	        }
	        return this._headers;
	    }
	    set headers(value) {
	        this._headers = value;
	    }
	    constructor() {
	        //Storybook url
	        if (window.location.href.includes(':6006')) {
	            sessionStorage.setItem('EAS_Base_Url', 'https://edu-dev-eas-assetauth.azurewebsites.net');
	            sessionStorage.setItem('EAS_Dataload_Base_Url', 'https://edu-dev-eas-dataload-request.azurewebsites.net');
	            sessionStorage.setItem('Asset_Auth_Url', 'https://edu-dev-eas-assetauth.azurewebsites.net');
	            sessionStorage.setItem('Eas_Help_Url', 'https://edu-dev-ent-help.azurewebsites.net');
	            sessionStorage.setItem('Eas_Utility_Url', 'https://edu-dev-eas-utility.azurewebsites.net');
	            sessionStorage.setItem('Eas_Workflow_Url', 'https://edu-dev-eas-workflow.azurewebsites.net');
	            sessionStorage.setItem('Eas_Contact_Url', 'https://edu-dev-eas-contact.azurewebsites.net');
	            sessionStorage.setItem('Eas_CommunicationLog_Url', 'https://edu-dev-eas-communicationlog.azurewebsites.net');
	            sessionStorage.setItem('Eas_Communication_Url', 'https://edu-dev-eas-communication.azurewebsites.net');
	            sessionStorage.setItem('accessToken', `{"accessToken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYzYmVjNmVkLWRlMDUtNGQxZS05ZTI0LTQwZTJlNTUxNGQzYSIsInVuaXF1ZV9uYW1lIjoiOTUzMDQiLCJmaXJzdF9uYW1lIjoiRGlhbmUiLCJsYXN0X25hbWUiOiJOZWFsIiwicGVyc29uX2tleSI6Ijk1MzA0Iiwic3lzdGVtX2tleSI6IjMwIiwidXVpZCI6IkE5Uk8wR1RXSklTTFJCSEo1UkU4WVVYTTlTUFJOSEIwVTk0QyIsInN5c3RlbV91cmwiOiJodHRwczovL2Vkc3RlcHNkZXYuZWR1Y2F0aW9uLm9oaW8uZ292L29uZWZ1bmRpbmcvIiwic3lzdGVtX25hbWUiOiJPbmUgRnVuZGluZyBBcHBsaWNhdGlvbiIsIm9mZmljZV9lbWFpbCI6IiIsImhvbWVfZW1haWwiOiIiLCJvYWtzX2lkIjoiIiwibmJmIjoxNzI3Nzg2MDQyLCJleHAiOjE3Mjc4NzI0NDIsImlhdCI6MTcyNzc4NjA0MiwiaXNzIjoib2hpby1kZXBhcnRtZW50LW9mLWVkdWNhdGlvbiIsImF1ZCI6ImVhc19hdWRpZW5jZSJ9.ZxhT5--NANxGfhrG15E_uCJp3iCR9nu_hykdzROYYN4","orgs":[{"org_id":6108,"name":"Ohio Department of Education and Workforce","audiences":[{"aud_id":1,"name":"Admin","applications":[{"app_id":231,"name":"One Funding Application","url":null}]}],"irn":"050765"}],"expires":"2024-10-02T08:34:02.4470379Z","public":false}`);
	            sessionStorage.setItem('claims', `{"claimsJwt":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYwNDdhZTYwLWE3Y2YtNDlhMy1hNjdiLTQ4YzgxYTIwMzU1ZSIsImFwcGxpY2F0aW9uX2tleSI6IjIzMSIsImF1ZGllbmNlX2tleSI6IjEiLCJvcmdfa2V5IjoiNjEwOCIsIm9yZ19uYW1lIjoiT2hpbyBEZXBhcnRtZW50IG9mIEVkdWNhdGlvbiBhbmQgV29ya2ZvcmNlIiwiaXJuIjoiMDUwNzY1Iiwib3JnX3R5cGVfa2V5IjoiMjciLCJvcmdfdHlwZV9uYW1lIjoiU3RhdGUgQm9hcmQvQWdlbmN5Iiwicm9sZV9jb250ZXh0IjoiMjciLCJjb250YWN0X2NvbnRleHRfaWQiOiIzNDAiLCJjb250YWN0X2NvbnRleHRfdXJsIjoiaHR0cHM6Ly9lZHUtZGV2LW9uZS1mdW5kaW5nLWdhdGV3YXkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL0NvbnRhY3RDb250ZXh0LzM0MCIsIm5iZiI6MTcyNzc4NjA1NSwiZXhwIjoxNzI3ODcyNDU1LCJpYXQiOjE3Mjc3ODYwNTUsImlzcyI6Im9oaW8tZGVwYXJ0bWVudC1vZi1lZHVjYXRpb24iLCJhdWQiOiJlYXNfYXVkaWVuY2UifQ.rX-IV9OdOKB2SeqGE171a0Ks-h6Mzy5VoIp1pSO9sg0","claims":{"organizationId":6108,"audienceId":1,"applicationId":231,"contactContextId":"340","contactContextUrl":"https://edu-dev-one-funding-gateway.azurewebsites.net/api/ContactContext/340"}}`);
	        }
	        this.easBaseUrl = sessionStorage.getItem('EAS_Base_Url') ?? '';
	        this.easDataloadBaseUrl = sessionStorage.getItem('EAS_Dataload_Base_Url') ?? '';
	        this.monitoringBaseUrl = sessionStorage.getItem('Monitoring_Base_Url') ?? '';
	        this.easAssetAuthUrl = sessionStorage.getItem('Asset_Auth_Url') ?? '';
	        this.helpBaseUrl = sessionStorage.getItem('Eas_Help_Url') ?? '';
	        this.easUtilityUrl = sessionStorage.getItem('Eas_Utility_Url') ?? '';
	        this.easWorkflowBaseUrl = sessionStorage.getItem('Eas_Workflow_Url') ?? '';
	        this.easContactBaseUrl = sessionStorage.getItem('Eas_Contact_Url') ?? '';
	        this.validationResultsUrl = sessionStorage.getItem('Validation_Results_Url') ?? '';
	        this.validationRevalidateUrl = sessionStorage.getItem('Validation_Revalidate_Url') ?? '';
	        this.apiEndPoint = sessionStorage.getItem('APIEndPoint') ?? '';
	        this.easCommunicationLogUrl = sessionStorage.getItem('Eas_CommunicationLog_Url') ?? '';
	        this.easCommunicationUrl = sessionStorage.getItem('Eas_Communication_Url') ?? '';
	        try {
	            this.accessToken = JSON.parse(sessionStorage.getItem('accessToken') ?? '{}');
	            if (!('accessToken' in this.accessToken)) {
	                console.error('accessToken is not found in session storage.');
	            }
	        }
	        catch (error) {
	            console.log(error);
	        }
	        try {
	            this.claimToken = JSON.parse(sessionStorage.getItem('claims') ?? '{}');
	            if (!('claimsJwt' in this.claimToken)) {
	                console.error('claims is not found in session storage.');
	            }
	        }
	        catch (error) {
	            console.error(error);
	        }
	        this.headers = new Headers();
	        this.headers.append('Content-Type', 'application/json');
	        this.headers.append('Authorization', `Bearer ${this.accessToken?.accessToken}`);
	        //this.headers.append('Authorization', `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYzYmVjNmVkLWRlMDUtNGQxZS05ZTI0LTQwZTJlNTUxNGQzYSIsInVuaXF1ZV9uYW1lIjoiOTUzMDQiLCJmaXJzdF9uYW1lIjoiRGlhbmUiLCJsYXN0X25hbWUiOiJOZWFsIiwicGVyc29uX2tleSI6Ijk1MzA0Iiwic3lzdGVtX2tleSI6IjMwIiwidXVpZCI6IkE5Uk8wR1RXSklTTFJCSEo1UkU4WVVYTTlTUFJOSEIwVTk0QyIsInN5c3RlbV91cmwiOiJodHRwczovL2Vkc3RlcHNkZXYuZWR1Y2F0aW9uLm9oaW8uZ292L29uZWZ1bmRpbmcvIiwic3lzdGVtX25hbWUiOiJPbmUgRnVuZGluZyBBcHBsaWNhdGlvbiIsIm9mZmljZV9lbWFpbCI6IiIsImhvbWVfZW1haWwiOiIiLCJvYWtzX2lkIjoiIiwibmJmIjoxNzI3Nzg2MDQyLCJleHAiOjE3Mjc4NzI0NDIsImlhdCI6MTcyNzc4NjA0MiwiaXNzIjoib2hpby1kZXBhcnRtZW50LW9mLWVkdWNhdGlvbiIsImF1ZCI6ImVhc19hdWRpZW5jZSJ9.ZxhT5--NANxGfhrG15E_uCJp3iCR9nu_hykdzROYYN4`);
	        this.headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
	        this.headers.append('x-requestid', this.generateUUID());
	        this.headers.append('claims', this.claimToken?.claimsJwt);
	        //this.headers.append('claims', `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYwNDdhZTYwLWE3Y2YtNDlhMy1hNjdiLTQ4YzgxYTIwMzU1ZSIsImFwcGxpY2F0aW9uX2tleSI6IjIzMSIsImF1ZGllbmNlX2tleSI6IjEiLCJvcmdfa2V5IjoiNjEwOCIsIm9yZ19uYW1lIjoiT2hpbyBEZXBhcnRtZW50IG9mIEVkdWNhdGlvbiBhbmQgV29ya2ZvcmNlIiwiaXJuIjoiMDUwNzY1Iiwib3JnX3R5cGVfa2V5IjoiMjciLCJvcmdfdHlwZV9uYW1lIjoiU3RhdGUgQm9hcmQvQWdlbmN5Iiwicm9sZV9jb250ZXh0IjoiMjciLCJjb250YWN0X2NvbnRleHRfaWQiOiIzNDAiLCJjb250YWN0X2NvbnRleHRfdXJsIjoiaHR0cHM6Ly9lZHUtZGV2LW9uZS1mdW5kaW5nLWdhdGV3YXkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL0NvbnRhY3RDb250ZXh0LzM0MCIsIm5iZiI6MTcyNzc4NjA1NSwiZXhwIjoxNzI3ODcyNDU1LCJpYXQiOjE3Mjc3ODYwNTUsImlzcyI6Im9oaW8tZGVwYXJ0bWVudC1vZi1lZHVjYXRpb24iLCJhdWQiOiJlYXNfYXVkaWVuY2UifQ.rX-IV9OdOKB2SeqGE171a0Ks-h6Mzy5VoIp1pSO9sg0`);
	    }
	    getJSON = (url) => {
	        return fetch(url, { headers: this.headers })
	            .then(response => {
	            return response.status === 204 ? [] : response.json();
	        });
	    };
	    postJSON = (url, payload) => {
	        return fetch(url, { method: 'POST', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => {
	            return response.json();
	        });
	    };
	    putJSON = (url, payload) => {
	        return fetch(url, { method: 'PUT', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => response.json());
	    };
	    putData = (url) => {
	        return fetch(url, { method: 'PUT', headers: this.headers })
	            .then(response => response.json());
	    };
	    deleteJSON = (url, payload) => {
	        return fetch(url, { method: 'DELETE', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => response.json());
	    };
	    postData = (url, payload) => {
	        return fetch(url, { method: 'POST', body: payload, headers: this.headers })
	            .then(response => response.json());
	    };
	    getString = (url) => {
	        return fetch(url, { headers: this.headers })
	            .then(response => response.text());
	    };
	    uploadFile = (url, payload) => {
	        this.headers.delete('Content-Type');
	        //this.headers.append('Content-Type', 'multipart/form-data; boundary=----WebKitFormBoundaryaw7OAy2cWKU1Ndnn');
	        return fetch(url, { method: 'POST', body: payload, headers: this.headers })
	            .then(data => data.text());
	    };
	    getFile = (url) => {
	        this.headers.delete('Content-Type');
	        const options = {
	            headers: this.headers,
	            observe: 'body', // return data only
	            responseType: 'blob' // return type for binary data; json is default
	        };
	        return fetch(url, options);
	        //.then(response => response);
	    };
	    get = (url) => {
	        this.headers.delete('Content-Type');
	        return fetch(url, { headers: this.headers });
	        //.then(response => response);
	    };
	    generateUUID() {
	        var d = new Date().getTime(); //Timestamp
	        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16; //random number between 0 and 16
	            if (d > 0) { //Use timestamp until depleted
	                r = (d + r) % 16 | 0;
	                d = Math.floor(d / 16);
	            }
	            else { //Use microseconds since page-load if supported
	                r = (d2 + r) % 16 | 0;
	                d2 = Math.floor(d2 / 16);
	            }
	            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	        });
	    }
	}

	class DocumentService extends ServiceBase {
	    getDocumentCount(moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey) {
	        if (!assetTemplateKey || !compositeOwnerSourceKey) {
	            console.error(`getDocumentCount: invalid parameters assetTemplateKey: ${assetTemplateKey} , compositeOwnerSourceKey: ${compositeOwnerSourceKey}`);
	            return new Promise((resolve) => {
	                resolve(0);
	            });
	        }
	        const _url = `${this.easUtilityUrl}/api/v1/Document/documents/count?moduleKey=${moduleKey}` +
	            `&assetTemplateKey=${assetTemplateKey}&detailKey=${compositeOwnerSourceKey}` +
	            (immediateOwnerSourceKey ?
	                `&immediateOwnerSourceKey=${immediateOwnerSourceKey}&immediateOwnerTypeKey=${immediateOwnerTypeKey}` : '') +
	            (compositeOwnerTypeKey ?
	                `&compositeOwnerTypeKey=${compositeOwnerTypeKey}` : '');
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(_url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getDocuments(moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, itemContextKey = 0) {
	        if (!assetTemplateKey || !compositeOwnerSourceKey) {
	            console.error(`getDocuments: invalid parameters assetTemplateKey: ${assetTemplateKey} , compositeOwnerSourceKey: ${compositeOwnerSourceKey}`);
	            return new Promise((resolve) => {
	                resolve([]);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/Document/documents?moduleKey=${moduleKey}` +
	            `&assetTemplateKey=${assetTemplateKey}&detailKey=${compositeOwnerSourceKey}&compositeOwnerTypeKey=${compositeOwnerTypeKey}` +
	            `&immediateOwnerSourceKey=${immediateOwnerSourceKey}&immediateOwnerTypeKey=${immediateOwnerTypeKey}`;
	        if (itemContextKey && itemContextKey != 0) {
	            url += `&itemContextKey=${itemContextKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getFileTypes() {
	        let _url = `${this.easUtilityUrl}/api/v1/Document/filetypes`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(_url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getDocTypes(moduleKey, assetTemplateKey, ownerTypeKey, type, itemContextKey = 0) {
	        if (!assetTemplateKey || !ownerTypeKey || !type) {
	            console.error(`getDocTypes: invalid parameters assetTemplateKey: ${assetTemplateKey} , ownerTypeKey: ${ownerTypeKey} , type: ${type}`);
	            return new Promise((resolve) => {
	                resolve([]);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/Document/doctypes?moduleKey=${moduleKey}&assetTemplateKey=${assetTemplateKey}&detailKey=${ownerTypeKey}&type=${type}`;
	        if (itemContextKey && itemContextKey != 0) {
	            url += `&itemContextKey=${itemContextKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getAllowedDocTypes(moduleKey, assetTemplateKey, ownerTypeKey, type, itemContext) {
	        let result = new Promise((resolve, reject) => {
	            this.getDocTypes(moduleKey, assetTemplateKey, ownerTypeKey, type, itemContext)
	                .then((items) => {
	                resolve(items.filter((item) => item.permission.create));
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getDocPermissions(moduleKey, assetTemplateKey, immediateOwnerSourceKey, itemContext = 0) {
	        if (!assetTemplateKey || !immediateOwnerSourceKey) {
	            console.error(`getDocPermissions: invalid parameters assetTemplateKey: ${assetTemplateKey} , immediateOwnerSourceKey: ${immediateOwnerSourceKey}`);
	            let retVal = { read: false, create: false, update: false, delete: false, approve: false, authorizeChange: false };
	            return new Promise((resolve) => {
	                resolve(retVal);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/Document/permissions?moduleKey=${moduleKey}&assetTemplateKey=${assetTemplateKey}&detailKey=${immediateOwnerSourceKey}&assetType=uicomp&childAssetTypeName=AddDocuments`;
	        if (itemContext && itemContext != 0) {
	            url += `&itemContextKey=${itemContext}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    uploadDocument(data, moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, docTypeKey, docTypeDescription, itemContextKey) {
	        let url = `${this.easUtilityUrl}/api/v1/Document/documents/saved?moduleKey=${moduleKey}` +
	            `&detailKey=${compositeOwnerSourceKey}&assetTemplateKey=${assetTemplateKey}&docType=${docTypeKey}` +
	            `&docTypeName=${docTypeDescription.split(' ').join('_')}` +
	            (immediateOwnerSourceKey ?
	                `&immediateOwnerSourceKey=${immediateOwnerSourceKey}&immediateOwnerTypeKey=${immediateOwnerTypeKey}` : '') +
	            (compositeOwnerTypeKey ?
	                `&compositeOwnerTypeKey=${compositeOwnerTypeKey}` : '');
	        if (itemContextKey != 0) {
	            url += `&itemContextKey=${itemContextKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.uploadFile(url, data)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    deleteDocument(data) {
	        let _url = `${this.easUtilityUrl}//api/v1/document/documents/deleted`;
	        let result = new Promise((resolve, reject) => {
	            this.putJSON(_url, data)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    downloadDocument(document) {
	        const _url = `${this.easUtilityUrl}/api/v1/Document/documents/file/${document.docKey}?moduleKey=${document.moduleKey}` +
	            `&assetTemplateKey=${document.assetTemplateKey}&detailKey=${document.documentCompositeOwnerSourceKey}` +
	            (document.documentImmediateOwnerSourceKey ?
	                `&immediateOwnerSourceKey=${document.documentImmediateOwnerSourceKey}&immediateOwnerTypeKey=${document.documentImmediateOwnerTypeKey}` : '') +
	            (document.documentCompositeOwnerTypeKey ?
	                `&compositeOwnerTypeKey=${document.documentCompositeOwnerTypeKey}` : '');
	        let result = new Promise((resolve, reject) => {
	            this.getFile(_url)
	                .then((response) => {
	                resolve(response.blob());
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    getDocStatuses(moduleKey, assetTemplateKey, documentRelationInstancekey, itemContextKey) {
	        if (!moduleKey || !assetTemplateKey || !documentRelationInstancekey || moduleKey == 0 || assetTemplateKey == 0 || documentRelationInstancekey == 0) {
	            console.error(`getDocStatuses: invalid parameters assetTemplateKey: ${assetTemplateKey} , documentRelationInstancekey: ${documentRelationInstancekey}`);
	            let retVal = { authorizedToUpdate: false, documentStatuses: [] };
	            return new Promise((resolve) => {
	                resolve(retVal);
	            });
	        }
	        let url = `${this.easUtilityUrl}/api/v1/Document/statuses?moduleKey=${moduleKey}&assetTemplateKey=${assetTemplateKey}&documentRelationInstanceKey=${documentRelationInstancekey}`;
	        if (itemContextKey && itemContextKey != 0) {
	            url += `&itemContextKey=${itemContextKey}`;
	        }
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    updateDocument(updateDocumentModel) {
	        let url = `${this.easUtilityUrl}/api/v1/Document/documents`;
	        let result = new Promise((resolve, reject) => {
	            this.putJSON(url, updateDocumentModel)
	                .then((items) => {
	                resolve(items);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	}

	/* src\lib\documents\add\document-add.component.svelte generated by Svelte v4.2.19 */

	const { document: document_1$1 } = globals;

	function add_css$4(target) {
		append_styles(target, "svelte-1w3xlv1", ".should-hide.svelte-1w3xlv1.svelte-1w3xlv1{display:none !important}.should-display.svelte-1w3xlv1.svelte-1w3xlv1{display:block !important}:root{--gray-800:#2c2c2c;--gray-700:#434343;--gray-600:#8c8c8c;--gray-500:#bfbfbf;--gray-400:#d9d9d9;--gray-300:#e8e8e8;--gray-250:#f0f0f0;--gray-200:#f2f2f2;--gray-100:#f6f6f6;--gray-50:#f7f7f7;--maroon-800:#700017;--maroon-700:#8b3043;--maroon-600:#99495a;--maroon-500:#aa6d7e;--maroon-400:#bf95a5;--maroon-300:#e9d9dc;--maroon-200:#f5eeee;--maroon-100:#faf6f6;--maroon-lte-100:#faf6f6;--maroon-lte-200:#f5eeee;--red-800:#ea1014;--red-700:#f1353a;--red-600:#f4595c;--red-500:#f57174;--red-400:#f7888b;--red-300:#f9acae;--red-200:#fbc4c5;--red-100:#fde7e7;--red-50:#faf6f6;--blue-800:#3d7aa9;--blue-700:#4781ad;--blue-600:#5f91b7;--blue-500:#749fc1;--blue-400:#9ebcd4;--blue-300:#c4d7e5;--blue-200:#e2ebf2;--blue-100:#f4f7fa;--blue-lte-100:#eff0f5;--lte-blue-800:#73a5cc;--lte-blue-700:#88b2d4;--lte-blue-600:#a4c4de;--lte-blue-500:#c0d6e8;--lte-blue-400:#cee0ed;--lte-blue-300:#dce8f2;--lte-blue-200:#eaf2f7;--lte-blue-100:#f4f8fb;--gold-800:#ffbe0e;--gold-700:#ffce4a;--gold-600:#fad87b;--gold-500:#f8de9b;--gold-400:#f6e2b2;--gold-300:#f4e7ca;--gold-200:#f2ebdd;--gold-100:#f3f1ed;--drk-green-800:#5e8000;--drk-green-700:#6e8c19;--drk-green-600:#7e9933;--drk-green-500:#8ea64c;--drk-green-400:#aebf7f;--drk-green-300:#c7d3a6;--drk-green-200:#dfe6cc;--drk-green-100:#eff2e5;--green-800:#b5dc10;--green-700:#bcdf27;--green-600:#c4e340;--green-500:#cbe657;--green-400:#daed87;--green-300:#e5f3ac;--green-200:#f0f8cf;--green-100:#f7fbe7;--ohid-blue-100:#ebf7ff;--ohid-blue-200:#d9efff;--ohid-blue-300:#bfe5ff;--ohid-blue-400:#a6daff;--ohid-blue-500:#8cd0ff;--ohid-blue-600:#59bbff;--ohid-blue-700:#26a6ff;--ohid-blue-800:#0096ff;--ohid-drk-blue-100:#ecf0f4;--ohid-drk-blue-200:#dae3e9;--ohid-drk-blue-300:#c2d0db;--ohid-drk-blue-400:#a9bdcc;--ohid-drk-blue-500:#91aabe;--ohid-drk-blue-600:#6084a1;--ohid-drk-blue-700:#2f5e84;--ohid-drk-blue-800:#0a426e;--iop-lt-blue-800:#40b0ff;--iop-blue-800:#0096ff;--iop-drk-blue-800:#004393;--lte:300;--reg:400;--semi:600;--bold:700}div.svelte-1w3xlv1.svelte-1w3xlv1{display:block;background:transparent;transition:all 0.2s ease-in-out}.svelte-1w3xlv1.svelte-1w3xlv1,.svelte-1w3xlv1.svelte-1w3xlv1:after,.svelte-1w3xlv1.svelte-1w3xlv1:before{box-sizing:border-box;padding:0;margin:0}.mb-10.svelte-1w3xlv1.svelte-1w3xlv1{margin-bottom:10px !important}button.svelte-1w3xlv1.svelte-1w3xlv1{position:relative;display:flex;align-items:center;justify-content:center;height:44px;width:max-content;padding:0 20px;border:0;font-size:16px;cursor:pointer;background:transparent;transition:all 0.2s ease-in-out !important}button.svelte-1w3xlv1 .btn-txt.svelte-1w3xlv1{transition:all 0.2s ease-in-out !important}.rounded-full.svelte-1w3xlv1.svelte-1w3xlv1{border-radius:100px !important}.fa-solid.svelte-1w3xlv1.svelte-1w3xlv1{font-family:'Font Awesome 6 Pro';font-weight:900}i.svelte-1w3xlv1.svelte-1w3xlv1{font-style:italic}div.svelte-1w3xlv1.svelte-1w3xlv1{font-family:'Source Sans Pro', sans-serif}button.border-red.svelte-1w3xlv1.svelte-1w3xlv1{border-color:var(--red-800)}.flex-row-reverse.svelte-1w3xlv1.svelte-1w3xlv1{flex-direction:row-reverse !important}.mr-10.svelte-1w3xlv1.svelte-1w3xlv1{margin-right:10px !important}button.svelte-1w3xlv1 .btn-txt.svelte-1w3xlv1{transition:all 0.2s ease-in-out !important}.font-red.svelte-1w3xlv1.svelte-1w3xlv1{color:var(--red-800) !important}.gap-10.svelte-1w3xlv1.svelte-1w3xlv1{gap:10px}button.svelte-1w3xlv1 .btn-txt.svelte-1w3xlv1{display:flex;justify-content:center;min-width:max-content;font-size:16px}button.svelte-1w3xlv1 .btn-txt.svelte-1w3xlv1{transition:all 0.2s ease-in-out !important}.mt-10.svelte-1w3xlv1.svelte-1w3xlv1{margin-top:10px !important}.select-container.svelte-1w3xlv1.svelte-1w3xlv1{position:relative}.border-gray-600.svelte-1w3xlv1.svelte-1w3xlv1{border-color:var(--gray-600) !important}.border-bottom.svelte-1w3xlv1.svelte-1w3xlv1{border-bottom:1px solid var(--gray-400)}.select-container.chevron.svelte-1w3xlv1.svelte-1w3xlv1::before{top:17px !important}.select-container.chevron.svelte-1w3xlv1.svelte-1w3xlv1::before{content:'\\f078';position:absolute;top:23px;right:20px;font-family:'font awesome 5 pro';font-weight:800;pointer-events:none;z-index:100}.hover-blue-200.svelte-1w3xlv1.svelte-1w3xlv1:hover{background:var(--blue-200) !important}button:hover.hover-red.svelte-1w3xlv1.svelte-1w3xlv1{background:var(--red-800) !important;color:white !important}:hover.hover-font-white.svelte-1w3xlv1>.svelte-1w3xlv1{color:white !important}.select-container.chevron.svelte-1w3xlv1.svelte-1w3xlv1::before{content:'\\f078';position:absolute;top:23px;right:20px;font-family:'font awesome 5 pro';font-weight:800;pointer-events:none;z-index:100}.select-container.svelte-1w3xlv1.svelte-1w3xlv1{position:relative}.select-container.chevron.svelte-1w3xlv1.svelte-1w3xlv1::before{content:'\\f078';position:absolute;top:23px;right:20px;font-family:'font awesome 5 pro';font-weight:800;pointer-events:none;z-index:100}.align-center.svelte-1w3xlv1.svelte-1w3xlv1{align-items:center !important}.flex.svelte-1w3xlv1.svelte-1w3xlv1{display:flex}.plr-10.svelte-1w3xlv1.svelte-1w3xlv1{padding-left:10px !important;padding-right:10px !important}.ptb-20.svelte-1w3xlv1.svelte-1w3xlv1{padding-top:20px !important;padding-bottom:20px !important}.border-gray-500.svelte-1w3xlv1.svelte-1w3xlv1{border-color:var(--gray-500) !important}.border.svelte-1w3xlv1.svelte-1w3xlv1{border:1px solid var(--gray-400)}.mt-20.svelte-1w3xlv1.svelte-1w3xlv1{margin-top:20px !important}.mtb-10.svelte-1w3xlv1.svelte-1w3xlv1{margin-top:10px !important;margin-bottom:10px !important}ul.svelte-1w3xlv1.svelte-1w3xlv1{max-width:720px;padding:0;margin-left:20px}ul.svelte-1w3xlv1>li.svelte-1w3xlv1{padding:8px 10px 8px 8px;line-height:24px}.select-container.chevron.svelte-1w3xlv1.svelte-1w3xlv1::before{top:17px !important}.progress_bar_frame.svelte-1w3xlv1.svelte-1w3xlv1{height:7px;width:100%;border-width:1px;border-style:solid;border-color:#a1a1a1;margin-top:5px}");
	}

	function get_each_context$1(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[34] = list[i];
		return child_ctx;
	}

	// (171:0) {#if errorMsg !== ''}
	function create_if_block_1$3(ctx) {
		let div3;
		let div2;
		let div1;
		let div0;
		let i;
		let t0;
		let t1;
		let span;

		return {
			c() {
				div3 = element("div");
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");
				i = element("i");
				t0 = text(/*errorMsg*/ ctx[3]);
				t1 = space();
				span = element("span");
				span.textContent = "×";
				attr(i, "class", "fa-solid fa-circle-info mr-10 fa-xl svelte-1w3xlv1");
				set_style(i, "font-size", "10px");
				set_style(div0, "font-size", "10px");
				attr(div0, "class", "svelte-1w3xlv1");
				attr(div1, "id", "Warning_Status_Holder");
				attr(div1, "class", "plr-10 ptb-20 svelte-1w3xlv1");
				set_style(div1, "width", "100%");
				attr(span, "class", "close svelte-1w3xlv1");
				set_style(span, "float", "right");
				set_style(span, "font-size", "30px");
				set_style(span, "color", "#f1353a");
				set_style(span, "padding-right", "10px");
				attr(div2, "id", "Warning_Status_Banner");
				attr(div2, "class", "flex align-center error-page-alert svelte-1w3xlv1");
				attr(div3, "class", "input__container svelte-1w3xlv1");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div2);
				append(div2, div1);
				append(div1, div0);
				append(div0, i);
				append(div0, t0);
				append(div2, t1);
				append(div2, span);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*errorMsg*/ 8) set_data(t0, /*errorMsg*/ ctx[3]);
			},
			d(detaching) {
				if (detaching) {
					detach(div3);
				}
			}
		};
	}

	// (194:3) {:else}
	function create_else_block$2(ctx) {
		let eas_select;
		let mounted;
		let dispose;

		return {
			c() {
				eas_select = element("eas-select");
				set_custom_element_data(eas_select, "controlid", "docTypes");
				set_custom_element_data(eas_select, "selecteditem", /*selectedDocType*/ ctx[5]);
				set_custom_element_data(eas_select, "data", /*docTypesList*/ ctx[2]);
				set_custom_element_data(eas_select, "placeholder", "Select Document Type*");
				set_custom_element_data(eas_select, "height", "35");
				set_custom_element_data(eas_select, "width", "300");
				set_style(eas_select, "font-size", "10px");
				set_custom_element_data(eas_select, "class", "svelte-1w3xlv1");
			},
			m(target, anchor) {
				insert(target, eas_select, anchor);

				if (!mounted) {
					dispose = listen(eas_select, "itemselected", /*itemselected_handler*/ ctx[17]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*selectedDocType*/ 32) {
					set_custom_element_data(eas_select, "selecteditem", /*selectedDocType*/ ctx[5]);
				}

				if (dirty[0] & /*docTypesList*/ 4) {
					set_custom_element_data(eas_select, "data", /*docTypesList*/ ctx[2]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(eas_select);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (192:3) {#if docTypesListLoading}
	function create_if_block$3(ctx) {
		let t;

		return {
			c() {
				t = text("loading...");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(t);
				}
			}
		};
	}

	// (274:1) {#each fileProgressBars as file}
	function create_each_block$1(ctx) {
		let div0;
		let t0;
		let t1_value = /*file*/ ctx[34].value + "";
		let t1;
		let t2;
		let t3_value = /*file*/ ctx[34].key + "";
		let t3;
		let t4;
		let t5;
		let div2;
		let div1;
		let t6;

		return {
			c() {
				div0 = element("div");
				t0 = text("Queue Progress: ");
				t1 = text(t1_value);
				t2 = text(" [ ");
				t3 = text(t3_value);
				t4 = text("% ]");
				t5 = space();
				div2 = element("div");
				div1 = element("div");
				t6 = space();
				set_style(div0, "font-size", "10px");
				attr(div0, "class", "mt-10 svelte-1w3xlv1");
				set_style(div1, "height", "6px");
				set_style(div1, "width", /*file*/ ctx[34].key + "%");
				set_style(div1, "background-color", "#A1A1A1");
				attr(div1, "class", "svelte-1w3xlv1");
				attr(div2, "class", "progress_bar_frame svelte-1w3xlv1");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				append(div0, t0);
				append(div0, t1);
				append(div0, t2);
				append(div0, t3);
				append(div0, t4);
				insert(target, t5, anchor);
				insert(target, div2, anchor);
				append(div2, div1);
				append(div2, t6);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*fileProgressBars*/ 2 && t1_value !== (t1_value = /*file*/ ctx[34].value + "")) set_data(t1, t1_value);
				if (dirty[0] & /*fileProgressBars*/ 2 && t3_value !== (t3_value = /*file*/ ctx[34].key + "")) set_data(t3, t3_value);

				if (dirty[0] & /*fileProgressBars*/ 2) {
					set_style(div1, "width", /*file*/ ctx[34].key + "%");
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div0);
					detach(t5);
					detach(div2);
				}
			}
		};
	}

	function create_fragment$4(ctx) {
		let link;
		let t0;
		let script;
		let script_src_value;
		let t1;
		let div0;
		let t3;
		let t4;
		let div11;
		let div2;
		let div1;
		let t5;
		let span0;
		let input0;
		let t6;
		let div4;
		let t8;
		let span1;
		let t9;
		let div5;
		let t11;
		let div8;
		let div6;
		let t13;
		let div7;
		let ul;
		let li0;
		let t15;
		let li1;
		let t17;
		let li2;
		let t19;
		let li3;
		let t21;
		let li4;
		let t22;
		let b;
		let t23;
		let div8_class_value;
		let t24;
		let t25;
		let div10;
		let button;
		let mounted;
		let dispose;
		let if_block0 = /*errorMsg*/ ctx[3] !== '' && create_if_block_1$3(ctx);

		function select_block_type(ctx, dirty) {
			if (/*docTypesListLoading*/ ctx[4]) return create_if_block$3;
			return create_else_block$2;
		}

		let current_block_type = select_block_type(ctx);
		let if_block1 = current_block_type(ctx);
		let each_value = ensure_array_like(/*fileProgressBars*/ ctx[1]);
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
		}

		return {
			c() {
				link = element("link");
				t0 = space();
				script = element("script");
				script.innerHTML = ``;
				t1 = space();
				div0 = element("div");
				div0.innerHTML = `<h4 class="svelte-1w3xlv1">Add Documents</h4>`;
				t3 = space();
				if (if_block0) if_block0.c();
				t4 = space();
				div11 = element("div");
				div2 = element("div");
				div1 = element("div");
				if_block1.c();
				t5 = space();
				span0 = element("span");
				input0 = element("input");
				t6 = space();
				div4 = element("div");
				div4.innerHTML = `<div style="font-weight: bold;color:#A1A1A1;padding:20px;font-size:10px;" class="svelte-1w3xlv1">Drag file(s) here to upload or click here to browse for files.</div>`;
				t8 = space();
				span1 = element("span");
				span1.innerHTML = `<input type="file" class="svelte-1w3xlv1"/>`;
				t9 = space();
				div5 = element("div");

				div5.innerHTML = `<i class="fa-solid fa-circle-info mr-10 fa-xl svelte-1w3xlv1" style="font-size: 10px;"></i>
		Instructions`;

				t11 = space();
				div8 = element("div");
				div6 = element("div");
				div6.textContent = "×";
				t13 = space();
				div7 = element("div");
				ul = element("ul");
				li0 = element("li");
				li0.textContent = "Under Document Type drop down list select the document type you would have the files\r\n\t\t\t\t\tlisted under.";
				t15 = space();
				li1 = element("li");
				li1.textContent = "You may select up to 5 documents at a time to upload.";
				t17 = space();
				li2 = element("li");
				li2.textContent = "Drag file from file window to the Drag and Drop window to add the file to the Documents\r\n\t\t\t\t\tlist";
				t19 = space();
				li3 = element("li");
				li3.textContent = "Maximum file size is 100MB";
				t21 = space();
				li4 = element("li");
				t22 = text("Only the following file extensions are accepted:");
				b = element("b");
				t23 = text(/*allowedExtensions*/ ctx[6]);
				t24 = space();

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t25 = space();
				div10 = element("div");
				button = element("button");
				button.innerHTML = `<div class="btn-txt font-red svelte-1w3xlv1" style="font-size:10px;">Close Add Document(s)</div>`;
				attr(link, "rel", "stylesheet");
				attr(link, "href", "https://use.fontawesome.com/releases/v5.11.2/css/all.css");
				attr(link, "class", "svelte-1w3xlv1");
				if (!src_url_equal(script.src, script_src_value = "https://kit.fontawesome.com/a5cccf28a6.js")) attr(script, "src", script_src_value);
				attr(script, "crossorigin", "anonymous");
				attr(script, "class", "svelte-1w3xlv1");
				set_style(div0, "margin", "20px auto");
				set_style(div0, "width", "95%");
				attr(div0, "class", "svelte-1w3xlv1");
				attr(div1, "class", "select-container chevron border-bottom border-gray-600 mt-10 svelte-1w3xlv1");
				set_style(div1, "height", "36px");
				set_style(div1, "width", "100%");
				set_style(div1, "font-size", "10px");
				attr(div2, "class", "mtb-10 svelte-1w3xlv1");
				attr(input0, "id", "uploadFile");
				attr(input0, "type", "file");
				input0.multiple = true;
				attr(input0, "class", "svelte-1w3xlv1");
				set_style(span0, "visibility", "hidden");
				set_style(span0, "position", "absolute");
				set_style(span0, "overflow", "hidden");
				set_style(span0, "width", "0px");
				set_style(span0, "height", "0px");
				set_style(span0, "border", "none");
				set_style(span0, "margin", "0");
				set_style(span0, "padding", "0");
				attr(span0, "class", "svelte-1w3xlv1");
				attr(div4, "class", "hover-blue-200 svelte-1w3xlv1");
				set_style(div4, "height", "100px");
				set_style(div4, "width", "100%");
				set_style(div4, "border-style", "dotted");
				set_style(div4, "border-color", "#A1A1A1");
				set_style(div4, "background-color", "#E8E8E8");
				set_style(span1, "visibility", "hidden");
				set_style(span1, "position", "absolute");
				set_style(span1, "overflow", "hidden");
				set_style(span1, "width", "0px");
				set_style(span1, "height", "0px");
				set_style(span1, "border", "none");
				set_style(span1, "margin", "0");
				set_style(span1, "padding", "0");
				attr(span1, "class", "svelte-1w3xlv1");
				set_style(div5, "font-size", "10px");
				attr(div5, "class", "mt-10 mb-10 svelte-1w3xlv1");
				attr(div6, "class", "close svelte-1w3xlv1");
				set_style(div6, "float", "right");
				set_style(div6, "font-size", "30px");
				set_style(div6, "color", "#000");
				set_style(div6, "padding-left", "10px");
				set_style(div6, "padding-right", "10px");
				set_style(li0, "padding", "3px");
				attr(li0, "class", "svelte-1w3xlv1");
				set_style(li1, "padding", "3px");
				attr(li1, "class", "svelte-1w3xlv1");
				set_style(li2, "padding", "3px");
				attr(li2, "class", "svelte-1w3xlv1");
				set_style(li3, "padding", "3px");
				attr(li3, "class", "svelte-1w3xlv1");
				attr(b, "class", "svelte-1w3xlv1");
				set_style(li4, "padding", "3px");
				attr(li4, "class", "svelte-1w3xlv1");
				attr(ul, "class", "svelte-1w3xlv1");
				set_style(div7, "width", "95%");
				set_style(div7, "padding-top", "20px");
				attr(div7, "class", "svelte-1w3xlv1");

				attr(div8, "class", div8_class_value = "border border-gray-500 " + (/*showInstruction*/ ctx[0]
				? 'should-display'
				: 'should-hide') + " svelte-1w3xlv1");

				set_style(div8, "padding", "0");
				set_style(div8, "font-size", "10px");
				set_style(button, "flex", "1 0 auto");
				set_style(button, "max-width", "200px");
				set_style(button, "height", "35px");
				attr(button, "id", "");
				attr(button, "class", "secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile svelte-1w3xlv1");
				attr(div10, "class", "gap-10 mt-20 svelte-1w3xlv1");
				set_style(div10, "display", "flex");
				set_style(div10, "flex-direction", "row");
				set_style(div10, "flex-wrap", "wrap");
				set_style(div10, "width", "150px");
				set_style(div10, "height", "35px");
				set_style(div11, "margin", "20px auto");
				set_style(div11, "width", "95%");
				attr(div11, "class", "svelte-1w3xlv1");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				append(document_1$1.head, script);
				insert(target, t1, anchor);
				insert(target, div0, anchor);
				insert(target, t3, anchor);
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t4, anchor);
				insert(target, div11, anchor);
				append(div11, div2);
				append(div2, div1);
				if_block1.m(div1, null);
				append(div11, t5);
				append(div11, span0);
				append(span0, input0);
				append(div11, t6);
				append(div11, div4);
				append(div11, t8);
				append(div11, span1);
				append(div11, t9);
				append(div11, div5);
				append(div11, t11);
				append(div11, div8);
				append(div8, div6);
				append(div8, t13);
				append(div8, div7);
				append(div7, ul);
				append(ul, li0);
				append(ul, t15);
				append(ul, li1);
				append(ul, t17);
				append(ul, li2);
				append(ul, t19);
				append(ul, li3);
				append(ul, t21);
				append(ul, li4);
				append(li4, t22);
				append(li4, b);
				append(b, t23);
				append(div11, t24);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div11, null);
					}
				}

				append(div11, t25);
				append(div11, div10);
				append(div10, button);

				if (!mounted) {
					dispose = [
						listen(input0, "select", /*select_handler*/ ctx[18]),
						listen(div4, "drop", /*drop_handler*/ ctx[19]),
						listen(div4, "dragover", /*dragover_handler*/ ctx[20]),
						listen(div4, "click", /*click_handler*/ ctx[21]),
						listen(div5, "click", /*click_handler_1*/ ctx[22]),
						listen(div6, "click", /*click_handler_2*/ ctx[23]),
						listen(button, "click", /*click_handler_3*/ ctx[24])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (/*errorMsg*/ ctx[3] !== '') {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_1$3(ctx);
						if_block0.c();
						if_block0.m(t4.parentNode, t4);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1.d(1);
					if_block1 = current_block_type(ctx);

					if (if_block1) {
						if_block1.c();
						if_block1.m(div1, null);
					}
				}

				if (dirty[0] & /*allowedExtensions*/ 64) set_data(t23, /*allowedExtensions*/ ctx[6]);

				if (dirty[0] & /*showInstruction*/ 1 && div8_class_value !== (div8_class_value = "border border-gray-500 " + (/*showInstruction*/ ctx[0]
				? 'should-display'
				: 'should-hide') + " svelte-1w3xlv1")) {
					attr(div8, "class", div8_class_value);
				}

				if (dirty[0] & /*fileProgressBars*/ 2) {
					each_value = ensure_array_like(/*fileProgressBars*/ ctx[1]);
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$1(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$1(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div11, t25);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(t1);
					detach(div0);
					detach(t3);
					detach(t4);
					detach(div11);
				}

				detach(script);
				if (if_block0) if_block0.d(detaching);
				if_block1.d();
				destroy_each(each_blocks, detaching);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	const MAX_FILE_SIZE_MB = 100;

	function openFileSelect(e) {
		document.getElementById('uploadFile')?.click();
	}

	function fileSelectHandler(e) {
		console.log('file selected:', e);
	}

	function dragOverHandler(e) {
		//console.log("File(s) in drop zone");
		// Prevent default behavior (Prevent file from being opened)
		e.preventDefault();
	}

	function instance$4($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		const uploadMaxFileSize = MAX_FILE_SIZE_MB * 1024 * 1024;
		let { moduleKey = 0 } = $$props;
		let { assetTemplateKey = 0 } = $$props;
		let { immediateOwnerSourceKey = 0 } = $$props;
		let { immediateOwnerTypeKey = 0 } = $$props;
		let { compositeOwnerSourceKey = 0 } = $$props;
		let { compositeOwnerTypeKey = 0 } = $$props;
		let documentService = new DocumentService();
		let showInstruction = false;
		let fileProgressBars = [];
		let docTypesList = [];
		let uploadfiles = [];
		let errorMsg = '';
		let docTypesListLoading = true;
		let selectedDocType;
		let selectedDocTypeValue = '';
		let allowedExtensions = '';

		onMount(async () => {
			getFileTypes();
			getAuthorizedDocTypes();
		});

		function getFileTypes() {
			documentService.getFileTypes().then(result => {
				$$invalidate(6, allowedExtensions = result.map(x => x.fileExt).join(', '));
			}).catch(error => {
				console.error('Error in getFileTypes', error);
			});
		}

		function getAuthorizedDocTypes() {
			documentService.getDocTypes(moduleKey, assetTemplateKey, immediateOwnerSourceKey, 'add').then(result => {
				$$invalidate(2, docTypesList = result.map(docType => {
					return new KeyValuePair(docType.docTypeKey, docType.docTypeName);
				}));

				$$invalidate(5, selectedDocType = 0);
				$$invalidate(4, docTypesListLoading = false);
			}).catch(error => {
				console.error('Error in getAuthorizedDocTypes', error);
			});
		}

		function onCloseClick(e) {
			fileProgressBars.slice();
			uploadfiles = [];
			let detail = { close: true };
			e.stopPropagation();
			svelteDispatch('closeClick', detail);
		}

		function dropHandler(e) {
			console.log('File(s) dropped');

			// Prevent default behavior (Prevent file from being opened)
			e.preventDefault();

			setTimeout(
				() => {
					$$invalidate(3, errorMsg = '');
				},
				5000
			);

			if (!selectedDocType) {
				$$invalidate(3, errorMsg = 'Document type must be selected.');
				return;
			}

			if (!e.dataTransfer) return;

			if (e.dataTransfer.items) {
				if (e.dataTransfer.items.length > 5) {
					$$invalidate(3, errorMsg = 'You have selected more than 5 documents to upload');
					return;
				}

				// Use DataTransferItemList interface to access the file(s)
				[...e.dataTransfer.items].forEach((item, i) => {
					// If dropped items aren't files, reject them
					if (item.kind === 'file') {
						const file = item.getAsFile();
						if (!file) return;
						uploadFile(file);
					} //console.log(`… file[${i}].name = ${file.name}`);
				});
			} else {
				if (e.dataTransfer.files.length > 5) {
					$$invalidate(3, errorMsg = 'You have selected more than 5 documents to upload');
					return;
				}

				// Use DataTransfer interface to access the file(s)
				[...e.dataTransfer.files].forEach((file, i) => {
					uploadFile(file);
				}); //console.log(`… file[${i}].name = ${file.name}`);
			}

			$$invalidate(1, fileProgressBars = uploadfiles);
		}

		function toggleInstruction(e) {
			$$invalidate(0, showInstruction = !showInstruction);
		}

		function uploadFile(file) {
			console.log(file);
			var extension = file.name.split('.')[file.name.split('.').length - 1].toLowerCase();

			if (!isValidExtension(`.${extension}`)) {
				$$invalidate(3, errorMsg = `${file.name} is invalid file. \nOnly the following file extensions are accepted: ${allowedExtensions}`);
				return;
			}

			if (file.size > uploadMaxFileSize) {
				$$invalidate(3, errorMsg = `${file.name} is larger than size limit(100MB).`);
				return;
			}

			uploadfiles.push(new KeyValuePair(100, file.name));

			//console.log(`File name: ${file.name} and size: ${fileSize}`);
			//console.log(uploadfiles);
			let formData = new FormData();

			formData.append('file', file);

			documentService.uploadDocument(formData, moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, selectedDocType, selectedDocTypeValue).then(result => {
				console.log(result);
			}).catch(error => {
				console.error('Error in uploadDocument', error);
			});
		}

		function isValidExtension(extension) {
			return allowedExtensions.indexOf(extension) > -1;
		}

		function onDocTypeSelect(e) {
			console.log(`onDocTypeSelect fired:`, e.detail);
			let selectedType = docTypesList.find(docType => docType.key === e.detail.selectedItem);

			if (selectedType) {
				$$invalidate(5, selectedDocType = selectedType.key);
				selectedDocTypeValue = selectedType.value;
			}

			console.log(`selectedDocType:`, selectedDocType);
		}

		const itemselected_handler = e => onDocTypeSelect(e);
		const select_handler = e => fileSelectHandler(e);
		const drop_handler = e => dropHandler(e);
		const dragover_handler = e => dragOverHandler(e);
		const click_handler = e => openFileSelect();
		const click_handler_1 = e => toggleInstruction();
		const click_handler_2 = e => toggleInstruction();
		const click_handler_3 = e => onCloseClick(e);

		$$self.$$set = $$props => {
			if ('moduleKey' in $$props) $$invalidate(11, moduleKey = $$props.moduleKey);
			if ('assetTemplateKey' in $$props) $$invalidate(12, assetTemplateKey = $$props.assetTemplateKey);
			if ('immediateOwnerSourceKey' in $$props) $$invalidate(13, immediateOwnerSourceKey = $$props.immediateOwnerSourceKey);
			if ('immediateOwnerTypeKey' in $$props) $$invalidate(14, immediateOwnerTypeKey = $$props.immediateOwnerTypeKey);
			if ('compositeOwnerSourceKey' in $$props) $$invalidate(15, compositeOwnerSourceKey = $$props.compositeOwnerSourceKey);
			if ('compositeOwnerTypeKey' in $$props) $$invalidate(16, compositeOwnerTypeKey = $$props.compositeOwnerTypeKey);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty[0] & /*moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey*/ 129024) {
				console.log(`moduleKey: ${moduleKey}; 
    assetTemplateKey: ${assetTemplateKey}
    immediateOwnerSourceKey: ${immediateOwnerSourceKey}
    immediateOwnerTypeKey: ${immediateOwnerTypeKey}
    compositeOwnerSourceKey: ${compositeOwnerSourceKey}
    compositeOwnerTypeKey: ${compositeOwnerTypeKey}`);
			}
		};

		return [
			showInstruction,
			fileProgressBars,
			docTypesList,
			errorMsg,
			docTypesListLoading,
			selectedDocType,
			allowedExtensions,
			onCloseClick,
			dropHandler,
			toggleInstruction,
			onDocTypeSelect,
			moduleKey,
			assetTemplateKey,
			immediateOwnerSourceKey,
			immediateOwnerTypeKey,
			compositeOwnerSourceKey,
			compositeOwnerTypeKey,
			itemselected_handler,
			select_handler,
			drop_handler,
			dragover_handler,
			click_handler,
			click_handler_1,
			click_handler_2,
			click_handler_3
		];
	}

	class Document_add_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$4,
				create_fragment$4,
				safe_not_equal,
				{
					moduleKey: 11,
					assetTemplateKey: 12,
					immediateOwnerSourceKey: 13,
					immediateOwnerTypeKey: 14,
					compositeOwnerSourceKey: 15,
					compositeOwnerTypeKey: 16
				},
				add_css$4,
				[-1, -1]
			);
		}

		get moduleKey() {
			return this.$$.ctx[11];
		}

		set moduleKey(moduleKey) {
			this.$$set({ moduleKey });
			flush();
		}

		get assetTemplateKey() {
			return this.$$.ctx[12];
		}

		set assetTemplateKey(assetTemplateKey) {
			this.$$set({ assetTemplateKey });
			flush();
		}

		get immediateOwnerSourceKey() {
			return this.$$.ctx[13];
		}

		set immediateOwnerSourceKey(immediateOwnerSourceKey) {
			this.$$set({ immediateOwnerSourceKey });
			flush();
		}

		get immediateOwnerTypeKey() {
			return this.$$.ctx[14];
		}

		set immediateOwnerTypeKey(immediateOwnerTypeKey) {
			this.$$set({ immediateOwnerTypeKey });
			flush();
		}

		get compositeOwnerSourceKey() {
			return this.$$.ctx[15];
		}

		set compositeOwnerSourceKey(compositeOwnerSourceKey) {
			this.$$set({ compositeOwnerSourceKey });
			flush();
		}

		get compositeOwnerTypeKey() {
			return this.$$.ctx[16];
		}

		set compositeOwnerTypeKey(compositeOwnerTypeKey) {
			this.$$set({ compositeOwnerTypeKey });
			flush();
		}
	}

	customElements.define("eas-document-add-swc", create_custom_element(Document_add_component, {"moduleKey":{},"assetTemplateKey":{},"immediateOwnerSourceKey":{},"immediateOwnerTypeKey":{},"compositeOwnerSourceKey":{},"compositeOwnerTypeKey":{}}, [], [], true));

	/* src\lib\documents\container\document-container.component.svelte generated by Svelte v4.2.19 */

	function add_css$3(target) {
		append_styles(target, "svelte-1wsk640", ".persistant-utility-container.svelte-1wsk640.svelte-1wsk640{padding-top:1px;background-color:#fff;font-family:'Source Sans Pro', sans-serif;-webkit-font-smoothing:antialiased}.should-hide.svelte-1wsk640.svelte-1wsk640{display:none !important}.should-display.svelte-1wsk640.svelte-1wsk640{display:block !important}:root{--gray-800:#2c2c2c;--gray-700:#434343;--gray-600:#8c8c8c;--gray-500:#bfbfbf;--gray-400:#d9d9d9;--gray-300:#e8e8e8;--gray-250:#f0f0f0;--gray-200:#f2f2f2;--gray-100:#f6f6f6;--gray-50:#f7f7f7;--maroon-800:#700017;--maroon-700:#8b3043;--maroon-600:#99495a;--maroon-500:#aa6d7e;--maroon-400:#bf95a5;--maroon-300:#e9d9dc;--maroon-200:#f5eeee;--maroon-100:#faf6f6;--maroon-lte-100:#faf6f6;--maroon-lte-200:#f5eeee;--red-800:#ea1014;--red-700:#f1353a;--red-600:#f4595c;--red-500:#f57174;--red-400:#f7888b;--red-300:#f9acae;--red-200:#fbc4c5;--red-100:#fde7e7;--red-50:#faf6f6;--blue-800:#3d7aa9;--blue-700:#4781ad;--blue-600:#5f91b7;--blue-500:#749fc1;--blue-400:#9ebcd4;--blue-300:#c4d7e5;--blue-200:#e2ebf2;--blue-100:#f4f7fa;--blue-lte-100:#eff0f5;--lte-blue-800:#73a5cc;--lte-blue-700:#88b2d4;--lte-blue-600:#a4c4de;--lte-blue-500:#c0d6e8;--lte-blue-400:#cee0ed;--lte-blue-300:#dce8f2;--lte-blue-200:#eaf2f7;--lte-blue-100:#f4f8fb;--gold-800:#ffbe0e;--gold-700:#ffce4a;--gold-600:#fad87b;--gold-500:#f8de9b;--gold-400:#f6e2b2;--gold-300:#f4e7ca;--gold-200:#f2ebdd;--gold-100:#f3f1ed;--drk-green-800:#5e8000;--drk-green-700:#6e8c19;--drk-green-600:#7e9933;--drk-green-500:#8ea64c;--drk-green-400:#aebf7f;--drk-green-300:#c7d3a6;--drk-green-200:#dfe6cc;--drk-green-100:#eff2e5;--green-800:#b5dc10;--green-700:#bcdf27;--green-600:#c4e340;--green-500:#cbe657;--green-400:#daed87;--green-300:#e5f3ac;--green-200:#f0f8cf;--green-100:#f7fbe7;--ohid-blue-100:#ebf7ff;--ohid-blue-200:#d9efff;--ohid-blue-300:#bfe5ff;--ohid-blue-400:#a6daff;--ohid-blue-500:#8cd0ff;--ohid-blue-600:#59bbff;--ohid-blue-700:#26a6ff;--ohid-blue-800:#0096ff;--ohid-drk-blue-100:#ecf0f4;--ohid-drk-blue-200:#dae3e9;--ohid-drk-blue-300:#c2d0db;--ohid-drk-blue-400:#a9bdcc;--ohid-drk-blue-500:#91aabe;--ohid-drk-blue-600:#6084a1;--ohid-drk-blue-700:#2f5e84;--ohid-drk-blue-800:#0a426e;--iop-lt-blue-800:#40b0ff;--iop-blue-800:#0096ff;--iop-drk-blue-800:#004393;--lte:300;--reg:400;--semi:600;--bold:700}div.svelte-1wsk640.svelte-1wsk640{display:block}.card.fluid.svelte-1wsk640.svelte-1wsk640{max-width:100% !important}.card.svelte-1wsk640.svelte-1wsk640{display:flex;flex:1 1 20%;flex-direction:column;width:100%;margin:0 !important;text-decoration:none;border:0 solid transparent;border-radius:0;background:white;overflow:hidden;outline:3px solid transparent;transition:all 0.22s ease-in-out}div.svelte-1wsk640.svelte-1wsk640{background:transparent;transition:all 0.2s ease-in-out}.svelte-1wsk640.svelte-1wsk640,.svelte-1wsk640.svelte-1wsk640:after,.svelte-1wsk640.svelte-1wsk640:before{box-sizing:border-box;padding:0;margin:0}.inline-text-field-container.svelte-1wsk640.svelte-1wsk640{display:flex;flex-direction:column}.mb-10.svelte-1wsk640.svelte-1wsk640{margin-bottom:10px !important}button.svelte-1wsk640.svelte-1wsk640{position:relative;display:flex;align-items:center;justify-content:center;height:44px;width:max-content;padding:0 20px;border:0;font-size:16px;cursor:pointer;background:transparent;transition:all 0.2s ease-in-out !important}button.svelte-1wsk640 .btn-txt.svelte-1wsk640{transition:all 0.2s ease-in-out !important}.bold.svelte-1wsk640.svelte-1wsk640{font-weight:var(--bold) !important}.font-blue.svelte-1wsk640.svelte-1wsk640{color:var(--blue-800) !important}.bold.svelte-1wsk640.svelte-1wsk640{font-weight:var(--bold) !important}.font-blue.svelte-1wsk640.svelte-1wsk640{color:var(--blue-800) !important}.rounded-full.svelte-1wsk640.svelte-1wsk640{border-radius:100px !important}div.svelte-1wsk640.svelte-1wsk640{font-family:'Source Sans Pro', sans-serif}.card.fluid.svelte-1wsk640.svelte-1wsk640{max-width:100% !important}.gap-10.svelte-1wsk640.svelte-1wsk640{gap:10px}.flex-row.svelte-1wsk640.svelte-1wsk640{flex-direction:row !important}button.svelte-1wsk640 .btn-txt.svelte-1wsk640{display:flex;justify-content:center;min-width:max-content;font-size:16px}button.svelte-1wsk640 .btn-txt.svelte-1wsk640{transition:all 0.2s ease-in-out !important}.mt-10.svelte-1wsk640.svelte-1wsk640{margin-top:10px !important}.hover-blue-200.svelte-1wsk640.svelte-1wsk640:hover{background:var(--blue-200) !important}button.border-blue.svelte-1wsk640.svelte-1wsk640{border-color:var(--blue-800)}");
	}

	// (152:3) {:else}
	function create_else_block$1(ctx) {
		let div;
		let t;
		let eas_document_list_swc;
		let mounted;
		let dispose;
		let if_block = /*hasCreatePermission*/ ctx[7] && create_if_block_2$2(ctx);

		return {
			c() {
				div = element("div");
				if (if_block) if_block.c();
				t = space();
				eas_document_list_swc = element("eas-document-list-swc");
				attr(div, "class", "inline-text-field-container flex-row gap-10 mb-10 svelte-1wsk640");
				set_custom_element_data(eas_document_list_swc, "docslist", /*documents*/ ctx[9]);
				set_custom_element_data(eas_document_list_swc, "class", "svelte-1wsk640");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if (if_block) if_block.m(div, null);
				insert(target, t, anchor);
				insert(target, eas_document_list_swc, anchor);

				if (!mounted) {
					dispose = [
						listen(eas_document_list_swc, "previewClick", /*previewClick_handler*/ ctx[19]),
						listen(eas_document_list_swc, "confirmDeleteClick", /*confirmDeleteClick_handler*/ ctx[20])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (/*hasCreatePermission*/ ctx[7]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_2$2(ctx);
						if_block.c();
						if_block.m(div, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}

				if (dirty & /*documents*/ 512) {
					set_custom_element_data(eas_document_list_swc, "docslist", /*documents*/ ctx[9]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
					detach(t);
					detach(eas_document_list_swc);
				}

				if (if_block) if_block.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (147:51) 
	function create_if_block_1$2(ctx) {
		let eas_document_preview_swc;
		let mounted;
		let dispose;

		return {
			c() {
				eas_document_preview_swc = element("eas-document-preview-swc");
				set_custom_element_data(eas_document_preview_swc, "document", /*selectedDoc*/ ctx[10]);
				set_custom_element_data(eas_document_preview_swc, "class", "svelte-1wsk640");
			},
			m(target, anchor) {
				insert(target, eas_document_preview_swc, anchor);

				if (!mounted) {
					dispose = listen(eas_document_preview_swc, "closeClick", /*closeClick_handler_1*/ ctx[17]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*selectedDoc*/ 1024) {
					set_custom_element_data(eas_document_preview_swc, "document", /*selectedDoc*/ ctx[10]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(eas_document_preview_swc);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (137:3) {#if userSection == SectionDisplay.Add}
	function create_if_block$2(ctx) {
		let eas_document_add_swc;
		let mounted;
		let dispose;

		return {
			c() {
				eas_document_add_swc = element("eas-document-add-swc");
				set_custom_element_data(eas_document_add_swc, "moduleKey", /*moduleKey*/ ctx[1]);
				set_custom_element_data(eas_document_add_swc, "assetTemplateKey", /*assetTemplateKey*/ ctx[2]);
				set_custom_element_data(eas_document_add_swc, "immediateOwnerSourceKey", /*immediateOwnerSourceKey*/ ctx[3]);
				set_custom_element_data(eas_document_add_swc, "immediateOwnerTypeKey", /*immediateOwnerTypeKey*/ ctx[4]);
				set_custom_element_data(eas_document_add_swc, "compositeOwnerSourceKey", /*compositeOwnerSourceKey*/ ctx[5]);
				set_custom_element_data(eas_document_add_swc, "compositeOwnerTypeKey", /*compositeOwnerTypeKey*/ ctx[6]);
				set_custom_element_data(eas_document_add_swc, "class", "svelte-1wsk640");
			},
			m(target, anchor) {
				insert(target, eas_document_add_swc, anchor);

				if (!mounted) {
					dispose = listen(eas_document_add_swc, "closeClick", /*closeClick_handler*/ ctx[16]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*moduleKey*/ 2) {
					set_custom_element_data(eas_document_add_swc, "moduleKey", /*moduleKey*/ ctx[1]);
				}

				if (dirty & /*assetTemplateKey*/ 4) {
					set_custom_element_data(eas_document_add_swc, "assetTemplateKey", /*assetTemplateKey*/ ctx[2]);
				}

				if (dirty & /*immediateOwnerSourceKey*/ 8) {
					set_custom_element_data(eas_document_add_swc, "immediateOwnerSourceKey", /*immediateOwnerSourceKey*/ ctx[3]);
				}

				if (dirty & /*immediateOwnerTypeKey*/ 16) {
					set_custom_element_data(eas_document_add_swc, "immediateOwnerTypeKey", /*immediateOwnerTypeKey*/ ctx[4]);
				}

				if (dirty & /*compositeOwnerSourceKey*/ 32) {
					set_custom_element_data(eas_document_add_swc, "compositeOwnerSourceKey", /*compositeOwnerSourceKey*/ ctx[5]);
				}

				if (dirty & /*compositeOwnerTypeKey*/ 64) {
					set_custom_element_data(eas_document_add_swc, "compositeOwnerTypeKey", /*compositeOwnerTypeKey*/ ctx[6]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(eas_document_add_swc);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (154:5) {#if hasCreatePermission}
	function create_if_block_2$2(ctx) {
		let button;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				button.innerHTML = `<div class="btn-txt font-blue bold svelte-1wsk640" style="font-size:10px;">Add Docs</div>`;
				attr(button, "class", "secondary border-blue rounded-full hover-blue-200 flex-row-reverse svelte-1wsk640");
				set_style(button, "width", "70px");
				set_style(button, "height", "35px");
			},
			m(target, anchor) {
				insert(target, button, anchor);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler*/ ctx[18]);
					mounted = true;
				}
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$3(ctx) {
		let link;
		let t0;
		let script;
		let script_src_value;
		let t1;
		let div2;
		let div1;
		let div0;
		let div2_class_value;

		function select_block_type(ctx, dirty) {
			if (/*userSection*/ ctx[8] == SectionDisplay.Add) return create_if_block$2;
			if (/*userSection*/ ctx[8] == SectionDisplay.Preview) return create_if_block_1$2;
			return create_else_block$1;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				script = element("script");
				script.innerHTML = ``;
				t1 = space();
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");
				if_block.c();
				attr(link, "rel", "stylesheet");
				attr(link, "href", "https://use.fontawesome.com/releases/v5.11.2/css/all.css");
				attr(link, "class", "svelte-1wsk640");
				if (!src_url_equal(script.src, script_src_value = "https://kit.fontawesome.com/a5cccf28a6.js")) attr(script, "src", script_src_value);
				attr(script, "crossorigin", "anonymous");
				attr(script, "class", "svelte-1wsk640");
				attr(div0, "class", "card fluid svelte-1wsk640");
				attr(div1, "class", "flex-row mt-10 svelte-1wsk640");
				attr(div2, "class", div2_class_value = "persistant-utility-container " + (/*display*/ ctx[0] ? 'should-display' : 'should-hide') + " svelte-1wsk640");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				append(document.head, script);
				insert(target, t1, anchor);
				insert(target, div2, anchor);
				append(div2, div1);
				append(div1, div0);
				if_block.m(div0, null);
			},
			p(ctx, [dirty]) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(div0, null);
					}
				}

				if (dirty & /*display*/ 1 && div2_class_value !== (div2_class_value = "persistant-utility-container " + (/*display*/ ctx[0] ? 'should-display' : 'should-hide') + " svelte-1wsk640")) {
					attr(div2, "class", div2_class_value);
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(t1);
					detach(div2);
				}

				detach(script);
				if_block.d();
			}
		};
	}

	function instance$3($$self, $$props, $$invalidate) {
		let { display = false } = $$props;
		let { moduleKey = 0 } = $$props;
		let { assetTemplateKey = 0 } = $$props;
		let { immediateOwnerSourceKey = 0 } = $$props;
		let { immediateOwnerTypeKey = 0 } = $$props;
		let { compositeOwnerSourceKey = 0 } = $$props;
		let { compositeOwnerTypeKey = 0 } = $$props;
		let { title = 'Documents on File' } = $$props;
		let hasCreatePermission = false;
		let oldAssetTemplateKey = 0;
		let oldImmediateOwnerSourceKey = 0;
		let documentService = new DocumentService();
		let userSection = SectionDisplay.List;
		let documents = [];
		let selectedDoc;

		onMount(async () => {
			getDocuments();
			getDocPermissions();
		});

		afterUpdate(() => {
			try {
				console.log(`getDocuments moduleKey: ${moduleKey}, assetTemplateKey: ${assetTemplateKey}, 
						immediateOwnerSourceKey: ${immediateOwnerSourceKey}, immediateOwnerTypeKey: ${immediateOwnerTypeKey}, 
						compositeOwnerSourceKey: ${compositeOwnerSourceKey}, compositeOwnerTypeKey: ${compositeOwnerTypeKey}`);

				setPageTitle();
				if (!moduleKey || moduleKey <= 0) return;
				if (!assetTemplateKey || assetTemplateKey <= 0) return;
				if (assetTemplateKey == oldAssetTemplateKey && immediateOwnerSourceKey == oldImmediateOwnerSourceKey) return;
				oldAssetTemplateKey = assetTemplateKey;
				oldImmediateOwnerSourceKey = immediateOwnerSourceKey;
				getDocPermissions();
				getDocuments();
				$$invalidate(8, userSection = SectionDisplay.List);
			} catch(error) {
				console.error('Error in document', error);
			}
		});

		function getDocPermissions() {
			documentService.getDocPermissions(moduleKey, assetTemplateKey, immediateOwnerSourceKey).then(result => {
				$$invalidate(7, hasCreatePermission = result?.create ?? false);
			}).catch(error => {
				console.error('Error in getDocPermissions', error);
			});
		}

		function getDocuments() {
			if (!moduleKey || moduleKey <= 0) return;
			if (!assetTemplateKey || assetTemplateKey <= 0) return;

			documentService.getDocuments(moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey).then(result => {
				$$invalidate(9, documents = result);

				documents.forEach(item => {
					item.moduleKey = moduleKey;
					item.assetTemplateKey = assetTemplateKey;
				});
			}).catch(error => {
				console.error('Error in getDocuments', error);
			});
		}

		function addDocsClicked(e) {
			$$invalidate(8, userSection = SectionDisplay.Add);
			setPageTitle();
		}

		function addDocsCloseClicked(e) {
			$$invalidate(8, userSection = SectionDisplay.List);
			setPageTitle();
			getDocuments();
		}

		function previewClicked(e) {
			console.log('preview button clicked.', e);

			if (e != null && e.detail != null) {
				$$invalidate(10, selectedDoc = e.detail);
				$$invalidate(8, userSection = SectionDisplay.Preview);
				setPageTitle();
			}
		}

		function confirmDeleteClicked(e) {
			console.log('preview button clicked.');
			console.log(e);

			if (e != null && e.detail != null) {
				$$invalidate(10, selectedDoc = e.detail);

				let data = {
					moduleKey: selectedDoc.moduleKey,
					detailKey: selectedDoc.documentImmediateOwnerSourceKey,
					assetTemplateKey: selectedDoc.assetTemplateKey,
					immediateOwnerSourceKey: selectedDoc.documentImmediateOwnerSourceKey,
					immediateOwnerTypeKey: selectedDoc.documentImmediateOwnerTypeKey,
					compositeOwnerTypeKey: selectedDoc.documentCompositeOwnerTypeKey,
					documents: [
						{
							documentKey: selectedDoc.docKey,
							docTypeKey: selectedDoc.docTypeKey
						}
					],
					itemContextKey: 0
				};

				documentService.deleteDocument(data).then(result => {
					if (result) {
						console.log('Document record has been deleted successfully!!!');
						getDocuments();
					}
				});
			}
		}

		function setPageTitle() {
			if (userSection == SectionDisplay.Add) ; else if (userSection == SectionDisplay.Preview) ; else ;
		}

		const closeClick_handler = e => addDocsCloseClicked();
		const closeClick_handler_1 = e => addDocsCloseClicked();
		const click_handler = e => addDocsClicked();
		const previewClick_handler = e => previewClicked(e);
		const confirmDeleteClick_handler = e => confirmDeleteClicked(e);

		$$self.$$set = $$props => {
			if ('display' in $$props) $$invalidate(0, display = $$props.display);
			if ('moduleKey' in $$props) $$invalidate(1, moduleKey = $$props.moduleKey);
			if ('assetTemplateKey' in $$props) $$invalidate(2, assetTemplateKey = $$props.assetTemplateKey);
			if ('immediateOwnerSourceKey' in $$props) $$invalidate(3, immediateOwnerSourceKey = $$props.immediateOwnerSourceKey);
			if ('immediateOwnerTypeKey' in $$props) $$invalidate(4, immediateOwnerTypeKey = $$props.immediateOwnerTypeKey);
			if ('compositeOwnerSourceKey' in $$props) $$invalidate(5, compositeOwnerSourceKey = $$props.compositeOwnerSourceKey);
			if ('compositeOwnerTypeKey' in $$props) $$invalidate(6, compositeOwnerTypeKey = $$props.compositeOwnerTypeKey);
			if ('title' in $$props) $$invalidate(15, title = $$props.title);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*display*/ 1) {
				console.log('document display', display);
			}
		};

		return [
			display,
			moduleKey,
			assetTemplateKey,
			immediateOwnerSourceKey,
			immediateOwnerTypeKey,
			compositeOwnerSourceKey,
			compositeOwnerTypeKey,
			hasCreatePermission,
			userSection,
			documents,
			selectedDoc,
			addDocsClicked,
			addDocsCloseClicked,
			previewClicked,
			confirmDeleteClicked,
			title,
			closeClick_handler,
			closeClick_handler_1,
			click_handler,
			previewClick_handler,
			confirmDeleteClick_handler
		];
	}

	class Document_container_component extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$3,
				create_fragment$3,
				safe_not_equal,
				{
					display: 0,
					moduleKey: 1,
					assetTemplateKey: 2,
					immediateOwnerSourceKey: 3,
					immediateOwnerTypeKey: 4,
					compositeOwnerSourceKey: 5,
					compositeOwnerTypeKey: 6,
					title: 15
				},
				add_css$3
			);
		}

		get display() {
			return this.$$.ctx[0];
		}

		set display(display) {
			this.$$set({ display });
			flush();
		}

		get moduleKey() {
			return this.$$.ctx[1];
		}

		set moduleKey(moduleKey) {
			this.$$set({ moduleKey });
			flush();
		}

		get assetTemplateKey() {
			return this.$$.ctx[2];
		}

		set assetTemplateKey(assetTemplateKey) {
			this.$$set({ assetTemplateKey });
			flush();
		}

		get immediateOwnerSourceKey() {
			return this.$$.ctx[3];
		}

		set immediateOwnerSourceKey(immediateOwnerSourceKey) {
			this.$$set({ immediateOwnerSourceKey });
			flush();
		}

		get immediateOwnerTypeKey() {
			return this.$$.ctx[4];
		}

		set immediateOwnerTypeKey(immediateOwnerTypeKey) {
			this.$$set({ immediateOwnerTypeKey });
			flush();
		}

		get compositeOwnerSourceKey() {
			return this.$$.ctx[5];
		}

		set compositeOwnerSourceKey(compositeOwnerSourceKey) {
			this.$$set({ compositeOwnerSourceKey });
			flush();
		}

		get compositeOwnerTypeKey() {
			return this.$$.ctx[6];
		}

		set compositeOwnerTypeKey(compositeOwnerTypeKey) {
			this.$$set({ compositeOwnerTypeKey });
			flush();
		}

		get title() {
			return this.$$.ctx[15];
		}

		set title(title) {
			this.$$set({ title });
			flush();
		}
	}

	customElements.define("eas-document-swc", create_custom_element(Document_container_component, {"display":{"type":"Boolean"},"moduleKey":{},"assetTemplateKey":{},"immediateOwnerSourceKey":{},"immediateOwnerTypeKey":{},"compositeOwnerSourceKey":{},"compositeOwnerTypeKey":{},"title":{}}, [], [], true));

	/* src\lib\documents\list\document-list.component.svelte generated by Svelte v4.2.19 */

	function add_css$2(target) {
		append_styles(target, "svelte-zqhbdh", ":root{--gray-800:#2c2c2c;--gray-700:#434343;--gray-600:#8C8C8C;--gray-500:#BFBFBF;--gray-400:#D9D9D9;--gray-300:#E8E8E8;--gray-250:#F0F0F0;--gray-200:#F2F2F2;--gray-100:#F6F6F6;--gray-50:#F7F7F7;--maroon-800:#700017;--maroon-700:#8B3043;--maroon-600:#99495A;--maroon-500:#AA6D7E;--maroon-400:#BF95A5;--maroon-300:#E9D9DC;--maroon-200:#F5EEEE;--maroon-100:#FAF6F6;--maroon-lte-100:#faf6f6;--maroon-lte-200:#f5eeee;--red-800:#EA1014;--red-700:#F1353A;--red-600:#F4595C;--red-500:#F57174;--red-400:#F7888B;--red-300:#F9ACAE;--red-200:#FBC4C5;--red-100:#FDE7E7;--red-50:#faf6f6;--blue-800:#3d7aa9;--blue-700:#4781ad;--blue-600:#5f91b7;--blue-500:#749fc1;--blue-400:#9ebcd4;--blue-300:#c4d7e5;--blue-200:#e2ebf2;--blue-100:#f4f7fa;--blue-lte-100:#eff0f5;--lte-blue-800:#73A5CC;--lte-blue-700:#88B2D4;--lte-blue-600:#A4C4DE;--lte-blue-500:#C0D6E8;--lte-blue-400:#CEE0ED;--lte-blue-300:#DCE8F2;--lte-blue-200:#EAF2F7;--lte-blue-100:#F4F8FB;--gold-800:#ffbe0e;--gold-700:#ffce4a;--gold-600:#fad87b;--gold-500:#f8de9b;--gold-400:#f6e2b2;--gold-300:#f4e7ca;--gold-200:#f2ebdd;--gold-100:#f3f1ed;--drk-green-800:#5E8000;--drk-green-700:#6E8C19;--drk-green-600:#7E9933;--drk-green-500:#8EA64C;--drk-green-400:#AEBF7F;--drk-green-300:#C7D3A6;--drk-green-200:#DFE6CC;--drk-green-100:#EFF2E5;--green-800:#B5DC10;--green-700:#BCDF27;--green-600:#C4E340;--green-500:#CBE657;--green-400:#DAED87;--green-300:#E5F3AC;--green-200:#F0F8CF;--green-100:#F7FBE7;--ohid-blue-100:#EBF7FF;--ohid-blue-200:#D9EFFF;--ohid-blue-300:#BFE5FF;--ohid-blue-400:#A6DAFF;--ohid-blue-500:#8CD0FF;--ohid-blue-600:#59BBFF;--ohid-blue-700:#26A6FF;--ohid-blue-800:#0096FF;--ohid-drk-blue-100:#ECF0F4;--ohid-drk-blue-200:#DAE3E9;--ohid-drk-blue-300:#C2D0DB;--ohid-drk-blue-400:#A9BDCC;--ohid-drk-blue-500:#91AABE;--ohid-drk-blue-600:#6084A1;--ohid-drk-blue-700:#2F5E84;--ohid-drk-blue-800:#0A426E;--iop-lt-blue-800:#40b0ff;--iop-blue-800:#0096ff;--iop-drk-blue-800:#004393;--lte:300;--reg:400;--semi:600;--bold:700}div.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:block}.card.fluid.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{max-width:100%!important}.card.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:flex;flex:1 1 20%;flex-direction:column;min-width:150px;max-width:340px;width:100%;margin:0!important;text-decoration:none;border:0 solid transparent;border-radius:0;background:white;overflow:hidden;outline:3px solid transparent;transition:all .22s ease-in-out}div.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{background:transparent;transition:all .2s ease-in-out}.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh,.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:after,.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:before{box-sizing:border-box;padding:0;margin:0}.inline-text-field-container.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:flex;flex-direction:column}button.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{position:relative;display:flex;align-items:center;justify-content:center;height:44px;width:max-content;padding:0 20px;border:0;font-size:16px;cursor:pointer;background:transparent;transition:all .2s ease-in-out!important}button.svelte-zqhbdh .btn-txt.svelte-zqhbdh.svelte-zqhbdh{transition:all .2s ease-in-out!important}.ds-text-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{z-index:0}.ds-text-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:inline-flex;position:relative;height:56px;width:100%;border-radius:4px 4px 0 0;margin-bottom:35px;box-sizing:border-box;overflow:hidden;background:white;overflow:visible}.ds-text-field.svelte-zqhbdh:not(.ds-text-field--disabled) .ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh{border-bottom-color:rgba(0,0,0,.42)}.ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{align-self:flex-end;width:inherit;height:100%;padding:20px 20px 0px;font-size:1rem;text-decoration:inherit;text-transform:inherit;border-radius:4px 4px 0 0;border:none;border-bottom:1px solid;box-sizing:border-box;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);background:none;appearance:none}.ds-text-field__input.svelte-zqhbdh~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:0;top:50%;width:inherit;padding:0 20px;transform:translateY(-50%);pointer-events:none;color:var(--gray-800)}.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{text-decoration:inherit;text-transform:inherit;position:absolute;transform-origin:left top;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);line-height:1.15rem;text-align:left;font-size:1rem;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;padding-right:16px}label.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{cursor:default}.field-line-ripple.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{position:absolute;bottom:0;left:0;width:100%;height:2px;transform:scaleX(0);transition:all 260ms cubic-bezier(0.4, 0, 0.2, 1);background:transparent;opacity:0;z-index:2}.blue.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{background:var(--blue-800)!important}.ds-text-field.svelte-zqhbdh .help.svelte-zqhbdh.svelte-zqhbdh{position:absolute;bottom:-13px;left:15px;height:10px;width:100%;padding:0 0 0 10px;font-size:15px;color:var(--gray-800)}.ds-text-field.svelte-zqhbdh .help.svelte-zqhbdh.svelte-zqhbdh::after{content:'';position:absolute;left:0;top:8px;width:4px;height:4px;border-radius:50%;background:var(--gray-800)}.ds-text-field.svelte-zqhbdh>span.error.svelte-zqhbdh.svelte-zqhbdh{display:none}.ds-text-field.svelte-zqhbdh .error.svelte-zqhbdh.svelte-zqhbdh{position:absolute;bottom:-13px;left:15px;height:10px;width:calc(100% - 15px);padding:0 0 0 10px;font-size:15px;color:var(--red-800);transition:all .2s ease-in-out}.display-none.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:none !important}.ds-text-field.svelte-zqhbdh .error.svelte-zqhbdh.svelte-zqhbdh::before{content:'';font-family:\"Font Awesome 5 Pro\";position:absolute;bottom:22px;right:15px;height:30px;width:30px;padding:0 0 0 10px;font-size:22px;font-weight:800;color:var(--red-800);z-index:100;pointer-events:none}.ds-text-field.svelte-zqhbdh .error.svelte-zqhbdh.svelte-zqhbdh::after{content:'';position:absolute;left:0;top:8px;width:4px;height:4px;border-radius:50%;background:var(--red-800)}table.table-ode.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{border:1px solid #D8D8D8;width:100%;text-align:left;border-collapse:collapse}table.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:table;border-collapse:separate;box-sizing:border-box;text-indent:initial;border-spacing:2px;border-color:gray}table.table-ode.svelte-zqhbdh thead.svelte-zqhbdh.svelte-zqhbdh{background:#F2F2F2;border-bottom:1px solid #D8D8D8}thead.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:table-header-group;vertical-align:middle;border-color:inherit}table.table-ode.svelte-zqhbdh thead th.svelte-zqhbdh.svelte-zqhbdh:first-child{border-left:none}table.table-ode.svelte-zqhbdh thead th.svelte-zqhbdh.svelte-zqhbdh{font-size:15px;font-weight:bold;color:#000000;text-align:left;border-left:1px solid #D8D8D8}table.table-ode.svelte-zqhbdh td.svelte-zqhbdh.svelte-zqhbdh,table.table-ode.svelte-zqhbdh th.svelte-zqhbdh.svelte-zqhbdh{border:1px solid #D8D8D8;padding:8px}th.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:table-cell;vertical-align:inherit;font-weight:bold;text-align:-internal-center}tbody.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:table-row-group;vertical-align:middle;border-color:inherit}tr.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:table-row;vertical-align:inherit;border-color:inherit}table.table-ode.svelte-zqhbdh tbody td.svelte-zqhbdh.svelte-zqhbdh{font-size:15px;color:#000000}table.table-ode.svelte-zqhbdh td.svelte-zqhbdh.svelte-zqhbdh,table.table-ode.svelte-zqhbdh th.svelte-zqhbdh.svelte-zqhbdh{border:1px solid #D8D8D8;padding:8px}td.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:table-cell;vertical-align:inherit}.form_text_wrap.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:flex;flex-direction:row;flex-wrap:wrap}div.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{background:transparent;transition:all .2s ease-in-out}table.table-ode.svelte-zqhbdh tbody td.svelte-zqhbdh.svelte-zqhbdh{font-size:15px;color:#000000}.form_text.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{flex:1 0 auto;font-size:10px;word-wrap:break-word;width:100%;max-width:200px}table.table-ode.svelte-zqhbdh tbody td.svelte-zqhbdh.svelte-zqhbdh{font-size:15px;color:#000000}a.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{text-decoration:none;color:var(--blue-800);font-weight:bold}table.table-ode.svelte-zqhbdh td.svelte-zqhbdh.svelte-zqhbdh,table.table-ode.svelte-zqhbdh th.svelte-zqhbdh.svelte-zqhbdh{border:1px solid #D8D8D8;padding:8px}td.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:table-cell;vertical-align:inherit}button.border-red.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{border-color:var(--red-800)}button.secondary.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{border:2px;border-style:solid;background:transparent}button.disabled.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{position:relative;pointer-events:none;background:var(--gray-400)!important;border-color:var(--gray-500)!important;z-index:0}.rounded-full.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{border-radius:100px !important}button.flex-row-reverse.svelte-zqhbdh .icon.trash.svelte-zqhbdh.svelte-zqhbdh{padding:5px;margin:0 0 0 0 !important}button.flex-row-reverse.svelte-zqhbdh .icon.svelte-zqhbdh.svelte-zqhbdh{padding:0 10px 0 0;margin:0 0 0 -4px!important}button.svelte-zqhbdh .icon.svelte-zqhbdh.svelte-zqhbdh{position:relative;padding-left:10px;display:flex;align-items:center}button.svelte-zqhbdh .icon.svelte-zqhbdh.svelte-zqhbdh{transition:all .05s ease-in-out!important}.icon-red.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{fill:var(--red-800)!important;color:var(--red-800)!important}.icon.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh,.icon.svelte-zqhbdh>i.svelte-zqhbdh.svelte-zqhbdh{transition:all .2s ease-in-out}button.disabled.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{position:relative;pointer-events:none;background:var(--gray-400)!important;border-color:var(--gray-500)!important;z-index:0}.fas.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{font-family:\"Font Awesome 6 Pro\";font-weight:900}.fas.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:var(--fa-display,inline-block);font-style:normal;font-variant:normal;line-height:1;text-rendering:auto}.fas.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{font-weight:900}.fas.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{font-family:\"Font Awesome 5 Free\"}.fas.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1}i.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{font-style:italic}div.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{font-family:'Source Sans Pro', sans-serif}.icon-red.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{fill:var(--red-800)!important;color:var(--red-800)!important}button.disabled.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{position:relative;pointer-events:none;background:var(--gray-400)!important;border-color:var(--gray-500)!important;z-index:0}.fa-trash.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:before{content:\"\\f1f8\"}table.table-ode.svelte-zqhbdh tr.svelte-zqhbdh.svelte-zqhbdh:nth-child(even){background:#F2F2F2}table.table-ode.svelte-zqhbdh tbody td.svelte-zqhbdh.svelte-zqhbdh{font-size:15px;color:#000000}table.table-ode.svelte-zqhbdh td.svelte-zqhbdh.svelte-zqhbdh,table.table-ode.svelte-zqhbdh th.svelte-zqhbdh.svelte-zqhbdh{border:1px solid #D8D8D8;padding:8px}.inset-blur.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{-webkit-box-shadow:inset 0px 3px 2px 0px rgba(0, 0, 0, 0.2);box-shadow:inset 0px 3px 2px 0px rgba(0, 0, 0, 0.2)}.fade.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{-webkit-animation:fadeEffect .4s;animation:fadeEffect .4s}.card.fluid.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{max-width:100%!important}.shadow.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{box-shadow:0px 0 32px -10px rgba(0,0,0, .2) !important}.card__content.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:flex;flex:auto;flex-direction:column;position:relative;padding:20px;color:black;text-decoration:none}.width-full.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{width:100% !important;max-width:100%!important}.p-5.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{padding:5px!important}.text-center.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{text-align:center}button.border-red.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{border-color:var(--red-800)}.flex-row-reverse.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{flex-direction:row-reverse !important}.display-inline-block.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:inline-block!important}.mr-10.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{margin-right:10px!important}button.svelte-zqhbdh .btn-txt.svelte-zqhbdh.svelte-zqhbdh{transition:all .2s ease-in-out!important}.font-red.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{color:var(--red-800)!important}.display-inline-block.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:inline-block!important}.font-white.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{color:white!important}.gap-10.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{gap:10px}.flex-row.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{flex-direction:row !important}button.disabled.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{position:relative;pointer-events:none;background:var(--gray-400)!important;border-color:var(--gray-500)!important;z-index:0}.black.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{background:#000!important}button.disabled.svelte-zqhbdh>.btn-txt.svelte-zqhbdh.svelte-zqhbdh{color:var(--gray-600)!important}button.svelte-zqhbdh .btn-txt.svelte-zqhbdh.svelte-zqhbdh{display:flex;justify-content:center;min-width:max-content;font-size:16px}button.svelte-zqhbdh .btn-txt.svelte-zqhbdh.svelte-zqhbdh{transition:all .2s ease-in-out!important}.font-white.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{color:white!important}.mt-10.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{margin-top:10px!important}.black.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{background:#000!important}.font-white.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{color:white!important}.select-container.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{position:relative}.border-gray-600.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{border-color:var(--gray-600)!important}.border-bottom.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{border-bottom:1px solid var(--gray-400)}.select-container.chevron.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh::before{top:17px !important}.select-container.chevron.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh::before{content:'\\f078';position:absolute;top:23px;right:20px;font-family:'font awesome 5 pro';font-weight:800;pointer-events:none;z-index:100}button:hover.hover-red.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{background:var(--red-800)!important;color:white!important}:hover.hover-font-white.svelte-zqhbdh>.svelte-zqhbdh.svelte-zqhbdh{color:white!important}.hover-blue-800.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:hover{background:var(--blue-800)!important}.ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{align-self:flex-end;width:inherit;height:100%;padding:20px 20px 0px;font-size:1rem;text-decoration:inherit;text-transform:inherit;border-radius:4px 4px 0 0;border:none;border-bottom:1px solid;box-sizing:border-box;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);background:none;appearance:none}.ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:focus{outline:none;background:#dcdcdc}.ds-text-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:hover{background:#ebebeb;transition:all 100ms ease-in-out}.ds-text-field__input.svelte-zqhbdh~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:0;top:50%;width:inherit;padding:0 20px;transform:translateY(-50%);pointer-events:none;color:var(--gray-800)}.ds-text-field__input.svelte-zqhbdh:focus~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh,.ds-text-field__input.svelte-zqhbdh:valid~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:0;top:30%;font-size:.875rem;transform:translateY(-50%);pointer-events:none;color:var(--gray-700)}.hover-gray-300.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:hover{background:var(--gray-300)!important}.ds-text-field__input.svelte-zqhbdh:focus~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:initial;top:30%;font-size:.875rem;transform:translateY(-50%);pointer-events:none;color:var(--gray-700)}.rounded-4.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{border-radius:4px !important}.ds-select-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:inline-flex;position:relative;height:56px;width:100%;font-size:16px;color:black;border-radius:4px 4px 0 0;padding:20px 20px 0 20px;margin-bottom:35px;margin:0;border:0;outline:none;cursor:pointer;box-sizing:border-box;overflow:hidden;background:white;transition:all .2s ease-in-out}select:focus.ds-select-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{background:#dfdfdf}select:focus.ds-select-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:hover{background:#dfdfdf}.select-container.chevron.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh::before{content:'\\f078';position:absolute;top:23px;right:20px;font-family:'font awesome 5 pro';font-weight:800;pointer-events:none;z-index:100}.select-container.chevron.svelte-zqhbdh::before>select.svelte-zqhbdh.svelte-zqhbdh:active{content:'\\f078';position:absolute;top:18px;right:20px;font-family:'font awesome 5 pro';transform:rotate(180deg);pointer-events:none}.ds-text-field__input.svelte-zqhbdh~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:0;top:50%;width:inherit;padding:0 20px;transform:translateY(-50%);pointer-events:none;color:var(--gray-800)}.ds-text-field__input.svelte-zqhbdh:focus~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh,.ds-text-field__input.svelte-zqhbdh:valid~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:0;top:30%;font-size:.875rem;transform:translateY(-50%);pointer-events:none;color:var(--gray-700)}.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{text-decoration:inherit;text-transform:inherit;position:absolute;transform-origin:left top;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);line-height:1.15rem;text-align:left;font-size:1rem;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;padding-right:16px}.ds-text-field__input.svelte-zqhbdh:focus~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:initial;top:30%;font-size:.875rem;transform:translateY(-50%);pointer-events:none;color:var(--gray-700)}select.svelte-zqhbdh:invalid~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:initial;top:50%;width:100%;padding:0 20px;font-size:1em;transform:translateY(-50%);pointer-events:none;color:var(--gray-700)}select.svelte-zqhbdh:valid~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:initial;top:30%;width:100%;padding:0 20px;font-size:.875rem;transform:translateY(-30%);pointer-events:none;color:var(--gray-700)}select.svelte-zqhbdh:focus~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:initial;top:30%;width:100%;padding:0 20px;font-size:.875rem;transform:translateY(-30%);pointer-events:none;color:var(--gray-700)}.ds-text-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:inline-flex;position:relative;height:56px;width:100%;border-radius:4px 4px 0 0;margin-bottom:35px;box-sizing:border-box;overflow:hidden;background:white;overflow:visible}.ds-text-field.svelte-zqhbdh .help.svelte-zqhbdh.svelte-zqhbdh{position:absolute;bottom:-13px;left:15px;height:10px;width:100%;padding:0 0 0 10px;font-size:15px;color:var(--gray-800)}.ds-text-field.svelte-zqhbdh .error.svelte-zqhbdh.svelte-zqhbdh{position:absolute;bottom:-13px;left:15px;height:10px;width:calc(100% - 15px);padding:0 0 0 10px;font-size:15px;color:var(--red-800);transition:all .2s ease-in-out}.ds-text-field.svelte-zqhbdh .help.svelte-zqhbdh.svelte-zqhbdh::after{content:'';position:absolute;left:0;top:8px;width:4px;height:4px;border-radius:50%;background:var(--gray-800)}.ds-text-field.svelte-zqhbdh .error.svelte-zqhbdh.svelte-zqhbdh::after{content:'';position:absolute;left:0;top:8px;width:4px;height:4px;border-radius:50%;background:var(--red-800)}.ds-text-field.svelte-zqhbdh .error.svelte-zqhbdh.svelte-zqhbdh::before{content:'';font-family:\"Font Awesome 5 Pro\";position:absolute;bottom:22px;right:15px;height:30px;width:30px;padding:0 0 0 10px;font-size:22px;font-weight:800;color:var(--red-800);z-index:100;pointer-events:none}.ds-text-field.svelte-zqhbdh>span.error.svelte-zqhbdh.svelte-zqhbdh{display:none}.ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{align-self:flex-end;width:inherit;height:100%;padding:20px 20px 0px;font-size:1rem;text-decoration:inherit;text-transform:inherit;border-radius:4px 4px 0 0;border:none;border-bottom:1px solid;box-sizing:border-box;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);background:none;appearance:none}.ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:focus{outline:none;background:#dcdcdc}.ds-text-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh:hover{background:#ebebeb;transition:all 100ms ease-in-out}.ds-text-field.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{z-index:0}.ds-text-field__input.svelte-zqhbdh~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:0;top:50%;width:inherit;padding:0 20px;transform:translateY(-50%);pointer-events:none;color:var(--gray-800)}.ds-text-field__input.svelte-zqhbdh:focus~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh,.ds-text-field__input.svelte-zqhbdh:valid~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:0;top:30%;font-size:.875rem;transform:translateY(-50%);pointer-events:none;color:var(--gray-700)}.ds-text-field__input.svelte-zqhbdh:focus~.ds-floating-label.svelte-zqhbdh.svelte-zqhbdh{left:0;right:initial;top:30%;font-size:.875rem;transform:translateY(-50%);pointer-events:none;color:var(--gray-700)}.ds-text-field.svelte-zqhbdh:not(.ds-text-field--disabled) .ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh:focus{border-bottom-color:rgba(0,0,0,.87)}.ds-text-field.svelte-zqhbdh:not(.ds-text-field--disabled) .ds-text-field__input.svelte-zqhbdh:focus~.field-line-ripple.svelte-zqhbdh{opacity:1;transform:scaleX(1)}.ds-text-field.svelte-zqhbdh:not(.ds-text-field--disabled) .ds-text-field__input.svelte-zqhbdh:focus~.field-line-ripple.blue.svelte-zqhbdh{opacity:1;transform:scaleX(1)}.ds-text-field.svelte-zqhbdh:not(.ds-text-field--disabled) .ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh{border-bottom-color:rgba(0,0,0,.42)}.ds-text-field.svelte-zqhbdh:hover:not(.ds-text-field--disabled) .ds-text-field__input.svelte-zqhbdh.svelte-zqhbdh{border-bottom-color:rgba(0,0,0,.87)}.select-container.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{position:relative}.select-container.chevron.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh::before{content:'\\f078';position:absolute;top:23px;right:20px;font-family:'font awesome 5 pro';font-weight:800;pointer-events:none;z-index:100}.select-container.chevron.svelte-zqhbdh::before>select.svelte-zqhbdh.svelte-zqhbdh:active{content:'\\f078';position:absolute;top:18px;right:20px;font-family:'font awesome 5 pro';transform:rotate(180deg);pointer-events:none}select.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{appearance:none;-webkit-appearence:none;-moz-appearance:none}.form_text.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{flex:1 0 auto;font-size:10px;word-wrap:break-word;width:100%;max-width:200px}.form_text_wrap.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh{display:flex;flex-direction:row;flex-wrap:wrap}.select-container.chevron.svelte-zqhbdh.svelte-zqhbdh.svelte-zqhbdh::before{top:17px !important}");
	}

	function get_each_context(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[28] = list[i];
		child_ctx[30] = i;
		return child_ctx;
	}

	function get_each_context_1(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[31] = list[i];
		return child_ctx;
	}

	// (107:12) {#if isDeletePermission}
	function create_if_block_2$1(ctx) {
		let th;

		return {
			c() {
				th = element("th");
				th.textContent = "Delete";
				set_style(th, "font-size", "10px");
				set_style(th, "width", "10%");
				attr(th, "class", "svelte-zqhbdh");
			},
			m(target, anchor) {
				insert(target, th, anchor);
			},
			d(detaching) {
				if (detaching) {
					detach(th);
				}
			}
		};
	}

	// (128:8) {#if isDeletePermission}
	function create_if_block_1$1(ctx) {
		let td;
		let button;
		let mounted;
		let dispose;

		function click_handler_1(...args) {
			return /*click_handler_1*/ ctx[18](/*document*/ ctx[31], ...args);
		}

		return {
			c() {
				td = element("td");
				button = element("button");
				button.innerHTML = `<div class="icon trash icon-red svelte-zqhbdh" style="font-size:12px;"><i aria-hidden="true" class="fas fa-trash svelte-zqhbdh"></i></div>`;
				attr(button, "id", "");
				attr(button, "title", "Delete");
				attr(button, "class", "secondary border-red rounded-full hover-red hover-font-white flex-row-reverse svelte-zqhbdh");
				set_style(button, "padding", "0 8px");
				set_style(button, "height", "30px");
				set_style(button, "width", "30px");
				set_style(td, "text-align", "center");
				attr(td, "class", "svelte-zqhbdh");
			},
			m(target, anchor) {
				insert(target, td, anchor);
				append(td, button);

				if (!mounted) {
					dispose = listen(button, "click", click_handler_1);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
			},
			d(detaching) {
				if (detaching) {
					detach(td);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (141:8) {#if expandDelete && document.isDeleteOpen}
	function create_if_block$1(ctx) {
		let tr;
		let td;
		let div4;
		let div3;
		let div2;
		let span0;
		let t1;
		let br;
		let t2;
		let span1;
		let button0;
		let t4;
		let button1;
		let t6;
		let mounted;
		let dispose;

		function click_handler_3(...args) {
			return /*click_handler_3*/ ctx[20](/*document*/ ctx[31], ...args);
		}

		return {
			c() {
				tr = element("tr");
				td = element("td");
				div4 = element("div");
				div3 = element("div");
				div2 = element("div");
				span0 = element("span");

				span0.innerHTML = `<i class="fas fa-trash svelte-zqhbdh" aria-hidden="true"></i> 
                        Confirm to delete this item?`;

				t1 = space();
				br = element("br");
				t2 = space();
				span1 = element("span");
				button0 = element("button");
				button0.innerHTML = `<div class="btn-txt font-red  svelte-zqhbdh" style="font-size:10px;margin:auto auto; ">No Cancel</div>`;
				t4 = space();
				button1 = element("button");
				button1.innerHTML = `<div class="btn-txt font-white svelte-zqhbdh" style="font-size:10px;margin:auto auto;">Yes Delete</div>`;
				t6 = space();
				attr(span0, "class", "delete-text svelte-zqhbdh");
				set_style(span0, "font-size", "10px");
				attr(br, "class", "svelte-zqhbdh");
				attr(button0, "id", "btnCancel");
				attr(button0, "class", "mr-10 display-inline-block secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mt-10 svelte-zqhbdh");
				set_style(button0, "width", "85px");
				set_style(button0, "height", "35px");
				attr(button1, "id", "btnConfirm");
				attr(button1, "class", "display-inline-block rounded-full hover-blue-800 black mt-10 svelte-zqhbdh");
				set_style(button1, "width", "85px");
				set_style(button1, "height", "35px");
				attr(span1, "class", "svelte-zqhbdh");
				attr(div2, "class", "width-full p-5 text-center gap-10 svelte-zqhbdh");
				attr(div3, "class", "card__content svelte-zqhbdh");
				set_style(div3, "padding", "5px");
				attr(div4, "class", "card fluid shadow svelte-zqhbdh");
				attr(td, "colspan", "5");
				attr(td, "class", "inset-blur fade svelte-zqhbdh");
				attr(tr, "class", "delete-confirm-block svelte-zqhbdh");
				set_style(tr, "background-color", "rgba(0, 0, 0, .100)");
			},
			m(target, anchor) {
				insert(target, tr, anchor);
				append(tr, td);
				append(td, div4);
				append(div4, div3);
				append(div3, div2);
				append(div2, span0);
				append(div2, t1);
				append(div2, br);
				append(div2, t2);
				append(div2, span1);
				append(span1, button0);
				append(span1, t4);
				append(span1, button1);
				append(tr, t6);

				if (!mounted) {
					dispose = [
						listen(button0, "click", /*click_handler_2*/ ctx[19]),
						listen(button1, "click", click_handler_3)
					];

					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
			},
			d(detaching) {
				if (detaching) {
					detach(tr);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (113:8) {#each filteredDocs as document (document.docKey)}
	function create_each_block_1(key_1, ctx) {
		let tr;
		let td;
		let div4;
		let div0;
		let a;
		let t0_value = /*document*/ ctx[31].docFileName + "";
		let t0;
		let a_title_value;
		let t1;
		let div1;
		let t2;
		let t3_value = /*document*/ ctx[31].docTypeName + "";
		let t3;
		let t4;
		let div2;
		let t5;
		let t6_value = /*document*/ ctx[31].docUploadDate + "";
		let t6;
		let t7;
		let div3;
		let t8;
		let t9_value = /*document*/ ctx[31].description + "";
		let t9;
		let t10;
		let t11;
		let if_block1_anchor;
		let mounted;
		let dispose;

		function click_handler(...args) {
			return /*click_handler*/ ctx[17](/*document*/ ctx[31], ...args);
		}

		let if_block0 = /*isDeletePermission*/ ctx[5] && create_if_block_1$1(ctx);
		let if_block1 = /*expandDelete*/ ctx[0] && /*document*/ ctx[31].isDeleteOpen && create_if_block$1(ctx);

		return {
			key: key_1,
			first: null,
			c() {
				tr = element("tr");
				td = element("td");
				div4 = element("div");
				div0 = element("div");
				a = element("a");
				t0 = text(t0_value);
				t1 = space();
				div1 = element("div");
				t2 = text("Doc Type: ");
				t3 = text(t3_value);
				t4 = space();
				div2 = element("div");
				t5 = text("Date: ");
				t6 = text(t6_value);
				t7 = space();
				div3 = element("div");
				t8 = text("Location: ");
				t9 = text(t9_value);
				t10 = space();
				if (if_block0) if_block0.c();
				t11 = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty();
				attr(a, "title", a_title_value = /*document*/ ctx[31].description);
				attr(a, "href", "javascript:void(0)");
				attr(a, "class", "svelte-zqhbdh");
				attr(div0, "class", "form_text svelte-zqhbdh");
				attr(div1, "class", "form_text svelte-zqhbdh");
				attr(div2, "class", "form_text svelte-zqhbdh");
				attr(div3, "class", "form_text svelte-zqhbdh");
				attr(div4, "class", "form_text_wrap svelte-zqhbdh");
				attr(td, "class", "svelte-zqhbdh");
				set_style(tr, "background-color", "rgba(0, 0, 0, .100)");
				attr(tr, "class", "svelte-zqhbdh");
				this.first = tr;
			},
			m(target, anchor) {
				insert(target, tr, anchor);
				append(tr, td);
				append(td, div4);
				append(div4, div0);
				append(div0, a);
				append(a, t0);
				append(div4, t1);
				append(div4, div1);
				append(div1, t2);
				append(div1, t3);
				append(div4, t4);
				append(div4, div2);
				append(div2, t5);
				append(div2, t6);
				append(div4, t7);
				append(div4, div3);
				append(div3, t8);
				append(div3, t9);
				append(tr, t10);
				if (if_block0) if_block0.m(tr, null);
				insert(target, t11, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);

				if (!mounted) {
					dispose = listen(a, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty[0] & /*filteredDocs*/ 4 && t0_value !== (t0_value = /*document*/ ctx[31].docFileName + "")) set_data(t0, t0_value);

				if (dirty[0] & /*filteredDocs*/ 4 && a_title_value !== (a_title_value = /*document*/ ctx[31].description)) {
					attr(a, "title", a_title_value);
				}

				if (dirty[0] & /*filteredDocs*/ 4 && t3_value !== (t3_value = /*document*/ ctx[31].docTypeName + "")) set_data(t3, t3_value);
				if (dirty[0] & /*filteredDocs*/ 4 && t6_value !== (t6_value = /*document*/ ctx[31].docUploadDate + "")) set_data(t6, t6_value);
				if (dirty[0] & /*filteredDocs*/ 4 && t9_value !== (t9_value = /*document*/ ctx[31].description + "")) set_data(t9, t9_value);

				if (/*isDeletePermission*/ ctx[5]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_1$1(ctx);
						if_block0.c();
						if_block0.m(tr, null);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*expandDelete*/ ctx[0] && /*document*/ ctx[31].isDeleteOpen) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block$1(ctx);
						if_block1.c();
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(tr);
					detach(t11);
					detach(if_block1_anchor);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d(detaching);
				mounted = false;
				dispose();
			}
		};
	}

	// (188:8) {#each Array(pageCount-1) as _, i}
	function create_each_block(ctx) {
		let option;

		return {
			c() {
				option = element("option");
				option.textContent = `${/*i*/ ctx[30] + 2}`;
				option.__value = /*i*/ ctx[30] + 2;
				set_input_value(option, option.__value);
				set_style(option, "font-size", "10px");
				attr(option, "class", "svelte-zqhbdh");
			},
			m(target, anchor) {
				insert(target, option, anchor);
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(option);
				}
			}
		};
	}

	function create_fragment$2(ctx) {
		let div1;
		let input;
		let t0;
		let label0;
		let t2;
		let div0;
		let t3;
		let span0;
		let t4;
		let span1;
		let t5;
		let div6;
		let table;
		let thead;
		let tr;
		let th;
		let t7;
		let t8;
		let tbody;
		let each_blocks_1 = [];
		let each0_lookup = new Map();
		let t9;
		let div5;
		let button0;
		let div2;
		let button0_class_value;
		let t11;
		let button1;
		let div3;
		let button1_class_value;
		let t13;
		let div4;
		let select;
		let option;
		let t15;
		let label1;
		let mounted;
		let dispose;
		let if_block = /*isDeletePermission*/ ctx[5] && create_if_block_2$1();
		let each_value_1 = ensure_array_like(/*filteredDocs*/ ctx[2]);
		const get_key = ctx => /*document*/ ctx[31].docKey;

		for (let i = 0; i < each_value_1.length; i += 1) {
			let child_ctx = get_each_context_1(ctx, each_value_1, i);
			let key = get_key(child_ctx);
			each0_lookup.set(key, each_blocks_1[i] = create_each_block_1(key, child_ctx));
		}

		let each_value = ensure_array_like(Array(/*pageCount*/ ctx[3] - 1));
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
		}

		return {
			c() {
				div1 = element("div");
				input = element("input");
				t0 = space();
				label0 = element("label");
				label0.textContent = "Enter Filter Details:";
				t2 = space();
				div0 = element("div");
				t3 = space();
				span0 = element("span");
				t4 = space();
				span1 = element("span");
				t5 = space();
				div6 = element("div");
				table = element("table");
				thead = element("thead");
				tr = element("tr");
				th = element("th");
				th.textContent = "Doc Name";
				t7 = space();
				if (if_block) if_block.c();
				t8 = space();
				tbody = element("tbody");

				for (let i = 0; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].c();
				}

				t9 = space();
				div5 = element("div");
				button0 = element("button");
				div2 = element("div");
				div2.textContent = "Prev 5 Items";
				t11 = space();
				button1 = element("button");
				div3 = element("div");
				div3.textContent = "Next 5 Items";
				t13 = space();
				div4 = element("div");
				select = element("select");
				option = element("option");
				option.textContent = "1";

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t15 = space();
				label1 = element("label");
				label1.textContent = "Jump to:";
				attr(input, "type", "text");
				attr(input, "name", "filterBox");
				attr(input, "id", "filterBox");
				attr(input, "autocomplete", "off");
				attr(input, "class", "ds-text-field__input svelte-zqhbdh");
				set_style(input, "font-size", "10px");
				attr(label0, "for", "address");
				attr(label0, "class", "ds-floating-label svelte-zqhbdh");
				set_style(label0, "font-size", "10px");
				attr(div0, "class", "field-line-ripple blue svelte-zqhbdh");
				set_style(div0, "font-size", "10px");
				attr(span0, "class", "help display-none svelte-zqhbdh");
				set_style(span0, "font-size", "10px");
				attr(span1, "class", "error display-none svelte-zqhbdh");
				set_style(span1, "font-size", "10px");
				attr(div1, "class", "ds-text-field svelte-zqhbdh");
				set_style(div1, "margin-bottom", "5px");
				set_style(div1, "width", "100%");
				set_style(div1, "height", "35px");
				set_style(div1, "margin-bottom", "10px");
				set_style(th, "font-size", "10px");
				set_style(th, "width", "90%");
				attr(th, "class", "svelte-zqhbdh");
				attr(tr, "class", "svelte-zqhbdh");
				attr(thead, "class", "svelte-zqhbdh");
				attr(tbody, "class", "svelte-zqhbdh");
				attr(table, "class", "table-ode svelte-zqhbdh");
				set_style(table, "min-width", "180px");
				attr(div2, "class", "btn-txt font-white svelte-zqhbdh");
				set_style(div2, "font-size", "10px");
				set_style(div2, "margin", "auto auto");
				attr(button0, "class", button0_class_value = "" + ((/*currentPage*/ ctx[4] == 1 ? 'disabled' : '') + " rounded-full hover-blue-800 black mobile mt-10" + " svelte-zqhbdh"));
				set_style(button0, "width", "75px");
				set_style(button0, "height", "35px");
				attr(div3, "class", "btn-txt font-white svelte-zqhbdh");
				set_style(div3, "font-size", "10px");
				set_style(div3, "margin", "auto auto");

				attr(button1, "class", button1_class_value = "" + ((/*currentPage*/ ctx[4] == /*pageCount*/ ctx[3]
				? 'disabled'
				: '') + " rounded-full hover-blue-800 black mt-10" + " svelte-zqhbdh"));

				set_style(button1, "width", "75px");
				set_style(button1, "height", "35px");
				option.__value = "1";
				set_input_value(option, option.__value);
				option.selected = true;
				set_style(option, "font-size", "10px");
				attr(option, "class", "svelte-zqhbdh");
				attr(select, "id", "paging");
				attr(select, "class", "ds-select-field rounded-4 hover-gray-300 svelte-zqhbdh");
				set_style(select, "height", "35px");
				set_style(select, "font-size", "10px");
				if (/*currentPage*/ ctx[4] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[23].call(select));
				attr(label1, "for", "paging");
				attr(label1, "class", "ds-floating-label svelte-zqhbdh");
				set_style(label1, "font-size", "10px");
				attr(div4, "class", "select-container chevron border-bottom border-gray-600 mt-10 svelte-zqhbdh");
				set_style(div4, "height", "36px");
				set_style(div4, "width", "40%");
				set_style(div4, "font-size", "10px");
				attr(div5, "class", "inline-text-field-container flex-row gap-10 svelte-zqhbdh");
				attr(div6, "class", "document-list-container svelte-zqhbdh");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, input);
				set_input_value(input, /*searchText*/ ctx[1]);
				append(div1, t0);
				append(div1, label0);
				append(div1, t2);
				append(div1, div0);
				append(div1, t3);
				append(div1, span0);
				append(div1, t4);
				append(div1, span1);
				insert(target, t5, anchor);
				insert(target, div6, anchor);
				append(div6, table);
				append(table, thead);
				append(thead, tr);
				append(tr, th);
				append(tr, t7);
				if (if_block) if_block.m(tr, null);
				append(table, t8);
				append(table, tbody);

				for (let i = 0; i < each_blocks_1.length; i += 1) {
					if (each_blocks_1[i]) {
						each_blocks_1[i].m(tbody, null);
					}
				}

				append(div6, t9);
				append(div6, div5);
				append(div5, button0);
				append(button0, div2);
				append(div5, t11);
				append(div5, button1);
				append(button1, div3);
				append(div5, t13);
				append(div5, div4);
				append(div4, select);
				append(select, option);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(select, null);
					}
				}

				select_option(select, /*currentPage*/ ctx[4], true);
				append(div4, t15);
				append(div4, label1);

				if (!mounted) {
					dispose = [
						listen(input, "input", /*input_input_handler*/ ctx[15]),
						listen(input, "keyup", /*keyup_handler*/ ctx[16]),
						listen(button0, "click", /*click_handler_4*/ ctx[21]),
						listen(button1, "click", /*click_handler_5*/ ctx[22]),
						listen(select, "change", /*select_change_handler*/ ctx[23]),
						listen(select, "change", /*change_handler*/ ctx[24])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*searchText*/ 2 && input.value !== /*searchText*/ ctx[1]) {
					set_input_value(input, /*searchText*/ ctx[1]);
				}

				if (/*isDeletePermission*/ ctx[5]) {
					if (if_block) ; else {
						if_block = create_if_block_2$1();
						if_block.c();
						if_block.m(tr, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}

				if (dirty[0] & /*confirmDeleteClicked, filteredDocs, cancelConfirm, expandDelete, deleteClicked, isDeletePermission, previewDoc*/ 1957) {
					each_value_1 = ensure_array_like(/*filteredDocs*/ ctx[2]);
					each_blocks_1 = update_keyed_each(each_blocks_1, dirty, get_key, 1, ctx, each_value_1, each0_lookup, tbody, destroy_block, create_each_block_1, null, get_each_context_1);
				}

				if (dirty[0] & /*currentPage*/ 16 && button0_class_value !== (button0_class_value = "" + ((/*currentPage*/ ctx[4] == 1 ? 'disabled' : '') + " rounded-full hover-blue-800 black mobile mt-10" + " svelte-zqhbdh"))) {
					attr(button0, "class", button0_class_value);
				}

				if (dirty[0] & /*currentPage, pageCount*/ 24 && button1_class_value !== (button1_class_value = "" + ((/*currentPage*/ ctx[4] == /*pageCount*/ ctx[3]
				? 'disabled'
				: '') + " rounded-full hover-blue-800 black mt-10" + " svelte-zqhbdh"))) {
					attr(button1, "class", button1_class_value);
				}

				if (dirty[0] & /*pageCount*/ 8) {
					each_value = ensure_array_like(Array(/*pageCount*/ ctx[3] - 1));
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(select, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}

				if (dirty[0] & /*currentPage*/ 16) {
					select_option(select, /*currentPage*/ ctx[4]);
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(div1);
					detach(t5);
					detach(div6);
				}

				if (if_block) if_block.d();

				for (let i = 0; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d();
				}

				destroy_each(each_blocks, detaching);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	let pageSize = 5;

	function instance$2($$self, $$props, $$invalidate) {
		let { docslist = [] } = $$props;
		let expandDelete = false;
		let searchText = '';
		let filteredDocs = [];
		let pageCount = 1;
		let currentPage = 1;
		let isDeletePermission = false;
		const svelteDispatch = createEventDispatcher();

		afterUpdate(() => {
			if (currentPage == 1) {
				$$invalidate(5, isDeletePermission = docslist.length > 0 && docslist[0].permission.delete);
				calculatePageCounts(getFilterDocs());
				SetPageNumber(1);
			}
		});

		function calculatePageCounts(docList) {
			if (docList.length == 0) return;
			$$invalidate(3, pageCount = Math.ceil(docList.length / pageSize));
		}

		function SetPageNumber(pageNumber) {
			let start = (pageNumber - 1) * pageSize;
			let end = start + pageSize;
			$$invalidate(2, filteredDocs = []);
			let docs = getFilterDocs();
			$$invalidate(2, filteredDocs = docs.slice(start, end));
		}

		function previewDoc(e, doc) {
			e.stopPropagation();
			svelteDispatch("previewClick", doc);
		}

		function deleteClicked(docKey) {
			$$invalidate(0, expandDelete = false);

			docslist.forEach(x => {
				x.isDeleteOpen = x.docKey == docKey;
			});

			$$invalidate(0, expandDelete = true);
		}

		function confirmDeleteClicked(doc) {
			$$invalidate(0, expandDelete = false);
			svelteDispatch("confirmDeleteClick", doc);
			$$invalidate(4, currentPage = 1);
		}

		function cancelConfirm() {
			$$invalidate(0, expandDelete = false);
		}

		function filterDocsEvent() {
			$$invalidate(4, currentPage = 1);
			$$invalidate(2, filteredDocs = getFilterDocs());
			calculatePageCounts(filteredDocs);
			SetPageNumber(currentPage);
		}

		function getFilterDocs() {
			if (searchText == null || searchText.length == 0) return docslist;
			var criteria = searchText.trim().split(' ');

			return docslist.filter(function (item) {
				for (let i = 0; i < criteria.length; i++) {
					if (criteria[i] != null) {
						let criterion = criteria[i].toLowerCase();

						if ((item.docFileName == null || item.docFileName != null && item.docFileName.toLowerCase().indexOf(criterion) == -1) && (item.docTypeName == null || item.docTypeName != null && item.docTypeName.toLowerCase().indexOf(criterion) == -1) && (item.docUploadDate == null || item.docUploadDate != null && item.docUploadDate.toLowerCase().indexOf(criterion) == -1) && (item.status == null || item.status != null && item.status.toLowerCase().indexOf(criterion) == -1) && (item.description == null || item.description != null && item.description.toLowerCase().indexOf(criterion) == -1) && (item.docNote == null || item.docNote != null && item.docNote.toLowerCase().indexOf(criterion) == -1)) {
							return false;
						}
					}
				}

				return true;
			});
		}

		function nextPageClick(e) {
			if (currentPage == pageCount) return;
			$$invalidate(4, currentPage++, currentPage);
			SetPageNumber(currentPage);
		}

		function previousPageClick(e) {
			if (currentPage <= 1) return;
			$$invalidate(4, currentPage--, currentPage);
			SetPageNumber(currentPage);
		}

		function input_input_handler() {
			searchText = this.value;
			$$invalidate(1, searchText);
		}

		const keyup_handler = e => filterDocsEvent();
		const click_handler = (document, e) => previewDoc(e, document);
		const click_handler_1 = (document, e) => deleteClicked(document.docKey);
		const click_handler_2 = e => cancelConfirm();
		const click_handler_3 = (document, e) => confirmDeleteClicked(document);
		const click_handler_4 = e => previousPageClick();
		const click_handler_5 = e => nextPageClick();

		function select_change_handler() {
			currentPage = select_value(this);
			$$invalidate(4, currentPage);
		}

		const change_handler = e => SetPageNumber(currentPage);

		$$self.$$set = $$props => {
			if ('docslist' in $$props) $$invalidate(14, docslist = $$props.docslist);
		};

		return [
			expandDelete,
			searchText,
			filteredDocs,
			pageCount,
			currentPage,
			isDeletePermission,
			SetPageNumber,
			previewDoc,
			deleteClicked,
			confirmDeleteClicked,
			cancelConfirm,
			filterDocsEvent,
			nextPageClick,
			previousPageClick,
			docslist,
			input_input_handler,
			keyup_handler,
			click_handler,
			click_handler_1,
			click_handler_2,
			click_handler_3,
			click_handler_4,
			click_handler_5,
			select_change_handler,
			change_handler
		];
	}

	class Document_list_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$2, create_fragment$2, safe_not_equal, { docslist: 14 }, add_css$2, [-1, -1]);
		}

		get docslist() {
			return this.$$.ctx[14];
		}

		set docslist(docslist) {
			this.$$set({ docslist });
			flush();
		}
	}

	customElements.define("eas-document-list-swc", create_custom_element(Document_list_component, {"docslist":{}}, [], [], true));

	/* src\lib\documents\preview\document-preview.component.svelte generated by Svelte v4.2.19 */

	const { document: document_1 } = globals;

	function add_css$1(target) {
		append_styles(target, "svelte-kvqn59", ".container-application.svelte-kvqn59.svelte-kvqn59{display:flex;flex-direction:column;overflow:hidden;font-family:'Source Sans Pro', sans-serif;margin-left:0px}#pdf_viewer.svelte-kvqn59.svelte-kvqn59{width:100%;height:800px}.content.svelte-kvqn59.svelte-kvqn59{flex-basis:100%;flex-direction:row;display:flex;overflow:hidden;flex-grow:1;margin-top:-15px}.panel.svelte-kvqn59.svelte-kvqn59{overflow-y:auto;overflow-x:hidden;height:100%;flex-grow:1;flex-shrink:6;padding:10px;padding-top:20px}.viewer.svelte-kvqn59.svelte-kvqn59{height:100%;width:auto;display:block}ul.svelte-kvqn59>li.svelte-kvqn59{padding:8px 10px 8px 8px;line-height:24px}.head-container.svelte-kvqn59.svelte-kvqn59{border-bottom:1px solid #707070;margin-bottom:5px}ul.head-list.svelte-kvqn59.svelte-kvqn59{list-style-type:none;margin-left:unset;display:flex;flex-wrap:wrap}ul.head-list.svelte-kvqn59 li a.button-details.svelte-kvqn59{padding:5px 7px;border-radius:50px;border:2px solid #3d7aa9;font-size:16px}ul.head-list.svelte-kvqn59 li a.button-details.svelte-kvqn59:hover{border:2px solid #254b69}ul.head-list.svelte-kvqn59 a.svelte-kvqn59{font-size:23px;color:#3d7aa9;transition:0.2s}a.close.svelte-kvqn59.svelte-kvqn59{border:2px solid #3d7aa9;font-size:23px;border:none}a.close.svelte-kvqn59.svelte-kvqn59:hover,ul.head-list.svelte-kvqn59 a.svelte-kvqn59:hover{color:#254b69}ul.head-list.svelte-kvqn59 li.title.svelte-kvqn59{font-size:15px;font-weight:bold}ul.head-list.svelte-kvqn59 li.svelte-kvqn59:nth-child(2){margin-left:auto}.details.svelte-kvqn59.svelte-kvqn59{margin-top:5px;margin-bottom:5px;padding-left:10px}.right-align.svelte-kvqn59.svelte-kvqn59{text-align:right}button.svelte-kvqn59.svelte-kvqn59{position:relative;display:flex;align-items:center;justify-content:center;height:44px;width:max-content;padding:0 20px;border:0;font-size:16px;cursor:pointer;background:transparent;transition:all 0.2s ease-in-out !important}button.svelte-kvqn59 .btn-txt.svelte-kvqn59{transition:all 0.2s ease-in-out !important}.font-blue.svelte-kvqn59.svelte-kvqn59{color:var(--blue-800) !important}.font-blue.svelte-kvqn59.svelte-kvqn59{color:var(--blue-800) !important}.ds-text-field.svelte-kvqn59.svelte-kvqn59{z-index:0}.ds-text-field.svelte-kvqn59.svelte-kvqn59{display:inline-flex;position:relative;height:56px;width:100%;border-radius:4px 4px 0 0;margin-bottom:35px;box-sizing:border-box;overflow:hidden;background:white;overflow:visible}.ds-text-field.svelte-kvqn59:not(.ds-text-field--disabled) .ds-text-field__input.svelte-kvqn59{border-bottom-color:rgba(0, 0, 0, 0.42)}.ds-text-field__input.svelte-kvqn59.svelte-kvqn59{align-self:flex-end;width:inherit;height:100%;padding:20px 20px 0px;font-size:1rem;text-decoration:inherit;text-transform:inherit;border-radius:4px 4px 0 0;border:none;border-bottom:1px solid;box-sizing:border-box;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);background:none;appearance:none}.ds-text-field__input.svelte-kvqn59~.ds-floating-label.svelte-kvqn59{left:0;right:0;top:10%;width:inherit;padding:0 10px;transform:translateY(-50%);pointer-events:none;color:var(--gray-800)}.ds-floating-label.svelte-kvqn59.svelte-kvqn59{text-decoration:inherit;text-transform:inherit;position:absolute;transform-origin:left top;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);line-height:1.15rem;text-align:left;font-size:1rem;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;padding-right:16px}label.svelte-kvqn59.svelte-kvqn59{cursor:default}.field-line-ripple.svelte-kvqn59.svelte-kvqn59{position:absolute;bottom:0;left:0;width:100%;height:2px;transform:scaleX(0);transition:all 260ms cubic-bezier(0.4, 0, 0.2, 1);background:transparent;opacity:0;z-index:2}.blue.svelte-kvqn59.svelte-kvqn59{background:var(--blue-800) !important}.ds-text-field.svelte-kvqn59 .help.svelte-kvqn59{position:absolute;bottom:-13px;left:15px;height:10px;width:100%;padding:0 0 0 10px;font-size:15px;color:var(--gray-800)}.ds-text-field.svelte-kvqn59 .help.svelte-kvqn59::after{content:'';position:absolute;left:0;top:8px;width:4px;height:4px;border-radius:50%;background:var(--gray-800)}.ds-text-field.svelte-kvqn59>span.error.svelte-kvqn59{display:none}.ds-text-field.svelte-kvqn59 .error.svelte-kvqn59{position:absolute;bottom:-13px;left:15px;height:10px;width:calc(100% - 15px);padding:0 0 0 10px;font-size:15px;color:var(--red-800);transition:all 0.2s ease-in-out}.display-none.svelte-kvqn59.svelte-kvqn59{display:none !important}.ds-text-field.svelte-kvqn59 .error.svelte-kvqn59::before{content:'';font-family:'Font Awesome 5 Pro';position:absolute;bottom:22px;right:15px;height:30px;width:30px;padding:0 0 0 10px;font-size:22px;font-weight:800;color:var(--red-800);z-index:100;pointer-events:none}.ds-text-field.svelte-kvqn59 .error.svelte-kvqn59::after{content:'';position:absolute;left:0;top:8px;width:4px;height:4px;border-radius:50%;background:var(--red-800)}");
	}

	// (317:4) {#if isDetailExpanded}
	function create_if_block_2(ctx) {
		let div15;
		let div13;
		let div12;
		let div2;
		let div0;
		let t0;
		let i0;
		let i0_class_value;
		let t1;
		let div1;
		let t2;
		let t3;
		let div5;
		let div3;
		let t4;
		let i1;
		let i1_class_value;
		let t5;
		let div4;
		let t6;
		let t7;
		let div8;
		let div6;
		let t8;
		let i2;
		let i2_class_value;
		let t9;
		let div7;
		let t10;
		let t11;
		let div11;
		let div9;
		let t12;
		let i3;
		let i3_class_value;
		let t13;
		let div10;
		let t14;
		let t15;
		let div14;
		let a;
		let mounted;
		let dispose;
		let if_block0 = !/*isEditDocNameEnabled*/ ctx[9] && create_if_block_10(ctx);
		let if_block1 = /*isEditDocNameEnabled*/ ctx[9] && create_if_block_9(ctx);
		let if_block2 = !/*isEditdocNoteEnabled*/ ctx[10] && create_if_block_8(ctx);
		let if_block3 = /*isEditdocNoteEnabled*/ ctx[10] && create_if_block_7(ctx);
		let if_block4 = !/*isEditDocStatusEnabled*/ ctx[11] && create_if_block_6(ctx);
		let if_block5 = /*isEditDocStatusEnabled*/ ctx[11] && create_if_block_5(ctx);
		let if_block6 = !/*isEditDocTypeEnabled*/ ctx[12] && create_if_block_4(ctx);
		let if_block7 = /*isEditDocTypeEnabled*/ ctx[12] && create_if_block_3(ctx);

		return {
			c() {
				div15 = element("div");
				div13 = element("div");
				div12 = element("div");
				div2 = element("div");
				div0 = element("div");
				t0 = text("Document Name\r\n\t\t\t\t\t\t\t\t\t\t");
				i0 = element("i");
				t1 = space();
				div1 = element("div");
				if (if_block0) if_block0.c();
				t2 = space();
				if (if_block1) if_block1.c();
				t3 = space();
				div5 = element("div");
				div3 = element("div");
				t4 = text("Document Note\r\n\t\t\t\t\t\t\t\t\t\t");
				i1 = element("i");
				t5 = space();
				div4 = element("div");
				if (if_block2) if_block2.c();
				t6 = space();
				if (if_block3) if_block3.c();
				t7 = space();
				div8 = element("div");
				div6 = element("div");
				t8 = text("Document Status\r\n\t\t\t\t\t\t\t\t\t\t");
				i2 = element("i");
				t9 = space();
				div7 = element("div");
				if (if_block4) if_block4.c();
				t10 = space();
				if (if_block5) if_block5.c();
				t11 = space();
				div11 = element("div");
				div9 = element("div");
				t12 = text("Document Type\r\n\t\t\t\t\t\t\t\t\t\t");
				i3 = element("i");
				t13 = space();
				div10 = element("div");
				if (if_block6) if_block6.c();
				t14 = space();
				if (if_block7) if_block7.c();
				t15 = space();
				div14 = element("div");
				a = element("a");
				a.innerHTML = `<i class="fas fa-solid fa-window-close"></i>`;

				attr(i0, "class", i0_class_value = "" + (null_to_empty(/*isAuthorizedToUpdate*/ ctx[8]
				? 'fas fa-edit font-blue'
				: '') + " svelte-kvqn59"));

				set_style(div0, "font-weight", "bold");
				set_style(div0, "color", "#A1A1A1");
				set_style(div2, "flex", "1 0 auto");
				set_style(div2, "max-width", "200px");

				attr(i1, "class", i1_class_value = "" + (null_to_empty(/*isAuthorizedToUpdate*/ ctx[8]
				? 'fas fa-edit font-blue'
				: '') + " svelte-kvqn59"));

				set_style(div3, "font-weight", "bold");
				set_style(div3, "color", "#A1A1A1");
				set_style(div3, "font-size", "16px");
				set_style(div4, "font-size", "16px");
				set_style(div5, "flex", "1 0 auto");
				set_style(div5, "max-width", "200px");

				attr(i2, "class", i2_class_value = "" + (null_to_empty(/*isAuthorizedToUpdate*/ ctx[8]
				? 'fas fa-edit font-blue'
				: '') + " svelte-kvqn59"));

				set_style(div6, "font-weight", "bold");
				set_style(div6, "color", "#A1A1A1");
				set_style(div6, "font-size", "16px");
				set_style(div7, "font-size", "16px");
				set_style(div8, "flex", "1 0 auto");
				set_style(div8, "max-width", "200px");

				attr(i3, "class", i3_class_value = "" + (null_to_empty(/*isAuthorizedToUpdate*/ ctx[8]
				? 'fas fa-edit font-blue'
				: '') + " svelte-kvqn59"));

				set_style(div9, "font-weight", "bold");
				set_style(div9, "color", "#A1A1A1");
				set_style(div9, "font-size", "16px");
				set_style(div10, "font-size", "16px");
				set_style(div11, "flex", "1 0 auto");
				set_style(div11, "max-width", "200px");
				attr(div12, "class", "gap-10 mt-10");
				set_style(div12, "display", "flex");
				set_style(div12, "flex-direction", "row");
				set_style(div12, "flex-wrap", "wrap");
				set_style(div13, "margin", "20px auto");
				set_style(div13, "width", "95%");
				attr(a, "class", "close svelte-kvqn59");
				attr(div14, "class", "right-align svelte-kvqn59");
				attr(div15, "class", "details svelte-kvqn59");
			},
			m(target, anchor) {
				insert(target, div15, anchor);
				append(div15, div13);
				append(div13, div12);
				append(div12, div2);
				append(div2, div0);
				append(div0, t0);
				append(div0, i0);
				append(div2, t1);
				append(div2, div1);
				if (if_block0) if_block0.m(div1, null);
				append(div12, t2);
				if (if_block1) if_block1.m(div12, null);
				append(div12, t3);
				append(div12, div5);
				append(div5, div3);
				append(div3, t4);
				append(div3, i1);
				append(div5, t5);
				append(div5, div4);
				if (if_block2) if_block2.m(div4, null);
				append(div12, t6);
				if (if_block3) if_block3.m(div12, null);
				append(div12, t7);
				append(div12, div8);
				append(div8, div6);
				append(div6, t8);
				append(div6, i2);
				append(div8, t9);
				append(div8, div7);
				if (if_block4) if_block4.m(div7, null);
				append(div12, t10);
				if (if_block5) if_block5.m(div12, null);
				append(div12, t11);
				append(div12, div11);
				append(div11, div9);
				append(div9, t12);
				append(div9, i3);
				append(div11, t13);
				append(div11, div10);
				if (if_block6) if_block6.m(div10, null);
				append(div12, t14);
				if (if_block7) if_block7.m(div12, null);
				append(div15, t15);
				append(div15, div14);
				append(div14, a);

				if (!mounted) {
					dispose = [
						listen(i0, "click", /*click_handler_3*/ ctx[31]),
						listen(i1, "click", /*click_handler_6*/ ctx[35]),
						listen(i2, "click", /*click_handler_9*/ ctx[39]),
						listen(i3, "click", /*click_handler_12*/ ctx[43]),
						listen(a, "click", /*click_handler_15*/ ctx[47])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*isAuthorizedToUpdate*/ 256 && i0_class_value !== (i0_class_value = "" + (null_to_empty(/*isAuthorizedToUpdate*/ ctx[8]
				? 'fas fa-edit font-blue'
				: '') + " svelte-kvqn59"))) {
					attr(i0, "class", i0_class_value);
				}

				if (!/*isEditDocNameEnabled*/ ctx[9]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_10(ctx);
						if_block0.c();
						if_block0.m(div1, null);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*isEditDocNameEnabled*/ ctx[9]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_9(ctx);
						if_block1.c();
						if_block1.m(div12, t3);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (dirty[0] & /*isAuthorizedToUpdate*/ 256 && i1_class_value !== (i1_class_value = "" + (null_to_empty(/*isAuthorizedToUpdate*/ ctx[8]
				? 'fas fa-edit font-blue'
				: '') + " svelte-kvqn59"))) {
					attr(i1, "class", i1_class_value);
				}

				if (!/*isEditdocNoteEnabled*/ ctx[10]) {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_8(ctx);
						if_block2.c();
						if_block2.m(div4, null);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}

				if (/*isEditdocNoteEnabled*/ ctx[10]) {
					if (if_block3) {
						if_block3.p(ctx, dirty);
					} else {
						if_block3 = create_if_block_7(ctx);
						if_block3.c();
						if_block3.m(div12, t7);
					}
				} else if (if_block3) {
					if_block3.d(1);
					if_block3 = null;
				}

				if (dirty[0] & /*isAuthorizedToUpdate*/ 256 && i2_class_value !== (i2_class_value = "" + (null_to_empty(/*isAuthorizedToUpdate*/ ctx[8]
				? 'fas fa-edit font-blue'
				: '') + " svelte-kvqn59"))) {
					attr(i2, "class", i2_class_value);
				}

				if (!/*isEditDocStatusEnabled*/ ctx[11]) {
					if (if_block4) {
						if_block4.p(ctx, dirty);
					} else {
						if_block4 = create_if_block_6(ctx);
						if_block4.c();
						if_block4.m(div7, null);
					}
				} else if (if_block4) {
					if_block4.d(1);
					if_block4 = null;
				}

				if (/*isEditDocStatusEnabled*/ ctx[11]) {
					if (if_block5) {
						if_block5.p(ctx, dirty);
					} else {
						if_block5 = create_if_block_5(ctx);
						if_block5.c();
						if_block5.m(div12, t11);
					}
				} else if (if_block5) {
					if_block5.d(1);
					if_block5 = null;
				}

				if (dirty[0] & /*isAuthorizedToUpdate*/ 256 && i3_class_value !== (i3_class_value = "" + (null_to_empty(/*isAuthorizedToUpdate*/ ctx[8]
				? 'fas fa-edit font-blue'
				: '') + " svelte-kvqn59"))) {
					attr(i3, "class", i3_class_value);
				}

				if (!/*isEditDocTypeEnabled*/ ctx[12]) {
					if (if_block6) {
						if_block6.p(ctx, dirty);
					} else {
						if_block6 = create_if_block_4(ctx);
						if_block6.c();
						if_block6.m(div10, null);
					}
				} else if (if_block6) {
					if_block6.d(1);
					if_block6 = null;
				}

				if (/*isEditDocTypeEnabled*/ ctx[12]) {
					if (if_block7) {
						if_block7.p(ctx, dirty);
					} else {
						if_block7 = create_if_block_3(ctx);
						if_block7.c();
						if_block7.m(div12, null);
					}
				} else if (if_block7) {
					if_block7.d(1);
					if_block7 = null;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div15);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				if (if_block2) if_block2.d();
				if (if_block3) if_block3.d();
				if (if_block4) if_block4.d();
				if (if_block5) if_block5.d();
				if (if_block6) if_block6.d();
				if (if_block7) if_block7.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (330:10) {#if !isEditDocNameEnabled}
	function create_if_block_10(ctx) {
		let t_value = /*document*/ ctx[0]?.docFileName + "";
		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*document*/ 1 && t_value !== (t_value = /*document*/ ctx[0]?.docFileName + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(t);
				}
			}
		};
	}

	// (335:8) {#if isEditDocNameEnabled}
	function create_if_block_9(ctx) {
		let div3;
		let span;
		let t1;
		let div1;
		let input;
		let t2;
		let label;
		let t4;
		let div0;
		let t5;
		let button;
		let div2;
		let button_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				div3 = element("div");
				span = element("span");
				span.textContent = "×";
				t1 = space();
				div1 = element("div");
				input = element("input");
				t2 = space();
				label = element("label");
				label.textContent = "Edit Document Name";
				t4 = space();
				div0 = element("div");
				t5 = space();
				button = element("button");
				div2 = element("div");
				div2.textContent = "Save";
				attr(span, "class", "close");
				set_style(span, "float", "right");
				set_style(span, "font-size", "30px");
				set_style(span, "color", "#000");
				attr(input, "id", "docName");
				set_style(input, "font-size", "16px");
				attr(input, "type", "text");
				attr(input, "name", "docName");
				attr(input, "class", "ds-text-field__input svelte-kvqn59");
				attr(label, "for", "address");
				attr(label, "class", "ds-floating-label svelte-kvqn59");
				set_style(label, "font-size", "16px");
				attr(div0, "class", "field-line-ripple blue svelte-kvqn59");
				set_style(div0, "font-size", "16px");
				attr(div1, "class", "ds-text-field svelte-kvqn59");
				set_style(div1, "margin-bottom", "10px");
				set_style(div1, "width", "100%");
				set_style(div1, "height", "35px");
				set_style(div1, "margin-bottom", "10px");
				attr(div2, "class", "btn-txt font-white svelte-kvqn59");
				set_style(div2, "font-size", "16px");

				attr(button, "class", button_class_value = "display-inline-block rounded-full hover-blue-800 black " + (isDirty(/*document*/ ctx[0].docFileName, /*docName*/ ctx[14])
				? ''
				: 'disabled') + " svelte-kvqn59");

				set_style(button, "width", "85px");
				set_style(button, "height", "35px");
				attr(div3, "class", "font-20 border border-gray-500");
				set_style(div3, "padding-right", "10px");
				set_style(div3, "padding-left", "10px");
				set_style(div3, "padding-bottom", "10px");
				set_style(div3, "width", "100%");
				set_style(div3, "text-align", "center");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, span);
				append(div3, t1);
				append(div3, div1);
				append(div1, input);
				set_input_value(input, /*docName*/ ctx[14]);
				append(div1, t2);
				append(div1, label);
				append(div1, t4);
				append(div1, div0);
				append(div3, t5);
				append(div3, button);
				append(button, div2);

				if (!mounted) {
					dispose = [
						listen(span, "click", /*click_handler_4*/ ctx[32]),
						listen(input, "input", /*input_input_handler*/ ctx[33]),
						listen(button, "click", /*click_handler_5*/ ctx[34])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*docName*/ 16384 && input.value !== /*docName*/ ctx[14]) {
					set_input_value(input, /*docName*/ ctx[14]);
				}

				if (dirty[0] & /*document, docName*/ 16385 && button_class_value !== (button_class_value = "display-inline-block rounded-full hover-blue-800 black " + (isDirty(/*document*/ ctx[0].docFileName, /*docName*/ ctx[14])
				? ''
				: 'disabled') + " svelte-kvqn59")) {
					attr(button, "class", button_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div3);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (387:10) {#if !isEditdocNoteEnabled}
	function create_if_block_8(ctx) {
		let t_value = (/*document*/ ctx[0]?.docNote ?? '') + "";
		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*document*/ 1 && t_value !== (t_value = (/*document*/ ctx[0]?.docNote ?? '') + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(t);
				}
			}
		};
	}

	// (393:8) {#if isEditdocNoteEnabled}
	function create_if_block_7(ctx) {
		let div4;
		let span;
		let t1;
		let div2;
		let div1;
		let div0;
		let textarea;
		let t2;
		let button;
		let div3;
		let button_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				div4 = element("div");
				span = element("span");
				span.textContent = "×";
				t1 = space();
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");
				textarea = element("textarea");
				t2 = space();
				button = element("button");
				div3 = element("div");
				div3.textContent = "Save";
				attr(span, "class", "close");
				set_style(span, "float", "right");
				set_style(span, "font-size", "30px");
				set_style(span, "color", "#000");
				attr(textarea, "rows", "3");
				attr(textarea, "cols", "50");
				attr(textarea, "class", "textarea ds-text-field__input svelte-kvqn59");
				set_style(textarea, "font-size", "16px");
				set_style(textarea, "font-family", "sans-serif");
				attr(textarea, "name", "docNote");
				attr(textarea, "placeholder", "Enter document note here");
				attr(div0, "class", "text-area-container");
				set_style(div0, "width", "100%");
				attr(div1, "class", "p-20 gray-200");
				set_style(div1, "width", "100%");
				attr(div2, "class", "inline-text-field-container mt-10");
				set_style(div2, "width", "100%");
				attr(div3, "class", "btn-txt font-white svelte-kvqn59");
				set_style(div3, "font-size", "16px");

				attr(button, "class", button_class_value = "display-inline-block rounded-full hover-blue-800 black " + (isDirty(/*document*/ ctx[0].docNote, /*docNote*/ ctx[15])
				? ''
				: 'disabled') + " svelte-kvqn59");

				set_style(button, "width", "85px");
				set_style(button, "height", "35px");
				attr(div4, "class", "font-20 border border-gray-500");
				set_style(div4, "padding-right", "10px");
				set_style(div4, "padding-left", "10px");
				set_style(div4, "padding-bottom", "10px");
				set_style(div4, "width", "100%");
				set_style(div4, "text-align", "center");
			},
			m(target, anchor) {
				insert(target, div4, anchor);
				append(div4, span);
				append(div4, t1);
				append(div4, div2);
				append(div2, div1);
				append(div1, div0);
				append(div0, textarea);
				set_input_value(textarea, /*docNote*/ ctx[15]);
				append(div4, t2);
				append(div4, button);
				append(button, div3);

				if (!mounted) {
					dispose = [
						listen(span, "click", /*click_handler_7*/ ctx[36]),
						listen(textarea, "input", /*textarea_input_handler*/ ctx[37]),
						listen(button, "click", /*click_handler_8*/ ctx[38])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*docNote*/ 32768) {
					set_input_value(textarea, /*docNote*/ ctx[15]);
				}

				if (dirty[0] & /*document, docNote*/ 32769 && button_class_value !== (button_class_value = "display-inline-block rounded-full hover-blue-800 black " + (isDirty(/*document*/ ctx[0].docNote, /*docNote*/ ctx[15])
				? ''
				: 'disabled') + " svelte-kvqn59")) {
					attr(button, "class", button_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div4);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (442:10) {#if !isEditDocStatusEnabled}
	function create_if_block_6(ctx) {
		let t_value = (/*document*/ ctx[0]?.status ?? '') + "";
		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*document*/ 1 && t_value !== (t_value = (/*document*/ ctx[0]?.status ?? '') + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) {
					detach(t);
				}
			}
		};
	}

	// (448:8) {#if isEditDocStatusEnabled}
	function create_if_block_5(ctx) {
		let div3;
		let span0;
		let t1;
		let div1;
		let eas_select;
		let t2;
		let label;
		let t4;
		let div0;
		let t5;
		let span1;
		let t6;
		let span2;
		let t7;
		let button;
		let div2;
		let button_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				div3 = element("div");
				span0 = element("span");
				span0.textContent = "×";
				t1 = space();
				div1 = element("div");
				eas_select = element("eas-select");
				t2 = space();
				label = element("label");
				label.textContent = "Edit Document Status";
				t4 = space();
				div0 = element("div");
				t5 = space();
				span1 = element("span");
				t6 = space();
				span2 = element("span");
				t7 = space();
				button = element("button");
				div2 = element("div");
				div2.textContent = "Save";
				attr(span0, "class", "close");
				set_style(span0, "float", "right");
				set_style(span0, "font-size", "30px");
				set_style(span0, "color", "#000");
				set_custom_element_data(eas_select, "controlid", "docStatus");
				set_custom_element_data(eas_select, "placeholder", "");
				set_custom_element_data(eas_select, "selecteditem", /*selectedDocStatus*/ ctx[5]);
				set_custom_element_data(eas_select, "data", /*docStatusesList*/ ctx[3]);
				set_custom_element_data(eas_select, "height", "35");
				set_custom_element_data(eas_select, "width", "300");
				set_style(eas_select, "font-size", "8px");
				attr(label, "for", "address");
				attr(label, "class", "ds-floating-label svelte-kvqn59");
				set_style(label, "font-size", "16px");
				attr(div0, "class", "field-line-ripple blue svelte-kvqn59");
				set_style(div0, "font-size", "16px");
				attr(span1, "class", "help display-none svelte-kvqn59");
				set_style(span1, "font-size", "16px");
				attr(span2, "class", "error display-none svelte-kvqn59");
				set_style(span2, "font-size", "16px");
				attr(div1, "class", "ds-text-field svelte-kvqn59");
				set_style(div1, "margin-bottom", "10px");
				set_style(div1, "width", "100%");
				set_style(div1, "height", "35px");
				set_style(div1, "margin-bottom", "10px");
				attr(div2, "class", "btn-txt font-white svelte-kvqn59");
				set_style(div2, "font-size", "16px");

				attr(button, "class", button_class_value = "display-inline-block rounded-full hover-blue-800 black " + (isDirty(/*document*/ ctx[0].status, /*selectedDocStatusValue*/ ctx[7])
				? ''
				: 'disabled') + " svelte-kvqn59");

				set_style(button, "width", "85px");
				set_style(button, "height", "35px");
				attr(div3, "class", "font-20 border border-gray-500");
				set_style(div3, "padding-right", "10px");
				set_style(div3, "padding-left", "10px");
				set_style(div3, "padding-bottom", "10px");
				set_style(div3, "width", "100%");
				set_style(div3, "text-align", "center");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, span0);
				append(div3, t1);
				append(div3, div1);
				append(div1, eas_select);
				append(div1, t2);
				append(div1, label);
				append(div1, t4);
				append(div1, div0);
				append(div1, t5);
				append(div1, span1);
				append(div1, t6);
				append(div1, span2);
				append(div3, t7);
				append(div3, button);
				append(button, div2);

				if (!mounted) {
					dispose = [
						listen(span0, "click", /*click_handler_10*/ ctx[40]),
						listen(eas_select, "itemselected", /*itemselected_handler*/ ctx[41]),
						listen(button, "click", /*click_handler_11*/ ctx[42])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*selectedDocStatus*/ 32) {
					set_custom_element_data(eas_select, "selecteditem", /*selectedDocStatus*/ ctx[5]);
				}

				if (dirty[0] & /*docStatusesList*/ 8) {
					set_custom_element_data(eas_select, "data", /*docStatusesList*/ ctx[3]);
				}

				if (dirty[0] & /*document, selectedDocStatusValue*/ 129 && button_class_value !== (button_class_value = "display-inline-block rounded-full hover-blue-800 black " + (isDirty(/*document*/ ctx[0].status, /*selectedDocStatusValue*/ ctx[7])
				? ''
				: 'disabled') + " svelte-kvqn59")) {
					attr(button, "class", button_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div3);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (505:10) {#if !isEditDocTypeEnabled}
	function create_if_block_4(ctx) {
		let t;

		return {
			c() {
				t = text(/*selectedDocTypeValue*/ ctx[6]);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*selectedDocTypeValue*/ 64) set_data(t, /*selectedDocTypeValue*/ ctx[6]);
			},
			d(detaching) {
				if (detaching) {
					detach(t);
				}
			}
		};
	}

	// (511:8) {#if isEditDocTypeEnabled}
	function create_if_block_3(ctx) {
		let div3;
		let span0;
		let t1;
		let div1;
		let eas_select;
		let t2;
		let label;
		let t4;
		let div0;
		let t5;
		let span1;
		let t6;
		let span2;
		let t7;
		let button;
		let div2;
		let button_class_value;
		let mounted;
		let dispose;

		return {
			c() {
				div3 = element("div");
				span0 = element("span");
				span0.textContent = "×";
				t1 = space();
				div1 = element("div");
				eas_select = element("eas-select");
				t2 = space();
				label = element("label");
				label.textContent = "Edit Document Type";
				t4 = space();
				div0 = element("div");
				t5 = space();
				span1 = element("span");
				t6 = space();
				span2 = element("span");
				t7 = space();
				button = element("button");
				div2 = element("div");
				div2.textContent = "Save";
				attr(span0, "class", "close");
				set_style(span0, "float", "right");
				set_style(span0, "font-size", "30px");
				set_style(span0, "color", "#000");
				set_custom_element_data(eas_select, "controlid", "docTypes");
				set_custom_element_data(eas_select, "selecteditem", /*selectedDocType*/ ctx[4]);
				set_custom_element_data(eas_select, "data", /*docTypesList*/ ctx[2]);
				set_custom_element_data(eas_select, "placeholder", "");
				set_custom_element_data(eas_select, "height", "35");
				set_custom_element_data(eas_select, "width", "300");
				set_style(eas_select, "font-size", "8px");
				attr(label, "for", "address");
				attr(label, "class", "ds-floating-label svelte-kvqn59");
				set_style(label, "font-size", "16px");
				attr(div0, "class", "field-line-ripple blue svelte-kvqn59");
				set_style(div0, "font-size", "16px");
				attr(span1, "class", "help display-none svelte-kvqn59");
				set_style(span1, "font-size", "16px");
				attr(span2, "class", "error display-none svelte-kvqn59");
				set_style(span2, "font-size", "16px");
				attr(div1, "class", "ds-text-field svelte-kvqn59");
				set_style(div1, "margin-bottom", "10px");
				set_style(div1, "width", "100%");
				set_style(div1, "height", "35px");
				set_style(div1, "margin-bottom", "10px");
				attr(div2, "class", "btn-txt font-white svelte-kvqn59");
				set_style(div2, "font-size", "16px");

				attr(button, "class", button_class_value = "display-inline-block rounded-full hover-blue-800 black " + (isDirty(/*document*/ ctx[0].docTypeKey, /*selectedDocType*/ ctx[4])
				? ''
				: 'disabled') + " svelte-kvqn59");

				set_style(button, "width", "85px");
				set_style(button, "height", "35px");
				attr(div3, "class", "font-20 border border-gray-500");
				set_style(div3, "padding-right", "10px");
				set_style(div3, "padding-left", "10px");
				set_style(div3, "padding-bottom", "10px");
				set_style(div3, "width", "100%");
				set_style(div3, "text-align", "center");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, span0);
				append(div3, t1);
				append(div3, div1);
				append(div1, eas_select);
				append(div1, t2);
				append(div1, label);
				append(div1, t4);
				append(div1, div0);
				append(div1, t5);
				append(div1, span1);
				append(div1, t6);
				append(div1, span2);
				append(div3, t7);
				append(div3, button);
				append(button, div2);

				if (!mounted) {
					dispose = [
						listen(span0, "click", /*click_handler_13*/ ctx[44]),
						listen(eas_select, "itemselected", /*itemselected_handler_1*/ ctx[45]),
						listen(button, "click", /*click_handler_14*/ ctx[46])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*selectedDocType*/ 16) {
					set_custom_element_data(eas_select, "selecteditem", /*selectedDocType*/ ctx[4]);
				}

				if (dirty[0] & /*docTypesList*/ 4) {
					set_custom_element_data(eas_select, "data", /*docTypesList*/ ctx[2]);
				}

				if (dirty[0] & /*document, selectedDocType*/ 17 && button_class_value !== (button_class_value = "display-inline-block rounded-full hover-blue-800 black " + (isDirty(/*document*/ ctx[0].docTypeKey, /*selectedDocType*/ ctx[4])
				? ''
				: 'disabled') + " svelte-kvqn59")) {
					attr(button, "class", button_class_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div3);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (577:4) {:else}
	function create_else_block_1(ctx) {
		let div;

		return {
			c() {
				div = element("div");
				div.innerHTML = `<span>** No document to view **</span>`;
				attr(div, "class", "iframe-doc-border");
			},
			m(target, anchor) {
				insert(target, div, anchor);
			},
			p: noop,
			d(detaching) {
				if (detaching) {
					detach(div);
				}
			}
		};
	}

	// (569:4) {#if document.docPreviewFlag}
	function create_if_block(ctx) {
		let div;
		let show_if;

		function select_block_type_1(ctx, dirty) {
			if (dirty[0] & /*document*/ 1) show_if = null;
			if (show_if == null) show_if = !!/*document*/ ctx[0].docResponseType.startsWith("image/");
			if (show_if) return create_if_block_1;
			return create_else_block;
		}

		let current_block_type = select_block_type_1(ctx, [-1, -1]);
		let if_block = current_block_type(ctx);

		return {
			c() {
				div = element("div");
				if_block.c();
				attr(div, "class", "iframe-doc-border");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if_block.m(div, null);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(div, null);
					}
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div);
				}

				if_block.d();
			}
		};
	}

	// (573:6) {:else}
	function create_else_block(ctx) {
		let iframe;
		let iframe_src_value;

		return {
			c() {
				iframe = element("iframe");
				attr(iframe, "id", "pdf_viewer");
				attr(iframe, "width", "100%");
				attr(iframe, "title", "Preview");
				if (!src_url_equal(iframe.src, iframe_src_value = "" + (/*objUrl*/ ctx[16] + "#view=fitH"))) attr(iframe, "src", iframe_src_value);
				attr(iframe, "class", "svelte-kvqn59");
			},
			m(target, anchor) {
				insert(target, iframe, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*objUrl*/ 65536 && !src_url_equal(iframe.src, iframe_src_value = "" + (/*objUrl*/ ctx[16] + "#view=fitH"))) {
					attr(iframe, "src", iframe_src_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(iframe);
				}
			}
		};
	}

	// (571:6) {#if document.docResponseType.startsWith("image/")}
	function create_if_block_1(ctx) {
		let img;
		let img_src_value;

		return {
			c() {
				img = element("img");
				attr(img, "width", "100%");
				attr(img, "title", "Preview");
				attr(img, "alt", "Preview");
				if (!src_url_equal(img.src, img_src_value = /*objUrl*/ ctx[16])) attr(img, "src", img_src_value);
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*objUrl*/ 65536 && !src_url_equal(img.src, img_src_value = /*objUrl*/ ctx[16])) {
					attr(img, "src", img_src_value);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(img);
				}
			}
		};
	}

	function create_fragment$1(ctx) {
		let link;
		let t0;
		let script;
		let script_src_value;
		let t1;
		let div5;
		let div4;
		let div3;
		let div1;
		let div0;
		let ul;
		let li0;
		let t2_value = /*document*/ ctx[0]?.docFileName + "";
		let t2;
		let t3;
		let li1;
		let a0;
		let t5;
		let li2;
		let a1;
		let t6;
		let li3;
		let a2;
		let t7;
		let t8;
		let div2;
		let mounted;
		let dispose;
		let if_block0 = /*isDetailExpanded*/ ctx[13] && create_if_block_2(ctx);

		function select_block_type(ctx, dirty) {
			if (/*document*/ ctx[0].docPreviewFlag) return create_if_block;
			return create_else_block_1;
		}

		let current_block_type = select_block_type(ctx);
		let if_block1 = current_block_type(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				script = element("script");
				script.innerHTML = ``;
				t1 = space();
				div5 = element("div");
				div4 = element("div");
				div3 = element("div");
				div1 = element("div");
				div0 = element("div");
				ul = element("ul");
				li0 = element("li");
				t2 = text(t2_value);
				t3 = space();
				li1 = element("li");
				a0 = element("a");
				a0.textContent = "Details";
				t5 = space();
				li2 = element("li");
				a1 = element("a");
				a1.innerHTML = `<i class="fas fa-solid fa-download"></i>`;
				t6 = space();
				li3 = element("li");
				a2 = element("a");
				a2.innerHTML = `<i class="fas fa-solid fa-window-close"></i>`;
				t7 = space();
				if (if_block0) if_block0.c();
				t8 = space();
				div2 = element("div");
				if_block1.c();
				attr(link, "rel", "stylesheet");
				attr(link, "href", "https://use.fontawesome.com/releases/v5.11.2/css/all.css");
				if (!src_url_equal(script.src, script_src_value = "https://kit.fontawesome.com/a5cccf28a6.js")) attr(script, "src", script_src_value);
				attr(script, "crossorigin", "anonymous");
				attr(li0, "class", "title svelte-kvqn59");
				attr(a0, "class", "button-details svelte-kvqn59");
				attr(li1, "class", "svelte-kvqn59");
				attr(a1, "class", "svelte-kvqn59");
				attr(li2, "class", "svelte-kvqn59");
				attr(a2, "class", "svelte-kvqn59");
				attr(li3, "class", "svelte-kvqn59");
				attr(ul, "class", "head-list svelte-kvqn59");
				attr(div0, "class", "head");
				attr(div1, "class", "head-container svelte-kvqn59");
				attr(div2, "class", "viewer svelte-kvqn59");
				attr(div3, "class", "panel svelte-kvqn59");
				attr(div4, "class", "content svelte-kvqn59");
				attr(div5, "class", "container-application svelte-kvqn59");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				append(document_1.head, script);
				insert(target, t1, anchor);
				insert(target, div5, anchor);
				append(div5, div4);
				append(div4, div3);
				append(div3, div1);
				append(div1, div0);
				append(div0, ul);
				append(ul, li0);
				append(li0, t2);
				append(ul, t3);
				append(ul, li1);
				append(li1, a0);
				append(ul, t5);
				append(ul, li2);
				append(li2, a1);
				append(ul, t6);
				append(ul, li3);
				append(li3, a2);
				append(div1, t7);
				if (if_block0) if_block0.m(div1, null);
				append(div3, t8);
				append(div3, div2);
				if_block1.m(div2, null);

				if (!mounted) {
					dispose = [
						listen(a0, "click", /*click_handler*/ ctx[28]),
						listen(a1, "click", /*click_handler_1*/ ctx[29]),
						listen(a2, "click", /*click_handler_2*/ ctx[30])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*document*/ 1 && t2_value !== (t2_value = /*document*/ ctx[0]?.docFileName + "")) set_data(t2, t2_value);

				if (/*isDetailExpanded*/ ctx[13]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_2(ctx);
						if_block0.c();
						if_block0.m(div1, null);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1.d(1);
					if_block1 = current_block_type(ctx);

					if (if_block1) {
						if_block1.c();
						if_block1.m(div2, null);
					}
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(t1);
					detach(div5);
				}

				detach(script);
				if (if_block0) if_block0.d();
				if_block1.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function isDirty(oldValue, newValue) {
		return oldValue != newValue;
	}

	function instance$1($$self, $$props, $$invalidate) {
		const svelteDispatch = createEventDispatcher();
		let { document } = $$props;
		var EnumDocumentProperty;

		(function (EnumDocumentProperty) {
			EnumDocumentProperty[EnumDocumentProperty["Name"] = 1] = "Name";
			EnumDocumentProperty[EnumDocumentProperty["Notes"] = 2] = "Notes";
			EnumDocumentProperty[EnumDocumentProperty["Status"] = 3] = "Status";
			EnumDocumentProperty[EnumDocumentProperty["Type"] = 4] = "Type";
		})(EnumDocumentProperty || (EnumDocumentProperty = {}));

		let documentService = new DocumentService();
		let docTypesList = [];
		let docStatusesList = [];
		let selectedDocType;
		let selectedDocStatus;
		let selectedDocTypeValue;
		let selectedDocStatusValue;

		//let docStatusModel: DocumentStatusModel;
		let oldRelationInstanceKey = 0;

		let isAuthorizedToUpdate = false;
		let isEditDocNameEnabled = false;
		let isEditdocNoteEnabled = false;
		let isEditDocStatusEnabled = false;
		let isEditDocTypeEnabled = false;
		let isDetailExpanded = false;
		let docName;
		let docNote;
		let objUrl;

		afterUpdate(async () => {
			console.log(`after update: ${document}`);

			if (document && oldRelationInstanceKey != document.documentRelationInstanceKey) {
				$$invalidate(8, isAuthorizedToUpdate = document.permission?.update ?? false);
				oldRelationInstanceKey = document.documentRelationInstanceKey;
				$$invalidate(7, selectedDocStatusValue = document.status);
				$$invalidate(4, selectedDocType = document.docTypeKey);
				previewDocument();
				getAuthorizedDocTypes();
				getDocStatuses();
			}
		});

		function getAuthorizedDocTypes() {
			if (document == null || document == undefined) return;

			//console.log(document);
			documentService.getDocTypes(document.moduleKey, document.documentImmediateOwnerSourceKey, document.documentCompositeOwnerSourceKey, 'add').then(result => {
				$$invalidate(2, docTypesList = result.map(docType => {
					return new KeyValuePair(docType.docTypeKey, docType.docTypeName);
				}));

				$$invalidate(4, selectedDocType = document.docTypeKey);
				let _docType = docTypesList.find(docStatus => docStatus.key === document.docTypeKey);

				if (!_docType) {
					return;
				}

				$$invalidate(6, selectedDocTypeValue = _docType.value);
			}).catch(error => {
				console.error('Error in getDocTypes', error);
			});
		}

		function getDocStatuses() {
			if (document == null || document == undefined) return;

			//console.log(document);
			documentService.getDocStatuses(document.moduleKey, document.documentImmediateOwnerSourceKey, document.documentRelationInstanceKey).then(result => {
				//docStatusModel = result;
				$$invalidate(3, docStatusesList = result?.documentStatuses.map(item => {
					return new KeyValuePair(item.documentStatusKey, item.documentStatusName);
				}));

				let _docStatus = docStatusesList.find(docStatus => docStatus.value === document.status);

				if (!_docStatus) {
					return;
				}

				$$invalidate(5, selectedDocStatus = _docStatus.key);
			}).catch(error => {
				console.error('Error in getDocStatuses', error);
			});
		}

		function onExpandClick() {
			$$invalidate(13, isDetailExpanded = !isDetailExpanded);
		}

		function onEditClick(docEnum) {
			onEditCancelClick();

			if (docEnum === EnumDocumentProperty.Name) {
				$$invalidate(14, docName = document.docFileName);
				$$invalidate(9, isEditDocNameEnabled = true);
			} else if (docEnum === EnumDocumentProperty.Notes) {
				$$invalidate(15, docNote = document.docNote);
				$$invalidate(10, isEditdocNoteEnabled = true);
			} else if (docEnum === EnumDocumentProperty.Status) {
				$$invalidate(7, selectedDocStatusValue = document.status);
				$$invalidate(11, isEditDocStatusEnabled = true);
			} else if (docEnum === EnumDocumentProperty.Type) {
				$$invalidate(12, isEditDocTypeEnabled = true);
			}
		}

		function onEditCancelClick() {
			$$invalidate(9, isEditDocNameEnabled = false);
			$$invalidate(10, isEditdocNoteEnabled = false);
			$$invalidate(11, isEditDocStatusEnabled = false);
			$$invalidate(12, isEditDocTypeEnabled = false);
			$$invalidate(7, selectedDocStatusValue = document.status);
		}

		function onCloseClick(e) {
			let detail = { close: true };
			e.stopPropagation();
			svelteDispatch('closeClick', detail);
		}

		function onDownloadClick(e) {
			e.stopPropagation();

			// Download document logic
			if (document.docPreviewFlag) {
				let docName = document.docFileName;

				if (docName == null || docName === '') {
					docName = 'Unknown.txt';
				}

				const downloadLink = window.document.createElement('a');
				downloadLink.href = objUrl;
				downloadLink.download = docName;
				window.document.body.appendChild(downloadLink);
				downloadLink.click();
			} else {
				documentService.downloadDocument(document).then(file => {
					console.log(`file:`, file);
					let docName = document.docFileName;

					if (docName == null || docName === '') {
						docName = 'Unknown.txt';
					}

					const docBlob = new Blob([file], { type: document.docResponseType });
					const fileUrl = window.URL.createObjectURL(docBlob);

					// Download document logic
					const downloadLink = window.document.createElement('a');

					downloadLink.href = fileUrl;
					downloadLink.download = docName;
					window.document.body.appendChild(downloadLink);
					downloadLink.click();
				}).catch(error => {
					console.log(`Error Status: ${JSON.stringify(error.status)}; Error Status Text: ${JSON.stringify(error.statusText)}; Error Msg: ${JSON.stringify(error.message)};`);
				});
			}

			return false;
		}

		function previewDocument() {
			if (!document.docPreviewFlag) return;

			documentService.downloadDocument(document).then(file => {
				document.docFileName;

				let docBlob = new Blob([file], { type: document.docResponseType });
				$$invalidate(16, objUrl = window.URL.createObjectURL(docBlob));
				docBlob.slice(0, 0, document.docResponseType);
			}).catch(error => {
				console.log(`Error Status: ${JSON.stringify(error.status)}; Error Status Text: ${JSON.stringify(error.statusText)}; Error Msg: ${JSON.stringify(error.message)};`);
				return '';
			});
		}

		function onSaveDocumentNameClick(e) {
			e.stopPropagation();

			if (docName.length <= 0) {
				return;
			}

			documentService.updateDocumentName(document.moduleKey, document.documentImmediateOwnerSourceKey, document.documentRelationInstanceKey, docName).then(result => {
				if (result) {
					$$invalidate(0, document.docFileName = docName, document);
					$$invalidate(9, isEditDocNameEnabled = false);
					$$invalidate(0, document);
				}
			}).catch(error => {
				console.error('Error in updateDocumentName', error);
			});
		}

		function onSaveDocumentNotesClick(e) {
			e.stopPropagation();

			if (docNote.length <= 0) {
				return;
			}

			documentService.updateDocumentNote(document.moduleKey, document.documentImmediateOwnerSourceKey, document.documentRelationInstanceKey, docNote).then(result => {
				if (result) {
					$$invalidate(0, document.docNote = docNote, document);
					$$invalidate(10, isEditdocNoteEnabled = false);
					$$invalidate(0, document);
				}
			}).catch(error => {
				console.error('Error in updateDocumentNote', error);
			});
		}

		function onSaveDocumentStatusClick(e) {
			e.stopPropagation();

			documentService.updateDocumentStatus(document.moduleKey, document.documentImmediateOwnerSourceKey, document.documentRelationInstanceKey, selectedDocStatus).then(result => {
				if (result) {
					let _docStatus = docStatusesList.find(docType => docType.key === selectedDocType);

					if (!_docStatus) {
						return;
					}

					$$invalidate(7, selectedDocStatusValue = _docStatus.value);
					$$invalidate(0, document.status = _docStatus.value, document);
					$$invalidate(11, isEditDocStatusEnabled = false);
					$$invalidate(0, document);
				}
			}).catch(error => {
				console.error('Error in updateDocumentStatus', error);
			});
		}

		function onSaveDocumentTypeClick(e) {
			e.stopPropagation();

			documentService.updateDocumentType(document.moduleKey, document.documentImmediateOwnerSourceKey, document.documentRelationInstanceKey, selectedDocType).then(result => {
				if (result) {
					$$invalidate(0, document.docTypeKey = selectedDocType, document);
					let _docType = docTypesList.find(docType => docType.value === selectedDocTypeValue);

					if (!_docType) {
						return;
					}

					$$invalidate(6, selectedDocTypeValue = _docType.value);
					$$invalidate(0, document.docTypeName = _docType.value, document);
					$$invalidate(12, isEditDocTypeEnabled = false);
					$$invalidate(0, document);
				}
			}).catch(error => {
				console.error('Error in updateDocumentType', error);
			});
		}

		function onDocStatusSelect(e) {
			console.log('onDocStatusSelect fired', e);
			$$invalidate(5, selectedDocStatus = e.detail.selectedItem);
			let _docStatus = docStatusesList.find(docType => docType.key === e.detail.selectedItem);

			if (!_docStatus) {
				return;
			}

			$$invalidate(7, selectedDocStatusValue = _docStatus.value);
			console.log(`selectedDocStatus:`, selectedDocStatus);
		}

		function onDocTypeSelect(e) {
			console.log('onDocTypeSelect fired', e);
			$$invalidate(4, selectedDocType = e.detail.selectedItem);

			//selectedDocType = docTypesList.find(docType => docType.value === selectedDocTypeValue);
			console.log(`selectedDocType:`, selectedDocType);
		}

		const click_handler = e => onExpandClick();
		const click_handler_1 = e => onDownloadClick(e);
		const click_handler_2 = e => onCloseClick(e);
		const click_handler_3 = e => onEditClick(EnumDocumentProperty.Name);
		const click_handler_4 = e => onEditCancelClick();

		function input_input_handler() {
			docName = this.value;
			$$invalidate(14, docName);
		}

		const click_handler_5 = e => onSaveDocumentNameClick(e);
		const click_handler_6 = e => onEditClick(EnumDocumentProperty.Notes);
		const click_handler_7 = e => onEditCancelClick();

		function textarea_input_handler() {
			docNote = this.value;
			$$invalidate(15, docNote);
		}

		const click_handler_8 = e => onSaveDocumentNotesClick(e);
		const click_handler_9 = e => onEditClick(EnumDocumentProperty.Status);
		const click_handler_10 = e => onEditCancelClick();
		const itemselected_handler = e => onDocStatusSelect(e);
		const click_handler_11 = e => onSaveDocumentStatusClick(e);
		const click_handler_12 = e => onEditClick(EnumDocumentProperty.Type);
		const click_handler_13 = e => onEditCancelClick();
		const itemselected_handler_1 = e => onDocTypeSelect(e);
		const click_handler_14 = e => onSaveDocumentTypeClick(e);
		const click_handler_15 = e => onExpandClick();

		$$self.$$set = $$props => {
			if ('document' in $$props) $$invalidate(0, document = $$props.document);
		};

		return [
			document,
			EnumDocumentProperty,
			docTypesList,
			docStatusesList,
			selectedDocType,
			selectedDocStatus,
			selectedDocTypeValue,
			selectedDocStatusValue,
			isAuthorizedToUpdate,
			isEditDocNameEnabled,
			isEditdocNoteEnabled,
			isEditDocStatusEnabled,
			isEditDocTypeEnabled,
			isDetailExpanded,
			docName,
			docNote,
			objUrl,
			onExpandClick,
			onEditClick,
			onEditCancelClick,
			onCloseClick,
			onDownloadClick,
			onSaveDocumentNameClick,
			onSaveDocumentNotesClick,
			onSaveDocumentStatusClick,
			onSaveDocumentTypeClick,
			onDocStatusSelect,
			onDocTypeSelect,
			click_handler,
			click_handler_1,
			click_handler_2,
			click_handler_3,
			click_handler_4,
			input_input_handler,
			click_handler_5,
			click_handler_6,
			click_handler_7,
			textarea_input_handler,
			click_handler_8,
			click_handler_9,
			click_handler_10,
			itemselected_handler,
			click_handler_11,
			click_handler_12,
			click_handler_13,
			itemselected_handler_1,
			click_handler_14,
			click_handler_15
		];
	}

	class Document_preview_component extends SvelteComponent {
		constructor(options) {
			super();
			init(this, options, instance$1, create_fragment$1, safe_not_equal, { document: 0 }, add_css$1, [-1, -1]);
		}

		get document() {
			return this.$$.ctx[0];
		}

		set document(document) {
			this.$$set({ document });
			flush();
		}
	}

	customElements.define("eas-document-preview-swc", create_custom_element(Document_preview_component, {"document":{}}, [], [], true));

	/* src\lib\documents\toolbar-count\document-toolbar-count.svelte generated by Svelte v4.2.19 */

	function add_css(target) {
		append_styles(target, "svelte-ewwl0j", ".utilities--a.svelte-ewwl0j{color:#525051;width:20px;text-decoration:none;width:23px;text-decoration:none;display:block}.utilities--count.svelte-ewwl0j{font-family:\"Source Sans Pro\", Tahoma, Verdana, Segoe, sans-serif;font-size:14px}");
	}

	function create_fragment(ctx) {
		let link;
		let t0;
		let div1;
		let a;
		let t1;
		let div0;
		let t2;
		let mounted;
		let dispose;

		return {
			c() {
				link = element("link");
				t0 = space();
				div1 = element("div");
				a = element("a");
				a.innerHTML = `<i class="fa-solid fa-file-lines fa-2x"></i>`;
				t1 = space();
				div0 = element("div");
				t2 = text(/*documentCount*/ ctx[0]);
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(a, "class", "utilities--a svelte-ewwl0j");
				attr(a, "href", "javascript:void(0)");
				attr(a, "title", "View Documents");
				attr(div0, "class", "utilities--count svelte-ewwl0j");
				set_style(div1, "margin", "auto");
				set_style(div1, "margin-top", "20px");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div1, anchor);
				append(div1, a);
				append(div1, t1);
				append(div1, div0);
				append(div0, t2);

				if (!mounted) {
					dispose = listen(a, "click", /*click_handler*/ ctx[8]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*documentCount*/ 1) set_data(t2, /*documentCount*/ ctx[0]);
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div1);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function instance($$self, $$props, $$invalidate) {
		let { moduleKey = 0 } = $$props;
		let { assetTemplateKey = 0 } = $$props;
		let { immediateOwnerSourceKey = 0 } = $$props;
		let { immediateOwnerTypeKey = 0 } = $$props;
		let { compositeOwnerSourceKey = 0 } = $$props;
		let { compositeOwnerTypeKey = 0 } = $$props;
		const svelteDispatch = createEventDispatcher();
		let documentCount = 0;
		let documentService = new DocumentService();

		afterUpdate(async () => {
			console.log('getDocumentCount', moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey);
			getDocumentCount(moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey);
		});

		onMount(() => {
			// Expose the refreshDocumentCount method
			window.refreshDocumentCount = refreshDocumentCount;
		});

		function getDocumentCount(
			_moduleKey,
		_assetTemplateKey,
		_immediateOwnerSourceKey,
		_immediateOwnerTypeKey,
		_compositeOwnerSourceKey,
		_compositeOwnerTypeKey
		) {
			documentService.getDocumentCount(_moduleKey, _assetTemplateKey, _immediateOwnerSourceKey, _immediateOwnerTypeKey, _compositeOwnerSourceKey, _compositeOwnerTypeKey).then(result => {
				$$invalidate(0, documentCount = result);
			}).catch(reason => {
				$$invalidate(0, documentCount = 0);
				console.error(`error in getDocumentCount: `, reason);
			});
		}

		function refreshDocumentCount() {
			getDocumentCount(moduleKey, assetTemplateKey, immediateOwnerSourceKey, immediateOwnerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey);
		}

		function onDocumentsClick(e) {
			let eventData = {
				...e,
				detail: {
					label: "Documents",
					url: window.location.href
				}
			};

			e.stopPropagation();
			svelteDispatch("documentsclick", eventData);
		}

		const click_handler = e => onDocumentsClick(e);

		$$self.$$set = $$props => {
			if ('moduleKey' in $$props) $$invalidate(2, moduleKey = $$props.moduleKey);
			if ('assetTemplateKey' in $$props) $$invalidate(3, assetTemplateKey = $$props.assetTemplateKey);
			if ('immediateOwnerSourceKey' in $$props) $$invalidate(4, immediateOwnerSourceKey = $$props.immediateOwnerSourceKey);
			if ('immediateOwnerTypeKey' in $$props) $$invalidate(5, immediateOwnerTypeKey = $$props.immediateOwnerTypeKey);
			if ('compositeOwnerSourceKey' in $$props) $$invalidate(6, compositeOwnerSourceKey = $$props.compositeOwnerSourceKey);
			if ('compositeOwnerTypeKey' in $$props) $$invalidate(7, compositeOwnerTypeKey = $$props.compositeOwnerTypeKey);
		};

		return [
			documentCount,
			onDocumentsClick,
			moduleKey,
			assetTemplateKey,
			immediateOwnerSourceKey,
			immediateOwnerTypeKey,
			compositeOwnerSourceKey,
			compositeOwnerTypeKey,
			click_handler
		];
	}

	class Document_toolbar_count extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance,
				create_fragment,
				safe_not_equal,
				{
					moduleKey: 2,
					assetTemplateKey: 3,
					immediateOwnerSourceKey: 4,
					immediateOwnerTypeKey: 5,
					compositeOwnerSourceKey: 6,
					compositeOwnerTypeKey: 7
				},
				add_css
			);
		}

		get moduleKey() {
			return this.$$.ctx[2];
		}

		set moduleKey(moduleKey) {
			this.$$set({ moduleKey });
			flush();
		}

		get assetTemplateKey() {
			return this.$$.ctx[3];
		}

		set assetTemplateKey(assetTemplateKey) {
			this.$$set({ assetTemplateKey });
			flush();
		}

		get immediateOwnerSourceKey() {
			return this.$$.ctx[4];
		}

		set immediateOwnerSourceKey(immediateOwnerSourceKey) {
			this.$$set({ immediateOwnerSourceKey });
			flush();
		}

		get immediateOwnerTypeKey() {
			return this.$$.ctx[5];
		}

		set immediateOwnerTypeKey(immediateOwnerTypeKey) {
			this.$$set({ immediateOwnerTypeKey });
			flush();
		}

		get compositeOwnerSourceKey() {
			return this.$$.ctx[6];
		}

		set compositeOwnerSourceKey(compositeOwnerSourceKey) {
			this.$$set({ compositeOwnerSourceKey });
			flush();
		}

		get compositeOwnerTypeKey() {
			return this.$$.ctx[7];
		}

		set compositeOwnerTypeKey(compositeOwnerTypeKey) {
			this.$$set({ compositeOwnerTypeKey });
			flush();
		}
	}

	customElements.define("eas-document-count-swc", create_custom_element(Document_toolbar_count, {"moduleKey":{},"assetTemplateKey":{},"immediateOwnerSourceKey":{},"immediateOwnerTypeKey":{},"compositeOwnerSourceKey":{},"compositeOwnerTypeKey":{}}, [], [], true));

})();

(function () {
	'use strict';

	/** @returns {void} */
	function noop() {}

	function run(fn) {
		return fn();
	}

	function blank_object() {
		return Object.create(null);
	}

	/**
	 * @param {Function[]} fns
	 * @returns {void}
	 */
	function run_all(fns) {
		fns.forEach(run);
	}

	/**
	 * @param {any} thing
	 * @returns {thing is Function}
	 */
	function is_function(thing) {
		return typeof thing === 'function';
	}

	/** @returns {boolean} */
	function safe_not_equal(a, b) {
		return a != a ? b == b : a !== b || (a && typeof a === 'object') || typeof a === 'function';
	}

	/** @returns {boolean} */
	function is_empty(obj) {
		return Object.keys(obj).length === 0;
	}

	/**
	 * @param {Node} target
	 * @param {Node} node
	 * @returns {void}
	 */
	function append(target, node) {
		target.appendChild(node);
	}

	/**
	 * @param {Node} target
	 * @param {string} style_sheet_id
	 * @param {string} styles
	 * @returns {void}
	 */
	function append_styles(target, style_sheet_id, styles) {
		const append_styles_to = get_root_for_style(target);
		if (!append_styles_to.getElementById(style_sheet_id)) {
			const style = element('style');
			style.id = style_sheet_id;
			style.textContent = styles;
			append_stylesheet(append_styles_to, style);
		}
	}

	/**
	 * @param {Node} node
	 * @returns {ShadowRoot | Document}
	 */
	function get_root_for_style(node) {
		if (!node) return document;
		const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
		if (root && /** @type {ShadowRoot} */ (root).host) {
			return /** @type {ShadowRoot} */ (root);
		}
		return node.ownerDocument;
	}

	/**
	 * @param {ShadowRoot | Document} node
	 * @param {HTMLStyleElement} style
	 * @returns {CSSStyleSheet}
	 */
	function append_stylesheet(node, style) {
		append(/** @type {Document} */ (node).head || node, style);
		return style.sheet;
	}

	/**
	 * @param {Node} target
	 * @param {Node} node
	 * @param {Node} [anchor]
	 * @returns {void}
	 */
	function insert(target, node, anchor) {
		target.insertBefore(node, anchor || null);
	}

	/**
	 * @param {Node} node
	 * @returns {void}
	 */
	function detach(node) {
		if (node.parentNode) {
			node.parentNode.removeChild(node);
		}
	}

	/**
	 * @returns {void} */
	function destroy_each(iterations, detaching) {
		for (let i = 0; i < iterations.length; i += 1) {
			if (iterations[i]) iterations[i].d(detaching);
		}
	}

	/**
	 * @template {keyof HTMLElementTagNameMap} K
	 * @param {K} name
	 * @returns {HTMLElementTagNameMap[K]}
	 */
	function element(name) {
		return document.createElement(name);
	}

	/**
	 * @param {string} data
	 * @returns {Text}
	 */
	function text(data) {
		return document.createTextNode(data);
	}

	/**
	 * @returns {Text} */
	function space() {
		return text(' ');
	}

	/**
	 * @param {EventTarget} node
	 * @param {string} event
	 * @param {EventListenerOrEventListenerObject} handler
	 * @param {boolean | AddEventListenerOptions | EventListenerOptions} [options]
	 * @returns {() => void}
	 */
	function listen(node, event, handler, options) {
		node.addEventListener(event, handler, options);
		return () => node.removeEventListener(event, handler, options);
	}

	/**
	 * @param {Element} node
	 * @param {string} attribute
	 * @param {string} [value]
	 * @returns {void}
	 */
	function attr(node, attribute, value) {
		if (value == null) node.removeAttribute(attribute);
		else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
	}

	/**
	 * @returns {void} */
	function set_custom_element_data(node, prop, value) {
		const lower = prop.toLowerCase(); // for backwards compatibility with existing behavior we do lowercase first
		if (lower in node) {
			node[lower] = typeof node[lower] === 'boolean' && value === '' ? true : value;
		} else if (prop in node) {
			node[prop] = typeof node[prop] === 'boolean' && value === '' ? true : value;
		} else {
			attr(node, prop, value);
		}
	}

	/**
	 * @param {Element} element
	 * @returns {ChildNode[]}
	 */
	function children(element) {
		return Array.from(element.childNodes);
	}

	/**
	 * @param {Text} text
	 * @param {unknown} data
	 * @returns {void}
	 */
	function set_data(text, data) {
		data = '' + data;
		if (text.data === data) return;
		text.data = /** @type {string} */ (data);
	}

	/**
	 * @returns {void} */
	function set_input_value(input, value) {
		input.value = value == null ? '' : value;
	}

	/**
	 * @template T
	 * @param {string} type
	 * @param {T} [detail]
	 * @param {{ bubbles?: boolean, cancelable?: boolean }} [options]
	 * @returns {CustomEvent<T>}
	 */
	function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
		return new CustomEvent(type, { detail, bubbles, cancelable });
	}

	/**
	 * @param {HTMLElement} element
	 * @returns {{}}
	 */
	function get_custom_elements_slots(element) {
		const result = {};
		element.childNodes.forEach(
			/** @param {Element} node */ (node) => {
				result[node.slot || 'default'] = true;
			}
		);
		return result;
	}

	/**
	 * @typedef {Node & {
	 * 	claim_order?: number;
	 * 	hydrate_init?: true;
	 * 	actual_end_child?: NodeEx;
	 * 	childNodes: NodeListOf<NodeEx>;
	 * }} NodeEx
	 */

	/** @typedef {ChildNode & NodeEx} ChildNodeEx */

	/** @typedef {NodeEx & { claim_order: number }} NodeEx2 */

	/**
	 * @typedef {ChildNodeEx[] & {
	 * 	claim_info?: {
	 * 		last_index: number;
	 * 		total_claimed: number;
	 * 	};
	 * }} ChildNodeArray
	 */

	let current_component;

	/** @returns {void} */
	function set_current_component(component) {
		current_component = component;
	}

	function get_current_component() {
		if (!current_component) throw new Error('Function called outside component initialization');
		return current_component;
	}

	/**
	 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
	 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
	 * it can be called from an external module).
	 *
	 * If a function is returned _synchronously_ from `onMount`, it will be called when the component is unmounted.
	 *
	 * `onMount` does not run inside a [server-side component](https://svelte.dev/docs#run-time-server-side-component-api).
	 *
	 * https://svelte.dev/docs/svelte#onmount
	 * @template T
	 * @param {() => import('./private.js').NotFunction<T> | Promise<import('./private.js').NotFunction<T>> | (() => any)} fn
	 * @returns {void}
	 */
	function onMount(fn) {
		get_current_component().$$.on_mount.push(fn);
	}

	/**
	 * Creates an event dispatcher that can be used to dispatch [component events](https://svelte.dev/docs#template-syntax-component-directives-on-eventname).
	 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
	 *
	 * Component events created with `createEventDispatcher` create a
	 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
	 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
	 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
	 * property and can contain any type of data.
	 *
	 * The event dispatcher can be typed to narrow the allowed event names and the type of the `detail` argument:
	 * ```ts
	 * const dispatch = createEventDispatcher<{
	 *  loaded: never; // does not take a detail argument
	 *  change: string; // takes a detail argument of type string, which is required
	 *  optional: number | null; // takes an optional detail argument of type number
	 * }>();
	 * ```
	 *
	 * https://svelte.dev/docs/svelte#createeventdispatcher
	 * @template {Record<string, any>} [EventMap=any]
	 * @returns {import('./public.js').EventDispatcher<EventMap>}
	 */
	function createEventDispatcher() {
		const component = get_current_component();
		return (type, detail, { cancelable = false } = {}) => {
			const callbacks = component.$$.callbacks[type];
			if (callbacks) {
				// TODO are there situations where events could be dispatched
				// in a server (non-DOM) environment?
				const event = custom_event(/** @type {string} */ (type), detail, { cancelable });
				callbacks.slice().forEach((fn) => {
					fn.call(component, event);
				});
				return !event.defaultPrevented;
			}
			return true;
		};
	}

	const dirty_components = [];
	const binding_callbacks = [];

	let render_callbacks = [];

	const flush_callbacks = [];

	const resolved_promise = /* @__PURE__ */ Promise.resolve();

	let update_scheduled = false;

	/** @returns {void} */
	function schedule_update() {
		if (!update_scheduled) {
			update_scheduled = true;
			resolved_promise.then(flush);
		}
	}

	/** @returns {void} */
	function add_render_callback(fn) {
		render_callbacks.push(fn);
	}

	// flush() calls callbacks in this order:
	// 1. All beforeUpdate callbacks, in order: parents before children
	// 2. All bind:this callbacks, in reverse order: children before parents.
	// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
	//    for afterUpdates called during the initial onMount, which are called in
	//    reverse order: children before parents.
	// Since callbacks might update component values, which could trigger another
	// call to flush(), the following steps guard against this:
	// 1. During beforeUpdate, any updated components will be added to the
	//    dirty_components array and will cause a reentrant call to flush(). Because
	//    the flush index is kept outside the function, the reentrant call will pick
	//    up where the earlier call left off and go through all dirty components. The
	//    current_component value is saved and restored so that the reentrant call will
	//    not interfere with the "parent" flush() call.
	// 2. bind:this callbacks cannot trigger new flush() calls.
	// 3. During afterUpdate, any updated components will NOT have their afterUpdate
	//    callback called a second time; the seen_callbacks set, outside the flush()
	//    function, guarantees this behavior.
	const seen_callbacks = new Set();

	let flushidx = 0; // Do *not* move this inside the flush() function

	/** @returns {void} */
	function flush() {
		// Do not reenter flush while dirty components are updated, as this can
		// result in an infinite loop. Instead, let the inner flush handle it.
		// Reentrancy is ok afterwards for bindings etc.
		if (flushidx !== 0) {
			return;
		}
		const saved_component = current_component;
		do {
			// first, call beforeUpdate functions
			// and update components
			try {
				while (flushidx < dirty_components.length) {
					const component = dirty_components[flushidx];
					flushidx++;
					set_current_component(component);
					update(component.$$);
				}
			} catch (e) {
				// reset dirty state to not end up in a deadlocked state and then rethrow
				dirty_components.length = 0;
				flushidx = 0;
				throw e;
			}
			set_current_component(null);
			dirty_components.length = 0;
			flushidx = 0;
			while (binding_callbacks.length) binding_callbacks.pop()();
			// then, once components are updated, call
			// afterUpdate functions. This may cause
			// subsequent updates...
			for (let i = 0; i < render_callbacks.length; i += 1) {
				const callback = render_callbacks[i];
				if (!seen_callbacks.has(callback)) {
					// ...so guard against infinite loops
					seen_callbacks.add(callback);
					callback();
				}
			}
			render_callbacks.length = 0;
		} while (dirty_components.length);
		while (flush_callbacks.length) {
			flush_callbacks.pop()();
		}
		update_scheduled = false;
		seen_callbacks.clear();
		set_current_component(saved_component);
	}

	/** @returns {void} */
	function update($$) {
		if ($$.fragment !== null) {
			$$.update();
			run_all($$.before_update);
			const dirty = $$.dirty;
			$$.dirty = [-1];
			$$.fragment && $$.fragment.p($$.ctx, dirty);
			$$.after_update.forEach(add_render_callback);
		}
	}

	/**
	 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
	 * @param {Function[]} fns
	 * @returns {void}
	 */
	function flush_render_callbacks(fns) {
		const filtered = [];
		const targets = [];
		render_callbacks.forEach((c) => (fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c)));
		targets.forEach((c) => c());
		render_callbacks = filtered;
	}

	const outroing = new Set();

	/**
	 * @param {import('./private.js').Fragment} block
	 * @param {0 | 1} [local]
	 * @returns {void}
	 */
	function transition_in(block, local) {
		if (block && block.i) {
			outroing.delete(block);
			block.i(local);
		}
	}

	/** @typedef {1} INTRO */
	/** @typedef {0} OUTRO */
	/** @typedef {{ direction: 'in' | 'out' | 'both' }} TransitionOptions */
	/** @typedef {(node: Element, params: any, options: TransitionOptions) => import('../transition/public.js').TransitionConfig} TransitionFn */

	/**
	 * @typedef {Object} Outro
	 * @property {number} r
	 * @property {Function[]} c
	 * @property {Object} p
	 */

	/**
	 * @typedef {Object} PendingProgram
	 * @property {number} start
	 * @property {INTRO|OUTRO} b
	 * @property {Outro} [group]
	 */

	/**
	 * @typedef {Object} Program
	 * @property {number} a
	 * @property {INTRO|OUTRO} b
	 * @property {1|-1} d
	 * @property {number} duration
	 * @property {number} start
	 * @property {number} end
	 * @property {Outro} [group]
	 */

	// general each functions:

	function ensure_array_like(array_like_or_iterator) {
		return array_like_or_iterator?.length !== undefined
			? array_like_or_iterator
			: Array.from(array_like_or_iterator);
	}

	/** @returns {void} */
	function mount_component(component, target, anchor) {
		const { fragment, after_update } = component.$$;
		fragment && fragment.m(target, anchor);
		// onMount happens before the initial afterUpdate
		add_render_callback(() => {
			const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
			// if the component was destroyed immediately
			// it will update the `$$.on_destroy` reference to `null`.
			// the destructured on_destroy may still reference to the old array
			if (component.$$.on_destroy) {
				component.$$.on_destroy.push(...new_on_destroy);
			} else {
				// Edge case - component was destroyed immediately,
				// most likely as a result of a binding initialising
				run_all(new_on_destroy);
			}
			component.$$.on_mount = [];
		});
		after_update.forEach(add_render_callback);
	}

	/** @returns {void} */
	function destroy_component(component, detaching) {
		const $$ = component.$$;
		if ($$.fragment !== null) {
			flush_render_callbacks($$.after_update);
			run_all($$.on_destroy);
			$$.fragment && $$.fragment.d(detaching);
			// TODO null out other refs, including component.$$ (but need to
			// preserve final state?)
			$$.on_destroy = $$.fragment = null;
			$$.ctx = [];
		}
	}

	/** @returns {void} */
	function make_dirty(component, i) {
		if (component.$$.dirty[0] === -1) {
			dirty_components.push(component);
			schedule_update();
			component.$$.dirty.fill(0);
		}
		component.$$.dirty[(i / 31) | 0] |= 1 << i % 31;
	}

	// TODO: Document the other params
	/**
	 * @param {SvelteComponent} component
	 * @param {import('./public.js').ComponentConstructorOptions} options
	 *
	 * @param {import('./utils.js')['not_equal']} not_equal Used to compare props and state values.
	 * @param {(target: Element | ShadowRoot) => void} [append_styles] Function that appends styles to the DOM when the component is first initialised.
	 * This will be the `add_css` function from the compiled component.
	 *
	 * @returns {void}
	 */
	function init(
		component,
		options,
		instance,
		create_fragment,
		not_equal,
		props,
		append_styles = null,
		dirty = [-1]
	) {
		const parent_component = current_component;
		set_current_component(component);
		/** @type {import('./private.js').T$$} */
		const $$ = (component.$$ = {
			fragment: null,
			ctx: [],
			// state
			props,
			update: noop,
			not_equal,
			bound: blank_object(),
			// lifecycle
			on_mount: [],
			on_destroy: [],
			on_disconnect: [],
			before_update: [],
			after_update: [],
			context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
			// everything else
			callbacks: blank_object(),
			dirty,
			skip_bound: false,
			root: options.target || parent_component.$$.root
		});
		append_styles && append_styles($$.root);
		let ready = false;
		$$.ctx = instance
			? instance(component, options.props || {}, (i, ret, ...rest) => {
					const value = rest.length ? rest[0] : ret;
					if ($$.ctx && not_equal($$.ctx[i], ($$.ctx[i] = value))) {
						if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
						if (ready) make_dirty(component, i);
					}
					return ret;
			  })
			: [];
		$$.update();
		ready = true;
		run_all($$.before_update);
		// `false` as a special case of no DOM component
		$$.fragment = create_fragment ? create_fragment($$.ctx) : false;
		if (options.target) {
			if (options.hydrate) {
				// TODO: what is the correct type here?
				// @ts-expect-error
				const nodes = children(options.target);
				$$.fragment && $$.fragment.l(nodes);
				nodes.forEach(detach);
			} else {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				$$.fragment && $$.fragment.c();
			}
			if (options.intro) transition_in(component.$$.fragment);
			mount_component(component, options.target, options.anchor);
			flush();
		}
		set_current_component(parent_component);
	}

	let SvelteElement;

	if (typeof HTMLElement === 'function') {
		SvelteElement = class extends HTMLElement {
			/** The Svelte component constructor */
			$$ctor;
			/** Slots */
			$$s;
			/** The Svelte component instance */
			$$c;
			/** Whether or not the custom element is connected */
			$$cn = false;
			/** Component props data */
			$$d = {};
			/** `true` if currently in the process of reflecting component props back to attributes */
			$$r = false;
			/** @type {Record<string, CustomElementPropDefinition>} Props definition (name, reflected, type etc) */
			$$p_d = {};
			/** @type {Record<string, Function[]>} Event listeners */
			$$l = {};
			/** @type {Map<Function, Function>} Event listener unsubscribe functions */
			$$l_u = new Map();

			constructor($$componentCtor, $$slots, use_shadow_dom) {
				super();
				this.$$ctor = $$componentCtor;
				this.$$s = $$slots;
				if (use_shadow_dom) {
					this.attachShadow({ mode: 'open' });
				}
			}

			addEventListener(type, listener, options) {
				// We can't determine upfront if the event is a custom event or not, so we have to
				// listen to both. If someone uses a custom event with the same name as a regular
				// browser event, this fires twice - we can't avoid that.
				this.$$l[type] = this.$$l[type] || [];
				this.$$l[type].push(listener);
				if (this.$$c) {
					const unsub = this.$$c.$on(type, listener);
					this.$$l_u.set(listener, unsub);
				}
				super.addEventListener(type, listener, options);
			}

			removeEventListener(type, listener, options) {
				super.removeEventListener(type, listener, options);
				if (this.$$c) {
					const unsub = this.$$l_u.get(listener);
					if (unsub) {
						unsub();
						this.$$l_u.delete(listener);
					}
				}
			}

			async connectedCallback() {
				this.$$cn = true;
				if (!this.$$c) {
					// We wait one tick to let possible child slot elements be created/mounted
					await Promise.resolve();
					if (!this.$$cn || this.$$c) {
						return;
					}
					function create_slot(name) {
						return () => {
							let node;
							const obj = {
								c: function create() {
									node = element('slot');
									if (name !== 'default') {
										attr(node, 'name', name);
									}
								},
								/**
								 * @param {HTMLElement} target
								 * @param {HTMLElement} [anchor]
								 */
								m: function mount(target, anchor) {
									insert(target, node, anchor);
								},
								d: function destroy(detaching) {
									if (detaching) {
										detach(node);
									}
								}
							};
							return obj;
						};
					}
					const $$slots = {};
					const existing_slots = get_custom_elements_slots(this);
					for (const name of this.$$s) {
						if (name in existing_slots) {
							$$slots[name] = [create_slot(name)];
						}
					}
					for (const attribute of this.attributes) {
						// this.$$data takes precedence over this.attributes
						const name = this.$$g_p(attribute.name);
						if (!(name in this.$$d)) {
							this.$$d[name] = get_custom_element_value(name, attribute.value, this.$$p_d, 'toProp');
						}
					}
					// Port over props that were set programmatically before ce was initialized
					for (const key in this.$$p_d) {
						if (!(key in this.$$d) && this[key] !== undefined) {
							this.$$d[key] = this[key]; // don't transform, these were set through JavaScript
							delete this[key]; // remove the property that shadows the getter/setter
						}
					}
					this.$$c = new this.$$ctor({
						target: this.shadowRoot || this,
						props: {
							...this.$$d,
							$$slots,
							$$scope: {
								ctx: []
							}
						}
					});

					// Reflect component props as attributes
					const reflect_attributes = () => {
						this.$$r = true;
						for (const key in this.$$p_d) {
							this.$$d[key] = this.$$c.$$.ctx[this.$$c.$$.props[key]];
							if (this.$$p_d[key].reflect) {
								const attribute_value = get_custom_element_value(
									key,
									this.$$d[key],
									this.$$p_d,
									'toAttribute'
								);
								if (attribute_value == null) {
									this.removeAttribute(this.$$p_d[key].attribute || key);
								} else {
									this.setAttribute(this.$$p_d[key].attribute || key, attribute_value);
								}
							}
						}
						this.$$r = false;
					};
					this.$$c.$$.after_update.push(reflect_attributes);
					reflect_attributes(); // once initially because after_update is added too late for first render

					for (const type in this.$$l) {
						for (const listener of this.$$l[type]) {
							const unsub = this.$$c.$on(type, listener);
							this.$$l_u.set(listener, unsub);
						}
					}
					this.$$l = {};
				}
			}

			// We don't need this when working within Svelte code, but for compatibility of people using this outside of Svelte
			// and setting attributes through setAttribute etc, this is helpful
			attributeChangedCallback(attr, _oldValue, newValue) {
				if (this.$$r) return;
				attr = this.$$g_p(attr);
				this.$$d[attr] = get_custom_element_value(attr, newValue, this.$$p_d, 'toProp');
				this.$$c?.$set({ [attr]: this.$$d[attr] });
			}

			disconnectedCallback() {
				this.$$cn = false;
				// In a microtask, because this could be a move within the DOM
				Promise.resolve().then(() => {
					if (!this.$$cn && this.$$c) {
						this.$$c.$destroy();
						this.$$c = undefined;
					}
				});
			}

			$$g_p(attribute_name) {
				return (
					Object.keys(this.$$p_d).find(
						(key) =>
							this.$$p_d[key].attribute === attribute_name ||
							(!this.$$p_d[key].attribute && key.toLowerCase() === attribute_name)
					) || attribute_name
				);
			}
		};
	}

	/**
	 * @param {string} prop
	 * @param {any} value
	 * @param {Record<string, CustomElementPropDefinition>} props_definition
	 * @param {'toAttribute' | 'toProp'} [transform]
	 */
	function get_custom_element_value(prop, value, props_definition, transform) {
		const type = props_definition[prop]?.type;
		value = type === 'Boolean' && typeof value !== 'boolean' ? value != null : value;
		if (!transform || !props_definition[prop]) {
			return value;
		} else if (transform === 'toAttribute') {
			switch (type) {
				case 'Object':
				case 'Array':
					return value == null ? null : JSON.stringify(value);
				case 'Boolean':
					return value ? '' : null;
				case 'Number':
					return value == null ? null : value;
				default:
					return value;
			}
		} else {
			switch (type) {
				case 'Object':
				case 'Array':
					return value && JSON.parse(value);
				case 'Boolean':
					return value; // conversion already handled above
				case 'Number':
					return value != null ? +value : value;
				default:
					return value;
			}
		}
	}

	/**
	 * @internal
	 *
	 * Turn a Svelte component into a custom element.
	 * @param {import('./public.js').ComponentType} Component  A Svelte component constructor
	 * @param {Record<string, CustomElementPropDefinition>} props_definition  The props to observe
	 * @param {string[]} slots  The slots to create
	 * @param {string[]} accessors  Other accessors besides the ones for props the component has
	 * @param {boolean} use_shadow_dom  Whether to use shadow DOM
	 * @param {(ce: new () => HTMLElement) => new () => HTMLElement} [extend]
	 */
	function create_custom_element(
		Component,
		props_definition,
		slots,
		accessors,
		use_shadow_dom,
		extend
	) {
		let Class = class extends SvelteElement {
			constructor() {
				super(Component, slots, use_shadow_dom);
				this.$$p_d = props_definition;
			}
			static get observedAttributes() {
				return Object.keys(props_definition).map((key) =>
					(props_definition[key].attribute || key).toLowerCase()
				);
			}
		};
		Object.keys(props_definition).forEach((prop) => {
			Object.defineProperty(Class.prototype, prop, {
				get() {
					return this.$$c && prop in this.$$c ? this.$$c[prop] : this.$$d[prop];
				},
				set(value) {
					value = get_custom_element_value(prop, value, props_definition);
					this.$$d[prop] = value;
					this.$$c?.$set({ [prop]: value });
				}
			});
		});
		accessors.forEach((accessor) => {
			Object.defineProperty(Class.prototype, accessor, {
				get() {
					return this.$$c?.[accessor];
				}
			});
		});
		if (extend) {
			// @ts-expect-error - assigning here is fine
			Class = extend(Class);
		}
		Component.element = /** @type {any} */ (Class);
		return Class;
	}

	/**
	 * Base class for Svelte components. Used when dev=false.
	 *
	 * @template {Record<string, any>} [Props=any]
	 * @template {Record<string, any>} [Events=any]
	 */
	class SvelteComponent {
		/**
		 * ### PRIVATE API
		 *
		 * Do not use, may change at any time
		 *
		 * @type {any}
		 */
		$$ = undefined;
		/**
		 * ### PRIVATE API
		 *
		 * Do not use, may change at any time
		 *
		 * @type {any}
		 */
		$$set = undefined;

		/** @returns {void} */
		$destroy() {
			destroy_component(this, 1);
			this.$destroy = noop;
		}

		/**
		 * @template {Extract<keyof Events, string>} K
		 * @param {K} type
		 * @param {((e: Events[K]) => void) | null | undefined} callback
		 * @returns {() => void}
		 */
		$on(type, callback) {
			if (!is_function(callback)) {
				return noop;
			}
			const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
			callbacks.push(callback);
			return () => {
				const index = callbacks.indexOf(callback);
				if (index !== -1) callbacks.splice(index, 1);
			};
		}

		/**
		 * @param {Partial<Props>} props
		 * @returns {void}
		 */
		$set(props) {
			if (this.$$set && !is_empty(props)) {
				this.$$.skip_bound = true;
				this.$$set(props);
				this.$$.skip_bound = false;
			}
		}
	}

	/**
	 * @typedef {Object} CustomElementPropDefinition
	 * @property {string} [attribute]
	 * @property {boolean} [reflect]
	 * @property {'String'|'Boolean'|'Number'|'Array'|'Object'} [type]
	 */

	// generated during release, do not modify

	const PUBLIC_VERSION = '4';

	if (typeof window !== 'undefined')
		// @ts-ignore
		(window.__svelte || (window.__svelte = { v: new Set() })).v.add(PUBLIC_VERSION);

	class ServiceBase {
	    _headers = new Headers();
	    easBaseUrl;
	    easDataloadBaseUrl;
	    monitoringBaseUrl;
	    easAssetAuthUrl;
	    helpBaseUrl;
	    easUtilityUrl;
	    easWorkflowBaseUrl;
	    easContactBaseUrl;
	    validationResultsUrl;
	    validationRevalidateUrl;
	    apiEndPoint;
	    easCommunicationLogUrl;
	    easCommunicationUrl;
	    accessToken;
	    claimToken;
	    get headers() {
	        // Every time we get the headers, we need to check if the access token and claims token
	        // are already loaded. If not, we need to load them from session storage. 
	        // Otherwise it just returns the headers without any change. - kevin.low 01/02/24
	        if (!('accessToken' in this.accessToken)) {
	            console.error('accessToken not in this.accessToken. Reloading it from session storage.');
	            try {
	                this.accessToken = JSON.parse(sessionStorage.getItem('accessToken') ?? '{}');
	                if (!('accessToken' in this.accessToken)) {
	                    console.error('accessToken is still not found in session storage.');
	                }
	                else {
	                    this._headers.delete('Authorization');
	                    this._headers.append('Authorization', `Bearer ${this.accessToken?.accessToken}`);
	                }
	            }
	            catch (error) {
	                console.error(error);
	            }
	        }
	        try {
	            let updatedClaimToken = JSON.parse(sessionStorage.getItem('claims') ?? '{}');
	            if (!('claimsJwt' in this.claimToken)) {
	                console.error('claims is still not found in session storage.');
	            }
	            else {
	                if (this.claimToken?.claimsJwt != updatedClaimToken?.claimsJwt) {
	                    this._headers.delete('claims');
	                    this._headers.append('claims', this.claimToken?.claimsJwt);
	                }
	            }
	        }
	        catch (error) {
	            console.error(error);
	        }
	        return this._headers;
	    }
	    set headers(value) {
	        this._headers = value;
	    }
	    constructor() {
	        //Storybook url
	        if (window.location.href.includes(':6006')) {
	            sessionStorage.setItem('EAS_Base_Url', 'https://edu-dev-eas-assetauth.azurewebsites.net');
	            sessionStorage.setItem('EAS_Dataload_Base_Url', 'https://edu-dev-eas-dataload-request.azurewebsites.net');
	            sessionStorage.setItem('Asset_Auth_Url', 'https://edu-dev-eas-assetauth.azurewebsites.net');
	            sessionStorage.setItem('Eas_Help_Url', 'https://edu-dev-ent-help.azurewebsites.net');
	            sessionStorage.setItem('Eas_Utility_Url', 'https://edu-dev-eas-utility.azurewebsites.net');
	            sessionStorage.setItem('Eas_Workflow_Url', 'https://edu-dev-eas-workflow.azurewebsites.net');
	            sessionStorage.setItem('Eas_Contact_Url', 'https://edu-dev-eas-contact.azurewebsites.net');
	            sessionStorage.setItem('Eas_CommunicationLog_Url', 'https://edu-dev-eas-communicationlog.azurewebsites.net');
	            sessionStorage.setItem('Eas_Communication_Url', 'https://edu-dev-eas-communication.azurewebsites.net');
	            sessionStorage.setItem('accessToken', `{"accessToken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYzYmVjNmVkLWRlMDUtNGQxZS05ZTI0LTQwZTJlNTUxNGQzYSIsInVuaXF1ZV9uYW1lIjoiOTUzMDQiLCJmaXJzdF9uYW1lIjoiRGlhbmUiLCJsYXN0X25hbWUiOiJOZWFsIiwicGVyc29uX2tleSI6Ijk1MzA0Iiwic3lzdGVtX2tleSI6IjMwIiwidXVpZCI6IkE5Uk8wR1RXSklTTFJCSEo1UkU4WVVYTTlTUFJOSEIwVTk0QyIsInN5c3RlbV91cmwiOiJodHRwczovL2Vkc3RlcHNkZXYuZWR1Y2F0aW9uLm9oaW8uZ292L29uZWZ1bmRpbmcvIiwic3lzdGVtX25hbWUiOiJPbmUgRnVuZGluZyBBcHBsaWNhdGlvbiIsIm9mZmljZV9lbWFpbCI6IiIsImhvbWVfZW1haWwiOiIiLCJvYWtzX2lkIjoiIiwibmJmIjoxNzI3Nzg2MDQyLCJleHAiOjE3Mjc4NzI0NDIsImlhdCI6MTcyNzc4NjA0MiwiaXNzIjoib2hpby1kZXBhcnRtZW50LW9mLWVkdWNhdGlvbiIsImF1ZCI6ImVhc19hdWRpZW5jZSJ9.ZxhT5--NANxGfhrG15E_uCJp3iCR9nu_hykdzROYYN4","orgs":[{"org_id":6108,"name":"Ohio Department of Education and Workforce","audiences":[{"aud_id":1,"name":"Admin","applications":[{"app_id":231,"name":"One Funding Application","url":null}]}],"irn":"050765"}],"expires":"2024-10-02T08:34:02.4470379Z","public":false}`);
	            sessionStorage.setItem('claims', `{"claimsJwt":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYwNDdhZTYwLWE3Y2YtNDlhMy1hNjdiLTQ4YzgxYTIwMzU1ZSIsImFwcGxpY2F0aW9uX2tleSI6IjIzMSIsImF1ZGllbmNlX2tleSI6IjEiLCJvcmdfa2V5IjoiNjEwOCIsIm9yZ19uYW1lIjoiT2hpbyBEZXBhcnRtZW50IG9mIEVkdWNhdGlvbiBhbmQgV29ya2ZvcmNlIiwiaXJuIjoiMDUwNzY1Iiwib3JnX3R5cGVfa2V5IjoiMjciLCJvcmdfdHlwZV9uYW1lIjoiU3RhdGUgQm9hcmQvQWdlbmN5Iiwicm9sZV9jb250ZXh0IjoiMjciLCJjb250YWN0X2NvbnRleHRfaWQiOiIzNDAiLCJjb250YWN0X2NvbnRleHRfdXJsIjoiaHR0cHM6Ly9lZHUtZGV2LW9uZS1mdW5kaW5nLWdhdGV3YXkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL0NvbnRhY3RDb250ZXh0LzM0MCIsIm5iZiI6MTcyNzc4NjA1NSwiZXhwIjoxNzI3ODcyNDU1LCJpYXQiOjE3Mjc3ODYwNTUsImlzcyI6Im9oaW8tZGVwYXJ0bWVudC1vZi1lZHVjYXRpb24iLCJhdWQiOiJlYXNfYXVkaWVuY2UifQ.rX-IV9OdOKB2SeqGE171a0Ks-h6Mzy5VoIp1pSO9sg0","claims":{"organizationId":6108,"audienceId":1,"applicationId":231,"contactContextId":"340","contactContextUrl":"https://edu-dev-one-funding-gateway.azurewebsites.net/api/ContactContext/340"}}`);
	        }
	        this.easBaseUrl = sessionStorage.getItem('EAS_Base_Url') ?? '';
	        this.easDataloadBaseUrl = sessionStorage.getItem('EAS_Dataload_Base_Url') ?? '';
	        this.monitoringBaseUrl = sessionStorage.getItem('Monitoring_Base_Url') ?? '';
	        this.easAssetAuthUrl = sessionStorage.getItem('Asset_Auth_Url') ?? '';
	        this.helpBaseUrl = sessionStorage.getItem('Eas_Help_Url') ?? '';
	        this.easUtilityUrl = sessionStorage.getItem('Eas_Utility_Url') ?? '';
	        this.easWorkflowBaseUrl = sessionStorage.getItem('Eas_Workflow_Url') ?? '';
	        this.easContactBaseUrl = sessionStorage.getItem('Eas_Contact_Url') ?? '';
	        this.validationResultsUrl = sessionStorage.getItem('Validation_Results_Url') ?? '';
	        this.validationRevalidateUrl = sessionStorage.getItem('Validation_Revalidate_Url') ?? '';
	        this.apiEndPoint = sessionStorage.getItem('APIEndPoint') ?? '';
	        this.easCommunicationLogUrl = sessionStorage.getItem('Eas_CommunicationLog_Url') ?? '';
	        this.easCommunicationUrl = sessionStorage.getItem('Eas_Communication_Url') ?? '';
	        try {
	            this.accessToken = JSON.parse(sessionStorage.getItem('accessToken') ?? '{}');
	            if (!('accessToken' in this.accessToken)) {
	                console.error('accessToken is not found in session storage.');
	            }
	        }
	        catch (error) {
	            console.log(error);
	        }
	        try {
	            this.claimToken = JSON.parse(sessionStorage.getItem('claims') ?? '{}');
	            if (!('claimsJwt' in this.claimToken)) {
	                console.error('claims is not found in session storage.');
	            }
	        }
	        catch (error) {
	            console.error(error);
	        }
	        this.headers = new Headers();
	        this.headers.append('Content-Type', 'application/json');
	        this.headers.append('Authorization', `Bearer ${this.accessToken?.accessToken}`);
	        //this.headers.append('Authorization', `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYzYmVjNmVkLWRlMDUtNGQxZS05ZTI0LTQwZTJlNTUxNGQzYSIsInVuaXF1ZV9uYW1lIjoiOTUzMDQiLCJmaXJzdF9uYW1lIjoiRGlhbmUiLCJsYXN0X25hbWUiOiJOZWFsIiwicGVyc29uX2tleSI6Ijk1MzA0Iiwic3lzdGVtX2tleSI6IjMwIiwidXVpZCI6IkE5Uk8wR1RXSklTTFJCSEo1UkU4WVVYTTlTUFJOSEIwVTk0QyIsInN5c3RlbV91cmwiOiJodHRwczovL2Vkc3RlcHNkZXYuZWR1Y2F0aW9uLm9oaW8uZ292L29uZWZ1bmRpbmcvIiwic3lzdGVtX25hbWUiOiJPbmUgRnVuZGluZyBBcHBsaWNhdGlvbiIsIm9mZmljZV9lbWFpbCI6IiIsImhvbWVfZW1haWwiOiIiLCJvYWtzX2lkIjoiIiwibmJmIjoxNzI3Nzg2MDQyLCJleHAiOjE3Mjc4NzI0NDIsImlhdCI6MTcyNzc4NjA0MiwiaXNzIjoib2hpby1kZXBhcnRtZW50LW9mLWVkdWNhdGlvbiIsImF1ZCI6ImVhc19hdWRpZW5jZSJ9.ZxhT5--NANxGfhrG15E_uCJp3iCR9nu_hykdzROYYN4`);
	        this.headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
	        this.headers.append('x-requestid', this.generateUUID());
	        this.headers.append('claims', this.claimToken?.claimsJwt);
	        //this.headers.append('claims', `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYwNDdhZTYwLWE3Y2YtNDlhMy1hNjdiLTQ4YzgxYTIwMzU1ZSIsImFwcGxpY2F0aW9uX2tleSI6IjIzMSIsImF1ZGllbmNlX2tleSI6IjEiLCJvcmdfa2V5IjoiNjEwOCIsIm9yZ19uYW1lIjoiT2hpbyBEZXBhcnRtZW50IG9mIEVkdWNhdGlvbiBhbmQgV29ya2ZvcmNlIiwiaXJuIjoiMDUwNzY1Iiwib3JnX3R5cGVfa2V5IjoiMjciLCJvcmdfdHlwZV9uYW1lIjoiU3RhdGUgQm9hcmQvQWdlbmN5Iiwicm9sZV9jb250ZXh0IjoiMjciLCJjb250YWN0X2NvbnRleHRfaWQiOiIzNDAiLCJjb250YWN0X2NvbnRleHRfdXJsIjoiaHR0cHM6Ly9lZHUtZGV2LW9uZS1mdW5kaW5nLWdhdGV3YXkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL0NvbnRhY3RDb250ZXh0LzM0MCIsIm5iZiI6MTcyNzc4NjA1NSwiZXhwIjoxNzI3ODcyNDU1LCJpYXQiOjE3Mjc3ODYwNTUsImlzcyI6Im9oaW8tZGVwYXJ0bWVudC1vZi1lZHVjYXRpb24iLCJhdWQiOiJlYXNfYXVkaWVuY2UifQ.rX-IV9OdOKB2SeqGE171a0Ks-h6Mzy5VoIp1pSO9sg0`);
	    }
	    getJSON = (url) => {
	        return fetch(url, { headers: this.headers })
	            .then(response => {
	            return response.status === 204 ? [] : response.json();
	        });
	    };
	    postJSON = (url, payload) => {
	        return fetch(url, { method: 'POST', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => {
	            return response.json();
	        });
	    };
	    putJSON = (url, payload) => {
	        return fetch(url, { method: 'PUT', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => response.json());
	    };
	    putData = (url) => {
	        return fetch(url, { method: 'PUT', headers: this.headers })
	            .then(response => response.json());
	    };
	    deleteJSON = (url, payload) => {
	        return fetch(url, { method: 'DELETE', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => response.json());
	    };
	    postData = (url, payload) => {
	        return fetch(url, { method: 'POST', body: payload, headers: this.headers })
	            .then(response => response.json());
	    };
	    getString = (url) => {
	        return fetch(url, { headers: this.headers })
	            .then(response => response.text());
	    };
	    uploadFile = (url, payload) => {
	        this.headers.delete('Content-Type');
	        //this.headers.append('Content-Type', 'multipart/form-data; boundary=----WebKitFormBoundaryaw7OAy2cWKU1Ndnn');
	        return fetch(url, { method: 'POST', body: payload, headers: this.headers })
	            .then(data => data.text());
	    };
	    getFile = (url) => {
	        this.headers.delete('Content-Type');
	        const options = {
	            headers: this.headers,
	            observe: 'body', // return data only
	            responseType: 'blob' // return type for binary data; json is default
	        };
	        return fetch(url, options);
	        //.then(response => response);
	    };
	    get = (url) => {
	        this.headers.delete('Content-Type');
	        return fetch(url, { headers: this.headers });
	        //.then(response => response);
	    };
	    generateUUID() {
	        var d = new Date().getTime(); //Timestamp
	        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16; //random number between 0 and 16
	            if (d > 0) { //Use timestamp until depleted
	                r = (d + r) % 16 | 0;
	                d = Math.floor(d / 16);
	            }
	            else { //Use microseconds since page-load if supported
	                r = (d2 + r) % 16 | 0;
	                d2 = Math.floor(d2 / 16);
	            }
	            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	        });
	    }
	}

	class WorkflowStatusService extends ServiceBase {
	    // workflowApiBaseUrl = `https://edu-dev-eas-workflow.azurewebsites.net`;
	    // workflowApiBaseUrl: string = `http://localhost:5870`;
	    workflowApiBaseUrl = this.easWorkflowBaseUrl;
	    updateRequest = [];
	    getWorkflowStatus(applicationKey, moduleKey, workflowTypeKey, ownerSourceKey, ownerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, itemContext) {
	        // applicationKey and itemContextfilter are optional but being blank causes a 400 error so if it's blank, don't include in the url - kevin.low 10/13/23
	        const applicationKeyParam = applicationKey ? `applicationKey=${applicationKey}&` : '';
	        const itemContextParam = itemContext ? `&itemContextfilter=${itemContext}` : '';
	        const _url = `${this.workflowApiBaseUrl}/api/v5/workflow?${applicationKeyParam}moduleKey=${moduleKey || ''}&` +
	            `workflowOwnerSourceKey=${ownerSourceKey || ''}&workflowOwnerTypeKey=${ownerTypeKey || ''}&workflowTypeKey=${workflowTypeKey || ''}&` +
	            `workflowCompositeOwnerSourceKey=${compositeOwnerSourceKey || ''}&workflowCompositeOwnerTypeKey=${compositeOwnerTypeKey || ''}` +
	            `${itemContextParam}`;
	        const result = new Promise((resolve, reject) => {
	            this.getJSON(_url)
	                .then((data) => {
	                resolve(data);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	    updateWorkflowStatus(applicationKey, moduleKey, workflowTypeKey, ownerSourceKey, ownerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, itemContext, workflowComment, workflowStateKey) {
	        const _url = `${this.workflowApiBaseUrl}/api/v5/workflow/update`;
	        const payload = {
	            applicationKey: applicationKey,
	            workflowStateKey: workflowStateKey,
	            moduleKey: moduleKey,
	            workflowOwnerSourceKey: ownerSourceKey,
	            workflowOwnerTypeKey: ownerTypeKey,
	            workflowTypeKey: workflowTypeKey,
	            workflowCompositeOwnerSourceKey: compositeOwnerSourceKey,
	            workflowCompositeOwnerTypeKey: compositeOwnerTypeKey,
	            itemContextfilter: itemContext,
	            workflowComment: workflowComment
	        };
	        this.updateRequest = [];
	        this.updateRequest.push(payload);
	        const result = new Promise((resolve, reject) => {
	            this.putJSON(_url, this.updateRequest)
	                .then((data) => {
	                this.updateRequest = [];
	                resolve(data);
	            }).catch((err) => {
	                this.updateRequest = [];
	                reject(err);
	            });
	        });
	        return result;
	    }
	}

	/* src\lib\workflow-transition\workflow-status\eas-workflow-status.svelte generated by Svelte v4.2.19 */

	function add_css$1(target) {
		append_styles(target, "svelte-13x4eic", ":host{--gray-800:#2c2c2c;--gray-700:#434343;--gray-600:#8C8C8C;--gray-500:#BFBFBF;--gray-400:#D9D9D9;--gray-300:#E8E8E8;--gray-250:#F0F0F0;--gray-200:#F2F2F2;--gray-100:#F6F6F6;--gray-50:#F7F7F7;--maroon-800:#700017;--maroon-700:#8B3043;--maroon-600:#99495A;--maroon-500:#AA6D7E;--maroon-400:#BF95A5;--maroon-300:#E9D9DC;--maroon-200:#F5EEEE;--maroon-100:#FAF6F6;--maroon-lte-100:#faf6f6;--maroon-lte-200:#f5eeee;--red-800:#EA1014;--red-700:#F1353A;--red-600:#F4595C;--red-500:#F57174;--red-400:#F7888B;--red-300:#F9ACAE;--red-200:#FBC4C5;--red-100:#FDE7E7;--red-50:#faf6f6;--blue-800:#3d7aa9;--blue-700:#4781ad;--blue-600:#5f91b7;--blue-500:#749fc1;--blue-400:#9ebcd4;--blue-300:#c4d7e5;--blue-200:#e2ebf2;--blue-100:#f4f7fa;--blue-lte-100:#eff0f5;--lte-blue-800:#73A5CC;--lte-blue-700:#88B2D4;--lte-blue-600:#A4C4DE;--lte-blue-500:#C0D6E8;--lte-blue-400:#CEE0ED;--lte-blue-300:#DCE8F2;--lte-blue-200:#EAF2F7;--lte-blue-100:#F4F8FB;--gold-800:#ffbe0e;--gold-700:#ffce4a;--gold-600:#fad87b;--gold-500:#f8de9b;--gold-400:#f6e2b2;--gold-300:#f4e7ca;--gold-200:#f2ebdd;--gold-100:#f3f1ed;--drk-green-800:#5E8000;--drk-green-700:#6E8C19;--drk-green-600:#7E9933;--drk-green-500:#8EA64C;--drk-green-400:#AEBF7F;--drk-green-300:#C7D3A6;--drk-green-200:#DFE6CC;--drk-green-100:#EFF2E5;--green-800:#B5DC10;--green-700:#BCDF27;--green-600:#C4E340;--green-500:#CBE657;--green-400:#DAED87;--green-300:#E5F3AC;--green-200:#F0F8CF;--green-100:#F7FBE7;--ohid-blue-100:#EBF7FF;--ohid-blue-200:#D9EFFF;--ohid-blue-300:#BFE5FF;--ohid-blue-400:#A6DAFF;--ohid-blue-500:#8CD0FF;--ohid-blue-600:#59BBFF;--ohid-blue-700:#26A6FF;--ohid-blue-800:#0096FF;--ohid-drk-blue-100:#ECF0F4;--ohid-drk-blue-200:#DAE3E9;--ohid-drk-blue-300:#C2D0DB;--ohid-drk-blue-400:#A9BDCC;--ohid-drk-blue-500:#91AABE;--ohid-drk-blue-600:#6084A1;--ohid-drk-blue-700:#2F5E84;--ohid-drk-blue-800:#0A426E;--iop-lt-blue-800:#40b0ff;--iop-blue-800:#0096ff;--iop-drk-blue-800:#004393;--lte:300;--reg:400;--semi:600;--bold:700}div.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{display:block}section.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic,.content-band.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic,div.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{background:transparent;transition:all .2s ease-in-out}.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic,.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic:after,.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic:before{box-sizing:border-box;padding:0;margin:0}button.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{position:relative;display:flex;align-items:center;justify-content:center;height:44px;width:max-content;padding:0 20px;border:0;font-size:16px;cursor:pointer;background:transparent;transition:all .2s ease-in-out!important}button.svelte-13x4eic .btn-txt.svelte-13x4eic.svelte-13x4eic{transition:all .2s ease-in-out!important}.bold.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{font-weight:var(--bold)!important}.bold.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{font-weight:var(--bold)!important}section.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic,.content-band.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic,div.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{background:transparent;transition:all .2s ease-in-out}button.secondary.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{border:2px;border-style:solid;background:transparent}button.disabled.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{position:relative;pointer-events:none;background:var(--gray-400)!important;border-color:var(--gray-500)!important;z-index:0}button.disabled.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{position:relative;pointer-events:none;background:var(--gray-400)!important;border-color:var(--gray-500)!important;z-index:0}div.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{font-family:'Source Sans Pro', sans-serif}button.disabled.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{position:relative;pointer-events:none;background:var(--gray-400)!important;border-color:var(--gray-500)!important;z-index:0}.width-full.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{width:100% !important;max-width:100%!important}button.svelte-13x4eic .btn-txt.svelte-13x4eic.svelte-13x4eic{transition:all .2s ease-in-out!important}.font-white.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{color:white!important}.gap-10.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{gap:10px}button.disabled.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{position:relative;pointer-events:none;background:var(--gray-400)!important;border-color:var(--gray-500)!important;z-index:0}.black.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{background:#000!important}button.disabled.svelte-13x4eic>.btn-txt.svelte-13x4eic.svelte-13x4eic{color:var(--gray-600)!important}button.svelte-13x4eic .btn-txt.svelte-13x4eic.svelte-13x4eic{display:flex;justify-content:center;min-width:max-content;font-size:16px}button.svelte-13x4eic .btn-txt.svelte-13x4eic.svelte-13x4eic{transition:all .2s ease-in-out!important}.font-white.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{color:white!important}.mt-10.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{margin-top:10px!important}.black.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{background:#000!important}.font-white.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{color:white!important}.border-gray-600.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{border-color:var(--gray-600)!important}.hover-blue-800.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic:hover{background:var(--blue-800)!important}.rounded-4.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{border-radius:4px !important}.flex.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{display:flex}ul.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{max-width:720px;padding:0;margin-left:20px}ul.totals.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{list-style-type:none}ul.totals.svelte-13x4eic li.svelte-13x4eic.svelte-13x4eic{display:inline-block;border-right:1px solid #a1a1a1;padding-right:10px;margin-right:5px}@media screen and (max-width: 425px){ul.totals.svelte-13x4eic li.svelte-13x4eic.svelte-13x4eic{border-right:none;border-bottom:1px solid #d8d8d8;display:block}ul.totals.svelte-13x4eic li.svelte-13x4eic.svelte-13x4eic:last-child{border-bottom:none}}.page-container.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{position:relative;display:flex;flex-direction:column;min-height:100%;width:100%}section.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{display:flex;justify-content:left}.content-band.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{position:relative;min-width:0;max-width:1440px;width:100%;margin:40px 20px}.container.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{position:relative;width:100%;transition:all .2s ease-in-out}.container.svelte-13x4eic .svelte-13x4eic>p.svelte-13x4eic,ul.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic,li.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{max-width:720px}.page-container-background.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{background-color:#F2F2F2;;}.height-50.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{height:50px}.no-right-border.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{border-right:0px !important}.square-44.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{width:44px;height:44px}.font-20.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{font-size:20px}.font-15.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{font-size:15px}.mt-0.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{margin-top:0!important}.mt-5.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{margin-top:5px!important}.mt-10.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{margin-top:10px!important}.pb-10.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{padding-bottom:10px!important}.pt-5.svelte-13x4eic.svelte-13x4eic.svelte-13x4eic{padding-top:5px!important}");
	}

	function get_each_context(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[45] = list[i];
		return child_ctx;
	}

	// (192:10) {#each stateTransitions?.filter((transition) => {                  return transition.permission.update;            }) as state}
	function create_each_block(ctx) {
		let button;
		let div;
		let t_value = /*state*/ ctx[45].endWorkflowState.workflowStateAction + "";
		let t;
		let button_title_value;
		let button_class_value;
		let mounted;
		let dispose;

		function click_handler_1(...args) {
			return /*click_handler_1*/ ctx[37](/*state*/ ctx[45], ...args);
		}

		return {
			c() {
				button = element("button");
				div = element("div");
				t = text(t_value);
				attr(div, "class", "btn-txt font-white svelte-13x4eic");
				attr(button, "title", button_title_value = /*state*/ ctx[45].endWorkflowState.workflowStateAction);
				attr(button, "class", button_class_value = "" + ((/*disableStateButtons*/ ctx[21] ? 'disabled' : '') + " rounded-4 hover-blue-800 black" + " svelte-13x4eic"));
				button.disabled = /*disableStateButtons*/ ctx[21];
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, div);
				append(div, t);

				if (!mounted) {
					dispose = listen(button, "click", click_handler_1);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty[0] & /*stateTransitions*/ 4194304 && t_value !== (t_value = /*state*/ ctx[45].endWorkflowState.workflowStateAction + "")) set_data(t, t_value);

				if (dirty[0] & /*stateTransitions*/ 4194304 && button_title_value !== (button_title_value = /*state*/ ctx[45].endWorkflowState.workflowStateAction)) {
					attr(button, "title", button_title_value);
				}

				if (dirty[0] & /*disableStateButtons*/ 2097152 && button_class_value !== (button_class_value = "" + ((/*disableStateButtons*/ ctx[21] ? 'disabled' : '') + " rounded-4 hover-blue-800 black" + " svelte-13x4eic"))) {
					attr(button, "class", button_class_value);
				}

				if (dirty[0] & /*disableStateButtons*/ 2097152) {
					button.disabled = /*disableStateButtons*/ ctx[21];
				}
			},
			d(detaching) {
				if (detaching) {
					detach(button);
				}

				mounted = false;
				dispose();
			}
		};
	}

	// (199:10) {#if stateTransitions?.filter((transition) => {                  return transition.permission.update;            })?.length === 0}
	function create_if_block_1$1(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "No Action Available";
				attr(p, "class", "svelte-13x4eic");
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			d(detaching) {
				if (detaching) {
					detach(p);
				}
			}
		};
	}

	// (209:4) {#if showWorkflowUpdate}
	function create_if_block$1(ctx) {
		let eas_workflow_update_swc;
		let mounted;
		let dispose;

		return {
			c() {
				eas_workflow_update_swc = element("eas-workflow-update-swc");
				set_custom_element_data(eas_workflow_update_swc, "application-key", /*applicationKey*/ ctx[0]);
				set_custom_element_data(eas_workflow_update_swc, "module-key", /*moduleKey*/ ctx[1]);
				set_custom_element_data(eas_workflow_update_swc, "workflow-type-key", /*workflowTypeKey*/ ctx[2]);
				set_custom_element_data(eas_workflow_update_swc, "owner-type-key", /*ownerTypeKey*/ ctx[3]);
				set_custom_element_data(eas_workflow_update_swc, "owner-source-key", /*ownerSourceKey*/ ctx[4]);
				set_custom_element_data(eas_workflow_update_swc, "composite-owner-type-key", /*compositeOwnerTypeKey*/ ctx[5]);
				set_custom_element_data(eas_workflow_update_swc, "composite-owner-source-key", /*compositeOwnerSourceKey*/ ctx[6]);
				set_custom_element_data(eas_workflow_update_swc, "item-context", /*itemContext*/ ctx[7]);
				set_custom_element_data(eas_workflow_update_swc, "selectedWorkflowAction", /*selectedWorkflowAction*/ ctx[18]);
				set_custom_element_data(eas_workflow_update_swc, "selectedWorkflowStateKey", /*selectedWorkflowStateKey*/ ctx[19]);
				set_custom_element_data(eas_workflow_update_swc, "commentStatus", /*commentStatus*/ ctx[20]);
				set_custom_element_data(eas_workflow_update_swc, "class", "svelte-13x4eic");
			},
			m(target, anchor) {
				insert(target, eas_workflow_update_swc, anchor);

				if (!mounted) {
					dispose = [
						listen(eas_workflow_update_swc, "cancelClicked", /*cancelClicked_handler*/ ctx[38]),
						listen(eas_workflow_update_swc, "submitClicked", /*submitClicked_handler*/ ctx[39])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*applicationKey*/ 1) {
					set_custom_element_data(eas_workflow_update_swc, "application-key", /*applicationKey*/ ctx[0]);
				}

				if (dirty[0] & /*moduleKey*/ 2) {
					set_custom_element_data(eas_workflow_update_swc, "module-key", /*moduleKey*/ ctx[1]);
				}

				if (dirty[0] & /*workflowTypeKey*/ 4) {
					set_custom_element_data(eas_workflow_update_swc, "workflow-type-key", /*workflowTypeKey*/ ctx[2]);
				}

				if (dirty[0] & /*ownerTypeKey*/ 8) {
					set_custom_element_data(eas_workflow_update_swc, "owner-type-key", /*ownerTypeKey*/ ctx[3]);
				}

				if (dirty[0] & /*ownerSourceKey*/ 16) {
					set_custom_element_data(eas_workflow_update_swc, "owner-source-key", /*ownerSourceKey*/ ctx[4]);
				}

				if (dirty[0] & /*compositeOwnerTypeKey*/ 32) {
					set_custom_element_data(eas_workflow_update_swc, "composite-owner-type-key", /*compositeOwnerTypeKey*/ ctx[5]);
				}

				if (dirty[0] & /*compositeOwnerSourceKey*/ 64) {
					set_custom_element_data(eas_workflow_update_swc, "composite-owner-source-key", /*compositeOwnerSourceKey*/ ctx[6]);
				}

				if (dirty[0] & /*itemContext*/ 128) {
					set_custom_element_data(eas_workflow_update_swc, "item-context", /*itemContext*/ ctx[7]);
				}

				if (dirty[0] & /*selectedWorkflowAction*/ 262144) {
					set_custom_element_data(eas_workflow_update_swc, "selectedWorkflowAction", /*selectedWorkflowAction*/ ctx[18]);
				}

				if (dirty[0] & /*selectedWorkflowStateKey*/ 524288) {
					set_custom_element_data(eas_workflow_update_swc, "selectedWorkflowStateKey", /*selectedWorkflowStateKey*/ ctx[19]);
				}

				if (dirty[0] & /*commentStatus*/ 1048576) {
					set_custom_element_data(eas_workflow_update_swc, "commentStatus", /*commentStatus*/ ctx[20]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(eas_workflow_update_swc);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	function create_fragment$1(ctx) {
		let div7;
		let section;
		let div6;
		let div5;
		let eas_validation_message0;
		let t0;
		let eas_validation_message1;
		let t1;
		let eas_validation_message2;
		let t2;
		let eas_validation_message3;
		let t3;
		let div4;
		let ul;
		let li0;
		let button;
		let t5;
		let li1;
		let div1;
		let t7;
		let div2;
		let t8_value = (/*currentWorkflowName*/ ctx[17] || 'Status Not Found') + "";
		let t8;
		let t9;
		let li2;
		let div3;
		let t10;
		let show_if = /*stateTransitions*/ ctx[22]?.filter(func)?.length === 0;
		let t11;
		let mounted;
		let dispose;
		let each_value = ensure_array_like(/*stateTransitions*/ ctx[22]?.filter(func_1));
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
		}

		let if_block0 = show_if && create_if_block_1$1();
		let if_block1 = /*showWorkflowUpdate*/ ctx[16] && create_if_block$1(ctx);

		return {
			c() {
				div7 = element("div");
				section = element("section");
				div6 = element("div");
				div5 = element("div");
				eas_validation_message0 = element("eas-validation-message");
				t0 = space();
				eas_validation_message1 = element("eas-validation-message");
				t1 = space();
				eas_validation_message2 = element("eas-validation-message");
				t2 = space();
				eas_validation_message3 = element("eas-validation-message");
				t3 = space();
				div4 = element("div");
				ul = element("ul");
				li0 = element("li");
				button = element("button");
				button.innerHTML = `<div class="bold font-20 svelte-13x4eic">H</div>`;
				t5 = space();
				li1 = element("li");
				div1 = element("div");
				div1.textContent = "Current Status";
				t7 = space();
				div2 = element("div");
				t8 = text(t8_value);
				t9 = space();
				li2 = element("li");
				div3 = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t10 = space();
				if (if_block0) if_block0.c();
				t11 = space();
				if (if_block1) if_block1.c();
				set_custom_element_data(eas_validation_message0, "message", /*errorMessage*/ ctx[9]);
				set_custom_element_data(eas_validation_message0, "type", "error");
				set_custom_element_data(eas_validation_message0, "showerror", /*showError*/ ctx[8]);
				set_custom_element_data(eas_validation_message0, "width", "800");
				set_custom_element_data(eas_validation_message0, "class", "svelte-13x4eic");
				set_custom_element_data(eas_validation_message1, "message", /*warningMessage*/ ctx[11]);
				set_custom_element_data(eas_validation_message1, "type", "warning");
				set_custom_element_data(eas_validation_message1, "showWarning", /*showWarning*/ ctx[10]);
				set_custom_element_data(eas_validation_message1, "width", "800");
				set_custom_element_data(eas_validation_message1, "class", "svelte-13x4eic");
				set_custom_element_data(eas_validation_message2, "message", /*infoMessage*/ ctx[13]);
				set_custom_element_data(eas_validation_message2, "type", "info");
				set_custom_element_data(eas_validation_message2, "showinfo", /*showInfo*/ ctx[12]);
				set_custom_element_data(eas_validation_message2, "width", "800");
				set_custom_element_data(eas_validation_message2, "class", "svelte-13x4eic");
				set_custom_element_data(eas_validation_message3, "message", /*successMessage*/ ctx[15]);
				set_custom_element_data(eas_validation_message3, "type", "success");
				set_custom_element_data(eas_validation_message3, "showsuccess", /*showSuccess*/ ctx[14]);
				set_custom_element_data(eas_validation_message3, "width", "800");
				set_custom_element_data(eas_validation_message3, "class", "svelte-13x4eic");
				attr(button, "class", "secondary border-black rounded-4 square-44 svelte-13x4eic");
				attr(button, "title", "History Log");
				attr(li0, "class", "height-50 pt-5 svelte-13x4eic");
				attr(div1, "class", "mt-0 font-15 svelte-13x4eic");
				attr(div2, "class", "bold font-15 svelte-13x4eic");
				attr(li1, "class", "height-50 svelte-13x4eic");
				attr(div3, "class", "flex gap-10 svelte-13x4eic");
				attr(li2, "class", "height-50 no-right-border mt-5 svelte-13x4eic");
				attr(ul, "class", "totals svelte-13x4eic");
				attr(div4, "class", "border-gray-600 pt-5 pb-10 mt-10 justify-end width-full svelte-13x4eic");
				attr(div5, "class", "container svelte-13x4eic");
				attr(div6, "class", "content-band max-w1200 svelte-13x4eic");
				attr(section, "class", "svelte-13x4eic");
				attr(div7, "class", "page-container page-container-background svelte-13x4eic");
			},
			m(target, anchor) {
				insert(target, div7, anchor);
				append(div7, section);
				append(section, div6);
				append(div6, div5);
				append(div5, eas_validation_message0);
				append(div5, t0);
				append(div5, eas_validation_message1);
				append(div5, t1);
				append(div5, eas_validation_message2);
				append(div5, t2);
				append(div5, eas_validation_message3);
				append(div5, t3);
				append(div5, div4);
				append(div4, ul);
				append(ul, li0);
				append(li0, button);
				append(ul, t5);
				append(ul, li1);
				append(li1, div1);
				append(li1, t7);
				append(li1, div2);
				append(div2, t8);
				append(ul, t9);
				append(ul, li2);
				append(li2, div3);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div3, null);
					}
				}

				append(div3, t10);
				if (if_block0) if_block0.m(div3, null);
				append(div4, t11);
				if (if_block1) if_block1.m(div4, null);

				if (!mounted) {
					dispose = [
						listen(eas_validation_message0, "errorclose", /*errorclose_handler*/ ctx[32]),
						listen(eas_validation_message1, "warningclose", /*warningclose_handler*/ ctx[33]),
						listen(eas_validation_message2, "infoclose", /*infoclose_handler*/ ctx[34]),
						listen(eas_validation_message3, "successclose", /*successclose_handler*/ ctx[35]),
						listen(button, "click", /*click_handler*/ ctx[36])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty[0] & /*errorMessage*/ 512) {
					set_custom_element_data(eas_validation_message0, "message", /*errorMessage*/ ctx[9]);
				}

				if (dirty[0] & /*showError*/ 256) {
					set_custom_element_data(eas_validation_message0, "showerror", /*showError*/ ctx[8]);
				}

				if (dirty[0] & /*warningMessage*/ 2048) {
					set_custom_element_data(eas_validation_message1, "message", /*warningMessage*/ ctx[11]);
				}

				if (dirty[0] & /*showWarning*/ 1024) {
					set_custom_element_data(eas_validation_message1, "showWarning", /*showWarning*/ ctx[10]);
				}

				if (dirty[0] & /*infoMessage*/ 8192) {
					set_custom_element_data(eas_validation_message2, "message", /*infoMessage*/ ctx[13]);
				}

				if (dirty[0] & /*showInfo*/ 4096) {
					set_custom_element_data(eas_validation_message2, "showinfo", /*showInfo*/ ctx[12]);
				}

				if (dirty[0] & /*successMessage*/ 32768) {
					set_custom_element_data(eas_validation_message3, "message", /*successMessage*/ ctx[15]);
				}

				if (dirty[0] & /*showSuccess*/ 16384) {
					set_custom_element_data(eas_validation_message3, "showsuccess", /*showSuccess*/ ctx[14]);
				}

				if (dirty[0] & /*currentWorkflowName*/ 131072 && t8_value !== (t8_value = (/*currentWorkflowName*/ ctx[17] || 'Status Not Found') + "")) set_data(t8, t8_value);

				if (dirty[0] & /*stateTransitions, disableStateButtons, onClick*/ 274726912) {
					each_value = ensure_array_like(/*stateTransitions*/ ctx[22]?.filter(func_1));
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div3, t10);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}

				if (dirty[0] & /*stateTransitions*/ 4194304) show_if = /*stateTransitions*/ ctx[22]?.filter(func)?.length === 0;

				if (show_if) {
					if (if_block0) ; else {
						if_block0 = create_if_block_1$1();
						if_block0.c();
						if_block0.m(div3, null);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*showWorkflowUpdate*/ ctx[16]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block$1(ctx);
						if_block1.c();
						if_block1.m(div4, null);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(div7);
				}

				destroy_each(each_blocks, detaching);
				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	const func = transition => {
		return transition.permission.update;
	};

	const func_1 = transition => {
		return transition.permission.update;
	};

	function instance$1($$self, $$props, $$invalidate) {
		var WorkflowComment;

		(function (WorkflowComment) {
			WorkflowComment[WorkflowComment["Required"] = 0] = "Required";
			WorkflowComment[WorkflowComment["Optional"] = 1] = "Optional";
			WorkflowComment[WorkflowComment["NotAllowed"] = 2] = "NotAllowed";
		})(WorkflowComment || (WorkflowComment = {}));

		const svelteDispatcher = createEventDispatcher();
		let { applicationKey } = $$props;
		let { moduleKey } = $$props;
		let { workflowTypeKey } = $$props;
		let { ownerTypeKey } = $$props;
		let { ownerSourceKey } = $$props;
		let { compositeOwnerTypeKey } = $$props;
		let { compositeOwnerSourceKey } = $$props;
		let { itemContext } = $$props;
		let { isItemContextRequired = false } = $$props;
		let showError = false;
		let errorMessage = "This is an Error Message";
		let showWarning = false;
		let warningMessage = "This is a Warning Message";
		let showInfo = false;
		let infoMessage = "This is an Information Message";
		let showSuccess = false;
		let successMessage = "This is a Success Message";
		let showWorkflowUpdate = false;
		let currentWorkflowName = "";
		let selectedWorkflowAction = "";
		let selectedWorkflowStateKey;
		let commentStatus;
		let disableStateButtons = false;
		let stateTransitions = [];
		let workflowService = new WorkflowStatusService();

		onMount(async () => {
			console.log('Workflow Status Component Mounted');
		});

		function getWorkflowStatus(comingFromUpdateStatus = false) {
			if (!isItemContextRequired || itemContext) {
				workflowService.getWorkflowStatus(applicationKey?.toString(), moduleKey?.toString(), workflowTypeKey?.toString(), ownerSourceKey?.toString(), ownerTypeKey?.toString(), compositeOwnerSourceKey?.toString(), compositeOwnerTypeKey?.toString(), itemContext?.toString()).then(result => {
					console.log(result);

					// if statusCode is defined, then the api call has failed, display error - kevin.low 10/06/2023
					if ('statusCode' in result && result.statusCode !== undefined && result.statusCode !== 200) {
						$$invalidate(17, currentWorkflowName = 'Unknown');
						$$invalidate(8, showError = true);
						$$invalidate(9, errorMessage = `${result.message} (${result.statusCode})`);
					} else {
						if (!comingFromUpdateStatus) {
							resetAlertMessages();
						}

						const workflowInstance = result[0];

						if (currentWorkflowName !== workflowInstance?.workflowStateName) {
							svelteDispatcher('workflowStatusChanged', {
								currentWorkflowStateKey: workflowInstance?.workflowStateKey,
								currentWorkflowName: workflowInstance?.workflowStateName
							});
						} else {
							if (comingFromUpdateStatus) {
								$$invalidate(10, showWarning = true);
								$$invalidate(11, warningMessage = 'Workflow status did not change');
							}
						}

						$$invalidate(17, currentWorkflowName = workflowInstance?.workflowStateName);
						$$invalidate(22, stateTransitions = workflowInstance?.stateTransitions || []);
					}
				}).catch(error => {
					console.error(error);
					$$invalidate(8, showError = true);
					$$invalidate(9, errorMessage = error.message);
				});
			}
		}

		let onHistory = async e => {
			svelteDispatcher('openHistory', {
				applicationKey,
				moduleKey,
				workflowTypeKey,
				ownerTypeKey,
				ownerSourceKey,
				compositeOwnerTypeKey,
				compositeOwnerSourceKey,
				itemContext
			});
		};

		let onErrorClose = async e => {
			$$invalidate(8, showError = false);
			$$invalidate(9, errorMessage = '');
		};

		let onSuccessClose = async e => {
			$$invalidate(14, showSuccess = false);
			$$invalidate(15, successMessage = '');
		};

		let onInfoClose = async e => {
			$$invalidate(12, showInfo = false);
			$$invalidate(13, infoMessage = '');
		};

		let onWarningClose = async e => {
			$$invalidate(10, showWarning = false);
			$$invalidate(11, warningMessage = '');
		};

		let onClick = async e => {
			$$invalidate(18, selectedWorkflowAction = e.endWorkflowState.workflowStateAction);
			$$invalidate(19, selectedWorkflowStateKey = e.endWorkflowState.workflowStateKey);
			if (e.isCommentRequiredFlag === true && e.isCommentAllowFlag === true) $$invalidate(20, commentStatus = WorkflowComment.Required); else if (e.isCommentAllowFlag === false) $$invalidate(20, commentStatus = WorkflowComment.NotAllowed); else if (e.isCommentRequiredFlag === false && e.isCommentAllowFlag === true) $$invalidate(20, commentStatus = WorkflowComment.Optional);
			$$invalidate(16, showWorkflowUpdate = true);
			$$invalidate(21, disableStateButtons = true);
		};

		let onCancelClicked = async e => {
			$$invalidate(16, showWorkflowUpdate = false);
			$$invalidate(21, disableStateButtons = false);
		};

		let onSubmitClicked = async e => {
			console.log('In onSubmitClicked()', e);
			resetAlertMessages();

			// this is for system errors - kevin.low 11/15/23
			if (e.detail.message) {
				$$invalidate(9, errorMessage = e.detail.message);
				console.log('System error occurred:', e.detail);
				$$invalidate(8, showError = true);
			} else if (e.detail[0]?.success === false || e.detail[0]?.preProcessMessages?.length > 0 || e.detail[0]?.postProcessMessages?.length > 0) {
				$$invalidate(
					9,
					errorMessage = e.detail[0].preProcessMessages[0] || e.detail[0].postProcessMessages[0] || 'Workflow update failed in pre or post processing'
				);

				console.log('Error occurred:', e.detail[0].preProcessMessages || e.detail[0].postProcessMessages || 'Error Occurred');
				$$invalidate(8, showError = true);
			}

			getWorkflowStatus(true);
			$$invalidate(16, showWorkflowUpdate = false);
			$$invalidate(21, disableStateButtons = false);
		};

		function resetAlertMessages() {
			$$invalidate(8, showError = false);
			$$invalidate(9, errorMessage = '');
			$$invalidate(10, showWarning = false);
			$$invalidate(11, warningMessage = '');
			$$invalidate(12, showInfo = false);
			$$invalidate(13, infoMessage = '');
			$$invalidate(14, showSuccess = false);
			$$invalidate(15, successMessage = '');
		}

		const errorclose_handler = e => onErrorClose();
		const warningclose_handler = e => onWarningClose();
		const infoclose_handler = e => onInfoClose();
		const successclose_handler = e => onSuccessClose();
		const click_handler = e => onHistory();
		const click_handler_1 = (state, e) => onClick(state);
		const cancelClicked_handler = e => onCancelClicked();
		const submitClicked_handler = e => onSubmitClicked(e);

		$$self.$$set = $$props => {
			if ('applicationKey' in $$props) $$invalidate(0, applicationKey = $$props.applicationKey);
			if ('moduleKey' in $$props) $$invalidate(1, moduleKey = $$props.moduleKey);
			if ('workflowTypeKey' in $$props) $$invalidate(2, workflowTypeKey = $$props.workflowTypeKey);
			if ('ownerTypeKey' in $$props) $$invalidate(3, ownerTypeKey = $$props.ownerTypeKey);
			if ('ownerSourceKey' in $$props) $$invalidate(4, ownerSourceKey = $$props.ownerSourceKey);
			if ('compositeOwnerTypeKey' in $$props) $$invalidate(5, compositeOwnerTypeKey = $$props.compositeOwnerTypeKey);
			if ('compositeOwnerSourceKey' in $$props) $$invalidate(6, compositeOwnerSourceKey = $$props.compositeOwnerSourceKey);
			if ('itemContext' in $$props) $$invalidate(7, itemContext = $$props.itemContext);
			if ('isItemContextRequired' in $$props) $$invalidate(31, isItemContextRequired = $$props.isItemContextRequired);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty[0] & /*applicationKey*/ 1) {
				console.log('applicationKey=', applicationKey);
			}

			if ($$self.$$.dirty[0] & /*moduleKey*/ 2) {
				console.log('moduleKey=', moduleKey);
			}

			if ($$self.$$.dirty[0] & /*workflowTypeKey*/ 4) {
				console.log('workflowTypeKey=', workflowTypeKey);
			}

			if ($$self.$$.dirty[0] & /*ownerTypeKey*/ 8) {
				console.log('ownerTypeKey=', ownerTypeKey);
			}

			if ($$self.$$.dirty[0] & /*ownerSourceKey*/ 16) {
				console.log('ownerSourceKey=', ownerSourceKey);
			}

			if ($$self.$$.dirty[0] & /*compositeOwnerSourceKey*/ 64) {
				console.log('compositeOwnerSourceKey=', compositeOwnerSourceKey);
			}

			if ($$self.$$.dirty[0] & /*compositeOwnerTypeKey*/ 32) {
				console.log('compositeOwnerTypeKey=', compositeOwnerTypeKey);
			}

			if ($$self.$$.dirty[0] & /*itemContext*/ 128) {
				console.log('itemContext=', itemContext);
			}

			if ($$self.$$.dirty[1] & /*isItemContextRequired*/ 1) {
				console.log('isItemContextRequired=', isItemContextRequired);
			}

			if ($$self.$$.dirty[0] & /*applicationKey, moduleKey, workflowTypeKey, ownerSourceKey, ownerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, itemContext*/ 255 | $$self.$$.dirty[1] & /*isItemContextRequired*/ 1) {
				(getWorkflowStatus());
			}
		};

		console.log('----------EAS Svelte Workflow Component---------');

		return [
			applicationKey,
			moduleKey,
			workflowTypeKey,
			ownerTypeKey,
			ownerSourceKey,
			compositeOwnerTypeKey,
			compositeOwnerSourceKey,
			itemContext,
			showError,
			errorMessage,
			showWarning,
			warningMessage,
			showInfo,
			infoMessage,
			showSuccess,
			successMessage,
			showWorkflowUpdate,
			currentWorkflowName,
			selectedWorkflowAction,
			selectedWorkflowStateKey,
			commentStatus,
			disableStateButtons,
			stateTransitions,
			onHistory,
			onErrorClose,
			onSuccessClose,
			onInfoClose,
			onWarningClose,
			onClick,
			onCancelClicked,
			onSubmitClicked,
			isItemContextRequired,
			errorclose_handler,
			warningclose_handler,
			infoclose_handler,
			successclose_handler,
			click_handler,
			click_handler_1,
			cancelClicked_handler,
			submitClicked_handler
		];
	}

	class Eas_workflow_status extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance$1,
				create_fragment$1,
				safe_not_equal,
				{
					applicationKey: 0,
					moduleKey: 1,
					workflowTypeKey: 2,
					ownerTypeKey: 3,
					ownerSourceKey: 4,
					compositeOwnerTypeKey: 5,
					compositeOwnerSourceKey: 6,
					itemContext: 7,
					isItemContextRequired: 31
				},
				add_css$1,
				[-1, -1]
			);
		}

		get applicationKey() {
			return this.$$.ctx[0];
		}

		set applicationKey(applicationKey) {
			this.$$set({ applicationKey });
			flush();
		}

		get moduleKey() {
			return this.$$.ctx[1];
		}

		set moduleKey(moduleKey) {
			this.$$set({ moduleKey });
			flush();
		}

		get workflowTypeKey() {
			return this.$$.ctx[2];
		}

		set workflowTypeKey(workflowTypeKey) {
			this.$$set({ workflowTypeKey });
			flush();
		}

		get ownerTypeKey() {
			return this.$$.ctx[3];
		}

		set ownerTypeKey(ownerTypeKey) {
			this.$$set({ ownerTypeKey });
			flush();
		}

		get ownerSourceKey() {
			return this.$$.ctx[4];
		}

		set ownerSourceKey(ownerSourceKey) {
			this.$$set({ ownerSourceKey });
			flush();
		}

		get compositeOwnerTypeKey() {
			return this.$$.ctx[5];
		}

		set compositeOwnerTypeKey(compositeOwnerTypeKey) {
			this.$$set({ compositeOwnerTypeKey });
			flush();
		}

		get compositeOwnerSourceKey() {
			return this.$$.ctx[6];
		}

		set compositeOwnerSourceKey(compositeOwnerSourceKey) {
			this.$$set({ compositeOwnerSourceKey });
			flush();
		}

		get itemContext() {
			return this.$$.ctx[7];
		}

		set itemContext(itemContext) {
			this.$$set({ itemContext });
			flush();
		}

		get isItemContextRequired() {
			return this.$$.ctx[31];
		}

		set isItemContextRequired(isItemContextRequired) {
			this.$$set({ isItemContextRequired });
			flush();
		}
	}

	customElements.define("eas-workflow-status-swc", create_custom_element(Eas_workflow_status, {"applicationKey":{},"moduleKey":{},"workflowTypeKey":{},"ownerTypeKey":{},"ownerSourceKey":{},"compositeOwnerTypeKey":{},"compositeOwnerSourceKey":{},"itemContext":{},"isItemContextRequired":{"type":"Boolean"}}, [], [], true));

	/* src\lib\workflow-transition\workflow-update\eas-workflow-update.svelte generated by Svelte v4.2.19 */

	function add_css(target) {
		append_styles(target, "svelte-1j7unm9", ":root{--gray-800:#2c2c2c;--gray-700:#434343;--gray-600:#8c8c8c;--gray-500:#bfbfbf;--gray-400:#d9d9d9;--gray-300:#e8e8e8;--gray-250:#f0f0f0;--gray-200:#f2f2f2;--gray-100:#f6f6f6;--gray-50:#f7f7f7;--maroon-800:#700017;--maroon-700:#8b3043;--maroon-600:#99495a;--maroon-500:#aa6d7e;--maroon-400:#bf95a5;--maroon-300:#e9d9dc;--maroon-200:#f5eeee;--maroon-100:#faf6f6;--maroon-lte-100:#faf6f6;--maroon-lte-200:#f5eeee;--red-800:#ea1014;--red-700:#f1353a;--red-600:#f4595c;--red-500:#f57174;--red-400:#f7888b;--red-300:#f9acae;--red-200:#fbc4c5;--red-100:#fde7e7;--red-50:#faf6f6;--blue-800:#3d7aa9;--blue-700:#4781ad;--blue-600:#5f91b7;--blue-500:#749fc1;--blue-400:#9ebcd4;--blue-300:#c4d7e5;--blue-200:#e2ebf2;--blue-100:#f4f7fa;--blue-lte-100:#eff0f5;--lte-blue-800:#73a5cc;--lte-blue-700:#88b2d4;--lte-blue-600:#a4c4de;--lte-blue-500:#c0d6e8;--lte-blue-400:#cee0ed;--lte-blue-300:#dce8f2;--lte-blue-200:#eaf2f7;--lte-blue-100:#f4f8fb;--gold-800:#ffbe0e;--gold-700:#ffce4a;--gold-600:#fad87b;--gold-500:#f8de9b;--gold-400:#f6e2b2;--gold-300:#f4e7ca;--gold-200:#f2ebdd;--gold-100:#f3f1ed;--drk-green-800:#5e8000;--drk-green-700:#6e8c19;--drk-green-600:#7e9933;--drk-green-500:#8ea64c;--drk-green-400:#aebf7f;--drk-green-300:#c7d3a6;--drk-green-200:#dfe6cc;--drk-green-100:#eff2e5;--green-800:#b5dc10;--green-700:#bcdf27;--green-600:#c4e340;--green-500:#cbe657;--green-400:#daed87;--green-300:#e5f3ac;--green-200:#f0f8cf;--green-100:#f7fbe7;--ohid-blue-100:#ebf7ff;--ohid-blue-200:#d9efff;--ohid-blue-300:#bfe5ff;--ohid-blue-400:#a6daff;--ohid-blue-500:#8cd0ff;--ohid-blue-600:#59bbff;--ohid-blue-700:#26a6ff;--ohid-blue-800:#0096ff;--ohid-drk-blue-100:#ecf0f4;--ohid-drk-blue-200:#dae3e9;--ohid-drk-blue-300:#c2d0db;--ohid-drk-blue-400:#a9bdcc;--ohid-drk-blue-500:#91aabe;--ohid-drk-blue-600:#6084a1;--ohid-drk-blue-700:#2f5e84;--ohid-drk-blue-800:#0a426e;--iop-lt-blue-800:#40b0ff;--iop-blue-800:#0096ff;--iop-drk-blue-800:#004393;--lte:300;--reg:400;--semi:600;--bold:700}div.svelte-1j7unm9.svelte-1j7unm9{display:block}section.svelte-1j7unm9.svelte-1j7unm9,.content-band.svelte-1j7unm9.svelte-1j7unm9,div.svelte-1j7unm9.svelte-1j7unm9{background:transparent;transition:all 0.2s ease-in-out}.svelte-1j7unm9.svelte-1j7unm9,.svelte-1j7unm9.svelte-1j7unm9:after,.svelte-1j7unm9.svelte-1j7unm9:before{box-sizing:border-box;padding:0;margin:0}.mb-10.svelte-1j7unm9.svelte-1j7unm9{margin-bottom:10px !important}button.svelte-1j7unm9.svelte-1j7unm9{position:relative;display:flex;align-items:center;justify-content:center;height:44px;width:max-content;padding:0 20px;border:0;font-size:16px;cursor:pointer;background:transparent;transition:all 0.2s ease-in-out !important}button.svelte-1j7unm9 .btn-txt.svelte-1j7unm9{transition:all 0.2s ease-in-out !important}.ds-floating-label.svelte-1j7unm9.svelte-1j7unm9{text-decoration:inherit;text-transform:inherit;position:absolute;transform-origin:left top;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);line-height:1.15rem;text-align:left;font-size:1rem;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;padding-right:16px}label.svelte-1j7unm9.svelte-1j7unm9{cursor:default}section.svelte-1j7unm9.svelte-1j7unm9,.content-band.svelte-1j7unm9.svelte-1j7unm9,div.svelte-1j7unm9.svelte-1j7unm9{background:transparent;transition:all 0.2s ease-in-out}button.border-red.svelte-1j7unm9.svelte-1j7unm9{border-color:var(--red-800)}button.secondary.svelte-1j7unm9.svelte-1j7unm9{border:2px;border-style:solid;background:transparent}button.disabled.svelte-1j7unm9.svelte-1j7unm9{position:relative;pointer-events:none;background:var(--gray-400) !important;border-color:var(--gray-500) !important;z-index:0}.icon.svelte-1j7unm9.svelte-1j7unm9,.icon.svelte-1j7unm9>i.svelte-1j7unm9{transition:all 0.2s ease-in-out}button.disabled.svelte-1j7unm9.svelte-1j7unm9{position:relative;pointer-events:none;background:var(--gray-400) !important;border-color:var(--gray-500) !important;z-index:0}.fas.svelte-1j7unm9.svelte-1j7unm9{font-family:'Font Awesome 6 Pro';font-weight:900}.fas.svelte-1j7unm9.svelte-1j7unm9{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:var(--fa-display, inline-block);font-style:normal;font-variant:normal;line-height:1;text-rendering:auto}.fas.svelte-1j7unm9.svelte-1j7unm9{font-weight:900}.fas.svelte-1j7unm9.svelte-1j7unm9{font-family:'Font Awesome 5 Free'}.fas.svelte-1j7unm9.svelte-1j7unm9{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1}i.svelte-1j7unm9.svelte-1j7unm9{font-style:italic}div.svelte-1j7unm9.svelte-1j7unm9{font-family:'Source Sans Pro', sans-serif}button.disabled.svelte-1j7unm9.svelte-1j7unm9{position:relative;pointer-events:none;background:var(--gray-400) !important;border-color:var(--gray-500) !important;z-index:0}.width-full.svelte-1j7unm9.svelte-1j7unm9{width:100% !important;max-width:100% !important}button.border-red.svelte-1j7unm9.svelte-1j7unm9{border-color:var(--red-800)}.flex-row-reverse.svelte-1j7unm9.svelte-1j7unm9{flex-direction:row-reverse !important}button.svelte-1j7unm9 .btn-txt.svelte-1j7unm9{transition:all 0.2s ease-in-out !important}.font-red.svelte-1j7unm9.svelte-1j7unm9{color:var(--red-800) !important}.font-white.svelte-1j7unm9.svelte-1j7unm9{color:white !important}button.disabled.svelte-1j7unm9.svelte-1j7unm9{position:relative;pointer-events:none;background:var(--gray-400) !important;border-color:var(--gray-500) !important;z-index:0}.black.svelte-1j7unm9.svelte-1j7unm9{background:#000 !important}button.disabled.svelte-1j7unm9>.btn-txt.svelte-1j7unm9{color:var(--gray-600) !important}button.svelte-1j7unm9 .btn-txt.svelte-1j7unm9{display:flex;justify-content:center;min-width:max-content;font-size:16px}button.svelte-1j7unm9 .btn-txt.svelte-1j7unm9{transition:all 0.2s ease-in-out !important}.font-white.svelte-1j7unm9.svelte-1j7unm9{color:white !important}.mt-10.svelte-1j7unm9.svelte-1j7unm9{margin-top:10px !important}.black.svelte-1j7unm9.svelte-1j7unm9{background:#000 !important}.font-white.svelte-1j7unm9.svelte-1j7unm9{color:white !important}.border-gray-600.svelte-1j7unm9.svelte-1j7unm9{border-color:var(--gray-600) !important}.border-bottom.svelte-1j7unm9.svelte-1j7unm9{border-bottom:1px solid var(--gray-400)}button:hover.hover-red.svelte-1j7unm9.svelte-1j7unm9{background:var(--red-800) !important;color:white !important}:hover.hover-font-white.svelte-1j7unm9>.svelte-1j7unm9{color:white !important}.hover-blue-800.svelte-1j7unm9.svelte-1j7unm9:hover{background:var(--blue-800) !important}.rounded-4.svelte-1j7unm9.svelte-1j7unm9{border-radius:4px !important}.ds-floating-label.svelte-1j7unm9.svelte-1j7unm9{text-decoration:inherit;text-transform:inherit;position:absolute;transform-origin:left top;transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1);line-height:1.15rem;text-align:left;font-size:1rem;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;padding-right:16px}.flex.svelte-1j7unm9.svelte-1j7unm9{display:flex}@media screen and (max-width: 425px){}.page-container.svelte-1j7unm9.svelte-1j7unm9{position:relative;display:flex;flex-direction:column;min-height:100%;width:100%}section.svelte-1j7unm9.svelte-1j7unm9{display:flex;justify-content:center}.content-band.svelte-1j7unm9.svelte-1j7unm9{position:relative;min-width:0;max-width:1440px;width:100%;margin:40px 20px}.container.svelte-1j7unm9.svelte-1j7unm9{position:relative;width:100%;transition:all 0.2s ease-in-out}.page-container-background.svelte-1j7unm9.svelte-1j7unm9{background-color:#f2f2f2}.white-background.svelte-1j7unm9.svelte-1j7unm9{background-color:white}.left-align.svelte-1j7unm9.svelte-1j7unm9{text-align:left}.font-20.svelte-1j7unm9.svelte-1j7unm9{font-size:20px}.font-15.svelte-1j7unm9.svelte-1j7unm9{font-size:15px}.border-bottom.svelte-1j7unm9.svelte-1j7unm9{border-bottom:1px solid var(--gray-400)}.mt-10.svelte-1j7unm9.svelte-1j7unm9{margin-top:10px !important}.mb-10.svelte-1j7unm9.svelte-1j7unm9{margin-bottom:10px !important}.p-20.svelte-1j7unm9.svelte-1j7unm9{padding:20px !important}.pb-10.svelte-1j7unm9.svelte-1j7unm9{padding-bottom:10px !important}.pt-5.svelte-1j7unm9.svelte-1j7unm9{padding-top:5px !important}.pt-10.svelte-1j7unm9.svelte-1j7unm9{padding-top:10px !important}.text-area-container.svelte-1j7unm9 textarea.svelte-1j7unm9{padding-top:25px}.text-area-container.svelte-1j7unm9.svelte-1j7unm9{position:relative;width:100%;height:auto;line-height:0;z-index:0}.text-area-container.svelte-1j7unm9 textarea.svelte-1j7unm9{position:relative;width:100%;padding:20px;text-align:left;border:0;outline:none;border-bottom:1px solid #000;border-top-left-radius:4px;border-top-right-radius:4px;font-size:16px;font-family:'Source Sans Pro', sans-serif;background:#f2f2f2;transition:all 0.2s ease-in-out;z-index:1}.gap-20.svelte-1j7unm9.svelte-1j7unm9{gap:20px}.justify-center.svelte-1j7unm9.svelte-1j7unm9{justify-content:center !important}.ds-floating-label.text-area.svelte-1j7unm9.svelte-1j7unm9{left:15px;right:0;top:15%;font-size:0.875rem;transform:translateY(-50%);pointer-events:none;color:#2c2c2c;z-index:2}.text-area-container.svelte-1j7unm9 .ds-floating-label.svelte-1j7unm9{left:15px;right:0;top:10px;font-size:0.875rem;transform:translateY(-50%);pointer-events:none;color:#2c2c2c;z-index:10}.text-area-container.svelte-1j7unm9 textarea.svelte-1j7unm9{padding-top:25px}");
	}

	// (115:6) {#if commentStatus == WorkflowComment.Optional }
	function create_if_block_2(ctx) {
		let div0;
		let t2;
		let div1;
		let t3;
		let t4;
		let t5;
		let t6;
		let div2;
		let label;
		let t8;
		let textarea;
		let t9;
		let div5;
		let button0;
		let t11;
		let button1;
		let div4;
		let t12;
		let mounted;
		let dispose;

		return {
			c() {
				div0 = element("div");
				div0.innerHTML = `<span class="icon trash icon-black font-20 svelte-1j7unm9"><i aria-hidden="true" class="fas fa-comment svelte-1j7unm9"></i></span> <b class="svelte-1j7unm9">Comment (Optional)</b>`;
				t2 = space();
				div1 = element("div");
				t3 = text("Your selection does not require a comment you may click the \"");
				t4 = text(/*selectedWorkflowAction*/ ctx[0]);
				t5 = text("\" button at\r\n\t\t\t\t\t\t\t\tanytime, or you may leave a comment below to further describe your decision.");
				t6 = space();
				div2 = element("div");
				label = element("label");
				label.textContent = "Comment";
				t8 = space();
				textarea = element("textarea");
				t9 = space();
				div5 = element("div");
				button0 = element("button");
				button0.innerHTML = `<div class="btn-txt font-red svelte-1j7unm9">Cancel</div>`;
				t11 = space();
				button1 = element("button");
				div4 = element("div");
				t12 = text(/*selectedWorkflowAction*/ ctx[0]);
				attr(div0, "class", "font-20 pt-10 pb-10 left-align svelte-1j7unm9");
				attr(div1, "class", "font-15 pb-10 border-bottom mb-10 left-align svelte-1j7unm9");
				attr(label, "for", "address2");
				attr(label, "class", "ds-floating-label text-area svelte-1j7unm9");
				attr(textarea, "name", "subject");
				attr(textarea, "rows", "3");
				attr(textarea, "class", "svelte-1j7unm9");
				attr(div2, "class", "text-area-container svelte-1j7unm9");
				attr(button0, "title", "Cancel");
				attr(button0, "id", "");
				attr(button0, "class", "secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse svelte-1j7unm9");
				attr(div4, "class", "btn-txt font-white svelte-1j7unm9");
				attr(button1, "title", "Submit");
				attr(button1, "id", "");
				attr(button1, "class", "rounded-4 hover-blue-800 black svelte-1j7unm9");
				attr(div5, "class", "container flex gap-20 justify-center bottom-buttons pt-10 svelte-1j7unm9");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				insert(target, t2, anchor);
				insert(target, div1, anchor);
				append(div1, t3);
				append(div1, t4);
				append(div1, t5);
				insert(target, t6, anchor);
				insert(target, div2, anchor);
				append(div2, label);
				append(div2, t8);
				append(div2, textarea);
				set_input_value(textarea, /*commentText*/ ctx[5]);
				insert(target, t9, anchor);
				insert(target, div5, anchor);
				append(div5, button0);
				append(div5, t11);
				append(div5, button1);
				append(button1, div4);
				append(div4, t12);

				if (!mounted) {
					dispose = [
						listen(textarea, "input", /*textarea_input_handler*/ ctx[19]),
						listen(button0, "click", /*onCancel*/ ctx[6]),
						listen(button1, "click", /*onSubmit*/ ctx[7])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*selectedWorkflowAction*/ 1) set_data(t4, /*selectedWorkflowAction*/ ctx[0]);

				if (dirty & /*commentText*/ 32) {
					set_input_value(textarea, /*commentText*/ ctx[5]);
				}

				if (dirty & /*selectedWorkflowAction*/ 1) set_data(t12, /*selectedWorkflowAction*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) {
					detach(div0);
					detach(t2);
					detach(div1);
					detach(t6);
					detach(div2);
					detach(t9);
					detach(div5);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (152:6) {#if commentStatus == WorkflowComment.Required }
	function create_if_block_1(ctx) {
		let div0;
		let t2;
		let div1;
		let t3;
		let t4;
		let t5;
		let t6;
		let div2;
		let label;
		let t8;
		let textarea;
		let t9;
		let div5;
		let button0;
		let t11;
		let button1;
		let div4;
		let t12;
		let button1_class_value;
		let button1_disabled_value;
		let mounted;
		let dispose;

		return {
			c() {
				div0 = element("div");
				div0.innerHTML = `<span class="icon trash icon-black font-20 svelte-1j7unm9"><i aria-hidden="true" class="fas fa-comment svelte-1j7unm9"></i></span> <b class="svelte-1j7unm9">Comment*</b>`;
				t2 = space();
				div1 = element("div");
				t3 = text("Your selection requires a comment to be able to submit. You may click the \"");
				t4 = text(/*selectedWorkflowAction*/ ctx[0]);
				t5 = text("\"\r\n\t\t\t\t\t\t\t\tbutton after entering a comment describing your decision.");
				t6 = space();
				div2 = element("div");
				label = element("label");
				label.textContent = "Comment*";
				t8 = space();
				textarea = element("textarea");
				t9 = space();
				div5 = element("div");
				button0 = element("button");
				button0.innerHTML = `<div class="btn-txt font-red svelte-1j7unm9">Cancel</div>`;
				t11 = space();
				button1 = element("button");
				div4 = element("div");
				t12 = text(/*selectedWorkflowAction*/ ctx[0]);
				attr(div0, "class", "font-20 pt-10 pb-10 left-align svelte-1j7unm9");
				attr(div1, "class", "font-15 pb-10 border-bottom mb-10 left-align svelte-1j7unm9");
				attr(label, "for", "address2");
				attr(label, "class", "ds-floating-label text-area svelte-1j7unm9");
				attr(textarea, "name", "subject");
				attr(textarea, "rows", "3");
				attr(textarea, "class", "svelte-1j7unm9");
				attr(div2, "class", "text-area-container svelte-1j7unm9");
				attr(button0, "title", "Cancel");
				attr(button0, "id", "");
				attr(button0, "class", "secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse svelte-1j7unm9");
				attr(div4, "class", "btn-txt font-white svelte-1j7unm9");
				attr(button1, "title", "Submit");
				attr(button1, "id", "");
				attr(button1, "class", button1_class_value = "" + ((isEmpty(/*commentText*/ ctx[5]) ? 'disabled' : '') + " rounded-4 hover-blue-800 black" + " svelte-1j7unm9"));
				button1.disabled = button1_disabled_value = isEmpty(/*commentText*/ ctx[5]);
				attr(div5, "class", "container flex gap-20 justify-center bottom-buttons pt-10 svelte-1j7unm9");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				insert(target, t2, anchor);
				insert(target, div1, anchor);
				append(div1, t3);
				append(div1, t4);
				append(div1, t5);
				insert(target, t6, anchor);
				insert(target, div2, anchor);
				append(div2, label);
				append(div2, t8);
				append(div2, textarea);
				set_input_value(textarea, /*commentText*/ ctx[5]);
				insert(target, t9, anchor);
				insert(target, div5, anchor);
				append(div5, button0);
				append(div5, t11);
				append(div5, button1);
				append(button1, div4);
				append(div4, t12);

				if (!mounted) {
					dispose = [
						listen(textarea, "input", /*textarea_input_handler_1*/ ctx[20]),
						listen(button0, "click", /*onCancel*/ ctx[6]),
						listen(button1, "click", /*onSubmit*/ ctx[7])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*selectedWorkflowAction*/ 1) set_data(t4, /*selectedWorkflowAction*/ ctx[0]);

				if (dirty & /*commentText*/ 32) {
					set_input_value(textarea, /*commentText*/ ctx[5]);
				}

				if (dirty & /*selectedWorkflowAction*/ 1) set_data(t12, /*selectedWorkflowAction*/ ctx[0]);

				if (dirty & /*commentText*/ 32 && button1_class_value !== (button1_class_value = "" + ((isEmpty(/*commentText*/ ctx[5]) ? 'disabled' : '') + " rounded-4 hover-blue-800 black" + " svelte-1j7unm9"))) {
					attr(button1, "class", button1_class_value);
				}

				if (dirty & /*commentText*/ 32 && button1_disabled_value !== (button1_disabled_value = isEmpty(/*commentText*/ ctx[5]))) {
					button1.disabled = button1_disabled_value;
				}
			},
			d(detaching) {
				if (detaching) {
					detach(div0);
					detach(t2);
					detach(div1);
					detach(t6);
					detach(div2);
					detach(t9);
					detach(div5);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (189:6) {#if commentStatus == WorkflowComment.NotAllowed }
	function create_if_block(ctx) {
		let div0;
		let t2;
		let div1;
		let t3;
		let t4;
		let t5;
		let t6;
		let div4;
		let button0;
		let t8;
		let button1;
		let div3;
		let t9;
		let mounted;
		let dispose;

		return {
			c() {
				div0 = element("div");
				div0.innerHTML = `<span class="icon trash icon-black font-20 svelte-1j7unm9"><i aria-hidden="true" class="fas fa-comment svelte-1j7unm9"></i></span> <b class="svelte-1j7unm9">Comment Not Allowed</b>`;
				t2 = space();
				div1 = element("div");
				t3 = text("Your selection does not allow for a comment. You may click the \"");
				t4 = text(/*selectedWorkflowAction*/ ctx[0]);
				t5 = text("\" button at\r\n\t\t\t\t\t\t\t\tanytime.");
				t6 = space();
				div4 = element("div");
				button0 = element("button");
				button0.innerHTML = `<div class="btn-txt font-red svelte-1j7unm9">Cancel</div>`;
				t8 = space();
				button1 = element("button");
				div3 = element("div");
				t9 = text(/*selectedWorkflowAction*/ ctx[0]);
				attr(div0, "class", "font-20 pt-10 pb-10 left-align svelte-1j7unm9");
				attr(div1, "class", "font-15 pb-10 border-bottom mb-10 left-align svelte-1j7unm9");
				attr(button0, "title", "Cancel");
				attr(button0, "id", "");
				attr(button0, "class", "secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse svelte-1j7unm9");
				attr(div3, "class", "btn-txt font-white svelte-1j7unm9");
				attr(button1, "title", "Submit");
				attr(button1, "id", "");
				attr(button1, "class", "rounded-4 hover-blue-800 black svelte-1j7unm9");
				attr(div4, "class", "container flex gap-20 justify-center bottom-buttons pt-10 svelte-1j7unm9");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				insert(target, t2, anchor);
				insert(target, div1, anchor);
				append(div1, t3);
				append(div1, t4);
				append(div1, t5);
				insert(target, t6, anchor);
				insert(target, div4, anchor);
				append(div4, button0);
				append(div4, t8);
				append(div4, button1);
				append(button1, div3);
				append(div3, t9);

				if (!mounted) {
					dispose = [
						listen(button0, "click", /*onCancel*/ ctx[6]),
						listen(button1, "click", /*onSubmit*/ ctx[7])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*selectedWorkflowAction*/ 1) set_data(t4, /*selectedWorkflowAction*/ ctx[0]);
				if (dirty & /*selectedWorkflowAction*/ 1) set_data(t9, /*selectedWorkflowAction*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) {
					detach(div0);
					detach(t2);
					detach(div1);
					detach(t6);
					detach(div4);
				}

				mounted = false;
				run_all(dispose);
			}
		};
	}

	function create_fragment(ctx) {
		let link;
		let t0;
		let div5;
		let section;
		let div4;
		let div3;
		let eas_validation_message;
		let t1;
		let div2;
		let div1;
		let div0;
		let b;
		let t2;
		let t3;
		let t4;
		let t5;
		let mounted;
		let dispose;
		let if_block0 = /*commentStatus*/ ctx[1] == /*WorkflowComment*/ ctx[2].Optional && create_if_block_2(ctx);
		let if_block1 = /*commentStatus*/ ctx[1] == /*WorkflowComment*/ ctx[2].Required && create_if_block_1(ctx);
		let if_block2 = /*commentStatus*/ ctx[1] == /*WorkflowComment*/ ctx[2].NotAllowed && create_if_block(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div5 = element("div");
				section = element("section");
				div4 = element("div");
				div3 = element("div");
				eas_validation_message = element("eas-validation-message");
				t1 = space();
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");
				b = element("b");
				t2 = text(/*selectedWorkflowAction*/ ctx[0]);
				t3 = space();
				if (if_block0) if_block0.c();
				t4 = space();
				if (if_block1) if_block1.c();
				t5 = space();
				if (if_block2) if_block2.c();
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(link, "class", "svelte-1j7unm9");
				set_custom_element_data(eas_validation_message, "message", /*errorMessage*/ ctx[3]);
				set_custom_element_data(eas_validation_message, "type", "error");
				set_custom_element_data(eas_validation_message, "showerror", /*showError*/ ctx[4]);
				set_custom_element_data(eas_validation_message, "width", "800");
				set_custom_element_data(eas_validation_message, "class", "svelte-1j7unm9");
				attr(b, "class", "svelte-1j7unm9");
				attr(div0, "class", "font-20 left-align svelte-1j7unm9");
				attr(div1, "class", "p-20 mt-10 white-background svelte-1j7unm9");
				attr(div2, "class", "border-gray-600 pt-5 pb-10 mt-10 justify-end width-full svelte-1j7unm9");
				attr(div3, "class", "container svelte-1j7unm9");
				attr(div4, "class", "content-band max-w1200 svelte-1j7unm9");
				attr(section, "class", "svelte-1j7unm9");
				attr(div5, "class", "page-container page-container-background svelte-1j7unm9");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div5, anchor);
				append(div5, section);
				append(section, div4);
				append(div4, div3);
				append(div3, eas_validation_message);
				append(div3, t1);
				append(div3, div2);
				append(div2, div1);
				append(div1, div0);
				append(div0, b);
				append(b, t2);
				append(div1, t3);
				if (if_block0) if_block0.m(div1, null);
				append(div1, t4);
				if (if_block1) if_block1.m(div1, null);
				append(div1, t5);
				if (if_block2) if_block2.m(div1, null);

				if (!mounted) {
					dispose = listen(eas_validation_message, "errorclose", /*errorclose_handler*/ ctx[18]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*errorMessage*/ 8) {
					set_custom_element_data(eas_validation_message, "message", /*errorMessage*/ ctx[3]);
				}

				if (dirty & /*showError*/ 16) {
					set_custom_element_data(eas_validation_message, "showerror", /*showError*/ ctx[4]);
				}

				if (dirty & /*selectedWorkflowAction*/ 1) set_data(t2, /*selectedWorkflowAction*/ ctx[0]);

				if (/*commentStatus*/ ctx[1] == /*WorkflowComment*/ ctx[2].Optional) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_2(ctx);
						if_block0.c();
						if_block0.m(div1, t4);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*commentStatus*/ ctx[1] == /*WorkflowComment*/ ctx[2].Required) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_1(ctx);
						if_block1.c();
						if_block1.m(div1, t5);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*commentStatus*/ ctx[1] == /*WorkflowComment*/ ctx[2].NotAllowed) {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block(ctx);
						if_block2.c();
						if_block2.m(div1, null);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div5);
				}

				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				if (if_block2) if_block2.d();
				mounted = false;
				dispose();
			}
		};
	}

	function isEmpty(commentText) {
		return commentText.trim() === '';
	}

	function instance($$self, $$props, $$invalidate) {
		var WorkflowComment;

		(function (WorkflowComment) {
			WorkflowComment[WorkflowComment["Required"] = 0] = "Required";
			WorkflowComment[WorkflowComment["Optional"] = 1] = "Optional";
			WorkflowComment[WorkflowComment["NotAllowed"] = 2] = "NotAllowed";
		})(WorkflowComment || (WorkflowComment = {}));

		const svelteDispatcher = createEventDispatcher();
		let workflowService = new WorkflowStatusService();
		let { applicationKey } = $$props;
		let { moduleKey } = $$props;
		let { workflowTypeKey } = $$props;
		let { ownerTypeKey } = $$props;
		let { ownerSourceKey } = $$props;
		let { compositeOwnerTypeKey } = $$props;
		let { compositeOwnerSourceKey } = $$props;
		let { itemContext } = $$props;
		let { selectedWorkflowAction } = $$props;
		let { selectedWorkflowStateKey } = $$props;
		let { commentStatus } = $$props;
		let errorMessage = "";
		let showError = false;
		let commentText = "";

		function onCancel() {
			svelteDispatcher('cancelClicked');
		}

		function onSubmit() {
			workflowService.updateWorkflowStatus(applicationKey, moduleKey, workflowTypeKey, ownerSourceKey, ownerTypeKey, compositeOwnerSourceKey, compositeOwnerTypeKey, itemContext, commentText, selectedWorkflowStateKey).then(result => {
				if ('statusCode' in result && result.statusCode !== undefined && result.statusCode !== 200) {
					$$invalidate(4, showError = true);
					$$invalidate(3, errorMessage = `(${result.statusCode})`);
				} else {
					$$invalidate(4, showError = false);
					$$invalidate(3, errorMessage = '');
				}

				svelteDispatcher('submitClicked', result);
			}).catch(error => {
				console.error(error);
				$$invalidate(4, showError = true);
				$$invalidate(3, errorMessage = error.message);
				svelteDispatcher('submitClicked', error);
			});
		}

		let onErrorClose = async e => {
			$$invalidate(4, showError = false);
			$$invalidate(3, errorMessage = '');
		};

		const errorclose_handler = e => onErrorClose();

		function textarea_input_handler() {
			commentText = this.value;
			$$invalidate(5, commentText);
		}

		function textarea_input_handler_1() {
			commentText = this.value;
			$$invalidate(5, commentText);
		}

		$$self.$$set = $$props => {
			if ('applicationKey' in $$props) $$invalidate(9, applicationKey = $$props.applicationKey);
			if ('moduleKey' in $$props) $$invalidate(10, moduleKey = $$props.moduleKey);
			if ('workflowTypeKey' in $$props) $$invalidate(11, workflowTypeKey = $$props.workflowTypeKey);
			if ('ownerTypeKey' in $$props) $$invalidate(12, ownerTypeKey = $$props.ownerTypeKey);
			if ('ownerSourceKey' in $$props) $$invalidate(13, ownerSourceKey = $$props.ownerSourceKey);
			if ('compositeOwnerTypeKey' in $$props) $$invalidate(14, compositeOwnerTypeKey = $$props.compositeOwnerTypeKey);
			if ('compositeOwnerSourceKey' in $$props) $$invalidate(15, compositeOwnerSourceKey = $$props.compositeOwnerSourceKey);
			if ('itemContext' in $$props) $$invalidate(16, itemContext = $$props.itemContext);
			if ('selectedWorkflowAction' in $$props) $$invalidate(0, selectedWorkflowAction = $$props.selectedWorkflowAction);
			if ('selectedWorkflowStateKey' in $$props) $$invalidate(17, selectedWorkflowStateKey = $$props.selectedWorkflowStateKey);
			if ('commentStatus' in $$props) $$invalidate(1, commentStatus = $$props.commentStatus);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*applicationKey*/ 512) {
				console.log('applicationKey=', applicationKey);
			}

			if ($$self.$$.dirty & /*moduleKey*/ 1024) {
				console.log('moduleKey=', moduleKey);
			}

			if ($$self.$$.dirty & /*workflowTypeKey*/ 2048) {
				console.log('workflowTypeKey=', workflowTypeKey);
			}

			if ($$self.$$.dirty & /*ownerTypeKey*/ 4096) {
				console.log('ownerTypeKey=', ownerTypeKey);
			}

			if ($$self.$$.dirty & /*ownerSourceKey*/ 8192) {
				console.log('ownerSourceKey=', ownerSourceKey);
			}

			if ($$self.$$.dirty & /*compositeOwnerTypeKey*/ 16384) {
				console.log('compositeOwnerTypeKey=', compositeOwnerTypeKey);
			}

			if ($$self.$$.dirty & /*compositeOwnerSourceKey*/ 32768) {
				console.log('compositeOwnerSourceKey=', compositeOwnerSourceKey);
			}

			if ($$self.$$.dirty & /*itemContext*/ 65536) {
				console.log('itemContext=', itemContext);
			}

			if ($$self.$$.dirty & /*selectedWorkflowAction*/ 1) {
				console.log('selectedWorkflowAction=', selectedWorkflowAction);
			}

			if ($$self.$$.dirty & /*selectedWorkflowStateKey*/ 131072) {
				console.log('selectedWorkflowStateKey=', selectedWorkflowStateKey);
			}

			if ($$self.$$.dirty & /*commentStatus*/ 2) {
				console.log('commentStatus=', commentStatus);
			}
		};

		console.log('----------EAS Svelte Workflow Update Component---------');

		return [
			selectedWorkflowAction,
			commentStatus,
			WorkflowComment,
			errorMessage,
			showError,
			commentText,
			onCancel,
			onSubmit,
			onErrorClose,
			applicationKey,
			moduleKey,
			workflowTypeKey,
			ownerTypeKey,
			ownerSourceKey,
			compositeOwnerTypeKey,
			compositeOwnerSourceKey,
			itemContext,
			selectedWorkflowStateKey,
			errorclose_handler,
			textarea_input_handler,
			textarea_input_handler_1
		];
	}

	class Eas_workflow_update extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance,
				create_fragment,
				safe_not_equal,
				{
					applicationKey: 9,
					moduleKey: 10,
					workflowTypeKey: 11,
					ownerTypeKey: 12,
					ownerSourceKey: 13,
					compositeOwnerTypeKey: 14,
					compositeOwnerSourceKey: 15,
					itemContext: 16,
					selectedWorkflowAction: 0,
					selectedWorkflowStateKey: 17,
					commentStatus: 1
				},
				add_css
			);
		}

		get applicationKey() {
			return this.$$.ctx[9];
		}

		set applicationKey(applicationKey) {
			this.$$set({ applicationKey });
			flush();
		}

		get moduleKey() {
			return this.$$.ctx[10];
		}

		set moduleKey(moduleKey) {
			this.$$set({ moduleKey });
			flush();
		}

		get workflowTypeKey() {
			return this.$$.ctx[11];
		}

		set workflowTypeKey(workflowTypeKey) {
			this.$$set({ workflowTypeKey });
			flush();
		}

		get ownerTypeKey() {
			return this.$$.ctx[12];
		}

		set ownerTypeKey(ownerTypeKey) {
			this.$$set({ ownerTypeKey });
			flush();
		}

		get ownerSourceKey() {
			return this.$$.ctx[13];
		}

		set ownerSourceKey(ownerSourceKey) {
			this.$$set({ ownerSourceKey });
			flush();
		}

		get compositeOwnerTypeKey() {
			return this.$$.ctx[14];
		}

		set compositeOwnerTypeKey(compositeOwnerTypeKey) {
			this.$$set({ compositeOwnerTypeKey });
			flush();
		}

		get compositeOwnerSourceKey() {
			return this.$$.ctx[15];
		}

		set compositeOwnerSourceKey(compositeOwnerSourceKey) {
			this.$$set({ compositeOwnerSourceKey });
			flush();
		}

		get itemContext() {
			return this.$$.ctx[16];
		}

		set itemContext(itemContext) {
			this.$$set({ itemContext });
			flush();
		}

		get selectedWorkflowAction() {
			return this.$$.ctx[0];
		}

		set selectedWorkflowAction(selectedWorkflowAction) {
			this.$$set({ selectedWorkflowAction });
			flush();
		}

		get selectedWorkflowStateKey() {
			return this.$$.ctx[17];
		}

		set selectedWorkflowStateKey(selectedWorkflowStateKey) {
			this.$$set({ selectedWorkflowStateKey });
			flush();
		}

		get commentStatus() {
			return this.$$.ctx[1];
		}

		set commentStatus(commentStatus) {
			this.$$set({ commentStatus });
			flush();
		}
	}

	customElements.define("eas-workflow-update-swc", create_custom_element(Eas_workflow_update, {"applicationKey":{"reflect":true,"type":"Number","attribute":"application-key"},"moduleKey":{"reflect":true,"type":"Number","attribute":"module-key"},"workflowTypeKey":{"reflect":true,"type":"Number","attribute":"workflow-type-key"},"ownerTypeKey":{"reflect":true,"type":"Number","attribute":"owner-type-key"},"ownerSourceKey":{"reflect":true,"type":"Number","attribute":"owner-source-key"},"compositeOwnerTypeKey":{"reflect":true,"type":"Number","attribute":"composite-owner-type-key"},"compositeOwnerSourceKey":{"reflect":true,"type":"Number","attribute":"composite-owner-source-key"},"itemContext":{"reflect":true,"type":"Number","attribute":"item-context"},"selectedWorkflowAction":{},"selectedWorkflowStateKey":{},"commentStatus":{}}, [], [], true));

})();

(function () {
	'use strict';

	/** @returns {void} */
	function noop() {}

	function run(fn) {
		return fn();
	}

	function blank_object() {
		return Object.create(null);
	}

	/**
	 * @param {Function[]} fns
	 * @returns {void}
	 */
	function run_all(fns) {
		fns.forEach(run);
	}

	/**
	 * @param {any} thing
	 * @returns {thing is Function}
	 */
	function is_function(thing) {
		return typeof thing === 'function';
	}

	/** @returns {boolean} */
	function safe_not_equal(a, b) {
		return a != a ? b == b : a !== b || (a && typeof a === 'object') || typeof a === 'function';
	}

	/** @returns {boolean} */
	function is_empty(obj) {
		return Object.keys(obj).length === 0;
	}

	/**
	 * @param {Node} target
	 * @param {Node} node
	 * @returns {void}
	 */
	function append(target, node) {
		target.appendChild(node);
	}

	/**
	 * @param {Node} target
	 * @param {string} style_sheet_id
	 * @param {string} styles
	 * @returns {void}
	 */
	function append_styles(target, style_sheet_id, styles) {
		const append_styles_to = get_root_for_style(target);
		if (!append_styles_to.getElementById(style_sheet_id)) {
			const style = element('style');
			style.id = style_sheet_id;
			style.textContent = styles;
			append_stylesheet(append_styles_to, style);
		}
	}

	/**
	 * @param {Node} node
	 * @returns {ShadowRoot | Document}
	 */
	function get_root_for_style(node) {
		if (!node) return document;
		const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
		if (root && /** @type {ShadowRoot} */ (root).host) {
			return /** @type {ShadowRoot} */ (root);
		}
		return node.ownerDocument;
	}

	/**
	 * @param {ShadowRoot | Document} node
	 * @param {HTMLStyleElement} style
	 * @returns {CSSStyleSheet}
	 */
	function append_stylesheet(node, style) {
		append(/** @type {Document} */ (node).head || node, style);
		return style.sheet;
	}

	/**
	 * @param {Node} target
	 * @param {Node} node
	 * @param {Node} [anchor]
	 * @returns {void}
	 */
	function insert(target, node, anchor) {
		target.insertBefore(node, anchor || null);
	}

	/**
	 * @param {Node} node
	 * @returns {void}
	 */
	function detach(node) {
		if (node.parentNode) {
			node.parentNode.removeChild(node);
		}
	}

	/**
	 * @template {keyof HTMLElementTagNameMap} K
	 * @param {K} name
	 * @returns {HTMLElementTagNameMap[K]}
	 */
	function element(name) {
		return document.createElement(name);
	}

	/**
	 * @param {string} data
	 * @returns {Text}
	 */
	function text(data) {
		return document.createTextNode(data);
	}

	/**
	 * @returns {Text} */
	function space() {
		return text(' ');
	}

	/**
	 * @param {EventTarget} node
	 * @param {string} event
	 * @param {EventListenerOrEventListenerObject} handler
	 * @param {boolean | AddEventListenerOptions | EventListenerOptions} [options]
	 * @returns {() => void}
	 */
	function listen(node, event, handler, options) {
		node.addEventListener(event, handler, options);
		return () => node.removeEventListener(event, handler, options);
	}

	/**
	 * @param {Element} node
	 * @param {string} attribute
	 * @param {string} [value]
	 * @returns {void}
	 */
	function attr(node, attribute, value) {
		if (value == null) node.removeAttribute(attribute);
		else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
	}

	/**
	 * @returns {void} */
	function set_custom_element_data(node, prop, value) {
		const lower = prop.toLowerCase(); // for backwards compatibility with existing behavior we do lowercase first
		if (lower in node) {
			node[lower] = typeof node[lower] === 'boolean' && value === '' ? true : value;
		} else if (prop in node) {
			node[prop] = typeof node[prop] === 'boolean' && value === '' ? true : value;
		} else {
			attr(node, prop, value);
		}
	}

	/**
	 * @param {Element} element
	 * @returns {ChildNode[]}
	 */
	function children(element) {
		return Array.from(element.childNodes);
	}

	/**
	 * @param {Text} text
	 * @param {unknown} data
	 * @returns {void}
	 */
	function set_data(text, data) {
		data = '' + data;
		if (text.data === data) return;
		text.data = /** @type {string} */ (data);
	}

	/**
	 * @template T
	 * @param {string} type
	 * @param {T} [detail]
	 * @param {{ bubbles?: boolean, cancelable?: boolean }} [options]
	 * @returns {CustomEvent<T>}
	 */
	function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
		return new CustomEvent(type, { detail, bubbles, cancelable });
	}

	/**
	 * @param {HTMLElement} element
	 * @returns {{}}
	 */
	function get_custom_elements_slots(element) {
		const result = {};
		element.childNodes.forEach(
			/** @param {Element} node */ (node) => {
				result[node.slot || 'default'] = true;
			}
		);
		return result;
	}

	/**
	 * @typedef {Node & {
	 * 	claim_order?: number;
	 * 	hydrate_init?: true;
	 * 	actual_end_child?: NodeEx;
	 * 	childNodes: NodeListOf<NodeEx>;
	 * }} NodeEx
	 */

	/** @typedef {ChildNode & NodeEx} ChildNodeEx */

	/** @typedef {NodeEx & { claim_order: number }} NodeEx2 */

	/**
	 * @typedef {ChildNodeEx[] & {
	 * 	claim_info?: {
	 * 		last_index: number;
	 * 		total_claimed: number;
	 * 	};
	 * }} ChildNodeArray
	 */

	let current_component;

	/** @returns {void} */
	function set_current_component(component) {
		current_component = component;
	}

	function get_current_component() {
		if (!current_component) throw new Error('Function called outside component initialization');
		return current_component;
	}

	/**
	 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
	 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
	 * it can be called from an external module).
	 *
	 * If a function is returned _synchronously_ from `onMount`, it will be called when the component is unmounted.
	 *
	 * `onMount` does not run inside a [server-side component](https://svelte.dev/docs#run-time-server-side-component-api).
	 *
	 * https://svelte.dev/docs/svelte#onmount
	 * @template T
	 * @param {() => import('./private.js').NotFunction<T> | Promise<import('./private.js').NotFunction<T>> | (() => any)} fn
	 * @returns {void}
	 */
	function onMount(fn) {
		get_current_component().$$.on_mount.push(fn);
	}

	/**
	 * Creates an event dispatcher that can be used to dispatch [component events](https://svelte.dev/docs#template-syntax-component-directives-on-eventname).
	 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
	 *
	 * Component events created with `createEventDispatcher` create a
	 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
	 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
	 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
	 * property and can contain any type of data.
	 *
	 * The event dispatcher can be typed to narrow the allowed event names and the type of the `detail` argument:
	 * ```ts
	 * const dispatch = createEventDispatcher<{
	 *  loaded: never; // does not take a detail argument
	 *  change: string; // takes a detail argument of type string, which is required
	 *  optional: number | null; // takes an optional detail argument of type number
	 * }>();
	 * ```
	 *
	 * https://svelte.dev/docs/svelte#createeventdispatcher
	 * @template {Record<string, any>} [EventMap=any]
	 * @returns {import('./public.js').EventDispatcher<EventMap>}
	 */
	function createEventDispatcher() {
		const component = get_current_component();
		return (type, detail, { cancelable = false } = {}) => {
			const callbacks = component.$$.callbacks[type];
			if (callbacks) {
				// TODO are there situations where events could be dispatched
				// in a server (non-DOM) environment?
				const event = custom_event(/** @type {string} */ (type), detail, { cancelable });
				callbacks.slice().forEach((fn) => {
					fn.call(component, event);
				});
				return !event.defaultPrevented;
			}
			return true;
		};
	}

	const dirty_components = [];
	const binding_callbacks = [];

	let render_callbacks = [];

	const flush_callbacks = [];

	const resolved_promise = /* @__PURE__ */ Promise.resolve();

	let update_scheduled = false;

	/** @returns {void} */
	function schedule_update() {
		if (!update_scheduled) {
			update_scheduled = true;
			resolved_promise.then(flush);
		}
	}

	/** @returns {void} */
	function add_render_callback(fn) {
		render_callbacks.push(fn);
	}

	// flush() calls callbacks in this order:
	// 1. All beforeUpdate callbacks, in order: parents before children
	// 2. All bind:this callbacks, in reverse order: children before parents.
	// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
	//    for afterUpdates called during the initial onMount, which are called in
	//    reverse order: children before parents.
	// Since callbacks might update component values, which could trigger another
	// call to flush(), the following steps guard against this:
	// 1. During beforeUpdate, any updated components will be added to the
	//    dirty_components array and will cause a reentrant call to flush(). Because
	//    the flush index is kept outside the function, the reentrant call will pick
	//    up where the earlier call left off and go through all dirty components. The
	//    current_component value is saved and restored so that the reentrant call will
	//    not interfere with the "parent" flush() call.
	// 2. bind:this callbacks cannot trigger new flush() calls.
	// 3. During afterUpdate, any updated components will NOT have their afterUpdate
	//    callback called a second time; the seen_callbacks set, outside the flush()
	//    function, guarantees this behavior.
	const seen_callbacks = new Set();

	let flushidx = 0; // Do *not* move this inside the flush() function

	/** @returns {void} */
	function flush() {
		// Do not reenter flush while dirty components are updated, as this can
		// result in an infinite loop. Instead, let the inner flush handle it.
		// Reentrancy is ok afterwards for bindings etc.
		if (flushidx !== 0) {
			return;
		}
		const saved_component = current_component;
		do {
			// first, call beforeUpdate functions
			// and update components
			try {
				while (flushidx < dirty_components.length) {
					const component = dirty_components[flushidx];
					flushidx++;
					set_current_component(component);
					update(component.$$);
				}
			} catch (e) {
				// reset dirty state to not end up in a deadlocked state and then rethrow
				dirty_components.length = 0;
				flushidx = 0;
				throw e;
			}
			set_current_component(null);
			dirty_components.length = 0;
			flushidx = 0;
			while (binding_callbacks.length) binding_callbacks.pop()();
			// then, once components are updated, call
			// afterUpdate functions. This may cause
			// subsequent updates...
			for (let i = 0; i < render_callbacks.length; i += 1) {
				const callback = render_callbacks[i];
				if (!seen_callbacks.has(callback)) {
					// ...so guard against infinite loops
					seen_callbacks.add(callback);
					callback();
				}
			}
			render_callbacks.length = 0;
		} while (dirty_components.length);
		while (flush_callbacks.length) {
			flush_callbacks.pop()();
		}
		update_scheduled = false;
		seen_callbacks.clear();
		set_current_component(saved_component);
	}

	/** @returns {void} */
	function update($$) {
		if ($$.fragment !== null) {
			$$.update();
			run_all($$.before_update);
			const dirty = $$.dirty;
			$$.dirty = [-1];
			$$.fragment && $$.fragment.p($$.ctx, dirty);
			$$.after_update.forEach(add_render_callback);
		}
	}

	/**
	 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
	 * @param {Function[]} fns
	 * @returns {void}
	 */
	function flush_render_callbacks(fns) {
		const filtered = [];
		const targets = [];
		render_callbacks.forEach((c) => (fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c)));
		targets.forEach((c) => c());
		render_callbacks = filtered;
	}

	const outroing = new Set();

	/**
	 * @param {import('./private.js').Fragment} block
	 * @param {0 | 1} [local]
	 * @returns {void}
	 */
	function transition_in(block, local) {
		if (block && block.i) {
			outroing.delete(block);
			block.i(local);
		}
	}

	/** @typedef {1} INTRO */
	/** @typedef {0} OUTRO */
	/** @typedef {{ direction: 'in' | 'out' | 'both' }} TransitionOptions */
	/** @typedef {(node: Element, params: any, options: TransitionOptions) => import('../transition/public.js').TransitionConfig} TransitionFn */

	/**
	 * @typedef {Object} Outro
	 * @property {number} r
	 * @property {Function[]} c
	 * @property {Object} p
	 */

	/**
	 * @typedef {Object} PendingProgram
	 * @property {number} start
	 * @property {INTRO|OUTRO} b
	 * @property {Outro} [group]
	 */

	/**
	 * @typedef {Object} Program
	 * @property {number} a
	 * @property {INTRO|OUTRO} b
	 * @property {1|-1} d
	 * @property {number} duration
	 * @property {number} start
	 * @property {number} end
	 * @property {Outro} [group]
	 */

	/** @returns {void} */
	function mount_component(component, target, anchor) {
		const { fragment, after_update } = component.$$;
		fragment && fragment.m(target, anchor);
		// onMount happens before the initial afterUpdate
		add_render_callback(() => {
			const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
			// if the component was destroyed immediately
			// it will update the `$$.on_destroy` reference to `null`.
			// the destructured on_destroy may still reference to the old array
			if (component.$$.on_destroy) {
				component.$$.on_destroy.push(...new_on_destroy);
			} else {
				// Edge case - component was destroyed immediately,
				// most likely as a result of a binding initialising
				run_all(new_on_destroy);
			}
			component.$$.on_mount = [];
		});
		after_update.forEach(add_render_callback);
	}

	/** @returns {void} */
	function destroy_component(component, detaching) {
		const $$ = component.$$;
		if ($$.fragment !== null) {
			flush_render_callbacks($$.after_update);
			run_all($$.on_destroy);
			$$.fragment && $$.fragment.d(detaching);
			// TODO null out other refs, including component.$$ (but need to
			// preserve final state?)
			$$.on_destroy = $$.fragment = null;
			$$.ctx = [];
		}
	}

	/** @returns {void} */
	function make_dirty(component, i) {
		if (component.$$.dirty[0] === -1) {
			dirty_components.push(component);
			schedule_update();
			component.$$.dirty.fill(0);
		}
		component.$$.dirty[(i / 31) | 0] |= 1 << i % 31;
	}

	// TODO: Document the other params
	/**
	 * @param {SvelteComponent} component
	 * @param {import('./public.js').ComponentConstructorOptions} options
	 *
	 * @param {import('./utils.js')['not_equal']} not_equal Used to compare props and state values.
	 * @param {(target: Element | ShadowRoot) => void} [append_styles] Function that appends styles to the DOM when the component is first initialised.
	 * This will be the `add_css` function from the compiled component.
	 *
	 * @returns {void}
	 */
	function init(
		component,
		options,
		instance,
		create_fragment,
		not_equal,
		props,
		append_styles = null,
		dirty = [-1]
	) {
		const parent_component = current_component;
		set_current_component(component);
		/** @type {import('./private.js').T$$} */
		const $$ = (component.$$ = {
			fragment: null,
			ctx: [],
			// state
			props,
			update: noop,
			not_equal,
			bound: blank_object(),
			// lifecycle
			on_mount: [],
			on_destroy: [],
			on_disconnect: [],
			before_update: [],
			after_update: [],
			context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
			// everything else
			callbacks: blank_object(),
			dirty,
			skip_bound: false,
			root: options.target || parent_component.$$.root
		});
		append_styles && append_styles($$.root);
		let ready = false;
		$$.ctx = instance
			? instance(component, options.props || {}, (i, ret, ...rest) => {
					const value = rest.length ? rest[0] : ret;
					if ($$.ctx && not_equal($$.ctx[i], ($$.ctx[i] = value))) {
						if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
						if (ready) make_dirty(component, i);
					}
					return ret;
			  })
			: [];
		$$.update();
		ready = true;
		run_all($$.before_update);
		// `false` as a special case of no DOM component
		$$.fragment = create_fragment ? create_fragment($$.ctx) : false;
		if (options.target) {
			if (options.hydrate) {
				// TODO: what is the correct type here?
				// @ts-expect-error
				const nodes = children(options.target);
				$$.fragment && $$.fragment.l(nodes);
				nodes.forEach(detach);
			} else {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				$$.fragment && $$.fragment.c();
			}
			if (options.intro) transition_in(component.$$.fragment);
			mount_component(component, options.target, options.anchor);
			flush();
		}
		set_current_component(parent_component);
	}

	let SvelteElement;

	if (typeof HTMLElement === 'function') {
		SvelteElement = class extends HTMLElement {
			/** The Svelte component constructor */
			$$ctor;
			/** Slots */
			$$s;
			/** The Svelte component instance */
			$$c;
			/** Whether or not the custom element is connected */
			$$cn = false;
			/** Component props data */
			$$d = {};
			/** `true` if currently in the process of reflecting component props back to attributes */
			$$r = false;
			/** @type {Record<string, CustomElementPropDefinition>} Props definition (name, reflected, type etc) */
			$$p_d = {};
			/** @type {Record<string, Function[]>} Event listeners */
			$$l = {};
			/** @type {Map<Function, Function>} Event listener unsubscribe functions */
			$$l_u = new Map();

			constructor($$componentCtor, $$slots, use_shadow_dom) {
				super();
				this.$$ctor = $$componentCtor;
				this.$$s = $$slots;
				if (use_shadow_dom) {
					this.attachShadow({ mode: 'open' });
				}
			}

			addEventListener(type, listener, options) {
				// We can't determine upfront if the event is a custom event or not, so we have to
				// listen to both. If someone uses a custom event with the same name as a regular
				// browser event, this fires twice - we can't avoid that.
				this.$$l[type] = this.$$l[type] || [];
				this.$$l[type].push(listener);
				if (this.$$c) {
					const unsub = this.$$c.$on(type, listener);
					this.$$l_u.set(listener, unsub);
				}
				super.addEventListener(type, listener, options);
			}

			removeEventListener(type, listener, options) {
				super.removeEventListener(type, listener, options);
				if (this.$$c) {
					const unsub = this.$$l_u.get(listener);
					if (unsub) {
						unsub();
						this.$$l_u.delete(listener);
					}
				}
			}

			async connectedCallback() {
				this.$$cn = true;
				if (!this.$$c) {
					// We wait one tick to let possible child slot elements be created/mounted
					await Promise.resolve();
					if (!this.$$cn || this.$$c) {
						return;
					}
					function create_slot(name) {
						return () => {
							let node;
							const obj = {
								c: function create() {
									node = element('slot');
									if (name !== 'default') {
										attr(node, 'name', name);
									}
								},
								/**
								 * @param {HTMLElement} target
								 * @param {HTMLElement} [anchor]
								 */
								m: function mount(target, anchor) {
									insert(target, node, anchor);
								},
								d: function destroy(detaching) {
									if (detaching) {
										detach(node);
									}
								}
							};
							return obj;
						};
					}
					const $$slots = {};
					const existing_slots = get_custom_elements_slots(this);
					for (const name of this.$$s) {
						if (name in existing_slots) {
							$$slots[name] = [create_slot(name)];
						}
					}
					for (const attribute of this.attributes) {
						// this.$$data takes precedence over this.attributes
						const name = this.$$g_p(attribute.name);
						if (!(name in this.$$d)) {
							this.$$d[name] = get_custom_element_value(name, attribute.value, this.$$p_d, 'toProp');
						}
					}
					// Port over props that were set programmatically before ce was initialized
					for (const key in this.$$p_d) {
						if (!(key in this.$$d) && this[key] !== undefined) {
							this.$$d[key] = this[key]; // don't transform, these were set through JavaScript
							delete this[key]; // remove the property that shadows the getter/setter
						}
					}
					this.$$c = new this.$$ctor({
						target: this.shadowRoot || this,
						props: {
							...this.$$d,
							$$slots,
							$$scope: {
								ctx: []
							}
						}
					});

					// Reflect component props as attributes
					const reflect_attributes = () => {
						this.$$r = true;
						for (const key in this.$$p_d) {
							this.$$d[key] = this.$$c.$$.ctx[this.$$c.$$.props[key]];
							if (this.$$p_d[key].reflect) {
								const attribute_value = get_custom_element_value(
									key,
									this.$$d[key],
									this.$$p_d,
									'toAttribute'
								);
								if (attribute_value == null) {
									this.removeAttribute(this.$$p_d[key].attribute || key);
								} else {
									this.setAttribute(this.$$p_d[key].attribute || key, attribute_value);
								}
							}
						}
						this.$$r = false;
					};
					this.$$c.$$.after_update.push(reflect_attributes);
					reflect_attributes(); // once initially because after_update is added too late for first render

					for (const type in this.$$l) {
						for (const listener of this.$$l[type]) {
							const unsub = this.$$c.$on(type, listener);
							this.$$l_u.set(listener, unsub);
						}
					}
					this.$$l = {};
				}
			}

			// We don't need this when working within Svelte code, but for compatibility of people using this outside of Svelte
			// and setting attributes through setAttribute etc, this is helpful
			attributeChangedCallback(attr, _oldValue, newValue) {
				if (this.$$r) return;
				attr = this.$$g_p(attr);
				this.$$d[attr] = get_custom_element_value(attr, newValue, this.$$p_d, 'toProp');
				this.$$c?.$set({ [attr]: this.$$d[attr] });
			}

			disconnectedCallback() {
				this.$$cn = false;
				// In a microtask, because this could be a move within the DOM
				Promise.resolve().then(() => {
					if (!this.$$cn && this.$$c) {
						this.$$c.$destroy();
						this.$$c = undefined;
					}
				});
			}

			$$g_p(attribute_name) {
				return (
					Object.keys(this.$$p_d).find(
						(key) =>
							this.$$p_d[key].attribute === attribute_name ||
							(!this.$$p_d[key].attribute && key.toLowerCase() === attribute_name)
					) || attribute_name
				);
			}
		};
	}

	/**
	 * @param {string} prop
	 * @param {any} value
	 * @param {Record<string, CustomElementPropDefinition>} props_definition
	 * @param {'toAttribute' | 'toProp'} [transform]
	 */
	function get_custom_element_value(prop, value, props_definition, transform) {
		const type = props_definition[prop]?.type;
		value = type === 'Boolean' && typeof value !== 'boolean' ? value != null : value;
		if (!transform || !props_definition[prop]) {
			return value;
		} else if (transform === 'toAttribute') {
			switch (type) {
				case 'Object':
				case 'Array':
					return value == null ? null : JSON.stringify(value);
				case 'Boolean':
					return value ? '' : null;
				case 'Number':
					return value == null ? null : value;
				default:
					return value;
			}
		} else {
			switch (type) {
				case 'Object':
				case 'Array':
					return value && JSON.parse(value);
				case 'Boolean':
					return value; // conversion already handled above
				case 'Number':
					return value != null ? +value : value;
				default:
					return value;
			}
		}
	}

	/**
	 * @internal
	 *
	 * Turn a Svelte component into a custom element.
	 * @param {import('./public.js').ComponentType} Component  A Svelte component constructor
	 * @param {Record<string, CustomElementPropDefinition>} props_definition  The props to observe
	 * @param {string[]} slots  The slots to create
	 * @param {string[]} accessors  Other accessors besides the ones for props the component has
	 * @param {boolean} use_shadow_dom  Whether to use shadow DOM
	 * @param {(ce: new () => HTMLElement) => new () => HTMLElement} [extend]
	 */
	function create_custom_element(
		Component,
		props_definition,
		slots,
		accessors,
		use_shadow_dom,
		extend
	) {
		let Class = class extends SvelteElement {
			constructor() {
				super(Component, slots, use_shadow_dom);
				this.$$p_d = props_definition;
			}
			static get observedAttributes() {
				return Object.keys(props_definition).map((key) =>
					(props_definition[key].attribute || key).toLowerCase()
				);
			}
		};
		Object.keys(props_definition).forEach((prop) => {
			Object.defineProperty(Class.prototype, prop, {
				get() {
					return this.$$c && prop in this.$$c ? this.$$c[prop] : this.$$d[prop];
				},
				set(value) {
					value = get_custom_element_value(prop, value, props_definition);
					this.$$d[prop] = value;
					this.$$c?.$set({ [prop]: value });
				}
			});
		});
		accessors.forEach((accessor) => {
			Object.defineProperty(Class.prototype, accessor, {
				get() {
					return this.$$c?.[accessor];
				}
			});
		});
		if (extend) {
			// @ts-expect-error - assigning here is fine
			Class = extend(Class);
		}
		Component.element = /** @type {any} */ (Class);
		return Class;
	}

	/**
	 * Base class for Svelte components. Used when dev=false.
	 *
	 * @template {Record<string, any>} [Props=any]
	 * @template {Record<string, any>} [Events=any]
	 */
	class SvelteComponent {
		/**
		 * ### PRIVATE API
		 *
		 * Do not use, may change at any time
		 *
		 * @type {any}
		 */
		$$ = undefined;
		/**
		 * ### PRIVATE API
		 *
		 * Do not use, may change at any time
		 *
		 * @type {any}
		 */
		$$set = undefined;

		/** @returns {void} */
		$destroy() {
			destroy_component(this, 1);
			this.$destroy = noop;
		}

		/**
		 * @template {Extract<keyof Events, string>} K
		 * @param {K} type
		 * @param {((e: Events[K]) => void) | null | undefined} callback
		 * @returns {() => void}
		 */
		$on(type, callback) {
			if (!is_function(callback)) {
				return noop;
			}
			const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
			callbacks.push(callback);
			return () => {
				const index = callbacks.indexOf(callback);
				if (index !== -1) callbacks.splice(index, 1);
			};
		}

		/**
		 * @param {Partial<Props>} props
		 * @returns {void}
		 */
		$set(props) {
			if (this.$$set && !is_empty(props)) {
				this.$$.skip_bound = true;
				this.$$set(props);
				this.$$.skip_bound = false;
			}
		}
	}

	/**
	 * @typedef {Object} CustomElementPropDefinition
	 * @property {string} [attribute]
	 * @property {boolean} [reflect]
	 * @property {'String'|'Boolean'|'Number'|'Array'|'Object'} [type]
	 */

	// generated during release, do not modify

	const PUBLIC_VERSION = '4';

	if (typeof window !== 'undefined')
		// @ts-ignore
		(window.__svelte || (window.__svelte = { v: new Set() })).v.add(PUBLIC_VERSION);

	class ServiceBase {
	    _headers = new Headers();
	    easBaseUrl;
	    easDataloadBaseUrl;
	    monitoringBaseUrl;
	    easAssetAuthUrl;
	    helpBaseUrl;
	    easUtilityUrl;
	    easWorkflowBaseUrl;
	    easContactBaseUrl;
	    validationResultsUrl;
	    validationRevalidateUrl;
	    apiEndPoint;
	    easCommunicationLogUrl;
	    easCommunicationUrl;
	    accessToken;
	    claimToken;
	    get headers() {
	        // Every time we get the headers, we need to check if the access token and claims token
	        // are already loaded. If not, we need to load them from session storage. 
	        // Otherwise it just returns the headers without any change. - kevin.low 01/02/24
	        if (!('accessToken' in this.accessToken)) {
	            console.error('accessToken not in this.accessToken. Reloading it from session storage.');
	            try {
	                this.accessToken = JSON.parse(sessionStorage.getItem('accessToken') ?? '{}');
	                if (!('accessToken' in this.accessToken)) {
	                    console.error('accessToken is still not found in session storage.');
	                }
	                else {
	                    this._headers.delete('Authorization');
	                    this._headers.append('Authorization', `Bearer ${this.accessToken?.accessToken}`);
	                }
	            }
	            catch (error) {
	                console.error(error);
	            }
	        }
	        try {
	            let updatedClaimToken = JSON.parse(sessionStorage.getItem('claims') ?? '{}');
	            if (!('claimsJwt' in this.claimToken)) {
	                console.error('claims is still not found in session storage.');
	            }
	            else {
	                if (this.claimToken?.claimsJwt != updatedClaimToken?.claimsJwt) {
	                    this._headers.delete('claims');
	                    this._headers.append('claims', this.claimToken?.claimsJwt);
	                }
	            }
	        }
	        catch (error) {
	            console.error(error);
	        }
	        return this._headers;
	    }
	    set headers(value) {
	        this._headers = value;
	    }
	    constructor() {
	        //Storybook url
	        if (window.location.href.includes(':6006')) {
	            sessionStorage.setItem('EAS_Base_Url', 'https://edu-dev-eas-assetauth.azurewebsites.net');
	            sessionStorage.setItem('EAS_Dataload_Base_Url', 'https://edu-dev-eas-dataload-request.azurewebsites.net');
	            sessionStorage.setItem('Asset_Auth_Url', 'https://edu-dev-eas-assetauth.azurewebsites.net');
	            sessionStorage.setItem('Eas_Help_Url', 'https://edu-dev-ent-help.azurewebsites.net');
	            sessionStorage.setItem('Eas_Utility_Url', 'https://edu-dev-eas-utility.azurewebsites.net');
	            sessionStorage.setItem('Eas_Workflow_Url', 'https://edu-dev-eas-workflow.azurewebsites.net');
	            sessionStorage.setItem('Eas_Contact_Url', 'https://edu-dev-eas-contact.azurewebsites.net');
	            sessionStorage.setItem('Eas_CommunicationLog_Url', 'https://edu-dev-eas-communicationlog.azurewebsites.net');
	            sessionStorage.setItem('Eas_Communication_Url', 'https://edu-dev-eas-communication.azurewebsites.net');
	            sessionStorage.setItem('accessToken', `{"accessToken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYzYmVjNmVkLWRlMDUtNGQxZS05ZTI0LTQwZTJlNTUxNGQzYSIsInVuaXF1ZV9uYW1lIjoiOTUzMDQiLCJmaXJzdF9uYW1lIjoiRGlhbmUiLCJsYXN0X25hbWUiOiJOZWFsIiwicGVyc29uX2tleSI6Ijk1MzA0Iiwic3lzdGVtX2tleSI6IjMwIiwidXVpZCI6IkE5Uk8wR1RXSklTTFJCSEo1UkU4WVVYTTlTUFJOSEIwVTk0QyIsInN5c3RlbV91cmwiOiJodHRwczovL2Vkc3RlcHNkZXYuZWR1Y2F0aW9uLm9oaW8uZ292L29uZWZ1bmRpbmcvIiwic3lzdGVtX25hbWUiOiJPbmUgRnVuZGluZyBBcHBsaWNhdGlvbiIsIm9mZmljZV9lbWFpbCI6IiIsImhvbWVfZW1haWwiOiIiLCJvYWtzX2lkIjoiIiwibmJmIjoxNzI3Nzg2MDQyLCJleHAiOjE3Mjc4NzI0NDIsImlhdCI6MTcyNzc4NjA0MiwiaXNzIjoib2hpby1kZXBhcnRtZW50LW9mLWVkdWNhdGlvbiIsImF1ZCI6ImVhc19hdWRpZW5jZSJ9.ZxhT5--NANxGfhrG15E_uCJp3iCR9nu_hykdzROYYN4","orgs":[{"org_id":6108,"name":"Ohio Department of Education and Workforce","audiences":[{"aud_id":1,"name":"Admin","applications":[{"app_id":231,"name":"One Funding Application","url":null}]}],"irn":"050765"}],"expires":"2024-10-02T08:34:02.4470379Z","public":false}`);
	            sessionStorage.setItem('claims', `{"claimsJwt":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYwNDdhZTYwLWE3Y2YtNDlhMy1hNjdiLTQ4YzgxYTIwMzU1ZSIsImFwcGxpY2F0aW9uX2tleSI6IjIzMSIsImF1ZGllbmNlX2tleSI6IjEiLCJvcmdfa2V5IjoiNjEwOCIsIm9yZ19uYW1lIjoiT2hpbyBEZXBhcnRtZW50IG9mIEVkdWNhdGlvbiBhbmQgV29ya2ZvcmNlIiwiaXJuIjoiMDUwNzY1Iiwib3JnX3R5cGVfa2V5IjoiMjciLCJvcmdfdHlwZV9uYW1lIjoiU3RhdGUgQm9hcmQvQWdlbmN5Iiwicm9sZV9jb250ZXh0IjoiMjciLCJjb250YWN0X2NvbnRleHRfaWQiOiIzNDAiLCJjb250YWN0X2NvbnRleHRfdXJsIjoiaHR0cHM6Ly9lZHUtZGV2LW9uZS1mdW5kaW5nLWdhdGV3YXkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL0NvbnRhY3RDb250ZXh0LzM0MCIsIm5iZiI6MTcyNzc4NjA1NSwiZXhwIjoxNzI3ODcyNDU1LCJpYXQiOjE3Mjc3ODYwNTUsImlzcyI6Im9oaW8tZGVwYXJ0bWVudC1vZi1lZHVjYXRpb24iLCJhdWQiOiJlYXNfYXVkaWVuY2UifQ.rX-IV9OdOKB2SeqGE171a0Ks-h6Mzy5VoIp1pSO9sg0","claims":{"organizationId":6108,"audienceId":1,"applicationId":231,"contactContextId":"340","contactContextUrl":"https://edu-dev-one-funding-gateway.azurewebsites.net/api/ContactContext/340"}}`);
	        }
	        this.easBaseUrl = sessionStorage.getItem('EAS_Base_Url') ?? '';
	        this.easDataloadBaseUrl = sessionStorage.getItem('EAS_Dataload_Base_Url') ?? '';
	        this.monitoringBaseUrl = sessionStorage.getItem('Monitoring_Base_Url') ?? '';
	        this.easAssetAuthUrl = sessionStorage.getItem('Asset_Auth_Url') ?? '';
	        this.helpBaseUrl = sessionStorage.getItem('Eas_Help_Url') ?? '';
	        this.easUtilityUrl = sessionStorage.getItem('Eas_Utility_Url') ?? '';
	        this.easWorkflowBaseUrl = sessionStorage.getItem('Eas_Workflow_Url') ?? '';
	        this.easContactBaseUrl = sessionStorage.getItem('Eas_Contact_Url') ?? '';
	        this.validationResultsUrl = sessionStorage.getItem('Validation_Results_Url') ?? '';
	        this.validationRevalidateUrl = sessionStorage.getItem('Validation_Revalidate_Url') ?? '';
	        this.apiEndPoint = sessionStorage.getItem('APIEndPoint') ?? '';
	        this.easCommunicationLogUrl = sessionStorage.getItem('Eas_CommunicationLog_Url') ?? '';
	        this.easCommunicationUrl = sessionStorage.getItem('Eas_Communication_Url') ?? '';
	        try {
	            this.accessToken = JSON.parse(sessionStorage.getItem('accessToken') ?? '{}');
	            if (!('accessToken' in this.accessToken)) {
	                console.error('accessToken is not found in session storage.');
	            }
	        }
	        catch (error) {
	            console.log(error);
	        }
	        try {
	            this.claimToken = JSON.parse(sessionStorage.getItem('claims') ?? '{}');
	            if (!('claimsJwt' in this.claimToken)) {
	                console.error('claims is not found in session storage.');
	            }
	        }
	        catch (error) {
	            console.error(error);
	        }
	        this.headers = new Headers();
	        this.headers.append('Content-Type', 'application/json');
	        this.headers.append('Authorization', `Bearer ${this.accessToken?.accessToken}`);
	        //this.headers.append('Authorization', `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYzYmVjNmVkLWRlMDUtNGQxZS05ZTI0LTQwZTJlNTUxNGQzYSIsInVuaXF1ZV9uYW1lIjoiOTUzMDQiLCJmaXJzdF9uYW1lIjoiRGlhbmUiLCJsYXN0X25hbWUiOiJOZWFsIiwicGVyc29uX2tleSI6Ijk1MzA0Iiwic3lzdGVtX2tleSI6IjMwIiwidXVpZCI6IkE5Uk8wR1RXSklTTFJCSEo1UkU4WVVYTTlTUFJOSEIwVTk0QyIsInN5c3RlbV91cmwiOiJodHRwczovL2Vkc3RlcHNkZXYuZWR1Y2F0aW9uLm9oaW8uZ292L29uZWZ1bmRpbmcvIiwic3lzdGVtX25hbWUiOiJPbmUgRnVuZGluZyBBcHBsaWNhdGlvbiIsIm9mZmljZV9lbWFpbCI6IiIsImhvbWVfZW1haWwiOiIiLCJvYWtzX2lkIjoiIiwibmJmIjoxNzI3Nzg2MDQyLCJleHAiOjE3Mjc4NzI0NDIsImlhdCI6MTcyNzc4NjA0MiwiaXNzIjoib2hpby1kZXBhcnRtZW50LW9mLWVkdWNhdGlvbiIsImF1ZCI6ImVhc19hdWRpZW5jZSJ9.ZxhT5--NANxGfhrG15E_uCJp3iCR9nu_hykdzROYYN4`);
	        this.headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
	        this.headers.append('x-requestid', this.generateUUID());
	        this.headers.append('claims', this.claimToken?.claimsJwt);
	        //this.headers.append('claims', `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5NTMwNCIsImp0aSI6IjYwNDdhZTYwLWE3Y2YtNDlhMy1hNjdiLTQ4YzgxYTIwMzU1ZSIsImFwcGxpY2F0aW9uX2tleSI6IjIzMSIsImF1ZGllbmNlX2tleSI6IjEiLCJvcmdfa2V5IjoiNjEwOCIsIm9yZ19uYW1lIjoiT2hpbyBEZXBhcnRtZW50IG9mIEVkdWNhdGlvbiBhbmQgV29ya2ZvcmNlIiwiaXJuIjoiMDUwNzY1Iiwib3JnX3R5cGVfa2V5IjoiMjciLCJvcmdfdHlwZV9uYW1lIjoiU3RhdGUgQm9hcmQvQWdlbmN5Iiwicm9sZV9jb250ZXh0IjoiMjciLCJjb250YWN0X2NvbnRleHRfaWQiOiIzNDAiLCJjb250YWN0X2NvbnRleHRfdXJsIjoiaHR0cHM6Ly9lZHUtZGV2LW9uZS1mdW5kaW5nLWdhdGV3YXkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL0NvbnRhY3RDb250ZXh0LzM0MCIsIm5iZiI6MTcyNzc4NjA1NSwiZXhwIjoxNzI3ODcyNDU1LCJpYXQiOjE3Mjc3ODYwNTUsImlzcyI6Im9oaW8tZGVwYXJ0bWVudC1vZi1lZHVjYXRpb24iLCJhdWQiOiJlYXNfYXVkaWVuY2UifQ.rX-IV9OdOKB2SeqGE171a0Ks-h6Mzy5VoIp1pSO9sg0`);
	    }
	    getJSON = (url) => {
	        return fetch(url, { headers: this.headers })
	            .then(response => {
	            return response.status === 204 ? [] : response.json();
	        });
	    };
	    postJSON = (url, payload) => {
	        return fetch(url, { method: 'POST', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => {
	            return response.json();
	        });
	    };
	    putJSON = (url, payload) => {
	        return fetch(url, { method: 'PUT', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => response.json());
	    };
	    putData = (url) => {
	        return fetch(url, { method: 'PUT', headers: this.headers })
	            .then(response => response.json());
	    };
	    deleteJSON = (url, payload) => {
	        return fetch(url, { method: 'DELETE', body: JSON.stringify(payload), headers: this.headers })
	            .then(response => response.json());
	    };
	    postData = (url, payload) => {
	        return fetch(url, { method: 'POST', body: payload, headers: this.headers })
	            .then(response => response.json());
	    };
	    getString = (url) => {
	        return fetch(url, { headers: this.headers })
	            .then(response => response.text());
	    };
	    uploadFile = (url, payload) => {
	        this.headers.delete('Content-Type');
	        //this.headers.append('Content-Type', 'multipart/form-data; boundary=----WebKitFormBoundaryaw7OAy2cWKU1Ndnn');
	        return fetch(url, { method: 'POST', body: payload, headers: this.headers })
	            .then(data => data.text());
	    };
	    getFile = (url) => {
	        this.headers.delete('Content-Type');
	        const options = {
	            headers: this.headers,
	            observe: 'body', // return data only
	            responseType: 'blob' // return type for binary data; json is default
	        };
	        return fetch(url, options);
	        //.then(response => response);
	    };
	    get = (url) => {
	        this.headers.delete('Content-Type');
	        return fetch(url, { headers: this.headers });
	        //.then(response => response);
	    };
	    generateUUID() {
	        var d = new Date().getTime(); //Timestamp
	        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16; //random number between 0 and 16
	            if (d > 0) { //Use timestamp until depleted
	                r = (d + r) % 16 | 0;
	                d = Math.floor(d / 16);
	            }
	            else { //Use microseconds since page-load if supported
	                r = (d2 + r) % 16 | 0;
	                d2 = Math.floor(d2 / 16);
	            }
	            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	        });
	    }
	}

	class WorkflowService extends ServiceBase {
	    getWorkflowTransitionHistory(request) {
	        let url = `${this.easWorkflowBaseUrl}/api/v4/workflow/history?moduleKey=${request.moduleKey}&workflowOwnerSourceKey=${request.workflowCompositeOwnerSourceKey}&workflowOwnerTypeKey=${request.workflowOwnerTypeKey}&workflowTypeKey=${request.workflowTypeKey}&workflowCompositeOwnerSourceKey=${request.workflowCompositeOwnerSourceKey}&workflowCompositeOwnerTypeKey=${request.workflowCompositeOwnerTypeKey}&applicationKey=${request.applicationKey}`;
	        let result = new Promise((resolve, reject) => {
	            this.getJSON(url)
	                .then((workflowHistory) => {
	                resolve(workflowHistory);
	            }).catch((err) => {
	                reject(err);
	            });
	        });
	        return result;
	    }
	}

	/* src\lib\workflow-history\eas-workflow-history.svelte generated by Svelte v4.2.19 */

	function add_css(target) {
		append_styles(target, "svelte-139h56j", ".header.svelte-139h56j{display:flex;justify-content:space-between}.should-hide.svelte-139h56j{display:none !important}.should-display.svelte-139h56j{display:flex;height:100%;flex-direction:column}:root{--gray-800:#2c2c2c;--gray-700:#434343;--gray-600:#8C8C8C;--gray-500:#BFBFBF;--gray-400:#D9D9D9;--gray-300:#E8E8E8;--gray-250:#F0F0F0;--gray-200:#F2F2F2;--gray-100:#F6F6F6;--gray-50:#F7F7F7;--maroon-800:#700017;--maroon-700:#8B3043;--maroon-600:#99495A;--maroon-500:#AA6D7E;--maroon-400:#BF95A5;--maroon-300:#E9D9DC;--maroon-200:#F5EEEE;--maroon-100:#FAF6F6;--maroon-lte-100:#faf6f6;--maroon-lte-200:#f5eeee;--red-800:#EA1014;--red-700:#F1353A;--red-600:#F4595C;--red-500:#F57174;--red-400:#F7888B;--red-300:#F9ACAE;--red-200:#FBC4C5;--red-100:#FDE7E7;--red-50:#faf6f6;--blue-800:#3d7aa9;--blue-700:#4781ad;--blue-600:#5f91b7;--blue-500:#749fc1;--blue-400:#9ebcd4;--blue-300:#c4d7e5;--blue-200:#e2ebf2;--blue-100:#f4f7fa;--blue-lte-100:#eff0f5;--lte-blue-800:#73A5CC;--lte-blue-700:#88B2D4;--lte-blue-600:#A4C4DE;--lte-blue-500:#C0D6E8;--lte-blue-400:#CEE0ED;--lte-blue-300:#DCE8F2;--lte-blue-200:#EAF2F7;--lte-blue-100:#F4F8FB;--gold-800:#ffbe0e;--gold-700:#ffce4a;--gold-600:#fad87b;--gold-500:#f8de9b;--gold-400:#f6e2b2;--gold-300:#f4e7ca;--gold-200:#f2ebdd;--gold-100:#f3f1ed;--drk-green-800:#5E8000;--drk-green-700:#6E8C19;--drk-green-600:#7E9933;--drk-green-500:#8EA64C;--drk-green-400:#AEBF7F;--drk-green-300:#C7D3A6;--drk-green-200:#DFE6CC;--drk-green-100:#EFF2E5;--green-800:#B5DC10;--green-700:#BCDF27;--green-600:#C4E340;--green-500:#CBE657;--green-400:#DAED87;--green-300:#E5F3AC;--green-200:#F0F8CF;--green-100:#F7FBE7;--ohid-blue-100:#EBF7FF;--ohid-blue-200:#D9EFFF;--ohid-blue-300:#BFE5FF;--ohid-blue-400:#A6DAFF;--ohid-blue-500:#8CD0FF;--ohid-blue-600:#59BBFF;--ohid-blue-700:#26A6FF;--ohid-blue-800:#0096FF;--ohid-drk-blue-100:#ECF0F4;--ohid-drk-blue-200:#DAE3E9;--ohid-drk-blue-300:#C2D0DB;--ohid-drk-blue-400:#A9BDCC;--ohid-drk-blue-500:#91AABE;--ohid-drk-blue-600:#6084A1;--ohid-drk-blue-700:#2F5E84;--ohid-drk-blue-800:#0A426E;--iop-lt-blue-800:#40b0ff;--iop-blue-800:#0096ff;--iop-drk-blue-800:#004393;--lte:300;--reg:400;--semi:600;--bold:700}h4.svelte-139h56j,h5.svelte-139h56j{width:fit-content;padding:0;margin:0}h4.svelte-139h56j{font-size:1.25rem;line-height:1.6rem}h4.svelte-139h56j,h5.svelte-139h56j{margin:0;font-weight:var(--reg);font-family:'Source Sans Pro', sans-serif}div.svelte-139h56j{display:block}.card.fluid.svelte-139h56j{max-width:100%!important}.card.svelte-139h56j{display:flex;flex:1 1 20%;flex-direction:column;min-width:150px;max-width:340px;width:100%;margin:0!important;text-decoration:none;border:0 solid transparent;border-radius:0;background:white;overflow:hidden;outline:3px solid transparent;transition:all .22s ease-in-out}.svelte-139h56j,.svelte-139h56j:after,.svelte-139h56j:before{box-sizing:border-box;padding:0;margin:0}a.svelte-139h56j{text-decoration:none;color:var(--blue-800);font-weight:bold}.fa-solid.svelte-139h56j{font-family:\"Font Awesome 6 Pro\";font-weight:900}.fa-solid.svelte-139h56j{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:var(--fa-display,inline-block);font-style:normal;font-variant:normal;line-height:1;text-rendering:auto}i.svelte-139h56j{font-style:italic}div.svelte-139h56j{font-family:'Source Sans Pro', sans-serif}.card.fluid.svelte-139h56j{max-width:100%!important}.flex-row.svelte-139h56j{flex-direction:row !important}.mt-10.svelte-139h56j{margin-top:10px!important}.font-20.svelte-139h56j{font-size:20px}.font-15.svelte-139h56j{font-size:15px}.utility_table_min_width.svelte-139h56j{min-width:130px}.utility_panel_container.svelte-139h56j{margin:20px auto;width:95%}.font-black.svelte-139h56j{color:black}.gray-600-font.svelte-139h56j{color:var(--gray-600)!important\r\n}h5.svelte-139h56j{font-size:1.125rem;line-height:1.125}");
	}

	// (129:8) {#if showError}
	function create_if_block(ctx) {
		let eas_validation_message;
		let mounted;
		let dispose;

		return {
			c() {
				eas_validation_message = element("eas-validation-message");
				set_custom_element_data(eas_validation_message, "message", /*errorMessage*/ ctx[3]);
				set_custom_element_data(eas_validation_message, "type", "error");
				set_custom_element_data(eas_validation_message, "showError", /*showError*/ ctx[2]);
				set_custom_element_data(eas_validation_message, "width", "500");
				set_custom_element_data(eas_validation_message, "class", "svelte-139h56j");
			},
			m(target, anchor) {
				insert(target, eas_validation_message, anchor);

				if (!mounted) {
					dispose = listen(eas_validation_message, "errorclose", /*errorclose_handler*/ ctx[15]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*errorMessage*/ 8) {
					set_custom_element_data(eas_validation_message, "message", /*errorMessage*/ ctx[3]);
				}

				if (dirty & /*showError*/ 4) {
					set_custom_element_data(eas_validation_message, "showError", /*showError*/ ctx[2]);
				}
			},
			d(detaching) {
				if (detaching) {
					detach(eas_validation_message);
				}

				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment(ctx) {
		let link;
		let t0;
		let div7;
		let div2;
		let div0;
		let t2;
		let div1;
		let t3;
		let h5;
		let t4;
		let t5;
		let div3;
		let t6;
		let div6;
		let div5;
		let div4;
		let eas_table_control;
		let div7_class_value;
		let mounted;
		let dispose;
		let if_block = /*showError*/ ctx[2] && create_if_block(ctx);

		return {
			c() {
				link = element("link");
				t0 = space();
				div7 = element("div");
				div2 = element("div");
				div0 = element("div");
				div0.innerHTML = `<h4 class="font-20 svelte-139h56j">Status History</h4>`;
				t2 = space();
				div1 = element("div");
				div1.innerHTML = `<a class="font-20 font-black svelte-139h56j"><i class="fa-sharp fa-solid fa-xmark svelte-139h56j"></i></a>`;
				t3 = space();
				h5 = element("h5");
				t4 = text(/*workflowTypeDescript*/ ctx[4]);
				t5 = space();
				div3 = element("div");
				if (if_block) if_block.c();
				t6 = space();
				div6 = element("div");
				div5 = element("div");
				div4 = element("div");
				eas_table_control = element("eas-table-control");
				attr(link, "href", "https://ka-p.fontawesome.com/releases/v6.1.1/css/pro.min.css?token=a5cccf28a6");
				attr(link, "rel", "stylesheet");
				attr(link, "class", "svelte-139h56j");
				attr(div0, "class", "svelte-139h56j");
				attr(div1, "class", "svelte-139h56j");
				attr(div2, "class", "header svelte-139h56j");
				attr(h5, "class", "font-15 gray-600-font svelte-139h56j");
				attr(div3, "class", "svelte-139h56j");
				set_custom_element_data(eas_table_control, "displayHeader", displayHeader);
				set_custom_element_data(eas_table_control, "displayFooter", displayFooter);
				set_custom_element_data(eas_table_control, "data", /*data*/ ctx[0]);
				set_custom_element_data(eas_table_control, "class", "svelte-139h56j");
				attr(div4, "class", "table-ode utility_table_min_width svelte-139h56j");
				attr(div5, "class", "card fluid svelte-139h56j");
				attr(div6, "class", "flex-row mt-10 svelte-139h56j");
				attr(div7, "class", div7_class_value = "utility_panel_container " + (/*display*/ ctx[1] ? 'should-display' : 'should-hide') + " svelte-139h56j");
			},
			m(target, anchor) {
				insert(target, link, anchor);
				insert(target, t0, anchor);
				insert(target, div7, anchor);
				append(div7, div2);
				append(div2, div0);
				append(div2, t2);
				append(div2, div1);
				append(div7, t3);
				append(div7, h5);
				append(h5, t4);
				append(div7, t5);
				append(div7, div3);
				if (if_block) if_block.m(div3, null);
				append(div7, t6);
				append(div7, div6);
				append(div6, div5);
				append(div5, div4);
				append(div4, eas_table_control);

				if (!mounted) {
					dispose = [
						listen(div1, "key", key_handler),
						listen(div1, "click", /*click_handler*/ ctx[14])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*workflowTypeDescript*/ 16) set_data(t4, /*workflowTypeDescript*/ ctx[4]);

				if (/*showError*/ ctx[2]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block(ctx);
						if_block.c();
						if_block.m(div3, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}

				if (dirty & /*data*/ 1) {
					set_custom_element_data(eas_table_control, "data", /*data*/ ctx[0]);
				}

				if (dirty & /*display*/ 2 && div7_class_value !== (div7_class_value = "utility_panel_container " + (/*display*/ ctx[1] ? 'should-display' : 'should-hide') + " svelte-139h56j")) {
					attr(div7, "class", div7_class_value);
				}
			},
			i: noop,
			o: noop,
			d(detaching) {
				if (detaching) {
					detach(link);
					detach(t0);
					detach(div7);
				}

				if (if_block) if_block.d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	let displayHeader = true;
	let displayFooter = true;

	function checkWorkflowComment(workflowComment) {
		if (typeof workflowComment != 'undefined' && workflowComment) {
			return {
				value: {
					href: 'javascript:void(0)',
					target: '',
					click: {},
					iconClass: 'fas fa-comment',
					linkStyle: 'color: #000;padding-left: 17px',
					showComment: true
				},
				type: 'linkicon',
				displayValue: workflowComment
			};
		}

		return {
			value: {
				href: 'javascript:void(0)',
				target: '',
				click: {},
				iconClass: '',
				linkStyle: '',
				showComment: false
			},
			type: 'linkicon',
			displayValue: ''
		};
	}

	const key_handler = e => {
		
	};

	function instance($$self, $$props, $$invalidate) {
		const svelteDispatcher = createEventDispatcher();
		let { applicationKey } = $$props;
		let { moduleKey } = $$props;
		let { workflowTypeKey } = $$props;
		let { workflowCompositeOwnerSourceKey } = $$props;
		let { display = false } = $$props;
		let { workflowOwnerTypeKey } = $$props;
		let { workflowCompositeOwnerTypeKey } = $$props;
		let { workflowOwnerSourceKey } = $$props;
		let showError = false;
		let errorMessage = "";
		let workFlowService = new WorkflowService();
		let workflowTypeDescript = "";

		let { data = {
			id: "",
			header: [
				{
					name: "State",
					filterable: false,
					sortable: false,
					sortDirection: "asc",
					index: 0
				},
				{
					name: "Person",
					filterable: false,
					sortable: false,
					sortDirection: "asc",
					index: 1
				},
				{
					name: "Comment",
					filterable: false,
					sortable: false,
					sortDirection: "asc",
					index: 2
				}
			],
			rows: []
		} } = $$props;

		function getWorkflowTransitionHistory() {
			if (workflowCompositeOwnerSourceKey) {
				let requestModel = {
					moduleKey,
					workflowOwnerSourceKey,
					workflowOwnerTypeKey,
					workflowTypeKey,
					workflowCompositeOwnerSourceKey,
					workflowCompositeOwnerTypeKey,
					applicationKey
				};

				workFlowService.getWorkflowTransitionHistory(requestModel).then(result => {
					if (result.length > 0) {
						$$invalidate(4, workflowTypeDescript = result[0].workflowTypeDescript);
						result = result.reverse();

						$$invalidate(
							0,
							data.rows = result.map(x => {
								return {
									columns: [
										{
											value: x.toWorkflowStateName + "       " + new Date(x.updateTs).toLocaleString(),
											type: 'text'
										},
										{
											value: x.updatePersonFirstName + " " + x.updatePersonLastName,
											type: 'text'
										},
										checkWorkflowComment(x.workflowComment)
									]
								};
							}),
							data
						);

						$$invalidate(0, data = { ...data });
						$$invalidate(2, showError = false);
						$$invalidate(3, errorMessage = "");
					} else {
						$$invalidate(2, showError = true);
						$$invalidate(3, errorMessage = "Workflow history returned zero results");
					}
				}).catch(error => {
					$$invalidate(2, showError = true);
					$$invalidate(3, errorMessage = "Workflow history search could not be completed");
				});
			}
		}

		onMount(() => {
			getWorkflowTransitionHistory();
		});

		function closeHistoryTab(e) {
			svelteDispatcher("closeClick");
		}

		function onErrorClose(e) {
			$$invalidate(2, showError = false);
		}

		const click_handler = e => closeHistoryTab();
		const errorclose_handler = e => onErrorClose();

		$$self.$$set = $$props => {
			if ('applicationKey' in $$props) $$invalidate(7, applicationKey = $$props.applicationKey);
			if ('moduleKey' in $$props) $$invalidate(8, moduleKey = $$props.moduleKey);
			if ('workflowTypeKey' in $$props) $$invalidate(9, workflowTypeKey = $$props.workflowTypeKey);
			if ('workflowCompositeOwnerSourceKey' in $$props) $$invalidate(10, workflowCompositeOwnerSourceKey = $$props.workflowCompositeOwnerSourceKey);
			if ('display' in $$props) $$invalidate(1, display = $$props.display);
			if ('workflowOwnerTypeKey' in $$props) $$invalidate(11, workflowOwnerTypeKey = $$props.workflowOwnerTypeKey);
			if ('workflowCompositeOwnerTypeKey' in $$props) $$invalidate(12, workflowCompositeOwnerTypeKey = $$props.workflowCompositeOwnerTypeKey);
			if ('workflowOwnerSourceKey' in $$props) $$invalidate(13, workflowOwnerSourceKey = $$props.workflowOwnerSourceKey);
			if ('data' in $$props) $$invalidate(0, data = $$props.data);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*applicationKey*/ 128) {
				console.log('applicationKey=', applicationKey);
			}

			if ($$self.$$.dirty & /*moduleKey*/ 256) {
				console.log('moduleKey=', moduleKey);
			}

			if ($$self.$$.dirty & /*workflowTypeKey*/ 512) {
				console.log('workflowTypeKey=', workflowTypeKey);
			}

			if ($$self.$$.dirty & /*workflowCompositeOwnerSourceKey*/ 1024) {
				console.log('workflowCompositeOwnerSourceKey=', workflowCompositeOwnerSourceKey);
			}

			if ($$self.$$.dirty & /*workflowOwnerTypeKey*/ 2048) {
				console.log('workflowOwnerTypeKey=', workflowOwnerTypeKey);
			}

			if ($$self.$$.dirty & /*display*/ 2) {
				console.log('display=', display);
			}

			if ($$self.$$.dirty & /*workflowCompositeOwnerTypeKey*/ 4096) {
				console.log('workflowCompositeOwnerTypeKey=', workflowCompositeOwnerTypeKey);
			}

			if ($$self.$$.dirty & /*workflowOwnerSourceKey*/ 8192) {
				console.log('workflowOwnerSourceKey=', workflowOwnerSourceKey);
			}

			if ($$self.$$.dirty & /*workflowCompositeOwnerSourceKey, workflowOwnerSourceKey, workflowOwnerTypeKey, workflowCompositeOwnerTypeKey, workflowTypeKey, moduleKey, applicationKey*/ 16256) {
				(getWorkflowTransitionHistory());
			}
		};

		console.log('----------EAS Svelte Workflow History Component---------');

		return [
			data,
			display,
			showError,
			errorMessage,
			workflowTypeDescript,
			closeHistoryTab,
			onErrorClose,
			applicationKey,
			moduleKey,
			workflowTypeKey,
			workflowCompositeOwnerSourceKey,
			workflowOwnerTypeKey,
			workflowCompositeOwnerTypeKey,
			workflowOwnerSourceKey,
			click_handler,
			errorclose_handler
		];
	}

	class Eas_workflow_history extends SvelteComponent {
		constructor(options) {
			super();

			init(
				this,
				options,
				instance,
				create_fragment,
				safe_not_equal,
				{
					applicationKey: 7,
					moduleKey: 8,
					workflowTypeKey: 9,
					workflowCompositeOwnerSourceKey: 10,
					display: 1,
					workflowOwnerTypeKey: 11,
					workflowCompositeOwnerTypeKey: 12,
					workflowOwnerSourceKey: 13,
					data: 0
				},
				add_css
			);
		}

		get applicationKey() {
			return this.$$.ctx[7];
		}

		set applicationKey(applicationKey) {
			this.$$set({ applicationKey });
			flush();
		}

		get moduleKey() {
			return this.$$.ctx[8];
		}

		set moduleKey(moduleKey) {
			this.$$set({ moduleKey });
			flush();
		}

		get workflowTypeKey() {
			return this.$$.ctx[9];
		}

		set workflowTypeKey(workflowTypeKey) {
			this.$$set({ workflowTypeKey });
			flush();
		}

		get workflowCompositeOwnerSourceKey() {
			return this.$$.ctx[10];
		}

		set workflowCompositeOwnerSourceKey(workflowCompositeOwnerSourceKey) {
			this.$$set({ workflowCompositeOwnerSourceKey });
			flush();
		}

		get display() {
			return this.$$.ctx[1];
		}

		set display(display) {
			this.$$set({ display });
			flush();
		}

		get workflowOwnerTypeKey() {
			return this.$$.ctx[11];
		}

		set workflowOwnerTypeKey(workflowOwnerTypeKey) {
			this.$$set({ workflowOwnerTypeKey });
			flush();
		}

		get workflowCompositeOwnerTypeKey() {
			return this.$$.ctx[12];
		}

		set workflowCompositeOwnerTypeKey(workflowCompositeOwnerTypeKey) {
			this.$$set({ workflowCompositeOwnerTypeKey });
			flush();
		}

		get workflowOwnerSourceKey() {
			return this.$$.ctx[13];
		}

		set workflowOwnerSourceKey(workflowOwnerSourceKey) {
			this.$$set({ workflowOwnerSourceKey });
			flush();
		}

		get data() {
			return this.$$.ctx[0];
		}

		set data(data) {
			this.$$set({ data });
			flush();
		}
	}

	customElements.define("eas-workflow-history-swc", create_custom_element(Eas_workflow_history, {"applicationKey":{},"moduleKey":{},"workflowTypeKey":{},"workflowCompositeOwnerSourceKey":{},"display":{"type":"Boolean"},"workflowOwnerTypeKey":{},"workflowCompositeOwnerTypeKey":{},"workflowOwnerSourceKey":{},"data":{}}, [], [], true));

})();

var EasDesktopMenu = (function () {
    'use strict';

    function noop() { }
    function run(fn) {
        return fn();
    }
    function blank_object() {
        return Object.create(null);
    }
    function run_all(fns) {
        fns.forEach(run);
    }
    function is_function(thing) {
        return typeof thing === 'function';
    }
    function safe_not_equal(a, b) {
        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
    }
    function is_empty(obj) {
        return Object.keys(obj).length === 0;
    }
    function append(target, node) {
        target.appendChild(node);
    }
    function insert(target, node, anchor) {
        target.insertBefore(node, anchor || null);
    }
    function detach(node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }
    function destroy_each(iterations, detaching) {
        for (let i = 0; i < iterations.length; i += 1) {
            if (iterations[i])
                iterations[i].d(detaching);
        }
    }
    function element(name) {
        return document.createElement(name);
    }
    function text(data) {
        return document.createTextNode(data);
    }
    function space() {
        return text(' ');
    }
    function listen(node, event, handler, options) {
        node.addEventListener(event, handler, options);
        return () => node.removeEventListener(event, handler, options);
    }
    function attr(node, attribute, value) {
        if (value == null)
            node.removeAttribute(attribute);
        else if (node.getAttribute(attribute) !== value)
            node.setAttribute(attribute, value);
    }
    function children(element) {
        return Array.from(element.childNodes);
    }
    function set_data(text, data) {
        data = '' + data;
        if (text.data === data)
            return;
        text.data = data;
    }
    function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
        const e = document.createEvent('CustomEvent');
        e.initCustomEvent(type, bubbles, cancelable, detail);
        return e;
    }
    function attribute_to_object(attributes) {
        const result = {};
        for (const attribute of attributes) {
            result[attribute.name] = attribute.value;
        }
        return result;
    }

    let current_component;
    function set_current_component(component) {
        current_component = component;
    }
    function get_current_component() {
        if (!current_component)
            throw new Error('Function called outside component initialization');
        return current_component;
    }
    /**
     * Schedules a callback to run immediately before the component is updated after any state change.
     *
     * The first time the callback runs will be before the initial `onMount`
     *
     * https://svelte.dev/docs#run-time-svelte-beforeupdate
     */
    function beforeUpdate(fn) {
        get_current_component().$$.before_update.push(fn);
    }
    /**
     * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
     * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
     * it can be called from an external module).
     *
     * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
     *
     * https://svelte.dev/docs#run-time-svelte-onmount
     */
    function onMount(fn) {
        get_current_component().$$.on_mount.push(fn);
    }
    /**
     * Creates an event dispatcher that can be used to dispatch [component events](/docs#template-syntax-component-directives-on-eventname).
     * Event dispatchers are functions that can take two arguments: `name` and `detail`.
     *
     * Component events created with `createEventDispatcher` create a
     * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
     * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
     * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
     * property and can contain any type of data.
     *
     * https://svelte.dev/docs#run-time-svelte-createeventdispatcher
     */
    function createEventDispatcher() {
        const component = get_current_component();
        return (type, detail, { cancelable = false } = {}) => {
            const callbacks = component.$$.callbacks[type];
            if (callbacks) {
                // TODO are there situations where events could be dispatched
                // in a server (non-DOM) environment?
                const event = custom_event(type, detail, { cancelable });
                callbacks.slice().forEach(fn => {
                    fn.call(component, event);
                });
                return !event.defaultPrevented;
            }
            return true;
        };
    }

    const dirty_components = [];
    const binding_callbacks = [];
    let render_callbacks = [];
    const flush_callbacks = [];
    const resolved_promise = /* @__PURE__ */ Promise.resolve();
    let update_scheduled = false;
    function schedule_update() {
        if (!update_scheduled) {
            update_scheduled = true;
            resolved_promise.then(flush);
        }
    }
    function add_render_callback(fn) {
        render_callbacks.push(fn);
    }
    // flush() calls callbacks in this order:
    // 1. All beforeUpdate callbacks, in order: parents before children
    // 2. All bind:this callbacks, in reverse order: children before parents.
    // 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
    //    for afterUpdates called during the initial onMount, which are called in
    //    reverse order: children before parents.
    // Since callbacks might update component values, which could trigger another
    // call to flush(), the following steps guard against this:
    // 1. During beforeUpdate, any updated components will be added to the
    //    dirty_components array and will cause a reentrant call to flush(). Because
    //    the flush index is kept outside the function, the reentrant call will pick
    //    up where the earlier call left off and go through all dirty components. The
    //    current_component value is saved and restored so that the reentrant call will
    //    not interfere with the "parent" flush() call.
    // 2. bind:this callbacks cannot trigger new flush() calls.
    // 3. During afterUpdate, any updated components will NOT have their afterUpdate
    //    callback called a second time; the seen_callbacks set, outside the flush()
    //    function, guarantees this behavior.
    const seen_callbacks = new Set();
    let flushidx = 0; // Do *not* move this inside the flush() function
    function flush() {
        // Do not reenter flush while dirty components are updated, as this can
        // result in an infinite loop. Instead, let the inner flush handle it.
        // Reentrancy is ok afterwards for bindings etc.
        if (flushidx !== 0) {
            return;
        }
        const saved_component = current_component;
        do {
            // first, call beforeUpdate functions
            // and update components
            try {
                while (flushidx < dirty_components.length) {
                    const component = dirty_components[flushidx];
                    flushidx++;
                    set_current_component(component);
                    update(component.$$);
                }
            }
            catch (e) {
                // reset dirty state to not end up in a deadlocked state and then rethrow
                dirty_components.length = 0;
                flushidx = 0;
                throw e;
            }
            set_current_component(null);
            dirty_components.length = 0;
            flushidx = 0;
            while (binding_callbacks.length)
                binding_callbacks.pop()();
            // then, once components are updated, call
            // afterUpdate functions. This may cause
            // subsequent updates...
            for (let i = 0; i < render_callbacks.length; i += 1) {
                const callback = render_callbacks[i];
                if (!seen_callbacks.has(callback)) {
                    // ...so guard against infinite loops
                    seen_callbacks.add(callback);
                    callback();
                }
            }
            render_callbacks.length = 0;
        } while (dirty_components.length);
        while (flush_callbacks.length) {
            flush_callbacks.pop()();
        }
        update_scheduled = false;
        seen_callbacks.clear();
        set_current_component(saved_component);
    }
    function update($$) {
        if ($$.fragment !== null) {
            $$.update();
            run_all($$.before_update);
            const dirty = $$.dirty;
            $$.dirty = [-1];
            $$.fragment && $$.fragment.p($$.ctx, dirty);
            $$.after_update.forEach(add_render_callback);
        }
    }
    /**
     * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
     */
    function flush_render_callbacks(fns) {
        const filtered = [];
        const targets = [];
        render_callbacks.forEach((c) => fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
        targets.forEach((c) => c());
        render_callbacks = filtered;
    }
    const outroing = new Set();
    function transition_in(block, local) {
        if (block && block.i) {
            outroing.delete(block);
            block.i(local);
        }
    }
    function mount_component(component, target, anchor, customElement) {
        const { fragment, after_update } = component.$$;
        fragment && fragment.m(target, anchor);
        if (!customElement) {
            // onMount happens before the initial afterUpdate
            add_render_callback(() => {
                const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
                // if the component was destroyed immediately
                // it will update the `$$.on_destroy` reference to `null`.
                // the destructured on_destroy may still reference to the old array
                if (component.$$.on_destroy) {
                    component.$$.on_destroy.push(...new_on_destroy);
                }
                else {
                    // Edge case - component was destroyed immediately,
                    // most likely as a result of a binding initialising
                    run_all(new_on_destroy);
                }
                component.$$.on_mount = [];
            });
        }
        after_update.forEach(add_render_callback);
    }
    function destroy_component(component, detaching) {
        const $$ = component.$$;
        if ($$.fragment !== null) {
            flush_render_callbacks($$.after_update);
            run_all($$.on_destroy);
            $$.fragment && $$.fragment.d(detaching);
            // TODO null out other refs, including component.$$ (but need to
            // preserve final state?)
            $$.on_destroy = $$.fragment = null;
            $$.ctx = [];
        }
    }
    function make_dirty(component, i) {
        if (component.$$.dirty[0] === -1) {
            dirty_components.push(component);
            schedule_update();
            component.$$.dirty.fill(0);
        }
        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
    }
    function init(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [-1]) {
        const parent_component = current_component;
        set_current_component(component);
        const $$ = component.$$ = {
            fragment: null,
            ctx: [],
            // state
            props,
            update: noop,
            not_equal,
            bound: blank_object(),
            // lifecycle
            on_mount: [],
            on_destroy: [],
            on_disconnect: [],
            before_update: [],
            after_update: [],
            context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
            // everything else
            callbacks: blank_object(),
            dirty,
            skip_bound: false,
            root: options.target || parent_component.$$.root
        };
        append_styles && append_styles($$.root);
        let ready = false;
        $$.ctx = instance
            ? instance(component, options.props || {}, (i, ret, ...rest) => {
                const value = rest.length ? rest[0] : ret;
                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                    if (!$$.skip_bound && $$.bound[i])
                        $$.bound[i](value);
                    if (ready)
                        make_dirty(component, i);
                }
                return ret;
            })
            : [];
        $$.update();
        ready = true;
        run_all($$.before_update);
        // `false` as a special case of no DOM component
        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
        if (options.target) {
            if (options.hydrate) {
                const nodes = children(options.target);
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.l(nodes);
                nodes.forEach(detach);
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.c();
            }
            if (options.intro)
                transition_in(component.$$.fragment);
            mount_component(component, options.target, options.anchor, options.customElement);
            flush();
        }
        set_current_component(parent_component);
    }
    let SvelteElement;
    if (typeof HTMLElement === 'function') {
        SvelteElement = class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({ mode: 'open' });
            }
            connectedCallback() {
                const { on_mount } = this.$$;
                this.$$.on_disconnect = on_mount.map(run).filter(is_function);
                // @ts-ignore todo: improve typings
                for (const key in this.$$.slotted) {
                    // @ts-ignore todo: improve typings
                    this.appendChild(this.$$.slotted[key]);
                }
            }
            attributeChangedCallback(attr, _oldValue, newValue) {
                this[attr] = newValue;
            }
            disconnectedCallback() {
                run_all(this.$$.on_disconnect);
            }
            $destroy() {
                destroy_component(this, 1);
                this.$destroy = noop;
            }
            $on(type, callback) {
                // TODO should this delegate to addEventListener?
                if (!is_function(callback)) {
                    return noop;
                }
                const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
                callbacks.push(callback);
                return () => {
                    const index = callbacks.indexOf(callback);
                    if (index !== -1)
                        callbacks.splice(index, 1);
                };
            }
            $set($$props) {
                if (this.$$set && !is_empty($$props)) {
                    this.$$.skip_bound = true;
                    this.$$set($$props);
                    this.$$.skip_bound = false;
                }
            }
        };
    }

    /* src\menu\eas-desktop-menu.component.svelte generated by Svelte v3.59.2 */

    function get_each_context(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[11] = list[i];
    	child_ctx[13] = i;
    	return child_ctx;
    }

    // (51:8) {#each menu.items as item, index}
    function create_each_block(ctx) {
    	let li;
    	let a;
    	let t0_value = /*item*/ ctx[11]?.label + "";
    	let t0;
    	let t1;
    	let li_class_value;
    	let mounted;
    	let dispose;

    	function click_handler(...args) {
    		return /*click_handler*/ ctx[5](/*item*/ ctx[11], ...args);
    	}

    	function keydown_handler(...args) {
    		return /*keydown_handler*/ ctx[6](/*item*/ ctx[11], ...args);
    	}

    	return {
    		c() {
    			li = element("li");
    			a = element("a");
    			t0 = text(t0_value);
    			t1 = space();
    			attr(a, "class", "top-nav--li--a");
    			attr(a, "href", "javascript:void(0)");

    			attr(li, "class", li_class_value = /*itemActive*/ ctx[0] === /*item*/ ctx[11]?.label
    			? "active top-nav--li"
    			: "top-nav--li");

    			attr(li, "tabindex", /*index*/ ctx[13] + 1);
    		},
    		m(target, anchor) {
    			insert(target, li, anchor);
    			append(li, a);
    			append(a, t0);
    			append(li, t1);

    			if (!mounted) {
    				dispose = [
    					listen(li, "click", click_handler),
    					listen(li, "keydown", keydown_handler)
    				];

    				mounted = true;
    			}
    		},
    		p(new_ctx, dirty) {
    			ctx = new_ctx;
    			if (dirty & /*menu*/ 2 && t0_value !== (t0_value = /*item*/ ctx[11]?.label + "")) set_data(t0, t0_value);

    			if (dirty & /*itemActive, menu*/ 3 && li_class_value !== (li_class_value = /*itemActive*/ ctx[0] === /*item*/ ctx[11]?.label
    			? "active top-nav--li"
    			: "top-nav--li")) {
    				attr(li, "class", li_class_value);
    			}
    		},
    		d(detaching) {
    			if (detaching) detach(li);
    			mounted = false;
    			run_all(dispose);
    		}
    	};
    }

    function create_fragment(ctx) {
    	let div;
    	let ul;
    	let each_value = /*menu*/ ctx[1].items;
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
    	}

    	return {
    		c() {
    			div = element("div");
    			ul = element("ul");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			this.c = noop;
    			attr(ul, "class", "top-nav");
    			attr(div, "class", "container-menu");
    		},
    		m(target, anchor) {
    			insert(target, div, anchor);
    			append(div, ul);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				if (each_blocks[i]) {
    					each_blocks[i].m(ul, null);
    				}
    			}
    		},
    		p(ctx, [dirty]) {
    			if (dirty & /*itemActive, menu, onClick, onKeyDown*/ 15) {
    				each_value = /*menu*/ ctx[1].items;
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(ul, null);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value.length;
    			}
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(div);
    			destroy_each(each_blocks, detaching);
    		}
    	};
    }

    function instance($$self, $$props, $$invalidate) {
    	let { itemActive = '' } = $$props;
    	const svelteDispatch = createEventDispatcher();
    	const component = get_current_component();

    	const dispatch = (name, data, event) => {
    		svelteDispatch(name, data);
    		component.dispatchEvent && component.dispatchEvent(event);
    	};

    	let { selectedmenuitem = "" } = $$props;
    	let { menu = { items: [] } } = $$props;

    	beforeUpdate(() => {
    		if (typeof menu === "string") {
    			$$invalidate(1, menu = JSON.parse(menu));
    		}
    	});

    	onMount(() => {
    		if (typeof menu === "string") {
    			$$invalidate(1, menu = JSON.parse(menu));
    		}
    	});

    	function onClick(item, e) {
    		$$invalidate(0, itemActive = item === null || item === void 0 ? void 0 : item.label);
    		let eventData = Object.assign(Object.assign({}, e), { detail: item });
    		e.stopPropagation();
    		setActive(item);
    		dispatch("click", item, new CustomEvent("click", eventData));
    	}

    	function onKeyDown(event, item) {
    		if (event.key === "Enter") {
    			setActive(item);
    		}
    	}

    	function setActive(item) {
    		let selectedItem = menu.items.find(i => i === item);
    		menu.items.forEach(i => i.selected = false);
    		selectedItem.selected = true;
    	}

    	const click_handler = (item, e) => onClick(item, e);

    	const keydown_handler = (item, e) => {
    		onKeyDown(e, item);
    	};

    	$$self.$$set = $$props => {
    		if ('itemActive' in $$props) $$invalidate(0, itemActive = $$props.itemActive);
    		if ('selectedmenuitem' in $$props) $$invalidate(4, selectedmenuitem = $$props.selectedmenuitem);
    		if ('menu' in $$props) $$invalidate(1, menu = $$props.menu);
    	};

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty & /*selectedmenuitem*/ 16) {
    			console.log('selectedmenuitem ', selectedmenuitem);
    		}

    		if ($$self.$$.dirty & /*menu*/ 2) {
    			console.log('menu ', menu);
    		}

    		if ($$self.$$.dirty & /*itemActive*/ 1) {
    			console.log('itemActive ', itemActive);
    		}
    	};

    	console.log('----------EAS Svelte Descktop Menu Cmmponent---------');

    	return [
    		itemActive,
    		menu,
    		onClick,
    		onKeyDown,
    		selectedmenuitem,
    		click_handler,
    		keydown_handler
    	];
    }

    class Eas_desktop_menu_component extends SvelteElement {
    	constructor(options) {
    		super();
    		const style = document.createElement('style');
    		style.textContent = `.container-menu{font-family:"Source Sans Pro", Tahoma, Verdana, Segoe, sans-serif;font-size:18px}.top-nav{display:flex;list-style:none}.top-nav--li{margin-right:20px}.top-nav--li--a{color:#4a4a4a;display:block;transition:all 0.5s ease;text-decoration:none;border-bottom:7px solid transparent;padding:5px 15px;padding-bottom:17px}.top-nav--li--a:hover{border-bottom:7px solid #65101c;text-decoration:none;color:#65101c}.active.top-nav--li .top-nav--li--a{color:#65101c;border-bottom:7px solid #65101c;text-decoration:none;transition:all 0.5s ease}@media(max-width: 1024px){.top-nav--li{margin-right:5px;font-size:16px}.top-nav--li--a{padding-bottom:19px}}@media(max-width: 768px){.top-nav--li{margin-right:5px;font-size:14px}.top-nav{padding-left:0}.top-nav--li .top-nav--li--a,.active.top-nav--li .top-nav--li--a{padding-left:5px;padding-right:5px;padding-bottom:21px}.top-nav--li--a{padding-bottom:19px}}@media(max-width: 425px){.top-nav{display:block;padding-left:15px;padding-right:15px;margin-top:5px}.top-nav--li{width:100%;border-bottom:1px solid #a1a1a1}.top-nav--li--a{padding:15px 15px;border-bottom:1px solid transparent}.top-nav--li--a:hover{border-bottom:1px solid #65101c}.active.top-nav--li .top-nav--li--a{border-bottom:1px solid #65101c}}`;
    		this.shadowRoot.appendChild(style);

    		init(
    			this,
    			{
    				target: this.shadowRoot,
    				props: attribute_to_object(this.attributes),
    				customElement: true
    			},
    			instance,
    			create_fragment,
    			safe_not_equal,
    			{
    				itemActive: 0,
    				selectedmenuitem: 4,
    				menu: 1
    			},
    			null
    		);

    		if (options) {
    			if (options.target) {
    				insert(options.target, this, options.anchor);
    			}

    			if (options.props) {
    				this.$set(options.props);
    				flush();
    			}
    		}
    	}

    	static get observedAttributes() {
    		return ["itemActive", "selectedmenuitem", "menu"];
    	}

    	get itemActive() {
    		return this.$$.ctx[0];
    	}

    	set itemActive(itemActive) {
    		this.$$set({ itemActive });
    		flush();
    	}

    	get selectedmenuitem() {
    		return this.$$.ctx[4];
    	}

    	set selectedmenuitem(selectedmenuitem) {
    		this.$$set({ selectedmenuitem });
    		flush();
    	}

    	get menu() {
    		return this.$$.ctx[1];
    	}

    	set menu(menu) {
    		this.$$set({ menu });
    		flush();
    	}
    }

    customElements.define("eas-desktop-menu", Eas_desktop_menu_component);

    return Eas_desktop_menu_component;

})();
//# sourceMappingURL=eas-desktop-menu.js.map

var EasSideMenu=function(){"use strict";function e(){}function t(e){return e()}function n(){return Object.create(null)}function o(e){e.forEach(t)}function u(e){return"function"==typeof e}function s(e,t){return e!=e?t==t:e!==t||e&&"object"==typeof e||"function"==typeof e}function l(e,t){e.appendChild(t)}function r(e,t,n){e.insertBefore(t,n||null)}function i(e){e.parentNode.removeChild(e)}function a(e){return document.createElement(e)}function c(e){return document.createElementNS("http://www.w3.org/2000/svg",e)}function d(e){return document.createTextNode(e)}function m(){return d(" ")}function p(e,t,n){null==n?e.removeAttribute(t):e.getAttribute(t)!==n&&e.setAttribute(t,n)}function f(e,t,n){e.classList[n?"add":"remove"](t)}function g(e){const t={};for(const n of e)t[n.name]=n.value;return t}let h;function b(e){h=e}function $(){if(!h)throw new Error("Function called outside component initialization");return h}function x(){const e=$();return(t,n)=>{const o=e.$$.callbacks[t];if(o){const u=function(e,t,n=!1){const o=document.createEvent("CustomEvent");return o.initCustomEvent(e,n,!1,t),o}(t,n);o.slice().forEach((t=>{t.call(e,u)}))}}}const v=[],w=[],y=[],E=[],k=Promise.resolve();let C=!1;function _(e){y.push(e)}const N=new Set;let L=0;function j(){const e=h;do{for(;L<v.length;){const e=v[L];L++,b(e),A(e.$$)}for(b(null),v.length=0,L=0;w.length;)w.pop()();for(let e=0;e<y.length;e+=1){const t=y[e];N.has(t)||(N.add(t),t())}y.length=0}while(v.length);for(;E.length;)E.pop()();C=!1,N.clear(),b(e)}function A(e){if(null!==e.fragment){e.update(),o(e.before_update);const t=e.dirty;e.dirty=[-1],e.fragment&&e.fragment.p(e.ctx,t),e.after_update.forEach(_)}}const z=new Set;let M,K;function O(){M={r:0,c:[],p:M}}function F(){M.r||o(M.c),M=M.p}function S(e,t){e&&e.i&&(z.delete(e),e.i(t))}function T(e,t,n,o){if(e&&e.o){if(z.has(e))return;z.add(e),M.c.push((()=>{z.delete(e),o&&(n&&e.d(1),o())})),e.o(t)}}function B(e,n,s,l){const{fragment:r,on_mount:i,on_destroy:a,after_update:c}=e.$$;r&&r.m(n,s),l||_((()=>{const n=i.map(t).filter(u);a?a.push(...n):o(n),e.$$.on_mount=[]})),c.forEach(_)}function D(e,t){const n=e.$$;null!==n.fragment&&(o(n.on_destroy),n.fragment&&n.fragment.d(t),n.on_destroy=n.fragment=null,n.ctx=[])}function H(e,t){-1===e.$$.dirty[0]&&(v.push(e),C||(C=!0,k.then(j)),e.$$.dirty.fill(0)),e.$$.dirty[t/31|0]|=1<<t%31}function P(t,u,s,l,r,a,c,d=[-1]){const m=h;b(t);const p=t.$$={fragment:null,ctx:null,props:a,update:e,not_equal:r,bound:n(),on_mount:[],on_destroy:[],on_disconnect:[],before_update:[],after_update:[],context:new Map(u.context||(m?m.$$.context:[])),callbacks:n(),dirty:d,skip_bound:!1,root:u.target||m.$$.root};c&&c(p.root);let f=!1;if(p.ctx=s?s(t,u.props||{},((e,n,...o)=>{const u=o.length?o[0]:n;return p.ctx&&r(p.ctx[e],p.ctx[e]=u)&&(!p.skip_bound&&p.bound[e]&&p.bound[e](u),f&&H(t,e)),n})):[],p.update(),f=!0,o(p.before_update),p.fragment=!!l&&l(p.ctx),u.target){if(u.hydrate){const e=function(e){return Array.from(e.childNodes)}(u.target);p.fragment&&p.fragment.l(e),e.forEach(i)}else p.fragment&&p.fragment.c();u.intro&&S(t.$$.fragment),B(t,u.target,u.anchor,u.customElement),j()}b(m)}function R(e,t,n){const o=e.slice();return o[10]=t[n],o[12]=n,o}function q(e){let t,n,o,u,s,c,f,g,h,b,$,x=e[0].label+"",v=e[0].submenu&&e[0].submenu.length>0&&(e[0].expanded||e[0]&&e[2]&&e[2]===e[0].menuKey)&&G(e),w=e[0].submenu&&e[0].submenu.length>0&&!e[0].expanded&&I(e),y=e[0].submenu&&e[0].submenu.length>0&&e[0].selected&&e[0].expanded&&J(e);return{c(){t=a("ul"),n=a("li"),o=a("a"),u=d(x),s=m(),v&&v.c(),c=m(),w&&w.c(),f=m(),y&&y.c(),p(o,"href","javascript:void(0)"),p(o,"class","nav--a"),p(n,"class",g="nav--menu--li round-8 "+(e[0].selected&&e[0].expanded||e[0]&&e[2]&&e[2]===e[0].menuKey?"active-open":e[0].selected&&!e[0].expanded?"active":"")),p(t,"class","nav--menu-ul")},m(i,a){var d,m,p,g;r(i,t,a),l(t,n),l(n,o),l(o,u),l(o,s),v&&v.m(o,null),l(o,c),w&&w.m(o,null),l(n,f),y&&y.m(n,null),h=!0,b||(d=o,m="click",p=e[4],d.addEventListener(m,p,g),$=()=>d.removeEventListener(m,p,g),b=!0)},p(e,t){(!h||1&t)&&x!==(x=e[0].label+"")&&function(e,t){t=""+t,e.wholeText!==t&&(e.data=t)}(u,x),e[0].submenu&&e[0].submenu.length>0&&(e[0].expanded||e[0]&&e[2]&&e[2]===e[0].menuKey)?v?v.p(e,t):(v=G(e),v.c(),v.m(o,c)):v&&(v.d(1),v=null),e[0].submenu&&e[0].submenu.length>0&&!e[0].expanded?w?w.p(e,t):(w=I(e),w.c(),w.m(o,null)):w&&(w.d(1),w=null),e[0].submenu&&e[0].submenu.length>0&&e[0].selected&&e[0].expanded?y?(y.p(e,t),1&t&&S(y,1)):(y=J(e),y.c(),S(y,1),y.m(n,null)):y&&(O(),T(y,1,1,(()=>{y=null})),F()),(!h||5&t&&g!==(g="nav--menu--li round-8 "+(e[0].selected&&e[0].expanded||e[0]&&e[2]&&e[2]===e[0].menuKey?"active-open":e[0].selected&&!e[0].expanded?"active":"")))&&p(n,"class",g)},i(e){h||(S(y),h=!0)},o(e){T(y),h=!1},d(e){e&&i(t),v&&v.d(),w&&w.d(),y&&y.d(),b=!1,$()}}}function G(e){let t,n,o,u;return{c(){t=a("div"),n=c("svg"),o=c("path"),p(o,"fill","currentColor"),p(o,"d","M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"),p(n,"xmlns","http://www.w3.org/2000/svg"),p(n,"aria-hidden","true"),p(n,"focusable","false"),p(n,"data-prefix","fas"),p(n,"data-icon","chevron-up"),p(n,"class","svg-inline--fa fa-chevron-up fa-w-14"),p(n,"role","img"),p(n,"viewBox","0 0 448 512"),p(t,"class",u="arrow-"+(e[0].submenu&&e[0].submenu.length>0&&e[0].expanded?"up":"none"))},m(e,u){r(e,t,u),l(t,n),l(n,o)},p(e,n){1&n&&u!==(u="arrow-"+(e[0].submenu&&e[0].submenu.length>0&&e[0].expanded?"up":"none"))&&p(t,"class",u)},d(e){e&&i(t)}}}function I(e){let t,n,o,u;return{c(){t=a("div"),n=c("svg"),o=c("path"),p(o,"fill","currentColor"),p(o,"d","M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"),p(n,"xmlns","http://www.w3.org/2000/svg"),p(n,"aria-hidden","true"),p(n,"focusable","false"),p(n,"data-prefix","fas"),p(n,"data-icon","chevron-down"),p(n,"class","svg-inline--fa fa-chevron-down fa-w-14"),p(n,"role","img"),p(n,"viewBox","0 0 448 512"),p(t,"class",u="arrow-"+(e[0].submenu&&e[0].submenu.length>0&&!e[0].expanded?"down":"none"))},m(e,u){r(e,t,u),l(t,n),l(n,o)},p(e,n){1&n&&u!==(u="arrow-"+(e[0].submenu&&e[0].submenu.length>0&&!e[0].expanded?"down":"none"))&&p(t,"class",u)},d(e){e&&i(t)}}}function J(e){let t,n,o,u=e[0].submenu,s=[];for(let t=0;t<u.length;t+=1)s[t]=Q(R(e,u,t));const c=e=>T(s[e],1,1,(()=>{s[e]=null}));return{c(){t=a("div"),n=a("ul");for(let e=0;e<s.length;e+=1)s[e].c();p(n,"class","nav--menu-ul"),f(n,"expanded",e[0].expanded),p(t,"class","sub-list")},m(e,u){r(e,t,u),l(t,n);for(let e=0;e<s.length;e+=1)s[e].m(n,null);o=!0},p(e,t){if(7&t){let o;for(u=e[0].submenu,o=0;o<u.length;o+=1){const l=R(e,u,o);s[o]?(s[o].p(l,t),S(s[o],1)):(s[o]=Q(l),s[o].c(),S(s[o],1),s[o].m(n,null))}for(O(),o=u.length;o<s.length;o+=1)c(o);F()}1&t&&f(n,"expanded",e[0].expanded)},i(e){if(!o){for(let e=0;e<u.length;e+=1)S(s[e]);o=!0}},o(e){s=s.filter(Boolean);for(let e=0;e<s.length;e+=1)T(s[e]);o=!1},d(e){e&&i(t),function(e,t){for(let n=0;n<e.length;n+=1)e[n]&&e[n].d(t)}(s,e)}}}function Q(e){let t,n,o,u;return n=new W({props:{submenuitem:e[10],groupedmenudataNew:e[1],selectedmenuitem:e[2]}}),{c(){var e;t=a("li"),(e=n.$$.fragment)&&e.c(),o=m(),p(t,"class","nav--menu--li sub-list--adjust")},m(e,s){r(e,t,s),B(n,t,null),r(e,o,s),u=!0},p(e,t){const o={};1&t&&(o.submenuitem=e[10]),2&t&&(o.groupedmenudataNew=e[1]),4&t&&(o.selectedmenuitem=e[2]),n.$set(o)},i(e){u||(S(n.$$.fragment,e),u=!0)},o(e){T(n.$$.fragment,e),u=!1},d(e){e&&i(t),D(n),e&&i(o)}}}function U(t){let n,o,u=t[0]&&q(t);return{c(){u&&u.c(),n=d(""),this.c=e},m(e,t){u&&u.m(e,t),r(e,n,t),o=!0},p(e,[t]){e[0]?u?(u.p(e,t),1&t&&S(u,1)):(u=q(e),u.c(),S(u,1),u.m(n.parentNode,n)):u&&(O(),T(u,1,1,(()=>{u=null})),F())},i(e){o||(S(u),o=!0)},o(e){T(u),o=!1},d(e){u&&u.d(e),e&&i(n)}}}function V(e,t,n){let{submenuitem:o}=t,{groupedmenudataNew:u}=t,{selectedmenuitem:s}=t;const l=x(),r=$();function i(e,t){o.submenu&&o.submenu.length>0?n(0,o.selected=!o.selected,o):n(0,o.selected=!0,o),o.submenu.length>0&&n(0,o.expanded=!o.expanded,o),n(0,o=Object.assign({},o));let u=Object.assign(Object.assign({},e),{detail:t.menuKey,bubbles:!0});var s,i,a;console.log("suri side menu item Arrow clicked 11:-----",t,o),e.stopPropagation(),s="itemArrowClicked",i=o.menuKey,a=new CustomEvent("itemArrowClicked",u),l(s,i),r.dispatchEvent&&r.dispatchEvent(a)}return e.$$set=e=>{"submenuitem"in e&&n(0,o=e.submenuitem),"groupedmenudataNew"in e&&n(1,u=e.groupedmenudataNew),"selectedmenuitem"in e&&n(2,s=e.selectedmenuitem)},e.$$.update=()=>{4&e.$$.dirty&&console.log("suri selected menu item from ",s)},[o,u,s,i,e=>i(e,o)]}"function"==typeof HTMLElement&&(K=class extends HTMLElement{constructor(){super(),this.attachShadow({mode:"open"})}connectedCallback(){const{on_mount:e}=this.$$;this.$$.on_disconnect=e.map(t).filter(u);for(const e in this.$$.slotted)this.appendChild(this.$$.slotted[e])}attributeChangedCallback(e,t,n){this[e]=n}disconnectedCallback(){o(this.$$.on_disconnect)}$destroy(){D(this,1),this.$destroy=e}$on(e,t){const n=this.$$.callbacks[e]||(this.$$.callbacks[e]=[]);return n.push(t),()=>{const e=n.indexOf(t);-1!==e&&n.splice(e,1)}}$set(e){var t;this.$$set&&(t=e,0!==Object.keys(t).length)&&(this.$$.skip_bound=!0,this.$$set(e),this.$$.skip_bound=!1)}});class W extends K{constructor(e){super(),this.shadowRoot.innerHTML="<style>.nav--menu-ul{list-style:none;padding-left:0;font-size:16px;overflow:auto}.nav--menu--li{transition:ease-in .2s}.nav--menu--li:hover{text-decoration:none;color:#525051;background-color:#DDD}.round-8{border-radius:8px}.nav--a{display:block;color:#525051;font-weight:normal;text-decoration:none;padding-bottom:10px;padding-top:10px;padding-left:7px}.arrow-down,.arrow-up{padding:0 6px 0 4px;font-size:24px;float:right;width:15px;margin-top:-5px}.arrow-up{color:#FF0021}.nav--menu--li.active .nav--a{color:#FF0021;background-color:#fff;font-weight:bold;margin-left:-7px;padding-left:15px;display:block;text-decoration:none;padding-bottom:10px;padding-top:10px}.active-open.nav--menu--li{color:#525051;background-color:#ECECEC;margin-left:0;font-size:18px}.sub-list .sub-list .nav--menu-ul{color:#525051;background-color:#ECECEC}.sub-list .sub-list .nav--menu-ul,.sub-list .nav--menu--li{font-size:14px}.sub-list--adjust{padding-left:5px}.sub-list{margin-top:5px}.sub-list .sub-list .nav--menu-ul{background-color:#ECECEC;padding-top:10px;padding-bottom:10px}.nav--menu--li.sub-list--adjust:last-child{border-bottom-left-radius:8px;border-bottom-right-radius:8px}@media(max-width: 425px){}</style>",P(this,{target:this.shadowRoot,props:g(this.attributes),customElement:!0},V,U,s,{submenuitem:0,groupedmenudataNew:1,selectedmenuitem:2},null),e&&(e.target&&r(e.target,this,e.anchor),e.props&&(this.$set(e.props),j()))}static get observedAttributes(){return["submenuitem","groupedmenudataNew","selectedmenuitem"]}get submenuitem(){return this.$$.ctx[0]}set submenuitem(e){this.$$set({submenuitem:e}),j()}get groupedmenudataNew(){return this.$$.ctx[1]}set groupedmenudataNew(e){this.$$set({groupedmenudataNew:e}),j()}get selectedmenuitem(){return this.$$.ctx[2]}set selectedmenuitem(e){this.$$set({selectedmenuitem:e}),j()}}return customElements.define("eas-submenu-item",W),W}();
//# sourceMappingURL=eas-submenu-item.js.map

var EasLayout=function(){"use strict";function t(){}function e(t){return t()}function n(){return Object.create(null)}function o(t){t.forEach(e)}function r(t){return"function"==typeof t}function s(t,e){return t!=t?e==e:t!==e||t&&"object"==typeof t||"function"==typeof t}function i(t,e){t.appendChild(e)}function a(t,e,n){t.insertBefore(e,n||null)}function c(t){t.parentNode.removeChild(t)}function u(t){return document.createElement(t)}function l(t){return document.createTextNode(t)}function d(){return l(" ")}function h(t,e,n){null==n?t.removeAttribute(e):t.getAttribute(e)!==n&&t.setAttribute(e,n)}function f(t){const e={};for(const n of t)e[n.name]=n.value;return e}let p;function $(t){p=t}const m=[],g=[],b=[],x=[],y=Promise.resolve();let _=!1;function k(t){b.push(t)}const v=new Set;let w=0;function E(){const t=p;do{for(;w<m.length;){const t=m[w];w++,$(t),C(t.$$)}for($(null),m.length=0,w=0;g.length;)g.pop()();for(let t=0;t<b.length;t+=1){const e=b[t];v.has(e)||(v.add(e),e())}b.length=0}while(m.length);for(;x.length;)x.pop()();_=!1,v.clear(),$(t)}function C(t){if(null!==t.fragment){t.update(),o(t.before_update);const e=t.dirty;t.dirty=[-1],t.fragment&&t.fragment.p(t.ctx,e),t.after_update.forEach(k)}}const A=new Set;function S(t,e){-1===t.$$.dirty[0]&&(m.push(t),_||(_=!0,y.then(E)),t.$$.dirty.fill(0)),t.$$.dirty[e/31|0]|=1<<e%31}function T(s,i,a,u,l,d,h,f=[-1]){const m=p;$(s);const g=s.$$={fragment:null,ctx:null,props:d,update:t,not_equal:l,bound:n(),on_mount:[],on_destroy:[],on_disconnect:[],before_update:[],after_update:[],context:new Map(i.context||(m?m.$$.context:[])),callbacks:n(),dirty:f,skip_bound:!1,root:i.target||m.$$.root};h&&h(g.root);let b=!1;if(g.ctx=a?a(s,i.props||{},((t,e,...n)=>{const o=n.length?n[0]:e;return g.ctx&&l(g.ctx[t],g.ctx[t]=o)&&(!g.skip_bound&&g.bound[t]&&g.bound[t](o),b&&S(s,t)),e})):[],g.update(),b=!0,o(g.before_update),g.fragment=!!u&&u(g.ctx),i.target){if(i.hydrate){const t=function(t){return Array.from(t.childNodes)}(i.target);g.fragment&&g.fragment.l(t),t.forEach(c)}else g.fragment&&g.fragment.c();i.intro&&((x=s.$$.fragment)&&x.i&&(A.delete(x),x.i(y))),function(t,n,s,i){const{fragment:a,on_mount:c,on_destroy:u,after_update:l}=t.$$;a&&a.m(n,s),i||k((()=>{const n=c.map(e).filter(r);u?u.push(...n):o(n),t.$$.on_mount=[]})),l.forEach(k)}(s,i.target,i.anchor,i.customElement),E()}var x,y;$(m)}let L;function M(e){let n,o,r,s,f,p,$,m,g,b,x;return{c(){n=u("div"),o=u("div"),r=u("div"),s=u("div"),f=l(e[0]),p=d(),$=u("hr"),m=d(),g=u("slot"),b=d(),x=u("slot"),this.c=t,h($,"class","hr"),h(s,"class","header"),h(g,"name","textarea"),h(x,"name","tiles"),h(o,"class","container"),h(n,"class","body")},m(t,e){a(t,n,e),i(n,o),i(o,r),i(r,s),i(s,f),i(s,p),i(s,$),i(r,m),i(r,g),i(r,b),i(r,x)},p(t,[e]){1&e&&function(t,e){e=""+e,t.wholeText!==e&&(t.data=e)}(f,t[0])},i:t,o:t,d(t){t&&c(n)}}}function j(t,e,n){let{header:o=""}=e,{theme:r="light"}=e;return t.$$set=t=>{"header"in t&&n(0,o=t.header),"theme"in t&&n(1,r=t.theme)},[o,r]}"function"==typeof HTMLElement&&(L=class extends HTMLElement{constructor(){super(),this.attachShadow({mode:"open"})}connectedCallback(){const{on_mount:t}=this.$$;this.$$.on_disconnect=t.map(e).filter(r);for(const t in this.$$.slotted)this.appendChild(this.$$.slotted[t])}attributeChangedCallback(t,e,n){this[t]=n}disconnectedCallback(){o(this.$$.on_disconnect)}$destroy(){!function(t,e){const n=t.$$;null!==n.fragment&&(o(n.on_destroy),n.fragment&&n.fragment.d(e),n.on_destroy=n.fragment=null,n.ctx=[])}(this,1),this.$destroy=t}$on(t,e){const n=this.$$.callbacks[t]||(this.$$.callbacks[t]=[]);return n.push(e),()=>{const t=n.indexOf(e);-1!==t&&n.splice(t,1)}}$set(t){var e;this.$$set&&(e=t,0!==Object.keys(e).length)&&(this.$$.skip_bound=!0,this.$$set(t),this.$$.skip_bound=!1)}});class H extends L{constructor(t){super(),this.shadowRoot.innerHTML='<style>.header{color:#700017;font-weight:700;font-size:20px}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;font-family:"Source Sans Pro", sans-serif;-webkit-font-smoothing:antialiased;height:100%;padding-top:30px}.hr{margin:14px 0;background-color:#525051;border:none;height:1px}@media(min-width: 1200px){.container{max-width:1140px}}</style>',T(this,{target:this.shadowRoot,props:f(this.attributes),customElement:!0},j,M,s,{header:0,theme:1},null),t&&(t.target&&a(t.target,this,t.anchor),t.props&&(this.$set(t.props),E()))}static get observedAttributes(){return["header","theme"]}get header(){return this.$$.ctx[0]}set header(t){this.$$set({header:t}),E()}get theme(){return this.$$.ctx[1]}set theme(t){this.$$set({theme:t}),E()}}return customElements.define("eas-layout",H),H}();
//# sourceMappingURL=eas-layout.js.map

var EasTextArea=function(){"use strict";function t(){}function e(t){return t()}function n(){return Object.create(null)}function o(t){t.forEach(e)}function i(t){return"function"==typeof t}function r(t,e){return t!=t?e==e:t!==e||t&&"object"==typeof t||"function"==typeof t}function s(t,e){t.appendChild(e)}function c(t,e,n){t.insertBefore(e,n||null)}function a(t){t.parentNode.removeChild(t)}function u(t){return document.createElement(t)}function l(t){return document.createTextNode(t)}function d(t,e,n){null==n?t.removeAttribute(e):t.getAttribute(e)!==n&&t.setAttribute(e,n)}function h(t,e){e=""+e,t.wholeText!==e&&(t.data=e)}function f(t){const e={};for(const n of t)e[n.name]=n.value;return e}let p;function $(t){p=t}const m=[],g=[],b=[],x=[],y=Promise.resolve();let _=!1;function k(t){b.push(t)}const v=new Set;let w=0;function E(){const t=p;do{for(;w<m.length;){const t=m[w];w++,$(t),C(t.$$)}for($(null),m.length=0,w=0;g.length;)g.pop()();for(let t=0;t<b.length;t+=1){const e=b[t];v.has(e)||(v.add(e),e())}b.length=0}while(m.length);for(;x.length;)x.pop()();_=!1,v.clear(),$(t)}function C(t){if(null!==t.fragment){t.update(),o(t.before_update);const e=t.dirty;t.dirty=[-1],t.fragment&&t.fragment.p(t.ctx,e),t.after_update.forEach(k)}}const A=new Set;function T(t,e){-1===t.$$.dirty[0]&&(m.push(t),_||(_=!0,y.then(E)),t.$$.dirty.fill(0)),t.$$.dirty[e/31|0]|=1<<e%31}function S(r,s,c,u,l,d,h,f=[-1]){const m=p;$(r);const g=r.$$={fragment:null,ctx:null,props:d,update:t,not_equal:l,bound:n(),on_mount:[],on_destroy:[],on_disconnect:[],before_update:[],after_update:[],context:new Map(s.context||(m?m.$$.context:[])),callbacks:n(),dirty:f,skip_bound:!1,root:s.target||m.$$.root};h&&h(g.root);let b=!1;if(g.ctx=c?c(r,s.props||{},((t,e,...n)=>{const o=n.length?n[0]:e;return g.ctx&&l(g.ctx[t],g.ctx[t]=o)&&(!g.skip_bound&&g.bound[t]&&g.bound[t](o),b&&T(r,t)),e})):[],g.update(),b=!0,o(g.before_update),g.fragment=!!u&&u(g.ctx),s.target){if(s.hydrate){const t=function(t){return Array.from(t.childNodes)}(s.target);g.fragment&&g.fragment.l(t),t.forEach(a)}else g.fragment&&g.fragment.c();s.intro&&((x=r.$$.fragment)&&x.i&&(A.delete(x),x.i(y))),function(t,n,r,s){const{fragment:c,on_mount:a,on_destroy:u,after_update:l}=t.$$;c&&c.m(n,r),s||k((()=>{const n=a.map(e).filter(i);u?u.push(...n):o(n),t.$$.on_mount=[]})),l.forEach(k)}(r,s.target,s.anchor,s.customElement),E()}var x,y;$(m)}let M;function j(e){let n,o,i,r,f,p,$,m,g,b,x;return{c(){n=u("div"),o=u("div"),i=u("div"),r=u("div"),f=u("div"),p=u("b"),$=l(e[0]),m=l(" "),g=u("div"),b=l(e[1]),this.c=t,d(r,"class","description"),d(o,"class","container"),d(n,"class",x="body-"+e[2])},m(t,e){c(t,n,e),s(n,o),s(o,i),s(i,r),s(r,f),s(f,p),s(p,$),s(r,m),s(r,g),s(g,b)},p(t,[e]){1&e&&h($,t[0]),2&e&&h(b,t[1]),4&e&&x!==(x="body-"+t[2])&&d(n,"class",x)},i:t,o:t,d(t){t&&a(n)}}}function H(t,e,n){let{title:o=""}=e,{description:i=""}=e,{theme:r="light"}=e;return t.$$set=t=>{"title"in t&&n(0,o=t.title),"description"in t&&n(1,i=t.description),"theme"in t&&n(2,r=t.theme)},[o,i,r]}"function"==typeof HTMLElement&&(M=class extends HTMLElement{constructor(){super(),this.attachShadow({mode:"open"})}connectedCallback(){const{on_mount:t}=this.$$;this.$$.on_disconnect=t.map(e).filter(i);for(const t in this.$$.slotted)this.appendChild(this.$$.slotted[t])}attributeChangedCallback(t,e,n){this[t]=n}disconnectedCallback(){o(this.$$.on_disconnect)}$destroy(){!function(t,e){const n=t.$$;null!==n.fragment&&(o(n.on_destroy),n.fragment&&n.fragment.d(e),n.on_destroy=n.fragment=null,n.ctx=[])}(this,1),this.$destroy=t}$on(t,e){const n=this.$$.callbacks[t]||(this.$$.callbacks[t]=[]);return n.push(e),()=>{const t=n.indexOf(e);-1!==t&&n.splice(t,1)}}$set(t){var e;this.$$set&&(e=t,0!==Object.keys(e).length)&&(this.$$.skip_bound=!0,this.$$set(t),this.$$.skip_bound=!1)}});class L extends M{constructor(t){super(),this.shadowRoot.innerHTML='<style>.body-dark{background-color:#f2f2f2;height:auto;height:100vh \n    }.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;font-family:"Source Sans Pro", sans-serif;-webkit-font-smoothing:antialiased;height:100%;padding-top:30px}.hr{margin:14px 0;background-color:#525051;border:none;height:1px}@media(min-width: 1200px){.container{max-width:1140px}}</style>',S(this,{target:this.shadowRoot,props:f(this.attributes),customElement:!0},H,j,r,{title:0,description:1,theme:2},null),t&&(t.target&&c(t.target,this,t.anchor),t.props&&(this.$set(t.props),E()))}static get observedAttributes(){return["title","description","theme"]}get title(){return this.$$.ctx[0]}set title(t){this.$$set({title:t}),E()}get description(){return this.$$.ctx[1]}set description(t){this.$$set({description:t}),E()}get theme(){return this.$$.ctx[2]}set theme(t){this.$$set({theme:t}),E()}}return customElements.define("eas-text-area",L),L}();
//# sourceMappingURL=eas-text-area.js.map

var EasReport=function(){"use strict";function t(){}function n(t){return t()}function e(){return Object.create(null)}function o(t){t.forEach(n)}function r(t){return"function"==typeof t}function c(t,n){return t!=t?n==n:t!==n||t&&"object"==typeof t||"function"==typeof t}function s(t,n,e){t.insertBefore(n,e||null)}function i(t){t.parentNode.removeChild(t)}function a(t,n,e,o){null===e?t.style.removeProperty(n):t.style.setProperty(n,e,o?"important":"")}function u(t){const n={};for(const e of t)n[e.name]=e.value;return n}let l;function f(t){l=t}const d=[],h=[],p=[],$=[],m=Promise.resolve();let g=!1;function y(t){p.push(t)}const b=new Set;let _=0;function x(){const t=l;do{for(;_<d.length;){const t=d[_];_++,f(t),k(t.$$)}for(f(null),d.length=0,_=0;h.length;)h.pop()();for(let t=0;t<p.length;t+=1){const n=p[t];b.has(n)||(b.add(n),n())}p.length=0}while(d.length);for(;$.length;)$.pop()();g=!1,b.clear(),f(t)}function k(t){if(null!==t.fragment){t.update(),o(t.before_update);const n=t.dirty;t.dirty=[-1],t.fragment&&t.fragment.p(t.ctx,n),t.after_update.forEach(y)}}const v=new Set;function E(t,n){-1===t.$$.dirty[0]&&(d.push(t),g||(g=!0,m.then(x)),t.$$.dirty.fill(0)),t.$$.dirty[n/31|0]|=1<<n%31}function w(c,s,a,u,d,h,p,$=[-1]){const m=l;f(c);const g=c.$$={fragment:null,ctx:null,props:h,update:t,not_equal:d,bound:e(),on_mount:[],on_destroy:[],on_disconnect:[],before_update:[],after_update:[],context:new Map(s.context||(m?m.$$.context:[])),callbacks:e(),dirty:$,skip_bound:!1,root:s.target||m.$$.root};p&&p(g.root);let b=!1;if(g.ctx=a?a(c,s.props||{},((t,n,...e)=>{const o=e.length?e[0]:n;return g.ctx&&d(g.ctx[t],g.ctx[t]=o)&&(!g.skip_bound&&g.bound[t]&&g.bound[t](o),b&&E(c,t)),n})):[],g.update(),b=!0,o(g.before_update),g.fragment=!!u&&u(g.ctx),s.target){if(s.hydrate){const t=function(t){return Array.from(t.childNodes)}(s.target);g.fragment&&g.fragment.l(t),t.forEach(i)}else g.fragment&&g.fragment.c();s.intro&&((_=c.$$.fragment)&&_.i&&(v.delete(_),_.i(k))),function(t,e,c,s){const{fragment:i,on_mount:a,on_destroy:u,after_update:l}=t.$$;i&&i.m(e,c),s||y((()=>{const e=a.map(n).filter(r);u?u.push(...e):o(e),t.$$.on_mount=[]})),l.forEach(y)}(c,s.target,s.anchor,s.customElement),x()}var _,k;f(m)}let C;function j(n){let e;return{c(){var n;n="div",e=document.createElement(n),e.innerHTML='<div style="font-size: 20px;font-weight: bold">Power BI report component is under construction</div>',this.c=t,a(e,"display","flex"),a(e,"justify-content","center"),a(e,"align-items","center")},m(t,n){s(t,e,n)},p:t,i:t,o:t,d(t){t&&i(e)}}}"function"==typeof HTMLElement&&(C=class extends HTMLElement{constructor(){super(),this.attachShadow({mode:"open"})}connectedCallback(){const{on_mount:t}=this.$$;this.$$.on_disconnect=t.map(n).filter(r);for(const t in this.$$.slotted)this.appendChild(this.$$.slotted[t])}attributeChangedCallback(t,n,e){this[t]=e}disconnectedCallback(){o(this.$$.on_disconnect)}$destroy(){!function(t,n){const e=t.$$;null!==e.fragment&&(o(e.on_destroy),e.fragment&&e.fragment.d(n),e.on_destroy=e.fragment=null,e.ctx=[])}(this,1),this.$destroy=t}$on(t,n){const e=this.$$.callbacks[t]||(this.$$.callbacks[t]=[]);return e.push(n),()=>{const t=e.indexOf(n);-1!==t&&e.splice(t,1)}}$set(t){var n;this.$$set&&(n=t,0!==Object.keys(n).length)&&(this.$$.skip_bound=!0,this.$$set(t),this.$$.skip_bound=!1)}});class M extends C{constructor(t){super(),w(this,{target:this.shadowRoot,props:u(this.attributes),customElement:!0},null,j,c,{},null),t&&t.target&&s(t.target,this,t.anchor)}}return customElements.define("eas-report",M),M}();
//# sourceMappingURL=eas-report.js.map

var EasStepper = function () { "use strict"; function t() { } function e(t, e) { for (const n in e) t[n] = e[n]; return t } function n(t) { return t() } function o() { return Object.create(null) } function s(t) { t.forEach(n) } function i(t) { return "function" == typeof t } function r(t, e) { return t != t ? e == e : t !== e || t && "object" == typeof t || "function" == typeof t } function a(t) { const e = {}; for (const n in t) "$" !== n[0] && (e[n] = t[n]); return e } function c(t, e) { t.appendChild(e) } function p(t, e, n) { t.insertBefore(e, n || null) } function d(t) { t.parentNode.removeChild(t) } function l(t) { return document.createElement(t) } function m(t) { return document.createTextNode(t) } function u() { return m(" ") } function _() { return m("") } function g(t, e, n, o) { return t.addEventListener(e, n, o), () => t.removeEventListener(e, n, o) } function f(t, e, n) { null == n ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n) } function b(t, e) { e = "" + e, t.wholeText !== e && (t.data = e) } function h(t) { const e = {}; for (const n of t) e[n.name] = n.value; return e } let x; function $(t) { x = t } function y() { if (!x) throw new Error("Function called outside component initialization"); return x } function w() { const t = y(); return (e, n, { cancelable: o = !1 } = {}) => { const s = t.$$.callbacks[e]; if (s) { const i = function (t, e, { bubbles: n = !1, cancelable: o = !1 } = {}) { const s = document.createEvent("CustomEvent"); return s.initCustomEvent(t, n, o, e), s }(e, n, { cancelable: o }); return s.slice().forEach((e => { e.call(t, i) })), !i.defaultPrevented } return !0 } } const k = [], v = [], E = [], C = [], A = Promise.resolve(); let j = !1; function S(t) { E.push(t) } const N = new Set; let O = 0; function z() { const t = x; do { for (; O < k.length;) { const t = k[O]; O++ , $(t), D(t.$$) } for ($(null), k.length = 0, O = 0; v.length;)v.pop()(); for (let t = 0; t < E.length; t += 1) { const e = E[t]; N.has(e) || (N.add(e), e()) } E.length = 0 } while (k.length); for (; C.length;)C.pop()(); j = !1, N.clear(), $(t) } function D(t) { if (null !== t.fragment) { t.update(), s(t.before_update); const e = t.dirty; t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(S) } } const L = new Set; function T(t, e) { -1 === t.$$.dirty[0] && (k.push(t), j || (j = !0, A.then(z)), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31 } function B(e, r, a, c, p, l, m, u = [-1]) { const _ = x; $(e); const g = e.$$ = { fragment: null, ctx: null, props: l, update: t, not_equal: p, bound: o(), on_mount: [], on_destroy: [], on_disconnect: [], before_update: [], after_update: [], context: new Map(r.context || (_ ? _.$$.context : [])), callbacks: o(), dirty: u, skip_bound: !1, root: r.target || _.$$.root }; m && m(g.root); let f = !1; if (g.ctx = a ? a(e, r.props || {}, ((t, n, ...o) => { const s = o.length ? o[0] : n; return g.ctx && p(g.ctx[t], g.ctx[t] = s) && (!g.skip_bound && g.bound[t] && g.bound[t](s), f && T(e, t)), n })) : [], g.update(), f = !0, s(g.before_update), g.fragment = !!c && c(g.ctx), r.target) { if (r.hydrate) { const t = function (t) { return Array.from(t.childNodes) }(r.target); g.fragment && g.fragment.l(t), t.forEach(d) } else g.fragment && g.fragment.c(); r.intro && ((b = e.$$.fragment) && b.i && (L.delete(b), b.i(h))), function (t, e, o, r) { const { fragment: a, on_mount: c, on_destroy: p, after_update: d } = t.$$; a && a.m(e, o), r || S((() => { const e = c.map(n).filter(i); p ? p.push(...e) : s(e), t.$$.on_mount = [] })), d.forEach(S) }(e, r.target, r.anchor, r.customElement), z() } var b, h; $(_) } let F; function M(t, e, n) { const o = t.slice(); return o[12] = e[n], o[14] = n, o } function P(t) { let e, n, o, s, i, r, a, _, g, h, x, $, y, w, k, v, E, C, A, j, S, N, O, z, D = t[0].length + "", L = t[0][t[1] - 1].label + "", T = t[0], B = []; for (let e = 0; e < T.length; e += 1)B[e] = R(M(t, T, e)); return { c() { e = l("div"), n = l("br"), o = l("br"), s = l("br"), i = l("br"), r = u(), a = l("section"), _ = l("div"), g = l("ol"); for (let t = 0; t < B.length; t += 1)B[t].c(); h = u(), x = l("div"), $ = l("div"), y = l("span"), w = l("span"), w.textContent = "Step", k = u(), v = l("span"), E = m(t[1]), C = u(), A = l("span"), j = m("of "), S = m(D), N = u(), O = l("span"), z = m(L), f(g, "class", "step-indicator__segments step--number steps-blue-800"), f(w, "class", "sr-only"), f(v, "class", "step-indicator__current-step"), f(A, "class", "step-indicator__total-steps"), f(y, "class", "step-indicator__heading-counter plr-10 ptb-5 gray-300 rounded-full"), f(O, "class", "step-indicator__heading-text"), f($, "class", "step-indicator__heading"), f(x, "class", "step-indicator__header"), f(_, "class", "step-container ptb-20"), f(_, "aria-label", "progress"), f(a, "class", "body-div") }, m(t, d) { p(t, e, d), c(e, n), c(e, o), c(e, s), c(e, i), c(e, r), c(e, a), c(a, _), c(_, g); for (let t = 0; t < B.length; t += 1)B[t].m(g, null); c(_, h), c(_, x), c(x, $), c($, y), c(y, w), c(y, k), c(y, v), c(v, E), c(y, C), c(y, A), c(A, j), c(A, S), c($, N), c($, O), c(O, z) }, p(t, e) { if (5 & e) { let n; for (T = t[0], n = 0; n < T.length; n += 1) { const o = M(t, T, n); B[n] ? B[n].p(o, e) : (B[n] = R(o), B[n].c(), B[n].m(g, null)) } for (; n < B.length; n += 1)B[n].d(1); B.length = T.length } 2 & e && b(E, t[1]), 1 & e && D !== (D = t[0].length + "") && b(S, D), 3 & e && L !== (L = t[0][t[1] - 1].label + "") && b(z, L) }, d(t) { t && d(e), function (t, e) { for (let n = 0; n < t.length; n += 1)t[n] && t[n].d(e) }(B, t) } } } function H(t) { let e, n, o, s, i, r, a = t[12].label + ""; return { c() { e = l("li"), n = l("span"), o = m(a), s = u(), i = l("span"), i.textContent = "not started", r = u(), f(i, "class", "sr-only"), f(n, "class", "step-indicator__segment-label"), f(e, "class", "step-indicator__segment") }, m(t, a) { p(t, e, a), c(e, n), c(n, o), c(n, s), c(n, i), c(e, r) }, p(t, e) { 1 & e && a !== (a = t[12].label + "") && b(o, a) }, d(t) { t && d(e) } } } function I(t) { let e, n, o, s, i, r, a, _, h = t[12].label + ""; function x(...e) { return t[4](t[12], ...e) } return { c() { e = l("li"), n = l("span"), o = m(h), s = u(), i = l("span"), i.textContent = "not completed", r = u(), f(i, "class", "sr-only"), f(n, "class", "step-indicator__segment-label"), f(e, "class", "step-indicator__segment step-indicator__segment--current") }, m(t, d) { p(t, e, d), c(e, n), c(n, o), c(n, s), c(n, i), c(e, r), a || (_ = g(e, "click", x), a = !0) }, p(e, n) { t = e, 1 & n && h !== (h = t[12].label + "") && b(o, h) }, d(t) { t && d(e), a = !1, _() } } } function J(t) { let e, n, o, s, i, r, a, _, h = t[12].label + ""; function x(...e) { return t[3](t[12], ...e) } return { c() { e = l("li"), n = l("span"), o = m(h), s = u(), i = l("span"), i.textContent = "completed", r = u(), f(i, "class", "sr-only"), f(n, "class", "step-indicator__segment-label"), f(e, "class", "step-indicator__segment step-indicator__segment--complete") }, m(t, d) { p(t, e, d), c(e, n), c(n, o), c(n, s), c(n, i), c(e, r), a || (_ = g(e, "click", x), a = !0) }, p(e, n) { t = e, 1 & n && h !== (h = t[12].label + "") && b(o, h) }, d(t) { t && d(e), a = !1, _() } } } function R(t) { let e; function n(t, e) { return t[12].completed ? J : t[12].current ? I : H } let o = n(t), s = o(t); return { c() { s.c(), e = _() }, m(t, n) { s.m(t, n), p(t, e, n) }, p(t, i) { o === (o = n(t)) && s ? s.p(t, i) : (s.d(1), s = o(t), s && (s.c(), s.m(e.parentNode, e))) }, d(t) { s.d(t), t && d(e) } } } function q(e) { let n, o = e[0] && e[0].length > 0 && P(e); return { c() { o && o.c(), n = _(), this.c = t }, m(t, e) { o && o.m(t, e), p(t, n, e) }, p(t, [e]) { t[0] && t[0].length > 0 ? o ? o.p(t, e) : (o = P(t), o.c(), o.m(n.parentNode, n)) : o && (o.d(1), o = null) }, i: t, o: t, d(t) { o && o.d(t), t && d(n) } } } function G(t, n, o) { let s, { stepperdata: i = [] } = n; const r = w(), c = y(); var p; function d(t, e) { let s = Object.assign(Object.assign({}, e), { detail: t }); var a, p, d; console.log("clicked event data=", s), console.log(" $$props= ", n), e.stopPropagation(), function (t) { let e = i.find((e => e === t)); null == i || i.forEach((t => t.selected = !1)), e.selected = !0, o(0, i = [...i]) }(t), a = "click", p = t, d = new CustomEvent("click", s), r(a, p), c.dispatchEvent && c.dispatchEvent(d) } p = () => { "string" == typeof i && o(0, i = JSON.parse(i)) }, y().$$.before_update.push(p), function (t) { y().$$.on_mount.push(t) }((() => { "string" == typeof i && o(0, i = JSON.parse(i)) })); return t.$$set = t => { o(11, n = e(e({}, n), a(t))), "stepperdata" in t && o(0, i = t.stepperdata) }, t.$$.update = () => { 1 & t.$$.dirty && o(0, i = [...i]), 1 & t.$$.dirty && console.log("suri testing for stepper model value", i), 1 & t.$$.dirty && o(1, s = [...i].findIndex((t => t.selected)) + 1), 1 & t.$$.dirty && [...i].findIndex((t => t.current)) }, n = a(n), [i, s, d, (t, e) => d(t, e), (t, e) => d(t, e)] } "function" == typeof HTMLElement && (F = class extends HTMLElement { constructor() { super(), this.attachShadow({ mode: "open" }) } connectedCallback() { const { on_mount: t } = this.$$; this.$$.on_disconnect = t.map(n).filter(i); for (const t in this.$$.slotted) this.appendChild(this.$$.slotted[t]) } attributeChangedCallback(t, e, n) { this[t] = n } disconnectedCallback() { s(this.$$.on_disconnect) } $destroy() { !function (t, e) { const n = t.$$; null !== n.fragment && (s(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []) }(this, 1), this.$destroy = t } $on(t, e) { const n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []); return n.push(e), () => { const t = n.indexOf(e); -1 !== t && n.splice(t, 1) } } $set(t) { var e; this.$$set && (e = t, 0 !== Object.keys(e).length) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1) } }); class K extends F { constructor(t) { super(), this.shadowRoot.innerHTML = "<style>.body-div{height:100%;margin:0;padding:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#000;font-family:'Source Sans Pro', sans-serif}.ptb-20{padding-top:20px !important;padding-bottom:20px !important}section,div{background:transparent;transition:all .2s ease-in-out}*,*:after,*:before{box-sizing:border-box;padding:0;margin:0}li{max-width:720px}ol>li{padding:8px 10px 8px 8px;line-height:24px}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only{position:absolute;left:-999em;right:auto}.gray-300{background:#E8E8E8!important}.rounded-full{border-radius:100px !important}.plr-10{padding-left:10px!important;padding-right:10px!important}.ptb-5{padding-top:5px!important;padding-bottom:5px !important}.step-indicator__segments>.step-indicator__segment::before,.step-indicator__segments>.step-indicator__segment.step-indicator__segment--complete::before,.step-indicator__segments>.step-indicator__segment.step-indicator__segment--current::before{content:'';position:absolute;left:0;top:calc(50% - 20px);z-index:100;display:flex;align-items:center;justify-content:center;height:40px;width:40px;border-radius:50%;font-weight:400;font-size:18px;line-height:0;background:transparent}.step-indicator__segments{max-width:100%!important;display:flex;list-style:none;margin:0;padding:0}.step-indicator__segments.step--number>.step-indicator__segment{position:relative;flex:1 1 0%;min-height:8px;max-width:240px}ol.step-indicator__segments{counter-reset:step-indicator}ol.step-indicator__segments.step--number>.step-indicator__segment{counter-increment:step-indicatior}.step-indicator__segments.step--number>.step-indicator__segment::before,.step-indicator__segments.step--number>.step-indicator__segment--complete::before,.step-indicator__segments.step--number>.step-indicator__segment--current::before{content:counter(step-indicatior);font-feature-settings:\"tnum\" 1,\"kern\" 1}ol.step-indicator__segments.step--number>.step-indicator__segment::before{content:counter(step-indicatior);border:3px solid transparent;color:#2c2c2c;font-weight:600;background:#D9D9D9}ol.step-indicator__segments.step--number>.step-indicator__segment--complete::before{border:3px solid transparent!important;color:white}ol.step-indicator__segments.step--number>.step-indicator__segment--current::before{font-weight:600;border:3px solid transparent!important;color:white;background:#2c2c2c}ol.step-indicator__segments.step--number>.step-indicator__segment--current>.step-indicator__segment-label{font-weight:600}ol.step-indicator__segments.step--number>.step-indicator__segment::after{content:'';position:absolute;left:37px;display:flex;justify-content:center;width:calc(100% - 35px);max-width:80%;height:5px;background:#D9D9D9}ol.step-indicator__segments.step--number>.step-indicator__segment--current::after{max-width:calc(100% - 50px);border:3px solid transparent!important;background:#BFBFBF;color:white}ol.step-indicator__segments.step--number>.step-indicator__segment--complete::after{border:3px solid transparent!important;background:#3C7AA9;color:white;max-width:100%\n}ol.step-indicator__segments.step--number>.step-indicator__segment:last-of-type::after{content:'';display:none}ol.step-indicator__segments.step--number.steps-blue-800>.step-indicator__segment--complete::before{background:#3C7AA9!important}ol.step-indicator__segments.step--number>.step-indicator__segment--complete::after{border:3px solid transparent!important;background:#3C7AA9;color:white;max-width:100%\n}ol.step-indicator__segments.step--number>.step-indicator__segment--current::before{font-weight:600;border:3px solid transparent!important;color:white;background:#3C7AA9}ol.step-indicator__segments.step--number.steps-blue-800>.step-indicator__segment--current::after{background:#3C7AA9!important}.step-indicator__segments>li.step-indicator__segment>.step-indicator__segment-label{position:absolute;display:block;font-size:16px;font-weight:400;padding-right:15px;text-align:left;margin-top:30px;color:black;user-select:none}.step-indicator__heading{font-weight:600;margin:80px 0 0 0;color:black}.step-indicator__total-steps{font-weight:400}.step-indicator__heading-text{margin-left:10px}.step-indicator__current-step{display:inline-flex;font-weight:400;border-radius:50%}@media screen and (max-width: 768px){.step-indicator__segments.step--number>.step-indicator__segment::before,.step-indicator__segments.step--number>.step-indicator__segment--complete::before,.step-indicator__segments.step--number>.step-indicator__segment--current::before{display:none!important}ol.step-indicator__segments.step--number>.step-indicator__segment:last-of-type::after,ol.step-indicator__segments.step--number>.step-indicator__segment::after{content:'';position:absolute;left:0!important;display:flex;justify-content:center;width:calc(100% - 1px)!important;max-width:100%!important;height:6px!important}ol.step-indicator__segments>li.step-indicator__segment.step-indicator__segment--current::after{width:calc(100% - 1px)!important}.step-indicator__segment-label{margin-top:20px!important}}@media screen and (max-width: 512px){.step-indicator__segments>.step-indicator__segment::before,.step-indicator__segments>.step-indicator__segment--complete::before,.step-indicator__segments>.step-indicator__segment--current::before{display:none!important}.step-indicator__segments>.step-indicator__segment:last-of-type::after,.step-indicator__segments>.step-indicator__segment::after{content:'';position:absolute;left:0;display:flex;justify-content:center;width:calc(100% - 1px);max-width:100%}.step-indicator__segments>.step-indicator__segment--current::after{max-width:100%!important}.step-indicator__segment-label{display:none!important}.step-indicator__heading{margin:20px 0 0 0}}</style>", B(this, { target: this.shadowRoot, props: h(this.attributes), customElement: !0 }, G, q, r, { stepperdata: 0 }, null), t && (t.target && p(t.target, this, t.anchor), t.props && (this.$set(t.props), z())) } static get observedAttributes() { return ["stepperdata"] } get stepperdata() { return this.$$.ctx[0] } set stepperdata(t) { this.$$set({ stepperdata: t }), z() } } return customElements.define("eas-stepper", K), K }();
//# sourceMappingURL=eas-stepper.js.map

var EasGraphicStepper = function () { "use strict"; function t() { } function e(t) { return t() } function n() { return Object.create(null) } function s(t) { t.forEach(e) } function i(t) { return "function" == typeof t } function o(t, e) { return t != t ? e == e : t !== e || t && "object" == typeof t || "function" == typeof t } function r(t, e) { t.appendChild(e) } function c(t, e, n) { t.insertBefore(e, n || null) } function a(t) { t.parentNode.removeChild(t) } function p(t) { return document.createElement(t) } function d(t) { return document.createTextNode(t) } function l() { return d(" ") } function m() { return d("") } function _(t, e, n, s) { return t.addEventListener(e, n, s), () => t.removeEventListener(e, n, s) } function g(t, e, n) { null == n ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n) } function u(t, e) { e = "" + e, t.wholeText !== e && (t.data = e) } function f(t) { const e = {}; for (const n of t) e[n.name] = n.value; return e } let h; function b(t) { h = t } function x() { if (!h) throw new Error("Function called outside component initialization"); return h } function w() { const t = x(); return (e, n, { cancelable: s = !1 } = {}) => { const i = t.$$.callbacks[e]; if (i) { const o = function (t, e, { bubbles: n = !1, cancelable: s = !1 } = {}) { const i = document.createEvent("CustomEvent"); return i.initCustomEvent(t, n, s, e), i }(e, n, { cancelable: s }); return i.slice().forEach((e => { e.call(t, o) })), !o.defaultPrevented } return !0 } } const $ = [], y = [], v = [], k = [], C = Promise.resolve(); let E = !1; function z(t) { v.push(t) } const D = new Set; let S = 0; function L() { const t = h; do { for (; S < $.length;) { const t = $[S]; S++ , b(t), j(t.$$) } for (b(null), $.length = 0, S = 0; y.length;)y.pop()(); for (let t = 0; t < v.length; t += 1) { const e = v[t]; D.has(e) || (D.add(e), e()) } v.length = 0 } while ($.length); for (; k.length;)k.pop()(); E = !1, D.clear(), b(t) } function j(t) { if (null !== t.fragment) { t.update(), s(t.before_update); const e = t.dirty; t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(z) } } const A = new Set; function M(t, e) { -1 === t.$$.dirty[0] && ($.push(t), E || (E = !0, C.then(L)), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31 } function F(o, r, c, p, d, l, m, _ = [-1]) { const g = h; b(o); const u = o.$$ = { fragment: null, ctx: null, props: l, update: t, not_equal: d, bound: n(), on_mount: [], on_destroy: [], on_disconnect: [], before_update: [], after_update: [], context: new Map(r.context || (g ? g.$$.context : [])), callbacks: n(), dirty: _, skip_bound: !1, root: r.target || g.$$.root }; m && m(u.root); let f = !1; if (u.ctx = c ? c(o, r.props || {}, ((t, e, ...n) => { const s = n.length ? n[0] : e; return u.ctx && d(u.ctx[t], u.ctx[t] = s) && (!u.skip_bound && u.bound[t] && u.bound[t](s), f && M(o, t)), e })) : [], u.update(), f = !0, s(u.before_update), u.fragment = !!p && p(u.ctx), r.target) { if (r.hydrate) { const t = function (t) { return Array.from(t.childNodes) }(r.target); u.fragment && u.fragment.l(t), t.forEach(a) } else u.fragment && u.fragment.c(); r.intro && ((x = o.$$.fragment) && x.i && (A.delete(x), x.i(w))), function (t, n, o, r) { const { fragment: c, on_mount: a, on_destroy: p, after_update: d } = t.$$; c && c.m(n, o), r || z((() => { const n = a.map(e).filter(i); p ? p.push(...n) : s(n), t.$$.on_mount = [] })), d.forEach(z) }(o, r.target, r.anchor, r.customElement), L() } var x, w; b(g) } let H; function T(t, e, n) { const s = t.slice(); return s[2] = e[n], s[16] = n, s } function N(t) { let e, n, s, i, o, m, _, f, h, b, x, w, $, y, v, k, C, E, z, D = t[1] + 1 + "", S = t[0].items.length + "", L = t[0].items[t[1]].label + "", j = t[0].items, A = []; for (let e = 0; e < j.length; e += 1)A[e] = J(T(t, j, e)); return { c() { e = p("div"), n = p("section"), s = p("div"), i = p("ul"); for (let t = 0; t < A.length; t += 1)A[t].c(); o = l(), m = p("div"), _ = p("div"), f = p("span"), h = p("span"), h.textContent = "Step", b = l(), x = p("span"), w = d(D), $ = l(), y = p("span"), v = d("of "), k = d(S), C = l(), E = p("span"), z = d(L), g(i, "class", "step-indicator__segments step--icon steps-red-600 marker-icon"), g(h, "class", "sr-only"), g(x, "class", "step-indicator__current-step"), g(y, "class", "step-indicator__total-steps"), g(f, "class", "step-indicator__heading-counter plr-10 ptb-5 gray-300 rounded-full"), g(E, "class", "step-indicator__heading-text"), g(_, "class", "step-indicator__heading"), g(m, "class", "step-indicator__header"), g(s, "class", "step-container ptb-20"), g(s, "aria-label", "progress"), g(n, "class", "body-div") }, m(t, a) { c(t, e, a), r(e, n), r(n, s), r(s, i); for (let t = 0; t < A.length; t += 1)A[t].m(i, null); r(s, o), r(s, m), r(m, _), r(_, f), r(f, h), r(f, b), r(f, x), r(x, w), r(f, $), r(f, y), r(y, v), r(y, k), r(_, C), r(_, E), r(E, z) }, p(t, e) { if (9 & e) { let n; for (j = t[0].items, n = 0; n < j.length; n += 1) { const s = T(t, j, n); A[n] ? A[n].p(s, e) : (A[n] = J(s), A[n].c(), A[n].m(i, null)) } for (; n < A.length; n += 1)A[n].d(1); A.length = j.length } 2 & e && D !== (D = t[1] + 1 + "") && u(w, D), 1 & e && S !== (S = t[0].items.length + "") && u(k, S), 3 & e && L !== (L = t[0].items[t[1]].label + "") && u(z, L) }, d(t) { t && a(e), function (t, e) { for (let n = 0; n < t.length; n += 1)t[n] && t[n].d(e) }(A, t) } } } function O(t) { let e, n, s, i, o, m, _ = t[2].label + ""; return { c() { e = p("li"), n = p("span"), s = d(_), i = l(), o = p("span"), o.textContent = "not completed", m = l(), g(o, "class", "sr-only"), g(n, "class", "step-indicator__segment-label"), g(e, "class", "step-indicator__segment") }, m(t, a) { c(t, e, a), r(e, n), r(n, s), r(n, i), r(n, o), r(e, m) }, p(t, e) { 1 & e && _ !== (_ = t[2].label + "") && u(s, _) }, d(t) { t && a(e) } } } function P(t) { let e, n, s, i, o, m, f, h, b, x, w, $, y = t[2].label + ""; function v(...e) { return t[9](t[2], ...e) } return { c() { e = p("li"), n = p("a"), s = l(), i = p("div"), i.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"></path></svg>', o = l(), m = p("span"), f = d(y), h = l(), b = p("span"), b.textContent = "not completed", x = l(), g(n, "href", "javascript:void(0)"), g(n, "class", "click"), g(i, "class", "step-indicator__segment---current--not-complete"), g(b, "class", "sr-only"), g(m, "class", "step-indicator__segment-label"), g(e, "class", "step-indicator__segment step-indicator__segment--current--not-complete") }, m(t, a) { c(t, e, a), r(e, n), r(e, s), r(e, i), r(e, o), r(e, m), r(m, f), r(m, h), r(m, b), r(e, x), w || ($ = _(n, "click", v), w = !0) }, p(e, n) { t = e, 1 & n && y !== (y = t[2].label + "") && u(f, y) }, d(t) { t && a(e), w = !1, $() } } } function B(t) { let e, n, s, i, o, m, f, h, b, x, w, $, y = t[2].label + ""; function v(...e) { return t[8](t[2], ...e) } return { c() { e = p("li"), n = p("a"), s = l(), i = p("div"), i.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"></path></svg>', o = l(), m = p("span"), f = d(y), h = l(), b = p("span"), b.textContent = "completed", x = l(), g(n, "href", "javascript:void(0)"), g(n, "class", "click"), g(i, "class", "step-indicator__segment---current"), g(b, "class", "sr-only"), g(m, "class", "step-indicator__segment-label"), g(e, "class", "step-indicator__segment step-indicator__segment--current") }, m(t, a) { c(t, e, a), r(e, n), r(e, s), r(e, i), r(e, o), r(e, m), r(m, f), r(m, h), r(m, b), r(e, x), w || ($ = _(n, "click", v), w = !0) }, p(e, n) { t = e, 1 & n && y !== (y = t[2].label + "") && u(f, y) }, d(t) { t && a(e), w = !1, $() } } } function I(t) { let e, n, s, i, o, m, f, h, b, x, w, $, y = t[2].label + ""; function v(...e) { return t[7](t[2], ...e) } return { c() { e = p("li"), n = p("a"), s = l(), i = p("div"), i.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"></path></svg>', o = l(), m = p("span"), f = d(y), h = l(), b = p("span"), b.textContent = "completed", x = l(), g(n, "href", "javascript:void(0)"), g(n, "class", "click"), g(i, "class", "step-indicator__segment---complete"), g(b, "class", "sr-only"), g(m, "class", "step-indicator__segment-label"), g(e, "class", "step-indicator__segment step-indicator__segment--complete") }, m(t, a) { c(t, e, a), r(e, n), r(e, s), r(e, i), r(e, o), r(e, m), r(m, f), r(m, h), r(m, b), r(e, x), w || ($ = _(n, "click", v), w = !0) }, p(e, n) { t = e, 1 & n && y !== (y = t[2].label + "") && u(f, y) }, d(t) { t && a(e), w = !1, $() } } } function J(t) { let e; function n(t, e) { return t[2].completed && !t[2].selected ? I : t[2].selected && t[2].completed ? B : t[2].current && !t[2].completed ? P : O } let s = n(t), i = s(t); return { c() { i.c(), e = m() }, m(t, n) { i.m(t, n), c(t, e, n) }, p(t, o) { s === (s = n(t)) && i ? i.p(t, o) : (i.d(1), i = s(t), i && (i.c(), i.m(e.parentNode, e))) }, d(t) { i.d(t), t && a(e) } } } function R(e) { let n, s = e[0].items.length > 0 && N(e); return { c() { s && s.c(), n = m(), this.c = t }, m(t, e) { s && s.m(t, e), c(t, n, e) }, p(t, [e]) { t[0].items.length > 0 ? s ? s.p(t, e) : (s = N(t), s.c(), s.m(n.parentNode, n)) : s && (s.d(1), s = null) }, i: t, o: t, d(t) { s && s.d(t), t && a(n) } } } function q(t, e, n) { let { stepper: s = { items: [] } } = e, { clickpos: i = 0 } = e, { currentpos: o = 0 } = e; const r = w(), c = x(), a = (t, e, n) => { r(t, e), c.dispatchEvent && c.dispatchEvent(n) }; let p = { url: window.location.href }; function d(t, e) { t.url = window.location.href; let r = Object.assign(Object.assign({}, e), { detail: t }); e.stopPropagation(), function (t) { var e, r; let c = s.items.find((e => e === t)); null === (e = s.items) || void 0 === e || e.forEach((t => t.selected = !1)), c.selected = !0, null === (r = s.items) || void 0 === r || r.forEach((t => t.current = !1)), c.current = !0, n(1, i = s.items.findIndex((t => t.selected))), n(4, o = s.items.findIndex((t => t.current))); for (let t = 0; t < s.items.length; t++)n(0, s.items[t].completed = t < o, s); n(0, s.items = [...s.items], s) }(t), a("click", t, new CustomEvent("click", r)) } var l; l = () => { "string" == typeof s && n(0, s = JSON.parse(s)) }, x().$$.before_update.push(l), function (t) { x().$$.on_mount.push(t) }((() => { "string" == typeof s && n(0, s = JSON.parse(s)) })); return t.$$set = t => { "stepper" in t && n(0, s = t.stepper), "clickpos" in t && n(1, i = t.clickpos), "currentpos" in t && n(4, o = t.currentpos) }, t.$$.update = () => { 1 & t.$$.dirty && n(1, i = s.items.findIndex((t => t.selected))), 1 & t.$$.dirty && n(4, o = s.items.findIndex((t => t.current))) }, [s, i, p, d, o, function () { var t; null === (t = s.items) || void 0 === t || t.forEach((t => (t.current = !1, t.completed = !1))), n(4, o = 0), n(1, i = 0), n(0, s.items[o].current = !0, s), n(0, s.items[o].selected = !0, s), n(0, s.items = [...s.items], s), n(2, p = s.items[o]); let e = { detail: p }; console.log("eventData=", e), a("reset", p, new CustomEvent("reset", e)) }, function (t) { var e, i; if (null === (e = s.items) || void 0 === e || e.forEach((t => t.current = !1)), null === (i = s.items) || void 0 === i || i.forEach((t => t.selected = !1)), 1 == t ? n(4, o++, o) : -1 == t && n(4, o--, o), console.log("component currentpos=", o), s.items.length > 0 && o >= 0 && s.items.length > o) { for (let t = 0; t < o; t++)n(0, s.items[t].completed = !0, s); n(0, s.items[o].current = !0, s), n(0, s.items[o].selected = !0, s), n(0, s.items[o].completed = !1, s), n(0, s.items = [...s.items], s), n(2, p = s.items[o]), n(2, p.isFirst = !1, p), n(2, p.isLast = !1, p), o == s.items.length - 1 ? n(2, p.isLast = !0, p) : 0 == o && n(2, p.isFirst = !0, p); let e = { detail: p }; 1 == t ? a("next", p, new CustomEvent("next", e)) : -1 == t && a("prev", p, new CustomEvent("prev", e)) } }, (t, e) => d(t, e), (t, e) => d(t, e), (t, e) => d(t, e)] } "function" == typeof HTMLElement && (H = class extends HTMLElement { constructor() { super(), this.attachShadow({ mode: "open" }) } connectedCallback() { const { on_mount: t } = this.$$; this.$$.on_disconnect = t.map(e).filter(i); for (const t in this.$$.slotted) this.appendChild(this.$$.slotted[t]) } attributeChangedCallback(t, e, n) { this[t] = n } disconnectedCallback() { s(this.$$.on_disconnect) } $destroy() { !function (t, e) { const n = t.$$; null !== n.fragment && (s(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []) }(this, 1), this.$destroy = t } $on(t, e) { const n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []); return n.push(e), () => { const t = n.indexOf(e); -1 !== t && n.splice(t, 1) } } $set(t) { var e; this.$$set && (e = t, 0 !== Object.keys(e).length) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1) } }); class G extends H { constructor(t) { super(), this.shadowRoot.innerHTML = "<style>.body-div{height:100%;margin:0;padding:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#000;font-family:'Source Sans Pro', sans-serif}.ptb-20{padding-top:20px !important;padding-bottom:20px !important}section,div{background:transparent;transition:all .2s ease-in-out}*,*:after,*:before{box-sizing:border-box;padding:0;margin:0}ul,li{max-width:720px}ul>li{padding:8px 10px 8px 8px;line-height:24px}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only{position:absolute;left:-999em;right:auto}.gray-300{background:#E8E8E8!important}.rounded-full{border-radius:100px !important}.plr-10{padding-left:10px!important;padding-right:10px!important}.ptb-5{padding-top:5px!important;padding-bottom:5px !important}.step-indicator__segments>.step-indicator__segment::before,.step-indicator__segments>.step-indicator__segment.step-indicator__segment--current--not-complete::before,.step-indicator__segments>.step-indicator__segment.step-indicator__segment--complete::before,.step-indicator__segments>.step-indicator__segment.step-indicator__segment--current::before{content:'';position:absolute;left:0;top:calc(50% - 20px);z-index:100;display:flex;align-items:center;justify-content:center;height:40px;width:40px;border-radius:50%;font-weight:400;font-size:18px;line-height:0;background:transparent}.step-indicator__segments{max-width:100%!important;display:flex;list-style:none;margin:0;padding:0}.step-indicator__segment---current{width:17px;color:rgb(255, 255, 255);position:absolute;z-index:999;top:-3px;left:12px}.step-indicator__segment---complete{width:17px;color:rgb(255, 255, 255);position:absolute;z-index:999;top:-3px;left:12px}.step-indicator__segment---current--not-complete{width:17px;color:#000;position:absolute;z-index:999;top:-3px;left:12px}.step-indicator__segments.step--icon{max-width:100%!important;display:flex;list-style:none;margin:0;padding:0}.step-indicator__segments.step--icon>.step-indicator__segment{position:relative;flex:1 1 0%;min-height:8px;max-width:240px}.step-indicator__segments.step--icon>.step-indicator__segment::before,.step-indicator__segments.step--icon>.step-indicator__segment.step-indicator__segment--current--not-complete::before,.step-indicator__segments.step--icon>.step-indicator__segment.step-indicator__segment--complete::before,.step-indicator__segments.step--icon>.step-indicator__segment.step-indicator__segment--current::before{content:''}.step-indicator__segments.step--icon>li.step-indicator__segment.step-indicator__segment::before{content:'';background:#D9D9D9;color:#D9D9D9;border:3px solid transparent!important}.step-indicator__segments.step--icon>li.step-indicator__segment.step-indicator__segment--current::before{content:'';font-weight:400;font-size:18px;border:0em solid black;background:black;color:white}.step-indicator__segments.step--icon>.step-indicator__segment::after{content:'';position:absolute;left:38px;display:flex;justify-content:center;width:calc(100% - 36px);max-width:80%;height:5px;background:#D9D9D9}.step-indicator__segments.step--icon>.step-indicator__segment--current--not-complete::after,.step-indicator__segments.step--icon>.step-indicator__segment--current::after{border:3px solid transparent!important;background:#D9D9D9;color:white;max-width:calc(100% - 50px)}.step-indicator__segments.step--icon>.step-indicator__segment--current::after{max-width:calc(100% - 36px)!important}.step-indicator__segments.step--icon>.step-indicator__segment--complete::after{border:3px solid transparent!important;background:#D9D9D9;color:white;max-width:100%}.step-indicator__segments.step--icon>.step-indicator__segment:last-of-type::after{content:'';display:none}.step-indicator__segments>li.step-indicator__segment.step-indicator__segment--current--not-complete>.step-indicator__segment-label,.step-indicator__segments>li.step-indicator__segment>.step-indicator__segment-label{position:absolute;display:block;font-size:16px;font-weight:400;padding-right:15px;text-align:left;margin-top:30px;color:black;user-select:none}.step-indicator__segments>li.step-indicator__segment.step-indicator__segment--current--not-complete>.step-indicator__segment-label{font-weight:bold}.step-indicator__heading{font-weight:600;margin:80px 0 0 0;color:black}.step-indicator__total-steps{font-weight:400}.step-indicator__heading-text{margin-left:10px}.step-indicator__current-step{display:inline-flex;font-weight:400;border-radius:50%}.step-indicator__segments.steps-red-600>li.step-indicator__segment.step-indicator__segment--complete::before{border:3px solid transparent!important;background:#F45A5C}.step-indicator__segments.steps-red-600>li.step-indicator__segment.step-indicator__segment--current--not-complete::before,.step-indicator__segments.steps-red-600>li.step-indicator__segment.step-indicator__segment--current::before{font-weight:400;font-size:18px;border:0em solid #F45A5C!important;background:#F45A5C!important;color:white}.step-indicator__segments.steps-red-600>li.step-indicator__segment.step-indicator__segment--current--not-complete::before{border:0em solid #d9d9d9!important;background:#d9d9d9!important;color:#000 !important}.step-indicator__segments.steps-red-600>li.step-indicator__segment--current>.step-indicator__segment-label{font-weight:600;color:#F45A5C}.step-indicator__segments.steps-red-600>.step-indicator__segment--current--not-complete::after{border:3px solid transparent!important;background:#d9d9d9;color:white}.step-indicator__segments.steps-red-600>.step-indicator__segment--current::after{border:3px solid transparent!important;background:#F45A5C;color:white}.step-indicator__segments.steps-red-600>.step-indicator__segment--current--not-complete::after{border:3px solid transparent!important;background:#d9d9d9;color:white}.step-indicator__segments.steps-red-600>.step-indicator__segment--complete::after{border:3px solid transparent!important;background:#F45A5C;color:white}.step-indicator__segments.step--icon>li.step-indicator__segment.step-indicator__segment--current--not-complete::before,.step-indicator__segments.step--icon>li.step-indicator__segment.step-indicator__segment--current::before{content:'';font-weight:400;font-size:18px;border:0em solid black;background:black;color:white;font-family:'font awesome 5 pro'}.step-indicator__segments.step--icon>li.step-indicator__segment.step-indicator__segment--current--not-complete::before,.step-indicator__segments.step--icon>li.step-indicator__segment.step-indicator__segment--complete::before{border:3px solid transparent!important;color:white;font-family:'font awesome 5 pro';font-family:'FontAwesome'}.step-indicator__segments.step--icon.marker-icon>li.step-indicator__segment.step-indicator__segment--current--not-complete::before,.step-indicator__segments.step--icon.marker-icon>li.step-indicator__segment.step-indicator__segment--current::before{font-weight:bold}a.click{position:absolute;display:block;width:39px;height:39px;z-index:9999;border-radius:50%;top:-12px;left:0}@media screen and (max-width: 768px){.step-indicator__segments.step--icon>.step-indicator__segment::before,.step-indicator__segments.step--icon>.step-indicator__segment--current--not-complete::before,.step-indicator__segments.step--icon>.step-indicator__segment--complete::before,.step-indicator__segments.step--icon>.step-indicator__segment--current::before{display:none!important}ul.step-indicator__segments.step--icon>.step-indicator__segment:last-of-type::after,ul.step-indicator__segments.step--icon>.step-indicator__segment::after{content:'';position:absolute;left:0!important;display:flex;justify-content:center;width:calc(100% - 1px)!important;max-width:100%!important;height:6px!important}ul.step-indicator__segments>li.step-indicator__segment.step-indicator__segment--current--not-complete::after,ul.step-indicator__segments>li.step-indicator__segment.step-indicator__segment--current::after{width:calc(100% - 1px)!important}.step-indicator__segment-label{margin-top:20px!important}}@media screen and (max-width: 512px){.step-indicator__segments>.step-indicator__segment::before,.step-indicator__segments>.step-indicator__segment--current--not-complete::before,.step-indicator__segments>.step-indicator__segment--complete::before,.step-indicator__segments>.step-indicator__segment--current::before{display:none!important}.step-indicator__segments>.step-indicator__segment:last-of-type::after,.step-indicator__segments>.step-indicator__segment::after{content:'';position:absolute;left:0;display:flex;justify-content:center;width:calc(100% - 1px);max-width:100%}.step-indicator__segments>.step-indicator__segment--current--not-complete::after,.step-indicator__segments>.step-indicator__segment--current::after,.step-indicator__segment--current--not-complete,.step-indicator__segment---current{max-width:100%!important}.step-indicator__segment-label{display:none!important}.step-indicator__heading{margin:20px 0 0 0}.step-indicator__segment---current{display:none}.step-indicator__segment---complete{display:none}}@media screen and (max-width: 414px){a.click{width:100%;height:7px;z-index:9999;border-radius:0;top:8px;left:0}}</style>", F(this, { target: this.shadowRoot, props: f(this.attributes), customElement: !0 }, q, R, o, { stepper: 0, clickpos: 1, currentpos: 4, resetSteps: 5, handleStepProgress: 6 }, null), t && (t.target && c(t.target, this, t.anchor), t.props && (this.$set(t.props), L())) } static get observedAttributes() { return ["stepper", "clickpos", "currentpos", "resetSteps", "handleStepProgress"] } get stepper() { return this.$$.ctx[0] } set stepper(t) { this.$$set({ stepper: t }), L() } get clickpos() { return this.$$.ctx[1] } set clickpos(t) { this.$$set({ clickpos: t }), L() } get currentpos() { return this.$$.ctx[4] } set currentpos(t) { this.$$set({ currentpos: t }), L() } get resetSteps() { return this.$$.ctx[5] } get handleStepProgress() { return this.$$.ctx[6] } } return customElements.define("eas-graphic-stepper", G), G }();
//# sourceMappingURL=eas-graphic-stepper.js.map
